
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire70ac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire70ac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});

parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


'use strict';
var $ef322a7f89c3ed41$exports = {};
'use strict';
var $6140c9fa18232846$exports = {};
'use strict';
$6140c9fa18232846$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$ef322a7f89c3ed41$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $fcd977913fa5bb2d$exports = {};
'use strict';
var $842f8f0a18746212$exports = {};
'use strict';
var $3fbf1185731afe2b$exports = {};
'use strict';
var $3fbf1185731afe2b$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$3fbf1185731afe2b$exports = // eslint-disable-next-line es/no-global-this -- safe
$3fbf1185731afe2b$var$check(typeof globalThis == 'object' && globalThis) || $3fbf1185731afe2b$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3fbf1185731afe2b$var$check(typeof self == 'object' && self) || $3fbf1185731afe2b$var$check(typeof $parcel$global == 'object' && $parcel$global) || $3fbf1185731afe2b$var$check(typeof $3fbf1185731afe2b$exports == 'object' && $3fbf1185731afe2b$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


var $1946b9b54b48e7fd$exports = {};
'use strict';
var $d00d03e557d638db$exports = {};
'use strict';
var $e0409817d4e03fc4$exports = {};
'use strict';
$e0409817d4e03fc4$exports = false;



var $4ce407c7007beb63$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $4ce407c7007beb63$var$defineProperty = Object.defineProperty;
$4ce407c7007beb63$exports = function(key, value) {
    try {
        $4ce407c7007beb63$var$defineProperty($3fbf1185731afe2b$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3fbf1185731afe2b$exports[key] = value;
    }
    return value;
};


var $d00d03e557d638db$var$SHARED = '__core-js_shared__';
var $d00d03e557d638db$var$store = $d00d03e557d638db$exports = $3fbf1185731afe2b$exports[$d00d03e557d638db$var$SHARED] || $4ce407c7007beb63$exports($d00d03e557d638db$var$SHARED, {});
($d00d03e557d638db$var$store.versions || ($d00d03e557d638db$var$store.versions = [])).push({
    version: '3.49.0',
    mode: $e0409817d4e03fc4$exports ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$1946b9b54b48e7fd$exports = function(key, value) {
    return $d00d03e557d638db$exports[key] || ($d00d03e557d638db$exports[key] = value || {});
};


var $1f868a26fd901990$exports = {};
'use strict';
var $43b18aa2f1faac44$exports = {};
'use strict';
var $bcbe62e89adc7d37$exports = {};
'use strict';

$bcbe62e89adc7d37$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $43b18aa2f1faac44$var$FunctionPrototype = Function.prototype;
var $43b18aa2f1faac44$var$call = $43b18aa2f1faac44$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $43b18aa2f1faac44$var$uncurryThisWithBind = $bcbe62e89adc7d37$exports && $43b18aa2f1faac44$var$FunctionPrototype.bind.bind($43b18aa2f1faac44$var$call, $43b18aa2f1faac44$var$call);
$43b18aa2f1faac44$exports = $bcbe62e89adc7d37$exports ? $43b18aa2f1faac44$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $43b18aa2f1faac44$var$call.apply(fn, arguments);
    };
};


var $a2f3ebb5da11db12$exports = {};
'use strict';
var $c378177673193450$exports = {};
'use strict';
var $7ce250ddf7b42d4d$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$7ce250ddf7b42d4d$exports = function(it) {
    return it === null || it === undefined;
};


var $c378177673193450$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$c378177673193450$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) throw new $c378177673193450$var$$TypeError("Can't call method on " + it);
    return it;
};


var $a2f3ebb5da11db12$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$a2f3ebb5da11db12$exports = function(argument) {
    return $a2f3ebb5da11db12$var$$Object($c378177673193450$exports(argument));
};


var $1f868a26fd901990$var$hasOwnProperty = $43b18aa2f1faac44$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$1f868a26fd901990$exports = Object.hasOwn || function hasOwn(it, key) {
    return $1f868a26fd901990$var$hasOwnProperty($a2f3ebb5da11db12$exports(it), key);
};


var $5e0a1e292f79defc$exports = {};
'use strict';

var $5e0a1e292f79defc$var$id = 0;
var $5e0a1e292f79defc$var$postfix = Math.random();
var $5e0a1e292f79defc$var$toString = $43b18aa2f1faac44$exports(1.1.toString);
$5e0a1e292f79defc$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $5e0a1e292f79defc$var$toString(++$5e0a1e292f79defc$var$id + $5e0a1e292f79defc$var$postfix, 36);
};


var $4a39565fee8fe980$exports = {};
'use strict';
var $b2a56c1a090208a5$exports = {};
'use strict';

var $34fa2a1382dc63c1$exports = {};
'use strict';

var $34fa2a1382dc63c1$var$navigator = $3fbf1185731afe2b$exports.navigator;
var $34fa2a1382dc63c1$var$userAgent = $34fa2a1382dc63c1$var$navigator && $34fa2a1382dc63c1$var$navigator.userAgent;
$34fa2a1382dc63c1$exports = $34fa2a1382dc63c1$var$userAgent ? String($34fa2a1382dc63c1$var$userAgent) : '';


var $b2a56c1a090208a5$var$process = $3fbf1185731afe2b$exports.process;
var $b2a56c1a090208a5$var$Deno = $3fbf1185731afe2b$exports.Deno;
var $b2a56c1a090208a5$var$versions = $b2a56c1a090208a5$var$process && $b2a56c1a090208a5$var$process.versions || $b2a56c1a090208a5$var$Deno && $b2a56c1a090208a5$var$Deno.version;
var $b2a56c1a090208a5$var$v8 = $b2a56c1a090208a5$var$versions && $b2a56c1a090208a5$var$versions.v8;
var $b2a56c1a090208a5$var$match, $b2a56c1a090208a5$var$version;
if ($b2a56c1a090208a5$var$v8) {
    $b2a56c1a090208a5$var$match = $b2a56c1a090208a5$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $b2a56c1a090208a5$var$version = $b2a56c1a090208a5$var$match[0] > 0 && $b2a56c1a090208a5$var$match[0] < 4 ? 1 : +($b2a56c1a090208a5$var$match[0] + $b2a56c1a090208a5$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$b2a56c1a090208a5$var$version && $34fa2a1382dc63c1$exports) {
    $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Edge\/(\d+)/);
    if (!$b2a56c1a090208a5$var$match || $b2a56c1a090208a5$var$match[1] >= 74) {
        $b2a56c1a090208a5$var$match = $34fa2a1382dc63c1$exports.match(/Chrome\/(\d+)/);
        if ($b2a56c1a090208a5$var$match) $b2a56c1a090208a5$var$version = +$b2a56c1a090208a5$var$match[1];
    }
}
$b2a56c1a090208a5$exports = $b2a56c1a090208a5$var$version;




var $4a39565fee8fe980$var$$String = $3fbf1185731afe2b$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$4a39565fee8fe980$exports = !!Object.getOwnPropertySymbols && !$6140c9fa18232846$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$4a39565fee8fe980$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $b2a56c1a090208a5$exports && $b2a56c1a090208a5$exports < 41;
});


var $47f18b427c2fbabf$exports = {};
'use strict';

$47f18b427c2fbabf$exports = $4a39565fee8fe980$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $842f8f0a18746212$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
var $842f8f0a18746212$var$WellKnownSymbolsStore = $1946b9b54b48e7fd$exports('wks');
var $842f8f0a18746212$var$createWellKnownSymbol = $47f18b427c2fbabf$exports ? $842f8f0a18746212$var$Symbol['for'] || $842f8f0a18746212$var$Symbol : $842f8f0a18746212$var$Symbol && $842f8f0a18746212$var$Symbol.withoutSetter || $5e0a1e292f79defc$exports;
$842f8f0a18746212$exports = function(name) {
    if (!$1f868a26fd901990$exports($842f8f0a18746212$var$WellKnownSymbolsStore, name)) $842f8f0a18746212$var$WellKnownSymbolsStore[name] = $4a39565fee8fe980$exports && $1f868a26fd901990$exports($842f8f0a18746212$var$Symbol, name) ? $842f8f0a18746212$var$Symbol[name] : $842f8f0a18746212$var$createWellKnownSymbol('Symbol.' + name);
    return $842f8f0a18746212$var$WellKnownSymbolsStore[name];
};


var $5c0346dde328cc4c$exports = {};
'use strict';
var $c845d421b7b0e630$exports = {};
'use strict';
var $6a130d390db46c8e$exports = {};
'use strict';
var $70e34a5a2021f756$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $70e34a5a2021f756$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$70e34a5a2021f756$exports = typeof $70e34a5a2021f756$var$documentAll == 'undefined' && $70e34a5a2021f756$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $70e34a5a2021f756$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$6a130d390db46c8e$exports = function(it) {
    return typeof it == 'object' ? it !== null : $70e34a5a2021f756$exports(it);
};


var $c845d421b7b0e630$var$$String = String;
var $c845d421b7b0e630$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c845d421b7b0e630$exports = function(argument) {
    if ($6a130d390db46c8e$exports(argument)) return argument;
    throw new $c845d421b7b0e630$var$$TypeError($c845d421b7b0e630$var$$String(argument) + ' is not an object');
};


// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $4c5dc42699fd98c2$export$2d1720544b23b823;
'use strict';

var $161a89d67c436ccf$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$161a89d67c436ccf$exports = $ef322a7f89c3ed41$exports && $6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $2d0ac3aa5e39584b$export$2d1720544b23b823;
'use strict';

var $d45526d8245cb22c$exports = {};
'use strict';


var $15c0c414b89100b1$exports = {};
'use strict';


var $15c0c414b89100b1$var$document = $3fbf1185731afe2b$exports.document;
// typeof document.createElement is 'object' in old IE
var $15c0c414b89100b1$var$EXISTS = $6a130d390db46c8e$exports($15c0c414b89100b1$var$document) && $6a130d390db46c8e$exports($15c0c414b89100b1$var$document.createElement);
$15c0c414b89100b1$exports = function(it) {
    return $15c0c414b89100b1$var$EXISTS ? $15c0c414b89100b1$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$d45526d8245cb22c$exports = !$ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($15c0c414b89100b1$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});




var $7f19acfe53927f5c$exports = {};
'use strict';
var $8ffb6b36a733d3c0$exports = {};
'use strict';
var $881ad37dbe259e8f$exports = {};
'use strict';

var $881ad37dbe259e8f$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$881ad37dbe259e8f$exports = $bcbe62e89adc7d37$exports ? $881ad37dbe259e8f$var$call.bind($881ad37dbe259e8f$var$call) : function() {
    return $881ad37dbe259e8f$var$call.apply($881ad37dbe259e8f$var$call, arguments);
};



var $0b429cc7792c7d26$exports = {};
'use strict';
var $a5217dbd1b0d33ce$exports = {};
'use strict';


var $a5217dbd1b0d33ce$var$aFunction = function(argument) {
    return $70e34a5a2021f756$exports(argument) ? argument : undefined;
};
$a5217dbd1b0d33ce$exports = function(namespace, method) {
    return arguments.length < 2 ? $a5217dbd1b0d33ce$var$aFunction($3fbf1185731afe2b$exports[namespace]) : $3fbf1185731afe2b$exports[namespace] && $3fbf1185731afe2b$exports[namespace][method];
};



var $41cc576e850a251e$exports = {};
'use strict';

$41cc576e850a251e$exports = $43b18aa2f1faac44$exports({}.isPrototypeOf);



var $0b429cc7792c7d26$var$$Object = Object;
$0b429cc7792c7d26$exports = $47f18b427c2fbabf$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $a5217dbd1b0d33ce$exports('Symbol');
    return $70e34a5a2021f756$exports($Symbol) && $41cc576e850a251e$exports($Symbol.prototype, $0b429cc7792c7d26$var$$Object(it));
};


var $eb80dcd0b8a5698c$exports = {};
'use strict';
var $ae485921c5498156$exports = {};
'use strict';

var $8f0ebae34f61e14c$exports = {};
'use strict';
var $8f0ebae34f61e14c$var$$String = String;
$8f0ebae34f61e14c$exports = function(argument) {
    try {
        return $8f0ebae34f61e14c$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $ae485921c5498156$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$ae485921c5498156$exports = function(argument) {
    if ($70e34a5a2021f756$exports(argument)) return argument;
    throw new $ae485921c5498156$var$$TypeError($8f0ebae34f61e14c$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$eb80dcd0b8a5698c$exports = function(V, P) {
    var func = V[P];
    return $7ce250ddf7b42d4d$exports(func) ? undefined : $ae485921c5498156$exports(func);
};


var $b0f812e443807cb5$exports = {};
'use strict';



var $b0f812e443807cb5$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$b0f812e443807cb5$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if ($70e34a5a2021f756$exports(fn = input.valueOf) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    if (pref !== 'string' && $70e34a5a2021f756$exports(fn = input.toString) && !$6a130d390db46c8e$exports(val = $881ad37dbe259e8f$exports(fn, input))) return val;
    throw new $b0f812e443807cb5$var$$TypeError("Can't convert object to primitive value");
};



var $8ffb6b36a733d3c0$var$$TypeError = TypeError;
var $8ffb6b36a733d3c0$var$TO_PRIMITIVE = $842f8f0a18746212$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$8ffb6b36a733d3c0$exports = function(input, pref) {
    if (!$6a130d390db46c8e$exports(input) || $0b429cc7792c7d26$exports(input)) return input;
    var exoticToPrim = $eb80dcd0b8a5698c$exports(input, $8ffb6b36a733d3c0$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $881ad37dbe259e8f$exports(exoticToPrim, input, pref);
        if (!$6a130d390db46c8e$exports(result) || $0b429cc7792c7d26$exports(result)) return result;
        throw new $8ffb6b36a733d3c0$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $b0f812e443807cb5$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$7f19acfe53927f5c$exports = function(argument) {
    var key = $8ffb6b36a733d3c0$exports(argument, 'string');
    return $0b429cc7792c7d26$exports(key) ? key : key + '';
};


var $2d0ac3aa5e39584b$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $2d0ac3aa5e39584b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2d0ac3aa5e39584b$var$ENUMERABLE = 'enumerable';
var $2d0ac3aa5e39584b$var$CONFIGURABLE = 'configurable';
var $2d0ac3aa5e39584b$var$WRITABLE = 'writable';
$2d0ac3aa5e39584b$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $161a89d67c436ccf$exports ? function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $2d0ac3aa5e39584b$var$WRITABLE in Attributes && !Attributes[$2d0ac3aa5e39584b$var$WRITABLE]) {
        var current = $2d0ac3aa5e39584b$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$2d0ac3aa5e39584b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $2d0ac3aa5e39584b$var$CONFIGURABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$CONFIGURABLE] : current[$2d0ac3aa5e39584b$var$CONFIGURABLE],
                enumerable: $2d0ac3aa5e39584b$var$ENUMERABLE in Attributes ? Attributes[$2d0ac3aa5e39584b$var$ENUMERABLE] : current[$2d0ac3aa5e39584b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
} : $2d0ac3aa5e39584b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c845d421b7b0e630$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    $c845d421b7b0e630$exports(Attributes);
    if ($d45526d8245cb22c$exports) try {
        return $2d0ac3aa5e39584b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $2d0ac3aa5e39584b$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



var $4d273c9d7e1bdf46$exports = {};
'use strict';
var $8239f4c7c6082668$exports = {};
'use strict';


var $b0ba63bfbfb16088$exports = {};
'use strict';

var $b0ba63bfbfb16088$var$toString = $43b18aa2f1faac44$exports({}.toString);
var $b0ba63bfbfb16088$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
$b0ba63bfbfb16088$exports = function(it) {
    return $b0ba63bfbfb16088$var$stringSlice($b0ba63bfbfb16088$var$toString(it), 8, -1);
};


var $8239f4c7c6082668$var$$Object = Object;
var $8239f4c7c6082668$var$split = $43b18aa2f1faac44$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$8239f4c7c6082668$exports = $6140c9fa18232846$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$8239f4c7c6082668$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $b0ba63bfbfb16088$exports(it) === 'String' ? $8239f4c7c6082668$var$split(it, '') : $8239f4c7c6082668$var$$Object(it);
} : $8239f4c7c6082668$var$$Object;



$4d273c9d7e1bdf46$exports = function(it) {
    return $8239f4c7c6082668$exports($c378177673193450$exports(it));
};


var $b74a8f96578f4948$exports = {};
'use strict';
var $c4fba4611365c4f5$exports = {};
'use strict';



var $f00609c516640f24$exports = {};
'use strict';

var $1ef9432c43157f41$exports = {};
'use strict';
var $b5bb21648546ce5b$exports = {};
'use strict';
var $5395b5a4913a5e32$exports = {};
'use strict';
var $5395b5a4913a5e32$var$ceil = Math.ceil;
var $5395b5a4913a5e32$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5395b5a4913a5e32$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5395b5a4913a5e32$var$floor : $5395b5a4913a5e32$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b5bb21648546ce5b$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5395b5a4913a5e32$exports(number);
};


var $1ef9432c43157f41$var$max = Math.max;
var $1ef9432c43157f41$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$1ef9432c43157f41$exports = function(index, length) {
    var integer = $b5bb21648546ce5b$exports(index);
    return integer < 0 ? $1ef9432c43157f41$var$max(integer + length, 0) : $1ef9432c43157f41$var$min(integer, length);
};


var $04c91bd3815cd64a$exports = {};
'use strict';
var $4aba983aae3daed3$exports = {};
'use strict';

var $4aba983aae3daed3$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$4aba983aae3daed3$exports = function(argument) {
    var len = $b5bb21648546ce5b$exports(argument);
    return len > 0 ? $4aba983aae3daed3$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$04c91bd3815cd64a$exports = function(obj) {
    return $4aba983aae3daed3$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $f00609c516640f24$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4d273c9d7e1bdf46$exports($this);
        var length = $04c91bd3815cd64a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $1ef9432c43157f41$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$f00609c516640f24$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f00609c516640f24$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f00609c516640f24$var$createMethod(false)
};


var $c4fba4611365c4f5$require$indexOf = $f00609c516640f24$exports.indexOf;
var $9f571a3f3d135e31$exports = {};
'use strict';
$9f571a3f3d135e31$exports = {};


var $c4fba4611365c4f5$var$push = $43b18aa2f1faac44$exports([].push);
$c4fba4611365c4f5$exports = function(object, names) {
    var O = $4d273c9d7e1bdf46$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$1f868a26fd901990$exports($9f571a3f3d135e31$exports, key) && $1f868a26fd901990$exports(O, key) && $c4fba4611365c4f5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($1f868a26fd901990$exports(O, key = names[i++])) ~$c4fba4611365c4f5$require$indexOf(result, key) || $c4fba4611365c4f5$var$push(result, key);
    return result;
};


var $e73f13f1d8a17cad$exports = {};
'use strict';
// IE8- don't enum bug keys
$e73f13f1d8a17cad$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$b74a8f96578f4948$exports = Object.keys || function keys(O) {
    return $c4fba4611365c4f5$exports(O, $e73f13f1d8a17cad$exports);
};


$4c5dc42699fd98c2$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports && !$161a89d67c436ccf$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c845d421b7b0e630$exports(O);
    var props = $4d273c9d7e1bdf46$exports(Properties);
    var keys = $b74a8f96578f4948$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$2d0ac3aa5e39584b$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $b8ce1ad1b6b1e7c1$exports = {};
'use strict';

$b8ce1ad1b6b1e7c1$exports = $a5217dbd1b0d33ce$exports('document', 'documentElement');



var $834abcf0f8f3f871$exports = {};
'use strict';


var $834abcf0f8f3f871$var$keys = $1946b9b54b48e7fd$exports('keys');
$834abcf0f8f3f871$exports = function(key) {
    return $834abcf0f8f3f871$var$keys[key] || ($834abcf0f8f3f871$var$keys[key] = $5e0a1e292f79defc$exports(key));
};


var $5c0346dde328cc4c$var$GT = '>';
var $5c0346dde328cc4c$var$LT = '<';
var $5c0346dde328cc4c$var$PROTOTYPE = 'prototype';
var $5c0346dde328cc4c$var$SCRIPT = 'script';
var $5c0346dde328cc4c$var$IE_PROTO = $834abcf0f8f3f871$exports('IE_PROTO');
var $5c0346dde328cc4c$var$EmptyConstructor = function() {};
var $5c0346dde328cc4c$var$scriptTag = function(content) {
    return $5c0346dde328cc4c$var$LT + $5c0346dde328cc4c$var$SCRIPT + $5c0346dde328cc4c$var$GT + content + $5c0346dde328cc4c$var$LT + '/' + $5c0346dde328cc4c$var$SCRIPT + $5c0346dde328cc4c$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5c0346dde328cc4c$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5c0346dde328cc4c$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5c0346dde328cc4c$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $15c0c414b89100b1$exports('iframe');
    var JS = 'java' + $5c0346dde328cc4c$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $b8ce1ad1b6b1e7c1$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5c0346dde328cc4c$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5c0346dde328cc4c$var$activeXDocument;
var $5c0346dde328cc4c$var$NullProtoObject = function() {
    try {
        $5c0346dde328cc4c$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $5c0346dde328cc4c$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $5c0346dde328cc4c$var$activeXDocument ? $5c0346dde328cc4c$var$NullProtoObjectViaActiveX($5c0346dde328cc4c$var$activeXDocument) // old IE
     : $5c0346dde328cc4c$var$NullProtoObjectViaIFrame() : $5c0346dde328cc4c$var$NullProtoObjectViaActiveX($5c0346dde328cc4c$var$activeXDocument); // WSH
    var length = $e73f13f1d8a17cad$exports.length;
    while(length--)delete $5c0346dde328cc4c$var$NullProtoObject[$5c0346dde328cc4c$var$PROTOTYPE][$e73f13f1d8a17cad$exports[length]];
    return $5c0346dde328cc4c$var$NullProtoObject();
};
$9f571a3f3d135e31$exports[$5c0346dde328cc4c$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$5c0346dde328cc4c$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5c0346dde328cc4c$var$EmptyConstructor[$5c0346dde328cc4c$var$PROTOTYPE] = $c845d421b7b0e630$exports(O);
        result = new $5c0346dde328cc4c$var$EmptyConstructor();
        $5c0346dde328cc4c$var$EmptyConstructor[$5c0346dde328cc4c$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5c0346dde328cc4c$var$IE_PROTO] = O;
    } else result = $5c0346dde328cc4c$var$NullProtoObject();
    return Properties === undefined ? result : $4c5dc42699fd98c2$export$2d1720544b23b823(result, Properties);
};



var $fcd977913fa5bb2d$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
var $fcd977913fa5bb2d$var$UNSCOPABLES = $842f8f0a18746212$exports('unscopables');
var $fcd977913fa5bb2d$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($fcd977913fa5bb2d$var$ArrayPrototype[$fcd977913fa5bb2d$var$UNSCOPABLES] === undefined) $fcd977913fa5bb2d$require$defineProperty($fcd977913fa5bb2d$var$ArrayPrototype, $fcd977913fa5bb2d$var$UNSCOPABLES, {
    configurable: true,
    value: $5c0346dde328cc4c$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$fcd977913fa5bb2d$exports = function(key) {
    $fcd977913fa5bb2d$var$ArrayPrototype[$fcd977913fa5bb2d$var$UNSCOPABLES][key] = true;
};




var $74a6fb831e72713b$exports = {};
'use strict';
var $09c56ff2ae09b2d7$exports = {};
'use strict';





var $81c64883d194e3b4$exports = {};
'use strict';


var $81c64883d194e3b4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $81c64883d194e3b4$var$getDescriptor = $ef322a7f89c3ed41$exports && Object.getOwnPropertyDescriptor;
var $81c64883d194e3b4$var$EXISTS = $1f868a26fd901990$exports($81c64883d194e3b4$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $81c64883d194e3b4$var$PROPER = $81c64883d194e3b4$var$EXISTS && (function something() {}).name === 'something';
var $81c64883d194e3b4$var$CONFIGURABLE = $81c64883d194e3b4$var$EXISTS && (!$ef322a7f89c3ed41$exports || $ef322a7f89c3ed41$exports && $81c64883d194e3b4$var$getDescriptor($81c64883d194e3b4$var$FunctionPrototype, 'name').configurable);
$81c64883d194e3b4$exports = {
    EXISTS: $81c64883d194e3b4$var$EXISTS,
    PROPER: $81c64883d194e3b4$var$PROPER,
    CONFIGURABLE: $81c64883d194e3b4$var$CONFIGURABLE
};


var $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9990f6f719f26a96$exports = {};
'use strict';



var $9990f6f719f26a96$var$functionToString = $43b18aa2f1faac44$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$70e34a5a2021f756$exports($d00d03e557d638db$exports.inspectSource)) $d00d03e557d638db$exports.inspectSource = function(it) {
    return $9990f6f719f26a96$var$functionToString(it);
};
$9990f6f719f26a96$exports = $d00d03e557d638db$exports.inspectSource;


var $3a8bcef306e86159$exports = {};
'use strict';
var $47d53bb84a8f3c5b$exports = {};
'use strict';


var $47d53bb84a8f3c5b$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
$47d53bb84a8f3c5b$exports = $70e34a5a2021f756$exports($47d53bb84a8f3c5b$var$WeakMap) && /native code/.test(String($47d53bb84a8f3c5b$var$WeakMap));




var $8693737507995841$exports = {};
'use strict';


var $b66966b48674609b$exports = {};
'use strict';
$b66966b48674609b$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$8693737507995841$exports = $ef322a7f89c3ed41$exports ? function(object, key, value) {
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};






var $3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $3a8bcef306e86159$var$TypeError = $3fbf1185731afe2b$exports.TypeError;
var $3a8bcef306e86159$var$WeakMap = $3fbf1185731afe2b$exports.WeakMap;
var $3a8bcef306e86159$var$set, $3a8bcef306e86159$var$get, $3a8bcef306e86159$var$has;
var $3a8bcef306e86159$var$enforce = function(it) {
    return $3a8bcef306e86159$var$has(it) ? $3a8bcef306e86159$var$get(it) : $3a8bcef306e86159$var$set(it, {});
};
var $3a8bcef306e86159$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6a130d390db46c8e$exports(it) || (state = $3a8bcef306e86159$var$get(it)).type !== TYPE) throw new $3a8bcef306e86159$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($47d53bb84a8f3c5b$exports || $d00d03e557d638db$exports.state) {
    var $3a8bcef306e86159$var$store = $d00d03e557d638db$exports.state || ($d00d03e557d638db$exports.state = new $3a8bcef306e86159$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$store.get = $3a8bcef306e86159$var$store.get;
    $3a8bcef306e86159$var$store.has = $3a8bcef306e86159$var$store.has;
    $3a8bcef306e86159$var$store.set = $3a8bcef306e86159$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($3a8bcef306e86159$var$store.has(it)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3a8bcef306e86159$var$store.set(it, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $3a8bcef306e86159$var$store.get(it) || {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $3a8bcef306e86159$var$store.has(it);
    };
} else {
    var $3a8bcef306e86159$var$STATE = $834abcf0f8f3f871$exports('state');
    $9f571a3f3d135e31$exports[$3a8bcef306e86159$var$STATE] = true;
    $3a8bcef306e86159$var$set = function(it, metadata) {
        if ($1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE)) throw new $3a8bcef306e86159$var$TypeError($3a8bcef306e86159$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8693737507995841$exports(it, $3a8bcef306e86159$var$STATE, metadata);
        return metadata;
    };
    $3a8bcef306e86159$var$get = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE) ? it[$3a8bcef306e86159$var$STATE] : {};
    };
    $3a8bcef306e86159$var$has = function(it) {
        return $1f868a26fd901990$exports(it, $3a8bcef306e86159$var$STATE);
    };
}
$3a8bcef306e86159$exports = {
    set: $3a8bcef306e86159$var$set,
    get: $3a8bcef306e86159$var$get,
    has: $3a8bcef306e86159$var$has,
    enforce: $3a8bcef306e86159$var$enforce,
    getterFor: $3a8bcef306e86159$var$getterFor
};


var $09c56ff2ae09b2d7$var$enforceInternalState = $3a8bcef306e86159$exports.enforce;
var $09c56ff2ae09b2d7$var$getInternalState = $3a8bcef306e86159$exports.get;
var $09c56ff2ae09b2d7$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $09c56ff2ae09b2d7$var$defineProperty = Object.defineProperty;
var $09c56ff2ae09b2d7$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
var $09c56ff2ae09b2d7$var$replace = $43b18aa2f1faac44$exports(''.replace);
var $09c56ff2ae09b2d7$var$join = $43b18aa2f1faac44$exports([].join);
var $09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH = $ef322a7f89c3ed41$exports && !$6140c9fa18232846$exports(function() {
    return $09c56ff2ae09b2d7$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $09c56ff2ae09b2d7$var$TEMPLATE = String(String).split('String');
var $09c56ff2ae09b2d7$var$makeBuiltIn = $09c56ff2ae09b2d7$exports = function(value, name, options) {
    if ($09c56ff2ae09b2d7$var$stringSlice($09c56ff2ae09b2d7$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $09c56ff2ae09b2d7$var$replace($09c56ff2ae09b2d7$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$1f868a26fd901990$exports(value, 'name') || $09c56ff2ae09b2d7$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($09c56ff2ae09b2d7$var$CONFIGURABLE_LENGTH && options && $1f868a26fd901990$exports(options, 'arity') && value.length !== options.arity) $09c56ff2ae09b2d7$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $1f868a26fd901990$exports(options, 'constructor') && options.constructor) {
            if ($ef322a7f89c3ed41$exports) $09c56ff2ae09b2d7$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $09c56ff2ae09b2d7$var$enforceInternalState(value);
    if (!$1f868a26fd901990$exports(state, 'source')) state.source = $09c56ff2ae09b2d7$var$join($09c56ff2ae09b2d7$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $09c56ff2ae09b2d7$var$makeBuiltIn(function toString() {
    return $70e34a5a2021f756$exports(this) && $09c56ff2ae09b2d7$var$getInternalState(this).source || $9990f6f719f26a96$exports(this);
}, 'toString');



$74a6fb831e72713b$exports = function(target, name, descriptor) {
    if (descriptor.get) $09c56ff2ae09b2d7$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $09c56ff2ae09b2d7$exports(descriptor.set, name, {
        setter: true
    });
    return $2d0ac3aa5e39584b$export$2d1720544b23b823(target, name, descriptor);
};


// `Array.prototype.lastIndex` getter
// https://github.com/tc39/proposal-array-last
if ($ef322a7f89c3ed41$exports) {
    $74a6fb831e72713b$exports(Array.prototype, 'lastIndex', {
        configurable: true,
        get: function lastIndex() {
            var O = $a2f3ebb5da11db12$exports(this);
            var len = $04c91bd3815cd64a$exports(O);
            return len === 0 ? 0 : len - 1;
        }
    });
    $fcd977913fa5bb2d$exports('lastIndex');
}


'use strict';





// `Array.prototype.lastIndex` accessor
// https://github.com/tc39/proposal-array-last
if ($ef322a7f89c3ed41$exports) {
    $74a6fb831e72713b$exports(Array.prototype, 'lastItem', {
        configurable: true,
        get: function lastItem() {
            var O = $a2f3ebb5da11db12$exports(this);
            var len = $04c91bd3815cd64a$exports(O);
            return len === 0 ? undefined : O[len - 1];
        },
        set: function lastItem(value) {
            var O = $a2f3ebb5da11db12$exports(this);
            var len = $04c91bd3815cd64a$exports(O);
            return O[len === 0 ? 0 : len - 1] = value;
        }
    });
    $fcd977913fa5bb2d$exports('lastItem');
}


'use strict';
var $ca3e1754e676956d$exports = {};
'use strict';

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $6d99163b6684d050$export$2d1720544b23b823;
'use strict';


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e0782be6903ea7b$export$2d1720544b23b823;
'use strict';
var $1e0782be6903ea7b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e0782be6903ea7b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e0782be6903ea7b$var$NASHORN_BUG = $1e0782be6903ea7b$var$getOwnPropertyDescriptor && !$1e0782be6903ea7b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e0782be6903ea7b$export$2d1720544b23b823 = $1e0782be6903ea7b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e0782be6903ea7b$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e0782be6903ea7b$var$$propertyIsEnumerable;







// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6d99163b6684d050$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$6d99163b6684d050$export$2d1720544b23b823 = $ef322a7f89c3ed41$exports ? $6d99163b6684d050$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4d273c9d7e1bdf46$exports(O);
    P = $7f19acfe53927f5c$exports(P);
    if ($d45526d8245cb22c$exports) try {
        return $6d99163b6684d050$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($1f868a26fd901990$exports(O, P)) return $b66966b48674609b$exports(!$881ad37dbe259e8f$exports($1e0782be6903ea7b$export$2d1720544b23b823, O, P), O[P]);
};


var $ca3e1754e676956d$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;

var $40e957865125f98f$exports = {};
'use strict';




$40e957865125f98f$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($70e34a5a2021f756$exports(value)) $09c56ff2ae09b2d7$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $4ce407c7007beb63$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $2d0ac3aa5e39584b$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ef14b437ba65973a$exports = {};
'use strict';

var $339f2419d379e6c2$exports = {};
'use strict';


var $f6c32256739dd9b5$exports = {};

$parcel$export($f6c32256739dd9b5$exports, "f", () => $f6c32256739dd9b5$export$2d1720544b23b823, (v) => $f6c32256739dd9b5$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f6c32256739dd9b5$export$2d1720544b23b823;
'use strict';


var $f6c32256739dd9b5$var$hiddenKeys = $e73f13f1d8a17cad$exports.concat('length', 'prototype');
$f6c32256739dd9b5$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $c4fba4611365c4f5$exports(O, $f6c32256739dd9b5$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $0ed66cde5c449819$export$2d1720544b23b823;
'use strict';
$0ed66cde5c449819$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $339f2419d379e6c2$var$concat = $43b18aa2f1faac44$exports([].concat);
// all object keys, includes non-enumerable and symbols
$339f2419d379e6c2$exports = $a5217dbd1b0d33ce$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $f6c32256739dd9b5$export$2d1720544b23b823($c845d421b7b0e630$exports(it));
    var getOwnPropertySymbols = $0ed66cde5c449819$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $339f2419d379e6c2$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ef14b437ba65973a$exports = function(target, source, exceptions) {
    var keys = $339f2419d379e6c2$exports(source);
    var defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$1f868a26fd901990$exports(target, key) && !(exceptions && $1f868a26fd901990$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $ca268db110e9e457$exports = {};
'use strict';


var $ca268db110e9e457$var$replacement = /#|\.prototype\./;
var $ca268db110e9e457$var$isForced = function(feature, detection) {
    var value = $ca268db110e9e457$var$data[$ca268db110e9e457$var$normalize(feature)];
    return value === $ca268db110e9e457$var$POLYFILL ? true : value === $ca268db110e9e457$var$NATIVE ? false : $70e34a5a2021f756$exports(detection) ? $6140c9fa18232846$exports(detection) : !!detection;
};
var $ca268db110e9e457$var$normalize = $ca268db110e9e457$var$isForced.normalize = function(string) {
    return String(string).replace($ca268db110e9e457$var$replacement, '.').toLowerCase();
};
var $ca268db110e9e457$var$data = $ca268db110e9e457$var$isForced.data = {};
var $ca268db110e9e457$var$NATIVE = $ca268db110e9e457$var$isForced.NATIVE = 'N';
var $ca268db110e9e457$var$POLYFILL = $ca268db110e9e457$var$isForced.POLYFILL = 'P';
$ca268db110e9e457$exports = $ca268db110e9e457$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $ca3e1754e676956d$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $3fbf1185731afe2b$exports;
    else if (STATIC) target = $3fbf1185731afe2b$exports[TARGET] || $4ce407c7007beb63$exports(TARGET, {});
    else target = $3fbf1185731afe2b$exports[TARGET] && $3fbf1185731afe2b$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $ca3e1754e676956d$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $ca268db110e9e457$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ef14b437ba65973a$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $8693737507995841$exports(sourceProperty, 'sham', true);
        $40e957865125f98f$exports(target, key, sourceProperty, options);
    }
};


var $3cdb2ef65d8e3cb5$exports = {};
'use strict';

var $3cdb2ef65d8e3cb5$var$FunctionPrototype = Function.prototype;
var $3cdb2ef65d8e3cb5$var$apply = $3cdb2ef65d8e3cb5$var$FunctionPrototype.apply;
var $3cdb2ef65d8e3cb5$var$call = $3cdb2ef65d8e3cb5$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$3cdb2ef65d8e3cb5$exports = typeof Reflect == 'object' && Reflect.apply || ($bcbe62e89adc7d37$exports ? $3cdb2ef65d8e3cb5$var$call.bind($3cdb2ef65d8e3cb5$var$apply) : function() {
    return $3cdb2ef65d8e3cb5$var$call.apply($3cdb2ef65d8e3cb5$var$apply, arguments);
});


var $e12f552938f6c28b$exports = {};
'use strict';
'use strict';
'use strict';
var $6b78298c759520c1$exports = {};
'use strict';





var $0a7dfd4ed285865b$exports = {};
'use strict';






var $0a7dfd4ed285865b$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $2d32fe738cfc6a16$export$2d1720544b23b823;
'use strict';



var $2d32fe738cfc6a16$require$$getOwnPropertyNames = $f6c32256739dd9b5$export$2d1720544b23b823;
var $0709cba658bb4ed6$exports = {};
'use strict';

$0709cba658bb4ed6$exports = $43b18aa2f1faac44$exports([].slice);


var $2d32fe738cfc6a16$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $2d32fe738cfc6a16$var$getWindowNames = function(it) {
    try {
        return $2d32fe738cfc6a16$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $0709cba658bb4ed6$exports($2d32fe738cfc6a16$var$windowNames);
    }
};
$2d32fe738cfc6a16$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $2d32fe738cfc6a16$var$windowNames && $b0ba63bfbfb16088$exports(it) === 'Window' ? $2d32fe738cfc6a16$var$getWindowNames(it) : $2d32fe738cfc6a16$require$$getOwnPropertyNames($4d273c9d7e1bdf46$exports(it));
};


var $abe4acfbab10a1da$exports = {};
'use strict';



var $e3ff2916d5862bdc$exports = {};
'use strict';

$e3ff2916d5862bdc$exports = $6140c9fa18232846$exports(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $abe4acfbab10a1da$var$$isExtensible = Object.isExtensible;
var $abe4acfbab10a1da$var$FAILS_ON_PRIMITIVES = $6140c9fa18232846$exports(function() {
    $abe4acfbab10a1da$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$abe4acfbab10a1da$exports = $abe4acfbab10a1da$var$FAILS_ON_PRIMITIVES || $e3ff2916d5862bdc$exports ? function isExtensible(it) {
    if (!$6a130d390db46c8e$exports(it)) return false;
    if ($e3ff2916d5862bdc$exports && $b0ba63bfbfb16088$exports(it) === 'ArrayBuffer') return false;
    return $abe4acfbab10a1da$var$$isExtensible ? $abe4acfbab10a1da$var$$isExtensible(it) : true;
} : $abe4acfbab10a1da$var$$isExtensible;



var $ef4d4edd3daa687a$exports = {};
'use strict';

$ef4d4edd3daa687a$exports = !$6140c9fa18232846$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $0a7dfd4ed285865b$var$REQUIRED = false;
var $0a7dfd4ed285865b$var$METADATA = $5e0a1e292f79defc$exports('meta');
var $0a7dfd4ed285865b$var$id = 0;
var $0a7dfd4ed285865b$var$setMetadata = function(it) {
    $0a7dfd4ed285865b$require$defineProperty(it, $0a7dfd4ed285865b$var$METADATA, {
        value: {
            objectID: 'O' + $0a7dfd4ed285865b$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $0a7dfd4ed285865b$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$6a130d390db46c8e$exports(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$1f868a26fd901990$exports(it, $0a7dfd4ed285865b$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$abe4acfbab10a1da$exports(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $0a7dfd4ed285865b$var$setMetadata(it);
    // return object ID
    }
    return it[$0a7dfd4ed285865b$var$METADATA].objectID;
};
var $0a7dfd4ed285865b$var$getWeakData = function(it, create) {
    if (!$1f868a26fd901990$exports(it, $0a7dfd4ed285865b$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$abe4acfbab10a1da$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $0a7dfd4ed285865b$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$0a7dfd4ed285865b$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $0a7dfd4ed285865b$var$onFreeze = function(it) {
    if ($ef4d4edd3daa687a$exports && $0a7dfd4ed285865b$var$REQUIRED && $abe4acfbab10a1da$exports(it) && !$1f868a26fd901990$exports(it, $0a7dfd4ed285865b$var$METADATA)) $0a7dfd4ed285865b$var$setMetadata(it);
    return it;
};
var $0a7dfd4ed285865b$var$enable = function() {
    $0a7dfd4ed285865b$var$meta.enable = function() {};
    $0a7dfd4ed285865b$var$REQUIRED = true;
    var getOwnPropertyNames = $f6c32256739dd9b5$export$2d1720544b23b823;
    var splice = $43b18aa2f1faac44$exports([].splice);
    var test = {};
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    test[$0a7dfd4ed285865b$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $f6c32256739dd9b5$exports.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $0a7dfd4ed285865b$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $ca3e1754e676956d$exports({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $2d32fe738cfc6a16$export$2d1720544b23b823
        });
    }
};
var $0a7dfd4ed285865b$var$meta = $0a7dfd4ed285865b$exports = {
    enable: $0a7dfd4ed285865b$var$enable,
    fastKey: $0a7dfd4ed285865b$var$fastKey,
    getWeakData: $0a7dfd4ed285865b$var$getWeakData,
    onFreeze: $0a7dfd4ed285865b$var$onFreeze
};
$9f571a3f3d135e31$exports[$0a7dfd4ed285865b$var$METADATA] = true;


var $a78806ef4ebb6167$exports = {};
'use strict';
var $43284f0171045916$exports = {};
'use strict';
var $4828cb1b4c7586c8$exports = {};
'use strict';


$4828cb1b4c7586c8$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($b0ba63bfbfb16088$exports(fn) === 'Function') return $43b18aa2f1faac44$exports(fn);
};




var $43284f0171045916$var$bind = $4828cb1b4c7586c8$exports($4828cb1b4c7586c8$exports.bind);
// optional / simple context binding
$43284f0171045916$exports = function(fn, that) {
    $ae485921c5498156$exports(fn);
    return that === undefined ? fn : $bcbe62e89adc7d37$exports ? $43284f0171045916$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $570a6df80758b4be$exports = {};
'use strict';

var $0fe0dd04b0eb22af$exports = {};
'use strict';
$0fe0dd04b0eb22af$exports = {};


var $570a6df80758b4be$var$ITERATOR = $842f8f0a18746212$exports('iterator');
var $570a6df80758b4be$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$570a6df80758b4be$exports = function(it) {
    return it !== undefined && ($0fe0dd04b0eb22af$exports.Array === it || $570a6df80758b4be$var$ArrayPrototype[$570a6df80758b4be$var$ITERATOR] === it);
};




var $13a4c31eee540026$exports = {};
'use strict';




var $8d560b8b837672a0$exports = {};
'use strict';
var $b07c9aec2f9c74e4$exports = {};
'use strict';
var $a2c149aaa14cc75b$exports = {};
'use strict';

var $a2c149aaa14cc75b$var$TO_STRING_TAG = $842f8f0a18746212$exports('toStringTag');
var $a2c149aaa14cc75b$var$test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
$a2c149aaa14cc75b$var$test[$a2c149aaa14cc75b$var$TO_STRING_TAG] = 'z';
$a2c149aaa14cc75b$exports = String($a2c149aaa14cc75b$var$test) === '[object z]';





var $b07c9aec2f9c74e4$var$TO_STRING_TAG = $842f8f0a18746212$exports('toStringTag');
var $b07c9aec2f9c74e4$var$$Object = Object;
// ES3 wrong here
var $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS = $b0ba63bfbfb16088$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $b07c9aec2f9c74e4$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$b07c9aec2f9c74e4$exports = $a2c149aaa14cc75b$exports ? $b0ba63bfbfb16088$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $b07c9aec2f9c74e4$var$tryGet(O = $b07c9aec2f9c74e4$var$$Object(it), $b07c9aec2f9c74e4$var$TO_STRING_TAG)) == 'string' ? tag : $b07c9aec2f9c74e4$var$CORRECT_ARGUMENTS ? $b0ba63bfbfb16088$exports(O) : (result = $b0ba63bfbfb16088$exports(O)) === 'Object' && $70e34a5a2021f756$exports(O.callee) ? 'Arguments' : result;
};






var $8d560b8b837672a0$var$ITERATOR = $842f8f0a18746212$exports('iterator');
$8d560b8b837672a0$exports = function(it) {
    if (!$7ce250ddf7b42d4d$exports(it)) return $eb80dcd0b8a5698c$exports(it, $8d560b8b837672a0$var$ITERATOR) || $eb80dcd0b8a5698c$exports(it, '@@iterator') || $0fe0dd04b0eb22af$exports[$b07c9aec2f9c74e4$exports(it)];
};


var $13a4c31eee540026$var$$TypeError = TypeError;
$13a4c31eee540026$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8d560b8b837672a0$exports(argument) : usingIterator;
    if ($ae485921c5498156$exports(iteratorMethod)) return $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(iteratorMethod, argument));
    throw new $13a4c31eee540026$var$$TypeError($8f0ebae34f61e14c$exports(argument) + ' is not iterable');
};



var $4105790cb9bf2aaa$exports = {};
'use strict';



$4105790cb9bf2aaa$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c845d421b7b0e630$exports(iterator);
    try {
        innerResult = $eb80dcd0b8a5698c$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $881ad37dbe259e8f$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $c845d421b7b0e630$exports(innerResult);
    return value;
};


var $a78806ef4ebb6167$var$$TypeError = TypeError;
var $a78806ef4ebb6167$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $a78806ef4ebb6167$var$ResultPrototype = $a78806ef4ebb6167$var$Result.prototype;
$a78806ef4ebb6167$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $43284f0171045916$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        var $iterator = iterator;
        iterator = undefined;
        if ($iterator) $4105790cb9bf2aaa$exports($iterator, 'normal');
        return new $a78806ef4ebb6167$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c845d421b7b0e630$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8d560b8b837672a0$exports(iterable);
        if (!iterFn) throw new $a78806ef4ebb6167$var$$TypeError($8f0ebae34f61e14c$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($570a6df80758b4be$exports(iterFn)) {
            for(index = 0, length = $04c91bd3815cd64a$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
            }
            return new $a78806ef4ebb6167$var$Result(false);
        }
        iterator = $13a4c31eee540026$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        // `IteratorValue` errors should propagate without closing the iterator
        var value = step.value;
        try {
            result = callFn(value);
        } catch (error) {
            if (iterator) $4105790cb9bf2aaa$exports(iterator, 'throw', error);
            else throw error;
        }
        if (typeof result == 'object' && result && $41cc576e850a251e$exports($a78806ef4ebb6167$var$ResultPrototype, result)) return result;
    }
    return new $a78806ef4ebb6167$var$Result(false);
};


var $85de2a4f93f1c485$exports = {};
'use strict';

var $85de2a4f93f1c485$var$$TypeError = TypeError;
$85de2a4f93f1c485$exports = function(it, Prototype) {
    if ($41cc576e850a251e$exports(Prototype, it)) return it;
    throw new $85de2a4f93f1c485$var$$TypeError('Incorrect invocation');
};






var $159ca9ebcc568d56$exports = {};
'use strict';

var $159ca9ebcc568d56$var$ITERATOR = $842f8f0a18746212$exports('iterator');
var $159ca9ebcc568d56$var$SAFE_CLOSING = false;
try {
    var $159ca9ebcc568d56$var$called = 0;
    var $159ca9ebcc568d56$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$159ca9ebcc568d56$var$called++
            };
        },
        'return': function() {
            $159ca9ebcc568d56$var$SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    $159ca9ebcc568d56$var$iteratorWithReturn[$159ca9ebcc568d56$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($159ca9ebcc568d56$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$159ca9ebcc568d56$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$159ca9ebcc568d56$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[$159ca9ebcc568d56$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $3984243ae29093af$exports = {};
'use strict';

var $3984243ae29093af$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;


var $3984243ae29093af$var$TO_STRING_TAG = $842f8f0a18746212$exports('toStringTag');
$3984243ae29093af$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$1f868a26fd901990$exports(target, $3984243ae29093af$var$TO_STRING_TAG)) $3984243ae29093af$require$defineProperty(target, $3984243ae29093af$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};


var $c84532d17907c41e$exports = {};
'use strict';


var $5e6994558f51b773$exports = {};
'use strict';
var $ab274a67893419f3$exports = {};
'use strict';


$ab274a67893419f3$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $43b18aa2f1faac44$exports($ae485921c5498156$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $d4d31549cf7c058b$exports = {};
'use strict';
var $46bfa91322f93a01$exports = {};
'use strict';

$46bfa91322f93a01$exports = function(argument) {
    return $6a130d390db46c8e$exports(argument) || argument === null;
};


var $d4d31549cf7c058b$var$$String = String;
var $d4d31549cf7c058b$var$$TypeError = TypeError;
$d4d31549cf7c058b$exports = function(argument) {
    if ($46bfa91322f93a01$exports(argument)) return argument;
    throw new $d4d31549cf7c058b$var$$TypeError("Can't set " + $d4d31549cf7c058b$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$5e6994558f51b773$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $ab274a67893419f3$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $c378177673193450$exports(O);
        $d4d31549cf7c058b$exports(proto);
        if (!$6a130d390db46c8e$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);


// makes subclassing work correct for wrapped built-ins
$c84532d17907c41e$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $5e6994558f51b773$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $70e34a5a2021f756$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $6a130d390db46c8e$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $5e6994558f51b773$exports($this, NewTargetPrototype);
    return $this;
};


$6b78298c759520c1$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $3fbf1185731afe2b$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $43b18aa2f1faac44$exports(NativePrototype[KEY]);
        $40e957865125f98f$exports(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !$6a130d390db46c8e$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !$6a130d390db46c8e$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !$6a130d390db46c8e$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $ca268db110e9e457$exports(CONSTRUCTOR_NAME, !$70e34a5a2021f756$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$6140c9fa18232846$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $0a7dfd4ed285865b$exports.enable();
    } else if ($ca268db110e9e457$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $6140c9fa18232846$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $159ca9ebcc568d56$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $6140c9fa18232846$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $85de2a4f93f1c485$exports(dummy, NativePrototype);
                var that = $c84532d17907c41e$exports(new NativeConstructor(), dummy, Constructor);
                if (!$7ce250ddf7b42d4d$exports(iterable)) $a78806ef4ebb6167$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $ca3e1754e676956d$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $3984243ae29093af$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $941be47da6423263$exports = {};
'use strict';


var $a3d227a61e709d75$exports = {};
'use strict';

$a3d227a61e709d75$exports = function(target, src, options) {
    for(var key in src)$40e957865125f98f$exports(target, key, src[key], options);
    return target;
};






var $9a73e569966b34cd$exports = {};
'use strict';





var $2428e9d9593354c3$exports = {};
'use strict';
var $82ce71e2bd45bc6e$exports = {};
'use strict';




var $a69a130329c6de82$exports = {};
'use strict';




var $e4c58b47d3c8d112$exports = {};
'use strict';

$e4c58b47d3c8d112$exports = !$6140c9fa18232846$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $a69a130329c6de82$var$IE_PROTO = $834abcf0f8f3f871$exports('IE_PROTO');
var $a69a130329c6de82$var$$Object = Object;
var $a69a130329c6de82$var$ObjectPrototype = $a69a130329c6de82$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$a69a130329c6de82$exports = $e4c58b47d3c8d112$exports ? $a69a130329c6de82$var$$Object.getPrototypeOf : function(O) {
    var object = $a2f3ebb5da11db12$exports(O);
    if ($1f868a26fd901990$exports(object, $a69a130329c6de82$var$IE_PROTO)) return object[$a69a130329c6de82$var$IE_PROTO];
    var constructor = object.constructor;
    if ($70e34a5a2021f756$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $a69a130329c6de82$var$$Object ? $a69a130329c6de82$var$ObjectPrototype : null;
};





var $82ce71e2bd45bc6e$var$ITERATOR = $842f8f0a18746212$exports('iterator');
var $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $82ce71e2bd45bc6e$var$IteratorPrototype, $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype, $82ce71e2bd45bc6e$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $82ce71e2bd45bc6e$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $82ce71e2bd45bc6e$var$arrayIterator)) $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype = $a69a130329c6de82$exports($a69a130329c6de82$exports($82ce71e2bd45bc6e$var$arrayIterator));
        if ($82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $82ce71e2bd45bc6e$var$IteratorPrototype = $82ce71e2bd45bc6e$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $82ce71e2bd45bc6e$var$NEW_ITERATOR_PROTOTYPE = !$6a130d390db46c8e$exports($82ce71e2bd45bc6e$var$IteratorPrototype) || $6140c9fa18232846$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $82ce71e2bd45bc6e$var$IteratorPrototype[$82ce71e2bd45bc6e$var$ITERATOR].call(test) !== test;
});
if ($82ce71e2bd45bc6e$var$NEW_ITERATOR_PROTOTYPE) $82ce71e2bd45bc6e$var$IteratorPrototype = {};
else if ($e0409817d4e03fc4$exports) $82ce71e2bd45bc6e$var$IteratorPrototype = $5c0346dde328cc4c$exports($82ce71e2bd45bc6e$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$70e34a5a2021f756$exports($82ce71e2bd45bc6e$var$IteratorPrototype[$82ce71e2bd45bc6e$var$ITERATOR])) $40e957865125f98f$exports($82ce71e2bd45bc6e$var$IteratorPrototype, $82ce71e2bd45bc6e$var$ITERATOR, function() {
    return this;
});
$82ce71e2bd45bc6e$exports = {
    IteratorPrototype: $82ce71e2bd45bc6e$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $82ce71e2bd45bc6e$var$BUGGY_SAFARI_ITERATORS
};


var $2428e9d9593354c3$require$IteratorPrototype = $82ce71e2bd45bc6e$exports.IteratorPrototype;




var $2428e9d9593354c3$var$returnThis = function() {
    return this;
};
$2428e9d9593354c3$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $5c0346dde328cc4c$exports($2428e9d9593354c3$require$IteratorPrototype, {
        next: $b66966b48674609b$exports(+!ENUMERABLE_NEXT, next)
    });
    $3984243ae29093af$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $0fe0dd04b0eb22af$exports[TO_STRING_TAG] = $2428e9d9593354c3$var$returnThis;
    return IteratorConstructor;
};










var $9a73e569966b34cd$var$PROPER_FUNCTION_NAME = $81c64883d194e3b4$exports.PROPER;
var $9a73e569966b34cd$var$CONFIGURABLE_FUNCTION_NAME = $81c64883d194e3b4$exports.CONFIGURABLE;
var $9a73e569966b34cd$var$IteratorPrototype = $82ce71e2bd45bc6e$exports.IteratorPrototype;
var $9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS = $82ce71e2bd45bc6e$exports.BUGGY_SAFARI_ITERATORS;
var $9a73e569966b34cd$var$ITERATOR = $842f8f0a18746212$exports('iterator');
var $9a73e569966b34cd$var$KEYS = 'keys';
var $9a73e569966b34cd$var$VALUES = 'values';
var $9a73e569966b34cd$var$ENTRIES = 'entries';
var $9a73e569966b34cd$var$returnThis = function() {
    return this;
};
$9a73e569966b34cd$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2428e9d9593354c3$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $9a73e569966b34cd$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $9a73e569966b34cd$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $9a73e569966b34cd$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$9a73e569966b34cd$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $a69a130329c6de82$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$e0409817d4e03fc4$exports && $a69a130329c6de82$exports(CurrentIteratorPrototype) !== $9a73e569966b34cd$var$IteratorPrototype) {
                if ($5e6994558f51b773$exports) $5e6994558f51b773$exports(CurrentIteratorPrototype, $9a73e569966b34cd$var$IteratorPrototype);
                else if (!$70e34a5a2021f756$exports(CurrentIteratorPrototype[$9a73e569966b34cd$var$ITERATOR])) $40e957865125f98f$exports(CurrentIteratorPrototype, $9a73e569966b34cd$var$ITERATOR, $9a73e569966b34cd$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $3984243ae29093af$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($e0409817d4e03fc4$exports) $0fe0dd04b0eb22af$exports[TO_STRING_TAG] = $9a73e569966b34cd$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($9a73e569966b34cd$var$PROPER_FUNCTION_NAME && DEFAULT === $9a73e569966b34cd$var$VALUES && nativeIterator && nativeIterator.name !== $9a73e569966b34cd$var$VALUES) {
        if (!$e0409817d4e03fc4$exports && $9a73e569966b34cd$var$CONFIGURABLE_FUNCTION_NAME) $8693737507995841$exports(IterablePrototype, 'name', $9a73e569966b34cd$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $881ad37dbe259e8f$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($9a73e569966b34cd$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($9a73e569966b34cd$var$KEYS),
            entries: getIterationMethod($9a73e569966b34cd$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $40e957865125f98f$exports(IterablePrototype, KEY, methods[KEY]);
        } else $ca3e1754e676956d$exports({
            target: NAME,
            proto: true,
            forced: $9a73e569966b34cd$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$e0409817d4e03fc4$exports || FORCED) && IterablePrototype[$9a73e569966b34cd$var$ITERATOR] !== defaultIterator) $40e957865125f98f$exports(IterablePrototype, $9a73e569966b34cd$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $0fe0dd04b0eb22af$exports[NAME] = defaultIterator;
    return methods;
};


var $dfab5f5c406cd291$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$dfab5f5c406cd291$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};


var $0df731b64ad8eead$exports = {};
'use strict';




var $0df731b64ad8eead$var$SPECIES = $842f8f0a18746212$exports('species');
$0df731b64ad8eead$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $a5217dbd1b0d33ce$exports(CONSTRUCTOR_NAME);
    if ($ef322a7f89c3ed41$exports && Constructor && !Constructor[$0df731b64ad8eead$var$SPECIES]) $74a6fb831e72713b$exports(Constructor, $0df731b64ad8eead$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};




var $941be47da6423263$require$fastKey = $0a7dfd4ed285865b$exports.fastKey;

var $941be47da6423263$var$setInternalState = $3a8bcef306e86159$exports.set;
var $941be47da6423263$var$internalStateGetterFor = $3a8bcef306e86159$exports.getterFor;
$941be47da6423263$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $85de2a4f93f1c485$exports(that, Prototype);
            $941be47da6423263$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $5c0346dde328cc4c$exports(null),
                first: null,
                last: null,
                size: 0
            });
            if (!$ef322a7f89c3ed41$exports) that.size = 0;
            if (!$7ce250ddf7b42d4d$exports(iterable)) $a78806ef4ebb6167$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $941be47da6423263$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $941be47da6423263$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: null,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($ef322a7f89c3ed41$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== 'F') state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $941be47da6423263$require$fastKey(key);
            var entry;
            if (index !== 'F') return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key === key) return entry;
            }
        };
        $a3d227a61e709d75$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = null;
                    entry = entry.next;
                }
                state.first = state.last = null;
                state.index = $5c0346dde328cc4c$exports(null);
                if ($ef322a7f89c3ed41$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            'delete': function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first === entry) state.first = next;
                    if (state.last === entry) state.last = prev;
                    if ($ef322a7f89c3ed41$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $a3d227a61e709d75$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($ef322a7f89c3ed41$exports) $74a6fb831e72713b$exports(Prototype, 'size', {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = $941be47da6423263$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $941be47da6423263$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $9a73e569966b34cd$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $941be47da6423263$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: null
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = null;
                return $dfab5f5c406cd291$exports(undefined, true);
            }
            // return step by kind
            if (kind === 'keys') return $dfab5f5c406cd291$exports(entry.key, false);
            if (kind === 'values') return $dfab5f5c406cd291$exports(entry.value, false);
            return $dfab5f5c406cd291$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $0df731b64ad8eead$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$6b78298c759520c1$exports('Map', function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $941be47da6423263$exports);




'use strict';
'use strict';






var $57377286d950d3fe$exports = {};
'use strict';



var $57377286d950d3fe$require$getWeakData = $0a7dfd4ed285865b$exports.getWeakData;





var $b83decaf38ef8d03$exports = {};
'use strict';




var $ff0c754b12dbde54$exports = {};
'use strict';
var $9f39c016fe266197$exports = {};
'use strict';
var $c73d879bf8761e55$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$c73d879bf8761e55$exports = Array.isArray || function isArray(argument) {
    return $b0ba63bfbfb16088$exports(argument) === 'Array';
};


var $1abaf8429012df1f$exports = {};
'use strict';






var $1abaf8429012df1f$var$noop = function() {};
var $1abaf8429012df1f$var$construct = $a5217dbd1b0d33ce$exports('Reflect', 'construct');
var $1abaf8429012df1f$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $1abaf8429012df1f$var$exec = $43b18aa2f1faac44$exports($1abaf8429012df1f$var$constructorRegExp.exec);
var $1abaf8429012df1f$var$INCORRECT_TO_STRING = !$1abaf8429012df1f$var$constructorRegExp.test($1abaf8429012df1f$var$noop);
var $1abaf8429012df1f$var$isConstructorModern = function isConstructor(argument) {
    if (!$70e34a5a2021f756$exports(argument)) return false;
    try {
        $1abaf8429012df1f$var$construct($1abaf8429012df1f$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $1abaf8429012df1f$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$70e34a5a2021f756$exports(argument)) return false;
    switch($b07c9aec2f9c74e4$exports(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $1abaf8429012df1f$var$INCORRECT_TO_STRING || !!$1abaf8429012df1f$var$exec($1abaf8429012df1f$var$constructorRegExp, $9990f6f719f26a96$exports(argument));
    } catch (error) {
        return true;
    }
};
$1abaf8429012df1f$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$1abaf8429012df1f$exports = !$1abaf8429012df1f$var$construct || $6140c9fa18232846$exports(function() {
    var called;
    return $1abaf8429012df1f$var$isConstructorModern($1abaf8429012df1f$var$isConstructorModern.call) || !$1abaf8429012df1f$var$isConstructorModern(Object) || !$1abaf8429012df1f$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $1abaf8429012df1f$var$isConstructorLegacy : $1abaf8429012df1f$var$isConstructorModern;




var $9f39c016fe266197$var$SPECIES = $842f8f0a18746212$exports('species');
var $9f39c016fe266197$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$9f39c016fe266197$exports = function(originalArray) {
    var C;
    if ($c73d879bf8761e55$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($1abaf8429012df1f$exports(C) && (C === $9f39c016fe266197$var$$Array || $c73d879bf8761e55$exports(C.prototype))) C = undefined;
        else if ($6a130d390db46c8e$exports(C)) {
            C = C[$9f39c016fe266197$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $9f39c016fe266197$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$ff0c754b12dbde54$exports = function(originalArray, length) {
    return new ($9f39c016fe266197$exports(originalArray))(length === 0 ? 0 : length);
};


var $d8c8827d6e29b8f8$exports = {};
'use strict';



$d8c8827d6e29b8f8$exports = function(object, key, value) {
    if ($ef322a7f89c3ed41$exports) $2d0ac3aa5e39584b$export$2d1720544b23b823(object, key, $b66966b48674609b$exports(0, value));
    else object[key] = value;
};


// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $b83decaf38ef8d03$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that) {
        var O = $a2f3ebb5da11db12$exports($this);
        var self = $8239f4c7c6082668$exports(O);
        var length = $04c91bd3815cd64a$exports(self);
        var boundFunction = $43284f0171045916$exports(callbackfn, that);
        var index = 0;
        var resIndex = 0;
        var target = IS_MAP ? $ff0c754b12dbde54$exports($this, length) : IS_FILTER || IS_FILTER_REJECT ? $ff0c754b12dbde54$exports($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) $d8c8827d6e29b8f8$exports(target, index, result); // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $d8c8827d6e29b8f8$exports(target, resIndex++, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $d8c8827d6e29b8f8$exports(target, resIndex++, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$b83decaf38ef8d03$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $b83decaf38ef8d03$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $b83decaf38ef8d03$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $b83decaf38ef8d03$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $b83decaf38ef8d03$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $b83decaf38ef8d03$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $b83decaf38ef8d03$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $b83decaf38ef8d03$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $b83decaf38ef8d03$var$createMethod(7)
};




var $57377286d950d3fe$var$setInternalState = $3a8bcef306e86159$exports.set;
var $57377286d950d3fe$var$internalStateGetterFor = $3a8bcef306e86159$exports.getterFor;
var $57377286d950d3fe$var$find = $b83decaf38ef8d03$exports.find;
var $57377286d950d3fe$var$findIndex = $b83decaf38ef8d03$exports.findIndex;
var $57377286d950d3fe$var$splice = $43b18aa2f1faac44$exports([].splice);
var $57377286d950d3fe$var$id = 0;
// fallback for uncaught frozen keys
var $57377286d950d3fe$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $57377286d950d3fe$var$UncaughtFrozenStore());
};
var $57377286d950d3fe$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $57377286d950d3fe$var$findUncaughtFrozen = function(store, key) {
    return $57377286d950d3fe$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$57377286d950d3fe$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $57377286d950d3fe$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$57377286d950d3fe$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $57377286d950d3fe$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $57377286d950d3fe$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $57377286d950d3fe$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$57377286d950d3fe$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $85de2a4f93f1c485$exports(that, Prototype);
            $57377286d950d3fe$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $57377286d950d3fe$var$id++,
                frozen: null
            });
            if (!$7ce250ddf7b42d4d$exports(iterable)) $a78806ef4ebb6167$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $57377286d950d3fe$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $57377286d950d3fe$require$getWeakData($c845d421b7b0e630$exports(key), true);
            if (data === true) $57377286d950d3fe$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $a3d227a61e709d75$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$6a130d390db46c8e$exports(key)) return false;
                var data = $57377286d950d3fe$require$getWeakData(key);
                if (data === true) return $57377286d950d3fe$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $1f868a26fd901990$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$6a130d390db46c8e$exports(key)) return false;
                var data = $57377286d950d3fe$require$getWeakData(key);
                if (data === true) return $57377286d950d3fe$var$uncaughtFrozenStore(state).has(key);
                return data && $1f868a26fd901990$exports(data, state.id);
            }
        });
        $a3d227a61e709d75$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($6a130d390db46c8e$exports(key)) {
                    var data = $57377286d950d3fe$require$getWeakData(key);
                    if (data === true) return $57377286d950d3fe$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $341abe5437092e31$require$enforceInternalState = $3a8bcef306e86159$exports.enforce;


var $341abe5437092e31$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $341abe5437092e31$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $341abe5437092e31$var$isExtensible = $341abe5437092e31$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $341abe5437092e31$var$isFrozen = $341abe5437092e31$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $341abe5437092e31$var$isSealed = $341abe5437092e31$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $341abe5437092e31$var$freeze = $341abe5437092e31$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $341abe5437092e31$var$seal = $341abe5437092e31$var$$Object.seal;
var $341abe5437092e31$var$IS_IE11 = !$3fbf1185731afe2b$exports.ActiveXObject && 'ActiveXObject' in $3fbf1185731afe2b$exports;
var $341abe5437092e31$var$InternalWeakMap;
var $341abe5437092e31$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $341abe5437092e31$var$$WeakMap = $6b78298c759520c1$exports('WeakMap', $341abe5437092e31$var$wrapper, $57377286d950d3fe$exports);
var $341abe5437092e31$var$WeakMapPrototype = $341abe5437092e31$var$$WeakMap.prototype;
var $341abe5437092e31$var$nativeSet = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $341abe5437092e31$var$hasMSEdgeFreezingBug = function() {
    return $ef4d4edd3daa687a$exports && $6140c9fa18232846$exports(function() {
        var frozenArray = $341abe5437092e31$var$freeze([]);
        $341abe5437092e31$var$nativeSet(new $341abe5437092e31$var$$WeakMap(), frozenArray, 1);
        return !$341abe5437092e31$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($47d53bb84a8f3c5b$exports) {
    if ($341abe5437092e31$var$IS_IE11) {
        $341abe5437092e31$var$InternalWeakMap = $57377286d950d3fe$exports.getConstructor($341abe5437092e31$var$wrapper, 'WeakMap', true);
        $0a7dfd4ed285865b$exports.enable();
        var $341abe5437092e31$var$nativeDelete = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype['delete']);
        var $341abe5437092e31$var$nativeHas = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype.has);
        var $341abe5437092e31$var$nativeGet = $43b18aa2f1faac44$exports($341abe5437092e31$var$WeakMapPrototype.get);
        $a3d227a61e709d75$exports($341abe5437092e31$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    return $341abe5437092e31$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $341abe5437092e31$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    return $341abe5437092e31$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $341abe5437092e31$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    return $341abe5437092e31$var$nativeHas(this, key) ? $341abe5437092e31$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $341abe5437092e31$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($6a130d390db46c8e$exports(key) && !$341abe5437092e31$var$isExtensible(key)) {
                    var state = $341abe5437092e31$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $341abe5437092e31$var$InternalWeakMap();
                    $341abe5437092e31$var$nativeHas(this, key) ? $341abe5437092e31$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $341abe5437092e31$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($341abe5437092e31$var$hasMSEdgeFreezingBug()) $a3d227a61e709d75$exports($341abe5437092e31$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($341abe5437092e31$var$isArray(key)) {
                if ($341abe5437092e31$var$isFrozen(key)) arrayIntegrityLevel = $341abe5437092e31$var$freeze;
                else if ($341abe5437092e31$var$isSealed(key)) arrayIntegrityLevel = $341abe5437092e31$var$seal;
            }
            $341abe5437092e31$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}







var $e12f552938f6c28b$var$$Object = Object;
var $e12f552938f6c28b$var$$TypeError = TypeError;
var $e12f552938f6c28b$var$Map = $a5217dbd1b0d33ce$exports('Map');
var $e12f552938f6c28b$var$WeakMap = $a5217dbd1b0d33ce$exports('WeakMap');
var $e12f552938f6c28b$var$Node = function() {
    // keys
    this.object = null;
    this.symbol = null;
    // child nodes
    this.primitives = null;
    this.objectsByIndex = $5c0346dde328cc4c$exports(null);
};
$e12f552938f6c28b$var$Node.prototype.get = function(key, initializer) {
    return this[key] || (this[key] = initializer());
};
$e12f552938f6c28b$var$Node.prototype.next = function(i, it, IS_OBJECT) {
    var store = IS_OBJECT ? this.objectsByIndex[i] || (this.objectsByIndex[i] = new $e12f552938f6c28b$var$WeakMap()) : this.primitives || (this.primitives = new $e12f552938f6c28b$var$Map());
    var entry = store.get(it);
    if (!entry) store.set(it, entry = new $e12f552938f6c28b$var$Node());
    return entry;
};
var $e12f552938f6c28b$var$root = new $e12f552938f6c28b$var$Node();
$e12f552938f6c28b$exports = function() {
    var active = $e12f552938f6c28b$var$root;
    var length = arguments.length;
    var i, it;
    // for prevent leaking, start from objects
    for(i = 0; i < length; i++)if ($6a130d390db46c8e$exports(it = arguments[i])) active = active.next(i, it, true);
    if (this === $e12f552938f6c28b$var$$Object && active === $e12f552938f6c28b$var$root) throw new $e12f552938f6c28b$var$$TypeError('Composite keys must contain a non-primitive component');
    for(i = 0; i < length; i++)if (!$6a130d390db46c8e$exports(it = arguments[i])) active = active.next(i, it, false);
    return active;
};




var $ce0417b2220ce615$var$$Object = Object;
var $ce0417b2220ce615$var$initializer = function() {
    var freeze = $a5217dbd1b0d33ce$exports('Object', 'freeze');
    return freeze ? freeze($5c0346dde328cc4c$exports(null)) : $5c0346dde328cc4c$exports(null);
};
// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$ca3e1754e676956d$exports({
    global: true,
    forced: true
}, {
    compositeKey: function compositeKey() {
        return $3cdb2ef65d8e3cb5$exports($e12f552938f6c28b$exports, $ce0417b2220ce615$var$$Object, arguments).get('object', $ce0417b2220ce615$var$initializer);
    }
});


'use strict';




// https://github.com/tc39/proposal-richer-keys/tree/master/compositeKey
$ca3e1754e676956d$exports({
    global: true,
    forced: true
}, {
    compositeSymbol: function compositeSymbol() {
        if (arguments.length === 1 && typeof arguments[0] == 'string') return $a5217dbd1b0d33ce$exports('Symbol')['for'](arguments[0]);
        return $3cdb2ef65d8e3cb5$exports($e12f552938f6c28b$exports, null, arguments).get('symbol', $a5217dbd1b0d33ce$exports('Symbol'));
    }
});


'use strict';

var $a39ae7ae5ecd9c38$exports = {};
'use strict';
var $e055c888a6d66079$exports = {};
'use strict';

// eslint-disable-next-line es/no-map -- safe
var $e055c888a6d66079$var$MapPrototype = Map.prototype;
$e055c888a6d66079$exports = {
    // eslint-disable-next-line es/no-map -- safe
    Map: Map,
    set: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.set),
    get: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.get),
    has: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype.has),
    remove: $43b18aa2f1faac44$exports($e055c888a6d66079$var$MapPrototype['delete']),
    proto: $e055c888a6d66079$var$MapPrototype
};


var $a39ae7ae5ecd9c38$require$has = $e055c888a6d66079$exports.has;
// Perform ? RequireInternalSlot(M, [[MapData]])
$a39ae7ae5ecd9c38$exports = function(it) {
    $a39ae7ae5ecd9c38$require$has(it);
    return it;
};



var $d3b2d4177c8bb8cf$require$remove = $e055c888a6d66079$exports.remove;
// `Map.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $a39ae7ae5ecd9c38$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $d3b2d4177c8bb8cf$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';



var $4ff0f82b80a31785$exports = {};
'use strict';

var $c3b265c1265de03f$exports = {};
'use strict';

$c3b265c1265de03f$exports = function(record, fn, ITERATOR_INSTEAD_OF_RECORD) {
    var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
    var next = record.next;
    var step, result;
    while(!(step = $881ad37dbe259e8f$exports(next, iterator)).done){
        result = fn(step.value);
        if (result !== undefined) return result;
    }
};



var $4ff0f82b80a31785$var$Map = $e055c888a6d66079$exports.Map;
var $4ff0f82b80a31785$var$MapPrototype = $e055c888a6d66079$exports.proto;
var $4ff0f82b80a31785$var$forEach = $43b18aa2f1faac44$exports($4ff0f82b80a31785$var$MapPrototype.forEach);
var $4ff0f82b80a31785$var$entries = $43b18aa2f1faac44$exports($4ff0f82b80a31785$var$MapPrototype.entries);
var $4ff0f82b80a31785$var$next = $4ff0f82b80a31785$var$entries(new $4ff0f82b80a31785$var$Map()).next;
$4ff0f82b80a31785$exports = function(map, fn, interruptible) {
    return interruptible ? $c3b265c1265de03f$exports({
        iterator: $4ff0f82b80a31785$var$entries(map),
        next: $4ff0f82b80a31785$var$next
    }, function(entry) {
        return fn(entry[1], entry[0]);
    }) : $4ff0f82b80a31785$var$forEach(map, fn);
};


// `Map.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $4ff0f82b80a31785$exports(map, function(value, key) {
            if (!boundFunction(value, key, map)) return false;
        }, true) !== false;
    }
});


'use strict';





var $ea55e810e162ec8e$var$Map = $e055c888a6d66079$exports.Map;
var $ea55e810e162ec8e$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $ea55e810e162ec8e$var$Map();
        $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) $ea55e810e162ec8e$var$set(newMap, key, value);
        });
        return newMap;
    }
});


'use strict';




// `Map.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


'use strict';




// `Map.prototype.findKey` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    findKey: function findKey(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


'use strict';


var $0026225b23b40e5f$exports = {};
'use strict';




$0026225b23b40e5f$exports = function(C, adder, ENTRY) {
    return function from(source /* , mapFn, thisArg */ ) {
        var O = $a2f3ebb5da11db12$exports(source);
        var length = arguments.length;
        var mapFn = length > 1 ? arguments[1] : undefined;
        var mapping = mapFn !== undefined;
        var boundFunction = mapping ? $43284f0171045916$exports(mapFn, length > 2 ? arguments[2] : undefined) : undefined;
        var result = new C();
        var n = 0;
        $a78806ef4ebb6167$exports(O, function(nextItem) {
            var entry = mapping ? boundFunction(nextItem, n++) : nextItem;
            if (ENTRY) adder(result, $c845d421b7b0e630$exports(entry)[0], entry[1]);
            else adder(result, entry);
        });
        return result;
    };
};


// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$ca3e1754e676956d$exports({
    target: 'Map',
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($e055c888a6d66079$exports.Map, $e055c888a6d66079$exports.set, true)
});


'use strict';

var $68a6fb62059d5265$exports = {};
'use strict';
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
$68a6fb62059d5265$exports = function(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y || x !== x && y !== y;
};




// `Map.prototype.includes` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    includes: function includes(searchElement) {
        return $4ff0f82b80a31785$exports($a39ae7ae5ecd9c38$exports(this), function(value) {
            if ($68a6fb62059d5265$exports(value, searchElement)) return true;
        }, true) === true;
    }
});


'use strict';






var $ccd66d5459d00cb6$require$Map = $e055c888a6d66079$exports.Map;
// `Map.keyBy` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    stat: true,
    forced: true
}, {
    keyBy: function keyBy(iterable, keyDerivative) {
        var C = $70e34a5a2021f756$exports(this) ? this : $ccd66d5459d00cb6$require$Map;
        var newMap = new C();
        $ae485921c5498156$exports(keyDerivative);
        var setter = $ae485921c5498156$exports(newMap.set);
        $a78806ef4ebb6167$exports(iterable, function(element) {
            $881ad37dbe259e8f$exports(setter, newMap, keyDerivative(element), element);
        });
        return newMap;
    }
});


'use strict';



// `Map.prototype.keyOf` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    keyOf: function keyOf(searchElement) {
        var result = $4ff0f82b80a31785$exports($a39ae7ae5ecd9c38$exports(this), function(value, key) {
            if (value === searchElement) return {
                key: key
            };
        }, true);
        return result && result.key;
    }
});


'use strict';





var $2d215c3a160ec6d3$var$Map = $e055c888a6d66079$exports.Map;
var $2d215c3a160ec6d3$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.mapKeys` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    mapKeys: function mapKeys(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $2d215c3a160ec6d3$var$Map();
        $4ff0f82b80a31785$exports(map, function(value, key) {
            $2d215c3a160ec6d3$var$set(newMap, boundFunction(value, key, map), value);
        });
        return newMap;
    }
});


'use strict';





var $4f84e6bb9ed6fc72$var$Map = $e055c888a6d66079$exports.Map;
var $4f84e6bb9ed6fc72$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.mapValues` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    mapValues: function mapValues(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newMap = new $4f84e6bb9ed6fc72$var$Map();
        $4ff0f82b80a31785$exports(map, function(value, key) {
            $4f84e6bb9ed6fc72$var$set(newMap, key, boundFunction(value, key, map));
        });
        return newMap;
    }
});


'use strict';




var $f683faf8deb6b58b$require$set = $e055c888a6d66079$exports.set;
// `Map.prototype.merge` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    arity: 1,
    forced: true
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    merge: function merge(iterable /* ...iterables */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var argumentsLength = arguments.length;
        var i = 0;
        while(i < argumentsLength)$a78806ef4ebb6167$exports(arguments[i++], function(key, value) {
            $f683faf8deb6b58b$require$set(map, key, value);
        }, {
            AS_ENTRIES: true
        });
        return map;
    }
});


'use strict';


var $2bf4af15edd92228$exports = {};
'use strict';

// https://tc39.github.io/proposal-setmap-offrom/
$2bf4af15edd92228$exports = function(C, adder, ENTRY) {
    return function of() {
        var result = new C();
        var length = arguments.length;
        for(var index = 0; index < length; index++){
            var entry = arguments[index];
            if (ENTRY) adder(result, $c845d421b7b0e630$exports(entry)[0], entry[1]);
            else adder(result, entry);
        }
        return result;
    };
};


// `Map.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
$ca3e1754e676956d$exports({
    target: 'Map',
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($e055c888a6d66079$exports.Map, $e055c888a6d66079$exports.set, true)
});


'use strict';




var $f80490e878d93f5c$var$$TypeError = TypeError;
// `Map.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ae485921c5498156$exports(callbackfn);
        $4ff0f82b80a31785$exports(map, function(value, key) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, key, map);
        });
        if (noInitial) throw new $f80490e878d93f5c$var$$TypeError('Reduce of empty map with no initial value');
        return accumulator;
    }
});


'use strict';




// `Map.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $4ff0f82b80a31785$exports(map, function(value, key) {
            if (boundFunction(value, key, map)) return true;
        }, true) === true;
    }
});


'use strict';




var $502cb96291d9f44c$var$$TypeError = TypeError;
var $502cb96291d9f44c$var$get = $e055c888a6d66079$exports.get;
var $502cb96291d9f44c$var$has = $e055c888a6d66079$exports.has;
var $502cb96291d9f44c$var$set = $e055c888a6d66079$exports.set;
// `Map.prototype.update` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Map',
    proto: true,
    real: true,
    forced: true
}, {
    update: function update(key, callback /* , thunk */ ) {
        var map = $a39ae7ae5ecd9c38$exports(this);
        var length = arguments.length;
        $ae485921c5498156$exports(callback);
        var isPresentInMap = $502cb96291d9f44c$var$has(map, key);
        if (!isPresentInMap && length < 3) throw new $502cb96291d9f44c$var$$TypeError('Updating absent value');
        var value = isPresentInMap ? $502cb96291d9f44c$var$get(map, key) : $ae485921c5498156$exports(length > 2 ? arguments[2] : undefined)(key, map);
        $502cb96291d9f44c$var$set(map, key, callback(value, key, map));
        return map;
    }
});


'use strict';

var $8e7b45fdd192c978$exports = {};
'use strict';
var $9df6e1221107f46e$exports = {};
'use strict';
var $9df6e1221107f46e$var$$TypeError = TypeError;
$9df6e1221107f46e$exports = function(argument) {
    if (typeof argument == 'number') return argument;
    throw new $9df6e1221107f46e$var$$TypeError('Argument is not a number');
};


var $8e7b45fdd192c978$var$$min = Math.min;
var $8e7b45fdd192c978$var$$max = Math.max;
$8e7b45fdd192c978$exports = function clamp(value, min, max) {
    return $8e7b45fdd192c978$var$$min($8e7b45fdd192c978$var$$max($9df6e1221107f46e$exports(value), $9df6e1221107f46e$exports(min)), $9df6e1221107f46e$exports(max));
};


// TODO: Remove from `core-js@4`
// `Math.clamp` method
// https://github.com/tc39/proposal-math-clamp
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    clamp: $8e7b45fdd192c978$exports
});


'use strict';

// `Math.DEG_PER_RAD` constant
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    DEG_PER_RAD: Math.PI / 180
});


'use strict';

var $2becb7b901651b90$var$RAD_PER_DEG = 180 / Math.PI;
// `Math.degrees` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    degrees: function degrees(radians) {
        return radians * $2becb7b901651b90$var$RAD_PER_DEG;
    }
});


'use strict';

var $8fd01e6e30bfee20$exports = {};
'use strict';
// `Math.scale` method implementation
// https://rwaldron.github.io/proposal-math-extensions/
$8fd01e6e30bfee20$exports = function scale(x, inLow, inHigh, outLow, outHigh) {
    var nx = +x;
    var nInLow = +inLow;
    var nInHigh = +inHigh;
    var nOutLow = +outLow;
    var nOutHigh = +outHigh;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (nx !== nx || nInLow !== nInLow || nInHigh !== nInHigh || nOutLow !== nOutLow || nOutHigh !== nOutHigh) return NaN;
    if (nx === Infinity || nx === -Infinity) return nx;
    return (nx - nInLow) * (nOutHigh - nOutLow) / (nInHigh - nInLow) + nOutLow;
};


var $dbdc440b8bcf2b92$exports = {};
'use strict';
var $d7b5efbe959018e3$exports = {};
'use strict';
var $ce4b597c505ed4be$exports = {};
'use strict';
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$ce4b597c505ed4be$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};


var $e9234dfe9bf7d6d0$exports = {};
'use strict';
var $e9234dfe9bf7d6d0$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
var $e9234dfe9bf7d6d0$var$INVERSE_EPSILON = 1 / $e9234dfe9bf7d6d0$var$EPSILON;
$e9234dfe9bf7d6d0$exports = function(n) {
    return n + $e9234dfe9bf7d6d0$var$INVERSE_EPSILON - $e9234dfe9bf7d6d0$var$INVERSE_EPSILON;
};


var $d7b5efbe959018e3$var$abs = Math.abs;
var $d7b5efbe959018e3$var$EPSILON = 2.220446049250313e-16; // Number.EPSILON
$d7b5efbe959018e3$exports = function(x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
    var n = +x;
    var absolute = $d7b5efbe959018e3$var$abs(n);
    var s = $ce4b597c505ed4be$exports(n);
    if (absolute < FLOAT_MIN_VALUE) return s * $e9234dfe9bf7d6d0$exports(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
    var a = (1 + FLOAT_EPSILON / $d7b5efbe959018e3$var$EPSILON) * absolute;
    var result = a - (a - absolute);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
    return s * result;
};


var $dbdc440b8bcf2b92$var$FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var $dbdc440b8bcf2b92$var$FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var $dbdc440b8bcf2b92$var$FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$dbdc440b8bcf2b92$exports = Math.fround || function fround(x) {
    return $d7b5efbe959018e3$exports(x, $dbdc440b8bcf2b92$var$FLOAT32_EPSILON, $dbdc440b8bcf2b92$var$FLOAT32_MAX_VALUE, $dbdc440b8bcf2b92$var$FLOAT32_MIN_VALUE);
};


// `Math.fscale` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return $dbdc440b8bcf2b92$exports($8fd01e6e30bfee20$exports(x, inLow, inHigh, outLow, outHigh));
    }
});


'use strict';

// `Math.iaddh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
    }
});


'use strict';

// `Math.imulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    imulh: function imulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
    }
});


'use strict';

// `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
    }
});


'use strict';

// `Math.RAD_PER_DEG` constant
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    RAD_PER_DEG: 180 / Math.PI
});


'use strict';

var $5bbfbf40a68377f9$var$DEG_PER_RAD = Math.PI / 180;
// `Math.radians` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    radians: function radians(degrees) {
        return degrees * $5bbfbf40a68377f9$var$DEG_PER_RAD;
    }
});


'use strict';


// `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    scale: $8fd01e6e30bfee20$exports
});


'use strict';


var $aa518c863f46227d$exports = {};
'use strict';

var $aa518c863f46227d$var$globalIsFinite = $3fbf1185731afe2b$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$aa518c863f46227d$exports = Number.isFinite || function isFinite(it) {
    return typeof it == 'number' && $aa518c863f46227d$var$globalIsFinite(it);
};





var $2530f6348992d8a0$var$SEEDED_RANDOM = 'Seeded Random';
var $2530f6348992d8a0$var$SEEDED_RANDOM_GENERATOR = $2530f6348992d8a0$var$SEEDED_RANDOM + ' Generator';
var $2530f6348992d8a0$var$SEED_TYPE_ERROR = 'Math.seededPRNG() argument should have a "seed" field with a finite value.';
var $2530f6348992d8a0$var$setInternalState = $3a8bcef306e86159$exports.set;
var $2530f6348992d8a0$var$getInternalState = $3a8bcef306e86159$exports.getterFor($2530f6348992d8a0$var$SEEDED_RANDOM_GENERATOR);
var $2530f6348992d8a0$var$$TypeError = TypeError;
var $2530f6348992d8a0$var$$SeededRandomGenerator = $2428e9d9593354c3$exports(function SeededRandomGenerator(seed) {
    $2530f6348992d8a0$var$setInternalState(this, {
        type: $2530f6348992d8a0$var$SEEDED_RANDOM_GENERATOR,
        seed: seed % 2147483647
    });
}, $2530f6348992d8a0$var$SEEDED_RANDOM, function next() {
    var state = $2530f6348992d8a0$var$getInternalState(this);
    var seed = state.seed = (state.seed * 1103515245 + 12345) % 2147483647;
    return $dfab5f5c406cd291$exports((seed & 1073741823) / 1073741823, false);
});
// `Math.seededPRNG` method
// https://github.com/tc39/proposal-seeded-random
// based on https://github.com/tc39/proposal-seeded-random/blob/78b8258835b57fc2100d076151ab506bc3202ae6/demo.html
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    seededPRNG: function seededPRNG(it) {
        var seed = $c845d421b7b0e630$exports(it).seed;
        if (!$aa518c863f46227d$exports(seed)) throw new $2530f6348992d8a0$var$$TypeError($2530f6348992d8a0$var$SEED_TYPE_ERROR);
        return new $2530f6348992d8a0$var$$SeededRandomGenerator(seed);
    }
});


'use strict';

// `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    signbit: function signbit(x) {
        var n = +x;
        // eslint-disable-next-line no-self-compare -- NaN check
        return n === n && n === 0 ? 1 / n === -Infinity : n < 0;
    }
});


'use strict';

// `Math.umulh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
// TODO: Remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Math',
    stat: true,
    forced: true
}, {
    umulh: function umulh(u, v) {
        var UINT16 = 0xFFFF;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
    }
});


'use strict';



var $7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION = 'Invalid number representation';
var $7b3e4eb8ac0fb40a$var$INVALID_RADIX = 'Invalid radix';
var $7b3e4eb8ac0fb40a$var$$RangeError = RangeError;
var $7b3e4eb8ac0fb40a$var$$SyntaxError = SyntaxError;
var $7b3e4eb8ac0fb40a$var$$TypeError = TypeError;
var $7b3e4eb8ac0fb40a$var$$parseInt = parseInt;
var $7b3e4eb8ac0fb40a$var$pow = Math.pow;
var $7b3e4eb8ac0fb40a$var$valid = /^[0-9a-z]+(\.[0-9a-z]+)?$/;
var $7b3e4eb8ac0fb40a$var$charAt = $43b18aa2f1faac44$exports(''.charAt);
var $7b3e4eb8ac0fb40a$var$charCodeAt = $43b18aa2f1faac44$exports(''.charCodeAt);
var $7b3e4eb8ac0fb40a$var$exec = $43b18aa2f1faac44$exports($7b3e4eb8ac0fb40a$var$valid.exec);
var $7b3e4eb8ac0fb40a$var$numberToString = $43b18aa2f1faac44$exports(1.1.toString);
var $7b3e4eb8ac0fb40a$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
var $7b3e4eb8ac0fb40a$var$split = $43b18aa2f1faac44$exports(''.split);
var $7b3e4eb8ac0fb40a$var$validDigitForRadix = function(string, R) {
    for(var i = 0; i < string.length; i++){
        var code = $7b3e4eb8ac0fb40a$var$charCodeAt(string, i);
        // '.' is allowed
        if (code === 0x2E) continue;
        // '0'-'9' - digit value 0-9
        if (code >= 0x30 && code <= 0x39) {
            if (code - 0x30 >= R) return false;
        // 'a'-'z' - digit value 10-35
        } else if (code >= 0x61 && code <= 0x7A) {
            if (code - 0x61 + 10 >= R) return false;
        } else return false;
    }
    return true;
};
// `Number.fromString` method
// https://github.com/tc39/proposal-number-fromstring
$ca3e1754e676956d$exports({
    target: 'Number',
    stat: true,
    forced: true
}, {
    fromString: function fromString(string, radix) {
        var sign = 1;
        if (typeof string != 'string') throw new $7b3e4eb8ac0fb40a$var$$TypeError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        if (!string.length) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        if ($7b3e4eb8ac0fb40a$var$charAt(string, 0) === '-') {
            sign = -1;
            string = $7b3e4eb8ac0fb40a$var$stringSlice(string, 1);
            if (!string.length) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        }
        var R = radix === undefined ? 10 : $b5bb21648546ce5b$exports(radix);
        if (R < 2 || R > 36) throw new $7b3e4eb8ac0fb40a$var$$RangeError($7b3e4eb8ac0fb40a$var$INVALID_RADIX);
        if (!$7b3e4eb8ac0fb40a$var$exec($7b3e4eb8ac0fb40a$var$valid, string) || !$7b3e4eb8ac0fb40a$var$validDigitForRadix(string, R)) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        var parts = $7b3e4eb8ac0fb40a$var$split(string, '.');
        var mathNum = $7b3e4eb8ac0fb40a$var$$parseInt(parts[0], R);
        if (parts.length > 1) mathNum += $7b3e4eb8ac0fb40a$var$$parseInt(parts[1], R) / $7b3e4eb8ac0fb40a$var$pow(R, parts[1].length);
        if (R === 10) {
            var compareString = string;
            if (parts.length > 1) {
                var fraction = parts[1];
                while(fraction.length && $7b3e4eb8ac0fb40a$var$charAt(fraction, fraction.length - 1) === '0')fraction = $7b3e4eb8ac0fb40a$var$stringSlice(fraction, 0, -1);
                compareString = fraction.length ? parts[0] + '.' + fraction : parts[0];
            }
            if ($7b3e4eb8ac0fb40a$var$numberToString(mathNum, R) !== compareString) throw new $7b3e4eb8ac0fb40a$var$$SyntaxError($7b3e4eb8ac0fb40a$var$INVALID_NUMBER_REPRESENTATION);
        }
        return sign * mathNum;
    }
});


'use strict';
'use strict';














var $46baa546620d2b70$exports = {};
'use strict';
$46baa546620d2b70$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length === 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};




var $6e179f71419cf8b4$var$$$OBSERVABLE = $842f8f0a18746212$exports('observable');
var $6e179f71419cf8b4$var$OBSERVABLE = 'Observable';
var $6e179f71419cf8b4$var$SUBSCRIPTION = 'Subscription';
var $6e179f71419cf8b4$var$SUBSCRIPTION_OBSERVER = 'SubscriptionObserver';
var $6e179f71419cf8b4$var$getterFor = $3a8bcef306e86159$exports.getterFor;
var $6e179f71419cf8b4$var$setInternalState = $3a8bcef306e86159$exports.set;
var $6e179f71419cf8b4$var$getObservableInternalState = $6e179f71419cf8b4$var$getterFor($6e179f71419cf8b4$var$OBSERVABLE);
var $6e179f71419cf8b4$var$getSubscriptionInternalState = $6e179f71419cf8b4$var$getterFor($6e179f71419cf8b4$var$SUBSCRIPTION);
var $6e179f71419cf8b4$var$getSubscriptionObserverInternalState = $6e179f71419cf8b4$var$getterFor($6e179f71419cf8b4$var$SUBSCRIPTION_OBSERVER);
var $6e179f71419cf8b4$var$SubscriptionState = function(observer) {
    this.observer = $c845d421b7b0e630$exports(observer);
    this.cleanup = null;
    this.subscriptionObserver = null;
};
$6e179f71419cf8b4$var$SubscriptionState.prototype = {
    type: $6e179f71419cf8b4$var$SUBSCRIPTION,
    clean: function() {
        var cleanup = this.cleanup;
        if (cleanup) {
            this.cleanup = null;
            try {
                cleanup();
            } catch (error) {
                $46baa546620d2b70$exports(error);
            }
        }
    },
    close: function() {
        if (!$ef322a7f89c3ed41$exports) {
            var subscription = this.facade;
            var subscriptionObserver = this.subscriptionObserver;
            subscription.closed = true;
            if (subscriptionObserver) subscriptionObserver.closed = true;
        }
        this.observer = null;
    },
    isClosed: function() {
        return this.observer === null;
    }
};
var $6e179f71419cf8b4$var$Subscription = function(observer, subscriber) {
    var subscriptionState = $6e179f71419cf8b4$var$setInternalState(this, new $6e179f71419cf8b4$var$SubscriptionState(observer));
    var start;
    if (!$ef322a7f89c3ed41$exports) this.closed = false;
    try {
        if (start = $eb80dcd0b8a5698c$exports(observer, 'start')) $881ad37dbe259e8f$exports(start, observer, this);
    } catch (error) {
        $46baa546620d2b70$exports(error);
    }
    if (subscriptionState.isClosed()) return;
    var subscriptionObserver = subscriptionState.subscriptionObserver = new $6e179f71419cf8b4$var$SubscriptionObserver(subscriptionState);
    try {
        var cleanup = subscriber(subscriptionObserver);
        var subscription = cleanup;
        if (!$7ce250ddf7b42d4d$exports(cleanup)) subscriptionState.cleanup = $70e34a5a2021f756$exports(cleanup.unsubscribe) ? function() {
            subscription.unsubscribe();
        } : $ae485921c5498156$exports(cleanup);
    } catch (error) {
        subscriptionObserver.error(error);
        return;
    }
    if (subscriptionState.isClosed()) subscriptionState.clean();
};
$6e179f71419cf8b4$var$Subscription.prototype = $a3d227a61e709d75$exports({}, {
    unsubscribe: function unsubscribe() {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionInternalState(this);
        if (!subscriptionState.isClosed()) {
            subscriptionState.close();
            subscriptionState.clean();
        }
    }
});
if ($ef322a7f89c3ed41$exports) $74a6fb831e72713b$exports($6e179f71419cf8b4$var$Subscription.prototype, 'closed', {
    configurable: true,
    get: function closed() {
        return $6e179f71419cf8b4$var$getSubscriptionInternalState(this).isClosed();
    }
});
var $6e179f71419cf8b4$var$SubscriptionObserver = function(subscriptionState) {
    $6e179f71419cf8b4$var$setInternalState(this, {
        type: $6e179f71419cf8b4$var$SUBSCRIPTION_OBSERVER,
        subscriptionState: subscriptionState
    });
    if (!$ef322a7f89c3ed41$exports) this.closed = false;
};
$6e179f71419cf8b4$var$SubscriptionObserver.prototype = $a3d227a61e709d75$exports({}, {
    next: function next(value) {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            try {
                var nextMethod = $eb80dcd0b8a5698c$exports(observer, 'next');
                if (nextMethod) $881ad37dbe259e8f$exports(nextMethod, observer, value);
            } catch (error) {
                $46baa546620d2b70$exports(error);
            }
        }
    },
    error: function error(value) {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var errorMethod = $eb80dcd0b8a5698c$exports(observer, 'error');
                if (errorMethod) $881ad37dbe259e8f$exports(errorMethod, observer, value);
                else $46baa546620d2b70$exports(value);
            } catch (err) {
                $46baa546620d2b70$exports(err);
            }
            subscriptionState.clean();
        }
    },
    complete: function complete() {
        var subscriptionState = $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState;
        if (!subscriptionState.isClosed()) {
            var observer = subscriptionState.observer;
            subscriptionState.close();
            try {
                var completeMethod = $eb80dcd0b8a5698c$exports(observer, 'complete');
                if (completeMethod) $881ad37dbe259e8f$exports(completeMethod, observer);
            } catch (error) {
                $46baa546620d2b70$exports(error);
            }
            subscriptionState.clean();
        }
    }
});
if ($ef322a7f89c3ed41$exports) $74a6fb831e72713b$exports($6e179f71419cf8b4$var$SubscriptionObserver.prototype, 'closed', {
    configurable: true,
    get: function closed() {
        return $6e179f71419cf8b4$var$getSubscriptionObserverInternalState(this).subscriptionState.isClosed();
    }
});
var $6e179f71419cf8b4$var$$Observable = function Observable(subscriber) {
    $85de2a4f93f1c485$exports(this, $6e179f71419cf8b4$var$ObservablePrototype);
    $6e179f71419cf8b4$var$setInternalState(this, {
        type: $6e179f71419cf8b4$var$OBSERVABLE,
        subscriber: $ae485921c5498156$exports(subscriber)
    });
};
var $6e179f71419cf8b4$var$ObservablePrototype = $6e179f71419cf8b4$var$$Observable.prototype;
$a3d227a61e709d75$exports($6e179f71419cf8b4$var$ObservablePrototype, {
    subscribe: function subscribe(observer) {
        var length = arguments.length;
        return new $6e179f71419cf8b4$var$Subscription($70e34a5a2021f756$exports(observer) ? {
            next: observer,
            error: length > 1 ? arguments[1] : undefined,
            complete: length > 2 ? arguments[2] : undefined
        } : $6a130d390db46c8e$exports(observer) ? observer : {}, $6e179f71419cf8b4$var$getObservableInternalState(this).subscriber);
    }
});
$40e957865125f98f$exports($6e179f71419cf8b4$var$ObservablePrototype, $6e179f71419cf8b4$var$$$OBSERVABLE, function() {
    return this;
});
$ca3e1754e676956d$exports({
    global: true,
    constructor: true,
    forced: true
}, {
    Observable: $6e179f71419cf8b4$var$$Observable
});
$0df731b64ad8eead$exports($6e179f71419cf8b4$var$OBSERVABLE);


'use strict';










var $b692844f8daa9d80$var$$$OBSERVABLE = $842f8f0a18746212$exports('observable');
// `Observable.from` method
// https://github.com/tc39/proposal-observable
$ca3e1754e676956d$exports({
    target: 'Observable',
    stat: true,
    forced: true
}, {
    from: function from(x) {
        var C = $1abaf8429012df1f$exports(this) ? this : $a5217dbd1b0d33ce$exports('Observable');
        var observableMethod = $eb80dcd0b8a5698c$exports($c845d421b7b0e630$exports(x), $b692844f8daa9d80$var$$$OBSERVABLE);
        if (observableMethod) {
            var observable = $c845d421b7b0e630$exports($881ad37dbe259e8f$exports(observableMethod, x));
            return observable.constructor === C ? observable : new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        var iteratorMethod = $8d560b8b837672a0$exports(x);
        // validate that x is iterable synchronously during `from()` call
        if (!iteratorMethod) $13a4c31eee540026$exports(x);
        return new C(function(observer) {
            $a78806ef4ebb6167$exports($13a4c31eee540026$exports(x, iteratorMethod), function(it, stop) {
                observer.next(it);
                if (observer.closed) return stop();
            }, {
                IS_ITERATOR: true,
                INTERRUPTED: true
            });
            observer.complete();
        });
    }
});


'use strict';



var $a2b413cf33342221$var$Array = $a5217dbd1b0d33ce$exports('Array');
// `Observable.of` method
// https://github.com/tc39/proposal-observable
$ca3e1754e676956d$exports({
    target: 'Observable',
    stat: true,
    forced: true
}, {
    of: function of() {
        var C = $1abaf8429012df1f$exports(this) ? this : $a5217dbd1b0d33ce$exports('Observable');
        var length = arguments.length;
        var items = $a2b413cf33342221$var$Array(length);
        var index = 0;
        while(index < length)items[index] = arguments[index++];
        return new C(function(observer) {
            for(var i = 0; i < length; i++){
                observer.next(items[i]);
                if (observer.closed) return;
            }
            observer.complete();
        });
    }
});




'use strict';
'use strict';




// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $1fc464e952e6a79f$export$2d1720544b23b823;
'use strict';

var $1fc464e952e6a79f$var$$TypeError = TypeError;
var $1fc464e952e6a79f$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $1fc464e952e6a79f$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $ae485921c5498156$exports(resolve);
    this.reject = $ae485921c5498156$exports(reject);
};
$1fc464e952e6a79f$export$2d1720544b23b823 = function(C) {
    return new $1fc464e952e6a79f$var$PromiseCapability(C);
};



var $04575dc6f23ce661$exports = {};
'use strict';
$04575dc6f23ce661$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


var $7106a3c87372e17c$var$Promise = $3fbf1185731afe2b$exports.Promise;
var $7106a3c87372e17c$var$ACCEPT_ARGUMENTS = false;
// Avoiding the use of polyfills of the previous iteration of this proposal
// that does not accept arguments of the callback
var $7106a3c87372e17c$var$FORCED = !$7106a3c87372e17c$var$Promise || !$7106a3c87372e17c$var$Promise['try'] || $04575dc6f23ce661$exports(function() {
    $7106a3c87372e17c$var$Promise['try'](function(argument) {
        $7106a3c87372e17c$var$ACCEPT_ARGUMENTS = argument === 8;
    }, 8);
}).error || !$7106a3c87372e17c$var$ACCEPT_ARGUMENTS;
// `Promise.try` method
// https://tc39.es/ecma262/#sec-promise.try
$ca3e1754e676956d$exports({
    target: 'Promise',
    stat: true,
    forced: $7106a3c87372e17c$var$FORCED
}, {
    'try': function(callbackfn /* , ...args */ ) {
        var args = arguments.length > 1 ? $0709cba658bb4ed6$exports(arguments, 1) : [];
        var promiseCapability = $1fc464e952e6a79f$export$2d1720544b23b823(this);
        var result = $04575dc6f23ce661$exports(function() {
            return $3cdb2ef65d8e3cb5$exports($ae485921c5498156$exports(callbackfn), undefined, args);
        });
        (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
        return promiseCapability.promise;
    }
});




'use strict';

var $b97c096df4b0e58b$exports = {};
'use strict';





var $b97c096df4b0e58b$var$Map = $a5217dbd1b0d33ce$exports('Map');
var $b97c096df4b0e58b$var$WeakMap = $a5217dbd1b0d33ce$exports('WeakMap');
var $b97c096df4b0e58b$var$push = $43b18aa2f1faac44$exports([].push);
var $b97c096df4b0e58b$var$metadata = $1946b9b54b48e7fd$exports('metadata');
var $b97c096df4b0e58b$var$store = $b97c096df4b0e58b$var$metadata.store || ($b97c096df4b0e58b$var$metadata.store = new $b97c096df4b0e58b$var$WeakMap());
var $b97c096df4b0e58b$var$getOrCreateMetadataMap = function(target, targetKey, create) {
    var targetMetadata = $b97c096df4b0e58b$var$store.get(target);
    if (!targetMetadata) {
        if (!create) return;
        $b97c096df4b0e58b$var$store.set(target, targetMetadata = new $b97c096df4b0e58b$var$Map());
    }
    var keyMetadata = targetMetadata.get(targetKey);
    if (!keyMetadata) {
        if (!create) return;
        targetMetadata.set(targetKey, keyMetadata = new $b97c096df4b0e58b$var$Map());
    }
    return keyMetadata;
};
var $b97c096df4b0e58b$var$ordinaryHasOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $b97c096df4b0e58b$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var $b97c096df4b0e58b$var$ordinaryGetOwnMetadata = function(MetadataKey, O, P) {
    var metadataMap = $b97c096df4b0e58b$var$getOrCreateMetadataMap(O, P, false);
    return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var $b97c096df4b0e58b$var$ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P) {
    $b97c096df4b0e58b$var$getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var $b97c096df4b0e58b$var$ordinaryOwnMetadataKeys = function(target, targetKey) {
    var metadataMap = $b97c096df4b0e58b$var$getOrCreateMetadataMap(target, targetKey, false);
    var keys = [];
    if (metadataMap) metadataMap.forEach(function(_, key) {
        $b97c096df4b0e58b$var$push(keys, key);
    });
    return keys;
};
var $b97c096df4b0e58b$var$toMetadataKey = function(it) {
    return it === undefined || typeof it == 'symbol' ? it : String(it);
};
$b97c096df4b0e58b$exports = {
    store: $b97c096df4b0e58b$var$store,
    getMap: $b97c096df4b0e58b$var$getOrCreateMetadataMap,
    has: $b97c096df4b0e58b$var$ordinaryHasOwnMetadata,
    get: $b97c096df4b0e58b$var$ordinaryGetOwnMetadata,
    set: $b97c096df4b0e58b$var$ordinaryDefineOwnMetadata,
    keys: $b97c096df4b0e58b$var$ordinaryOwnMetadataKeys,
    toKey: $b97c096df4b0e58b$var$toMetadataKey
};



var $31d54640b5be68a1$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $31d54640b5be68a1$var$ordinaryDefineOwnMetadata = $b97c096df4b0e58b$exports.set;
// `Reflect.defineMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    defineMetadata: function defineMetadata(metadataKey, metadataValue, target /* , targetKey */ ) {
        var targetKey = arguments.length < 4 ? undefined : $31d54640b5be68a1$var$toMetadataKey(arguments[3]);
        $31d54640b5be68a1$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';



var $c0dea472571e3a69$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $c0dea472571e3a69$var$getOrCreateMetadataMap = $b97c096df4b0e58b$exports.getMap;
var $c0dea472571e3a69$var$store = $b97c096df4b0e58b$exports.store;
// `Reflect.deleteMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $c0dea472571e3a69$var$toMetadataKey(arguments[2]);
        var metadataMap = $c0dea472571e3a69$var$getOrCreateMetadataMap($c845d421b7b0e630$exports(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = $c0dea472571e3a69$var$store.get(target);
        targetMetadata['delete'](targetKey);
        return !!targetMetadata.size || $c0dea472571e3a69$var$store['delete'](target);
    }
});


'use strict';




var $f00623edbf0e2abf$var$ordinaryHasOwnMetadata = $b97c096df4b0e58b$exports.has;
var $f00623edbf0e2abf$var$ordinaryGetOwnMetadata = $b97c096df4b0e58b$exports.get;
var $f00623edbf0e2abf$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $f00623edbf0e2abf$var$ordinaryGetMetadata = function(MetadataKey, O, P) {
    var hasOwn = $f00623edbf0e2abf$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return $f00623edbf0e2abf$var$ordinaryGetOwnMetadata(MetadataKey, O, P);
    var parent = $a69a130329c6de82$exports(O);
    return parent !== null ? $f00623edbf0e2abf$var$ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};
// `Reflect.getMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    getMetadata: function getMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $f00623edbf0e2abf$var$toMetadataKey(arguments[2]);
        return $f00623edbf0e2abf$var$ordinaryGetMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';





var $c9061a42f4079c73$exports = {};
'use strict';







var $c9061a42f4079c73$var$Map = $e055c888a6d66079$exports.Map;
var $c9061a42f4079c73$var$mapHas = $e055c888a6d66079$exports.has;
var $c9061a42f4079c73$var$mapSet = $e055c888a6d66079$exports.set;
// `Array.prototype.uniqueBy` method
// https://github.com/tc39/proposal-array-unique
$c9061a42f4079c73$exports = function uniqueBy(resolver) {
    var that = $a2f3ebb5da11db12$exports(this);
    var length = $04c91bd3815cd64a$exports(that);
    var result = [];
    var map = new $c9061a42f4079c73$var$Map();
    var resolverFunction = !$7ce250ddf7b42d4d$exports(resolver) ? $ae485921c5498156$exports(resolver) : function(value) {
        return value;
    };
    var index, item, key;
    for(index = 0; index < length; index++){
        item = that[index];
        key = resolverFunction(item);
        if (!$c9061a42f4079c73$var$mapHas(map, key)) $c9061a42f4079c73$var$mapSet(map, key, item);
    }
    index = 0;
    $4ff0f82b80a31785$exports(map, function(value) {
        $d8c8827d6e29b8f8$exports(result, index++, value);
    });
    return result;
};


var $c2762de34bdcf4da$var$arrayUniqueBy = $43b18aa2f1faac44$exports($c9061a42f4079c73$exports);
var $c2762de34bdcf4da$var$concat = $43b18aa2f1faac44$exports([].concat);
var $c2762de34bdcf4da$var$ordinaryOwnMetadataKeys = $b97c096df4b0e58b$exports.keys;
var $c2762de34bdcf4da$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $c2762de34bdcf4da$var$ordinaryMetadataKeys = function(O, P) {
    var oKeys = $c2762de34bdcf4da$var$ordinaryOwnMetadataKeys(O, P);
    var parent = $a69a130329c6de82$exports(O);
    if (parent === null) return oKeys;
    var pKeys = $c2762de34bdcf4da$var$ordinaryMetadataKeys(parent, P);
    return pKeys.length ? oKeys.length ? $c2762de34bdcf4da$var$arrayUniqueBy($c2762de34bdcf4da$var$concat(oKeys, pKeys)) : pKeys : oKeys;
};
// `Reflect.getMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    getMetadataKeys: function getMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $c2762de34bdcf4da$var$toMetadataKey(arguments[1]);
        return $c2762de34bdcf4da$var$ordinaryMetadataKeys($c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';



var $20787d7b927a9461$var$ordinaryGetOwnMetadata = $b97c096df4b0e58b$exports.get;
var $20787d7b927a9461$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
// `Reflect.getOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $20787d7b927a9461$var$toMetadataKey(arguments[2]);
        return $20787d7b927a9461$var$ordinaryGetOwnMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';



var $729002be664fa9da$var$ordinaryOwnMetadataKeys = $b97c096df4b0e58b$exports.keys;
var $729002be664fa9da$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
// `Reflect.getOwnMetadataKeys` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */ ) {
        var targetKey = arguments.length < 2 ? undefined : $729002be664fa9da$var$toMetadataKey(arguments[1]);
        return $729002be664fa9da$var$ordinaryOwnMetadataKeys($c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';




var $bd7d56d22c6f063c$var$ordinaryHasOwnMetadata = $b97c096df4b0e58b$exports.has;
var $bd7d56d22c6f063c$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $bd7d56d22c6f063c$var$ordinaryHasMetadata = function(MetadataKey, O, P) {
    var hasOwn = $bd7d56d22c6f063c$var$ordinaryHasOwnMetadata(MetadataKey, O, P);
    if (hasOwn) return true;
    var parent = $a69a130329c6de82$exports(O);
    return parent !== null ? $bd7d56d22c6f063c$var$ordinaryHasMetadata(MetadataKey, parent, P) : false;
};
// `Reflect.hasMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $bd7d56d22c6f063c$var$toMetadataKey(arguments[2]);
        return $bd7d56d22c6f063c$var$ordinaryHasMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';



var $3eb05025dc586de2$var$ordinaryHasOwnMetadata = $b97c096df4b0e58b$exports.has;
var $3eb05025dc586de2$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
// `Reflect.hasOwnMetadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */ ) {
        var targetKey = arguments.length < 3 ? undefined : $3eb05025dc586de2$var$toMetadataKey(arguments[2]);
        return $3eb05025dc586de2$var$ordinaryHasOwnMetadata(metadataKey, $c845d421b7b0e630$exports(target), targetKey);
    }
});


'use strict';



var $e51ee49c376f0001$var$toMetadataKey = $b97c096df4b0e58b$exports.toKey;
var $e51ee49c376f0001$var$ordinaryDefineOwnMetadata = $b97c096df4b0e58b$exports.set;
// `Reflect.metadata` method
// https://github.com/rbuckton/reflect-metadata
$ca3e1754e676956d$exports({
    target: 'Reflect',
    stat: true
}, {
    metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, key) {
            $e51ee49c376f0001$var$ordinaryDefineOwnMetadata(metadataKey, metadataValue, $c845d421b7b0e630$exports(target), $e51ee49c376f0001$var$toMetadataKey(key));
        };
    }
});


'use strict';

var $181da54e4761d0e8$exports = {};
'use strict';
var $f5060c84c0f60f7e$exports = {};
'use strict';

// eslint-disable-next-line es/no-set -- safe
var $f5060c84c0f60f7e$var$SetPrototype = Set.prototype;
$f5060c84c0f60f7e$exports = {
    // eslint-disable-next-line es/no-set -- safe
    Set: Set,
    add: $43b18aa2f1faac44$exports($f5060c84c0f60f7e$var$SetPrototype.add),
    has: $43b18aa2f1faac44$exports($f5060c84c0f60f7e$var$SetPrototype.has),
    remove: $43b18aa2f1faac44$exports($f5060c84c0f60f7e$var$SetPrototype['delete']),
    proto: $f5060c84c0f60f7e$var$SetPrototype
};


var $181da54e4761d0e8$require$has = $f5060c84c0f60f7e$exports.has;
// Perform ? RequireInternalSlot(M, [[SetData]])
$181da54e4761d0e8$exports = function(it) {
    $181da54e4761d0e8$require$has(it);
    return it;
};



var $d07daff3c49c457c$require$add = $f5060c84c0f60f7e$exports.add;
// `Set.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $181da54e4761d0e8$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$d07daff3c49c457c$require$add(set, arguments[k]);
        return set;
    }
});


'use strict';



var $84d9e98b9d741732$require$remove = $f5060c84c0f60f7e$exports.remove;
// `Set.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $181da54e4761d0e8$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $84d9e98b9d741732$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';


var $b126c600f59850cf$exports = {};
'use strict';


var $965955edb258a3f2$exports = {};
'use strict';





var $965955edb258a3f2$var$ITERATOR = $842f8f0a18746212$exports('iterator');
var $965955edb258a3f2$var$$Object = Object;
$965955edb258a3f2$exports = function(it) {
    if ($7ce250ddf7b42d4d$exports(it)) return false;
    var O = $965955edb258a3f2$var$$Object(it);
    return O[$965955edb258a3f2$var$ITERATOR] !== undefined || '@@iterator' in O || $1f868a26fd901990$exports($0fe0dd04b0eb22af$exports, $b07c9aec2f9c74e4$exports(O));
};



var $b126c600f59850cf$var$Set = $a5217dbd1b0d33ce$exports('Set');
var $b126c600f59850cf$var$isSetLike = function(it) {
    return $6a130d390db46c8e$exports(it) && typeof it.size == 'number' && $70e34a5a2021f756$exports(it.has) && $70e34a5a2021f756$exports(it.keys);
};
// fallback old -> new set methods proposal arguments
$b126c600f59850cf$exports = function(it) {
    if ($b126c600f59850cf$var$isSetLike(it)) return it;
    return $965955edb258a3f2$exports(it) ? new $b126c600f59850cf$var$Set(it) : it;
};


var $456984ac7dad2a58$exports = {};
'use strict';


var $d77fd3960bcf099e$exports = {};
'use strict';

var $fa8664a1252d26ee$exports = {};
'use strict';



var $fa8664a1252d26ee$var$Set = $f5060c84c0f60f7e$exports.Set;
var $fa8664a1252d26ee$var$SetPrototype = $f5060c84c0f60f7e$exports.proto;
var $fa8664a1252d26ee$var$forEach = $43b18aa2f1faac44$exports($fa8664a1252d26ee$var$SetPrototype.forEach);
var $fa8664a1252d26ee$var$keys = $43b18aa2f1faac44$exports($fa8664a1252d26ee$var$SetPrototype.keys);
var $fa8664a1252d26ee$var$next = $fa8664a1252d26ee$var$keys(new $fa8664a1252d26ee$var$Set()).next;
$fa8664a1252d26ee$exports = function(set, fn, interruptible) {
    return interruptible ? $c3b265c1265de03f$exports({
        iterator: $fa8664a1252d26ee$var$keys(set),
        next: $fa8664a1252d26ee$var$next
    }, fn) : $fa8664a1252d26ee$var$forEach(set, fn);
};


var $d77fd3960bcf099e$var$Set = $f5060c84c0f60f7e$exports.Set;
var $d77fd3960bcf099e$var$add = $f5060c84c0f60f7e$exports.add;
$d77fd3960bcf099e$exports = function(set) {
    var result = new $d77fd3960bcf099e$var$Set();
    $fa8664a1252d26ee$exports(set, function(it) {
        $d77fd3960bcf099e$var$add(result, it);
    });
    return result;
};


var $425be1cc5645690d$exports = {};
'use strict';


$425be1cc5645690d$exports = $ab274a67893419f3$exports($f5060c84c0f60f7e$exports.proto, 'size', 'get') || function(set) {
    return set.size;
};


var $a57ec52899092109$exports = {};
'use strict';




var $48a5733549e1760e$exports = {};
'use strict';
// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/ecma262/#sec-getiteratordirect
$48a5733549e1760e$exports = function(obj) {
    return {
        iterator: obj,
        next: obj.next,
        done: false
    };
};


var $a57ec52899092109$var$INVALID_SIZE = 'Invalid size';
var $a57ec52899092109$var$$RangeError = RangeError;
var $a57ec52899092109$var$$TypeError = TypeError;
var $a57ec52899092109$var$max = Math.max;
var $a57ec52899092109$var$SetRecord = function(set, intSize) {
    this.set = set;
    this.size = $a57ec52899092109$var$max(intSize, 0);
    this.has = $ae485921c5498156$exports(set.has);
    this.keys = $ae485921c5498156$exports(set.keys);
};
$a57ec52899092109$var$SetRecord.prototype = {
    getIterator: function() {
        return $48a5733549e1760e$exports($c845d421b7b0e630$exports($881ad37dbe259e8f$exports(this.keys, this.set)));
    },
    includes: function(it) {
        return $881ad37dbe259e8f$exports(this.has, this.set, it);
    }
};
// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
$a57ec52899092109$exports = function(obj) {
    $c845d421b7b0e630$exports(obj);
    var numSize = +obj.size;
    // NOTE: If size is undefined, then numSize will be NaN
    // eslint-disable-next-line no-self-compare -- NaN check
    if (numSize !== numSize) throw new $a57ec52899092109$var$$TypeError($a57ec52899092109$var$INVALID_SIZE);
    var intSize = $b5bb21648546ce5b$exports(numSize);
    if (intSize < 0) throw new $a57ec52899092109$var$$RangeError($a57ec52899092109$var$INVALID_SIZE);
    return new $a57ec52899092109$var$SetRecord(obj, intSize);
};




var $456984ac7dad2a58$var$has = $f5060c84c0f60f7e$exports.has;
var $456984ac7dad2a58$var$remove = $f5060c84c0f60f7e$exports.remove;
// `Set.prototype.difference` method
// https://tc39.es/ecma262/#sec-set.prototype.difference
$456984ac7dad2a58$exports = function difference(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    var result = $d77fd3960bcf099e$exports(O);
    if ($425be1cc5645690d$exports(result) <= otherRec.size) $fa8664a1252d26ee$exports(result, function(e) {
        if (otherRec.includes(e)) $456984ac7dad2a58$var$remove(result, e);
    });
    else $c3b265c1265de03f$exports(otherRec.getIterator(), function(e) {
        if ($456984ac7dad2a58$var$has(result, e)) $456984ac7dad2a58$var$remove(result, e);
    });
    return result;
};


// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    difference: function difference(other) {
        return $881ad37dbe259e8f$exports($456984ac7dad2a58$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';




// `Set.prototype.every` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $fa8664a1252d26ee$exports(set, function(value) {
            if (!boundFunction(value, value, set)) return false;
        }, true) !== false;
    }
});


'use strict';





var $0a8f56ceec8deeee$var$Set = $f5060c84c0f60f7e$exports.Set;
var $0a8f56ceec8deeee$var$add = $f5060c84c0f60f7e$exports.add;
// `Set.prototype.filter` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $0a8f56ceec8deeee$var$Set();
        $fa8664a1252d26ee$exports(set, function(value) {
            if (boundFunction(value, value, set)) $0a8f56ceec8deeee$var$add(newSet, value);
        });
        return newSet;
    }
});


'use strict';




// `Set.prototype.find` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    find: function find(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var result = $fa8664a1252d26ee$exports(set, function(value) {
            if (boundFunction(value, value, set)) return {
                value: value
            };
        }, true);
        return result && result.value;
    }
});


'use strict';



// `Set.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
$ca3e1754e676956d$exports({
    target: 'Set',
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($f5060c84c0f60f7e$exports.Set, $f5060c84c0f60f7e$exports.add, false)
});


'use strict';



var $7c51fff376b214dd$exports = {};
'use strict';






var $7c51fff376b214dd$var$Set = $f5060c84c0f60f7e$exports.Set;
var $7c51fff376b214dd$var$add = $f5060c84c0f60f7e$exports.add;
var $7c51fff376b214dd$var$has = $f5060c84c0f60f7e$exports.has;
// `Set.prototype.intersection` method
// https://tc39.es/ecma262/#sec-set.prototype.intersection
$7c51fff376b214dd$exports = function intersection(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    var result = new $7c51fff376b214dd$var$Set();
    if ($425be1cc5645690d$exports(O) > otherRec.size) $c3b265c1265de03f$exports(otherRec.getIterator(), function(e) {
        if ($7c51fff376b214dd$var$has(O, e)) $7c51fff376b214dd$var$add(result, e);
    });
    else $fa8664a1252d26ee$exports(O, function(e) {
        if (otherRec.includes(e)) $7c51fff376b214dd$var$add(result, e);
    });
    return result;
};


// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    intersection: function intersection(other) {
        return $881ad37dbe259e8f$exports($7c51fff376b214dd$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';



var $d0fa8e310d7bc338$exports = {};
'use strict';


var $d0fa8e310d7bc338$require$has = $f5060c84c0f60f7e$exports.has;





// `Set.prototype.isDisjointFrom` method
// https://tc39.es/ecma262/#sec-set.prototype.isdisjointfrom
$d0fa8e310d7bc338$exports = function isDisjointFrom(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    if ($425be1cc5645690d$exports(O) <= otherRec.size) return $fa8664a1252d26ee$exports(O, function(e) {
        if (otherRec.includes(e)) return false;
    }, true) !== false;
    var iterator = otherRec.getIterator();
    return $c3b265c1265de03f$exports(iterator, function(e) {
        if ($d0fa8e310d7bc338$require$has(O, e)) return $4105790cb9bf2aaa$exports(iterator.iterator, 'normal', false);
    }) !== false;
};


// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    isDisjointFrom: function isDisjointFrom(other) {
        return $881ad37dbe259e8f$exports($d0fa8e310d7bc338$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';



var $cc6482b020a78a5f$exports = {};
'use strict';




// `Set.prototype.isSubsetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issubsetof
$cc6482b020a78a5f$exports = function isSubsetOf(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    if ($425be1cc5645690d$exports(O) > otherRec.size) return false;
    return $fa8664a1252d26ee$exports(O, function(e) {
        if (!otherRec.includes(e)) return false;
    }, true) !== false;
};


// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    isSubsetOf: function isSubsetOf(other) {
        return $881ad37dbe259e8f$exports($cc6482b020a78a5f$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';



var $d824487b4bec8d7f$exports = {};
'use strict';


var $d824487b4bec8d7f$require$has = $f5060c84c0f60f7e$exports.has;




// `Set.prototype.isSupersetOf` method
// https://tc39.es/ecma262/#sec-set.prototype.issupersetof
$d824487b4bec8d7f$exports = function isSupersetOf(other) {
    var O = $181da54e4761d0e8$exports(this);
    var otherRec = $a57ec52899092109$exports(other);
    if ($425be1cc5645690d$exports(O) < otherRec.size) return false;
    var iterator = otherRec.getIterator();
    return $c3b265c1265de03f$exports(iterator, function(e) {
        if (!$d824487b4bec8d7f$require$has(O, e)) return $4105790cb9bf2aaa$exports(iterator.iterator, 'normal', false);
    }) !== false;
};


// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    isSupersetOf: function isSupersetOf(other) {
        return $881ad37dbe259e8f$exports($d824487b4bec8d7f$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';




var $e25aed89b5529bcb$exports = {};
'use strict';

var $e25aed89b5529bcb$var$$String = String;
$e25aed89b5529bcb$exports = function(argument) {
    if ($b07c9aec2f9c74e4$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $e25aed89b5529bcb$var$$String(argument);
};


var $cd706fad0a9135e1$var$arrayJoin = $43b18aa2f1faac44$exports([].join);
var $cd706fad0a9135e1$var$push = $43b18aa2f1faac44$exports([].push);
// `Set.prototype.join` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    join: function join(separator) {
        var set = $181da54e4761d0e8$exports(this);
        var sep = separator === undefined ? ',' : $e25aed89b5529bcb$exports(separator);
        var array = [];
        $fa8664a1252d26ee$exports(set, function(value) {
            $cd706fad0a9135e1$var$push(array, value);
        });
        return $cd706fad0a9135e1$var$arrayJoin(array, sep);
    }
});


'use strict';





var $a7c147af33eabfc9$var$Set = $f5060c84c0f60f7e$exports.Set;
var $a7c147af33eabfc9$var$add = $f5060c84c0f60f7e$exports.add;
// `Set.prototype.map` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var newSet = new $a7c147af33eabfc9$var$Set();
        $fa8664a1252d26ee$exports(set, function(value) {
            $a7c147af33eabfc9$var$add(newSet, boundFunction(value, value, set));
        });
        return newSet;
    }
});


'use strict';



// `Set.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
$ca3e1754e676956d$exports({
    target: 'Set',
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($f5060c84c0f60f7e$exports.Set, $f5060c84c0f60f7e$exports.add, false)
});


'use strict';




var $ac455a9431d64528$var$$TypeError = TypeError;
// `Set.prototype.reduce` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var noInitial = arguments.length < 2;
        var accumulator = noInitial ? undefined : arguments[1];
        $ae485921c5498156$exports(callbackfn);
        $fa8664a1252d26ee$exports(set, function(value) {
            if (noInitial) {
                noInitial = false;
                accumulator = value;
            } else accumulator = callbackfn(accumulator, value, value, set);
        });
        if (noInitial) throw new $ac455a9431d64528$var$$TypeError('Reduce of empty set with no initial value');
        return accumulator;
    }
});


'use strict';




// `Set.prototype.some` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        var set = $181da54e4761d0e8$exports(this);
        var boundFunction = $43284f0171045916$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return $fa8664a1252d26ee$exports(set, function(value) {
            if (boundFunction(value, value, set)) return true;
        }, true) === true;
    }
});


'use strict';



var $d76d05972236f5c4$exports = {};
'use strict';





var $d76d05972236f5c4$var$add = $f5060c84c0f60f7e$exports.add;
var $d76d05972236f5c4$var$has = $f5060c84c0f60f7e$exports.has;
var $d76d05972236f5c4$var$remove = $f5060c84c0f60f7e$exports.remove;
// `Set.prototype.symmetricDifference` method
// https://tc39.es/ecma262/#sec-set.prototype.symmetricdifference
$d76d05972236f5c4$exports = function symmetricDifference(other) {
    var O = $181da54e4761d0e8$exports(this);
    var keysIter = $a57ec52899092109$exports(other).getIterator();
    var result = $d77fd3960bcf099e$exports(O);
    $c3b265c1265de03f$exports(keysIter, function(e) {
        if ($d76d05972236f5c4$var$has(O, e)) $d76d05972236f5c4$var$remove(result, e);
        else $d76d05972236f5c4$var$add(result, e);
    });
    return result;
};


// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    symmetricDifference: function symmetricDifference(other) {
        return $881ad37dbe259e8f$exports($d76d05972236f5c4$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';



var $2a73a1a5fe9468e8$exports = {};
'use strict';


var $2a73a1a5fe9468e8$require$add = $f5060c84c0f60f7e$exports.add;



// `Set.prototype.union` method
// https://tc39.es/ecma262/#sec-set.prototype.union
$2a73a1a5fe9468e8$exports = function union(other) {
    var O = $181da54e4761d0e8$exports(this);
    var keysIter = $a57ec52899092109$exports(other).getIterator();
    var result = $d77fd3960bcf099e$exports(O);
    $c3b265c1265de03f$exports(keysIter, function(it) {
        $2a73a1a5fe9468e8$require$add(result, it);
    });
    return result;
};


// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
// TODO: Obsolete version, remove from `core-js@4`
$ca3e1754e676956d$exports({
    target: 'Set',
    proto: true,
    real: true,
    forced: true
}, {
    union: function union(other) {
        return $881ad37dbe259e8f$exports($2a73a1a5fe9468e8$exports, this, $b126c600f59850cf$exports(other));
    }
});


'use strict';

var $d2d4d612d3120d2f$exports = {};
'use strict';




var $d2d4d612d3120d2f$var$charAt = $43b18aa2f1faac44$exports(''.charAt);
var $d2d4d612d3120d2f$var$charCodeAt = $43b18aa2f1faac44$exports(''.charCodeAt);
var $d2d4d612d3120d2f$var$stringSlice = $43b18aa2f1faac44$exports(''.slice);
var $d2d4d612d3120d2f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $e25aed89b5529bcb$exports($c378177673193450$exports($this));
        var position = $b5bb21648546ce5b$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $d2d4d612d3120d2f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $d2d4d612d3120d2f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $d2d4d612d3120d2f$var$charAt(S, position) : first : CONVERT_TO_STRING ? $d2d4d612d3120d2f$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$d2d4d612d3120d2f$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $d2d4d612d3120d2f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $d2d4d612d3120d2f$var$createMethod(true)
};


var $3af59adea3ff7a02$require$charAt = $d2d4d612d3120d2f$exports.charAt;



// `String.prototype.at` method
// https://github.com/mathiasbynens/String.prototype.at
$ca3e1754e676956d$exports({
    target: 'String',
    proto: true,
    forced: true
}, {
    at: function at(index) {
        var S = $e25aed89b5529bcb$exports($c378177673193450$exports(this));
        var len = S.length;
        var relativeIndex = $b5bb21648546ce5b$exports(index);
        var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
        return k < 0 || k >= len ? undefined : $3af59adea3ff7a02$require$charAt(S, k);
    }
});


'use strict';







var $754c0816c814f0fa$var$codeAt = $d2d4d612d3120d2f$exports.codeAt;
var $754c0816c814f0fa$var$charAt = $d2d4d612d3120d2f$exports.charAt;
var $754c0816c814f0fa$var$STRING_ITERATOR = 'String Iterator';
var $754c0816c814f0fa$var$setInternalState = $3a8bcef306e86159$exports.set;
var $754c0816c814f0fa$var$getInternalState = $3a8bcef306e86159$exports.getterFor($754c0816c814f0fa$var$STRING_ITERATOR);
// TODO: unify with String#@@iterator
var $754c0816c814f0fa$var$$StringIterator = $2428e9d9593354c3$exports(function StringIterator(string) {
    $754c0816c814f0fa$var$setInternalState(this, {
        type: $754c0816c814f0fa$var$STRING_ITERATOR,
        string: string,
        index: 0
    });
}, 'String', function next() {
    var state = $754c0816c814f0fa$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $dfab5f5c406cd291$exports(undefined, true);
    point = $754c0816c814f0fa$var$charAt(string, index);
    state.index += point.length;
    return $dfab5f5c406cd291$exports({
        codePoint: $754c0816c814f0fa$var$codeAt(point, 0),
        position: index
    }, false);
});
// `String.prototype.codePoints` method
// https://github.com/tc39/proposal-string-prototype-codepoints
$ca3e1754e676956d$exports({
    target: 'String',
    proto: true,
    forced: true
}, {
    codePoints: function codePoints() {
        return new $754c0816c814f0fa$var$$StringIterator($e25aed89b5529bcb$exports($c378177673193450$exports(this)));
    }
});


'use strict';
'use strict';

var $d59cfa12048c6a93$exports = {};
'use strict';
var $d7077b1b2482ede0$exports = {};
'use strict';

$d7077b1b2482ede0$exports = $3fbf1185731afe2b$exports;



var $f95af0e9699ed86b$export$2d1720544b23b823;
'use strict';

$f95af0e9699ed86b$export$2d1720544b23b823 = $842f8f0a18746212$exports;



var $d59cfa12048c6a93$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;
$d59cfa12048c6a93$exports = function(NAME) {
    var Symbol = $d7077b1b2482ede0$exports.Symbol || ($d7077b1b2482ede0$exports.Symbol = {});
    if (!$1f868a26fd901990$exports(Symbol, NAME)) $d59cfa12048c6a93$require$defineProperty(Symbol, NAME, {
        value: $f95af0e9699ed86b$export$2d1720544b23b823(NAME)
    });
};



var $9c4acb38d07f6f64$require$defineProperty = $2d0ac3aa5e39584b$export$2d1720544b23b823;

var $9c4acb38d07f6f64$require$getOwnPropertyDescriptor = $6d99163b6684d050$export$2d1720544b23b823;
var $9c4acb38d07f6f64$var$Symbol = $3fbf1185731afe2b$exports.Symbol;
// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-explicit-resource-management
$d59cfa12048c6a93$exports('dispose');
if ($9c4acb38d07f6f64$var$Symbol) {
    var $9c4acb38d07f6f64$var$descriptor = $9c4acb38d07f6f64$require$getOwnPropertyDescriptor($9c4acb38d07f6f64$var$Symbol, 'dispose');
    // workaround of NodeJS 20.4 bug
    // https://github.com/nodejs/node/issues/48699
    // and incorrect descriptor from some transpilers and userland helpers
    if ($9c4acb38d07f6f64$var$descriptor.enumerable && $9c4acb38d07f6f64$var$descriptor.configurable && $9c4acb38d07f6f64$var$descriptor.writable) $9c4acb38d07f6f64$require$defineProperty($9c4acb38d07f6f64$var$Symbol, 'dispose', {
        value: $9c4acb38d07f6f64$var$descriptor.value,
        enumerable: false,
        configurable: false,
        writable: false
    });
}




'use strict';

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
$d59cfa12048c6a93$exports('observable');


'use strict';

// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
$d59cfa12048c6a93$exports('patternMatch');


'use strict';

var $ae43bfa593b0460a$exports = {};
'use strict';
var $9a631153b9a7e6cd$exports = {};
'use strict';

// eslint-disable-next-line es/no-weak-map -- safe
var $9a631153b9a7e6cd$var$WeakMapPrototype = WeakMap.prototype;
$9a631153b9a7e6cd$exports = {
    // eslint-disable-next-line es/no-weak-map -- safe
    WeakMap: WeakMap,
    set: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype.set),
    get: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype.get),
    has: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype.has),
    remove: $43b18aa2f1faac44$exports($9a631153b9a7e6cd$var$WeakMapPrototype['delete'])
};


var $ae43bfa593b0460a$require$has = $9a631153b9a7e6cd$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakMapData]])
$ae43bfa593b0460a$exports = function(it) {
    $ae43bfa593b0460a$require$has(it);
    return it;
};



var $3704a7e2d113d7a5$require$remove = $9a631153b9a7e6cd$exports.remove;
// `WeakMap.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'WeakMap',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $ae43bfa593b0460a$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $3704a7e2d113d7a5$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';



// `WeakMap.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
$ca3e1754e676956d$exports({
    target: 'WeakMap',
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($9a631153b9a7e6cd$exports.WeakMap, $9a631153b9a7e6cd$exports.set, true)
});


'use strict';



// `WeakMap.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
$ca3e1754e676956d$exports({
    target: 'WeakMap',
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($9a631153b9a7e6cd$exports.WeakMap, $9a631153b9a7e6cd$exports.set, true)
});


'use strict';

var $5f9b7dcc7d8b56a1$exports = {};
'use strict';
var $2a8a6281836e2ca2$exports = {};
'use strict';

// eslint-disable-next-line es/no-weak-set -- safe
var $2a8a6281836e2ca2$var$WeakSetPrototype = WeakSet.prototype;
$2a8a6281836e2ca2$exports = {
    // eslint-disable-next-line es/no-weak-set -- safe
    WeakSet: WeakSet,
    add: $43b18aa2f1faac44$exports($2a8a6281836e2ca2$var$WeakSetPrototype.add),
    has: $43b18aa2f1faac44$exports($2a8a6281836e2ca2$var$WeakSetPrototype.has),
    remove: $43b18aa2f1faac44$exports($2a8a6281836e2ca2$var$WeakSetPrototype['delete'])
};


var $5f9b7dcc7d8b56a1$require$has = $2a8a6281836e2ca2$exports.has;
// Perform ? RequireInternalSlot(M, [[WeakSetData]])
$5f9b7dcc7d8b56a1$exports = function(it) {
    $5f9b7dcc7d8b56a1$require$has(it);
    return it;
};



var $e1a09ce94db7efdc$require$add = $2a8a6281836e2ca2$exports.add;
// `WeakSet.prototype.addAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'WeakSet',
    proto: true,
    real: true,
    forced: true
}, {
    addAll: function addAll() {
        var set = $5f9b7dcc7d8b56a1$exports(this);
        for(var k = 0, len = arguments.length; k < len; k++)$e1a09ce94db7efdc$require$add(set, arguments[k]);
        return set;
    }
});


'use strict';



var $9b4fda4227855a37$require$remove = $2a8a6281836e2ca2$exports.remove;
// `WeakSet.prototype.deleteAll` method
// https://github.com/tc39/proposal-collection-methods
$ca3e1754e676956d$exports({
    target: 'WeakSet',
    proto: true,
    real: true,
    forced: true
}, {
    deleteAll: function deleteAll() {
        var collection = $5f9b7dcc7d8b56a1$exports(this);
        var allDeleted = true;
        var wasDeleted;
        for(var k = 0, len = arguments.length; k < len; k++){
            wasDeleted = $9b4fda4227855a37$require$remove(collection, arguments[k]);
            allDeleted = allDeleted && wasDeleted;
        }
        return !!allDeleted;
    }
});


'use strict';



// `WeakSet.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
$ca3e1754e676956d$exports({
    target: 'WeakSet',
    stat: true,
    forced: true
}, {
    from: $0026225b23b40e5f$exports($2a8a6281836e2ca2$exports.WeakSet, $2a8a6281836e2ca2$exports.add, false)
});


'use strict';



// `WeakSet.of` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
$ca3e1754e676956d$exports({
    target: 'WeakSet',
    stat: true,
    forced: true
}, {
    of: $2bf4af15edd92228$exports($2a8a6281836e2ca2$exports.WeakSet, $2a8a6281836e2ca2$exports.add, false)
});


'use strict';
'use strict';


var $a393da0e05d61ed1$exports = {};
'use strict';









var $7d824954c5058f7d$exports = {};
'use strict';
var $7d824954c5058f7d$var$$TypeError = TypeError;
$7d824954c5058f7d$exports = function(passed, required) {
    if (passed < required) throw new $7d824954c5058f7d$var$$TypeError('Not enough arguments');
    return passed;
};


var $2d59c67a15180939$exports = {};
'use strict';

$2d59c67a15180939$exports = /ipad|iphone|ipod/i.test($34fa2a1382dc63c1$exports) && /applewebkit/i.test($34fa2a1382dc63c1$exports);


var $88d6935be735e2e8$exports = {};
'use strict';
var $87e21695405add0a$exports = {};
'use strict';



var $87e21695405add0a$var$userAgentStartsWith = function(string) {
    return $34fa2a1382dc63c1$exports.slice(0, string.length) === string;
};
$87e21695405add0a$exports = function() {
    if ($87e21695405add0a$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($87e21695405add0a$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($87e21695405add0a$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($87e21695405add0a$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($3fbf1185731afe2b$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($3fbf1185731afe2b$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($b0ba63bfbfb16088$exports($3fbf1185731afe2b$exports.process) === 'process') return 'NODE';
    if ($3fbf1185731afe2b$exports.window && $3fbf1185731afe2b$exports.document) return 'BROWSER';
    return 'REST';
}();


$88d6935be735e2e8$exports = $87e21695405add0a$exports === 'NODE';


var $a393da0e05d61ed1$var$set = $3fbf1185731afe2b$exports.setImmediate;
var $a393da0e05d61ed1$var$clear = $3fbf1185731afe2b$exports.clearImmediate;
var $a393da0e05d61ed1$var$process = $3fbf1185731afe2b$exports.process;
var $a393da0e05d61ed1$var$Dispatch = $3fbf1185731afe2b$exports.Dispatch;
var $a393da0e05d61ed1$var$Function = $3fbf1185731afe2b$exports.Function;
var $a393da0e05d61ed1$var$MessageChannel = $3fbf1185731afe2b$exports.MessageChannel;
var $a393da0e05d61ed1$var$String = $3fbf1185731afe2b$exports.String;
var $a393da0e05d61ed1$var$counter = 0;
var $a393da0e05d61ed1$var$queue = {};
var $a393da0e05d61ed1$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $a393da0e05d61ed1$var$$location, $a393da0e05d61ed1$var$defer, $a393da0e05d61ed1$var$channel, $a393da0e05d61ed1$var$port;
$6140c9fa18232846$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $a393da0e05d61ed1$var$$location = $3fbf1185731afe2b$exports.location;
});
var $a393da0e05d61ed1$var$run = function(id) {
    if ($1f868a26fd901990$exports($a393da0e05d61ed1$var$queue, id)) {
        var fn = $a393da0e05d61ed1$var$queue[id];
        delete $a393da0e05d61ed1$var$queue[id];
        fn();
    }
};
var $a393da0e05d61ed1$var$runner = function(id) {
    return function() {
        $a393da0e05d61ed1$var$run(id);
    };
};
var $a393da0e05d61ed1$var$eventListener = function(event) {
    $a393da0e05d61ed1$var$run(event.data);
};
var $a393da0e05d61ed1$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $3fbf1185731afe2b$exports.postMessage($a393da0e05d61ed1$var$String(id), $a393da0e05d61ed1$var$$location.protocol + '//' + $a393da0e05d61ed1$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$a393da0e05d61ed1$var$set || !$a393da0e05d61ed1$var$clear) {
    $a393da0e05d61ed1$var$set = function setImmediate(handler) {
        $7d824954c5058f7d$exports(arguments.length, 1);
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $a393da0e05d61ed1$var$Function(handler);
        var args = $0709cba658bb4ed6$exports(arguments, 1);
        $a393da0e05d61ed1$var$queue[++$a393da0e05d61ed1$var$counter] = function() {
            $3cdb2ef65d8e3cb5$exports(fn, undefined, args);
        };
        $a393da0e05d61ed1$var$defer($a393da0e05d61ed1$var$counter);
        return $a393da0e05d61ed1$var$counter;
    };
    $a393da0e05d61ed1$var$clear = function clearImmediate(id) {
        delete $a393da0e05d61ed1$var$queue[id];
    };
    // Node.js 0.8-
    if ($88d6935be735e2e8$exports) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$process.nextTick($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$Dispatch && $a393da0e05d61ed1$var$Dispatch.now) $a393da0e05d61ed1$var$defer = function(id) {
        $a393da0e05d61ed1$var$Dispatch.now($a393da0e05d61ed1$var$runner(id));
    };
    else if ($a393da0e05d61ed1$var$MessageChannel && !$2d59c67a15180939$exports) {
        $a393da0e05d61ed1$var$channel = new $a393da0e05d61ed1$var$MessageChannel();
        $a393da0e05d61ed1$var$port = $a393da0e05d61ed1$var$channel.port2;
        $a393da0e05d61ed1$var$channel.port1.onmessage = $a393da0e05d61ed1$var$eventListener;
        $a393da0e05d61ed1$var$defer = $43284f0171045916$exports($a393da0e05d61ed1$var$port.postMessage, $a393da0e05d61ed1$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($3fbf1185731afe2b$exports.addEventListener && $70e34a5a2021f756$exports($3fbf1185731afe2b$exports.postMessage) && !$3fbf1185731afe2b$exports.importScripts && $a393da0e05d61ed1$var$$location && $a393da0e05d61ed1$var$$location.protocol !== 'file:' && !$6140c9fa18232846$exports($a393da0e05d61ed1$var$globalPostMessageDefer)) {
        $a393da0e05d61ed1$var$defer = $a393da0e05d61ed1$var$globalPostMessageDefer;
        $3fbf1185731afe2b$exports.addEventListener('message', $a393da0e05d61ed1$var$eventListener, false);
    // IE8-
    } else if ($a393da0e05d61ed1$var$ONREADYSTATECHANGE in $15c0c414b89100b1$exports('script')) $a393da0e05d61ed1$var$defer = function(id) {
        $b8ce1ad1b6b1e7c1$exports.appendChild($15c0c414b89100b1$exports('script'))[$a393da0e05d61ed1$var$ONREADYSTATECHANGE] = function() {
            $b8ce1ad1b6b1e7c1$exports.removeChild(this);
            $a393da0e05d61ed1$var$run(id);
        };
    };
    else $a393da0e05d61ed1$var$defer = function(id) {
        setTimeout($a393da0e05d61ed1$var$runner(id), 0);
    };
}
$a393da0e05d61ed1$exports = {
    set: $a393da0e05d61ed1$var$set,
    clear: $a393da0e05d61ed1$var$clear
};


var $99b55bbd56d52729$require$clearImmediate = $a393da0e05d61ed1$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.clearImmediate !== $99b55bbd56d52729$require$clearImmediate
}, {
    clearImmediate: $99b55bbd56d52729$require$clearImmediate
});


'use strict';



var $e55ac54d5aaa2e1c$require$setTask = $a393da0e05d61ed1$exports.set;
var $f112a170991e44cc$exports = {};
'use strict';







var $f112a170991e44cc$var$Function = $3fbf1185731afe2b$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f112a170991e44cc$var$WRAP = /MSIE .\./.test($34fa2a1382dc63c1$exports) || $87e21695405add0a$exports === 'BUN' && function() {
    var version = $3fbf1185731afe2b$exports.Bun.version.split('.');
    return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f112a170991e44cc$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f112a170991e44cc$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $7d824954c5058f7d$exports(arguments.length, 1) > firstParamIndex;
        var fn = $70e34a5a2021f756$exports(handler) ? handler : $f112a170991e44cc$var$Function(handler);
        var params = boundArgs ? $0709cba658bb4ed6$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $3cdb2ef65d8e3cb5$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $e55ac54d5aaa2e1c$var$setImmediate = $3fbf1185731afe2b$exports.setImmediate ? $f112a170991e44cc$exports($e55ac54d5aaa2e1c$require$setTask, false) : $e55ac54d5aaa2e1c$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$ca3e1754e676956d$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $3fbf1185731afe2b$exports.setImmediate !== $e55ac54d5aaa2e1c$var$setImmediate
}, {
    setImmediate: $e55ac54d5aaa2e1c$var$setImmediate
});





var $acw62 = parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();



var $acw62 = parcelRequire("acw62");
var $e738ce20751cb945$var$hasDocument = typeof document !== 'undefined';
var $e738ce20751cb945$var$vendorEvents = [
    {
        hidden: 'hidden',
        event: 'visibilitychange',
        state: 'visibilityState'
    },
    {
        hidden: 'webkitHidden',
        event: 'webkitvisibilitychange',
        state: 'webkitVisibilityState'
    },
    {
        hidden: 'mozHidden',
        event: 'mozvisibilitychange',
        state: 'mozVisibilityState'
    },
    {
        hidden: 'msHidden',
        event: 'msvisibilitychange',
        state: 'msVisibilityState'
    },
    {
        hidden: 'oHidden',
        event: 'ovisibilitychange',
        state: 'oVisibilityState'
    }
];
var $e738ce20751cb945$export$48c17662a6902497 = $e738ce20751cb945$var$hasDocument && Boolean(document.addEventListener);
var $e738ce20751cb945$export$91fa9ac3f4021ce4 = function() {
    if (!$e738ce20751cb945$export$48c17662a6902497) return null;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $e738ce20751cb945$var$vendorEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var event = _step.value;
            if (event.hidden in document) return event;
        }
    // otherwise it's not supported
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return null;
}();
var $e738ce20751cb945$export$8f31d6b76f7eaa9e = function getHandlerArgs() {
    if (!$e738ce20751cb945$export$91fa9ac3f4021ce4) return [
        true,
        'visible'
    ];
    var hidden = $e738ce20751cb945$export$91fa9ac3f4021ce4.hidden, state = $e738ce20751cb945$export$91fa9ac3f4021ce4.state;
    return [
        !document[hidden],
        document[state]
    ];
};


var $902e5babeaf3f2b3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $902e5babeaf3f2b3$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $902e5babeaf3f2b3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $902e5babeaf3f2b3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $902e5babeaf3f2b3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $902e5babeaf3f2b3$var$PageVisibility = function(_React$Component) {
    $902e5babeaf3f2b3$var$_inherits(PageVisibility, _React$Component);
    function PageVisibility(props) {
        $902e5babeaf3f2b3$var$_classCallCheck(this, PageVisibility);
        var _this = $902e5babeaf3f2b3$var$_possibleConstructorReturn(this, (PageVisibility.__proto__ || Object.getPrototypeOf(PageVisibility)).call(this, props));
        _this.state = {
            isSupported: (0, $e738ce20751cb945$export$48c17662a6902497) && (0, $e738ce20751cb945$export$91fa9ac3f4021ce4)
        };
        return _this;
    }
    $902e5babeaf3f2b3$var$_createClass(PageVisibility, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!this.state.isSupported) return;
                this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
                document.addEventListener((0, $e738ce20751cb945$export$91fa9ac3f4021ce4).event, this.handleVisibilityChange);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!this.state.isSupported) return;
                document.removeEventListener((0, $e738ce20751cb945$export$91fa9ac3f4021ce4).event, this.handleVisibilityChange);
            }
        },
        {
            key: 'handleVisibilityChange',
            value: function handleVisibilityChange() {
                if (typeof this.props.onChange === 'function') {
                    var _props;
                    // propagate change to callback
                    (_props = this.props).onChange.apply(_props, $902e5babeaf3f2b3$var$_toConsumableArray((0, $e738ce20751cb945$export$8f31d6b76f7eaa9e)()));
                }
                if (typeof this.props.children === 'function') // we pass the props directly to the function as children
                this.forceUpdate();
            }
        },
        {
            key: 'render',
            value: function render() {
                if (!this.props.children) return null;
                // function as children pattern support
                if (typeof this.props.children === 'function') {
                    var _props2;
                    if (!this.state.isSupported) // don't pass any arguments if PageVisibility is not supported
                    return this.props.children();
                    return (_props2 = this.props).children.apply(_props2, $902e5babeaf3f2b3$var$_toConsumableArray((0, $e738ce20751cb945$export$8f31d6b76f7eaa9e)()));
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(this.props.children);
            }
        }
    ]);
    return PageVisibility;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$902e5babeaf3f2b3$var$PageVisibility.displayName = 'PageVisibility';
$902e5babeaf3f2b3$var$PageVisibility.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    ])
};
var $902e5babeaf3f2b3$export$2e2bcd8739ae039 = $902e5babeaf3f2b3$var$PageVisibility;



var $01a5de12b9480c6b$export$2e2bcd8739ae039 = (0, $902e5babeaf3f2b3$export$2e2bcd8739ae039);


var $77f60634a37f26aa$export$595bc52137d2dc55 = /*#__PURE__*/ function(DisplayState) {
    DisplayState["Covered"] = "COVERED";
    DisplayState["Uncovered"] = "UNCOVERED";
    DisplayState["Flagged"] = "FLAGGED";
    DisplayState["Detonated"] = "DETONATED";
    DisplayState["Maybe"] = "MAYBE";
    return DisplayState;
}({});


const $4388d496bdb048be$var$Levels = {
    EASY: {
        width: 9,
        height: 9,
        mines: 10
    },
    MEDIUM: {
        width: 16,
        height: 16,
        mines: 40
    },
    HARD: {
        width: 30,
        height: 16,
        mines: 99
    }
};
var $4388d496bdb048be$export$2e2bcd8739ae039 = $4388d496bdb048be$var$Levels;


class $cfdb0b85ae696cd2$export$2e2bcd8739ae039 {
    #achievements;
    constructor(){
        this.#achievements = {
            juniorAnalyst: {
                name: 'Junior Security Analyst',
                description: 'Remediate a class C network in 8 seconds or less',
                secret: false,
                achievedOn: null
            },
            seniorAnalyst: {
                name: 'Senior Security Analyst',
                description: 'Remediate a class B network in 60 seconds or less',
                secret: false,
                achievedOn: null
            },
            ciso: {
                name: 'Chief Information Security Officer',
                description: 'Remediate a class A network in 180 seconds or less',
                link: 'https://en.wikipedia.org/wiki/Chief_information_security_officer',
                secret: false,
                achievedOn: null
            },
            weakestLink: {
                name: 'Weakest Link in the Chain',
                description: 'Get pwned while booting the last three devices of a class B or class A network',
                link: 'https://blog.avast.com/weakest-link-in-security-avast',
                secret: false,
                achievedOn: null
            },
            extinguished: {
                name: 'Extinguished',
                description: 'Get pwned on the perimeter of the network',
                link: 'https://en.wikipedia.org/wiki/Firewall_(computing)',
                secret: false,
                achievedOn: null
            },
            highValueTarget: {
                name: 'High Value Target',
                description: 'Get pwned by a zero-day vulnerability',
                link: 'https://en.wikipedia.org/wiki/Zero-day_(computing)',
                secret: false,
                achievedOn: null
            },
            apt: {
                name: 'Advanced Persistent Threat',
                description: 'Get pwned by five zero-day vulnerabilities',
                link: 'https://en.wikipedia.org/wiki/Advanced_persistent_threat',
                secret: false,
                achievedOn: null
            },
            soar: {
                name: 'SOARing Above and Beyond',
                description: 'Win 20 games',
                link: 'https://www.gartner.com/en/information-technology/glossary/security-orchestration-automation-response-soar',
                secret: false,
                achievedOn: null
            },
            dhcp: {
                name: 'Do You Even DHCP Bro?',
                description: 'Remediate a class C network without using flags',
                link: 'https://en.wikipedia.org/wiki/Dynamic_Host_Configuration_Protocol',
                secret: false,
                achievedOn: null
            },
            ipam: {
                name: 'IPAM is My Best Friend',
                description: 'Remediate a class B network without using flags',
                link: 'https://en.wikipedia.org/wiki/IP_address_management',
                secret: false,
                achievedOn: null
            },
            cmdb: {
                name: 'Who Needs a CMDB Anyways?',
                description: 'Remediate a class A network without using flags',
                link: 'https://en.wikipedia.org/wiki/Configuration_management_database',
                secret: false,
                achievedOn: null
            },
            overzealous: {
                name: 'Overzealous',
                description: 'Get pwned with a false positive',
                link: 'https://en.wikipedia.org/wiki/False_positives_and_false_negatives',
                secret: false,
                achievedOn: null
            },
            bufferOverflow: {
                name: 'Buffer Overflow',
                description: 'Quarantine (flag) more devices than known threats',
                link: 'https://en.wikipedia.org/wiki/Buffer_overflow',
                secret: true,
                achievedOn: null
            },
            liveUsb: {
                name: 'If Only We Had a Live USB',
                description: 'Mark four or more devices as "maybe compromised"',
                link: 'https://en.wikipedia.org/wiki/Live_USB',
                secret: true,
                achievedOn: null
            },
            coffeeBreak: {
                name: 'Coffee Break',
                description: 'Switch tabs or minimize the window',
                secret: true,
                achievedOn: null
            }
        };
        this.#loadFromWebStorage();
    }
    /**
     * Load achievements from Web Storage
     */ #loadFromWebStorage() {
        try {
            const savedAchievements = JSON.parse(localStorage.getItem('achievements') ?? '{}');
            Object.entries(savedAchievements).forEach(([name, achievement])=>{
                if (name in this.#achievements) this.#achievements[name].achievedOn = new Date(achievement.achievedOn);
            });
        } catch (err) {
            console.error('Error retrieving saved achievements: ' + err);
        }
    }
    /**
     * Persist acheivements to Web Storage
     */ persist() {
        const serializableAchievements = Object.fromEntries(Object.entries(this.#achievements).filter(([, achievement])=>achievement.achievedOn !== null).map(([name, achievement])=>{
            return [
                name,
                {
                    achievedOn: achievement.achievedOn?.toISOString()
                }
            ];
        }));
        localStorage.setItem('achievements', JSON.stringify(serializableAchievements));
    }
    /**
     * Evaluate whether achievements have been achieved
     * @param game
     * @param timer
     */ evaluate(game, timer) {
        const date = new Date();
        const { board: board, level: level, won: won, lost: lost, flagsUsed: flagsUsed } = game;
        const flatBoard = board.flat();
        const totalSquares = flatBoard.length;
        this.#achievements.juniorAnalyst.achievedOn ||= won && level === (0, $4388d496bdb048be$export$2e2bcd8739ae039).EASY && timer <= 8 ? date : null;
        this.#achievements.seniorAnalyst.achievedOn ||= won && level === (0, $4388d496bdb048be$export$2e2bcd8739ae039).MEDIUM && timer <= 60 ? date : null;
        this.#achievements.ciso.achievedOn ||= won && level === (0, $4388d496bdb048be$export$2e2bcd8739ae039).HARD && timer <= 180 ? date : null;
        this.#achievements.weakestLink.achievedOn ||= lost && [
            (0, $4388d496bdb048be$export$2e2bcd8739ae039).MEDIUM,
            (0, $4388d496bdb048be$export$2e2bcd8739ae039).HARD
        ].includes(level) && totalSquares - flatBoard.filter((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered || square.surroundingMines === -1).length <= 3 ? date : null;
        this.#achievements.extinguished.achievedOn ||= lost && [
            ...board[0],
            ...board[board.length - 1],
            ...board.map((col)=>col[0]),
            ...board.map((col)=>col[col.length - 1])
        ].some((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated) ? date : null;
        this.#achievements.highValueTarget.achievedOn ||= lost && flatBoard.some((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated) && !flatBoard.some((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered) ? date : null;
        this.#achievements.apt.achievedOn ||= Number(localStorage.getItem('gamesInstantlyLost')) >= 5 ? date : null;
        this.#achievements.soar.achievedOn ||= Number(localStorage.getItem('gamesWon')) >= 20 ? date : null;
        this.#achievements.dhcp.achievedOn ||= won && !flagsUsed && level === (0, $4388d496bdb048be$export$2e2bcd8739ae039).EASY ? date : null;
        this.#achievements.ipam.achievedOn ||= won && !flagsUsed && level === (0, $4388d496bdb048be$export$2e2bcd8739ae039).MEDIUM ? date : null;
        this.#achievements.cmdb.achievedOn ||= won && !flagsUsed && level === (0, $4388d496bdb048be$export$2e2bcd8739ae039).HARD ? date : null;
        this.#achievements.overzealous.achievedOn ||= lost && flatBoard.some((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged && square.surroundingMines !== -1) ? date : null;
        this.#achievements.bufferOverflow.achievedOn ||= flatBoard.filter((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged).length > level.mines ? date : null;
        this.#achievements.liveUsb.achievedOn ||= flatBoard.filter((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe).length >= 4 ? date : null;
        this.#achievements.coffeeBreak.achievedOn ||= game.paused && flatBoard.some((square)=>square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered) ? date : null;
    }
    list() {
        return this.#achievements;
    }
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Concatination helper, which can merge class names together. Skips over falsey values.
 *
 * @public
 */ function $12c8f27fb57f0fcf$export$dbf350e5966cf602() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var classes = [];
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        if (arg) {
            if (typeof arg === 'string') classes.push(arg);
            else if (arg.hasOwnProperty('toString') && typeof arg.toString === 'function') classes.push(arg.toString());
            else {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                for(var key in arg)// eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (arg[key]) classes.push(key);
            }
        }
    }
    return classes.join(' ');
}

var $076f236b4b7f2dc0$var$toObjectMap = function() {
    var items = [];
    for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
    var result = {};
    for(var _a = 0, items_1 = items; _a < items_1.length; _a++){
        var item = items_1[_a];
        var keys = Array.isArray(item) ? item : Object.keys(item);
        for(var _b = 0, keys_1 = keys; _b < keys_1.length; _b++){
            var key = keys_1[_b];
            result[key] = 1;
        }
    }
    return result;
};
var $076f236b4b7f2dc0$export$32eff4db2feb903 = $076f236b4b7f2dc0$var$toObjectMap([
    'onCopy',
    'onCut',
    'onPaste',
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onInput',
    'onSubmit',
    'onLoad',
    'onError',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyUp',
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onDoubleClick',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
    'onScroll',
    'onWheel',
    'onPointerCancel',
    'onPointerDown',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerMove',
    'onPointerOut',
    'onPointerOver',
    'onPointerUp',
    'onGotPointerCapture',
    'onLostPointerCapture'
]);
var $076f236b4b7f2dc0$export$7256d73338e409fd = $076f236b4b7f2dc0$var$toObjectMap([
    'accessKey',
    'children',
    'className',
    'contentEditable',
    'dir',
    'draggable',
    'hidden',
    'htmlFor',
    'id',
    'lang',
    'ref',
    'role',
    'style',
    'tabIndex',
    'title',
    'translate',
    'spellCheck',
    'name'
]);
var $076f236b4b7f2dc0$export$e4936fed10ab2c40 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$7256d73338e409fd, $076f236b4b7f2dc0$export$32eff4db2feb903);
var $076f236b4b7f2dc0$export$ec8d81a3d8f61d0f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'form'
]);
var $076f236b4b7f2dc0$export$55af9cf105a52547 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'height',
    'loop',
    'muted',
    'preload',
    'src',
    'width'
]);
var $076f236b4b7f2dc0$export$cd2126b486be823e = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$55af9cf105a52547, [
    'poster'
]);
var $076f236b4b7f2dc0$export$9e755727cea4fd1f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'start'
]);
var $076f236b4b7f2dc0$export$8703767c2ecb797b = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'value'
]);
var $076f236b4b7f2dc0$export$bd4643a0b4568ed8 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'download',
    'href',
    'hrefLang',
    'media',
    'rel',
    'target',
    'type'
]);
var $076f236b4b7f2dc0$export$4fd534fb1e82b8b4 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'type',
    'value'
]);
var $076f236b4b7f2dc0$export$33c6815a27d08ce5 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$4fd534fb1e82b8b4, [
    'accept',
    'alt',
    'autoCapitalize',
    'autoComplete',
    'checked',
    'dirname',
    'form',
    'height',
    'inputMode',
    'list',
    'max',
    'maxLength',
    'min',
    'minLength',
    'multiple',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'src',
    'step',
    'size',
    'type',
    'value',
    'width'
]);
var $076f236b4b7f2dc0$export$699534499318873d = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$4fd534fb1e82b8b4, [
    'autoCapitalize',
    'cols',
    'dirname',
    'form',
    'maxLength',
    'minLength',
    'placeholder',
    'readOnly',
    'required',
    'rows',
    'wrap'
]);
var $076f236b4b7f2dc0$export$9475341421ea2846 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$4fd534fb1e82b8b4, [
    'form',
    'multiple',
    'required'
]);
var $076f236b4b7f2dc0$export$9004c3828878727f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'selected',
    'value'
]);
var $076f236b4b7f2dc0$export$2f53f8cf7eb86ae5 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'cellPadding',
    'cellSpacing'
]);
var $076f236b4b7f2dc0$export$3ab2f4f445c2eb24 = $076f236b4b7f2dc0$export$e4936fed10ab2c40;
var $076f236b4b7f2dc0$export$2b115a026f474c83 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'rowSpan',
    'scope'
]);
var $076f236b4b7f2dc0$export$b5d753b2279d22cc = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'colSpan',
    'headers',
    'rowSpan',
    'scope'
]);
var $076f236b4b7f2dc0$export$d526cc4b9c261b42 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'span'
]);
var $076f236b4b7f2dc0$export$e487baa138d06e98 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'span'
]);
var $076f236b4b7f2dc0$export$477a3a6d251d97a7 = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'acceptCharset',
    'action',
    'encType',
    'encType',
    'method',
    'noValidate',
    'target'
]);
var $076f236b4b7f2dc0$export$727a7f82229b450f = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'allow',
    'allowFullScreen',
    'allowPaymentRequest',
    'allowTransparency',
    'csp',
    'height',
    'importance',
    'referrerPolicy',
    'sandbox',
    'src',
    'srcDoc',
    'width'
]);
var $076f236b4b7f2dc0$export$91f8cc2b546c057d = $076f236b4b7f2dc0$var$toObjectMap($076f236b4b7f2dc0$export$e4936fed10ab2c40, [
    'alt',
    'crossOrigin',
    'height',
    'src',
    'srcSet',
    'useMap',
    'width'
]);
var $076f236b4b7f2dc0$export$dcff37c9c09e9e03 = $076f236b4b7f2dc0$export$91f8cc2b546c057d;
var $076f236b4b7f2dc0$export$eb42a981869108f0 = $076f236b4b7f2dc0$export$e4936fed10ab2c40;
function $076f236b4b7f2dc0$export$26fba481281db559(// eslint-disable-next-line @typescript-eslint/no-explicit-any
props, allowedPropNames, excludedPropNames) {
    // It'd be great to properly type this while allowing 'aria-` and 'data-' attributes like TypeScript does for
    // JSX attributes, but that ability is hardcoded into the TS compiler with no analog in TypeScript typings.
    // Then we'd be able to enforce props extends native props (including aria- and data- attributes), and then
    // return native props.
    // We should be able to do this once this PR is merged: https://github.com/microsoft/TypeScript/pull/26797
    var isArray = Array.isArray(allowedPropNames);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    var keys = Object.keys(props);
    for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
        var key = keys_2[_i];
        var isNativeProp = !isArray && allowedPropNames[key] || isArray && allowedPropNames.indexOf(key) >= 0 || key.indexOf('data-') === 0 || key.indexOf('aria-') === 0;
        if (isNativeProp && (!excludedPropNames || (excludedPropNames === null || excludedPropNames === void 0 ? void 0 : excludedPropNames.indexOf(key)) === -1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        result[key] = props[key];
    }
    return result;
}


var $2eb6636429fd94cd$exports = {};

$parcel$export($2eb6636429fd94cd$exports, "root", () => $2eb6636429fd94cd$export$e8e78c978b129247);
$parcel$export($2eb6636429fd94cd$exports, "svg", () => $2eb6636429fd94cd$export$7ed1367e7fa1ad68);
/* eslint-disable */ // Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var $3f49b970b29d910a$var$__assign = undefined && undefined.__assign || function() {
    $3f49b970b29d910a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f49b970b29d910a$var$__assign.apply(this, arguments);
};
// Store the theming state in __themeState__ global scope for reuse in the case of duplicate
// load-themed-styles hosted on the page.
var $3f49b970b29d910a$var$_root = typeof window === 'undefined' ? $parcel$global : window; // eslint-disable-line @typescript-eslint/no-explicit-any
// Nonce string to inject into script tag if one provided. This is used in CSP (Content Security Policy).
var $3f49b970b29d910a$var$_styleNonce = $3f49b970b29d910a$var$_root && $3f49b970b29d910a$var$_root.CSPSettings && $3f49b970b29d910a$var$_root.CSPSettings.nonce;
var $3f49b970b29d910a$var$_themeState = $3f49b970b29d910a$var$initializeThemeState();
/**
 * Matches theming tokens. For example, "[theme: themeSlotName, default: #FFF]" (including the quotes).
 */ var $3f49b970b29d910a$var$_themeTokenRegex = /[\'\"]\[theme:\s*(\w+)\s*(?:\,\s*default:\s*([\\"\']?[\.\,\(\)\#\-\s\w]*[\.\,\(\)\#\-\w][\"\']?))?\s*\][\'\"]/g;
var $3f49b970b29d910a$var$now = function() {
    return typeof performance !== 'undefined' && !!performance.now ? performance.now() : Date.now();
};
function $3f49b970b29d910a$var$measure(func) {
    var start = $3f49b970b29d910a$var$now();
    func();
    var end = $3f49b970b29d910a$var$now();
    $3f49b970b29d910a$var$_themeState.perf.duration += end - start;
}
/**
 * initialize global state object
 */ function $3f49b970b29d910a$var$initializeThemeState() {
    var state = $3f49b970b29d910a$var$_root.__themeState__ || {
        theme: undefined,
        lastStyleElement: undefined,
        registeredStyles: []
    };
    if (!state.runState) state = $3f49b970b29d910a$var$__assign($3f49b970b29d910a$var$__assign({}, state), {
        perf: {
            count: 0,
            duration: 0
        },
        runState: {
            flushTimer: 0,
            mode: 0 /* sync */ ,
            buffer: []
        }
    });
    if (!state.registeredThemableStyles) state = $3f49b970b29d910a$var$__assign($3f49b970b29d910a$var$__assign({}, state), {
        registeredThemableStyles: []
    });
    $3f49b970b29d910a$var$_root.__themeState__ = state;
    return state;
}
function $3f49b970b29d910a$export$277cf3cf4a1518cd(styles, loadAsync) {
    if (loadAsync === void 0) loadAsync = false;
    $3f49b970b29d910a$var$measure(function() {
        var styleParts = Array.isArray(styles) ? styles : $3f49b970b29d910a$export$bb01df06f2c55008(styles);
        var _a = $3f49b970b29d910a$var$_themeState.runState, mode = _a.mode, buffer = _a.buffer, flushTimer = _a.flushTimer;
        if (loadAsync || mode === 1 /* async */ ) {
            buffer.push(styleParts);
            if (!flushTimer) $3f49b970b29d910a$var$_themeState.runState.flushTimer = $3f49b970b29d910a$var$asyncLoadStyles();
        } else $3f49b970b29d910a$var$applyThemableStyles(styleParts);
    });
}
function $3f49b970b29d910a$export$181b9c90f55ff807(loadStylesFn) {
    $3f49b970b29d910a$var$_themeState.loadStyles = loadStylesFn;
}
function $3f49b970b29d910a$export$116c501adb0c3234(mode) {
    $3f49b970b29d910a$var$_themeState.runState.mode = mode;
}
function $3f49b970b29d910a$export$4909b86c8034bf73() {
    $3f49b970b29d910a$var$measure(function() {
        var styleArrays = $3f49b970b29d910a$var$_themeState.runState.buffer.slice();
        $3f49b970b29d910a$var$_themeState.runState.buffer = [];
        var mergedStyleArray = [].concat.apply([], styleArrays);
        if (mergedStyleArray.length > 0) $3f49b970b29d910a$var$applyThemableStyles(mergedStyleArray);
    });
}
/**
 * register async loadStyles
 */ function $3f49b970b29d910a$var$asyncLoadStyles() {
    return setTimeout(function() {
        $3f49b970b29d910a$var$_themeState.runState.flushTimer = 0;
        $3f49b970b29d910a$export$4909b86c8034bf73();
    }, 0);
}
/**
 * Loads a set of style text. If it is registered too early, we will register it when the window.load event
 * is fired.
 * @param {string} styleText Style to register.
 * @param {IStyleRecord} styleRecord Existing style record to re-apply.
 */ function $3f49b970b29d910a$var$applyThemableStyles(stylesArray, styleRecord) {
    if ($3f49b970b29d910a$var$_themeState.loadStyles) $3f49b970b29d910a$var$_themeState.loadStyles($3f49b970b29d910a$var$resolveThemableArray(stylesArray).styleString, stylesArray);
    else $3f49b970b29d910a$var$registerStyles(stylesArray);
}
function $3f49b970b29d910a$export$a1d87755f3c9500d(theme) {
    $3f49b970b29d910a$var$_themeState.theme = theme;
    // reload styles.
    $3f49b970b29d910a$var$reloadStyles();
}
function $3f49b970b29d910a$export$537f61d53c932351(option) {
    if (option === void 0) option = 3 /* all */ ;
    if (option === 3 /* all */  || option === 2 /* onlyNonThemable */ ) {
        $3f49b970b29d910a$var$clearStylesInternal($3f49b970b29d910a$var$_themeState.registeredStyles);
        $3f49b970b29d910a$var$_themeState.registeredStyles = [];
    }
    if (option === 3 /* all */  || option === 1 /* onlyThemable */ ) {
        $3f49b970b29d910a$var$clearStylesInternal($3f49b970b29d910a$var$_themeState.registeredThemableStyles);
        $3f49b970b29d910a$var$_themeState.registeredThemableStyles = [];
    }
}
function $3f49b970b29d910a$var$clearStylesInternal(records) {
    records.forEach(function(styleRecord) {
        var styleElement = styleRecord && styleRecord.styleElement;
        if (styleElement && styleElement.parentElement) styleElement.parentElement.removeChild(styleElement);
    });
}
/**
 * Reloads styles.
 */ function $3f49b970b29d910a$var$reloadStyles() {
    if ($3f49b970b29d910a$var$_themeState.theme) {
        var themableStyles = [];
        for(var _i = 0, _a = $3f49b970b29d910a$var$_themeState.registeredThemableStyles; _i < _a.length; _i++){
            var styleRecord = _a[_i];
            themableStyles.push(styleRecord.themableStyle);
        }
        if (themableStyles.length > 0) {
            $3f49b970b29d910a$export$537f61d53c932351(1 /* onlyThemable */ );
            $3f49b970b29d910a$var$applyThemableStyles([].concat.apply([], themableStyles));
        }
    }
}
function $3f49b970b29d910a$export$208ca8297aba2218(styles) {
    if (styles) styles = $3f49b970b29d910a$var$resolveThemableArray($3f49b970b29d910a$export$bb01df06f2c55008(styles)).styleString;
    return styles;
}
/**
 * Resolves ThemingInstruction objects in an array and joins the result into a string.
 * @param {ThemableArray} splitStyleArray ThemableArray to resolve and join.
 */ function $3f49b970b29d910a$var$resolveThemableArray(splitStyleArray) {
    var theme = $3f49b970b29d910a$var$_themeState.theme;
    var themable = false;
    // Resolve the array of theming instructions to an array of strings.
    // Then join the array to produce the final CSS string.
    var resolvedArray = (splitStyleArray || []).map(function(currentValue) {
        var themeSlot = currentValue.theme;
        if (themeSlot) {
            themable = true;
            // A theming annotation. Resolve it.
            var themedValue = theme ? theme[themeSlot] : undefined;
            var defaultValue = currentValue.defaultValue || 'inherit';
            // Warn to console if we hit an unthemed value even when themes are provided, but only if "DEBUG" is true.
            // Allow the themedValue to be undefined to explicitly request the default value.
            if (theme && !themedValue && console && !(themeSlot in theme) && typeof DEBUG !== 'undefined' && DEBUG) console.warn("Theming value not provided for \"" + themeSlot + "\". Falling back to \"" + defaultValue + "\".");
            return themedValue || defaultValue;
        } else // A non-themable string. Preserve it.
        return currentValue.rawString;
    });
    return {
        styleString: resolvedArray.join(''),
        themable: themable
    };
}
function $3f49b970b29d910a$export$bb01df06f2c55008(styles) {
    var result = [];
    if (styles) {
        var pos = 0; // Current position in styles.
        var tokenMatch = void 0;
        while(tokenMatch = $3f49b970b29d910a$var$_themeTokenRegex.exec(styles)){
            var matchIndex = tokenMatch.index;
            if (matchIndex > pos) result.push({
                rawString: styles.substring(pos, matchIndex)
            });
            result.push({
                theme: tokenMatch[1],
                defaultValue: tokenMatch[2] // May be undefined
            });
            // index of the first character after the current match
            pos = $3f49b970b29d910a$var$_themeTokenRegex.lastIndex;
        }
        // Push the rest of the string after the last match.
        result.push({
            rawString: styles.substring(pos)
        });
    }
    return result;
}
/**
 * Registers a set of style text. If it is registered too early, we will register it when the
 * window.load event is fired.
 * @param {ThemableArray} styleArray Array of IThemingInstruction objects to register.
 * @param {IStyleRecord} styleRecord May specify a style Element to update.
 */ function $3f49b970b29d910a$var$registerStyles(styleArray) {
    if (typeof document === 'undefined') return;
    var head = document.getElementsByTagName('head')[0];
    var styleElement = document.createElement('style');
    var _a = $3f49b970b29d910a$var$resolveThemableArray(styleArray), styleString = _a.styleString, themable = _a.themable;
    styleElement.setAttribute('data-load-themed-styles', 'true');
    if ($3f49b970b29d910a$var$_styleNonce) styleElement.setAttribute('nonce', $3f49b970b29d910a$var$_styleNonce);
    styleElement.appendChild(document.createTextNode(styleString));
    $3f49b970b29d910a$var$_themeState.perf.count++;
    head.appendChild(styleElement);
    var ev = document.createEvent('HTMLEvents');
    ev.initEvent('styleinsert', true, false);
    ev.args = {
        newStyle: styleElement
    };
    document.dispatchEvent(ev);
    var record = {
        styleElement: styleElement,
        themableStyle: styleArray
    };
    if (themable) $3f49b970b29d910a$var$_themeState.registeredThemableStyles.push(record);
    else $3f49b970b29d910a$var$_themeState.registeredStyles.push(record);
}


(0, $3f49b970b29d910a$export$277cf3cf4a1518cd)([
    {
        "rawString": ".root_dd790ee3{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_dd790ee3{height:100%;fill:currentColor;vertical-align:top;forced-color-adjust:auto}"
    }
]);
const $2eb6636429fd94cd$export$e8e78c978b129247 = "root_dd790ee3";
const $2eb6636429fd94cd$export$7ed1367e7fa1ad68 = "svg_dd790ee3";



var $acw62 = parcelRequire("acw62");
'use client';
const $75b153952a1bd716$export$a49f528ae1a4d0ed = $acw62.createContext(undefined);
const $75b153952a1bd716$export$df6539f760cbfcae = ()=>$acw62.useContext($75b153952a1bd716$export$a49f528ae1a4d0ed);
const $75b153952a1bd716$export$c9b796b52d7458ee = (props)=>{
    return $acw62.createElement($75b153952a1bd716$export$a49f528ae1a4d0ed.Provider, {
        value: props.icons
    }, props.children);
};


const $f790329e2d5b970e$var$createSvgIcon = ({ svg: svg, displayName: displayName })=>{
    const Component = (props)=>{
        var _a;
        const { className: className, style: style = {} } = props;
        const icons = (0, $75b153952a1bd716$export$df6539f760cbfcae)(); // TODO: handle fontFace and styles
        const nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
        const containerProps = props['aria-label'] || props['aria-labelledby'] || props.title ? {
            role: 'img'
        } : {
            ['aria-hidden']: true
        };
        return $acw62.createElement('span', {
            ...containerProps,
            ...nativeProps,
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)($2eb6636429fd94cd$export$e8e78c978b129247, className),
            style: style
        }, ((_a = icons === null || icons === void 0 ? void 0 : icons.icons) === null || _a === void 0 ? void 0 : _a[displayName]) ? icons.icons[displayName] : svg({
            classes: $2eb6636429fd94cd$exports,
            props: props
        }));
    };
    Component.displayName = displayName;
    return Component;
};
var $f790329e2d5b970e$export$2e2bcd8739ae039 = $f790329e2d5b970e$var$createSvgIcon;


const $8216ceb11a955081$var$BlockedSiteIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1314 674l-68-68-286 286-286-286-68 68 286 286-286 286 68 68 286-286 284 284 68-68-284-284 286-286zM960 2045q-119-70-236-149t-224-171-198-196-159-223-105-253T0 768V256q83 0 161-6t152-22 146-45 144-75q85-55 170-81T960 0q51 0 97 6t89 20 86 34 85 48q72 46 144 75t146 45 152 22 161 6v512q0 151-38 285t-105 253-158 223-198 195-224 171-237 150zM128 382v386q0 127 33 244t92 222 138 200 172 178 193 155 204 130q102-59 203-130t194-154 172-178 138-200 91-223 34-244V382q-149-8-285-48t-263-121q-68-44-135-64t-149-21q-81 0-148 20t-136 65q-126 81-262 121t-286 48z"
        })),
    displayName: 'BlockedSiteIcon'
});
var $8216ceb11a955081$export$2e2bcd8739ae039 = $8216ceb11a955081$var$BlockedSiteIcon;


var $acw62 = parcelRequire("acw62");

const $e842457e4b03ee94$var$BlockedSiteSolid12Icon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1877 250v501q0 144-37 274t-103 248-155 221-193 194-219 168-231 143q-116-61-230-138t-219-169-194-197-155-224-103-248T0 751V250q84 0 159-5t147-22 142-44 143-75q42-26 83-45t83-33 87-19 95-7q51 0 96 6t87 20 83 33 83 47q71 45 141 73t142 44 148 21 158 6zm-438 1038l-349-349 351-352-151-150-351 351-352-351-150 150 351 352-351 351 150 151 352-351 349 349 151-151z"
        })),
    displayName: 'BlockedSiteSolid12Icon'
});
var $e842457e4b03ee94$export$2e2bcd8739ae039 = $e842457e4b03ee94$var$BlockedSiteSolid12Icon;


var $acw62 = parcelRequire("acw62");

const $77c0fd305f57675d$var$EndPointSolidIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M256 2048V0h768v1024H384v1024H256zm896-1792h768v1024h-768V256z"
        })),
    displayName: 'EndPointSolidIcon'
});
var $77c0fd305f57675d$export$2e2bcd8739ae039 = $77c0fd305f57675d$var$EndPointSolidIcon;


var $acw62 = parcelRequire("acw62");

const $2b67cb17ed6686c5$var$UnknownSolidIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M960 0q132 0 255 34t229 97 194 150 150 194 97 230 35 255q0 132-34 255t-97 229-150 194-194 150-230 97-255 35q-132 0-255-34t-229-97-194-150-150-194-97-229T0 960q0-132 34-255t97-229 150-194 194-150 229-97T960 0zm64 1408H896v128h128v-128zm8-169q0-37 7-70t36-62q39-39 77-74t68-75 49-85 19-105q0-68-26-127t-70-104-104-71-128-26q-68 0-127 26t-104 70-71 104-26 128h144q0-38 14-71t40-59 58-39 72-15q38 0 71 14t59 40 39 58 15 72q0 41-19 73t-47 61-62 60-61 66-48 81-19 107v64h144v-41z"
        })),
    displayName: 'UnknownSolidIcon'
});
var $2b67cb17ed6686c5$export$2e2bcd8739ae039 = $2b67cb17ed6686c5$var$UnknownSolidIcon;


class $8f851af26927dc75$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * Handler for keyboard controls
     */ #handleKeyboardControls(e) {
        switch(e.code){
            // Click/double-click events
            case 'Enter':
            case 'Space':
                e.preventDefault();
                switch(this.props.squareState.displayState){
                    case (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered:
                        this.props.onClick();
                        break;
                    case (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered:
                        this.props.onDoubleClick();
                        break;
                }
                break;
            // Right-click events
            case 'KeyQ':
                e.preventDefault();
                this.props.onRightClick();
                break;
            // Navigation
            case 'ArrowUp':
            case 'KeyW':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Up);
                break;
            case 'ArrowDown':
            case 'KeyS':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Down);
                break;
            case 'ArrowLeft':
            case 'KeyA':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Left);
                break;
            case 'ArrowRight':
            case 'KeyD':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Right);
                break;
            case 'Home':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Start);
                break;
            case 'End':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).End);
                break;
            case 'PageUp':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Top);
                break;
            case 'PageDown':
                e.preventDefault();
                this.props.onNavigate(e, (0, $c9f4886983da49d0$export$9f46381784b9f7b9).Bottom);
                break;
        }
    }
    render() {
        const { surroundingMines: surroundingMines, displayState: displayState } = this.props.squareState;
        let contents = {
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered]: '',
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered]: String(surroundingMines || ''),
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged]: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77c0fd305f57675d$export$2e2bcd8739ae039), {}),
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe]: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b67cb17ed6686c5$export$2e2bcd8739ae039), {}),
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated]: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e842457e4b03ee94$export$2e2bcd8739ae039), {})
        }[displayState];
        let label = {
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered]: `Node ${this.props.x},${this.props.y} - Powered off`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered]: `Node ${this.props.x},${this.props.y} - ${this.props.squareState.surroundingMines} adjacent threats`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged]: `Node ${this.props.x},${this.props.y} - Flagged for quarantine`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe]: `Node ${this.props.x},${this.props.y} - Maybe quarantine?`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated]: `Node ${this.props.x},${this.props.y} - Compromised`
        }[displayState];
        let className = {
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered]: `covered`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered]: `revealed`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged]: `flagged`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe]: `maybe`,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated]: `detonated`
        }[displayState];
        // If game is not in progress
        if (!this.props.gameAvailable) {
            // Incorrectly flagged squares
            if (displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged && surroundingMines !== -1) {
                label = `Node ${this.props.x},${this.props.y} - Falsely quarantined`;
                className = 'flagged-wrong';
            }
            // Undetonated mines
            if (displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered && surroundingMines === -1) {
                contents = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8216ceb11a955081$export$2e2bcd8739ae039), {});
                label = `Node ${this.props.x},${this.props.y} - Contained a threat`;
                className = 'vulnerable';
            }
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
            className: className || '',
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                ref: (element)=>element && this.props.isFocused && element.focus(),
                type: "button",
                value: surroundingMines,
                title: label,
                "aria-label": label,
                disabled: !this.props.gameAvailable,
                onClick: this.props.gameAvailable && displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered ? this.props.onClick : undefined,
                onDoubleClick: this.props.gameAvailable && displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered ? this.props.onDoubleClick : undefined,
                onContextMenu: this.props.gameAvailable ? this.props.onRightClick : undefined,
                onKeyDown: this.props.gameAvailable ? this.#handleKeyboardControls.bind(this) : undefined,
                tabIndex: surroundingMines === 0 && displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered ? -1 : 0,
                children: contents
            })
        }, this.props.x + ' ' + this.props.y);
    }
}



/**
 * Array sorting function for numbers, in ascending order
 */ const $2626343136bb479c$export$5b66f3fff0c2847f = (a, b)=>a - b;
/**
 * Array sorting function for numbers, in descending order
 */ const $2626343136bb479c$export$3b4d91a489a825f9 = (a, b)=>b - a;


var $c9f4886983da49d0$export$9f46381784b9f7b9 = /*#__PURE__*/ function(NavigationDirection) {
    NavigationDirection[NavigationDirection["Up"] = 0] = "Up";
    NavigationDirection[NavigationDirection["Down"] = 1] = "Down";
    NavigationDirection[NavigationDirection["Left"] = 2] = "Left";
    NavigationDirection[NavigationDirection["Right"] = 3] = "Right";
    NavigationDirection[NavigationDirection["Start"] = 4] = "Start";
    NavigationDirection[NavigationDirection["End"] = 5] = "End";
    NavigationDirection[NavigationDirection["Top"] = 6] = "Top";
    NavigationDirection[NavigationDirection["Bottom"] = 7] = "Bottom";
    return NavigationDirection;
}({});
class $c9f4886983da49d0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * Get a column of the game board
     */ #getColumn(col) {
        return this.props.squares[col];
    }
    /**
     * Get a row of the game board
     */ #getRow(row) {
        return this.props.squares.map((colSquares)=>colSquares[row]);
    }
    /**
     * Handle navigating the game board using a keyboard
     */ #handleKeyboardNavigation(e, col, row, direction) {
        e.preventDefault();
        let targetCol = -1;
        let targetRow = -1;
        const isFocusable = (square)=>!(square.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered && square.surroundingMines === 0);
        const rowOfCurrentColumn = this.#getColumn(col);
        const columnOfCurrentRow = this.#getRow(row);
        const focusableRows = rowOfCurrentColumn.map((row, idx)=>isFocusable(row) ? idx : -1).filter((row)=>row > -1);
        const focusableColumns = columnOfCurrentRow.map((col, idx)=>isFocusable(col) ? idx : -1).filter((col)=>col > -1);
        switch(direction){
            case 0:
                targetRow = focusableRows.sort((0, $2626343136bb479c$export$3b4d91a489a825f9)).find((idx)=>idx < row) ?? row;
                break;
            case 1:
                targetRow = focusableRows.sort((0, $2626343136bb479c$export$5b66f3fff0c2847f)).find((idx)=>idx > row) ?? row;
                break;
            case 2:
                targetCol = focusableColumns.sort((0, $2626343136bb479c$export$3b4d91a489a825f9)).find((idx)=>idx < col) ?? col;
                break;
            case 3:
                targetCol = focusableColumns.sort((0, $2626343136bb479c$export$5b66f3fff0c2847f)).find((idx)=>idx > col) ?? col;
                break;
            case 4:
                targetCol = focusableColumns.shift() ?? col;
                break;
            case 5:
                targetCol = focusableColumns.pop() ?? col;
                break;
            case 6:
                targetRow = focusableRows.shift() ?? row;
                break;
            case 7:
                targetRow = focusableRows.pop() ?? row;
                break;
        }
        if (targetCol === -1) targetCol = col;
        if (targetRow === -1) targetRow = row;
        this.setState({
            activeCol: targetCol,
            activeRow: targetRow
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeCol: null,
            activeRow: null
        };
    }
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("table", {
            onContextMenu: (e)=>e.preventDefault(),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                children: this.props.squares[0].map((_row, y)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                        children: this.props.squares.map((_, x)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f851af26927dc75$export$2e2bcd8739ae039), {
                                x: x,
                                y: y,
                                gameAvailable: this.props.isGameActive,
                                onClick: ()=>this.props.handleSquareClick(x, y),
                                onDoubleClick: ()=>this.props.handleSquareDoubleClick(x, y),
                                onRightClick: ()=>this.props.handleSquareRightClick(x, y),
                                onNavigate: (e, direction)=>this.#handleKeyboardNavigation(e, x, y, direction),
                                squareState: this.props.squares[x][y],
                                isFocused: this.state.activeCol === x && this.state.activeRow === y
                            }, x + ',' + y))
                    }, y))
            })
        });
    }
}




class $353f29edb58ffff4$export$2e2bcd8739ae039 {
    #board;
    #won;
    #lost;
    #level;
    #mines;
    #flagsUsed;
    constructor(){
        this.#board = [];
        this.#won = false;
        this.#lost = false;
        this.paused = false;
        this.#level = (0, $4388d496bdb048be$export$2e2bcd8739ae039).EASY;
        this.#mines = new Set();
        this.#flagsUsed = false;
        this.initialize(this.#level);
    }
    initialize(level) {
        this.#level = level;
        this.#mines = this.#generateMines();
        this.#board = this.#initializeSquaresArray();
        this.#won = false;
        this.#lost = false;
        this.paused = false;
        this.#flagsUsed = false;
    }
    /**
     * Generates a set of mines
     */ #generateMines() {
        const { width: width, height: height } = this.#level;
        const mines = new Set();
        while(mines.size < this.#level.mines){
            let x = Math.floor(Math.random() * Math.floor(width));
            let y = Math.floor(Math.random() * Math.floor(height));
            mines.add(x + ',' + y);
        }
        return mines;
    }
    #initializeSquaresArray() {
        const { width: width, height: height } = this.#level;
        const squares = [];
        for(let i = 0; i < width; ++i){
            squares[i] = [];
            for(let j = 0; j < height; ++j)squares[i][j] = {
                displayState: (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered,
                surroundingMines: this.#computeSurroundingMines(i, j)
            };
        }
        return squares;
    }
    /**
     * Determine the number of surrounding mines for a given square
     */ #computeSurroundingMines(x, y) {
        if (this.#mines.has(x + ',' + y)) return -1;
        const choices = [
            [
                x - 1,
                y - 1
            ],
            [
                x - 1,
                y
            ],
            [
                x - 1,
                y + 1
            ],
            [
                x,
                y - 1
            ],
            [
                x,
                y + 1
            ],
            [
                x + 1,
                y - 1
            ],
            [
                x + 1,
                y
            ],
            [
                x + 1,
                y + 1
            ]
        ];
        const { width: width, height: height } = this.#level;
        return choices.reduce((acc, [v, h])=>{
            const inBounds = v >= 0 && v < width && h >= 0 && h < height;
            return acc + (inBounds ? Number(this.#mines.has(v + ',' + h)) : 0);
        }, 0);
    }
    /**
     * Reveal adjacent squares
     */ #revealAdjacentSquares(squares, x, y) {
        const { width: width, height: height } = this.#level;
        const choices = [
            [
                x - 1,
                y - 1
            ],
            [
                x - 1,
                y
            ],
            [
                x - 1,
                y + 1
            ],
            [
                x,
                y - 1
            ],
            [
                x,
                y + 1
            ],
            [
                x + 1,
                y - 1
            ],
            [
                x + 1,
                y
            ],
            [
                x + 1,
                y + 1
            ]
        ];
        const coveredAdjacentSquares = choices.filter(([v, h])=>{
            const inBounds = v >= 0 && v < width && h >= 0 && h < height;
            return inBounds && squares[v][h].displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered;
        });
        for (const [v, h] of coveredAdjacentSquares){
            squares[v][h].displayState = (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered;
            if (squares[v][h].surroundingMines === 0) this.#revealAdjacentSquares(squares, v, h);
        }
        return squares;
    }
    /**
     * Reveal a square
     */ uncover(x, y) {
        if (this.#board[x][y].displayState !== (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered) return false;
        let newSquares = this.#board.slice();
        const surroundingMines = this.#board[x][y].surroundingMines;
        const newState = surroundingMines === -1 ? (0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated : (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered;
        newSquares[x][y].displayState = newState;
        if (newState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered && surroundingMines === 0) newSquares = this.#revealAdjacentSquares(newSquares, x, y);
        if (surroundingMines === -1) this.#lost = true;
        else {
            const won = this.#board.every((column)=>column.every((s)=>s.displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered || s.surroundingMines === -1));
            if (won) this.#won = true;
        }
        return true;
    }
    /**
     * Toggle a flag on a square
     */ toggleFlag(x, y) {
        const stateTransitions = [
            (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered,
            (0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged,
            (0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe
        ];
        if (!stateTransitions.includes(this.#board[x][y].displayState)) return false;
        let currentSquareStateIdx = stateTransitions.indexOf(this.#board[x][y].displayState);
        let newSquareStateIdx = (currentSquareStateIdx + 1) % stateTransitions.length;
        let newSquareState = stateTransitions[newSquareStateIdx];
        let newSquares = this.#board.slice();
        newSquares[x][y].displayState = newSquareState;
        this.#flagsUsed = true;
        return true;
    }
    /**
     * Uncover adjacent squares of an uncovered square with the appropriate flags
     */ autoUncoverAdjacent(x, y) {
        if (this.#board[x][y].displayState !== (0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered) return false;
        const { width: width, height: height } = this.#level;
        const choices = [
            [
                x - 1,
                y - 1
            ],
            [
                x - 1,
                y
            ],
            [
                x - 1,
                y + 1
            ],
            [
                x,
                y - 1
            ],
            [
                x,
                y + 1
            ],
            [
                x + 1,
                y - 1
            ],
            [
                x + 1,
                y
            ],
            [
                x + 1,
                y + 1
            ]
        ];
        const adjacentSquares = choices.filter(([v, h])=>{
            return v >= 0 && v < width && h >= 0 && h < height;
        });
        const adjacentMaybe = adjacentSquares.filter(([v, h])=>this.#board[v][h].displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe);
        const adjacentFlags = adjacentSquares.filter(([v, h])=>this.#board[v][h].displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged);
        if (adjacentMaybe.length > 0 || adjacentFlags.length !== this.#board[x][y].surroundingMines) return false;
        const adjacentCoveredSquares = adjacentSquares.filter(([v, h])=>this.#board[v][h].displayState === (0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered);
        adjacentCoveredSquares.forEach(([v, h])=>this.uncover(v, h));
        return true;
    }
    get gameState() {
        return {
            level: this.#level,
            board: this.#board,
            lost: this.#lost,
            won: this.#won,
            paused: Boolean(this.paused),
            flagsUsed: this.#flagsUsed
        };
    }
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");
var $c9c2f6e9ef06bed5$export$5afbf446153651d = '__global__';
var $c9c2f6e9ef06bed5$export$ae507c30100600a = '__shadow_dom_stylesheet__';
var $c9c2f6e9ef06bed5$export$d2afb82ff2b52633 = {
    stylesheetKey: $c9c2f6e9ef06bed5$export$5afbf446153651d,
    inShadow: false,
    window: undefined,
    __isShadowConfig__: true
};
var $c9c2f6e9ef06bed5$export$e2bab33b2c30d9 = function(stylesheetKey, inShadow, window) {
    return {
        stylesheetKey: stylesheetKey,
        inShadow: inShadow,
        window: window,
        __isShadowConfig__: true
    };
};
var $c9c2f6e9ef06bed5$export$81e860c23a35a7b8 = function(value) {
    if (!(value && $c9c2f6e9ef06bed5$var$isRecord(value))) return false;
    return value.__isShadowConfig__ === true;
};
function $c9c2f6e9ef06bed5$var$isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}


function $1fbb556661b56077$export$b1c01d3d68dc0b88(sheet) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var classes = [];
    var objects = [];
    var stylesheet = sheet;
    function _processArgs(argsList) {
        for(var _i = 0, argsList_1 = argsList; _i < argsList_1.length; _i++){
            var arg = argsList_1[_i];
            if (arg && !(0, $c9c2f6e9ef06bed5$export$81e860c23a35a7b8)(arg)) {
                if (typeof arg === 'string') {
                    if (arg.indexOf(' ') >= 0) _processArgs(arg.split(' '));
                    else {
                        var translatedArgs = stylesheet.argsFromClassName(arg);
                        if (translatedArgs) _processArgs(translatedArgs);
                        else // Avoid adding the same class twice.
                        if (classes.indexOf(arg) === -1) classes.push(arg);
                    }
                } else if (Array.isArray(arg)) _processArgs(arg);
                else if (typeof arg === 'object') objects.push(arg);
            }
        }
    }
    _processArgs(args);
    return {
        classes: classes,
        objects: objects
    };
}




function $83a2b0773b0b5f26$export$64006deca925fb65(isRTL) {
    if ($83a2b0773b0b5f26$var$_rtl !== isRTL) $83a2b0773b0b5f26$var$_rtl = isRTL;
}
function $83a2b0773b0b5f26$export$b2303637e9533380() {
    if ($83a2b0773b0b5f26$var$_rtl === undefined) $83a2b0773b0b5f26$var$_rtl = // eslint-disable-next-line no-restricted-globals
    typeof document !== 'undefined' && // eslint-disable-next-line no-restricted-globals
    !!document.documentElement && // eslint-disable-next-line no-restricted-globals
    document.documentElement.getAttribute('dir') === 'rtl';
    return $83a2b0773b0b5f26$var$_rtl;
}
// This has been split into 2 lines because it was working in Fabric due to the code being transpiled to es5, so this
// was converted to var while not working in Fluent that uses babel to transpile the code to be es6-like. Splitting the
// logic into two lines, however, allows it to work in both scenarios.
var $83a2b0773b0b5f26$var$_rtl;
$83a2b0773b0b5f26$var$_rtl = $83a2b0773b0b5f26$export$b2303637e9533380();
function $83a2b0773b0b5f26$export$6c4e12d3949051a() {
    return {
        rtl: $83a2b0773b0b5f26$export$b2303637e9533380(),
        shadowConfig: (0, $c9c2f6e9ef06bed5$export$d2afb82ff2b52633)
    };
}




var $09297afe86dd7d0e$export$acb42adc2faed244 = {
    /**
     * Avoids style injection, use getRules() to read the styles.
     */ none: 0,
    /**
     * Inserts rules using the insertRule api.
     */ insertNode: 1,
    /**
     * Appends rules using appendChild.
     */ appendChild: 2
};
var $09297afe86dd7d0e$export$736e27b030c49702 = '__stylesheet__';
/**
 * MSIE 11 doesn't cascade styles based on DOM ordering, but rather on the order that each style node
 * is created. As such, to maintain consistent priority, IE11 should reuse a single style node.
 */ var $09297afe86dd7d0e$var$REUSE_STYLE_NODE = typeof navigator !== 'undefined' && /rv:11.0/.test(navigator.userAgent);
var $09297afe86dd7d0e$var$_global = {};
// Grab window.
try {
    // Why the cast?
    // if compiled/type checked in same program with `@fluentui/font-icons-mdl2` which extends `Window` on global
    // ( check packages/font-icons-mdl2/src/index.ts ) the definitions don't match! Thus the need of this extra assertion
    $09297afe86dd7d0e$var$_global = window || {};
} catch (_a) {
/* leave as blank object */ }
var $09297afe86dd7d0e$var$_stylesheet;
/**
 * Represents the state of styles registered in the page. Abstracts
 * the surface for adding styles to the stylesheet, exposes helpers
 * for reading the styles registered in server rendered scenarios.
 *
 * @public
 */ var $09297afe86dd7d0e$export$cd02bf5de16fbd7c = /** @class */ function() {
    function Stylesheet(config, serializedStylesheet) {
        var _a, _b, _c, _d, _e, _f;
        this._rules = [];
        this._preservedRules = [];
        this._counter = 0;
        this._keyToClassName = {};
        this._onInsertRuleCallbacks = [];
        this._onResetCallbacks = [];
        this._classNameToArgs = {};
        // If there is no document we won't have an element to inject into.
        this._config = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            injectionMode: typeof document === 'undefined' ? $09297afe86dd7d0e$export$acb42adc2faed244.none : $09297afe86dd7d0e$export$acb42adc2faed244.insertNode,
            defaultPrefix: 'css',
            namespace: undefined,
            cspSettings: undefined
        }, config);
        this._classNameToArgs = (_a = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.classNameToArgs) !== null && _a !== void 0 ? _a : this._classNameToArgs;
        this._counter = (_b = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.counter) !== null && _b !== void 0 ? _b : this._counter;
        this._keyToClassName = (_d = (_c = this._config.classNameCache) !== null && _c !== void 0 ? _c : serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.keyToClassName) !== null && _d !== void 0 ? _d : this._keyToClassName;
        this._preservedRules = (_e = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.preservedRules) !== null && _e !== void 0 ? _e : this._preservedRules;
        this._rules = (_f = serializedStylesheet === null || serializedStylesheet === void 0 ? void 0 : serializedStylesheet.rules) !== null && _f !== void 0 ? _f : this._rules;
    }
    /**
     * Gets the singleton instance.
     */ Stylesheet.getInstance = function(shadowConfig) {
        $09297afe86dd7d0e$var$_stylesheet = $09297afe86dd7d0e$var$_global[$09297afe86dd7d0e$export$736e27b030c49702];
        if ($09297afe86dd7d0e$var$_global[0, $c9c2f6e9ef06bed5$export$ae507c30100600a]) return $09297afe86dd7d0e$var$_global[0, $c9c2f6e9ef06bed5$export$ae507c30100600a].getInstance(shadowConfig);
        if (!$09297afe86dd7d0e$var$_stylesheet || $09297afe86dd7d0e$var$_stylesheet._lastStyleElement && $09297afe86dd7d0e$var$_stylesheet._lastStyleElement.ownerDocument !== document) {
            var fabricConfig = ($09297afe86dd7d0e$var$_global === null || $09297afe86dd7d0e$var$_global === void 0 ? void 0 : $09297afe86dd7d0e$var$_global.FabricConfig) || {};
            var stylesheet = new Stylesheet(fabricConfig.mergeStyles, fabricConfig.serializedStylesheet);
            $09297afe86dd7d0e$var$_stylesheet = stylesheet;
            $09297afe86dd7d0e$var$_global[$09297afe86dd7d0e$export$736e27b030c49702] = stylesheet;
        }
        return $09297afe86dd7d0e$var$_stylesheet;
    };
    /**
     * Serializes the Stylesheet instance into a format which allows rehydration on creation.
     * @returns string representation of `ISerializedStylesheet` interface.
     */ Stylesheet.prototype.serialize = function() {
        return JSON.stringify({
            classNameToArgs: this._classNameToArgs,
            counter: this._counter,
            keyToClassName: this._keyToClassName,
            preservedRules: this._preservedRules,
            rules: this._rules
        });
    };
    /**
     * Configures the stylesheet.
     */ Stylesheet.prototype.setConfig = function(config) {
        this._config = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this._config), config);
    };
    /**
     * Configures a reset callback.
     *
     * @param callback - A callback which will be called when the Stylesheet is reset.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onReset = function(callback) {
        var _this = this;
        this._onResetCallbacks.push(callback);
        return function() {
            _this._onResetCallbacks = _this._onResetCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Configures an insert rule callback.
     *
     * @param callback - A callback which will be called when a rule is inserted.
     * @returns function which when called un-registers provided callback.
     */ Stylesheet.prototype.onInsertRule = function(callback) {
        var _this = this;
        this._onInsertRuleCallbacks.push(callback);
        return function() {
            _this._onInsertRuleCallbacks = _this._onInsertRuleCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    /**
     * Generates a unique classname.
     *
     * @param displayName - Optional value to use as a prefix.
     */ Stylesheet.prototype.getClassName = function(displayName) {
        var namespace = this._config.namespace;
        var prefix = displayName || this._config.defaultPrefix;
        return "".concat(namespace ? namespace + '-' : '').concat(prefix, "-").concat(this._counter++);
    };
    /**
     * Used internally to cache information about a class which was
     * registered with the stylesheet.
     */ Stylesheet.prototype.cacheClassName = function(className, key, args, rules) {
        this._keyToClassName[this._getCacheKey(key)] = className;
        this._classNameToArgs[className] = {
            args: args,
            rules: rules
        };
    };
    /**
     * Gets the appropriate classname given a key which was previously
     * registered using cacheClassName.
     */ Stylesheet.prototype.classNameFromKey = function(key) {
        return this._keyToClassName[this._getCacheKey(key)];
    };
    /**
     * Gets all classnames cache with the stylesheet.
     */ Stylesheet.prototype.getClassNameCache = function() {
        return this._keyToClassName;
    };
    /**
     * Gets the arguments associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.argsFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.args;
    };
    /**
     * Gets the rules associated with a given classname which was
     * previously registered using cacheClassName.
     */ Stylesheet.prototype.insertedRulesFromClassName = function(className) {
        var entry = this._classNameToArgs[className];
        return entry && entry.rules;
    };
    /**
     * Inserts a css rule into the stylesheet.
     * @param preserve - Preserves the rule beyond a reset boundary.
     */ Stylesheet.prototype.insertRule = function(rule, preserve, stylesheetKey) {
        if (stylesheetKey === void 0) stylesheetKey = (0, $c9c2f6e9ef06bed5$export$5afbf446153651d);
        var injectionMode = this._config.injectionMode;
        var element = injectionMode !== $09297afe86dd7d0e$export$acb42adc2faed244.none ? this._getStyleElement() : undefined;
        if (preserve) this._preservedRules.push(rule);
        if (element) switch(injectionMode){
            case $09297afe86dd7d0e$export$acb42adc2faed244.insertNode:
                this._insertRuleIntoSheet(element.sheet, rule);
                break;
            case $09297afe86dd7d0e$export$acb42adc2faed244.appendChild:
                element.appendChild(document.createTextNode(rule));
                break;
        }
        else this._rules.push(rule);
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (this._config.onInsertRule) // eslint-disable-next-line @typescript-eslint/no-deprecated
        this._config.onInsertRule(rule);
        this._onInsertRuleCallbacks.forEach(function(callback) {
            return callback({
                key: stylesheetKey,
                sheet: element ? element.sheet : undefined,
                rule: rule
            });
        });
    };
    /**
     * Gets all rules registered with the stylesheet; only valid when
     * using InsertionMode.none.
     */ Stylesheet.prototype.getRules = function(includePreservedRules) {
        return (includePreservedRules ? this._preservedRules.join('') : '') + this._rules.join('');
    };
    /**
     * Resets the internal state of the stylesheet. Only used in server
     * rendered scenarios where we're using InsertionMode.none.
     */ Stylesheet.prototype.reset = function() {
        this._rules = [];
        this._counter = 0;
        this._classNameToArgs = {};
        this._keyToClassName = {};
        this._onResetCallbacks.forEach(function(callback) {
            return callback();
        });
    };
    // Forces the regeneration of incoming styles without totally resetting the stylesheet.
    Stylesheet.prototype.resetKeys = function() {
        this._keyToClassName = {};
    };
    Stylesheet.prototype._createStyleElement = function() {
        var _a;
        var doc = ((_a = this._config.window) === null || _a === void 0 ? void 0 : _a.document) || document;
        var head = doc.head;
        var styleElement = doc.createElement('style');
        var nodeToInsertBefore = null;
        styleElement.setAttribute('data-merge-styles', 'true');
        var cspSettings = this._config.cspSettings;
        if (cspSettings) {
            if (cspSettings.nonce) styleElement.setAttribute('nonce', cspSettings.nonce);
        }
        if (this._lastStyleElement) // If the `nextElementSibling` is null, then the insertBefore will act as a regular append.
        // https://developer.mozilla.org/en-US/docs/Web/API/Node/insertBefore#Syntax
        nodeToInsertBefore = this._lastStyleElement.nextElementSibling;
        else {
            var placeholderStyleTag = this._findPlaceholderStyleTag();
            if (placeholderStyleTag) nodeToInsertBefore = placeholderStyleTag.nextElementSibling;
            else nodeToInsertBefore = head.childNodes[0];
        }
        head.insertBefore(styleElement, head.contains(nodeToInsertBefore) ? nodeToInsertBefore : null);
        this._lastStyleElement = styleElement;
        return styleElement;
    };
    Stylesheet.prototype._insertRuleIntoSheet = function(sheet, rule) {
        if (!sheet) return false;
        try {
            sheet.insertRule(rule, sheet.cssRules.length);
            return true;
        } catch (e) {
        // The browser will throw exceptions on unsupported rules (such as a moz prefix in webkit.)
        // We need to swallow the exceptions for this scenario, otherwise we'd need to filter
        // which could be slower and bulkier.
        }
        return false;
    };
    Stylesheet.prototype._getCacheKey = function(key) {
        return key;
    };
    Stylesheet.prototype._getStyleElement = function() {
        var _this = this;
        if (!this._styleElement) {
            this._styleElement = this._createStyleElement();
            if (!$09297afe86dd7d0e$var$REUSE_STYLE_NODE) {
                // Reset the style element on the next frame.
                var win = this._config.window || window;
                win.requestAnimationFrame(function() {
                    _this._styleElement = undefined;
                });
            }
        }
        return this._styleElement;
    };
    Stylesheet.prototype._findPlaceholderStyleTag = function() {
        var head = document.head;
        if (head) return head.querySelector('style[data-merge-styles]');
        return null;
    };
    return Stylesheet;
}();




var $1297e85c823d0447$var$rules = {};
function $1297e85c823d0447$export$81a4f1c533782259(rulePairs, index) {
    var rule = rulePairs[index];
    if (rule.charAt(0) !== '-') rulePairs[index] = $1297e85c823d0447$var$rules[rule] = $1297e85c823d0447$var$rules[rule] || rule.replace(/([A-Z])/g, '-$1').toLowerCase();
}


var $72c15e38e4ff2eb0$var$_vendorSettings;
function $72c15e38e4ff2eb0$export$80b0e239f56c8c7d() {
    var _a;
    if (!$72c15e38e4ff2eb0$var$_vendorSettings) {
        // eslint-disable-next-line no-restricted-globals
        var doc = typeof document !== 'undefined' ? document : undefined;
        var nav = typeof navigator !== 'undefined' ? navigator : undefined;
        var userAgent = (_a = nav === null || nav === void 0 ? void 0 : nav.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (!doc) $72c15e38e4ff2eb0$var$_vendorSettings = {
            isWebkit: true,
            isMoz: true,
            isOpera: true,
            isMs: true
        };
        else $72c15e38e4ff2eb0$var$_vendorSettings = {
            isWebkit: !!(doc && 'WebkitAppearance' in doc.documentElement.style),
            isMoz: !!(userAgent && userAgent.indexOf('firefox') > -1),
            isOpera: !!(userAgent && userAgent.indexOf('opera') > -1),
            isMs: !!(nav && (/rv:11.0/i.test(nav.userAgent) || /Edge\/\d./i.test(navigator.userAgent)))
        };
    }
    return $72c15e38e4ff2eb0$var$_vendorSettings;
}
function $72c15e38e4ff2eb0$export$9f7e3c53560dab05(vendorSettings) {
    $72c15e38e4ff2eb0$var$_vendorSettings = vendorSettings;
}


var $b359f16d76871ecd$var$autoPrefixNames = {
    'user-select': 1
};
function $b359f16d76871ecd$export$6c6679cd94cc8e5a(rulePairs, index) {
    var vendorSettings = (0, $72c15e38e4ff2eb0$export$80b0e239f56c8c7d)();
    var name = rulePairs[index];
    if ($b359f16d76871ecd$var$autoPrefixNames[name]) {
        var value = rulePairs[index + 1];
        if ($b359f16d76871ecd$var$autoPrefixNames[name]) {
            if (vendorSettings.isWebkit) rulePairs.push('-webkit-' + name, value);
            if (vendorSettings.isMoz) rulePairs.push('-moz-' + name, value);
            if (vendorSettings.isMs) rulePairs.push('-ms-' + name, value);
            if (vendorSettings.isOpera) rulePairs.push('-o-' + name, value);
        }
    }
}


var $4c7513fab2ae30d8$var$NON_PIXEL_NUMBER_PROPS = [
    'column-count',
    'font-weight',
    'flex',
    'flex-grow',
    'flex-shrink',
    'fill-opacity',
    'opacity',
    'order',
    'z-index',
    'zoom'
];
function $4c7513fab2ae30d8$export$4d98e579c8cf34c8(rulePairs, index) {
    var name = rulePairs[index];
    var value = rulePairs[index + 1];
    if (typeof value === 'number') {
        var isNonPixelProp = $4c7513fab2ae30d8$var$NON_PIXEL_NUMBER_PROPS.indexOf(name) > -1;
        var isVariableOrPrefixed = name.indexOf('--') > -1;
        var unit = isNonPixelProp || isVariableOrPrefixed ? '' : 'px';
        rulePairs[index + 1] = "".concat(value).concat(unit);
    }
}


var $63553894ba0df07e$var$_a;
var $63553894ba0df07e$var$LEFT = 'left';
var $63553894ba0df07e$var$RIGHT = 'right';
var $63553894ba0df07e$var$NO_FLIP = '@noflip';
var $63553894ba0df07e$var$NAME_REPLACEMENTS = ($63553894ba0df07e$var$_a = {}, $63553894ba0df07e$var$_a[$63553894ba0df07e$var$LEFT] = $63553894ba0df07e$var$RIGHT, $63553894ba0df07e$var$_a[$63553894ba0df07e$var$RIGHT] = $63553894ba0df07e$var$LEFT, $63553894ba0df07e$var$_a);
var $63553894ba0df07e$var$VALUE_REPLACEMENTS = {
    'w-resize': 'e-resize',
    'sw-resize': 'se-resize',
    'nw-resize': 'ne-resize'
};
function $63553894ba0df07e$export$79e12f79f6fb4537(options, rulePairs, index) {
    if (options.rtl) {
        var name_1 = rulePairs[index];
        if (!name_1) return;
        var value = rulePairs[index + 1];
        if (typeof value === 'string' && value.indexOf($63553894ba0df07e$var$NO_FLIP) >= 0) rulePairs[index + 1] = value.replace(/\s*(?:\/\*\s*)?\@noflip\b(?:\s*\*\/)?\s*?/g, '');
        else if (name_1.indexOf($63553894ba0df07e$var$LEFT) >= 0) rulePairs[index] = name_1.replace($63553894ba0df07e$var$LEFT, $63553894ba0df07e$var$RIGHT);
        else if (name_1.indexOf($63553894ba0df07e$var$RIGHT) >= 0) rulePairs[index] = name_1.replace($63553894ba0df07e$var$RIGHT, $63553894ba0df07e$var$LEFT);
        else if (String(value).indexOf($63553894ba0df07e$var$LEFT) >= 0) rulePairs[index + 1] = value.replace($63553894ba0df07e$var$LEFT, $63553894ba0df07e$var$RIGHT);
        else if (String(value).indexOf($63553894ba0df07e$var$RIGHT) >= 0) rulePairs[index + 1] = value.replace($63553894ba0df07e$var$RIGHT, $63553894ba0df07e$var$LEFT);
        else if ($63553894ba0df07e$var$NAME_REPLACEMENTS[name_1]) rulePairs[index] = $63553894ba0df07e$var$NAME_REPLACEMENTS[name_1];
        else if ($63553894ba0df07e$var$VALUE_REPLACEMENTS[value]) rulePairs[index + 1] = $63553894ba0df07e$var$VALUE_REPLACEMENTS[value];
        else switch(name_1){
            case 'margin':
            case 'padding':
                rulePairs[index + 1] = $63553894ba0df07e$var$flipQuad(value);
                break;
            case 'box-shadow':
                rulePairs[index + 1] = $63553894ba0df07e$var$negateNum(value, 0);
                break;
        }
    }
}
/**
 * Given a string value in a space delimited format (e.g. "1 2 3 4"), negates a particular value.
 */ function $63553894ba0df07e$var$negateNum(value, partIndex) {
    var parts = value.split(' ');
    var numberVal = parseInt(parts[partIndex], 10);
    parts[0] = parts[0].replace(String(numberVal), String(numberVal * -1));
    return parts.join(' ');
}
/**
 * Given a string quad, flips the left and right values.
 */ function $63553894ba0df07e$var$flipQuad(value) {
    if (typeof value === 'string') {
        var parts = value.split(' ');
        if (parts.length === 4) return "".concat(parts[0], " ").concat(parts[3], " ").concat(parts[2], " ").concat(parts[1]);
    }
    return value;
}


/**
 * Split a string into tokens separated by whitespace, except all text within parentheses
 * is treated as a single token (whitespace is ignored within parentheses).
 *
 * Unlike String.split(' '), multiple consecutive space characters are collapsed and
 * removed from the returned array (including leading and trailing spaces).
 *
 * For example:
 * `tokenizeWithParentheses("3px calc(var(--x) / 2) 9px    0 ")`
 *   => `["3px", "calc(var(--x) / 2)", "9px", "0"]`
 *
 * @returns The array of tokens. Returns an empty array if the string was empty or contained only whitespace.
 */ function $52be0e6a60d47477$export$73b82e713dad971(value) {
    var parts = [];
    var partStart = 0;
    var parens = 0;
    for(var i = 0; i < value.length; i++)switch(value[i]){
        case '(':
            parens++;
            break;
        case ')':
            if (parens) parens--;
            break;
        case '\t':
        case ' ':
            if (!parens) {
                // Add the new part if it's not an empty string
                if (i > partStart) parts.push(value.substring(partStart, i));
                partStart = i + 1;
            }
            break;
    }
    // Add the last part
    if (partStart < value.length) parts.push(value.substring(partStart));
    return parts;
}


var $3984cc6e71239662$var$DISPLAY_NAME = 'displayName';
function $3984cc6e71239662$var$getDisplayName(rules) {
    var rootStyle = rules && rules['&'];
    return rootStyle ? rootStyle.displayName : undefined;
}
var $3984cc6e71239662$var$globalSelectorRegExp = /\:global\((.+?)\)/g;
/**
 * Finds comma separated selectors in a :global() e.g. ":global(.class1, .class2, .class3)"
 * and wraps them each in their own global ":global(.class1), :global(.class2), :global(.class3)"
 *
 * @param selectorWithGlobals The selector to process
 * @returns The updated selector
 */ function $3984cc6e71239662$var$expandCommaSeparatedGlobals(selectorWithGlobals) {
    // We the selector does not have a :global() we can shortcut
    if (!$3984cc6e71239662$var$globalSelectorRegExp.test(selectorWithGlobals)) return selectorWithGlobals;
    var replacementInfo = [];
    var findGlobal = /\:global\((.+?)\)/g;
    var match = null;
    // Create a result list for global selectors so we can replace them.
    while(match = findGlobal.exec(selectorWithGlobals))// Only if the found selector is a comma separated list we'll process it.
    if (match[1].indexOf(',') > -1) replacementInfo.push([
        match.index,
        match.index + match[0].length,
        // Wrap each of the found selectors in :global()
        match[1].split(',').map(function(v) {
            return ":global(".concat(v.trim(), ")");
        }).join(', ')
    ]);
    // Replace the found selectors with their wrapped variants in reverse order
    return replacementInfo.reverse().reduce(function(selector, _a) {
        var matchIndex = _a[0], matchEndIndex = _a[1], replacement = _a[2];
        var prefix = selector.slice(0, matchIndex);
        var suffix = selector.slice(matchEndIndex);
        return prefix + replacement + suffix;
    }, selectorWithGlobals);
}
function $3984cc6e71239662$var$isSelector(potentialSelector) {
    return potentialSelector.indexOf(':global(') >= 0 || potentialSelector.indexOf(':') === 0;
}
function $3984cc6e71239662$var$expandSelector(newSelector, currentSelector) {
    if (newSelector.indexOf(':global(') >= 0) return newSelector.replace($3984cc6e71239662$var$globalSelectorRegExp, '$1');
    else if (newSelector.indexOf(':host(') === 0) return newSelector;
    else if (newSelector.indexOf(':') === 0) return currentSelector + newSelector;
    else if (newSelector.indexOf('&') < 0) return currentSelector + ' ' + newSelector;
    return newSelector;
}
function $3984cc6e71239662$var$extractSelector(currentSelector, rules, selector, value, stylesheet) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (selector.indexOf('@') === 0) {
        selector = selector + '{' + currentSelector;
        $3984cc6e71239662$var$extractRules([
            value
        ], rules, selector, stylesheet);
    } else if (selector.indexOf(',') > -1) $3984cc6e71239662$var$expandCommaSeparatedGlobals(selector).split(',').map(function(s) {
        return s.trim();
    }).forEach(function(separatedSelector) {
        return $3984cc6e71239662$var$extractRules([
            value
        ], rules, $3984cc6e71239662$var$expandSelector(separatedSelector, currentSelector), stylesheet);
    });
    else $3984cc6e71239662$var$extractRules([
        value
    ], rules, $3984cc6e71239662$var$expandSelector(selector, currentSelector), stylesheet);
}
function $3984cc6e71239662$var$extractRules(args, rules, currentSelector, stylesheet) {
    if (rules === void 0) rules = {
        __order: []
    };
    if (currentSelector === void 0) currentSelector = '&';
    var currentRules = rules[currentSelector];
    if (!currentRules) {
        currentRules = {};
        rules[currentSelector] = currentRules;
        rules.__order.push(currentSelector);
    }
    for(var _i = 0, args_1 = args; _i < args_1.length; _i++){
        var arg = args_1[_i];
        // If the arg is a string, we need to look up the class map and merge.
        if (typeof arg === 'string') {
            var expandedRules = stylesheet.argsFromClassName(arg);
            if (expandedRules) $3984cc6e71239662$var$extractRules(expandedRules, rules, currentSelector, stylesheet);
        // Else if the arg is an array, we need to recurse in.
        } else if (Array.isArray(arg)) $3984cc6e71239662$var$extractRules(arg, rules, currentSelector, stylesheet);
        else {
            for(var prop in arg)if (arg.hasOwnProperty(prop)) {
                var propValue = arg[prop];
                if (prop === 'selectors') {
                    // every child is a selector.
                    var selectors = arg.selectors;
                    for(var newSelector in selectors)if (selectors.hasOwnProperty(newSelector)) $3984cc6e71239662$var$extractSelector(currentSelector, rules, newSelector, selectors[newSelector], stylesheet);
                } else if (typeof propValue === 'object' || $3984cc6e71239662$var$isSelector(prop)) // prop is a selector.
                {
                    if (propValue !== null && propValue !== undefined) $3984cc6e71239662$var$extractSelector(currentSelector, rules, prop, propValue, stylesheet);
                } else if (propValue !== undefined) {
                    // Else, add the rule to the currentSelector.
                    if (prop === 'margin' || prop === 'padding') $3984cc6e71239662$var$expandQuads(currentRules, prop, propValue);
                    else currentRules[prop] = propValue;
                }
            }
        }
    }
    return rules;
}
function $3984cc6e71239662$var$expandQuads(currentRules, name, value) {
    var parts = typeof value === 'string' ? (0, $52be0e6a60d47477$export$73b82e713dad971)(value) : [
        value
    ];
    if (parts.length === 0) parts.push(value);
    if (parts[parts.length - 1] === '!important') // Remove !important from parts, and append it to each part individually
    parts = parts.slice(0, -1).map(function(p) {
        return p + ' !important';
    });
    currentRules[name + 'Top'] = parts[0];
    currentRules[name + 'Right'] = parts[1] || parts[0];
    currentRules[name + 'Bottom'] = parts[2] || parts[0];
    currentRules[name + 'Left'] = parts[3] || parts[1] || parts[0];
}
function $3984cc6e71239662$var$getKeyForRules(options, rules) {
    var serialized = [
        options.rtl ? 'rtl' : 'ltr'
    ];
    var hasProps = false;
    for(var _i = 0, _a = rules.__order; _i < _a.length; _i++){
        var selector = _a[_i];
        serialized.push(selector);
        var rulesForSelector = rules[selector];
        for(var propName in rulesForSelector)if (rulesForSelector.hasOwnProperty(propName) && rulesForSelector[propName] !== undefined) {
            hasProps = true;
            serialized.push(propName, rulesForSelector[propName]);
        }
    }
    return hasProps ? serialized.join('') : undefined;
}
function $3984cc6e71239662$var$repeatString(target, count) {
    if (count <= 0) return '';
    if (count === 1) return target;
    return target + $3984cc6e71239662$var$repeatString(target, count - 1);
}
function $3984cc6e71239662$export$4080b13ebe249c61(options, ruleEntries) {
    if (!ruleEntries) return '';
    var allEntries = [];
    for(var entry in ruleEntries)if (ruleEntries.hasOwnProperty(entry) && entry !== $3984cc6e71239662$var$DISPLAY_NAME && ruleEntries[entry] !== undefined) allEntries.push(entry, ruleEntries[entry]);
    // Apply transforms.
    for(var i = 0; i < allEntries.length; i += 2){
        (0, $1297e85c823d0447$export$81a4f1c533782259)(allEntries, i);
        (0, $4c7513fab2ae30d8$export$4d98e579c8cf34c8)(allEntries, i);
        (0, $63553894ba0df07e$export$79e12f79f6fb4537)(options, allEntries, i);
        (0, $b359f16d76871ecd$export$6c6679cd94cc8e5a)(allEntries, i);
    }
    // Apply punctuation.
    for(var i = 1; i < allEntries.length; i += 4)allEntries.splice(i, 1, ':', allEntries[i], ';');
    return allEntries.join('');
}
function $3984cc6e71239662$export$f51c5a57f5409a02(options) {
    var _a;
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var stylesheet = (_a = options.stylesheet) !== null && _a !== void 0 ? _a : (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance(options.shadowConfig);
    var rules = $3984cc6e71239662$var$extractRules(args, undefined, undefined, stylesheet);
    var key = $3984cc6e71239662$var$getKeyForRules(options, rules);
    if (key) {
        var registration = {
            className: stylesheet.classNameFromKey(key),
            key: key,
            args: args
        };
        if (!registration.className) {
            registration.className = stylesheet.getClassName($3984cc6e71239662$var$getDisplayName(rules));
            var rulesToInsert = [];
            for(var _b = 0, _c = rules.__order; _b < _c.length; _b++){
                var selector = _c[_b];
                rulesToInsert.push(selector, $3984cc6e71239662$export$4080b13ebe249c61(options, rules[selector]));
            }
            registration.rulesToInsert = rulesToInsert;
        }
        return registration;
    }
    return undefined;
}
function $3984cc6e71239662$export$cf30abcc7f4a413c(registration, specificityMultiplier, shadowConfig, sheet) {
    if (specificityMultiplier === void 0) specificityMultiplier = 1;
    var stylesheet = sheet !== null && sheet !== void 0 ? sheet : (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance(shadowConfig);
    var className = registration.className, key = registration.key, args = registration.args, rulesToInsert = registration.rulesToInsert;
    if (rulesToInsert) {
        // rulesToInsert is an ordered array of selector/rule pairs.
        for(var i = 0; i < rulesToInsert.length; i += 2){
            var rules = rulesToInsert[i + 1];
            if (rules) {
                var selector = rulesToInsert[i];
                selector = selector.replace(/&/g, $3984cc6e71239662$var$repeatString(".".concat(registration.className), specificityMultiplier));
                // Insert. Note if a media query, we must close the query with a final bracket.
                var processedRule = "".concat(selector, "{").concat(rules, "}").concat(selector.indexOf('@') === 0 ? '}' : '');
                stylesheet.insertRule(processedRule);
            }
        }
        stylesheet.cacheClassName(className, key, args, rulesToInsert);
    }
}
function $3984cc6e71239662$export$40e90054d98a04a(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var registration = $3984cc6e71239662$export$f51c5a57f5409a02.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        options
    ], args, false));
    if (registration) {
        $3984cc6e71239662$export$cf30abcc7f4a413c(registration, options.specificityMultiplier, options.shadowConfig, options.stylesheet);
        return registration.className;
    }
    return '';
}


function $aa1d034ba9a4cf1b$export$e618dc39ac9ad607() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $aa1d034ba9a4cf1b$export$f77a3199de250644(args, (0, $83a2b0773b0b5f26$export$6c4e12d3949051a)());
}
function $aa1d034ba9a4cf1b$export$f77a3199de250644(args, options) {
    var styleArgs = args instanceof Array ? args : [
        args
    ];
    var opts = options || {};
    var hasShadowConfig = (0, $c9c2f6e9ef06bed5$export$81e860c23a35a7b8)(styleArgs[0]);
    if (hasShadowConfig) opts.shadowConfig = styleArgs[0];
    opts.stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance(opts.shadowConfig);
    var _a = (0, $1fbb556661b56077$export$b1c01d3d68dc0b88)(opts.stylesheet, styleArgs), classes = _a.classes, objects = _a.objects;
    if (objects.length) classes.push((0, $3984cc6e71239662$export$40e90054d98a04a)(opts, objects));
    return classes.join(' ');
}


function $7bf22b09420ef54a$export$c78c3a64e19cf4fb(styles) {
    var classes = {};
    var _loop_1 = function(styleName) {
        if (styles.hasOwnProperty(styleName)) {
            var className_1;
            Object.defineProperty(classes, styleName, {
                get: function() {
                    if (className_1 === undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    className_1 = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles[styleName]).toString();
                    return className_1;
                },
                enumerable: true,
                configurable: true
            });
        }
    };
    for(var styleName in styles)_loop_1(styleName);
    return classes;
}





function $20f518cc12336d5a$export$d25ddfdf17c3ad3e(timeline) {
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    var rulesArray = [];
    for(var prop in timeline)if (timeline.hasOwnProperty(prop)) rulesArray.push(prop, '{', (0, $3984cc6e71239662$export$4080b13ebe249c61)((0, $83a2b0773b0b5f26$export$6c4e12d3949051a)(), timeline[prop]), '}');
    var rules = rulesArray.join('');
    var className = stylesheet.classNameFromKey(rules);
    if (className) return className;
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@keyframes ".concat(name, "{").concat(rules, "}"), true);
    stylesheet.cacheClassName(name, rules, [], [
        'keyframes',
        rules
    ]);
    return name;
}


/* Register the keyframes */ var $ca17ef8e897e1cc4$var$EASING_FUNCTION_1 = 'cubic-bezier(.1,.9,.2,1)';
var $ca17ef8e897e1cc4$var$EASING_FUNCTION_2 = 'cubic-bezier(.1,.25,.75,.9)';
var $ca17ef8e897e1cc4$var$DURATION_1 = '0.167s';
var $ca17ef8e897e1cc4$var$DURATION_2 = '0.267s';
var $ca17ef8e897e1cc4$var$DURATION_3 = '0.367s';
var $ca17ef8e897e1cc4$var$DURATION_4 = '0.467s';
var $ca17ef8e897e1cc4$var$FADE_IN = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
var $ca17ef8e897e1cc4$var$FADE_OUT = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 1
    },
    to: {
        opacity: 0,
        visibility: 'hidden'
    }
});
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN10 = $ca17ef8e897e1cc4$var$_createSlideInX(-10);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN20 = $ca17ef8e897e1cc4$var$_createSlideInX(-20);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN40 = $ca17ef8e897e1cc4$var$_createSlideInX(-40);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN400 = $ca17ef8e897e1cc4$var$_createSlideInX(-400);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN10 = $ca17ef8e897e1cc4$var$_createSlideInX(10);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN20 = $ca17ef8e897e1cc4$var$_createSlideInX(20);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN40 = $ca17ef8e897e1cc4$var$_createSlideInX(40);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_IN400 = $ca17ef8e897e1cc4$var$_createSlideInX(400);
var $ca17ef8e897e1cc4$var$SLIDE_UP_IN10 = $ca17ef8e897e1cc4$var$_createSlideInY(10);
var $ca17ef8e897e1cc4$var$SLIDE_UP_IN20 = $ca17ef8e897e1cc4$var$_createSlideInY(20);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_IN10 = $ca17ef8e897e1cc4$var$_createSlideInY(-10);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_IN20 = $ca17ef8e897e1cc4$var$_createSlideInY(-20);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutX(10);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutX(20);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT40 = $ca17ef8e897e1cc4$var$_createSlideOutX(40);
var $ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT400 = $ca17ef8e897e1cc4$var$_createSlideOutX(400);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutX(-10);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutX(-20);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT40 = $ca17ef8e897e1cc4$var$_createSlideOutX(-40);
var $ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT400 = $ca17ef8e897e1cc4$var$_createSlideOutX(-400);
var $ca17ef8e897e1cc4$var$SLIDE_UP_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutY(-10);
var $ca17ef8e897e1cc4$var$SLIDE_UP_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutY(-20);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT10 = $ca17ef8e897e1cc4$var$_createSlideOutY(10);
var $ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT20 = $ca17ef8e897e1cc4$var$_createSlideOutY(20);
var $ca17ef8e897e1cc4$var$SCALE_UP100 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'scale3d(.98,.98,1)'
    },
    to: {
        transform: 'scale3d(1,1,1)'
    }
});
var $ca17ef8e897e1cc4$var$SCALE_DOWN98 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'scale3d(1,1,1)'
    },
    to: {
        transform: 'scale3d(.98,.98,1)'
    }
});
var $ca17ef8e897e1cc4$var$SCALE_DOWN100 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'scale3d(1.03,1.03,1)'
    },
    to: {
        transform: 'scale3d(1,1,1)'
    }
});
var $ca17ef8e897e1cc4$var$SCALE_UP103 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'scale3d(1,1,1)'
    },
    to: {
        transform: 'scale3d(1.03,1.03,1)'
    }
});
var $ca17ef8e897e1cc4$var$ROTATE90 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'rotateZ(0deg)'
    },
    to: {
        transform: 'rotateZ(90deg)'
    }
});
var $ca17ef8e897e1cc4$var$ROTATE_N90 = (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'rotateZ(0deg)'
    },
    to: {
        transform: 'rotateZ(-90deg)'
    }
});
var $ca17ef8e897e1cc4$export$8b2661a06dc8473f = {
    easeFunction1: $ca17ef8e897e1cc4$var$EASING_FUNCTION_1,
    easeFunction2: $ca17ef8e897e1cc4$var$EASING_FUNCTION_2,
    durationValue1: $ca17ef8e897e1cc4$var$DURATION_1,
    durationValue2: $ca17ef8e897e1cc4$var$DURATION_2,
    durationValue3: $ca17ef8e897e1cc4$var$DURATION_3,
    durationValue4: $ca17ef8e897e1cc4$var$DURATION_4
};
var $ca17ef8e897e1cc4$export$30948f134ffb9e45 = {
    slideRightIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightIn40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightIn400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_IN400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftIn400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_IN400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownIn10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_IN10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownIn20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_IN20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideRightOut400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_RIGHT_OUT400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut40: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT40), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideLeftOut400: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_LEFT_OUT400), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideUpOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_UP_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownOut10: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT10), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    slideDownOut20: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SLIDE_DOWN_OUT20), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    scaleUpIn100: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SCALE_UP100), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    scaleDownIn100: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_IN, ",").concat($ca17ef8e897e1cc4$var$SCALE_DOWN100), $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_1),
    scaleUpOut103: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SCALE_UP103), $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    scaleDownOut98: $ca17ef8e897e1cc4$var$_createAnimation("".concat($ca17ef8e897e1cc4$var$FADE_OUT, ",").concat($ca17ef8e897e1cc4$var$SCALE_DOWN98), $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn100: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn200: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_2, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn400: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeIn500: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_IN, $ca17ef8e897e1cc4$var$DURATION_4, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut100: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_1, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut200: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_2, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut400: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_3, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    fadeOut500: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$FADE_OUT, $ca17ef8e897e1cc4$var$DURATION_4, $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    rotate90deg: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$ROTATE90, '0.1s', $ca17ef8e897e1cc4$var$EASING_FUNCTION_2),
    rotateN90deg: $ca17ef8e897e1cc4$var$_createAnimation($ca17ef8e897e1cc4$var$ROTATE_N90, '0.1s', $ca17ef8e897e1cc4$var$EASING_FUNCTION_2)
};
function $ca17ef8e897e1cc4$var$_createAnimation(animationName, animationDuration, animationTimingFunction) {
    return {
        animationName: animationName,
        animationDuration: animationDuration,
        animationTimingFunction: animationTimingFunction,
        animationFillMode: 'both'
    };
}
function $ca17ef8e897e1cc4$var$_createSlideInX(fromX) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(".concat(fromX, "px,0,0)"),
            pointerEvents: 'none'
        },
        to: {
            transform: "translate3d(0,0,0)",
            pointerEvents: 'auto'
        }
    });
}
function $ca17ef8e897e1cc4$var$_createSlideInY(fromY) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(0,".concat(fromY, "px,0)"),
            pointerEvents: 'none'
        },
        to: {
            transform: "translate3d(0,0,0)",
            pointerEvents: 'auto'
        }
    });
}
function $ca17ef8e897e1cc4$var$_createSlideOutX(toX) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(0,0,0)"
        },
        to: {
            transform: "translate3d(".concat(toX, "px,0,0)")
        }
    });
}
function $ca17ef8e897e1cc4$var$_createSlideOutY(toY) {
    return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)({
        from: {
            transform: "translate3d(0,0,0)"
        },
        to: {
            transform: "translate3d(0,".concat(toY, "px,0)")
        }
    });
}


var $e2629e8d47c94809$export$a386448ab9904275 = (0, $7bf22b09420ef54a$export$c78c3a64e19cf4fb)((0, $ca17ef8e897e1cc4$export$30948f134ffb9e45));


var $905fed6f1ccd845a$export$77a09a3b0466bd17 = '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)';
var $905fed6f1ccd845a$export$f57e8a065222a88e = // eslint-disable-next-line @fluentui/max-len
'@media screen and (-ms-high-contrast: black-on-white), screen and (forced-colors: active) and (prefers-color-scheme: light)';
var $905fed6f1ccd845a$export$46e50d23541200fa = // eslint-disable-next-line @fluentui/max-len
'@media screen and (-ms-high-contrast: white-on-black), screen and (forced-colors: active) and (prefers-color-scheme: dark)';
var $905fed6f1ccd845a$export$e795cfe26983ca2b = '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)';
var $905fed6f1ccd845a$export$a91d390a6282498 = 320;
var $905fed6f1ccd845a$export$2a2cf3a4e575f28 = 480;
var $905fed6f1ccd845a$export$3b8f430e18451172 = 640;
var $905fed6f1ccd845a$export$8063c2544c1fd1ee = 1024;
var $905fed6f1ccd845a$export$21a5264b301ff8d4 = 1366;
var $905fed6f1ccd845a$export$9d47a7778008a6dd = 1920;
var $905fed6f1ccd845a$export$b7949b403ba42a41 = $905fed6f1ccd845a$export$2a2cf3a4e575f28 - 1;
var $905fed6f1ccd845a$export$af97800cf211974a = $905fed6f1ccd845a$export$3b8f430e18451172 - 1;
var $905fed6f1ccd845a$export$9d555ccb57f8acb0 = $905fed6f1ccd845a$export$8063c2544c1fd1ee - 1;
var $905fed6f1ccd845a$export$eb3f4d948789a51d = $905fed6f1ccd845a$export$21a5264b301ff8d4 - 1;
var $905fed6f1ccd845a$export$cb61294b6ad9e14c = $905fed6f1ccd845a$export$9d47a7778008a6dd - 1;
var $905fed6f1ccd845a$export$db6df1a0c5d780ca = 768;
function $905fed6f1ccd845a$export$be136f2e7621e736(min, max) {
    var minSelector = typeof min === 'number' ? " and (min-width: ".concat(min, "px)") : '';
    var maxSelector = typeof max === 'number' ? " and (max-width: ".concat(max, "px)") : '';
    return "@media only screen".concat(minSelector).concat(maxSelector);
}
function $905fed6f1ccd845a$export$ea44bc327145cc4d() {
    return {
        forcedColorAdjust: 'none',
        MsHighContrastAdjust: 'none'
    };
}
function $905fed6f1ccd845a$export$85ad7d67343aaedb() {
    var _a;
    return _a = {}, // eslint-disable-next-line @typescript-eslint/no-deprecated
    _a[$905fed6f1ccd845a$export$e795cfe26983ca2b] = {
        forcedColorAdjust: 'none',
        MsHighContrastAdjust: 'none'
    }, _a;
}


/**
 * Verifies if an application can use DOM.
 */ function $18aa0efffa2a3752$export$71594e8a50f746f4() {
    return(// eslint-disable-next-line no-restricted-globals
    typeof window !== 'undefined' && !!// eslint-disable-next-line no-restricted-globals, @typescript-eslint/no-deprecated
    (window.document && window.document.createElement));
}


var $1e1f791b4ec4e821$var$_window = undefined;
// Note: Accessing "window" in IE11 is somewhat expensive, and calling "typeof window"
// hits a memory leak, whereas aliasing it and calling "typeof _window" does not.
// Caching the window value at the file scope lets us minimize the impact.
try {
    // eslint-disable-next-line no-restricted-globals
    $1e1f791b4ec4e821$var$_window = window;
} catch (e) {
/* no-op */ }
function $1e1f791b4ec4e821$export$38b2d434cce3ea22(rootElement) {
    if (!(0, $18aa0efffa2a3752$export$71594e8a50f746f4)() || typeof $1e1f791b4ec4e821$var$_window === 'undefined') return undefined;
    else {
        var el = rootElement;
        return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : $1e1f791b4ec4e821$var$_window;
    }
}


var $68e6902efa21380a$export$d4b0d4f3148ab6bf = 'ms-Fabric--isFocusVisible';
var $68e6902efa21380a$export$e9dc2f0a678c0693 = 'ms-Fabric--isFocusHidden';
function $68e6902efa21380a$var$updateClassList(el, enabled) {
    if (el) {
        el.classList.add(enabled ? $68e6902efa21380a$export$d4b0d4f3148ab6bf : $68e6902efa21380a$export$e9dc2f0a678c0693);
        el.classList.remove(enabled ? $68e6902efa21380a$export$e9dc2f0a678c0693 : $68e6902efa21380a$export$d4b0d4f3148ab6bf);
    }
}
function $68e6902efa21380a$export$760b5674477e9343(enabled, target, registeredProviders) {
    var _a;
    if (registeredProviders) registeredProviders.forEach(function(ref) {
        return $68e6902efa21380a$var$updateClassList(ref.current, enabled);
    });
    else $68e6902efa21380a$var$updateClassList((_a = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(target)) === null || _a === void 0 ? void 0 : _a.document.body, enabled);
}


var $e718b14ff8496161$export$ee30d3e11c8625f1;
(function(ZIndexes) {
    ZIndexes.Nav = 1;
    /**
     * @deprecated Do not use
     */ ZIndexes.ScrollablePane = 1;
    ZIndexes.FocusStyle = 1;
    ZIndexes.Coachmark = 1000;
    ZIndexes.Layer = 1000000;
    ZIndexes.KeytipLayer = 1000001;
})($e718b14ff8496161$export$ee30d3e11c8625f1 || ($e718b14ff8496161$export$ee30d3e11c8625f1 = {}));


function $3c8eab4e1d179dea$export$58062d1b35a0b5bd(theme, insetOrOptions, position, highContrastStyle, borderColor, outlineColor, isFocusedOnly, borderRadius) {
    if (typeof insetOrOptions === 'number' || !insetOrOptions) return $3c8eab4e1d179dea$var$_getFocusStyleInternal(theme, {
        inset: insetOrOptions,
        position: position,
        highContrastStyle: highContrastStyle,
        borderColor: borderColor,
        outlineColor: outlineColor,
        isFocusedOnly: isFocusedOnly,
        borderRadius: borderRadius
    });
    else return $3c8eab4e1d179dea$var$_getFocusStyleInternal(theme, insetOrOptions);
}
function $3c8eab4e1d179dea$var$_getFocusStyleInternal(theme, options) {
    var _a, _b;
    if (options === void 0) options = {};
    var borderRadius = options.borderRadius, _c = options.inset, inset = _c === void 0 ? 0 : _c, _d = options.width, width = _d === void 0 ? 1 : _d, _e = options.position, position = _e === void 0 ? 'relative' : _e, highContrastStyle = options.highContrastStyle, _f = options.borderColor, borderColor = _f === void 0 ? theme.palette.white : _f, _g = options.outlineColor, outlineColor = _g === void 0 ? theme.palette.neutralSecondary : _g, _h = options.isFocusedOnly, isFocusedOnly = _h === void 0 ? true : _h, pointerEvents = options.pointerEvents;
    return {
        // Clear browser-specific focus styles and use 'transparent' as placeholder for focus style.
        outline: 'transparent',
        // Requirement because pseudo-element is absolutely positioned.
        position: position,
        selectors: (_a = {
            // Clear the focus border in Firefox.
            // Reference: http://stackoverflow.com/a/199319/1436671
            '::-moz-focus-inner': {
                border: '0'
            }
        }, // When the element that uses this mixin is in a :focus state, add a pseudo-element to
        // create a border.
        _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &").concat(isFocusedOnly ? ':focus' : '', ":after, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &").concat(isFocusedOnly ? ':focus' : '', ":after")] = {
            content: '""',
            position: 'absolute',
            pointerEvents: pointerEvents,
            left: inset + 1,
            top: inset + 1,
            bottom: inset + 1,
            right: inset + 1,
            border: "".concat(width, "px solid ").concat(borderColor),
            outline: "".concat(width, "px solid ").concat(outlineColor),
            zIndex: (0, $e718b14ff8496161$export$ee30d3e11c8625f1).FocusStyle,
            borderRadius: borderRadius,
            selectors: (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = highContrastStyle, _b)
        }, _a)
    };
}
function $3c8eab4e1d179dea$export$47933a1040be8871() {
    return {
        selectors: {
            '&::-moz-focus-inner': {
                // Clear the focus border in Firefox. Reference: http://stackoverflow.com/a/199319/1436671
                border: 0
            },
            '&': {
                // Clear browser specific focus styles and use transparent as placeholder for focus style
                outline: 'transparent'
            }
        }
    };
}
function $3c8eab4e1d179dea$export$e336755c5511e49c(theme, inset, width, color) {
    var _a;
    if (inset === void 0) inset = 0;
    if (width === void 0) width = 1;
    return {
        selectors: (_a = {}, _a[":global(".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus")] = {
            outline: "".concat(width, " solid ").concat(color || theme.palette.neutralSecondary),
            outlineOffset: "".concat(-inset, "px")
        }, _a)
    };
}
var $3c8eab4e1d179dea$export$47ad9ea05ccc047b = function(borderColor, borderRadius, borderType, borderPosition) {
    var _a, _b, _c;
    if (borderType === void 0) borderType = 'border';
    if (borderPosition === void 0) borderPosition = -1;
    var isBorderBottom = borderType === 'borderBottom';
    return {
        borderColor: borderColor,
        selectors: {
            ':after': (_a = {
                pointerEvents: 'none',
                content: "''",
                position: 'absolute',
                left: isBorderBottom ? 0 : borderPosition,
                top: borderPosition,
                bottom: borderPosition,
                right: isBorderBottom ? 0 : borderPosition
            }, _a[borderType] = "2px solid ".concat(borderColor), _a.borderRadius = borderRadius, _a.width = borderType === 'borderBottom' ? '100%' : undefined, _a.selectors = (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (_c = {}, _c[borderType === 'border' ? 'borderColor' : 'borderBottomColor'] = 'Highlight', _c), _b), _a)
        }
    };
};

// Font face names to be registered.
var $1ba480b26914dcf0$export$ed6682c3a2de350f;
(function(LocalizedFontNames) {
    LocalizedFontNames.Arabic = 'Segoe UI Web (Arabic)';
    LocalizedFontNames.Cyrillic = 'Segoe UI Web (Cyrillic)';
    LocalizedFontNames.EastEuropean = 'Segoe UI Web (East European)';
    LocalizedFontNames.Greek = 'Segoe UI Web (Greek)';
    LocalizedFontNames.Hebrew = 'Segoe UI Web (Hebrew)';
    LocalizedFontNames.Thai = 'Leelawadee UI Web';
    LocalizedFontNames.Vietnamese = 'Segoe UI Web (Vietnamese)';
    LocalizedFontNames.WestEuropean = 'Segoe UI Web (West European)';
    LocalizedFontNames.Selawik = 'Selawik Web';
    LocalizedFontNames.Armenian = 'Segoe UI Web (Armenian)';
    LocalizedFontNames.Georgian = 'Segoe UI Web (Georgian)';
})($1ba480b26914dcf0$export$ed6682c3a2de350f || ($1ba480b26914dcf0$export$ed6682c3a2de350f = {}));
var $1ba480b26914dcf0$export$a84f0633d5188de4;
(function(LocalizedFontFamilies) {
    LocalizedFontFamilies.Arabic = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Arabic, "'");
    LocalizedFontFamilies.ChineseSimplified = "'Microsoft Yahei UI', Verdana, Simsun";
    LocalizedFontFamilies.ChineseTraditional = "'Microsoft Jhenghei UI', Pmingliu";
    LocalizedFontFamilies.Cyrillic = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Cyrillic, "'");
    LocalizedFontFamilies.EastEuropean = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.EastEuropean, "'");
    LocalizedFontFamilies.Greek = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Greek, "'");
    LocalizedFontFamilies.Hebrew = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Hebrew, "'");
    LocalizedFontFamilies.Hindi = "'Nirmala UI'";
    LocalizedFontFamilies.Japanese = "'Yu Gothic UI', 'Meiryo UI', Meiryo, 'MS Pgothic', Osaka";
    LocalizedFontFamilies.Korean = "'Malgun Gothic', Gulim";
    LocalizedFontFamilies.Selawik = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Selawik, "'");
    LocalizedFontFamilies.Thai = "'Leelawadee UI Web', 'Kmer UI'";
    LocalizedFontFamilies.Vietnamese = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Vietnamese, "'");
    LocalizedFontFamilies.WestEuropean = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.WestEuropean, "'");
    LocalizedFontFamilies.Armenian = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Armenian, "'");
    LocalizedFontFamilies.Georgian = "'".concat($1ba480b26914dcf0$export$ed6682c3a2de350f.Georgian, "'");
})($1ba480b26914dcf0$export$a84f0633d5188de4 || ($1ba480b26914dcf0$export$a84f0633d5188de4 = {}));
var $1ba480b26914dcf0$export$f2bd2ec6ef52693e;
(function(FontSizes) {
    FontSizes.size10 = '10px';
    FontSizes.size12 = '12px';
    FontSizes.size14 = '14px';
    FontSizes.size16 = '16px';
    FontSizes.size18 = '18px';
    FontSizes.size20 = '20px';
    FontSizes.size24 = '24px';
    FontSizes.size28 = '28px';
    FontSizes.size32 = '32px';
    FontSizes.size42 = '42px';
    FontSizes.size68 = '68px';
    FontSizes.mini = '10px';
    FontSizes.xSmall = '10px';
    FontSizes.small = '12px';
    FontSizes.smallPlus = '12px';
    FontSizes.medium = '14px';
    FontSizes.mediumPlus = '16px';
    FontSizes.icon = '16px';
    FontSizes.large = '18px';
    FontSizes.xLarge = '20px';
    FontSizes.xLargePlus = '24px';
    FontSizes.xxLarge = '28px';
    FontSizes.xxLargePlus = '32px';
    FontSizes.superLarge = '42px';
    FontSizes.mega = '68px';
})($1ba480b26914dcf0$export$f2bd2ec6ef52693e || ($1ba480b26914dcf0$export$f2bd2ec6ef52693e = {}));
var $1ba480b26914dcf0$export$32743b01f42d159e;
(function(FontWeights) {
    FontWeights.light = 100;
    FontWeights.semilight = 300;
    FontWeights.regular = 400;
    FontWeights.semibold = 600;
    FontWeights.bold = 700;
})($1ba480b26914dcf0$export$32743b01f42d159e || ($1ba480b26914dcf0$export$32743b01f42d159e = {}));
var $1ba480b26914dcf0$export$7f8918a48f5782fd;
(function(IconFontSizes) {
    IconFontSizes.xSmall = '10px';
    IconFontSizes.small = '12px';
    IconFontSizes.medium = '16px';
    IconFontSizes.large = '20px';
})($1ba480b26914dcf0$export$7f8918a48f5782fd || ($1ba480b26914dcf0$export$7f8918a48f5782fd = {}));



var $ccf88a0d18e38068$var$_initializedStylesheetResets = false;
var $ccf88a0d18e38068$var$_resetCounter = 0;
var $ccf88a0d18e38068$var$_emptyObject = {
    empty: true
};
var $ccf88a0d18e38068$var$_dictionary = {};
var $ccf88a0d18e38068$var$_weakMap = typeof WeakMap === 'undefined' ? null : WeakMap;
function $ccf88a0d18e38068$export$c05f7913c3736a3a(weakMap) {
    $ccf88a0d18e38068$var$_weakMap = weakMap;
}
function $ccf88a0d18e38068$export$73eecc6b962b0486() {
    $ccf88a0d18e38068$var$_resetCounter++;
}
function $ccf88a0d18e38068$export$fc10aeed3a532e2a(_target, _key, descriptor) {
    // We bind to "null" to prevent people from inadvertently pulling values from "this",
    // rather than passing them in as input values which can be memoized.
    var fn = $ccf88a0d18e38068$export$c008d290adbd8ce5(descriptor.value && descriptor.value.bind(null));
    return {
        configurable: true,
        get: function() {
            return fn;
        }
    };
}
function $ccf88a0d18e38068$export$c008d290adbd8ce5(cb, maxCacheSize, ignoreNullOrUndefinedResult) {
    if (maxCacheSize === void 0) maxCacheSize = 100;
    if (ignoreNullOrUndefinedResult === void 0) ignoreNullOrUndefinedResult = false;
    // Avoid breaking scenarios which don't have weak map.
    if (!$ccf88a0d18e38068$var$_weakMap) return cb;
    if (!$ccf88a0d18e38068$var$_initializedStylesheetResets) {
        var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
        if (stylesheet && stylesheet.onReset) (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance().onReset($ccf88a0d18e38068$export$73eecc6b962b0486);
        $ccf88a0d18e38068$var$_initializedStylesheetResets = true;
    }
    var rootNode;
    var cacheSize = 0;
    var localResetCounter = $ccf88a0d18e38068$var$_resetCounter;
    return function memoizedFunction() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var currentNode = rootNode;
        if (rootNode === undefined || localResetCounter !== $ccf88a0d18e38068$var$_resetCounter || maxCacheSize > 0 && cacheSize > maxCacheSize) {
            rootNode = $ccf88a0d18e38068$var$_createNode();
            cacheSize = 0;
            localResetCounter = $ccf88a0d18e38068$var$_resetCounter;
        }
        currentNode = rootNode;
        // Traverse the tree until we find the match.
        for(var i = 0; i < args.length; i++){
            var arg = $ccf88a0d18e38068$var$_normalizeArg(args[i]);
            if (!currentNode.map.has(arg)) currentNode.map.set(arg, $ccf88a0d18e38068$var$_createNode());
            currentNode = currentNode.map.get(arg);
        }
        if (!currentNode.hasOwnProperty('value')) {
            currentNode.value = cb.apply(void 0, args);
            cacheSize++;
        }
        if (ignoreNullOrUndefinedResult && (currentNode.value === null || currentNode.value === undefined)) currentNode.value = cb.apply(void 0, args);
        return currentNode.value;
    };
}
function $ccf88a0d18e38068$export$99061b04f99342f(getValue) {
    if (!$ccf88a0d18e38068$var$_weakMap) // Without a `WeakMap` implementation, memoization is not possible.
    return getValue;
    var cache = new $ccf88a0d18e38068$var$_weakMap();
    function memoizedGetValue(input) {
        if (!input || typeof input !== 'function' && typeof input !== 'object') // A WeakMap can only be used to test against reference values, i.e. 'function' and 'object'.
        // All other inputs cannot be memoized against in this manner.
        return getValue(input);
        if (cache.has(input)) return cache.get(input);
        var value = getValue(input);
        cache.set(input, value);
        return value;
    }
    return memoizedGetValue;
}
function $ccf88a0d18e38068$var$_normalizeArg(val) {
    if (!val) return $ccf88a0d18e38068$var$_emptyObject;
    else if (typeof val === 'object' || typeof val === 'function') return val;
    else if (!$ccf88a0d18e38068$var$_dictionary[val]) $ccf88a0d18e38068$var$_dictionary[val] = {
        val: val
    };
    return $ccf88a0d18e38068$var$_dictionary[val];
}
function $ccf88a0d18e38068$var$_createNode() {
    return {
        map: $ccf88a0d18e38068$var$_weakMap ? new $ccf88a0d18e38068$var$_weakMap() : null
    };
}


/**
 * Internal memoized function which simply takes in the class map and the
 * disable boolean. These immutable values can be memoized.
 */ var $82e4fc67b7d16117$var$_getGlobalClassNames = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(classNames, disableGlobalClassNames) {
    var styleSheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    if (disableGlobalClassNames) // disable global classnames
    return Object.keys(classNames).reduce(function(acc, className) {
        acc[className] = styleSheet.getClassName(classNames[className]);
        return acc;
    }, {});
    // use global classnames
    return classNames;
});
function $82e4fc67b7d16117$export$e14385d8f1853921(classNames, theme, disableGlobalClassNames) {
    return $82e4fc67b7d16117$var$_getGlobalClassNames(classNames, disableGlobalClassNames !== undefined ? disableGlobalClassNames : theme.disableGlobalClassNames);
}




/**
 * Storing global state in local module variables has issues when more than one copy
 * if the module gets loaded on the page (due to a bundling error or simply by consuming
 * a prebundled script.)
 *
 * This file contains helpers to deal with the getting and setting local state, and allows
 * callers to get called back when it mutates.
 */ var $2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME = '__globalSettings__';
var $2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME = '__callbacks__';
var $2a6b20086a42f1ef$var$_counter = 0;
/**
 * Global settings helper, which stores settings in the global (window) namespace.
 * If window is not provided, it will store settings in module scope. Provides a
 * way to observe changes as well when their values change.
 *
 * @public
 * {@docCategory GlobalSettings}
 */ var $2a6b20086a42f1ef$export$e962ef7984a884aa = /** @class */ function() {
    function GlobalSettings() {}
    GlobalSettings.getValue = function(key, defaultValue) {
        var globalSettings = $2a6b20086a42f1ef$var$_getGlobalSettings();
        if (globalSettings[key] === undefined) globalSettings[key] = typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        return globalSettings[key];
    };
    GlobalSettings.setValue = function(key, value) {
        var globalSettings = $2a6b20086a42f1ef$var$_getGlobalSettings();
        var callbacks = globalSettings[$2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME];
        var oldValue = globalSettings[key];
        if (value !== oldValue) {
            globalSettings[key] = value;
            var changeDescription = {
                oldValue: oldValue,
                value: value,
                key: key
            };
            for(var id in callbacks)if (callbacks.hasOwnProperty(id)) callbacks[id](changeDescription);
        }
        return value;
    };
    GlobalSettings.addChangeListener = function(cb) {
        // Note: we use generated ids on the callbacks to create a map of the callbacks, which optimizes removal.
        // (It's faster to delete a key than it is to look up the index of an object and splice an array.)
        var id = cb.__id__;
        var callbacks = $2a6b20086a42f1ef$var$_getCallbacks();
        if (!id) id = cb.__id__ = String($2a6b20086a42f1ef$var$_counter++);
        callbacks[id] = cb;
    };
    GlobalSettings.removeChangeListener = function(cb) {
        var callbacks = $2a6b20086a42f1ef$var$_getCallbacks();
        delete callbacks[cb.__id__];
    };
    return GlobalSettings;
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2a6b20086a42f1ef$var$_getGlobalSettings() {
    var _a;
    var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObj = win || {};
    if (!globalObj[$2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME]) globalObj[$2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME] = (_a = {}, _a[$2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME] = {}, _a);
    return globalObj[$2a6b20086a42f1ef$var$GLOBAL_SETTINGS_PROP_NAME];
}
function $2a6b20086a42f1ef$var$_getCallbacks() {
    var globalSettings = $2a6b20086a42f1ef$var$_getGlobalSettings();
    return globalSettings[$2a6b20086a42f1ef$var$CALLBACK_STATE_PROP_NAME];
}


var $dae4fc66435db4e1$var$CustomizationsGlobalKey = 'customizations';
var $dae4fc66435db4e1$var$NO_CUSTOMIZATIONS = {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
};
var $dae4fc66435db4e1$var$_allSettings = (0, $2a6b20086a42f1ef$export$e962ef7984a884aa).getValue($dae4fc66435db4e1$var$CustomizationsGlobalKey, {
    settings: {},
    scopedSettings: {},
    inCustomizerContext: false
});
var $dae4fc66435db4e1$var$_events = [];
var $dae4fc66435db4e1$export$cbb5b5586292cdb = /** @class */ function() {
    function Customizations() {}
    Customizations.reset = function() {
        $dae4fc66435db4e1$var$_allSettings.settings = {};
        $dae4fc66435db4e1$var$_allSettings.scopedSettings = {};
    };
    /** Apply global Customization settings.
     * @example Customizations.applySettings(\{ theme: \{...\} \});
     */ Customizations.applySettings = function(settings) {
        $dae4fc66435db4e1$var$_allSettings.settings = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $dae4fc66435db4e1$var$_allSettings.settings), settings);
        Customizations._raiseChange();
    };
    /** Apply Customizations to a particular named scope, like a component.
     * @example Customizations.applyScopedSettings('Nav', \{ styles: () =\> \{\} \});
     */ Customizations.applyScopedSettings = function(scopeName, settings) {
        $dae4fc66435db4e1$var$_allSettings.scopedSettings[scopeName] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $dae4fc66435db4e1$var$_allSettings.scopedSettings[scopeName]), settings);
        Customizations._raiseChange();
    };
    Customizations.getSettings = function(properties, scopeName, localSettings) {
        if (localSettings === void 0) localSettings = $dae4fc66435db4e1$var$NO_CUSTOMIZATIONS;
        var settings = {};
        var localScopedSettings = scopeName && localSettings.scopedSettings[scopeName] || {};
        var globalScopedSettings = scopeName && $dae4fc66435db4e1$var$_allSettings.scopedSettings[scopeName] || {};
        for(var _i = 0, properties_1 = properties; _i < properties_1.length; _i++){
            var property = properties_1[_i];
            settings[property] = localScopedSettings[property] || localSettings.settings[property] || globalScopedSettings[property] || $dae4fc66435db4e1$var$_allSettings.settings[property];
        }
        return settings;
    };
    /** Used to run some code that sets Customizations without triggering an update until the end.
     * Useful for applying Customizations that don't affect anything currently rendered, or for
     * applying many customizations at once.
     * @param suppressUpdate - Do not raise the change event at the end, preventing all updates
     */ Customizations.applyBatchedUpdates = function(code, suppressUpdate) {
        Customizations._suppressUpdates = true;
        try {
            code();
        } catch (_a) {
        /* do nothing */ }
        Customizations._suppressUpdates = false;
        if (!suppressUpdate) Customizations._raiseChange();
    };
    Customizations.observe = function(onChange) {
        $dae4fc66435db4e1$var$_events.push(onChange);
    };
    Customizations.unobserve = function(onChange) {
        $dae4fc66435db4e1$var$_events = $dae4fc66435db4e1$var$_events.filter(function(cb) {
            return cb !== onChange;
        });
    };
    Customizations._raiseChange = function() {
        if (!Customizations._suppressUpdates) $dae4fc66435db4e1$var$_events.forEach(function(cb) {
            return cb();
        });
    };
    return Customizations;
}();



// When adding or removing a color, make sure you keep this consistent with IColorClassNames
// by adding the color variants.
var $b4b0355870aa648e$export$109c1b21def6ffa4 = {
    themeDarker: '#004578',
    themeDark: '#005a9e',
    themeDarkAlt: '#106ebe',
    themePrimary: '#0078d4',
    themeSecondary: '#2b88d8',
    themeTertiary: '#71afe5',
    themeLight: '#c7e0f4',
    themeLighter: '#deecf9',
    themeLighterAlt: '#eff6fc',
    black: '#000000',
    blackTranslucent40: 'rgba(0,0,0,.4)',
    neutralDark: '#201f1e',
    neutralPrimary: '#323130',
    neutralPrimaryAlt: '#3b3a39',
    neutralSecondary: '#605e5c',
    neutralSecondaryAlt: '#8a8886',
    neutralTertiary: '#a19f9d',
    neutralTertiaryAlt: '#c8c6c4',
    neutralQuaternary: '#d2d0ce',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralLight: '#edebe9',
    neutralLighter: '#f3f2f1',
    neutralLighterAlt: '#faf9f8',
    accent: '#0078d4',
    white: '#ffffff',
    whiteTranslucent40: 'rgba(255,255,255,.4)',
    yellowDark: '#d29200',
    yellow: '#ffb900',
    yellowLight: '#fff100',
    orange: '#d83b01',
    orangeLight: '#ea4300',
    orangeLighter: '#ff8c00',
    redDark: '#a4262c',
    red: '#e81123',
    magentaDark: '#5c005c',
    magenta: '#b4009e',
    magentaLight: '#e3008c',
    purpleDark: '#32145a',
    purple: '#5c2d91',
    purpleLight: '#b4a0ff',
    blueDark: '#002050',
    blueMid: '#00188f',
    blue: '#0078d4',
    blueLight: '#00bcf2',
    tealDark: '#004b50',
    teal: '#008272',
    tealLight: '#00b294',
    greenDark: '#004b1c',
    green: '#107c10',
    greenLight: '#bad80a'
};


var $f656f986859a9dca$export$9b00c83187ceb0d1;
(function(Depths) {
    Depths.depth0 = '0 0 0 0 transparent';
    Depths.depth4 = '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)';
    Depths.depth8 = '0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)';
    Depths.depth16 = '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.132), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.108)';
    Depths.depth64 = '0 25.6px 57.6px 0 rgba(0, 0, 0, 0.22), 0 4.8px 14.4px 0 rgba(0, 0, 0, 0.18)';
})($f656f986859a9dca$export$9b00c83187ceb0d1 || ($f656f986859a9dca$export$9b00c83187ceb0d1 = {}));


var $b23fc3a5e3a63797$export$1b052b16bf67042a = {
    elevation4: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth4,
    elevation8: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth8,
    elevation16: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth16,
    elevation64: (0, $f656f986859a9dca$export$9b00c83187ceb0d1).depth64,
    roundedCorner2: '2px',
    roundedCorner4: '4px',
    roundedCorner6: '6px'
};





function $14126b943c3ed2af$export$566c6c2ff0443c7(font) {
    var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
    var rule = (0, $3984cc6e71239662$export$4080b13ebe249c61)((0, $83a2b0773b0b5f26$export$6c4e12d3949051a)(), font);
    var className = stylesheet.classNameFromKey(rule);
    if (className) return;
    var name = stylesheet.getClassName();
    stylesheet.insertRule("@font-face{".concat(rule, "}"), true);
    stylesheet.cacheClassName(name, rule, [], [
        'font-face',
        rule
    ]);
}




// Fallback fonts, if specified system or web fonts are unavailable.
var $34eafb537e5c5200$var$FontFamilyFallbacks = "'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', 'Helvetica Neue', sans-serif";
// By default, we favor system fonts for the default.
// All localized fonts use a web font and never use the system font.
var $34eafb537e5c5200$var$defaultFontFamily = "'Segoe UI', '".concat((0, $1ba480b26914dcf0$export$ed6682c3a2de350f).WestEuropean, "'");
// Mapping of language prefix to to font family.
var $34eafb537e5c5200$var$LanguageToFontMap = {
    ar: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Arabic,
    bg: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Cyrillic,
    cs: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    el: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Greek,
    et: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    he: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Hebrew,
    hi: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Hindi,
    hr: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    hu: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    ja: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Japanese,
    kk: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    ko: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Korean,
    lt: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    lv: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    pl: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    ru: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Cyrillic,
    sk: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    'sr-latn': (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    th: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Thai,
    tr: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).EastEuropean,
    uk: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Cyrillic,
    vi: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Vietnamese,
    'zh-hans': (0, $1ba480b26914dcf0$export$a84f0633d5188de4).ChineseSimplified,
    'zh-hant': (0, $1ba480b26914dcf0$export$a84f0633d5188de4).ChineseTraditional,
    hy: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Armenian,
    ka: (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Georgian
};
function $34eafb537e5c5200$var$_fontFamilyWithFallbacks(fontFamily) {
    return "".concat(fontFamily, ", ").concat($34eafb537e5c5200$var$FontFamilyFallbacks);
}
/**
 * If there is a localized font for this language, return that.
 * Returns undefined if there is no localized font for that language.
 */ function $34eafb537e5c5200$var$_getLocalizedFontFamily(language) {
    for(var lang in $34eafb537e5c5200$var$LanguageToFontMap){
        if ($34eafb537e5c5200$var$LanguageToFontMap.hasOwnProperty(lang) && language && lang.indexOf(language) === 0) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $34eafb537e5c5200$var$LanguageToFontMap[lang];
    }
    return $34eafb537e5c5200$var$defaultFontFamily;
}
function $34eafb537e5c5200$var$_createFont(size, weight, fontFamily) {
    return {
        fontFamily: fontFamily,
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        fontSize: size,
        fontWeight: weight
    };
}
function $34eafb537e5c5200$export$a4fa8de6a1c20b63(localeCode) {
    var localizedFont = $34eafb537e5c5200$var$_getLocalizedFontFamily(localeCode);
    var fontFamilyWithFallback = $34eafb537e5c5200$var$_fontFamilyWithFallbacks(localizedFont);
    var fontStyles = {
        tiny: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).mini, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xSmall: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xSmall, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        small: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).small, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        smallPlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).smallPlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        medium: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).medium, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        mediumPlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).mediumPlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        large: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).large, (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, fontFamilyWithFallback),
        xLarge: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xLarge, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xLargePlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xLargePlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLarge: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xxLarge, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        xxLargePlus: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).xxLargePlus, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        superLarge: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).superLarge, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback),
        mega: $34eafb537e5c5200$var$_createFont((0, $1ba480b26914dcf0$export$f2bd2ec6ef52693e).mega, (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, fontFamilyWithFallback)
    };
    return fontStyles;
}



function $6787cc90d6254b3e$export$f65ca476c09acec0(rootElement) {
    // eslint-disable-next-line no-restricted-globals
    if (!(0, $18aa0efffa2a3752$export$71594e8a50f746f4)() || typeof document === 'undefined') return undefined;
    else {
        var el = rootElement;
        // eslint-disable-next-line no-restricted-globals
        return el && el.ownerDocument ? el.ownerDocument : document;
    }
}



function $f962a8dfcd8ca8ce$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        result = win ? win.localStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $f962a8dfcd8ca8ce$export$8a8216c44337cd5(key, data) {
    try {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        win && win.localStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}



function $6e93d649f0f85bbf$export$f92dfeb71e9bb569(key) {
    var result = null;
    try {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        result = win ? win.sessionStorage.getItem(key) : null;
    } catch (e) {
    /* Eat the exception */ }
    return result;
}
function $6e93d649f0f85bbf$export$8a8216c44337cd5(key, data) {
    var _a;
    try {
        (_a = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)()) === null || _a === void 0 || _a.sessionStorage.setItem(key, data);
    } catch (e) {
    /* Eat the exception */ }
}


// Default to undefined so that we initialize on first read.
var $4a1314ddc25702e6$var$_language;
var $4a1314ddc25702e6$var$STORAGE_KEY = 'language';
function $4a1314ddc25702e6$export$64783e31db14f0ba(persistenceType) {
    if (persistenceType === void 0) persistenceType = 'sessionStorage';
    if ($4a1314ddc25702e6$var$_language === undefined) {
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        var savedLanguage = persistenceType === 'localStorage' ? $f962a8dfcd8ca8ce$export$f92dfeb71e9bb569($4a1314ddc25702e6$var$STORAGE_KEY) : persistenceType === 'sessionStorage' ? $6e93d649f0f85bbf$export$f92dfeb71e9bb569($4a1314ddc25702e6$var$STORAGE_KEY) : undefined;
        if (savedLanguage) $4a1314ddc25702e6$var$_language = savedLanguage;
        if ($4a1314ddc25702e6$var$_language === undefined && doc) $4a1314ddc25702e6$var$_language = doc.documentElement.getAttribute('lang');
        if ($4a1314ddc25702e6$var$_language === undefined) $4a1314ddc25702e6$var$_language = 'en';
    }
    return $4a1314ddc25702e6$var$_language;
}
function $4a1314ddc25702e6$export$4b6bf64406ec64af(language, persistenceParam) {
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    if (doc) doc.documentElement.setAttribute('lang', language);
    var persistenceType = persistenceParam === true ? 'none' : !persistenceParam ? 'sessionStorage' : persistenceParam;
    if (persistenceType === 'localStorage') $f962a8dfcd8ca8ce$export$8a8216c44337cd5($4a1314ddc25702e6$var$STORAGE_KEY, language);
    else if (persistenceType === 'sessionStorage') $6e93d649f0f85bbf$export$8a8216c44337cd5($4a1314ddc25702e6$var$STORAGE_KEY, language);
    $4a1314ddc25702e6$var$_language = language;
}


// Default urls.
var $f4e14b7f1ed61365$var$DefaultBaseUrl = 'https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets';
var $f4e14b7f1ed61365$export$3d534eec2182c14b = (0, $34eafb537e5c5200$export$a4fa8de6a1c20b63)((0, $4a1314ddc25702e6$export$64783e31db14f0ba)());
function $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, url, fontWeight, localFontName) {
    fontFamily = "'".concat(fontFamily, "'");
    var localFontSrc = localFontName !== undefined ? "local('".concat(localFontName, "'),") : '';
    (0, $14126b943c3ed2af$export$566c6c2ff0443c7)({
        fontFamily: fontFamily,
        src: localFontSrc + "url('".concat(url, ".woff2') format('woff2'),") + "url('".concat(url, ".woff') format('woff')"),
        fontWeight: fontWeight,
        fontStyle: 'normal',
        fontDisplay: 'swap'
    });
}
function $f4e14b7f1ed61365$var$_registerFontFaceSet(baseUrl, fontFamily, cdnFolder, cdnFontName, localFontName) {
    if (cdnFontName === void 0) cdnFontName = 'segoeui';
    var urlBase = "".concat(baseUrl, "/").concat(cdnFolder, "/").concat(cdnFontName);
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + '-light', (0, $1ba480b26914dcf0$export$32743b01f42d159e).light, localFontName && localFontName + ' Light');
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + '-semilight', (0, $1ba480b26914dcf0$export$32743b01f42d159e).semilight, localFontName && localFontName + ' SemiLight');
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + '-regular', (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular, localFontName);
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + '-semibold', (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold, localFontName && localFontName + ' SemiBold');
    $f4e14b7f1ed61365$var$_registerFontFace(fontFamily, urlBase + '-bold', (0, $1ba480b26914dcf0$export$32743b01f42d159e).bold, localFontName && localFontName + ' Bold');
}
function $f4e14b7f1ed61365$export$1c5ba4c2e362bd9e(baseUrl) {
    if (baseUrl) {
        var fontUrl = "".concat(baseUrl, "/fonts");
        // Produce @font-face definitions for all supported web fonts.
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Thai, 'leelawadeeui-thai', 'leelawadeeui');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Arabic, 'segoeui-arabic');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Cyrillic, 'segoeui-cyrillic');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).EastEuropean, 'segoeui-easteuropean');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Greek, 'segoeui-greek');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Hebrew, 'segoeui-hebrew');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Vietnamese, 'segoeui-vietnamese');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).WestEuropean, 'segoeui-westeuropean', 'segoeui', 'Segoe UI');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$a84f0633d5188de4).Selawik, 'selawik', 'selawik');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Armenian, 'segoeui-armenian');
        $f4e14b7f1ed61365$var$_registerFontFaceSet(fontUrl, (0, $1ba480b26914dcf0$export$ed6682c3a2de350f).Georgian, 'segoeui-georgian');
        // Leelawadee UI (Thai) does not have a 'light' weight, so we override
        // the font-face generated above to use the 'semilight' weight instead.
        $f4e14b7f1ed61365$var$_registerFontFace('Leelawadee UI Web', "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-semilight"), (0, $1ba480b26914dcf0$export$32743b01f42d159e).light);
        // Leelawadee UI (Thai) does not have a 'semibold' weight, so we override
        // the font-face generated above to use the 'bold' weight instead.
        $f4e14b7f1ed61365$var$_registerFontFace('Leelawadee UI Web', "".concat(fontUrl, "/leelawadeeui-thai/leelawadeeui-bold"), (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold);
    }
}
/**
 * Reads the fontBaseUrl from window.FabricConfig.fontBaseUrl or falls back to a default.
 */ function $f4e14b7f1ed61365$var$_getFontBaseUrl() {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var fabricConfig = (_a = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)()) === null || _a === void 0 ? void 0 : _a.FabricConfig;
    return (_b = fabricConfig === null || fabricConfig === void 0 ? void 0 : fabricConfig.fontBaseUrl) !== null && _b !== void 0 ? _b : $f4e14b7f1ed61365$var$DefaultBaseUrl;
}
/**
 * Register the font faces.
 */ $f4e14b7f1ed61365$export$1c5ba4c2e362bd9e($f4e14b7f1ed61365$var$_getFontBaseUrl());


/**
 * Simple deep merge function. Takes all arguments and returns a deep copy of the objects merged
 * together in the order provided. If an object creates a circular reference, it will assign the
 * original reference.
 */ function $6f99f03776d37396$export$4950aa0f605343fb(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var arg = args_1[_a];
        $6f99f03776d37396$var$_merge(target || {}, arg);
    }
    return target;
}
/**
 * The _merge helper iterates through all props on source and assigns them to target.
 * When the value is an object, we will create a deep clone of the object. However if
 * there is a circular reference, the value will not be deep cloned and will persist
 * the reference.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6f99f03776d37396$var$_merge(target, source, circularReferences) {
    if (circularReferences === void 0) circularReferences = [];
    circularReferences.push(source);
    for(var name_1 in source){
        if (source.hasOwnProperty(name_1)) {
            if (name_1 !== '__proto__' && name_1 !== 'constructor' && name_1 !== 'prototype') {
                var value = source[name_1];
                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    var isCircularReference = circularReferences.indexOf(value) > -1;
                    target[name_1] = isCircularReference ? value : $6f99f03776d37396$var$_merge(target[name_1] || {}, value, circularReferences);
                } else target[name_1] = value;
            }
        }
    }
    circularReferences.pop();
    return target;
}



function $121003e76cb3da39$export$1084519c371c0719(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var semanticColors = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        primaryButtonBorder: 'transparent',
        errorText: !isInverted ? '#a4262c' : '#F1707B',
        messageText: !isInverted ? '#323130' : '#F3F2F1',
        messageLink: !isInverted ? '#005A9E' : '#6CB8F6',
        messageLinkHovered: !isInverted ? '#004578' : '#82C7FF',
        infoIcon: !isInverted ? '#605e5c' : '#C8C6C4',
        errorIcon: !isInverted ? '#A80000' : '#F1707B',
        blockingIcon: !isInverted ? '#FDE7E9' : '#442726',
        warningIcon: !isInverted ? '#797775' : '#C8C6C4',
        severeWarningIcon: !isInverted ? '#D83B01' : '#FCE100',
        successIcon: !isInverted ? '#107C10' : '#92C353',
        infoBackground: !isInverted ? '#f3f2f1' : '#323130',
        errorBackground: !isInverted ? '#FDE7E9' : '#442726',
        blockingBackground: !isInverted ? '#FDE7E9' : '#442726',
        warningBackground: !isInverted ? '#FFF4CE' : '#433519',
        severeWarningBackground: !isInverted ? '#FED9CC' : '#4F2A0F',
        successBackground: !isInverted ? '#DFF6DD' : '#393D1B',
        // deprecated
        warningHighlight: !isInverted ? '#ffb900' : '#fff100',
        successText: !isInverted ? '#107C10' : '#92c353'
    }, s);
    var fullSemanticColors = $121003e76cb3da39$export$aca509a1becd8a60(p, e, semanticColors, isInverted);
    return $121003e76cb3da39$var$_fixDeprecatedSlots(fullSemanticColors, depComments);
}
function $121003e76cb3da39$export$aca509a1becd8a60(p, e, s, isInverted, depComments) {
    if (depComments === void 0) depComments = false;
    var result = {};
    // map palette
    var _a = p || {}, white = _a.white, black = _a.black, themePrimary = _a.themePrimary, themeDark = _a.themeDark, themeDarker = _a.themeDarker, themeDarkAlt = _a.themeDarkAlt, themeLighter = _a.themeLighter, neutralLight = _a.neutralLight, neutralLighter = _a.neutralLighter, neutralDark = _a.neutralDark, neutralQuaternary = _a.neutralQuaternary, neutralQuaternaryAlt = _a.neutralQuaternaryAlt, neutralPrimary = _a.neutralPrimary, neutralSecondary = _a.neutralSecondary, neutralSecondaryAlt = _a.neutralSecondaryAlt, neutralTertiary = _a.neutralTertiary, neutralTertiaryAlt = _a.neutralTertiaryAlt, neutralLighterAlt = _a.neutralLighterAlt, accent = _a.accent;
    if (white) {
        result.bodyBackground = white;
        result.bodyFrameBackground = white;
        result.accentButtonText = white;
        result.buttonBackground = white;
        result.primaryButtonText = white;
        result.primaryButtonTextHovered = white;
        result.primaryButtonTextPressed = white;
        result.inputBackground = white;
        result.inputForegroundChecked = white;
        result.listBackground = white;
        result.menuBackground = white;
        result.cardStandoutBackground = white;
    }
    if (black) {
        result.bodyTextChecked = black;
        result.buttonTextCheckedHovered = black;
    }
    if (themePrimary) {
        result.link = themePrimary;
        result.primaryButtonBackground = themePrimary;
        result.inputBackgroundChecked = themePrimary;
        result.inputIcon = themePrimary;
        result.inputFocusBorderAlt = themePrimary;
        result.menuIcon = themePrimary;
        result.menuHeader = themePrimary;
        result.accentButtonBackground = themePrimary;
    }
    if (themeDark) {
        result.primaryButtonBackgroundPressed = themeDark;
        result.inputBackgroundCheckedHovered = themeDark;
        result.inputIconHovered = themeDark;
    }
    if (themeDarker) result.linkHovered = themeDarker;
    if (themeDarkAlt) result.primaryButtonBackgroundHovered = themeDarkAlt;
    if (themeLighter) result.inputPlaceholderBackgroundChecked = themeLighter;
    if (neutralLight) {
        result.bodyBackgroundChecked = neutralLight;
        result.bodyFrameDivider = neutralLight;
        result.bodyDivider = neutralLight;
        result.variantBorder = neutralLight;
        result.buttonBackgroundCheckedHovered = neutralLight;
        result.buttonBackgroundPressed = neutralLight;
        result.listItemBackgroundChecked = neutralLight;
        result.listHeaderBackgroundPressed = neutralLight;
        result.menuItemBackgroundPressed = neutralLight;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        result.menuItemBackgroundChecked = neutralLight;
    }
    if (neutralLighter) {
        result.bodyBackgroundHovered = neutralLighter;
        result.buttonBackgroundHovered = neutralLighter;
        result.buttonBackgroundDisabled = neutralLighter;
        result.buttonBorderDisabled = neutralLighter;
        result.primaryButtonBackgroundDisabled = neutralLighter;
        result.disabledBackground = neutralLighter;
        result.listItemBackgroundHovered = neutralLighter;
        result.listHeaderBackgroundHovered = neutralLighter;
        result.menuItemBackgroundHovered = neutralLighter;
    }
    if (neutralQuaternary) {
        result.primaryButtonTextDisabled = neutralQuaternary;
        result.disabledSubtext = neutralQuaternary;
    }
    if (neutralQuaternaryAlt) result.listItemBackgroundCheckedHovered = neutralQuaternaryAlt;
    if (neutralTertiary) {
        result.disabledBodyText = neutralTertiary;
        result.variantBorderHovered = (s === null || s === void 0 ? void 0 : s.variantBorderHovered) || neutralTertiary;
        result.buttonTextDisabled = neutralTertiary;
        result.inputIconDisabled = neutralTertiary;
        result.disabledText = neutralTertiary;
    }
    if (neutralPrimary) {
        result.bodyText = neutralPrimary;
        result.actionLink = neutralPrimary;
        result.buttonText = neutralPrimary;
        result.inputBorderHovered = neutralPrimary;
        result.inputText = neutralPrimary;
        result.listText = neutralPrimary;
        result.menuItemText = neutralPrimary;
    }
    if (neutralLighterAlt) {
        result.bodyStandoutBackground = neutralLighterAlt;
        result.defaultStateBackground = neutralLighterAlt;
    }
    if (neutralDark) {
        result.actionLinkHovered = neutralDark;
        result.buttonTextHovered = neutralDark;
        result.buttonTextChecked = neutralDark;
        result.buttonTextPressed = neutralDark;
        result.inputTextHovered = neutralDark;
        result.menuItemTextHovered = neutralDark;
    }
    if (neutralSecondary) {
        result.bodySubtext = neutralSecondary;
        result.focusBorder = neutralSecondary;
        result.inputBorder = neutralSecondary;
        result.smallInputBorder = neutralSecondary;
        result.inputPlaceholderText = neutralSecondary;
    }
    if (neutralSecondaryAlt) result.buttonBorder = neutralSecondaryAlt;
    if (neutralTertiaryAlt) {
        result.disabledBodySubtext = neutralTertiaryAlt;
        result.disabledBorder = neutralTertiaryAlt;
        result.buttonBackgroundChecked = neutralTertiaryAlt;
        result.menuDivider = neutralTertiaryAlt;
    }
    if (accent) result.accentButtonBackground = accent;
    // map effects
    if (e === null || e === void 0 ? void 0 : e.elevation4) result.cardShadow = e.elevation4;
    if (!isInverted && (e === null || e === void 0 ? void 0 : e.elevation8)) result.cardShadowHovered = e.elevation8;
    else if (result.variantBorderHovered) result.cardShadowHovered = '0 0 1px ' + result.variantBorderHovered;
    result = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, result), s);
    return result;
}
function $121003e76cb3da39$var$_fixDeprecatedSlots(s, depComments) {
    // Add @deprecated tag as comment if enabled
    var dep = '';
    if (depComments === true) dep = ' /* @deprecated */';
    /*  eslint-disable @typescript-eslint/no-deprecated */ s.listTextColor = s.listText + dep;
    s.menuItemBackgroundChecked += dep;
    s.warningHighlight += dep;
    s.warningText = s.messageText + dep;
    s.successText += dep;
    /* eslint-enable @typescript-eslint/no-deprecated */ return s;
}


function $535786ba16bdff82$export$919aa3481b25eaec(theme, partialTheme) {
    var _a, _b, _c;
    if (partialTheme === void 0) partialTheme = {};
    var mergedTheme = (0, $6f99f03776d37396$export$4950aa0f605343fb)({}, theme, partialTheme, {
        semanticColors: (0, $121003e76cb3da39$export$aca509a1becd8a60)(partialTheme.palette, partialTheme.effects, partialTheme.semanticColors, partialTheme.isInverted === undefined ? theme.isInverted : partialTheme.isInverted)
    });
    if (((_a = partialTheme.palette) === null || _a === void 0 ? void 0 : _a.themePrimary) && !((_b = partialTheme.palette) === null || _b === void 0 ? void 0 : _b.accent)) mergedTheme.palette.accent = partialTheme.palette.themePrimary;
    if (partialTheme.defaultFontStyle) for(var _i = 0, _d = Object.keys(mergedTheme.fonts); _i < _d.length; _i++){
        var fontStyle = _d[_i];
        mergedTheme.fonts[fontStyle] = (0, $6f99f03776d37396$export$4950aa0f605343fb)(mergedTheme.fonts[fontStyle], partialTheme.defaultFontStyle, (_c = partialTheme === null || partialTheme === void 0 ? void 0 : partialTheme.fonts) === null || _c === void 0 ? void 0 : _c[fontStyle]);
    }
    return mergedTheme;
}


var $2587f08b2750d110$export$f1e7669f0aafe571 = {
    s2: '4px',
    s1: '8px',
    m: '16px',
    l1: '20px',
    l2: '32px'
};



function $49b644eef671596b$export$25d302a5b900a763(theme, depComments) {
    if (theme === void 0) theme = {};
    if (depComments === void 0) depComments = false;
    var isInverted = !!theme.isInverted;
    var baseTheme = {
        palette: (0, $b4b0355870aa648e$export$109c1b21def6ffa4),
        effects: (0, $b23fc3a5e3a63797$export$1b052b16bf67042a),
        fonts: (0, $f4e14b7f1ed61365$export$3d534eec2182c14b),
        spacing: (0, $2587f08b2750d110$export$f1e7669f0aafe571),
        isInverted: isInverted,
        disableGlobalClassNames: false,
        semanticColors: (0, $121003e76cb3da39$export$1084519c371c0719)((0, $b4b0355870aa648e$export$109c1b21def6ffa4), (0, $b23fc3a5e3a63797$export$1b052b16bf67042a), undefined, isInverted, depComments),
        rtl: undefined
    };
    return (0, $535786ba16bdff82$export$919aa3481b25eaec)(baseTheme, theme);
}


var $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)({});
var $756f0943cb677ee4$var$_onThemeChangeCallbacks = [];
var $756f0943cb677ee4$export$cf613f78cce4b73f = 'theme';
function $756f0943cb677ee4$export$8a248add43552e89() {
    var _a;
    var _b, _c;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    if ((_b = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _b === void 0 ? void 0 : _b.legacyTheme) // does everything the `else` clause does and more, such as invoke legacy theming
    $756f0943cb677ee4$export$a1d87755f3c9500d(win.FabricConfig.legacyTheme);
    else if (!(0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings([
        $756f0943cb677ee4$export$cf613f78cce4b73f
    ]).theme) {
        if ((_c = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _c === void 0 ? void 0 : _c.theme) $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)(win.FabricConfig.theme);
        // Set the default theme.
        (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$756f0943cb677ee4$export$cf613f78cce4b73f] = $756f0943cb677ee4$var$_theme, _a));
    }
}
$756f0943cb677ee4$export$8a248add43552e89();
function $756f0943cb677ee4$export$89cbf1a0881c8b9c(depComments) {
    if (depComments === void 0) depComments = false;
    if (depComments === true) $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)({}, depComments);
    return $756f0943cb677ee4$var$_theme;
}
function $756f0943cb677ee4$export$e7b32ab372e04de(callback) {
    if ($756f0943cb677ee4$var$_onThemeChangeCallbacks.indexOf(callback) === -1) $756f0943cb677ee4$var$_onThemeChangeCallbacks.push(callback);
}
function $756f0943cb677ee4$export$d0ea9fdf152462c9(callback) {
    var i = $756f0943cb677ee4$var$_onThemeChangeCallbacks.indexOf(callback);
    if (i === -1) return;
    $756f0943cb677ee4$var$_onThemeChangeCallbacks.splice(i, 1);
}
function $756f0943cb677ee4$export$a1d87755f3c9500d(theme, depComments) {
    var _a;
    if (depComments === void 0) depComments = false;
    $756f0943cb677ee4$var$_theme = (0, $49b644eef671596b$export$25d302a5b900a763)(theme, depComments);
    // Invoke the legacy method of theming the page as well.
    (0, $3f49b970b29d910a$export$a1d87755f3c9500d)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $756f0943cb677ee4$var$_theme.palette), $756f0943cb677ee4$var$_theme.semanticColors), $756f0943cb677ee4$var$_theme.effects), $756f0943cb677ee4$var$_loadFonts($756f0943cb677ee4$var$_theme)));
    (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).applySettings((_a = {}, _a[$756f0943cb677ee4$export$cf613f78cce4b73f] = $756f0943cb677ee4$var$_theme, _a));
    $756f0943cb677ee4$var$_onThemeChangeCallbacks.forEach(function(callback) {
        try {
            callback($756f0943cb677ee4$var$_theme);
        } catch (e) {
        // don't let a bad callback break everything else
        }
    });
    return $756f0943cb677ee4$var$_theme;
}
/**
 * Loads font variables into a JSON object.
 * @param theme - The theme object
 */ function $756f0943cb677ee4$var$_loadFonts(theme) {
    var lines = {};
    for(var _i = 0, _a = Object.keys(theme.fonts); _i < _a.length; _i++){
        var fontName = _a[_i];
        var font = theme.fonts[fontName];
        for(var _b = 0, _c = Object.keys(font); _b < _c.length; _b++){
            var propName = _c[_b];
            var name_1 = fontName + propName.charAt(0).toUpperCase() + propName.slice(1);
            var value = font[propName];
            if (propName === 'fontSize' && typeof value === 'number') // if it's a number, convert it to px by default like our theming system does
            value = value + 'px';
            lines[name_1] = value;
        }
    }
    return lines;
}

var $34563ae103a23d08$export$35835471cbe77db4 = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
};

// This file mimics styles and mixins from _General.Mixins.scss
var $3472c0f90c64fe40$export$a3295358bff77e = {
    boxShadow: 'none',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
};
var $3472c0f90c64fe40$export$2e0098041746c0f4 = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};



/* eslint-disable no-console */ var $6f044242a3d99d90$var$_warningCallback = undefined;
function $6f044242a3d99d90$export$c106dd0671a0fc2d(message) {
    if (console && console.warn) console.warn(message);
}
function $6f044242a3d99d90$export$70b267401ac98961(warningCallback) {
    $6f044242a3d99d90$var$_warningCallback = warningCallback;
}



var $157fc0f40a8f1c26$var$ICON_SETTING_NAME = 'icons';
var $157fc0f40a8f1c26$var$_iconSettings = (0, $2a6b20086a42f1ef$export$e962ef7984a884aa).getValue($157fc0f40a8f1c26$var$ICON_SETTING_NAME, {
    __options: {
        disableWarnings: false,
        warnOnMissingIcons: true
    },
    __remapped: {}
});
// Reset icon registration on stylesheet resets.
var $157fc0f40a8f1c26$var$stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
if ($157fc0f40a8f1c26$var$stylesheet && $157fc0f40a8f1c26$var$stylesheet.onReset) $157fc0f40a8f1c26$var$stylesheet.onReset(function() {
    for(var name_1 in $157fc0f40a8f1c26$var$_iconSettings)if ($157fc0f40a8f1c26$var$_iconSettings.hasOwnProperty(name_1) && !!$157fc0f40a8f1c26$var$_iconSettings[name_1].subset) $157fc0f40a8f1c26$var$_iconSettings[name_1].subset.className = undefined;
});
/**
 * Normalizes an icon name for consistent mapping.
 * Current implementation is to convert the icon name to lower case.
 *
 * @param name - Icon name to normalize.
 * @returns {string} Normalized icon name to use for indexing and mapping.
 */ var $157fc0f40a8f1c26$var$normalizeIconName = function(name) {
    return name.toLowerCase();
};
function $157fc0f40a8f1c26$export$99b432e1290ef823(iconSubset, options) {
    var subset = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, iconSubset), {
        isRegistered: false,
        className: undefined
    });
    var icons = iconSubset.icons;
    // Grab options, optionally mix user provided ones on top.
    options = options ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $157fc0f40a8f1c26$var$_iconSettings.__options), options) : $157fc0f40a8f1c26$var$_iconSettings.__options;
    for(var iconName in icons)if (icons.hasOwnProperty(iconName)) {
        var code = icons[iconName];
        var normalizedIconName = $157fc0f40a8f1c26$var$normalizeIconName(iconName);
        if ($157fc0f40a8f1c26$var$_iconSettings[normalizedIconName]) $157fc0f40a8f1c26$var$_warnDuplicateIcon(iconName);
        else $157fc0f40a8f1c26$var$_iconSettings[normalizedIconName] = {
            code: code,
            subset: subset
        };
    }
}
function $157fc0f40a8f1c26$export$d4eb2d2d2a4efe94(iconNames) {
    var options = $157fc0f40a8f1c26$var$_iconSettings.__options;
    var _loop_1 = function(iconName) {
        var normalizedIconName = $157fc0f40a8f1c26$var$normalizeIconName(iconName);
        if ($157fc0f40a8f1c26$var$_iconSettings[normalizedIconName]) delete $157fc0f40a8f1c26$var$_iconSettings[normalizedIconName];
        else // Warn that we are trying to delete an icon that doesn't exist
        if (!options.disableWarnings) (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)("The icon \"".concat(iconName, "\" tried to unregister but was not registered."));
        // Delete any aliases for this iconName
        if ($157fc0f40a8f1c26$var$_iconSettings.__remapped[normalizedIconName]) delete $157fc0f40a8f1c26$var$_iconSettings.__remapped[normalizedIconName];
        // Delete any items that were an alias for this iconName
        Object.keys($157fc0f40a8f1c26$var$_iconSettings.__remapped).forEach(function(key) {
            if ($157fc0f40a8f1c26$var$_iconSettings.__remapped[key] === normalizedIconName) delete $157fc0f40a8f1c26$var$_iconSettings.__remapped[key];
        });
    };
    for(var _i = 0, iconNames_1 = iconNames; _i < iconNames_1.length; _i++){
        var iconName = iconNames_1[_i];
        _loop_1(iconName);
    }
}
function $157fc0f40a8f1c26$export$4fad376c7613260(iconName, mappedToName) {
    $157fc0f40a8f1c26$var$_iconSettings.__remapped[$157fc0f40a8f1c26$var$normalizeIconName(iconName)] = $157fc0f40a8f1c26$var$normalizeIconName(mappedToName);
}
function $157fc0f40a8f1c26$export$16b26cd5e98d9100(name) {
    var icon = undefined;
    var options = $157fc0f40a8f1c26$var$_iconSettings.__options;
    name = name ? $157fc0f40a8f1c26$var$normalizeIconName(name) : '';
    name = $157fc0f40a8f1c26$var$_iconSettings.__remapped[name] || name;
    if (name) {
        icon = $157fc0f40a8f1c26$var$_iconSettings[name];
        if (icon) {
            var subset = icon.subset;
            if (subset && subset.fontFace) {
                if (!subset.isRegistered) {
                    (0, $14126b943c3ed2af$export$566c6c2ff0443c7)(subset.fontFace);
                    subset.isRegistered = true;
                }
                if (!subset.className) subset.className = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(subset.style, {
                    fontFamily: subset.fontFace.fontFamily,
                    fontWeight: subset.fontFace.fontWeight || 'normal',
                    fontStyle: subset.fontFace.fontStyle || 'normal'
                });
            }
        } else // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (!options.disableWarnings && options.warnOnMissingIcons) (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)("The icon \"".concat(name, "\" was used but not registered. See https://github.com/microsoft/fluentui/wiki/Using-icons for more information."));
    }
    return icon;
}
function $157fc0f40a8f1c26$export$931896f68834c675(options) {
    $157fc0f40a8f1c26$var$_iconSettings.__options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $157fc0f40a8f1c26$var$_iconSettings.__options), options);
}
var $157fc0f40a8f1c26$var$_missingIcons = [];
var $157fc0f40a8f1c26$var$_missingIconsTimer = undefined;
function $157fc0f40a8f1c26$var$_warnDuplicateIcon(iconName) {
    var options = $157fc0f40a8f1c26$var$_iconSettings.__options;
    var warningDelay = 2000;
    var maxIconsInMessage = 10;
    if (!options.disableWarnings) {
        $157fc0f40a8f1c26$var$_missingIcons.push(iconName);
        if ($157fc0f40a8f1c26$var$_missingIconsTimer === undefined) $157fc0f40a8f1c26$var$_missingIconsTimer = setTimeout(function() {
            (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)("Some icons were re-registered. Applications should only call registerIcons for any given icon once. Redefining what an icon is may have unintended consequences. Duplicates include: \n" + $157fc0f40a8f1c26$var$_missingIcons.slice(0, maxIconsInMessage).join(', ') + ($157fc0f40a8f1c26$var$_missingIcons.length > maxIconsInMessage ? " (+ ".concat($157fc0f40a8f1c26$var$_missingIcons.length - maxIconsInMessage, " more)") : ''));
            $157fc0f40a8f1c26$var$_missingIconsTimer = undefined;
            $157fc0f40a8f1c26$var$_missingIcons = [];
        }, warningDelay);
    }
}




function $9f80d64ff1d557a5$export$b9e8701096551fdc() {
    var styleSets = [];
    for(var _i = 0; _i < arguments.length; _i++)styleSets[_i] = arguments[_i];
    if (styleSets && styleSets.length === 1 && styleSets[0] && !styleSets[0].subComponentStyles && !(0, $c9c2f6e9ef06bed5$export$81e860c23a35a7b8)(styleSets[0])) return styleSets[0];
    var mergedSet = {};
    // We process sub component styles in two phases. First we collect them, then we combine them into 1 style function.
    var workingSubcomponentStyles = {};
    for(var _a = 0, styleSets_1 = styleSets; _a < styleSets_1.length; _a++){
        var currentSet = styleSets_1[_a];
        if (currentSet && !(0, $c9c2f6e9ef06bed5$export$81e860c23a35a7b8)(currentSet)) {
            for(var prop in currentSet)if (currentSet.hasOwnProperty(prop)) {
                if (prop === 'subComponentStyles' && currentSet.subComponentStyles !== undefined) {
                    // subcomponent styles - style functions or objects
                    var currentComponentStyles = currentSet.subComponentStyles;
                    for(var subCompProp in currentComponentStyles)if (currentComponentStyles.hasOwnProperty(subCompProp)) {
                        if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) workingSubcomponentStyles[subCompProp].push(currentComponentStyles[subCompProp]);
                        else workingSubcomponentStyles[subCompProp] = [
                            currentComponentStyles[subCompProp]
                        ];
                    }
                    continue;
                }
                // the as any casts below is a workaround for ts 2.8.
                // todo: remove cast to any in ts 2.9.
                var mergedValue = mergedSet[prop];
                var currentValue = currentSet[prop];
                if (mergedValue === undefined) mergedSet[prop] = currentValue;
                else mergedSet[prop] = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], Array.isArray(mergedValue) ? mergedValue : [
                    mergedValue
                ], true), Array.isArray(currentValue) ? currentValue : [
                    currentValue
                ], true);
            }
        }
    }
    if (Object.keys(workingSubcomponentStyles).length > 0) {
        mergedSet.subComponentStyles = {};
        var mergedSubStyles = mergedSet.subComponentStyles;
        var _loop_1 = function(subCompProp) {
            if (workingSubcomponentStyles.hasOwnProperty(subCompProp)) {
                var workingSet_1 = workingSubcomponentStyles[subCompProp];
                mergedSubStyles[subCompProp] = function(styleProps) {
                    return $9f80d64ff1d557a5$export$b9e8701096551fdc.apply(void 0, workingSet_1.map(function(styleFunctionOrObject) {
                        return typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject;
                    }));
                };
            }
        };
        // now we process the subcomponent styles if there are any
        for(var subCompProp in workingSubcomponentStyles)_loop_1(subCompProp);
    }
    return mergedSet;
}


function $386ae5a2cd0e8632$export$5136bfd779f95982(styleProps) {
    var allStyles = [];
    for(var _i = 1; _i < arguments.length; _i++)allStyles[_i - 1] = arguments[_i];
    var result = [];
    for(var _a = 0, allStyles_1 = allStyles; _a < allStyles_1.length; _a++){
        var styles = allStyles_1[_a];
        if (styles) result.push(typeof styles === 'function' ? styles(styleProps) : styles);
    }
    if (result.length === 1) return result[0];
    else if (result.length) // cliffkoh: I cannot figure out how to avoid the cast to any here.
    // It is something to do with the use of Omit in IStyleSet.
    // It might not be necessary once  Omit becomes part of lib.d.ts (when we remove our own Omit and rely on
    // the official version).
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc).apply(void 0, result);
    return {};
}








function $00784e00f3e28b27$export$fbaf15ac64fa8f3e() {
    var styleSets = [];
    for(var _i = 0; _i < arguments.length; _i++)styleSets[_i] = arguments[_i];
    return $00784e00f3e28b27$export$3ea21144e9973d29(styleSets, (0, $83a2b0773b0b5f26$export$6c4e12d3949051a)());
}
function $00784e00f3e28b27$export$3ea21144e9973d29(styleSets, options) {
    var classNameSet = {
        subComponentStyles: {}
    };
    var shadowConfig = undefined;
    var styleSet;
    if ((0, $c9c2f6e9ef06bed5$export$81e860c23a35a7b8)(styleSets[0])) {
        shadowConfig = styleSets[0];
        styleSet = styleSets[1];
    } else styleSet = styleSets[0];
    shadowConfig !== null && shadowConfig !== void 0 ? shadowConfig : shadowConfig = options === null || options === void 0 ? void 0 : options.shadowConfig;
    var opts = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, options), {
        shadowConfig: shadowConfig
    });
    if (!styleSet && styleSets.length <= 1) return {
        subComponentStyles: {}
    };
    var sheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance(shadowConfig);
    opts.stylesheet = sheet;
    var concatenatedStyleSet = (0, $9f80d64ff1d557a5$export$b9e8701096551fdc).apply(void 0, styleSets);
    var registrations = [];
    for(var styleSetArea in concatenatedStyleSet)if (concatenatedStyleSet.hasOwnProperty(styleSetArea)) {
        if (styleSetArea === 'subComponentStyles') {
            classNameSet.subComponentStyles = concatenatedStyleSet.subComponentStyles || {};
            continue;
        } else if (styleSetArea === '__shadowConfig__') continue;
        var styles = concatenatedStyleSet[styleSetArea];
        var _a = (0, $1fbb556661b56077$export$b1c01d3d68dc0b88)(sheet, styles), classes = _a.classes, objects = _a.objects;
        if (objects === null || objects === void 0 ? void 0 : objects.length) {
            var registration = (0, $3984cc6e71239662$export$f51c5a57f5409a02)(opts || {}, {
                displayName: styleSetArea
            }, objects);
            if (registration) {
                registrations.push(registration);
                classNameSet[styleSetArea] = classes.concat([
                    registration.className
                ]).join(' ');
            }
        } else classNameSet[styleSetArea] = classes.join(' ');
    }
    for(var _i = 0, registrations_1 = registrations; _i < registrations_1.length; _i++){
        var registration = registrations_1[_i];
        if (registration) (0, $3984cc6e71239662$export$cf30abcc7f4a413c)(registration, options === null || options === void 0 ? void 0 : options.specificityMultiplier, shadowConfig);
    }
    return classNameSet;
}



// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
// A packages cache that makes sure that we don't inject the same packageName twice in the same bundle -
// this cache is local to the module closure inside this bundle
var $8bcf2d68614748d6$var$packagesCache = {};
// Cache access to window to avoid IE11 memory leak.
var $8bcf2d68614748d6$var$_win = undefined;
try {
    $8bcf2d68614748d6$var$_win = window;
} catch (e) {
/* no-op */ }
function $8bcf2d68614748d6$export$f99c3c9c04cda7ae(packageName, packageVersion) {
    if (typeof $8bcf2d68614748d6$var$_win !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var packages = $8bcf2d68614748d6$var$_win.__packages__ = $8bcf2d68614748d6$var$_win.__packages__ || {};
        // We allow either the global packages or local packages caches to invalidate so testing can
        // just clear the global to set this state
        if (!packages[packageName] || !$8bcf2d68614748d6$var$packagesCache[packageName]) {
            $8bcf2d68614748d6$var$packagesCache[packageName] = packageVersion;
            var versions = packages[packageName] = packages[packageName] || [];
            versions.push(packageVersion);
        }
    }
}


(0, $8bcf2d68614748d6$export$f99c3c9c04cda7ae)('@fluentui/set-version', '6.0.0');


(0, $8bcf2d68614748d6$export$f99c3c9c04cda7ae)('@fluentui/style-utilities', '8.15.0');



(0, $756f0943cb677ee4$export$8a248add43552e89)();



var $acw62 = parcelRequire("acw62");
var $841b877f8387ff91$export$3eb7f4ab94bcebc3 = $acw62.createContext({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {}
    }
});




var $acw62 = parcelRequire("acw62");

/**
 * Simulated enum for keycodes. These will get inlined by uglify when used much like an enum
 *
 * @public
 * {@docCategory KeyCodes}
 */ var $c011a102064f82ea$export$ec835b702d42f3f0 = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    pauseBreak: 19,
    capslock: 20,
    escape: 27,
    space: 32,
    pageUp: 33,
    pageDown: 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    del: 46,
    zero: 48,
    one: 49,
    two: 50,
    three: 51,
    four: 52,
    five: 53,
    six: 54,
    seven: 55,
    eight: 56,
    nine: 57,
    colon: 58,
    a: 65,
    b: 66,
    c: 67,
    d: 68,
    e: 69,
    f: 70,
    g: 71,
    h: 72,
    i: 73,
    j: 74,
    k: 75,
    l: 76,
    m: 77,
    n: 78,
    o: 79,
    p: 80,
    q: 81,
    r: 82,
    s: 83,
    t: 84,
    u: 85,
    v: 86,
    w: 87,
    x: 88,
    y: 89,
    z: 90,
    leftWindow: 91,
    rightWindow: 92,
    select: 93,
    /* eslint-disable @typescript-eslint/naming-convention */ zero_numpad: 96,
    one_numpad: 97,
    two_numpad: 98,
    three_numpad: 99,
    four_numpad: 100,
    five_numpad: 101,
    six_numpad: 102,
    seven_numpad: 103,
    eight_numpad: 104,
    nine_numpad: 105,
    /* eslint-enable @typescript-eslint/naming-convention */ multiply: 106,
    add: 107,
    subtract: 109,
    decimalPoint: 110,
    divide: 111,
    f1: 112,
    f2: 113,
    f3: 114,
    f4: 115,
    f5: 116,
    f6: 117,
    f7: 118,
    f8: 119,
    f9: 120,
    f10: 121,
    f11: 122,
    f12: 123,
    numlock: 144,
    scrollLock: 145,
    semicolon: 186,
    equalSign: 187,
    comma: 188,
    dash: 189,
    period: 190,
    forwardSlash: 191,
    graveAccent: 192,
    openBracket: 219,
    backSlash: 220,
    closeBracket: 221,
    singleQuote: 222
};





var $723d0744d8fe4fde$var$RTL_LOCAL_STORAGE_KEY = 'isRTL';
// Default to undefined so that we initialize on first read.
var $723d0744d8fe4fde$var$_isRTL;
function $723d0744d8fe4fde$export$b2303637e9533380(theme) {
    if (theme === void 0) theme = {};
    if (theme.rtl !== undefined) return theme.rtl;
    if ($723d0744d8fe4fde$var$_isRTL === undefined) {
        // Fabric supports persisting the RTL setting between page refreshes via session storage
        var savedRTL = (0, $6e93d649f0f85bbf$export$f92dfeb71e9bb569)($723d0744d8fe4fde$var$RTL_LOCAL_STORAGE_KEY);
        if (savedRTL !== null) {
            $723d0744d8fe4fde$var$_isRTL = savedRTL === '1';
            $723d0744d8fe4fde$export$64006deca925fb65($723d0744d8fe4fde$var$_isRTL);
        }
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if ($723d0744d8fe4fde$var$_isRTL === undefined && doc) {
            $723d0744d8fe4fde$var$_isRTL = (doc.body && doc.body.getAttribute('dir') || doc.documentElement.getAttribute('dir')) === 'rtl';
            (0, $83a2b0773b0b5f26$export$64006deca925fb65)($723d0744d8fe4fde$var$_isRTL);
        }
    }
    return !!$723d0744d8fe4fde$var$_isRTL;
}
function $723d0744d8fe4fde$export$64006deca925fb65(isRTL, persistSetting) {
    if (persistSetting === void 0) persistSetting = false;
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    if (doc) doc.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    if (persistSetting) (0, $6e93d649f0f85bbf$export$8a8216c44337cd5)($723d0744d8fe4fde$var$RTL_LOCAL_STORAGE_KEY, isRTL ? '1' : '0');
    $723d0744d8fe4fde$var$_isRTL = isRTL;
    (0, $83a2b0773b0b5f26$export$64006deca925fb65)($723d0744d8fe4fde$var$_isRTL);
}
function $723d0744d8fe4fde$export$404175034cd47507(key, theme) {
    if (theme === void 0) theme = {};
    if ($723d0744d8fe4fde$export$b2303637e9533380(theme)) {
        if (key === (0, $c011a102064f82ea$export$ec835b702d42f3f0).left) key = (0, $c011a102064f82ea$export$ec835b702d42f3f0).right;
        else if (key === (0, $c011a102064f82ea$export$ec835b702d42f3f0).right) key = (0, $c011a102064f82ea$export$ec835b702d42f3f0).left;
    }
    return key;
}



var $d53776f84aaef75b$export$e6e34fd1f2686227 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b);


function $4ef47077a6518ef4$export$bb4665f044311879(type, props) {
    var children = [];
    for(var _i = 2; _i < arguments.length; _i++)children[_i - 2] = arguments[_i];
    var slotType = type;
    if (slotType.isSlot) {
        // Since we are bypassing createElement, use React.Children.toArray to make sure children are
        // properly assigned keys.
        // TODO: should this be mutating? does React mutate children subprop with createElement?
        // TODO: will toArray clobber existing keys?
        // TODO: React generates warnings because it doesn't detect hidden member _store that is set in createElement.
        //        Even children passed to createElement without keys don't generate this warning.
        //        Is there a better way to prevent slots from appearing in hierarchy? toArray doesn't address root issue.
        children = $acw62.Children.toArray(children);
        // TODO: There is something weird going on here with children embedded in props vs. rest args.
        // Comment out these lines to see. Make sure this function is doing the right things.
        if (children.length === 0) return slotType(props);
        return slotType((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
            children: children
        }));
    } else // TODO: Are there some cases where children should NOT be spread? Also, spreading reraises perf question.
    //        Children had to be spread to avoid breaking KeytipData in Toggle.view:
    //        react-dom.development.js:18931 Uncaught TypeError: children is not a function
    //        Without spread, function child is a child array of one element
    // TODO: is there a reason this can't be:
    // return React.createElement.apply(this, arguments);
    return $acw62.createElement.apply($acw62, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        type,
        props
    ], children, false));
}
function $4ef47077a6518ef4$export$d38cd72104c1f0e9(DefaultComponent, options) {
    if (options === void 0) options = {};
    var _a = options.defaultProp, defaultProp = _a === void 0 ? 'children' : _a;
    var result = function(componentProps, userProps, userSlotOptions, defaultStyles, theme) {
        // If they passed in raw JSX, just return that.
        if ($acw62.isValidElement(userProps)) return userProps;
        var flattenedUserProps = $4ef47077a6518ef4$var$_translateShorthand(defaultProp, userProps);
        var finalProps = $4ef47077a6518ef4$var$_constructFinalProps(defaultStyles, theme, componentProps, flattenedUserProps);
        if (userSlotOptions) {
            if (userSlotOptions.component) {
                // TODO: Remove cast if possible. This cast is needed because TS errors on the intrinsic portion of ReactType.
                // return <userSlotOptions.component {...finalProps} />;
                var UserComponent = userSlotOptions.component;
                return $acw62.createElement(UserComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, finalProps));
            }
            if (userSlotOptions.render) return userSlotOptions.render(finalProps, DefaultComponent);
        }
        return $acw62.createElement(DefaultComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, finalProps));
    };
    return result;
}
/**
 * Default factory for components without explicit factories.
 */ var $4ef47077a6518ef4$var$defaultFactory = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(type) {
    return $4ef47077a6518ef4$export$d38cd72104c1f0e9(type);
});
function $4ef47077a6518ef4$export$47dfb797b70c39e3(userProps, slots) {
    var result = {};
    // userProps already has default props mixed in by createComponent. Recast here to gain typing for this function.
    var mixedProps = userProps;
    var _loop_1 = function(name_1) {
        if (slots.hasOwnProperty(name_1)) {
            // This closure method requires the use of withSlots to prevent unnecessary rerenders. This is because React
            // detects each closure as a different component (since it is a new instance) from the previous one and then
            // forces a rerender of the entire slot subtree. For now, the only way to avoid this is to use withSlots, which
            // bypasses the call to React.createElement.
            var slot = function(componentProps) {
                var args = [];
                for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                if (args.length > 0) // If React.createElement is being incorrectly used with slots, there will be additional arguments.
                // We can detect these additional arguments and error on their presence.
                throw new Error('Any module using getSlots must use withSlots. Please see withSlots javadoc for more info.');
                // TODO: having TS infer types here seems to cause infinite loop.
                //   use explicit types or casting to preserve typing if possible.
                // TODO: this should be a lookup on TProps property instead of being TProps directly, which is probably
                //   causing the infinite loop
                return $4ef47077a6518ef4$var$_renderSlot(slots[name_1], // TODO: this cast to any is hiding a relationship issue between the first two args
                componentProps, mixedProps[name_1], mixedProps.slots && mixedProps.slots[name_1], // _defaultStyles should always be present, but a check for existence is added to make view tests
                // easier to use.
                mixedProps._defaultStyles && mixedProps._defaultStyles[name_1], mixedProps.theme);
            };
            slot.isSlot = true;
            result[name_1] = slot;
        }
    };
    for(var name_1 in slots)_loop_1(name_1);
    return result;
}
/**
 * Helper function that translates shorthand as needed.
 * @param defaultProp
 * @param slotProps
 */ function $4ef47077a6518ef4$var$_translateShorthand(defaultProp, slotProps) {
    var _a;
    var transformedProps;
    if (typeof slotProps === 'string' || typeof slotProps === 'number' || typeof slotProps === 'boolean') transformedProps = (_a = {}, _a[defaultProp] = slotProps, _a);
    else transformedProps = slotProps;
    return transformedProps;
}
/**
 * Helper function that constructs final styles and props given a series of props ordered by increasing priority.
 */ function $4ef47077a6518ef4$var$_constructFinalProps(defaultStyles, theme) {
    var allProps = [];
    for(var _i = 2; _i < arguments.length; _i++)allProps[_i - 2] = arguments[_i];
    var finalProps = {};
    var classNames = [];
    for(var _a = 0, allProps_1 = allProps; _a < allProps_1.length; _a++){
        var props = allProps_1[_a];
        classNames.push(props && props.className);
        (0, $d53776f84aaef75b$export$e6e34fd1f2686227)(finalProps, props);
    }
    finalProps.className = (0, $aa1d034ba9a4cf1b$export$f77a3199de250644)([
        defaultStyles,
        classNames
    ], {
        rtl: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme)
    });
    return finalProps;
}
/**
 * Render a slot given component and user props. Uses component factory if available, otherwise falls back
 * to default factory.
 * @param ComponentType Factory component type.
 * @param componentProps The properties passed into slot from within the component.
 * @param userProps The user properties passed in from outside of the component.
 */ function $4ef47077a6518ef4$var$_renderSlot(ComponentType, componentProps, userProps, slotOptions, defaultStyles, theme) {
    if (ComponentType.create !== undefined) return ComponentType.create(componentProps, userProps, slotOptions, defaultStyles);
    else // TODO: need to resolve typing / generic issues passing through memoizeFunction. for now, cast to 'unknown'
    return $4ef47077a6518ef4$var$defaultFactory(ComponentType)(componentProps, userProps, slotOptions, defaultStyles, theme);
}



function $8775c756093daf3d$export$60e54eaca7e7fb38(view, options) {
    if (options === void 0) options = {};
    var _a = options.factoryOptions, factoryOptions = _a === void 0 ? {} : _a;
    var defaultProp = factoryOptions.defaultProp;
    var ResultComponent = function(componentProps) {
        var settings = $8775c756093daf3d$var$_getCustomizations(options.displayName, $acw62.useContext((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3)), options.fields);
        var stateReducer = options.state;
        if (stateReducer) // Don't assume state will return all props, so spread useState result over component props.
        componentProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, componentProps), stateReducer(componentProps));
        var theme = componentProps.theme || settings.theme;
        var tokens = $8775c756093daf3d$var$_resolveTokens(componentProps, theme, options.tokens, settings.tokens, componentProps.tokens);
        var styles = $8775c756093daf3d$var$_resolveStyles(componentProps, theme, tokens, options.styles, settings.styles, componentProps.styles);
        var viewProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, componentProps), {
            styles: styles,
            tokens: tokens,
            _defaultStyles: styles,
            theme: theme
        });
        return view(viewProps);
    };
    ResultComponent.displayName = options.displayName || view.name;
    // If a shorthand prop is defined, create a factory for the component.
    // TODO: This shouldn't be a concern of createComponent.. factoryOptions should just be forwarded.
    //       Need to weigh creating default factories on component creation vs. memoizing them on use in slots.tsx.
    if (defaultProp) ResultComponent.create = (0, $4ef47077a6518ef4$export$d38cd72104c1f0e9)(ResultComponent, {
        defaultProp: defaultProp
    });
    (0, $d53776f84aaef75b$export$e6e34fd1f2686227)(ResultComponent, options.statics);
    // Later versions of TypeSript should allow us to merge objects in a type safe way and avoid this cast.
    return ResultComponent;
}
/**
 * Resolve all styles functions with both props and tokens and flatten results along with all styles objects.
 */ function $8775c756093daf3d$var$_resolveStyles(props, theme, tokens) {
    var allStyles = [];
    for(var _i = 3; _i < arguments.length; _i++)allStyles[_i - 3] = arguments[_i];
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc).apply(void 0, allStyles.map(function(styles) {
        return typeof styles === 'function' ? styles(props, theme, tokens) : styles;
    }));
}
/**
 * Resolve all tokens functions with props flatten results along with all tokens objects.
 */ function $8775c756093daf3d$var$_resolveTokens(props, theme) {
    var allTokens = [];
    for(var _i = 2; _i < arguments.length; _i++)allTokens[_i - 2] = arguments[_i];
    var tokens = {};
    for(var _a = 0, allTokens_1 = allTokens; _a < allTokens_1.length; _a++){
        var currentTokens = allTokens_1[_a];
        if (currentTokens) {
            // TODO: why is this cast needed? TS seems to think there is a (TToken | Function) union from somewhere.
            currentTokens = typeof currentTokens === 'function' ? currentTokens(props, theme) : currentTokens;
            if (Array.isArray(currentTokens)) currentTokens = $8775c756093daf3d$var$_resolveTokens.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props,
                theme
            ], currentTokens, false));
            (0, $d53776f84aaef75b$export$e6e34fd1f2686227)(tokens, currentTokens);
        }
    }
    return tokens;
}
/**
 * Helper function for calling Customizations.getSettings falling back to default fields.
 *
 * @param displayName Displayable name for component.
 * @param context React context passed to component containing contextual settings.
 * @param fields Optional list of properties to grab from global store and context.
 */ function $8775c756093daf3d$var$_getCustomizations(displayName, context, fields) {
    // TODO: do we want field props? should fields be part of IComponent and used here?
    // TODO: should we centrally define DefaultFields? (not exported from styling)
    // TODO: tie this array to ICustomizationProps, such that each array element is keyof ICustomizationProps
    var DefaultFields = [
        'theme',
        'styles',
        'tokens'
    ];
    return (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings(fields || DefaultFields, displayName, context.customizations);
}





var $c5e1b3c4dc63601c$export$cd63654593e982b8 = function(props) {
    // eslint-disable-next-line eqeqeq
    if (props.children == null) return null;
    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? 'span' : _a, variant = props.variant, nowrap = props.nowrap, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "block",
        "className",
        "as",
        "variant",
        "nowrap"
    ]);
    var Slots = (0, $4ef47077a6518ef4$export$47dfb797b70c39e3)(props, {
        root: RootType
    });
    return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(rest, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40))));
};


var $4862b3c0e20b96d3$export$3b0f27c60c314f21 = function(props, theme) {
    var as = props.as, className = props.className, block = props.block, nowrap = props.nowrap, variant = props.variant;
    var fonts = theme.fonts, semanticColors = theme.semanticColors;
    var variantObject = fonts[variant || 'medium'];
    return {
        root: [
            variantObject,
            {
                color: variantObject.color || semanticColors.bodyText,
                display: block ? as === 'td' ? 'table-cell' : 'block' : 'inline',
                mozOsxFontSmoothing: variantObject.MozOsxFontSmoothing,
                webkitFontSmoothing: variantObject.WebkitFontSmoothing
            },
            nowrap && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            className
        ]
    };
};


var $33ce6250cbba555f$export$5f1af8db9871e1d6 = (0, $8775c756093daf3d$export$60e54eaca7e7fb38)((0, $c5e1b3c4dc63601c$export$cd63654593e982b8), {
    displayName: 'Text',
    styles: (0, $4862b3c0e20b96d3$export$3b0f27c60c314f21)
});
var $33ce6250cbba555f$export$2e2bcd8739ae039 = $33ce6250cbba555f$export$5f1af8db9871e1d6;



var $acw62 = parcelRequire("acw62");

const $880657b9bb955411$var$Trophy2Icon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1792 256q27 0 50 10t40 27 28 41 10 50v192q0 86-30 163t-85 137-127 98-159 48q-19 62-51 116t-76 98-97 77-114 56q35 34 58 76t35 91h70q40 0 75 15t61 41 41 61 15 75v192H384v-192q0-40 15-75t41-61 61-41 75-15h70q11-48 34-90t59-77q-61-22-114-55t-96-78-76-98-52-116q-86-9-159-47t-127-99-84-137T0 576V384q0-27 10-50t27-40 41-28 50-10h256V128h1152v128h256zm-1280 0v128h896V256H512zM128 576q0 57 19 109t53 93 81 71 103 41V384H128v192zm1280 1152q0-26-19-45t-45-19H576q-26 0-45 19t-19 45v64h896v-64zm-267-192q-10-29-28-52t-42-41-52-26-59-9q-30 0-58 9t-53 26-42 40-28 53h362zm-181-256q81 0 161-27t144-76 103-121 40-160V512H512v384q0 89 39 160t103 120 144 77 162 27zm832-896h-256v506q56-12 103-41t81-70 53-94 19-109V384z"
        })),
    displayName: 'Trophy2Icon'
});
var $880657b9bb955411$export$2e2bcd8739ae039 = $880657b9bb955411$var$Trophy2Icon;


var $acw62 = parcelRequire("acw62");

const $ac42e68e97b5a53b$var$Trophy2SolidIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M640 1536q0-62 29-109t76-80 103-50 112-17q55 0 111 17t103 49 76 80 30 110H640zm864 128q13 0 22 9t10 23v224H384v-224q0-13 9-22t23-10h1088zm288-1408q27 0 50 10t40 27 28 41 10 50v192q0 98-36 180t-98 141-147 93-180 34q-41 62-96 110t-121 80-137 49-145 17q-74 0-145-16t-137-49-120-81-97-110q-96 0-180-33t-146-93-99-142T0 576V384q0-27 10-50t27-40 41-28 50-10h256V128h1152v128h256zM384 384H128v192q0 57 19 109t53 93 81 71 103 41V384zm1408 0h-256v506q56-12 103-41t81-70 53-94 19-109V384z"
        })),
    displayName: 'Trophy2SolidIcon'
});
var $ac42e68e97b5a53b$export$2e2bcd8739ae039 = $ac42e68e97b5a53b$var$Trophy2SolidIcon;


class $f7514c45a7d5f305$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const achievements = this.props.engine.list();
        const dateFormatter = new Intl.DateTimeFormat([], {
            dateStyle: 'long'
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
            className: "achievementsPanel",
            children: Object.entries(achievements).map(([name, achievement])=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    className: achievement.achievedOn ? 'achieved' : 'notAchieved',
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "trophyIcon",
                            children: achievement.achievedOn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac42e68e97b5a53b$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $880657b9bb955411$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "achievementTitle",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                                        variant: "mediumPlus",
                                        style: {
                                            fontWeight: 'bold'
                                        },
                                        children: achievement.link ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: achievement.link,
                                            target: "_blank",
                                            rel: "noreferrer noopener",
                                            children: achievement.name
                                        }) : achievement.name
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                                    className: "achievementDescription",
                                    children: achievement.secret && !achievement.achievedOn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        children: "This is a secret achievement"
                                    }) : achievement.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                                        children: achievement.achievedOn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                "You first achieved this on",
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("time", {
                                                    dateTime: achievement.achievedOn.toISOString(),
                                                    title: achievement.achievedOn.toISOString(),
                                                    children: dateFormatter.format(achievement.achievedOn)
                                                })
                                            ]
                                        }) : `Not achieved yet`
                                    })
                                })
                            ]
                        })
                    ]
                }, name);
            })
        });
    }
}




var $acw62 = parcelRequire("acw62");
class $e241e8c3cc886a95$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    componentDidCatch(error) {
        this.setState({
            error: error
        });
        console.error(error);
    }
    render() {
        if (this.state.error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "Something went wrong"
        });
        return this.props.children;
    }
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $c8ba3406398cf124$var$noop = function() {
    return false;
};
var $c8ba3406398cf124$var$noopShadow = function() {
    return 0, $c9c2f6e9ef06bed5$export$d2afb82ff2b52633;
};
var $c8ba3406398cf124$var$noopRootStylesheets = function() {
    return new Map();
};
var $c8ba3406398cf124$var$noopUndefined = function() {
    return undefined;
};
var $c8ba3406398cf124$export$af2bad7303295083 = function() {
    return {
        stylesheets: new Map(),
        useAdoptedStylesheetEx: $c8ba3406398cf124$var$noop,
        useAdoptedStylesheet: $c8ba3406398cf124$var$noop,
        useShadowConfig: $c8ba3406398cf124$var$noopShadow,
        useMergeStylesShadowRootContext: $c8ba3406398cf124$var$noopUndefined,
        useHasMergeStylesShadowRootContext: $c8ba3406398cf124$var$noop,
        useMergeStylesRootStylesheets: $c8ba3406398cf124$var$noopRootStylesheets,
        useWindow: $c8ba3406398cf124$var$noopUndefined,
        useStyled: $c8ba3406398cf124$var$noopUndefined
    };
};
var $c8ba3406398cf124$export$69356112b16746e6 = $acw62.createContext($c8ba3406398cf124$export$af2bad7303295083());


var $a76127aad685aec8$export$c700cc7ea3d01c27 = function() {
    var ctx = $acw62.useContext((0, $c8ba3406398cf124$export$69356112b16746e6));
    return {
        useAdoptedStylesheet: ctx.useAdoptedStylesheet,
        useAdoptedStylesheetEx: ctx.useAdoptedStylesheetEx,
        useShadowConfig: ctx.useShadowConfig,
        useMergeStylesShadowRootContext: ctx.useMergeStylesShadowRootContext,
        useHasMergeStylesShadowRootContext: ctx.useHasMergeStylesShadowRootContext,
        useMergeStylesRootStylesheets: ctx.useMergeStylesRootStylesheets,
        useWindow: ctx.useWindow,
        useStyled: ctx.useStyled
    };
};



var $acw62 = parcelRequire("acw62");


function $2a04d28498bd59af$export$e00cde8527a0be3f(properties, scopeName) {
    var forceUpdate = $2a04d28498bd59af$var$useForceUpdate();
    var customizations = $acw62.useContext((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3)).customizations;
    var inCustomizerContext = customizations.inCustomizerContext;
    $acw62.useEffect(function() {
        if (!inCustomizerContext) (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).observe(forceUpdate);
        return function() {
            if (!inCustomizerContext) (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).unobserve(forceUpdate);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude forceUpdate
    }, [
        inCustomizerContext
    ]);
    return (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings(properties, scopeName, customizations);
}
function $2a04d28498bd59af$var$useForceUpdate() {
    var _a = $acw62.useState(0), setValue = _a[1];
    return function() {
        return setValue(function(value) {
            return ++value;
        });
    };
}


var $8af9a8c8d5cac055$var$DefaultFields = [
    'theme',
    'styles'
];
function $8af9a8c8d5cac055$export$3817b7a54a07cec7(Component, baseStyles, getProps, customizable, pure) {
    customizable = customizable || {
        scope: '',
        fields: undefined
    };
    var scope = customizable.scope, _a = customizable.fields, fields = _a === void 0 ? $8af9a8c8d5cac055$var$DefaultFields : _a;
    var Wrapped = $acw62.forwardRef(function(props, forwardedRef) {
        var styles = $acw62.useRef(undefined);
        var settings = (0, $2a04d28498bd59af$export$e00cde8527a0be3f)(fields, scope);
        var customizedStyles = settings.styles, dir = settings.dir, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(settings, [
            "styles",
            "dir"
        ]);
        var additionalProps = getProps ? getProps(props) : undefined;
        var useStyled = (0, $a76127aad685aec8$export$c700cc7ea3d01c27)().useStyled;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var cache = styles.current && styles.current.__cachedInputs__ || [];
        var propStyles = props.styles;
        if (!styles.current || customizedStyles !== cache[1] || propStyles !== cache[2]) {
            // Using styled components as the Component arg will result in nested styling arrays.
            // The function can be cached and in order to prevent the props from being retained within it's closure
            // we pass in just the styles and not the entire props
            var concatenatedStyles = function(styleProps) {
                return (0, $386ae5a2cd0e8632$export$5136bfd779f95982)(styleProps, baseStyles, customizedStyles, propStyles);
            };
            // The __cachedInputs__ array is attached to the function and consumed by the
            // classNamesFunction as a list of keys to include for memoizing classnames.
            concatenatedStyles.__cachedInputs__ = [
                baseStyles,
                customizedStyles,
                propStyles
            ];
            concatenatedStyles.__noStyleOverride__ = !customizedStyles && !propStyles;
            styles.current = concatenatedStyles;
        }
        styles.current.__shadowConfig__ = useStyled(scope);
        return $acw62.createElement(Component, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            ref: forwardedRef
        }, rest, additionalProps, props, {
            styles: styles.current
        }));
    });
    // Function.prototype.name is an ES6 feature, so the cast to any is required until we're
    // able to drop IE 11 support and compile with ES6 libs
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Wrapped.displayName = "Styled".concat(Component.displayName || Component.name);
    // This preserves backwards compatibility.
    var pureComponent = pure ? $acw62.memo(Wrapped) : Wrapped;
    // Check if the wrapper has a displayName after it has been memoized. Then assign it to the pure component.
    if (Wrapped.displayName) pureComponent.displayName = Wrapped.displayName;
    return pureComponent;
}




var $acw62 = parcelRequire("acw62");



var $f64c8e86ac270e43$var$MAX_CACHE_COUNT = 50;
var $f64c8e86ac270e43$var$DEFAULT_SPECIFICITY_MULTIPLIER = 5;
var $f64c8e86ac270e43$var$_memoizedClassNames = 0;
var $f64c8e86ac270e43$var$stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
if ($f64c8e86ac270e43$var$stylesheet && $f64c8e86ac270e43$var$stylesheet.onReset) $f64c8e86ac270e43$var$stylesheet.onReset(function() {
    return $f64c8e86ac270e43$var$_memoizedClassNames++;
});
// Note that because of the caching nature within the classNames memoization,
// I've disabled this rule to simply be able to work with any types.
/* eslint-disable @typescript-eslint/no-explicit-any */ // This represents a prop we attach to each Map to indicate the cached return value
// associated with the graph node.
var $f64c8e86ac270e43$var$retVal = '__retval__';
function $f64c8e86ac270e43$export$8584b618c75d395d(options) {
    // We build a trie where each node is a Map. The map entry key represents an argument
    // value, and the entry value is another node (Map). Each node has a `__retval__`
    // property which is used to hold the cached response.
    if (options === void 0) options = {};
    // To derive the response, we can simply ensure the arguments are added or already
    // exist in the trie. At the last node, if there is a `__retval__` we return that. Otherwise
    // we call the `getStyles` api to evaluate, cache on the property, and return that.
    // let map: IRecursiveMemoNode = new Map();
    var windowMap = new Map();
    var styleCalcCount = 0;
    var getClassNamesCount = 0;
    var currentMemoizedClassNames = $f64c8e86ac270e43$var$_memoizedClassNames;
    var getClassNames = function(styleFunctionOrObject, styleProps) {
        var _a;
        if (styleProps === void 0) styleProps = {};
        // If useStaticStyles is true, styleFunctionOrObject returns slot to classname mappings.
        // If there is also no style overrides, we can skip merge styles completely and
        // simply return the result from the style funcion.
        if (options.useStaticStyles && typeof styleFunctionOrObject === 'function' && styleFunctionOrObject.__noStyleOverride__) return styleFunctionOrObject(styleProps);
        getClassNamesCount++;
        var shadowConfig = styleFunctionOrObject ? styleFunctionOrObject.__shadowConfig__ : undefined;
        var key = shadowConfig && shadowConfig.window ? shadowConfig.window : '__default__';
        if (!windowMap.has(key)) windowMap.set(key, new Map());
        var current = windowMap.get(key);
        // let current: Map<any, any> = map;
        var theme = styleProps.theme;
        var rtl = theme && theme.rtl !== undefined ? theme.rtl : (0, $723d0744d8fe4fde$export$b2303637e9533380)();
        var disableCaching = options.disableCaching;
        // On reset of our stylesheet, reset memoized cache.
        if (currentMemoizedClassNames !== $f64c8e86ac270e43$var$_memoizedClassNames) {
            currentMemoizedClassNames = $f64c8e86ac270e43$var$_memoizedClassNames;
            // map = new Map();
            windowMap.set(key, new Map());
            current = windowMap.get(key);
            styleCalcCount = 0;
        }
        if (!options.disableCaching) {
            current = $f64c8e86ac270e43$var$_traverseMap(windowMap.get(key), styleFunctionOrObject);
            current = $f64c8e86ac270e43$var$_traverseMap(current, styleProps);
        }
        if (disableCaching || !current[$f64c8e86ac270e43$var$retVal]) {
            if (styleFunctionOrObject === undefined) current[$f64c8e86ac270e43$var$retVal] = {};
            else current[$f64c8e86ac270e43$var$retVal] = (0, $00784e00f3e28b27$export$3ea21144e9973d29)([
                typeof styleFunctionOrObject === 'function' ? styleFunctionOrObject(styleProps) : styleFunctionOrObject
            ], {
                shadowConfig: styleFunctionOrObject.__shadowConfig__,
                rtl: !!rtl,
                specificityMultiplier: options.useStaticStyles ? $f64c8e86ac270e43$var$DEFAULT_SPECIFICITY_MULTIPLIER : undefined
            });
            if (!disableCaching) styleCalcCount++;
        }
        if (styleCalcCount > (options.cacheSize || $f64c8e86ac270e43$var$MAX_CACHE_COUNT)) {
            var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
            if ((_a = win === null || win === void 0 ? void 0 : win.FabricConfig) === null || _a === void 0 ? void 0 : _a.enableClassNameCacheFullWarning) {
                // eslint-disable-next-line no-console
                console.warn("Styles are being recalculated too frequently. Cache miss rate is ".concat(styleCalcCount, "/").concat(getClassNamesCount, "."));
                // eslint-disable-next-line no-console
                console.trace();
            }
            windowMap.get(key).clear();
            styleCalcCount = 0;
            // Mutate the options passed in, that's all we can do.
            options.disableCaching = true;
        }
        // Note: the retVal is an attached property on the Map; not a key in the Map. We use this attached property to
        // cache the return value for this branch of the graph.
        return current[$f64c8e86ac270e43$var$retVal];
    };
    return getClassNames;
}
function $f64c8e86ac270e43$var$_traverseEdge(current, value) {
    value = $f64c8e86ac270e43$var$_normalizeValue(value);
    if (!current.has(value)) current.set(value, new Map());
    return current.get(value);
}
function $f64c8e86ac270e43$var$_traverseMap(current, inputs) {
    if (typeof inputs === 'function') {
        var cachedInputsFromStyled = inputs.__cachedInputs__;
        if (cachedInputsFromStyled) // The styled helper will generate the styles function and will attach the cached
        // inputs (consisting of the default styles, customzied styles, and user provided styles.)
        // These should be used as cache keys for deriving the memoized value.
        for(var _i = 0, _a = inputs.__cachedInputs__; _i < _a.length; _i++){
            var input = _a[_i];
            current = $f64c8e86ac270e43$var$_traverseEdge(current, input);
        }
        else current = $f64c8e86ac270e43$var$_traverseEdge(current, inputs);
    } else if (typeof inputs === 'object') {
        for(var propName in inputs)if (inputs.hasOwnProperty(propName)) current = $f64c8e86ac270e43$var$_traverseEdge(current, inputs[propName]);
    }
    return current;
}
function $f64c8e86ac270e43$var$_normalizeValue(value) {
    switch(value){
        case undefined:
            return '__undefined__';
        case null:
            return '__null__';
        default:
            return value;
    }
}


var $bffbc12413005587$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)({
    // Label is used a lot by other components.
    // It's likely to see expected cases which pass different className to the Label.
    // Therefore setting a larger cache size.
    cacheSize: 100
});
var $bffbc12413005587$export$31008ffe97c96a49 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LabelBase, _super);
    function LabelBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelBase.prototype.render = function() {
        var _a = this.props, _b = _a.as, RootType = _b === void 0 ? 'label' : _b, children = _a.children, className = _a.className, disabled = _a.disabled, styles = _a.styles, required = _a.required, theme = _a.theme;
        var classNames = $bffbc12413005587$var$getClassNames(styles, {
            className: className,
            disabled: disabled,
            required: required,
            theme: theme
        });
        return $acw62.createElement(RootType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
            className: classNames.root
        }), children);
    };
    return LabelBase;
}($acw62.Component);




var $3e06d26ec4cbb954$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var theme = props.theme, className = props.className, disabled = props.disabled, required = props.required;
    var semanticColors = theme.semanticColors;
    // Tokens
    var labelFontWeight = (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold;
    var labelColor = semanticColors.bodyText;
    var labelDisabledColor = semanticColors.disabledBodyText;
    var labelRequiredStarColor = semanticColors.errorText;
    return {
        root: [
            'ms-Label',
            theme.fonts.medium,
            {
                fontWeight: labelFontWeight,
                color: labelColor,
                boxSizing: 'border-box',
                boxShadow: 'none',
                margin: 0,
                display: 'block',
                padding: '5px 0',
                wordWrap: 'break-word',
                overflowWrap: 'break-word'
            },
            disabled && {
                color: labelDisabledColor,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    color: 'GrayText'
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _a)
            },
            required && {
                selectors: {
                    '::after': {
                        content: "' *'",
                        color: labelRequiredStarColor,
                        paddingRight: 12
                    }
                }
            },
            className
        ]
    };
};


var $dd965dd4d4e16b95$export$b04be29aa201d4f5 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $bffbc12413005587$export$31008ffe97c96a49), (0, $3e06d26ec4cbb954$export$ffd58b7f6f099a57), undefined, {
    scope: 'Label'
});




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


// Initialize global window id.
var $532a46d3b196c0f3$var$CURRENT_ID_PROPERTY = '__currentId__';
var $532a46d3b196c0f3$var$DEFAULT_ID_STRING = 'id__';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $532a46d3b196c0f3$var$_global = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)() || {};
if ($532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY] === undefined) $532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY] = 0;
var $532a46d3b196c0f3$var$_initializedStylesheetResets = false;
function $532a46d3b196c0f3$export$218c8c3169c024d2(prefix) {
    if (!$532a46d3b196c0f3$var$_initializedStylesheetResets) {
        // Configure ids to reset on stylesheet resets.
        var stylesheet = (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance();
        if (stylesheet && stylesheet.onReset) stylesheet.onReset($532a46d3b196c0f3$export$4cc3052e36a312db);
        $532a46d3b196c0f3$var$_initializedStylesheetResets = true;
    }
    var index = $532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY]++;
    return (prefix === undefined ? $532a46d3b196c0f3$var$DEFAULT_ID_STRING : prefix) + index;
}
function $532a46d3b196c0f3$export$4cc3052e36a312db(counter) {
    if (counter === void 0) counter = 0;
    $532a46d3b196c0f3$var$_global[$532a46d3b196c0f3$var$CURRENT_ID_PROPERTY] = counter;
}


function $cd7f9b753e2e3aa8$export$f680877a34711e37(prefix, providedId) {
    // getId should only be called once since it updates the global constant for the next ID value.
    // (While an extra update isn't likely to cause problems in practice, it's better to avoid it.)
    var ref = $acw62.useRef(providedId);
    if (!ref.current) ref.current = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)(prefix);
    return ref.current;
}



function $9d47dbd69e7cba76$export$8f36788a39deb482(componentName, props, deprecationMap) {
    var propName, deprecationMessage, replacementPropName;
}





var $a6a15e2533bfbd6b$export$2ecde6259cbd2585 = {
    root: 'ms-StackItem'
};
var $a6a15e2533bfbd6b$var$alignMap = {
    start: 'flex-start',
    end: 'flex-end'
};
var $a6a15e2533bfbd6b$export$180f1ee1f54d2183 = function(props, theme, tokens) {
    var grow = props.grow, shrink = props.shrink, disableShrink = props.disableShrink, align = props.align, verticalFill = props.verticalFill, order = props.order, className = props.className, _a = props.basis, basis = _a === void 0 ? 'auto' : _a;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($a6a15e2533bfbd6b$export$2ecde6259cbd2585, theme);
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            {
                flexBasis: basis,
                margin: tokens.margin,
                padding: tokens.padding,
                height: verticalFill ? '100%' : 'auto',
                width: 'auto'
            },
            grow && {
                flexGrow: grow === true ? 1 : grow
            },
            (disableShrink || !grow && !shrink) && {
                flexShrink: 0
            },
            shrink && !disableShrink && {
                flexShrink: 1
            },
            align && {
                alignSelf: $a6a15e2533bfbd6b$var$alignMap[align] || align
            },
            order && {
                order: order
            },
            className
        ]
    };
};


// Helper function that converts a themed spacing key (if given) to the corresponding themed spacing value.
var $de2b55cd863af155$var$_getThemedSpacing = function(space, theme) {
    if (theme.spacing.hasOwnProperty(space)) return theme.spacing[space];
    return space;
};
// Helper function that takes a gap as a string and converts it into a { value, unit } representation.
var $de2b55cd863af155$var$_getValueUnitGap = function(gap) {
    var numericalPart = parseFloat(gap);
    var numericalValue = isNaN(numericalPart) ? 0 : numericalPart;
    var numericalString = isNaN(numericalPart) ? '' : numericalPart.toString();
    var unitPart = gap.substring(numericalString.toString().length);
    return {
        value: numericalValue,
        unit: unitPart || 'px'
    };
};
var $de2b55cd863af155$export$639eae2f079cf37f = function(gap, theme) {
    if (gap === undefined || gap === '') return {
        rowGap: {
            value: 0,
            unit: 'px'
        },
        columnGap: {
            value: 0,
            unit: 'px'
        }
    };
    if (typeof gap === 'number') return {
        rowGap: {
            value: gap,
            unit: 'px'
        },
        columnGap: {
            value: gap,
            unit: 'px'
        }
    };
    var splitGap = gap.split(' ');
    // If the array has more than two values, then return 0px.
    if (splitGap.length > 2) return {
        rowGap: {
            value: 0,
            unit: 'px'
        },
        columnGap: {
            value: 0,
            unit: 'px'
        }
    };
    // If the array has two values, then parse each one.
    if (splitGap.length === 2) return {
        rowGap: $de2b55cd863af155$var$_getValueUnitGap($de2b55cd863af155$var$_getThemedSpacing(splitGap[0], theme)),
        columnGap: $de2b55cd863af155$var$_getValueUnitGap($de2b55cd863af155$var$_getThemedSpacing(splitGap[1], theme))
    };
    // Else, parse the numerical value and pass it as both the vertical and horizontal gap.
    var calculatedGap = $de2b55cd863af155$var$_getValueUnitGap($de2b55cd863af155$var$_getThemedSpacing(gap, theme));
    return {
        rowGap: calculatedGap,
        columnGap: calculatedGap
    };
};
var $de2b55cd863af155$export$4bc3c325941e6f67 = function(padding, theme) {
    if (padding === undefined || typeof padding === 'number' || padding === '') return padding;
    var paddingValues = padding.split(' ');
    if (paddingValues.length < 2) return $de2b55cd863af155$var$_getThemedSpacing(padding, theme);
    return paddingValues.reduce(function(padding1, padding2) {
        return $de2b55cd863af155$var$_getThemedSpacing(padding1, theme) + ' ' + $de2b55cd863af155$var$_getThemedSpacing(padding2, theme);
    });
};


var $ce115449bc17fcbf$var$nameMap = {
    start: 'flex-start',
    end: 'flex-end'
};
var $ce115449bc17fcbf$export$2ecde6259cbd2585 = {
    root: 'ms-Stack',
    inner: 'ms-Stack-inner',
    child: 'ms-Stack-child'
};
var $ce115449bc17fcbf$export$9dd6ff9ea0189349 = function(props, theme, tokens) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var className = props.className, disableShrink = props.disableShrink, enableScopedSelectors = props.enableScopedSelectors, grow = props.grow, horizontal = props.horizontal, horizontalAlign = props.horizontalAlign, reversed = props.reversed, verticalAlign = props.verticalAlign, verticalFill = props.verticalFill, wrap = props.wrap;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($ce115449bc17fcbf$export$2ecde6259cbd2585, theme);
    /*  eslint-disable @typescript-eslint/no-deprecated */ var childrenGap = tokens && tokens.childrenGap ? tokens.childrenGap : props.gap;
    var maxHeight = tokens && tokens.maxHeight ? tokens.maxHeight : props.maxHeight;
    var maxWidth = tokens && tokens.maxWidth ? tokens.maxWidth : props.maxWidth;
    var padding = tokens && tokens.padding ? tokens.padding : props.padding;
    /* eslint-enable @typescript-eslint/no-deprecated */ var _p = (0, $de2b55cd863af155$export$639eae2f079cf37f)(childrenGap, theme), rowGap = _p.rowGap, columnGap = _p.columnGap;
    var horizontalMargin = "".concat(-0.5 * columnGap.value).concat(columnGap.unit);
    var verticalMargin = "".concat(-0.5 * rowGap.value).concat(rowGap.unit);
    // styles to be applied to all direct children regardless of wrap or direction
    var childStyles = {
        textOverflow: 'ellipsis'
    };
    var childSelector = '> ' + (enableScopedSelectors ? '.' + $ce115449bc17fcbf$export$2ecde6259cbd2585.child : '*');
    var disableShrinkStyles = (_a = {}, // flexShrink styles are applied by the StackItem
    _a["".concat(childSelector, ":not(.").concat((0, $a6a15e2533bfbd6b$export$2ecde6259cbd2585).root, ")")] = {
        flexShrink: 0
    }, _a);
    if (wrap) return {
        root: [
            classNames.root,
            {
                flexWrap: 'wrap',
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                width: 'auto',
                overflow: 'visible',
                height: '100%'
            },
            horizontalAlign && (_b = {}, _b[horizontal ? 'justifyContent' : 'alignItems'] = $ce115449bc17fcbf$var$nameMap[horizontalAlign] || horizontalAlign, _b),
            verticalAlign && (_c = {}, _c[horizontal ? 'alignItems' : 'justifyContent'] = $ce115449bc17fcbf$var$nameMap[verticalAlign] || verticalAlign, _c),
            className,
            {
                // not allowed to be overridden by className
                // since this is necessary in order to prevent collapsing margins
                display: 'flex'
            },
            horizontal && {
                height: verticalFill ? '100%' : 'auto'
            }
        ],
        inner: [
            classNames.inner,
            (_d = {
                display: 'flex',
                flexWrap: 'wrap',
                marginLeft: horizontalMargin,
                marginRight: horizontalMargin,
                marginTop: verticalMargin,
                marginBottom: verticalMargin,
                overflow: 'visible',
                boxSizing: 'border-box',
                padding: (0, $de2b55cd863af155$export$4bc3c325941e6f67)(padding, theme),
                // avoid unnecessary calc() calls if horizontal gap is 0
                width: columnGap.value === 0 ? '100%' : "calc(100% + ".concat(columnGap.value).concat(columnGap.unit, ")"),
                maxWidth: '100vw'
            }, _d[childSelector] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                margin: "".concat(0.5 * rowGap.value).concat(rowGap.unit, " ").concat(0.5 * columnGap.value).concat(columnGap.unit)
            }, childStyles), _d),
            disableShrink && disableShrinkStyles,
            horizontalAlign && (_e = {}, _e[horizontal ? 'justifyContent' : 'alignItems'] = $ce115449bc17fcbf$var$nameMap[horizontalAlign] || horizontalAlign, _e),
            verticalAlign && (_f = {}, _f[horizontal ? 'alignItems' : 'justifyContent'] = $ce115449bc17fcbf$var$nameMap[verticalAlign] || verticalAlign, _f),
            horizontal && (_g = {
                flexDirection: reversed ? 'row-reverse' : 'row',
                // avoid unnecessary calc() calls if vertical gap is 0
                height: rowGap.value === 0 ? '100%' : "calc(100% + ".concat(rowGap.value).concat(rowGap.unit, ")")
            }, _g[childSelector] = {
                maxWidth: columnGap.value === 0 ? '100%' : "calc(100% - ".concat(columnGap.value).concat(columnGap.unit, ")")
            }, _g),
            !horizontal && (_h = {
                flexDirection: reversed ? 'column-reverse' : 'column',
                height: "calc(100% + ".concat(rowGap.value).concat(rowGap.unit, ")")
            }, _h[childSelector] = {
                maxHeight: rowGap.value === 0 ? '100%' : "calc(100% - ".concat(rowGap.value).concat(rowGap.unit, ")")
            }, _h)
        ]
    };
    return {
        root: [
            classNames.root,
            (_j = {
                display: 'flex',
                flexDirection: horizontal ? reversed ? 'row-reverse' : 'row' : reversed ? 'column-reverse' : 'column',
                flexWrap: 'nowrap',
                width: 'auto',
                height: verticalFill ? '100%' : 'auto',
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                padding: (0, $de2b55cd863af155$export$4bc3c325941e6f67)(padding, theme),
                boxSizing: 'border-box'
            }, _j[childSelector] = childStyles, _j),
            disableShrink && disableShrinkStyles,
            grow && {
                flexGrow: grow === true ? 1 : grow
            },
            horizontalAlign && (_k = {}, _k[horizontal ? 'justifyContent' : 'alignItems'] = $ce115449bc17fcbf$var$nameMap[horizontalAlign] || horizontalAlign, _k),
            verticalAlign && (_l = {}, _l[horizontal ? 'alignItems' : 'justifyContent'] = $ce115449bc17fcbf$var$nameMap[verticalAlign] || verticalAlign, _l),
            horizontal && columnGap.value > 0 && (_m = {}, // apply gap margin to every direct child except the first direct child if the direction is not reversed,
            // and the last direct one if it is
            _m[reversed ? "".concat(childSelector, ":not(:last-child)") : "".concat(childSelector, ":not(:first-child)")] = {
                marginLeft: "".concat(columnGap.value).concat(columnGap.unit)
            }, _m),
            !horizontal && rowGap.value > 0 && (_o = {}, // apply gap margin to every direct child except the first direct child if the direction is not reversed,
            // and the last direct one if it is
            _o[reversed ? "".concat(childSelector, ":not(:last-child)") : "".concat(childSelector, ":not(:first-child)")] = {
                marginTop: "".concat(rowGap.value).concat(rowGap.unit)
            }, _o),
            className
        ]
    };
};






var $5ed43aff81d2044b$var$StackItemView = function(props) {
    var children = props.children;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
    // eslint-disable-next-line eqeqeq
    if (children == null) return null;
    var Slots = (0, $4ef47077a6518ef4$export$47dfb797b70c39e3)(props, {
        root: 'div'
    });
    return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps), children);
};
var $5ed43aff81d2044b$export$50d5391cd1a018c6 = (0, $8775c756093daf3d$export$60e54eaca7e7fb38)($5ed43aff81d2044b$var$StackItemView, {
    displayName: 'StackItem',
    styles: (0, $a6a15e2533bfbd6b$export$180f1ee1f54d2183)
});
var $5ed43aff81d2044b$export$2e2bcd8739ae039 = $5ed43aff81d2044b$export$50d5391cd1a018c6;


var $96647f41d860b545$var$StackView = function(props) {
    var _a = props.as, RootType = _a === void 0 ? 'div' : _a, _b = props.disableShrink, disableShrink = _b === void 0 ? false : _b, // eslint-disable-next-line @typescript-eslint/no-deprecated
    _c = props.doNotRenderFalsyValues, // eslint-disable-next-line @typescript-eslint/no-deprecated
    doNotRenderFalsyValues = _c === void 0 ? false : _c, _d = props.enableScopedSelectors, enableScopedSelectors = _d === void 0 ? false : _d, wrap = props.wrap, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "as",
        "disableShrink",
        "doNotRenderFalsyValues",
        "enableScopedSelectors",
        "wrap"
    ]);
    (0, $9d47dbd69e7cba76$export$8f36788a39deb482)('Stack', props, {
        gap: 'tokens.childrenGap',
        maxHeight: 'tokens.maxHeight',
        maxWidth: 'tokens.maxWidth',
        padding: 'tokens.padding'
    });
    var stackInnerId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)('stack-inner');
    var stackChildren = $96647f41d860b545$var$_processStackChildren(props.children, {
        disableShrink: disableShrink,
        enableScopedSelectors: enableScopedSelectors,
        doNotRenderFalsyValues: doNotRenderFalsyValues
    });
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(rest, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
    var Slots = (0, $4ef47077a6518ef4$export$47dfb797b70c39e3)(props, {
        root: RootType,
        inner: 'div'
    });
    if (wrap) return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps), (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.inner, {
        key: stackInnerId
    }, stackChildren));
    return (0, $4ef47077a6518ef4$export$bb4665f044311879)(Slots.root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, nativeProps), stackChildren);
};
function $96647f41d860b545$var$_processStackChildren(children, _a) {
    var disableShrink = _a.disableShrink, enableScopedSelectors = _a.enableScopedSelectors, doNotRenderFalsyValues = _a.doNotRenderFalsyValues;
    var childrenArray = $acw62.Children.toArray(children);
    childrenArray = $acw62.Children.map(childrenArray, function(child) {
        if (!child) return doNotRenderFalsyValues ? null : child;
        // We need to allow children that aren't falsy values, but not valid elements since they could be
        // a string like <Stack>{'sample string'}</Stack>
        if (!$acw62.isValidElement(child)) return child;
        if (child.type === $acw62.Fragment) {
            var fragmentChild = child;
            return fragmentChild.props.children ? $96647f41d860b545$var$_processStackChildren(fragmentChild.props.children, {
                disableShrink: disableShrink,
                enableScopedSelectors: enableScopedSelectors,
                doNotRenderFalsyValues: doNotRenderFalsyValues
            }) : null;
        }
        var childAsReactElement = child;
        var defaultItemProps = {};
        if ($96647f41d860b545$var$_isStackItem(child)) defaultItemProps = {
            shrink: !disableShrink
        };
        var childClassName = childAsReactElement.props.className;
        return $acw62.cloneElement(childAsReactElement, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultItemProps), childAsReactElement.props), childClassName && {
            className: childClassName
        }), enableScopedSelectors && {
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)((0, $ce115449bc17fcbf$export$2ecde6259cbd2585).child, childClassName)
        }));
    });
    return childrenArray;
}
function $96647f41d860b545$var$_isStackItem(item) {
    // In theory, we should be able to just check item.type === StackItem.
    // However, under certain unclear circumstances (see https://github.com/microsoft/fluentui/issues/10785),
    // the object identity is different despite the function implementation being the same.
    return !!item && typeof item === 'object' && !!item.type && // StackItem is generated by createComponent, so we need to check its displayName instead of name
    item.type.displayName === (0, $5ed43aff81d2044b$export$50d5391cd1a018c6).displayName;
}
var $96647f41d860b545$var$StackStatics = {
    Item: (0, $5ed43aff81d2044b$export$50d5391cd1a018c6)
};
var $96647f41d860b545$export$694e0d28c7ffc90c = (0, $8775c756093daf3d$export$60e54eaca7e7fb38)($96647f41d860b545$var$StackView, {
    displayName: 'Stack',
    styles: (0, $ce115449bc17fcbf$export$9dd6ff9ea0189349),
    statics: $96647f41d860b545$var$StackStatics
});
var $96647f41d860b545$export$2e2bcd8739ae039 = $96647f41d860b545$export$694e0d28c7ffc90c;



var $acw62 = parcelRequire("acw62");

const $6bab4c16a5a172a0$var$KeyboardClassicIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1783 384q30 0 55 12t43 31 28 46 11 55v864q0 29-10 55t-29 45-43 32-55 12H137q-30 0-55-12t-43-31-28-46-11-55V528q0-28 10-54t29-46 43-32 55-12h1646zm9 144q0-11-9-16H137q-9 5-9 16v864q0 11 9 16h1646q9-5 9-16V528zM384 768H256V640h128v128zM256 896h256v128H256V896zm1152 0h256v128h-256V896zm0 256h256v128h-256v-128zm-1152 0h256v128H256v-128zm384 0h640v128H640v-128zm0-384H512V640h128v128zm0 128h128v128H640V896zm256 0h128v128H896V896zm256 0h128v128h-128V896zM896 768H768V640h128v128zm256 0h-128V640h128v128zm256 0h-128V640h128v128zm128-128h128v128h-128V640z"
        })),
    displayName: 'KeyboardClassicIcon'
});
var $6bab4c16a5a172a0$export$2e2bcd8739ae039 = $6bab4c16a5a172a0$var$KeyboardClassicIcon;


var $acw62 = parcelRequire("acw62");

const $c263358ce62da604$var$TouchPointerIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1856 768q40 0 75 15t61 41 41 61 15 75v384q0 119-45 224t-124 183-183 123-224 46q-141 0-266-55t-228-157l-319-318-272 136-138-277L0 1499V165l896 896V320q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75v331q27-10 59-10 49 0 95 23t72 65q44-25 94-25 51 0 93 24t69 65q44-25 94-25zM424 960h190L128 475v714l156-156 161 321 141-71-162-323zm1496 0q0-26-19-45t-45-19q-26 0-45 19t-19 45v128q0 26-19 45t-45 19q-26 0-45-19t-19-45V896q0-26-19-45t-45-19q-26 0-45 19t-19 45v128q0 26-19 45t-45 19q-26 0-45-19t-19-45V832q0-26-19-45t-45-19q-26 0-45 19t-19 45v128q0 26-19 45t-45 19q-26 0-45-19t-19-45V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v787q0 33-18 60t-49 41q-19 8-42 8-44 0-78-32l-75-75q-21-21-50-21-30 0-51 21-11 11-16 24t-5 27q0 30 21 51l408 408q81 85 184 129t219 44q93 0 174-35t142-96 96-142 36-175V960z"
        })),
    displayName: 'TouchPointerIcon'
});
var $c263358ce62da604$export$2e2bcd8739ae039 = $c263358ce62da604$var$TouchPointerIcon;


class $a8aaa562457c1b2a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
            horizontal: true,
            horizontalAlign: "space-between",
            wrap: true,
            tokens: {
                childrenGap: 's1'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c).Item, {
                    style: {
                        flexBasis: '45%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bab4c16a5a172a0$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '1.25em',
                                        marginRight: '0.25rem'
                                    }
                                }),
                                "Keyboard"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                            children: "Enter"
                                        }),
                                        " or ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                            children: "Spacebar"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "On powered-off nodes: Power on"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "On powered-on nodes with adjacent threats: Attempt to safely auto power on adjacent nodes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                        children: "Q"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Toggle flag on selected powered-off node"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dt", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                            children: "W"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                            children: "A"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                            children: "S"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                            children: "D"
                                        }),
                                        " (or arrow keys)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Navigate (nodes with no adjacent threats will be skipped)"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                        children: "Home"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Navigate to start of row"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                        children: "End"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Navigate to end of row"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                        children: "Page up"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Navigate to top of column"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("kbd", {
                                        children: "Page down"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Navigate to bottom of column"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c).Item, {
                    style: {
                        flexBasis: '45%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dd965dd4d4e16b95$export$b04be29aa201d4f5), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c263358ce62da604$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: '1.25em',
                                        marginRight: '0.25rem'
                                    }
                                }),
                                "Mouse"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("dl", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: "Click"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "On powered-off nodes: Power on"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: "Double-click"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "On powered-on nodes with adjacent threats: Attempt to safely auto power on adjacent nodes"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dt", {
                                    children: "Right-click"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("dd", {
                                    children: "Toggle flag on selected powered-off node"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}




var $acw62 = parcelRequire("acw62");
class $47176950e2a98b0b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        if (this.props.highscores.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
            children: "No scores yet for this level"
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
            children: this.props.highscores.map((score, key)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                    children: [
                        score,
                        " seconds"
                    ]
                }, key))
        });
    }
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $7cd4cc59ef8f1433$export$8219f5c55c7cc288(initialValue) {
    // Use useRef to store the value because it's the least expensive built-in hook that works here
    // (we could also use `const [value] = React.useState(initialValue)` but that's more expensive
    // internally due to reducer handling which we don't need)
    var ref = $acw62.useRef(undefined);
    if (ref.current === undefined) // Box the value in an object so we can tell if it's initialized even if the initializer
    // returns/is undefined
    ref.current = {
        value: typeof initialValue === 'function' ? initialValue() : initialValue
    };
    return ref.current.value;
}


function $55cf7aa9f769b3e9$export$2400c890ca0180b4(controlledValue, defaultUncontrolledValue, onChange) {
    var _a = $acw62.useState(defaultUncontrolledValue), value = _a[0], setValue = _a[1];
    var isControlled = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(controlledValue !== undefined);
    var currentValue = isControlled ? controlledValue : value;
    // Duplicate the current value and onChange in refs so they're accessible from
    // setValueOrCallOnChange without creating a new callback every time
    var valueRef = $acw62.useRef(currentValue);
    var onChangeRef = $acw62.useRef(onChange);
    $acw62.useEffect(function() {
        valueRef.current = currentValue;
        onChangeRef.current = onChange;
    });
    // To match the behavior of the setter returned by React.useState, this callback's identity
    // should never change. This means it MUST NOT directly reference variables that can change.
    var setValueOrCallOnChange = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function(update, ev) {
            // Assuming here that TValue is not a function, because a controllable value will typically
            // be something a user can enter as input
            var newValue = typeof update === 'function' ? update(valueRef.current) : update;
            if (onChangeRef.current) onChangeRef.current(ev, newValue);
            if (!isControlled) setValue(newValue);
        };
    });
    return [
        currentValue,
        setValueOrCallOnChange
    ];
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
/**
 * Compares a to b and b to a.
 *
 * @public
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f504d2279336999d$export$90e866afbd6b9f1a(a, b) {
    if (!a || !b) // only return true if both a and b are falsy
    return !a && !b;
    for(var propName in a)if (a.hasOwnProperty(propName)) {
        if (!b.hasOwnProperty(propName) || b[propName] !== a[propName]) return false;
    }
    for(var propName in b)if (b.hasOwnProperty(propName)) {
        if (!a.hasOwnProperty(propName)) return false;
    }
    return true;
}
function $f504d2279336999d$export$e6e34fd1f2686227(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $f504d2279336999d$export$e0c55363f2296695.apply(this, [
        null,
        target
    ].concat(args));
}
function $f504d2279336999d$export$e0c55363f2296695(isAllowed, target) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    target = target || {};
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var sourceObject = args_1[_a];
        if (sourceObject) {
            for(var propName in sourceObject)if (sourceObject.hasOwnProperty(propName) && (!isAllowed || isAllowed(propName))) target[propName] = sourceObject[propName];
        }
    }
    return target;
}
function $f504d2279336999d$export$8951e1a012e6d096(// eslint-disable-next-line @typescript-eslint/no-explicit-any
theEnum, callback) {
    // map<any> to satisfy compiler since it doesn't realize we strip out undefineds in the .filter() call
    return Object.keys(theEnum).map(function(p) {
        // map on each property name as a string
        if (String(Number(p)) !== p) // if the property is not just a number (because enums in TypeScript will map both ways)
        return callback(p, theEnum[p]);
        return undefined;
    }).filter(function(v) {
        return !!v;
    }); // only return elements with values
}
function $f504d2279336999d$export$68c286be0e7e55b7(obj) {
    return Object.keys(obj).reduce(function(arr, key) {
        arr.push(obj[key]);
        return arr;
    }, []);
}
function $f504d2279336999d$export$30a06c8d3562193f(obj, exclusions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    for(var key in obj)if (exclusions.indexOf(key) === -1 && obj.hasOwnProperty(key)) result[key] = obj[key];
    return result;
}


/**
 * Bugs often appear in async code when stuff gets disposed, but async operations don't get canceled.
 * This Async helper class solves these issues by tying async code to the lifetime of a disposable object.
 *
 * Usage: Anything class extending from BaseModel can access this helper via this.async. Otherwise create a
 * new instance of the class and remember to call dispose() during your code's dispose handler.
 *
 * @public
 */ var $64b4350fe064431c$export$4d3c597da532240f = /** @class */ function() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Async(parent, onError) {
        this._timeoutIds = null;
        this._immediateIds = null;
        this._intervalIds = null;
        this._animationFrameIds = null;
        this._isDisposed = false;
        this._parent = parent || null;
        this._onErrorHandler = onError;
        this._noop = function() {
        /* do nothing */ };
    }
    /**
     * Dispose function, clears all async operations.
     */ Async.prototype.dispose = function() {
        var id;
        this._isDisposed = true;
        this._parent = null;
        // Clear timeouts.
        if (this._timeoutIds) {
            for(id in this._timeoutIds)if (this._timeoutIds.hasOwnProperty(id)) this.clearTimeout(parseInt(id, 10));
            this._timeoutIds = null;
        }
        // Clear immediates.
        if (this._immediateIds) {
            for(id in this._immediateIds)if (this._immediateIds.hasOwnProperty(id)) this.clearImmediate(parseInt(id, 10));
            this._immediateIds = null;
        }
        // Clear intervals.
        if (this._intervalIds) {
            for(id in this._intervalIds)if (this._intervalIds.hasOwnProperty(id)) this.clearInterval(parseInt(id, 10));
            this._intervalIds = null;
        }
        // Clear animation frames.
        if (this._animationFrameIds) {
            for(id in this._animationFrameIds)if (this._animationFrameIds.hasOwnProperty(id)) this.cancelAnimationFrame(parseInt(id, 10));
            this._animationFrameIds = null;
        }
    };
    /**
     * SetTimeout override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */ Async.prototype.setTimeout = function(callback, duration) {
        var _this = this;
        var timeoutId = 0;
        if (!this._isDisposed) {
            if (!this._timeoutIds) this._timeoutIds = {};
            timeoutId = setTimeout(function() {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._timeoutIds) delete _this._timeoutIds[timeoutId];
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            }, duration);
            this._timeoutIds[timeoutId] = true;
        }
        return timeoutId;
    };
    /**
     * Clears the timeout.
     * @param id - Id to cancel.
     */ Async.prototype.clearTimeout = function(id) {
        if (this._timeoutIds && this._timeoutIds[id]) {
            clearTimeout(id);
            delete this._timeoutIds[id];
        }
    };
    /**
     * SetImmediate override, which will auto cancel the immediate during dispose.
     * @param callback - Callback to execute.
     * @param targetElement - Optional target element to use for identifying the correct window.
     * @returns The setTimeout id.
     */ Async.prototype.setImmediate = function(callback, targetElement) {
        var _this = this;
        var immediateId = 0;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (!this._isDisposed) {
            if (!this._immediateIds) this._immediateIds = {};
            var setImmediateCallback = function() {
                // Time to execute the timeout, enqueue it as a foreground task to be executed.
                try {
                    // Now delete the record and call the callback.
                    if (_this._immediateIds) delete _this._immediateIds[immediateId];
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            };
            immediateId = win.setTimeout(setImmediateCallback, 0);
            this._immediateIds[immediateId] = true;
        }
        return immediateId;
    };
    /**
     * Clears the immediate.
     * @param id - Id to cancel.
     * @param targetElement - Optional target element to use for identifying the correct window.
     */ Async.prototype.clearImmediate = function(id, targetElement) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (this._immediateIds && this._immediateIds[id]) {
            win.clearTimeout(id);
            delete this._immediateIds[id];
        }
    };
    /**
     * SetInterval override, which will auto cancel the timeout during dispose.
     * @param callback - Callback to execute.
     * @param duration - Duration in milliseconds.
     * @returns The setTimeout id.
     */ Async.prototype.setInterval = function(callback, duration) {
        var _this = this;
        var intervalId = 0;
        if (!this._isDisposed) {
            if (!this._intervalIds) this._intervalIds = {};
            intervalId = setInterval(function() {
                // Time to execute the interval callback, enqueue it as a foreground task to be executed.
                try {
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            }, duration);
            this._intervalIds[intervalId] = true;
        }
        return intervalId;
    };
    /**
     * Clears the interval.
     * @param id - Id to cancel.
     */ Async.prototype.clearInterval = function(id) {
        if (this._intervalIds && this._intervalIds[id]) {
            clearInterval(id);
            delete this._intervalIds[id];
        }
    };
    /**
     * Creates a function that, when executed, will only call the func function at most once per
     * every wait milliseconds. Provide an options object to indicate that func should be invoked
     * on the leading and/or trailing edge of the wait timeout. Subsequent calls to the throttled
     * function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the throttled function is invoked more than once during the wait timeout.
     *
     * @param func - The function to throttle.
     * @param wait - The number of milliseconds to throttle executions to. Defaults to 0.
     * @param options - The options object.
     * @returns The new throttled function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype.throttle = function(func, wait, options) {
        var _this = this;
        if (this._isDisposed) return this._noop;
        var waitMS = wait || 0;
        var leading = true;
        var trailing = true;
        var lastExecuteTime = 0;
        var lastResult;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === 'boolean') leading = options.leading;
        if (options && typeof options.trailing === 'boolean') trailing = options.trailing;
        var callback = function(userCall) {
            var now = Date.now();
            var delta = now - lastExecuteTime;
            var waitLength = leading ? waitMS - delta : waitMS;
            if (delta >= waitMS && (!userCall || leading)) {
                lastExecuteTime = now;
                if (timeoutId) {
                    _this.clearTimeout(timeoutId);
                    timeoutId = null;
                }
                lastResult = func.apply(_this._parent, lastArgs);
            } else if (timeoutId === null && trailing) timeoutId = _this.setTimeout(callback, waitLength);
            return lastResult;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultFunction = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            lastArgs = args;
            return callback(true);
        };
        return resultFunction;
    };
    /**
     * Creates a function that will delay the execution of func until after wait milliseconds have
     * elapsed since the last time it was invoked. Provide an options object to indicate that func
     * should be invoked on the leading and/or trailing edge of the wait timeout. Subsequent calls
     * to the debounced function will return the result of the last func call.
     *
     * Note: If leading and trailing options are true func will be called on the trailing edge of
     * the timeout only if the debounced function is invoked more than once during the wait
     * timeout.
     *
     * @param func - The function to debounce.
     * @param wait - The number of milliseconds to delay.
     * @param options - The options object.
     * @returns The new debounced function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype.debounce = function(func, wait, options) {
        var _this = this;
        if (this._isDisposed) {
            var noOpFunction = function() {
            /** Do nothing */ };
            noOpFunction.cancel = function() {
                return;
            };
            noOpFunction.flush = function() {
                return null;
            };
            noOpFunction.pending = function() {
                return false;
            };
            return noOpFunction;
        }
        var waitMS = wait || 0;
        var leading = false;
        var trailing = true;
        var maxWait = null;
        var lastCallTime = 0;
        var lastExecuteTime = Date.now();
        var lastResult;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var lastArgs;
        var timeoutId = null;
        if (options && typeof options.leading === 'boolean') leading = options.leading;
        if (options && typeof options.trailing === 'boolean') trailing = options.trailing;
        if (options && typeof options.maxWait === 'number' && !isNaN(options.maxWait)) maxWait = options.maxWait;
        var markExecuted = function(time) {
            if (timeoutId) {
                _this.clearTimeout(timeoutId);
                timeoutId = null;
            }
            lastExecuteTime = time;
        };
        var invokeFunction = function(time) {
            markExecuted(time);
            lastResult = func.apply(_this._parent, lastArgs);
        };
        var callback = function(userCall) {
            var now = Date.now();
            var executeImmediately = false;
            if (userCall) {
                if (leading && now - lastCallTime >= waitMS) executeImmediately = true;
                lastCallTime = now;
            }
            var delta = now - lastCallTime;
            var waitLength = waitMS - delta;
            var maxWaitDelta = now - lastExecuteTime;
            var maxWaitExpired = false;
            if (maxWait !== null) {
                // maxWait only matters when there is a pending callback
                if (maxWaitDelta >= maxWait && timeoutId) maxWaitExpired = true;
                else waitLength = Math.min(waitLength, maxWait - maxWaitDelta);
            }
            if (delta >= waitMS || maxWaitExpired || executeImmediately) invokeFunction(now);
            else if ((timeoutId === null || !userCall) && trailing) timeoutId = _this.setTimeout(callback, waitLength);
            return lastResult;
        };
        var pending = function() {
            return !!timeoutId;
        };
        var cancel = function() {
            if (pending()) // Mark the debounced function as having executed
            markExecuted(Date.now());
        };
        var flush = function() {
            if (pending()) invokeFunction(Date.now());
            return lastResult;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resultFunction = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            lastArgs = args;
            return callback(true);
        };
        resultFunction.cancel = cancel;
        resultFunction.flush = flush;
        resultFunction.pending = pending;
        return resultFunction;
    };
    Async.prototype.requestAnimationFrame = function(callback, targetElement) {
        var _this = this;
        var animationFrameId = 0;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (!this._isDisposed) {
            if (!this._animationFrameIds) this._animationFrameIds = {};
            var animationFrameCallback = function() {
                try {
                    // Now delete the record and call the callback.
                    if (_this._animationFrameIds) delete _this._animationFrameIds[animationFrameId];
                    callback.apply(_this._parent);
                } catch (e) {
                    _this._logError(e);
                }
            };
            animationFrameId = win.requestAnimationFrame ? win.requestAnimationFrame(animationFrameCallback) : win.setTimeout(animationFrameCallback, 0);
            this._animationFrameIds[animationFrameId] = true;
        }
        return animationFrameId;
    };
    Async.prototype.cancelAnimationFrame = function(id, targetElement) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(targetElement);
        if (this._animationFrameIds && this._animationFrameIds[id]) {
            win.cancelAnimationFrame ? win.cancelAnimationFrame(id) : win.clearTimeout(id);
            delete this._animationFrameIds[id];
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Async.prototype._logError = function(e) {
        if (this._onErrorHandler) this._onErrorHandler(e);
    };
    return Async;
}();



var $acw62 = parcelRequire("acw62");

function $7d0a77756f8e01ee$var$createComposedComponent(outer) {
    var Outer = outer;
    var outerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(inner) {
        if (outer === inner) throw new Error('Attempted to compose a component with itself.');
        var Inner = inner;
        var innerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(defaultRender) {
            var InnerWithDefaultRender = function(innerProps) {
                return $acw62.createElement(Inner, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, innerProps, {
                    defaultRender: defaultRender
                }));
            };
            return InnerWithDefaultRender;
        });
        var OuterWithDefaultRender = function(outerProps) {
            var defaultRender = outerProps.defaultRender;
            return $acw62.createElement(Outer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, outerProps, {
                defaultRender: defaultRender ? innerMemoizer(defaultRender) : Inner
            }));
        };
        return OuterWithDefaultRender;
    });
    return outerMemoizer;
}
var $7d0a77756f8e01ee$var$componentAsMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)($7d0a77756f8e01ee$var$createComposedComponent);
function $7d0a77756f8e01ee$export$a196dddec0747ba0(outer, inner) {
    return $7d0a77756f8e01ee$var$componentAsMemoizer(outer)(inner);
}

/**
 * Helper to find the index of an item within an array, using a callback to
 * determine the match.
 *
 * @public
 * @param array - Array to search.
 * @param cb - Callback which returns true on matches.
 * @param fromIndex - Optional index to start from (defaults to 0)
 */ function $b9105dc723fd02ea$export$de3a4d4a0d731119(array, cb, fromIndex) {
    if (fromIndex === void 0) fromIndex = 0;
    var index = -1;
    for(var i = fromIndex; array && i < array.length; i++)if (cb(array[i], i)) {
        index = i;
        break;
    }
    return index;
}
function $b9105dc723fd02ea$export$71aa6c912b956294(array, cb) {
    var index = $b9105dc723fd02ea$export$de3a4d4a0d731119(array, cb);
    if (index < 0) return undefined;
    return array[index];
}
function $b9105dc723fd02ea$export$7f1ebd623f131021(size, getItem) {
    var array = [];
    for(var i = 0; i < size; i++)array.push(getItem(i));
    return array;
}
function $b9105dc723fd02ea$export$88114232bee231be(items, columnCount) {
    return items.reduce(function(rows, currentValue, index) {
        if (index % columnCount === 0) rows.push([
            currentValue
        ]);
        else rows[rows.length - 1].push(currentValue);
        return rows;
    }, []);
}
function $b9105dc723fd02ea$export$c36ae5e7e50e8840(array, index) {
    return array.filter(function(_, i) {
        return index !== i;
    });
}
function $b9105dc723fd02ea$export$2dfe578f95754f6a(array, newElement, index) {
    var copy = array.slice();
    copy[index] = newElement;
    return copy;
}
function $b9105dc723fd02ea$export$df2fbf469f510c97(array, index, itemToAdd) {
    var copy = array.slice();
    copy.splice(index, 0, itemToAdd);
    return copy;
}
function $b9105dc723fd02ea$export$bffa455ba8c619a6(array) {
    var result = [];
    array.forEach(function(item) {
        return result = result.concat(item);
    });
    return result;
}
function $b9105dc723fd02ea$export$234180f8206db11b(array1, array2) {
    if (array1.length !== array2.length) return false;
    for(var i = 0; i < array1.length; i++){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}


/**
 * Set up a ref resolver function given internal state managed for the ref.
 * @param local Set
 */ var $ad53d15595d1f5d5$var$createResolver = function(local) {
    return function(newValue) {
        for(var _i = 0, _a = local.refs; _i < _a.length; _i++){
            var ref = _a[_i];
            if (typeof ref === 'function') ref(newValue);
            else if (ref) // work around the immutability of the React.Ref type
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ref.current = newValue;
        }
    };
};
var $ad53d15595d1f5d5$export$9f37a988498f0f9c = function(value) {
    var local = {
        refs: []
    };
    return function() {
        var newRefs = [];
        for(var _i = 0; _i < arguments.length; _i++)newRefs[_i] = arguments[_i];
        if (!local.resolver || !(0, $b9105dc723fd02ea$export$234180f8206db11b)(local.refs, newRefs)) local.resolver = $ad53d15595d1f5d5$var$createResolver(local);
        local.refs = newRefs;
        return local.resolver;
    };
};



/** An instance of EventGroup allows anything with a handle to it to trigger events on it.
 *  If the target is an HTMLElement, the event will be attached to the element and can be
 *  triggered as usual (like clicking for onClick).
 *  The event can be triggered by calling EventGroup.raise() here. If the target is an
 *  HTMLElement, the event gets raised and is handled by the browser. Otherwise, it gets
 *  handled here in EventGroup, and the handler is called in the context of the parent
 *  (which is passed in in the constructor).
 *
 * @public
 * {@docCategory EventGroup}
 */ var $7e392406ee2126b8$export$7af5106782f53286 = /** @class */ function() {
    /** parent: the context in which events attached to non-HTMLElements are called */ function EventGroup(parent) {
        this._id = EventGroup._uniqueId++;
        this._parent = parent;
        this._eventRecords = [];
    }
    /** For IE8, bubbleEvent is ignored here and must be dealt with by the handler.
     *  Events raised here by default have bubbling set to false and cancelable set to true.
     *  This applies also to built-in events being raised manually here on HTMLElements,
     *  which may lead to unexpected behavior if it differs from the defaults.
     *
     */ EventGroup.raise = function(target, eventName, eventArgs, bubbleEvent, doc) {
        var retVal;
        var theDoc = doc !== null && doc !== void 0 ? doc : (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if (EventGroup._isElement(target)) {
            if (typeof theDoc !== 'undefined' && theDoc.createEvent) {
                var ev = theDoc.createEvent('HTMLEvents');
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                ev.initEvent(eventName, bubbleEvent || false, true);
                (0, $f504d2279336999d$export$e6e34fd1f2686227)(ev, eventArgs);
                retVal = target.dispatchEvent(ev);
            } else if (typeof theDoc !== 'undefined' && theDoc.createEventObject) {
                // IE8
                var evObj = theDoc.createEventObject(eventArgs);
                // cannot set cancelBubble on evObj, fireEvent will overwrite it
                target.fireEvent('on' + eventName, evObj);
            }
        } else // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
        while(target && retVal !== false){
            var events = target.__events__;
            var eventRecords = events ? events[eventName] : null;
            if (eventRecords) {
                for(var id in eventRecords)if (eventRecords.hasOwnProperty(id)) {
                    var eventRecordList = eventRecords[id];
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
                    for(var listIndex = 0; retVal !== false && listIndex < eventRecordList.length; listIndex++){
                        var record = eventRecordList[listIndex];
                        if (record.objectCallback) retVal = record.objectCallback.call(record.parent, eventArgs);
                    }
                }
            }
            // If the target has a parent, bubble the event up.
            target = bubbleEvent ? target.parent : null;
        }
        return retVal;
    };
    EventGroup.isObserved = function(target, eventName) {
        var events = target && target.__events__;
        return !!events && !!events[eventName];
    };
    /** Check to see if the target has declared support of the given event. */ EventGroup.isDeclared = function(target, eventName) {
        var declaredEvents = target && target.__declaredEvents;
        return !!declaredEvents && !!declaredEvents[eventName];
    };
    EventGroup.stopPropagation = function(event) {
        if (event.stopPropagation) event.stopPropagation();
        else // IE8
        event.cancelBubble = true;
    };
    EventGroup._isElement = function(target) {
        return !!target && (!!target.addEventListener || typeof HTMLElement !== 'undefined' && target instanceof HTMLElement);
    };
    EventGroup.prototype.dispose = function() {
        if (!this._isDisposed) {
            this._isDisposed = true;
            this.off();
            this._parent = null;
        }
    };
    /** On the target, attach a set of events, where the events object is a name to function mapping. */ EventGroup.prototype.onAll = function(target, events, useCapture) {
        for(var eventName in events)if (events.hasOwnProperty(eventName)) this.on(target, eventName, events[eventName], useCapture);
    };
    /**
     * On the target, attach an event whose handler will be called in the context of the parent
     * of this instance of EventGroup.
     */ EventGroup.prototype.on = function(target, eventName, callback, options) {
        var _this = this;
        if (eventName.indexOf(',') > -1) {
            var events = eventName.split(/[ ,]+/);
            for(var i = 0; i < events.length; i++)this.on(target, events[i], callback, options);
        } else {
            var parent_1 = this._parent;
            var eventRecord = {
                target: target,
                eventName: eventName,
                parent: parent_1,
                callback: callback,
                options: options
            };
            // Initialize and wire up the record on the target, so that it can call the callback if the event fires.
            var events = target.__events__ = target.__events__ || {};
            events[eventName] = events[eventName] || {
                count: 0
            };
            events[eventName][this._id] = events[eventName][this._id] || [];
            events[eventName][this._id].push(eventRecord);
            events[eventName].count++;
            if (EventGroup._isElement(target)) {
                var processElementEvent = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    if (_this._isDisposed) return;
                    var result;
                    try {
                        result = callback.apply(parent_1, args);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore  -- FIXME: strictBindCallApply error - https://github.com/microsoft/fluentui/issues/17331
                        if (result === false && args[0]) {
                            var e = args[0];
                            if (e.preventDefault) e.preventDefault();
                            if (e.stopPropagation) e.stopPropagation();
                            e.cancelBubble = true;
                        }
                    } catch (e) {
                    // ignore
                    }
                    return result;
                };
                eventRecord.elementCallback = processElementEvent;
                if (target.addEventListener) target.addEventListener(eventName, processElementEvent, options);
                else if (target.attachEvent) // IE8
                target.attachEvent('on' + eventName, processElementEvent);
            } else {
                var processObjectEvent = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    if (_this._isDisposed) return;
                    return callback.apply(parent_1, args);
                };
                eventRecord.objectCallback = processObjectEvent;
            }
            // Remember the record locally, so that it can be removed.
            this._eventRecords.push(eventRecord);
        }
    };
    EventGroup.prototype.off = function(target, eventName, callback, options) {
        for(var i = 0; i < this._eventRecords.length; i++){
            var eventRecord = this._eventRecords[i];
            if ((!target || target === eventRecord.target) && (!eventName || eventName === eventRecord.eventName) && (!callback || callback === eventRecord.callback) && (typeof options !== 'boolean' || options === eventRecord.options)) {
                var events = eventRecord.target.__events__;
                var targetArrayLookup = events[eventRecord.eventName];
                var targetArray = targetArrayLookup ? targetArrayLookup[this._id] : null;
                // We may have already target's entries, so check for null.
                if (targetArray) {
                    if (targetArray.length === 1 || !callback) {
                        targetArrayLookup.count -= targetArray.length;
                        delete events[eventRecord.eventName][this._id];
                    } else {
                        targetArrayLookup.count--;
                        targetArray.splice(targetArray.indexOf(eventRecord), 1);
                    }
                    if (!targetArrayLookup.count) delete events[eventRecord.eventName];
                }
                if (eventRecord.elementCallback) {
                    if (eventRecord.target.removeEventListener) eventRecord.target.removeEventListener(eventRecord.eventName, eventRecord.elementCallback, eventRecord.options);
                    else if (eventRecord.target.detachEvent) // IE8
                    eventRecord.target.detachEvent('on' + eventRecord.eventName, eventRecord.elementCallback);
                }
                this._eventRecords.splice(i--, 1);
            }
        }
    };
    /** Trigger the given event in the context of this instance of EventGroup. */ EventGroup.prototype.raise = function(eventName, eventArgs, bubbleEvent) {
        return EventGroup.raise(this._parent, eventName, eventArgs, bubbleEvent);
    };
    /** Declare an event as being supported by this instance of EventGroup. */ EventGroup.prototype.declare = function(event) {
        var declaredEvents = this._parent.__declaredEvents = this._parent.__declaredEvents || {};
        if (typeof event === 'string') declaredEvents[event] = true;
        else for(var i = 0; i < event.length; i++)declaredEvents[event[i]] = true;
    };
    EventGroup._uniqueId = 0;
    return EventGroup;
}();


var $acw62 = parcelRequire("acw62");


var $fef2641414ae093e$var$_a;
var $fef2641414ae093e$var$DirectionalKeyCodes = ($fef2641414ae093e$var$_a = {}, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).up] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).down] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).left] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).right] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).home] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).end] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).tab] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).pageUp] = 1, $fef2641414ae093e$var$_a[(0, $c011a102064f82ea$export$ec835b702d42f3f0).pageDown] = 1, $fef2641414ae093e$var$_a);
function $fef2641414ae093e$export$e5f9b34bb820f5e3(which) {
    return !!$fef2641414ae093e$var$DirectionalKeyCodes[which];
}
function $fef2641414ae093e$export$616d8c95f2a9d165(which) {
    $fef2641414ae093e$var$DirectionalKeyCodes[which] = 1;
}
function $fef2641414ae093e$export$795d157d4f303684(which) {
    delete $fef2641414ae093e$var$DirectionalKeyCodes[which];
}



var $872a30e3c6519016$var$mountCounters = new WeakMap();
var $872a30e3c6519016$var$callbackMap = new WeakMap();
function $872a30e3c6519016$var$setMountCounters(key, delta) {
    var newValue;
    var currValue = $872a30e3c6519016$var$mountCounters.get(key);
    if (currValue) newValue = currValue + delta;
    else newValue = 1;
    $872a30e3c6519016$var$mountCounters.set(key, newValue);
    return newValue;
}
function $872a30e3c6519016$var$setCallbackMap(context) {
    var callbacks = $872a30e3c6519016$var$callbackMap.get(context);
    if (callbacks) return callbacks;
    var onMouseDown = function(ev) {
        return $872a30e3c6519016$var$_onMouseDown(ev, context.registeredProviders);
    };
    var onPointerDown = function(ev) {
        return $872a30e3c6519016$var$_onPointerDown(ev, context.registeredProviders);
    };
    var onKeyDown = function(ev) {
        return $872a30e3c6519016$var$_onKeyDown(ev, context.registeredProviders);
    };
    var onKeyUp = function(ev) {
        return $872a30e3c6519016$var$_onKeyUp(ev, context.registeredProviders);
    };
    callbacks = {
        onMouseDown: onMouseDown,
        onPointerDown: onPointerDown,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    $872a30e3c6519016$var$callbackMap.set(context, callbacks);
    return callbacks;
}
var $872a30e3c6519016$export$683969f4bf72ffbd = $acw62.createContext(undefined);
function $872a30e3c6519016$export$471b875afaf1c0a9(rootRef) {
    var context = $acw62.useContext($872a30e3c6519016$export$683969f4bf72ffbd);
    $acw62.useEffect(function() {
        var _a, _b, _c, _d;
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(rootRef === null || rootRef === void 0 ? void 0 : rootRef.current);
        if (!win || ((_a = win.FabricConfig) === null || _a === void 0 ? void 0 : _a.disableFocusRects) === true) return undefined;
        var el = win;
        var onMouseDown;
        var onPointerDown;
        var onKeyDown;
        var onKeyUp;
        if (((_b = context === null || context === void 0 ? void 0 : context.providerRef) === null || _b === void 0 ? void 0 : _b.current) && ((_d = (_c = context === null || context === void 0 ? void 0 : context.providerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.addEventListener)) {
            el = context.providerRef.current;
            // The NOINLINE directive tells terser not to move the setCallbackMap implementation into the call site during
            // minification.
            // This prevents the function from capturing additional variables in the closure, which can cause memory leaks.
            var callbacks = /*@__NOINLINE__*/ $872a30e3c6519016$var$setCallbackMap(context);
            onMouseDown = callbacks.onMouseDown;
            onPointerDown = callbacks.onPointerDown;
            onKeyDown = callbacks.onKeyDown;
            onKeyUp = callbacks.onKeyUp;
        } else {
            onMouseDown = $872a30e3c6519016$var$_onMouseDown;
            onPointerDown = $872a30e3c6519016$var$_onPointerDown;
            onKeyDown = $872a30e3c6519016$var$_onKeyDown;
            onKeyUp = $872a30e3c6519016$var$_onKeyUp;
        }
        var count = $872a30e3c6519016$var$setMountCounters(el, 1);
        if (count <= 1) {
            el.addEventListener('mousedown', onMouseDown, true);
            el.addEventListener('pointerdown', onPointerDown, true);
            el.addEventListener('keydown', onKeyDown, true);
            el.addEventListener('keyup', onKeyUp, true);
        }
        return function() {
            var _a;
            if (!win || ((_a = win.FabricConfig) === null || _a === void 0 ? void 0 : _a.disableFocusRects) === true) return;
            count = $872a30e3c6519016$var$setMountCounters(el, -1);
            if (count === 0) {
                el.removeEventListener('mousedown', onMouseDown, true);
                el.removeEventListener('pointerdown', onPointerDown, true);
                el.removeEventListener('keydown', onKeyDown, true);
                el.removeEventListener('keyup', onKeyUp, true);
            }
        };
    }, [
        context,
        rootRef
    ]);
}
var $872a30e3c6519016$export$5dedbdbae91633c9 = function(props) {
    $872a30e3c6519016$export$471b875afaf1c0a9(props.rootRef);
    return null;
};
function $872a30e3c6519016$var$_onMouseDown(ev, registeredProviders) {
    (0, $68e6902efa21380a$export$760b5674477e9343)(false, ev.target, registeredProviders);
}
function $872a30e3c6519016$var$_onPointerDown(ev, registeredProviders) {
    if (ev.pointerType !== 'mouse') (0, $68e6902efa21380a$export$760b5674477e9343)(false, ev.target, registeredProviders);
}
// You need both a keydown and a keyup listener that sets focus visibility to true to handle two distinct scenarios when
// attaching the listeners and classnames to the provider instead of the document body.
// If you only have a keydown listener, then the focus rectangles will not show when moving from outside of the provider
// to inside it. That is why a keyup listener is needed, since it will always trigger after the focus event is fired.
// If you only have a keyup listener, then the focus rectangles will not show moving between different tabbable elements
// if the tab key is pressed without being released. That's is why we need a keydown listener, since it will trigger for
// every element that is being tabbed into.
// This works because `classList.add` is smart and will not duplicate a classname that already exists on the classList
// when focus visibility is turned on.
function $872a30e3c6519016$var$_onKeyDown(ev, registeredProviders) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    if ((0, $fef2641414ae093e$export$e5f9b34bb820f5e3)(ev.which)) (0, $68e6902efa21380a$export$760b5674477e9343)(true, ev.target, registeredProviders);
}
function $872a30e3c6519016$var$_onKeyUp(ev, registeredProviders) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    if ((0, $fef2641414ae093e$export$e5f9b34bb820f5e3)(ev.which)) (0, $68e6902efa21380a$export$760b5674477e9343)(true, ev.target, registeredProviders);
}

/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns a single function which will call each of the given functions in the context of the
 * parent.
 */ function $a2f876b5f5ff31f2$export$b8fb43c74a4e9be3(parent) {
    var functions = [];
    for(var _i = 1; _i < arguments.length; _i++)functions[_i - 1] = arguments[_i];
    if (functions.length < 2) return functions[0];
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        functions.forEach(function(f) {
            return f && f.apply(parent, args);
        });
    };
}


function $ee07c8e3227b2b42$export$ef567452699b6b33(parent, methods) {
    for(var name_1 in methods)if (methods.hasOwnProperty(name_1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parent[name_1] = (0, $a2f876b5f5ff31f2$export$b8fb43c74a4e9be3)(parent, parent[name_1], methods[name_1]);
}


function $e67df77dd079fd43$export$4e1ebb7d216e1f17(obj) {
    (0, $ee07c8e3227b2b42$export$ef567452699b6b33)(obj, {
        componentDidMount: $e67df77dd079fd43$var$_onMount,
        componentDidUpdate: $e67df77dd079fd43$var$_onUpdate,
        componentWillUnmount: $e67df77dd079fd43$var$_onUnmount
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e67df77dd079fd43$var$_onMount() {
    $e67df77dd079fd43$var$_setComponentRef(this.props.componentRef, this);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e67df77dd079fd43$var$_onUpdate(prevProps) {
    if (prevProps.componentRef !== this.props.componentRef) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $e67df77dd079fd43$var$_setComponentRef(prevProps.componentRef, null);
        $e67df77dd079fd43$var$_setComponentRef(this.props.componentRef, this);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e67df77dd079fd43$var$_onUnmount() {
    $e67df77dd079fd43$var$_setComponentRef(this.props.componentRef, null);
}
function $e67df77dd079fd43$var$_setComponentRef(componentRef, value) {
    if (componentRef) {
        if (typeof componentRef === 'object') componentRef.current = value;
        else if (typeof componentRef === 'function') componentRef(value);
    }
}

/**
 * ARIA helper to concatenate attributes, returning undefined if all attributes
 * are undefined. (Empty strings are not a valid ARIA attribute value.)
 *
 * @param ariaAttributes - ARIA attributes to merge
 */ function $47ed660f7395a6aa$export$35013cdad9bb6ffa() {
    var ariaAttributes = [];
    for(var _i = 0; _i < arguments.length; _i++)ariaAttributes[_i] = arguments[_i];
    var mergedAttribute = ariaAttributes.filter(function(arg) {
        return arg;
    }).join(' ').trim();
    return mergedAttribute === '' ? undefined : mergedAttribute;
}



var $acw62 = parcelRequire("acw62");



function $35efe983fe3c9b91$export$864d02b07a04fe0f(componentName, props, requiredProps, conditionalPropName, condition) {
    condition;
    var _i, requiredProps_1, requiredPropName;
}



function $8c9f8bb7c7ee0375$export$3dca6a71e81a1f03(componentName, props, exclusiveMap) {
    var propName, propInExclusiveMapValue;
}



/**
 * BaseComponent class, which provides basic helpers for all components.
 *
 * @public
 * {@docCategory BaseComponent}
 *
 * @deprecated Do not use. We are moving away from class component.
 */ var $12233c50b7efccdc$export$55ae5207ce896a6b = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseComponent, _super);
    /**
     * BaseComponent constructor
     * @param props - The props for the component.
     * @param context - The context for the component.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function BaseComponent(props, context) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var _this = _super.call(this, props, context) || this;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        $12233c50b7efccdc$var$_makeAllSafe(_this, BaseComponent.prototype, [
            'componentDidMount',
            'shouldComponentUpdate',
            'getSnapshotBeforeUpdate',
            'render',
            'componentDidUpdate',
            'componentWillUnmount'
        ]);
        return _this;
    }
    /**
     * When the component receives props, make sure the componentRef is updated.
     */ BaseComponent.prototype.componentDidUpdate = function(prevProps, prevState) {
        this._updateComponentRef(prevProps, this.props);
    };
    /**
     * When the component has mounted, update the componentRef.
     */ BaseComponent.prototype.componentDidMount = function() {
        this._setComponentRef(this.props.componentRef, this);
    };
    /**
     * If we have disposables, dispose them automatically on unmount.
     */ BaseComponent.prototype.componentWillUnmount = function() {
        this._setComponentRef(this.props.componentRef, null);
        if (this.__disposables) {
            for(var i = 0, len = this._disposables.length; i < len; i++){
                var disposable = this.__disposables[i];
                if (disposable.dispose) disposable.dispose();
            }
            this.__disposables = null;
        }
    };
    Object.defineProperty(BaseComponent.prototype, "className", {
        /**
         * Gets the object's class name.
         */ get: function() {
            if (!this.__className) {
                var funcNameRegex = /function (.{1,})\(/;
                var results = funcNameRegex.exec(this.constructor.toString());
                this.__className = results && results.length > 1 ? results[1] : '';
            }
            return this.__className;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_disposables", {
        /**
         * Allows subclasses to push things to this._disposables to be auto disposed.
         */ get: function() {
            if (!this.__disposables) this.__disposables = [];
            return this.__disposables;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_async", {
        /**
         * Gets the async instance associated with the component, created on demand. The async instance gives
         * subclasses a way to execute setTimeout/setInterval async calls safely, where the callbacks
         * will be cleared/ignored automatically after unmounting. The helpers within the async object also
         * preserve the this pointer so that you don't need to "bind" the callbacks.
         */ get: function() {
            if (!this.__async) {
                this.__async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(this);
                this._disposables.push(this.__async);
            }
            return this.__async;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "_events", {
        /**
         * Gets the event group instance assocaited with the component, created on demand. The event instance
         * provides on/off methods for listening to DOM (or regular javascript object) events. The event callbacks
         * will be automatically disconnected after unmounting. The helpers within the events object also
         * preserve the this reference so that you don't need to "bind" the callbacks.
         */ get: function() {
            if (!this.__events) {
                this.__events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(this);
                this._disposables.push(this.__events);
            }
            return this.__events;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Helper to return a memoized ref resolver function.
     * @param refName - Name of the member to assign the ref to.
     * @returns A function instance keyed from the given refname.
     * @deprecated Use `createRef` from React.createRef.
     */ BaseComponent.prototype._resolveRef = function(refName) {
        var _this = this;
        if (!this.__resolves) this.__resolves = {};
        if (!this.__resolves[refName]) this.__resolves[refName] = function(ref) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return _this[refName] = ref;
        };
        return this.__resolves[refName];
    };
    /**
     * Updates the componentRef (by calling it with "this" when necessary.)
     */ BaseComponent.prototype._updateComponentRef = function(currentProps, newProps) {
        if (newProps === void 0) newProps = {};
        // currentProps *should* always be defined, but verify that just in case a subclass is manually
        // calling a lifecycle method with no parameters (which has happened) or other odd usage.
        if (currentProps && newProps && currentProps.componentRef !== newProps.componentRef) {
            this._setComponentRef(currentProps.componentRef, null);
            this._setComponentRef(newProps.componentRef, this);
        }
    };
    /**
     * Warns when a deprecated props are being used.
     *
     * @param deprecationMap - The map of deprecations, where key is the prop name and the value is
     * either null or a replacement prop name.
     */ BaseComponent.prototype._warnDeprecations = function(deprecationMap) {
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)(this.className, this.props, deprecationMap);
    };
    /**
     * Warns when props which are mutually exclusive with each other are both used.
     *
     * @param mutuallyExclusiveMap - The map of mutually exclusive props.
     */ BaseComponent.prototype._warnMutuallyExclusive = function(mutuallyExclusiveMap) {
        (0, $8c9f8bb7c7ee0375$export$3dca6a71e81a1f03)(this.className, this.props, mutuallyExclusiveMap);
    };
    /**
     * Warns when props are required if a condition is met.
     *
     * @param requiredProps - The name of the props that are required when the condition is met.
     * @param conditionalPropName - The name of the prop that the condition is based on.
     * @param condition - Whether the condition is met.
     */ BaseComponent.prototype._warnConditionallyRequiredProps = function(requiredProps, conditionalPropName, condition) {
        (0, $35efe983fe3c9b91$export$864d02b07a04fe0f)(this.className, this.props, requiredProps, conditionalPropName, condition);
    };
    BaseComponent.prototype._setComponentRef = function(ref, value) {
        if (!this._skipComponentRefResolution && ref) {
            if (typeof ref === 'function') ref(value);
            if (typeof ref === 'object') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref.current = value;
        }
    };
    return BaseComponent;
}($acw62.Component);
/**
 * Helper to override a given method with a wrapper method that can try/catch the original, but also
 * ensures that the BaseComponent's methods are called before the subclass's. This ensures that
 * componentWillUnmount in the base is called and that things in the _disposables array are disposed.
 */ // eslint-disable-next-line @typescript-eslint/no-deprecated
function $12233c50b7efccdc$var$_makeAllSafe(obj, prototype, methodNames) {
    for(var i = 0, len = methodNames.length; i < len; i++)$12233c50b7efccdc$var$_makeSafe(obj, prototype, methodNames[i]);
}
// eslint-disable-next-line @typescript-eslint/no-deprecated
function $12233c50b7efccdc$var$_makeSafe(obj, prototype, methodName) {
    /* eslint-disable @typescript-eslint/no-explicit-any */ var classMethod = obj[methodName];
    var prototypeMethod = prototype[methodName];
    if (classMethod || prototypeMethod) obj[methodName] = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        /* eslint-enable @typescript-eslint/no-explicit-any */ var retVal;
        if (prototypeMethod) retVal = prototypeMethod.apply(this, args);
        if (classMethod !== prototypeMethod) retVal = classMethod.apply(this, args);
        return retVal;
    };
}
function $12233c50b7efccdc$export$c14f77b8570f3676() {
    return null;
}

/**
 * Determines whether or not an element has the virtual hierarchy extension.
 *
 * @public
 */ function $62f1f04af4f10ed3$export$405b1af69064399d(element) {
    return element && !!element._virtual;
}


function $8e13e667a15b71d4$export$7a054da414775188(child) {
    var parent;
    if (child && (0, $62f1f04af4f10ed3$export$405b1af69064399d)(child)) parent = child._virtual.parent;
    return parent;
}


function $7ca0c55777f4d1e1$export$58081aedf094d85b(child, allowVirtualParents) {
    var _a, _b;
    if (allowVirtualParents === void 0) allowVirtualParents = true;
    if (!child) return null;
    var parent = allowVirtualParents && (0, $8e13e667a15b71d4$export$7a054da414775188)(child);
    if (parent) return parent;
    // Support looking for parents in shadow DOM
    if (typeof child.assignedElements !== 'function' && ((_a = child.assignedSlot) === null || _a === void 0 ? void 0 : _a.parentNode)) // Element is slotted
    return child.assignedSlot;
    else if (((_b = child.parentNode) === null || _b === void 0 ? void 0 : _b.nodeType) === 11) // nodeType 11 is DOCUMENT_FRAGMENT
    // Element is in shadow root
    return child.parentNode.host;
    else return child.parentNode;
}


function $ac7720b658a51a62$export$52e9043fba4174a7(element, matchFunction, doc) {
    // eslint-disable-next-line no-restricted-globals
    doc !== null && doc !== void 0 ? doc : doc = document;
    if (!element || element === doc.body || element instanceof Document) return null;
    return matchFunction(element) ? element : $ac7720b658a51a62$export$52e9043fba4174a7((0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(element), matchFunction);
}


var $d38428ba3ade01f7$export$a2035272131f96ca = 'data-portal-element';
function $d38428ba3ade01f7$export$c36b8a5db804ed10(element) {
    element.setAttribute($d38428ba3ade01f7$export$a2035272131f96ca, 'true');
}


function $8eda1135a5ecf96f$export$ca66eda9f83446dd(target, parent, doc) {
    var _a;
    var elementMatch = (0, $ac7720b658a51a62$export$52e9043fba4174a7)(target, function(testElement) {
        var _a;
        return parent === testElement || !!((_a = testElement.hasAttribute) === null || _a === void 0 ? void 0 : _a.call(testElement, (0, $d38428ba3ade01f7$export$a2035272131f96ca)));
    }, doc);
    return elementMatch !== null && !!((_a = elementMatch.hasAttribute) === null || _a === void 0 ? void 0 : _a.call(elementMatch, (0, $d38428ba3ade01f7$export$a2035272131f96ca)));
}




var $acw62 = parcelRequire("acw62");

var $91cc3acbdc44edfa$export$ce4ab0c55987d1ff = (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
    root: {
        display: 'inline-block',
        textDecoration: 'inherit'
    },
    placeholder: [
        'ms-Icon-placeHolder',
        {
            width: '1em'
        }
    ],
    image: [
        'ms-Icon-imageContainer',
        {
            overflow: 'hidden'
        }
    ]
});
var $91cc3acbdc44edfa$export$5895f18d7dadc168 = 'ms-Icon';
var $91cc3acbdc44edfa$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, iconClassName = props.iconClassName, isPlaceholder = props.isPlaceholder, isImage = props.isImage, styles = props.styles;
    return {
        root: [
            isPlaceholder && $91cc3acbdc44edfa$export$ce4ab0c55987d1ff.placeholder,
            $91cc3acbdc44edfa$export$ce4ab0c55987d1ff.root,
            isImage && $91cc3acbdc44edfa$export$ce4ab0c55987d1ff.image,
            iconClassName,
            className,
            styles && styles.root,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            styles && styles.imageContainer
        ]
    };
};




var $eec83b0087c5fe87$export$5222c8060583ee57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(iconName) {
    var _a = (0, $157fc0f40a8f1c26$export$16b26cd5e98d9100)(iconName) || {
        subset: {},
        code: undefined
    }, code = _a.code, subset = _a.subset;
    if (!code) return null;
    return {
        children: code,
        iconClassName: subset.className,
        fontFamily: subset.fontFace && subset.fontFace.fontFamily,
        mergeImageProps: subset.mergeImageProps
    };
}, undefined, true);
var $eec83b0087c5fe87$export$f56ea46797033f60 = function(props) {
    var iconName = props.iconName, className = props.className, _a = props.style, style = _a === void 0 ? {} : _a;
    var iconContent = $eec83b0087c5fe87$export$5222c8060583ee57(iconName) || {};
    var iconClassName = iconContent.iconClassName, children = iconContent.children, fontFamily = iconContent.fontFamily, mergeImageProps = iconContent.mergeImageProps;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
    var accessibleName = props['aria-label'] || props.title;
    var containerProps = props['aria-label'] || props['aria-labelledby'] || props.title ? {
        role: mergeImageProps ? undefined : 'img'
    } : {
        'aria-hidden': true
    };
    var finalChildren = children;
    if (mergeImageProps) {
        if (typeof children === 'object' && typeof children.props === 'object' && accessibleName) finalChildren = $acw62.cloneElement(children, {
            alt: accessibleName
        });
    }
    return $acw62.createElement("i", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        "data-icon-name": iconName
    }, containerProps, nativeProps, mergeImageProps ? {
        title: undefined,
        'aria-label': undefined
    } : {}, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)((0, $91cc3acbdc44edfa$export$5895f18d7dadc168), (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).root, iconClassName, !iconName && (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).placeholder, className),
        // Apply the font family this way to ensure it doesn't get overridden by Fabric Core ms-Icon styles
        // https://github.com/microsoft/fluentui/issues/10449
        style: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            fontFamily: fontFamily
        }, style)
    }), finalChildren);
};
var $eec83b0087c5fe87$export$2160c7b76a453797 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(iconName, className, ariaLabel) {
    return $eec83b0087c5fe87$export$f56ea46797033f60({
        iconName: iconName,
        className: className,
        'aria-label': ariaLabel
    });
});




var $acw62 = parcelRequire("acw62");
/**
 * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
 * {@docCategory Icon}
 */ var $b2334e548db36fc7$export$13ff1290a9e22e77;
(function(IconType) {
    /**
     * Render using the fabric icon font.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["default"] = 0] = "default";
    /**
     * Render using an image, where imageProps would be used.
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["image"] = 1] = "image";
    /**
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["Default"] = 100000] = "Default";
    /**
     * @deprecated Icon type is inferred based on presence of `IIconProps.imageProps`
     */ IconType[IconType["Image"] = 100001] = "Image";
})($b2334e548db36fc7$export$13ff1290a9e22e77 || ($b2334e548db36fc7$export$13ff1290a9e22e77 = {}));





var $acw62 = parcelRequire("acw62");

/**
 * The possible methods that can be used to fit the image.
 * {@docCategory Image}
 */ var $7ce18db28442d0b5$export$76ad86136a99d38d;
(function(ImageFit) {
    /**
     * The image is not scaled. The image is centered and cropped within the content box.
     */ ImageFit[ImageFit["center"] = 0] = "center";
    /**
     * The image is scaled to maintain its aspect ratio while being fully contained within the frame. The image will
     * be centered horizontally and vertically within the frame. The space in the top and bottom or in the sides of
     * the frame will be empty depending on the difference in aspect ratio between the image and the frame.
     */ ImageFit[ImageFit["contain"] = 1] = "contain";
    /**
     * The image is scaled to maintain its aspect ratio while filling the frame. Portions of the image will be cropped
     * from the top and bottom, or the sides, depending on the difference in aspect ratio between the image and the frame.
     */ ImageFit[ImageFit["cover"] = 2] = "cover";
    /**
     * Neither the image nor the frame are scaled. If their sizes do not match, the image will either be cropped or the
     * frame will have empty space.
     */ ImageFit[ImageFit["none"] = 3] = "none";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height or width is less than the Image frame's height or width,
     * but if both natural height and width are larger than the frame it will behave as ImageFit.cover.
     */ ImageFit[ImageFit["centerCover"] = 4] = "centerCover";
    /**
     * The image will be centered horizontally and vertically within the frame and maintains its aspect ratio. It will
     * behave as ImageFit.center if the image's natural height and width is less than the Image frame's height and width,
     * but if either natural height or width are larger than the frame it will behave as ImageFit.contain.
     */ ImageFit[ImageFit["centerContain"] = 5] = "centerContain";
})($7ce18db28442d0b5$export$76ad86136a99d38d || ($7ce18db28442d0b5$export$76ad86136a99d38d = {}));
var $7ce18db28442d0b5$export$45bb2c5c61dbecf7;
(function(ImageCoverStyle) {
    /**
     * The image will be shown at 100% height of container and the width will be scaled accordingly
     */ ImageCoverStyle[ImageCoverStyle["landscape"] = 0] = "landscape";
    /**
     * The image will be shown at 100% width of container and the height will be scaled accordingly
     */ ImageCoverStyle[ImageCoverStyle["portrait"] = 1] = "portrait";
})($7ce18db28442d0b5$export$45bb2c5c61dbecf7 || ($7ce18db28442d0b5$export$45bb2c5c61dbecf7 = {}));
var $7ce18db28442d0b5$export$f1a20b6e49b78679;
(function(ImageLoadState) {
    /**
     * The image has not yet been loaded, and there is no error yet.
     */ ImageLoadState[ImageLoadState["notLoaded"] = 0] = "notLoaded";
    /**
     * The image has been loaded successfully.
     */ ImageLoadState[ImageLoadState["loaded"] = 1] = "loaded";
    /**
     * An error has been encountered while loading the image.
     */ ImageLoadState[ImageLoadState["error"] = 2] = "error";
    /**
     * @deprecated Not used. Use `onLoadingStateChange` and re-render the Image with a different src.
     */ ImageLoadState[ImageLoadState["errorLoaded"] = 3] = "errorLoaded";
})($7ce18db28442d0b5$export$f1a20b6e49b78679 || ($7ce18db28442d0b5$export$f1a20b6e49b78679 = {}));



var $acw62 = parcelRequire("acw62");

var $8c9c580731387b01$export$700979bc83e7db82 = (0, $18aa0efffa2a3752$export$71594e8a50f746f4)() ? $acw62.useLayoutEffect : $acw62.useEffect;



var $acw62 = parcelRequire("acw62");
function $0dfbd1d4e59c5781$export$9cf7d991616612b3() {
    var refs = [];
    for(var _i = 0; _i < arguments.length; _i++)refs[_i] = arguments[_i];
    var mergedCallback = $acw62.useCallback(function(value) {
        // Update the "current" prop hanging on the function.
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        mergedCallback.current = value;
        for(var _i = 0, refs_1 = refs; _i < refs_1.length; _i++){
            var ref = refs_1[_i];
            if (typeof ref === 'function') ref(value);
            else if (ref) // work around the immutability of the React.Ref type
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ref.current = value;
        }
    }, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], refs, true));
    return mergedCallback;
}


var $649c58d3f72a3825$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $649c58d3f72a3825$var$SVG_REGEX = /\.svg$/i;
var $649c58d3f72a3825$var$KEY_PREFIX = 'fabricImage';
function $649c58d3f72a3825$var$useLoadState(props, imageElement) {
    var onLoadingStateChange = props.onLoadingStateChange, onLoad = props.onLoad, onError = props.onError, src = props.src;
    var _a = $acw62.useState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded), loadState = _a[0], setLoadState = _a[1];
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        // If the src property changes, reset the load state
        // (does nothing if the load state is already notLoaded)
        setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded);
    }, [
        src
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intended to run every render
    $acw62.useEffect(function() {
        if (loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded) {
            // testing if naturalWidth and naturalHeight are greater than zero is better than checking
            // .complete, because .complete will also be set to true if the image breaks. However,
            // for some browsers, SVG images do not have a naturalWidth or naturalHeight, so fall back
            // to checking .complete for these images.
            var isLoaded = imageElement.current ? src && imageElement.current.naturalWidth > 0 && imageElement.current.naturalHeight > 0 || imageElement.current.complete && $649c58d3f72a3825$var$SVG_REGEX.test(src) : false;
            if (isLoaded) setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded);
        }
    });
    $acw62.useEffect(function() {
        onLoadingStateChange === null || onLoadingStateChange === void 0 || onLoadingStateChange(loadState);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when loadState changes
    }, [
        loadState
    ]);
    var onImageLoaded = $acw62.useCallback(function(ev) {
        onLoad === null || onLoad === void 0 || onLoad(ev);
        if (src) setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded);
    }, [
        src,
        onLoad
    ]);
    var onImageError = $acw62.useCallback(function(ev) {
        onError === null || onError === void 0 || onError(ev);
        setLoadState((0, $7ce18db28442d0b5$export$f1a20b6e49b78679).error);
    }, [
        onError
    ]);
    return [
        loadState,
        onImageLoaded,
        onImageError
    ];
}
var $649c58d3f72a3825$export$a3758d3f9ac64232 = $acw62.forwardRef(function(props, forwardedRef) {
    var frameElement = $acw62.useRef(undefined);
    var imageElement = $acw62.useRef(undefined);
    var _a = $649c58d3f72a3825$var$useLoadState(props, imageElement), loadState = _a[0], onImageLoaded = _a[1], onImageError = _a[2];
    var imageProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$91f8cc2b546c057d), [
        'width',
        'height'
    ]);
    var src = props.src, alt = props.alt, width = props.width, height = props.height, _b = props.shouldFadeIn, shouldFadeIn = _b === void 0 ? true : _b, shouldStartVisible = props.shouldStartVisible, className = props.className, imageFit = props.imageFit, role = props.role, maximizeFrame = props.maximizeFrame, styles = props.styles, theme = props.theme, loading = props.loading;
    var coverStyle = $649c58d3f72a3825$var$useCoverStyle(props, loadState, imageElement, frameElement);
    var classNames = $649c58d3f72a3825$var$getClassNames(styles, {
        theme: theme,
        className: className,
        width: width,
        height: height,
        maximizeFrame: maximizeFrame,
        shouldFadeIn: shouldFadeIn,
        shouldStartVisible: shouldStartVisible,
        isLoaded: loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded || loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded && props.shouldStartVisible,
        isLandscape: coverStyle === (0, $7ce18db28442d0b5$export$45bb2c5c61dbecf7).landscape,
        isCenter: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).center,
        isCenterContain: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerContain,
        isCenterCover: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerCover,
        isContain: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).contain,
        isCover: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).cover,
        isNone: imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).none,
        isError: loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).error,
        isNotImageFit: imageFit === undefined
    });
    // If image dimensions aren't specified, the natural size of the image is used.
    return $acw62.createElement("div", {
        className: classNames.root,
        style: {
            width: width,
            height: height
        },
        ref: frameElement
    }, $acw62.createElement("img", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, imageProps, {
        onLoad: onImageLoaded,
        onError: onImageError,
        key: $649c58d3f72a3825$var$KEY_PREFIX + props.src || '',
        className: classNames.image,
        ref: (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(imageElement, forwardedRef),
        src: src,
        alt: alt,
        role: role,
        loading: loading
    })));
});
$649c58d3f72a3825$export$a3758d3f9ac64232.displayName = 'ImageBase';
function $649c58d3f72a3825$var$useCoverStyle(props, loadState, imageElement, frameElement) {
    var previousLoadState = $acw62.useRef(loadState);
    var coverStyle = $acw62.useRef(undefined);
    if (coverStyle === undefined || previousLoadState.current === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).notLoaded && loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded) coverStyle.current = $649c58d3f72a3825$var$computeCoverStyle(props, loadState, imageElement, frameElement);
    previousLoadState.current = loadState;
    return coverStyle.current;
}
function $649c58d3f72a3825$var$computeCoverStyle(props, loadState, imageElement, frameElement) {
    var imageFit = props.imageFit, width = props.width, height = props.height;
    // Do not compute cover style if it was already specified in props
    if (props.coverStyle !== undefined) return props.coverStyle;
    else if (loadState === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).loaded && (imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).cover || imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).contain || imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerContain || imageFit === (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerCover) && imageElement.current && frameElement.current) {
        // Determine the desired ratio using the width and height props.
        // If those props aren't available, measure measure the frame.
        var desiredRatio = void 0;
        if (typeof width === 'number' && typeof height === 'number' && imageFit !== (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerContain && imageFit !== (0, $7ce18db28442d0b5$export$76ad86136a99d38d).centerCover) desiredRatio = width / height;
        else desiredRatio = frameElement.current.clientWidth / frameElement.current.clientHeight;
        // Examine the source image to determine its original ratio.
        var naturalRatio = imageElement.current.naturalWidth / imageElement.current.naturalHeight;
        // Should we crop from the top or the sides?
        if (naturalRatio > desiredRatio) return (0, $7ce18db28442d0b5$export$45bb2c5c61dbecf7).landscape;
    }
    return (0, $7ce18db28442d0b5$export$45bb2c5c61dbecf7).portrait;
}




var $c192249f2ea24da6$var$GlobalClassNames = {
    root: 'ms-Image',
    rootMaximizeFrame: 'ms-Image--maximizeFrame',
    image: 'ms-Image-image',
    imageCenter: 'ms-Image-image--center',
    imageContain: 'ms-Image-image--contain',
    imageCover: 'ms-Image-image--cover',
    imageCenterContain: 'ms-Image-image--centerContain',
    imageCenterCover: 'ms-Image-image--centerCover',
    imageNone: 'ms-Image-image--none',
    imageLandscape: 'ms-Image-image--landscape',
    imagePortrait: 'ms-Image-image--portrait'
};
var $c192249f2ea24da6$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, width = props.width, height = props.height, maximizeFrame = props.maximizeFrame, isLoaded = props.isLoaded, shouldFadeIn = props.shouldFadeIn, shouldStartVisible = props.shouldStartVisible, isLandscape = props.isLandscape, isCenter = props.isCenter, isContain = props.isContain, isCover = props.isCover, isCenterContain = props.isCenterContain, isCenterCover = props.isCenterCover, isNone = props.isNone, isError = props.isError, isNotImageFit = props.isNotImageFit, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($c192249f2ea24da6$var$GlobalClassNames, theme);
    var ImageFitStyles = {
        position: 'absolute',
        left: '50% /* @noflip */',
        top: '50%',
        transform: 'translate(-50%,-50%)'
    };
    // Cut the mustard using msMaxTouchPoints to detect IE11 which does not support CSS object-fit
    var window = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    var supportsObjectFit = window !== undefined && // eslint-disable-next-line @fluentui/max-len
    // cast needed as vendor prefixed `msMaxTouchPoints` api is no longer part of TS lib declaration - introduced with TS 4.4
    window.navigator.msMaxTouchPoints === undefined;
    var fallbackObjectFitStyles = isContain && isLandscape || isCover && !isLandscape ? {
        width: '100%',
        height: 'auto'
    } : {
        width: 'auto',
        height: '100%'
    };
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                overflow: 'hidden'
            },
            maximizeFrame && [
                classNames.rootMaximizeFrame,
                {
                    height: '100%',
                    width: '100%'
                }
            ],
            isLoaded && shouldFadeIn && !shouldStartVisible && (0, $e2629e8d47c94809$export$a386448ab9904275).fadeIn400,
            (isCenter || isContain || isCover || isCenterContain || isCenterCover) && {
                position: 'relative'
            },
            className
        ],
        image: [
            classNames.image,
            {
                display: 'block',
                opacity: 0
            },
            isLoaded && [
                'is-loaded',
                {
                    opacity: 1
                }
            ],
            isCenter && [
                classNames.imageCenter,
                ImageFitStyles
            ],
            isContain && [
                classNames.imageContain,
                supportsObjectFit && {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                !supportsObjectFit && ImageFitStyles
            ],
            isCover && [
                classNames.imageCover,
                supportsObjectFit && {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                },
                !supportsObjectFit && fallbackObjectFitStyles,
                !supportsObjectFit && ImageFitStyles
            ],
            isCenterContain && [
                classNames.imageCenterContain,
                isLandscape && {
                    maxWidth: '100%'
                },
                !isLandscape && {
                    maxHeight: '100%'
                },
                ImageFitStyles
            ],
            isCenterCover && [
                classNames.imageCenterCover,
                isLandscape && {
                    maxHeight: '100%'
                },
                !isLandscape && {
                    maxWidth: '100%'
                },
                ImageFitStyles
            ],
            isNone && [
                classNames.imageNone,
                {
                    width: 'auto',
                    height: 'auto'
                }
            ],
            isNotImageFit && [
                !!width && !height && {
                    height: 'auto',
                    width: '100%'
                },
                !width && !!height && {
                    height: '100%',
                    width: 'auto'
                },
                !!width && !!height && {
                    height: '100%',
                    width: '100%'
                }
            ],
            isLandscape && classNames.imageLandscape,
            !isLandscape && classNames.imagePortrait,
            !isLoaded && 'is-notLoaded',
            shouldFadeIn && 'is-fadeIn',
            isError && 'is-error'
        ]
    };
};


var $6023154631a54d52$export$3e431a229df88919 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $649c58d3f72a3825$export$a3758d3f9ac64232), (0, $c192249f2ea24da6$export$ffd58b7f6f099a57), undefined, {
    scope: 'Image'
}, true);
$6023154631a54d52$export$3e431a229df88919.displayName = 'Image';





var $c165ae9cd6954cb9$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)({
    // Icon is used a lot by other components.
    // It's likely to see expected cases which pass different className to the Icon.
    // Therefore setting a larger cache size.
    cacheSize: 100
});
var $c165ae9cd6954cb9$export$a188ecdd443fe91a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IconBase, _super);
    function IconBase(props) {
        var _this = _super.call(this, props) || this;
        _this._onImageLoadingStateChange = function(state) {
            if (_this.props.imageProps && _this.props.imageProps.onLoadingStateChange) _this.props.imageProps.onLoadingStateChange(state);
            if (state === (0, $7ce18db28442d0b5$export$f1a20b6e49b78679).error) _this.setState({
                imageLoadError: true
            });
        };
        _this.state = {
            imageLoadError: false
        };
        return _this;
    }
    IconBase.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className, styles = _a.styles, iconName = _a.iconName, imageErrorAs = _a.imageErrorAs, theme = _a.theme;
        var isPlaceholder = typeof iconName === 'string' && iconName.length === 0;
        var isImage = // eslint-disable-next-line @typescript-eslint/no-deprecated
        !!this.props.imageProps || this.props.iconType === (0, $b2334e548db36fc7$export$13ff1290a9e22e77).image || this.props.iconType === (0, $b2334e548db36fc7$export$13ff1290a9e22e77).Image;
        var iconContent = (0, $eec83b0087c5fe87$export$5222c8060583ee57)(iconName) || {};
        var iconClassName = iconContent.iconClassName, iconContentChildren = iconContent.children, mergeImageProps = iconContent.mergeImageProps;
        var classNames = $c165ae9cd6954cb9$var$getClassNames(styles, {
            theme: theme,
            className: className,
            iconClassName: iconClassName,
            isImage: isImage,
            isPlaceholder: isPlaceholder
        });
        var RootType = isImage ? 'span' : 'i';
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40), [
            'aria-label'
        ]);
        var imageLoadError = this.state.imageLoadError;
        var imageProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props.imageProps), {
            onLoadingStateChange: this._onImageLoadingStateChange
        });
        var ImageType = imageLoadError && imageErrorAs || (0, $6023154631a54d52$export$3e431a229df88919);
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var ariaLabel = this.props['aria-label'] || this.props.ariaLabel;
        var accessibleName = imageProps.alt || ariaLabel || this.props.title;
        var hasName = !!(accessibleName || this.props['aria-labelledby'] || imageProps['aria-label'] || imageProps['aria-labelledby']);
        var containerProps = hasName ? {
            role: isImage || mergeImageProps ? undefined : 'img',
            'aria-label': isImage || mergeImageProps ? undefined : accessibleName
        } : {
            'aria-hidden': true
        };
        var finalIconContentChildren = iconContentChildren;
        if (mergeImageProps && iconContentChildren && typeof iconContentChildren === 'object' && accessibleName) finalIconContentChildren = $acw62.cloneElement(iconContentChildren, {
            alt: accessibleName
        });
        return $acw62.createElement(RootType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-icon-name": iconName
        }, containerProps, nativeProps, mergeImageProps ? {
            title: undefined,
            'aria-label': undefined
        } : {}, {
            className: classNames.root
        }), isImage ? $acw62.createElement(ImageType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, imageProps)) : children || finalIconContentChildren);
    };
    return IconBase;
}($acw62.Component);



var $4b3e235077c5b552$export$f04a61298a47a40f = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $c165ae9cd6954cb9$export$a188ecdd443fe91a), (0, $91cc3acbdc44edfa$export$ffd58b7f6f099a57), undefined, {
    scope: 'Icon'
}, true);
$4b3e235077c5b552$export$f04a61298a47a40f.displayName = 'Icon';



var $acw62 = parcelRequire("acw62");



var $98737100b97aa693$export$4a122bafaa48b23d = function(props) {
    var className = props.className, imageProps = props.imageProps;
    var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40), [
        'aria-label',
        'aria-labelledby',
        'title',
        'aria-describedby'
    ]);
    var altText = imageProps.alt || props['aria-label'];
    var hasName = altText || props['aria-labelledby'] || props.title || imageProps['aria-label'] || imageProps['aria-labelledby'] || imageProps.title;
    // move naming or describing attributes from the container (where they are invalid) to the image
    var imageNameProps = {
        'aria-labelledby': props['aria-labelledby'],
        'aria-describedby': props['aria-describedby'],
        title: props.title
    };
    var containerProps = hasName ? {} : {
        'aria-hidden': true
    };
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, nativeProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)((0, $91cc3acbdc44edfa$export$5895f18d7dadc168), (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).root, (0, $91cc3acbdc44edfa$export$ce4ab0c55987d1ff).image, className)
    }), $acw62.createElement((0, $6023154631a54d52$export$3e431a229df88919), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, imageNameProps, imageProps, {
        alt: hasName ? altText : ''
    })));
};


var $e52f208cfc343b11$export$7bbc434a13063638 = {
    /**
     * Appear above the target element, with the left edges of the callout and target aligning.
     */ topLeftEdge: 0,
    /**
     * Appear above the target element, with the centers of the callout and target aligning.
     */ topCenter: 1,
    /**
     * Appear above the target element, with the right edges of the callout and target aligning.
     */ topRightEdge: 2,
    /**
     * Appear above the target element, aligning with the target element such that the callout tends toward
     * the center of the screen.
     */ topAutoEdge: 3,
    /**
     * Appear below the target element, with the left edges of the callout and target aligning.
     */ bottomLeftEdge: 4,
    /**
     * Appear below the target element, with the centers of the callout and target aligning.
     */ bottomCenter: 5,
    /**
     * Appear below the target element, with the right edges of the callout and target aligning.
     */ bottomRightEdge: 6,
    /**
     * Appear below the target element, aligning with the target element such that the callout tends toward
     * the center of the screen.
     */ bottomAutoEdge: 7,
    /**
     * Appear to the left of the target element, with the top edges of the callout and target aligning.
     */ leftTopEdge: 8,
    /**
     * Appear to the left of the target element, with the centers of the callout and target aligning.
     */ leftCenter: 9,
    /**
     * Appear to the left of the target element, with the bottom edges of the callout and target aligning.
     */ leftBottomEdge: 10,
    /**
     * Appear to the right of the target element, with the top edges of the callout and target aligning.
     */ rightTopEdge: 11,
    /**
     * Appear to the right of the target element, with the centers of the callout and target aligning.
     */ rightCenter: 12,
    /**
     * Appear to the right of the target element, with the bottom edges of the callout and target aligning.
     */ rightBottomEdge: 13
};




var $acw62 = parcelRequire("acw62");

function $dcded159bee91fac$var$createComposedRenderFunction(outer) {
    var outerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(inner) {
        var innerMemoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)(function(defaultRender) {
            return function(innerProps) {
                return inner(innerProps, defaultRender);
            };
        });
        return function(outerProps, defaultRender) {
            return outer(outerProps, defaultRender ? innerMemoizer(defaultRender) : inner);
        };
    });
    return outerMemoizer;
}
var $dcded159bee91fac$var$memoizer = (0, $ccf88a0d18e38068$export$99061b04f99342f)($dcded159bee91fac$var$createComposedRenderFunction);
function $dcded159bee91fac$export$6427897eb70b5e23(outer, inner) {
    return $dcded159bee91fac$var$memoizer(outer)(inner);
}




var $acw62 = parcelRequire("acw62");

var $406552f968f746a1$export$7dc3c01339ee6e7f;
(function(ContextualMenuItemType) {
    ContextualMenuItemType[ContextualMenuItemType["Normal"] = 0] = "Normal";
    ContextualMenuItemType[ContextualMenuItemType["Divider"] = 1] = "Divider";
    ContextualMenuItemType[ContextualMenuItemType["Header"] = 2] = "Header";
    ContextualMenuItemType[ContextualMenuItemType["Section"] = 3] = "Section";
})($406552f968f746a1$export$7dc3c01339ee6e7f || ($406552f968f746a1$export$7dc3c01339ee6e7f = {}));





var $acw62 = parcelRequire("acw62");
/**
 * {@docCategory FocusZone}
 */ var $13ca773bee6ceecf$export$269041a88986a933 = {
    /** Tabbing is not allowed */ none: 0,
    /** All tabbing action is allowed */ all: 1,
    /** Tabbing is allowed only on input elements */ inputOnly: 2
};
var $13ca773bee6ceecf$export$5764f9ffe1c23cd3;
(function(FocusZoneDirection) {
    /** Only react to up/down arrows. */ FocusZoneDirection[FocusZoneDirection["vertical"] = 0] = "vertical";
    /** Only react to left/right arrows. */ FocusZoneDirection[FocusZoneDirection["horizontal"] = 1] = "horizontal";
    /** React to all arrows. */ FocusZoneDirection[FocusZoneDirection["bidirectional"] = 2] = "bidirectional";
    /**
     * React to all arrows. Navigate next item in DOM on right/down arrow keys and previous - left/up arrow keys.
     * Right and Left arrow keys are swapped in RTL mode.
     */ FocusZoneDirection[FocusZoneDirection["domOrder"] = 3] = "domOrder";
})($13ca773bee6ceecf$export$5764f9ffe1c23cd3 || ($13ca773bee6ceecf$export$5764f9ffe1c23cd3 = {}));



function $bd2f10be17e6ca27$export$12de49ec5e3dd0cd(parent, child, allowVirtualParents) {
    if (allowVirtualParents === void 0) allowVirtualParents = true;
    var isContained = false;
    if (parent && child) {
        if (allowVirtualParents) {
            if (parent === child) isContained = true;
            else {
                isContained = false;
                while(child){
                    var nextParent = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(child);
                    if (nextParent === parent) {
                        isContained = true;
                        break;
                    }
                    child = nextParent;
                }
            }
        } else if (parent.contains) isContained = parent.contains(child);
    }
    return isContained;
}




var $11f97b2a9a127629$var$_scrollbarWidth;
var $11f97b2a9a127629$var$_bodyScrollDisabledCount = 0;
var $11f97b2a9a127629$var$DisabledScrollClassName = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)({
    overflow: 'hidden !important'
});
var $11f97b2a9a127629$export$5d74730bd625cf54 = 'data-is-scrollable';
var $11f97b2a9a127629$export$f02f9101103a4939 = function(element, events) {
    var window = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(element);
    if (!element || !window) return;
    var _previousClientY = 0;
    var _element = null;
    var computedStyles = window.getComputedStyle(element);
    // remember the clientY for future calls of _preventOverscrolling
    var _saveClientY = function(event) {
        if (event.targetTouches.length === 1) _previousClientY = event.targetTouches[0].clientY;
    };
    // prevent the body from scrolling when the user attempts
    // to scroll past the top or bottom of the element
    var _preventOverscrolling = function(event) {
        // only respond to a single-finger touch
        if (event.targetTouches.length !== 1) return;
        // prevent the body touchmove handler from firing
        // so that scrolling is allowed within the element
        event.stopPropagation();
        if (!_element) return;
        var clientY = event.targetTouches[0].clientY - _previousClientY;
        var scrollableParent = $11f97b2a9a127629$export$494fa69500a5872a(event.target);
        if (scrollableParent && _element !== scrollableParent) {
            _element = scrollableParent;
            computedStyles = window.getComputedStyle(_element);
        }
        var scrollTop = _element.scrollTop;
        var isColumnReverse = (computedStyles === null || computedStyles === void 0 ? void 0 : computedStyles.flexDirection) === 'column-reverse';
        // if the element is scrolled to the top,
        // prevent the user from scrolling up
        if (scrollTop === 0 && (isColumnReverse ? clientY < 0 : clientY > 0)) event.preventDefault();
        // if the element is scrolled to the bottom,
        // prevent the user from scrolling down
        if (_element.scrollHeight - Math.abs(Math.ceil(scrollTop)) <= _element.clientHeight && (isColumnReverse ? clientY > 0 : clientY < 0)) event.preventDefault();
    };
    events.on(element, 'touchstart', _saveClientY, {
        passive: false
    });
    events.on(element, 'touchmove', _preventOverscrolling, {
        passive: false
    });
    _element = element;
};
var $11f97b2a9a127629$export$d4daebbd8ba7010c = function(element, events) {
    if (!element) return;
    var _allowElementScroll = function(event) {
        event.stopPropagation();
    };
    events.on(element, 'touchmove', _allowElementScroll, {
        passive: false
    });
};
var $11f97b2a9a127629$var$_disableIosBodyScroll = function(event) {
    event.preventDefault();
};
function $11f97b2a9a127629$export$24fdf68abf432c44() {
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    if (doc && doc.body && !$11f97b2a9a127629$var$_bodyScrollDisabledCount) {
        doc.body.classList.add($11f97b2a9a127629$var$DisabledScrollClassName);
        doc.body.addEventListener('touchmove', $11f97b2a9a127629$var$_disableIosBodyScroll, {
            passive: false,
            capture: false
        });
    }
    $11f97b2a9a127629$var$_bodyScrollDisabledCount++;
}
function $11f97b2a9a127629$export$e5d0524c3725571e() {
    if ($11f97b2a9a127629$var$_bodyScrollDisabledCount > 0) {
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        if (doc && doc.body && $11f97b2a9a127629$var$_bodyScrollDisabledCount === 1) {
            doc.body.classList.remove($11f97b2a9a127629$var$DisabledScrollClassName);
            doc.body.removeEventListener('touchmove', $11f97b2a9a127629$var$_disableIosBodyScroll);
        }
        $11f97b2a9a127629$var$_bodyScrollDisabledCount--;
    }
}
function $11f97b2a9a127629$export$ace028f8da1a6300(doc) {
    if ($11f97b2a9a127629$var$_scrollbarWidth === undefined) {
        var theDoc = doc !== null && doc !== void 0 ? doc : (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
        var scrollDiv = theDoc.createElement('div');
        scrollDiv.style.setProperty('width', '100px');
        scrollDiv.style.setProperty('height', '100px');
        scrollDiv.style.setProperty('overflow', 'scroll');
        scrollDiv.style.setProperty('position', 'absolute');
        scrollDiv.style.setProperty('top', '-9999px');
        theDoc.body.appendChild(scrollDiv);
        // Get the scrollbar width
        $11f97b2a9a127629$var$_scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        // Delete the DIV
        theDoc.body.removeChild(scrollDiv);
    }
    return $11f97b2a9a127629$var$_scrollbarWidth;
}
function $11f97b2a9a127629$export$494fa69500a5872a(startingElement) {
    var el = startingElement;
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(startingElement);
    // First do a quick scan for the scrollable attribute.
    while(el && el !== doc.body){
        if (el.getAttribute($11f97b2a9a127629$export$5d74730bd625cf54) === 'true') return el;
        el = el.parentElement;
    }
    // If we haven't found it, the use the slower method: compute styles to evaluate if overflow is set.
    el = startingElement;
    while(el && el !== doc.body){
        if (el.getAttribute($11f97b2a9a127629$export$5d74730bd625cf54) !== 'false') {
            var computedStyles = getComputedStyle(el);
            var overflowY = computedStyles ? computedStyles.getPropertyValue('overflow-y') : '';
            if (overflowY && (overflowY === 'scroll' || overflowY === 'auto')) return el;
        }
        el = el.parentElement;
    }
    // Fall back to window scroll.
    if (!el || el === doc.body) el = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(startingElement);
    return el;
}


function $9f024846b985abb6$export$c87fe71d3aea462(element, attribute, doc) {
    var elementMatch = (0, $ac7720b658a51a62$export$52e9043fba4174a7)(element, function(testElement) {
        return testElement.hasAttribute(attribute);
    }, doc);
    return elementMatch && elementMatch.getAttribute(attribute);
}






var $94bdc1ebed789608$var$IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
var $94bdc1ebed789608$var$IS_VISIBLE_ATTRIBUTE = 'data-is-visible';
var $94bdc1ebed789608$var$FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
var $94bdc1ebed789608$var$FOCUSZONE_SUB_ATTRIBUTE = 'data-is-sub-focuszone';
function $94bdc1ebed789608$export$748138f04a69bf21(rootElement, currentElement, includeElementsInFocusZones, includeShadowRoots) {
    return $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement, true, false, false, includeElementsInFocusZones, undefined, undefined, undefined, includeShadowRoots);
}
function $94bdc1ebed789608$export$73e81fa65335a75b(rootElement, currentElement, includeElementsInFocusZones, includeShadowRoots) {
    return $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement, true, false, true, includeElementsInFocusZones, undefined, undefined, includeShadowRoots);
}
function $94bdc1ebed789608$export$9beaf9bf6ff178ae(rootElement, currentElement, includeElementsInFocusZones, checkNode, includeShadowRoots) {
    if (checkNode === void 0) checkNode = true;
    return $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement, checkNode, false, false, includeElementsInFocusZones, false, true, undefined, includeShadowRoots);
}
function $94bdc1ebed789608$export$73cc6e682b257cff(rootElement, currentElement, includeElementsInFocusZones, checkNode, includeShadowRoots) {
    if (checkNode === void 0) checkNode = true;
    return $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement, checkNode, false, true, includeElementsInFocusZones, false, true, includeShadowRoots);
}
function $94bdc1ebed789608$export$8765806c2c274519(rootElement, bypassHiddenElements, includeShadowRoots) {
    var element = $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, rootElement, true, false, false, true, undefined, undefined, bypassHiddenElements, includeShadowRoots);
    if (element) {
        $94bdc1ebed789608$export$b5a401136c35d08a(element);
        return true;
    }
    return false;
}
function $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement, checkNode, suppressParentTraversal, traverseChildren, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots) {
    var _a;
    if (!currentElement || !allowFocusRoot && currentElement === rootElement) return null;
    var isCurrentElementVisible = $94bdc1ebed789608$export$e989c0fffaa6b27a(currentElement);
    // Check its children.
    if (traverseChildren && isCurrentElementVisible && (includeElementsInFocusZones || !($94bdc1ebed789608$export$1b55aa98f48e3915(currentElement) || $94bdc1ebed789608$export$7e6b7baad6f0187d(currentElement)))) {
        var lastElementChild = currentElement.lastElementChild || includeShadowRoots && ((_a = currentElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.lastElementChild);
        var childMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, lastElementChild, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
        if (childMatch) {
            if (tabbable && $94bdc1ebed789608$export$5d5979bf640d1558(childMatch, true, includeShadowRoots) || !tabbable) return childMatch;
            var childMatchSiblingMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, childMatch.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
            if (childMatchSiblingMatch) return childMatchSiblingMatch;
            var childMatchParent = childMatch.parentElement;
            // At this point if we have not found any potential matches
            // start looking at the rest of the subtree under the currentParent.
            // NOTE: We do not want to recurse here because doing so could
            // cause elements to get skipped.
            while(childMatchParent && childMatchParent !== currentElement){
                var childMatchParentMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, childMatchParent.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
                if (childMatchParentMatch) return childMatchParentMatch;
                childMatchParent = childMatchParent.parentElement;
            }
        }
    }
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && $94bdc1ebed789608$export$5d5979bf640d1558(currentElement, tabbable, includeShadowRoots)) return currentElement;
    // Check its previous sibling.
    var siblingMatch = $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement.previousElementSibling, true, true, true, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
    if (siblingMatch) return siblingMatch;
    // Check its parent.
    if (!suppressParentTraversal) return $94bdc1ebed789608$export$42ed4d93850449f7(rootElement, currentElement.parentElement, true, false, false, includeElementsInFocusZones, allowFocusRoot, tabbable, includeShadowRoots);
    return null;
}
function $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement, checkNode, suppressParentTraversal, suppressChildTraversal, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots) {
    var _a;
    if (!currentElement || currentElement === rootElement && suppressChildTraversal && !allowFocusRoot) return null;
    var checkElementVisibility = bypassHiddenElements ? $94bdc1ebed789608$export$5d127f54530ed28b : $94bdc1ebed789608$export$e989c0fffaa6b27a;
    var isCurrentElementVisible = checkElementVisibility(currentElement);
    // Check the current node, if it's not the first traversal.
    if (checkNode && isCurrentElementVisible && $94bdc1ebed789608$export$5d5979bf640d1558(currentElement, tabbable, includeShadowRoots)) return currentElement;
    // Check its children.
    if (!suppressChildTraversal && isCurrentElementVisible && (includeElementsInFocusZones || !($94bdc1ebed789608$export$1b55aa98f48e3915(currentElement) || $94bdc1ebed789608$export$7e6b7baad6f0187d(currentElement)))) {
        var firstElementchild = currentElement.firstElementChild || includeShadowRoots && ((_a = currentElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.firstElementChild);
        var childMatch = $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, firstElementchild, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots);
        if (childMatch) return childMatch;
    }
    if (currentElement === rootElement) return null;
    // Check its sibling.
    var siblingMatch = $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement.nextElementSibling, true, true, false, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots);
    if (siblingMatch) return siblingMatch;
    if (!suppressParentTraversal) return $94bdc1ebed789608$export$4109ed81edd7716d(rootElement, currentElement.parentElement, false, false, true, includeElementsInFocusZones, allowFocusRoot, tabbable, bypassHiddenElements, includeShadowRoots);
    return null;
}
function $94bdc1ebed789608$export$e989c0fffaa6b27a(element) {
    // If the element is not valid, return false.
    if (!element || !element.getAttribute) return false;
    var visibilityAttribute = element.getAttribute($94bdc1ebed789608$var$IS_VISIBLE_ATTRIBUTE);
    // If the element is explicitly marked with the visibility attribute, return that value as boolean.
    if (visibilityAttribute !== null && visibilityAttribute !== undefined) return visibilityAttribute === 'true';
    // Fallback to other methods of determining actual visibility.
    return element.offsetHeight !== 0 || element.offsetParent !== null || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    element.isVisible === true; // used as a workaround for testing.
}
function $94bdc1ebed789608$export$5d127f54530ed28b(element, win) {
    var theWin = win !== null && win !== void 0 ? win : (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    return !!element && $94bdc1ebed789608$export$e989c0fffaa6b27a(element) && !element.hidden && theWin.getComputedStyle(element).visibility !== 'hidden';
}
function $94bdc1ebed789608$export$5d5979bf640d1558(element, checkTabIndex, checkShadowRoot) {
    if (checkShadowRoot === void 0) checkShadowRoot = true;
    // If this element is null or is disabled, it is not considered tabbable.
    if (!element || element.disabled) return false;
    var tabIndex = 0;
    var tabIndexAttributeValue = null;
    if (element && element.getAttribute) {
        tabIndexAttributeValue = element.getAttribute('tabIndex');
        if (tabIndexAttributeValue) tabIndex = parseInt(tabIndexAttributeValue, 10);
    }
    var isFocusableAttribute = element.getAttribute ? element.getAttribute($94bdc1ebed789608$var$IS_FOCUSABLE_ATTRIBUTE) : null;
    var isTabIndexSet = tabIndexAttributeValue !== null && tabIndex >= 0;
    var delegatesFocus = checkShadowRoot && element.shadowRoot ? !!element.shadowRoot.delegatesFocus : false;
    var result = !!element && isFocusableAttribute !== 'false' && (element.tagName === 'A' || element.tagName === 'BUTTON' || element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT' || isFocusableAttribute === 'true' || isTabIndexSet || delegatesFocus);
    return checkTabIndex ? tabIndex !== -1 && result : result;
}
function $94bdc1ebed789608$export$1b55aa98f48e3915(element) {
    return !!(element && element.getAttribute && !!element.getAttribute($94bdc1ebed789608$var$FOCUSZONE_ID_ATTRIBUTE));
}
function $94bdc1ebed789608$export$7e6b7baad6f0187d(element) {
    return !!(element && element.getAttribute && element.getAttribute($94bdc1ebed789608$var$FOCUSZONE_SUB_ATTRIBUTE) === 'true');
}
function $94bdc1ebed789608$export$597abdf7826dd64a(element) {
    var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(element);
    var currentActiveElement = doc && doc.activeElement;
    if (currentActiveElement && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(element, currentActiveElement)) return true;
    return false;
}
function $94bdc1ebed789608$export$841acbea7fb3b182(element, noWrapDataAttribute, doc) {
    var theDoc = doc !== null && doc !== void 0 ? doc : (0, $6787cc90d6254b3e$export$f65ca476c09acec0)();
    return (0, $9f024846b985abb6$export$c87fe71d3aea462)(element, noWrapDataAttribute, theDoc) === 'true' ? false : true;
}
var $94bdc1ebed789608$var$animationId = undefined;
function $94bdc1ebed789608$export$b5a401136c35d08a(element) {
    if (element) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(element);
        if (win) {
            // cancel any previous focus queues
            if ($94bdc1ebed789608$var$animationId !== undefined) win.cancelAnimationFrame($94bdc1ebed789608$var$animationId);
            // element.focus() is a no-op if the element is no longer in the DOM, meaning this is always safe
            $94bdc1ebed789608$var$animationId = win.requestAnimationFrame(function() {
                element && element.focus();
                // We are done focusing for this frame, so reset the queued focus element
                $94bdc1ebed789608$var$animationId = undefined;
            });
        }
    }
}
function $94bdc1ebed789608$export$f41c042330addd91(parent, path) {
    var element = parent;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var index = path_1[_i];
        var nextChild = element.children[Math.min(index, element.children.length - 1)];
        if (!nextChild) break;
        element = nextChild;
    }
    element = $94bdc1ebed789608$export$5d5979bf640d1558(element) && $94bdc1ebed789608$export$e989c0fffaa6b27a(element) ? element : $94bdc1ebed789608$export$4109ed81edd7716d(parent, element, true) || $94bdc1ebed789608$export$42ed4d93850449f7(parent, element);
    return element;
}
function $94bdc1ebed789608$export$fe29704f84b976d2(fromElement, toElement) {
    var path = [];
    while(toElement && fromElement && toElement !== fromElement){
        var parent_1 = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(toElement, true);
        if (parent_1 === null) return [];
        path.unshift(Array.prototype.indexOf.call(parent_1.children, toElement));
        toElement = parent_1;
    }
    return path;
}



var $acw62 = parcelRequire("acw62");


var $81033f91b1d0d219$export$bab63bc83b10c08f = $acw62.createContext(undefined);
var $81033f91b1d0d219$export$c7f836dc6bdf9d56 = function(_a) {
    var shadowRoot = _a.shadowRoot, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "shadowRoot"
    ]);
    var value = $acw62.useMemo(function() {
        return {
            stylesheets: new Map(),
            shadowRoot: shadowRoot
        };
    }, [
        shadowRoot
    ]);
    return $acw62.createElement($81033f91b1d0d219$export$bab63bc83b10c08f.Provider, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        value: value
    }, props), $acw62.createElement($81033f91b1d0d219$var$GlobalStyles, null), props.children);
};
var $81033f91b1d0d219$var$GlobalStyles = function(props) {
    var useAdoptedStylesheet = (0, $a76127aad685aec8$export$c700cc7ea3d01c27)().useAdoptedStylesheet;
    useAdoptedStylesheet((0, $c9c2f6e9ef06bed5$export$5afbf446153651d));
    return null;
};




var $8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
var $8c4e0e7eaa58d986$var$IS_ENTER_DISABLED_ATTRIBUTE = 'data-disable-click-on-enter';
var $8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE = 'data-focuszone-id';
var $8c4e0e7eaa58d986$var$TABINDEX = 'tabindex';
var $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP = 'data-no-vertical-wrap';
var $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP = 'data-no-horizontal-wrap';
var $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER = 999999999;
var $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER = -999999999;
var $8c4e0e7eaa58d986$var$focusZoneStyles;
var $8c4e0e7eaa58d986$var$focusZoneClass = 'ms-FocusZone';
/**
 * Raises a click on a target element based on a keyboard event.
 */ function $8c4e0e7eaa58d986$var$raiseClickFromKeyboardEvent(target, ev) {
    var event;
    if (typeof MouseEvent === 'function') event = new MouseEvent('click', {
        ctrlKey: ev === null || ev === void 0 ? void 0 : ev.ctrlKey,
        metaKey: ev === null || ev === void 0 ? void 0 : ev.metaKey,
        shiftKey: ev === null || ev === void 0 ? void 0 : ev.shiftKey,
        altKey: ev === null || ev === void 0 ? void 0 : ev.altKey,
        bubbles: ev === null || ev === void 0 ? void 0 : ev.bubbles,
        cancelable: ev === null || ev === void 0 ? void 0 : ev.cancelable
    });
    else {
        // eslint-disable-next-line no-restricted-globals
        event = document.createEvent('MouseEvents');
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        event.initMouseEvent('click', ev ? ev.bubbles : false, ev ? ev.cancelable : false, // eslint-disable-next-line no-restricted-globals
        window, 0, 0, 0, 0, 0, ev ? ev.ctrlKey : false, ev ? ev.altKey : false, ev ? ev.shiftKey : false, ev ? ev.metaKey : false, 0, null);
    }
    target.dispatchEvent(event);
}
// Helper function that will return a class for when the root is focused
function $8c4e0e7eaa58d986$var$getRootClass() {
    if (!$8c4e0e7eaa58d986$var$focusZoneStyles) $8c4e0e7eaa58d986$var$focusZoneStyles = (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)({
        selectors: {
            ':focus': {
                outline: 'none'
            }
        }
    }, $8c4e0e7eaa58d986$var$focusZoneClass);
    return $8c4e0e7eaa58d986$var$focusZoneStyles;
}
var $8c4e0e7eaa58d986$var$_allInstances = {};
var $8c4e0e7eaa58d986$var$_outerZones = new Set();
var $8c4e0e7eaa58d986$var$ALLOWED_INPUT_TYPES = [
    'text',
    'number',
    'password',
    'email',
    'tel',
    'url',
    'search',
    'textarea'
];
var $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS = false;
var $8c4e0e7eaa58d986$export$4949eceb002ae2e2 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FocusZone, _super);
    function FocusZone(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this._root = $acw62.createRef();
        _this._mergedRef = (0, $ad53d15595d1f5d5$export$9f37a988498f0f9c)();
        _this._onFocus = function(ev) {
            if (_this._portalContainsElement(ev.target)) // If the event target is inside a portal do not process the event.
            return;
            var _a = _this.props, onActiveElementChanged = _a.onActiveElementChanged, // eslint-disable-next-line @typescript-eslint/no-deprecated
            doNotAllowFocusEventToPropagate = _a.doNotAllowFocusEventToPropagate, stopFocusPropagation = _a.stopFocusPropagation, // eslint-disable-next-line @typescript-eslint/no-deprecated
            onFocusNotification = _a.onFocusNotification, onFocus = _a.onFocus, shouldFocusInnerElementWhenReceivedFocus = _a.shouldFocusInnerElementWhenReceivedFocus, defaultTabbableElement = _a.defaultTabbableElement;
            var isImmediateDescendant = _this._isImmediateDescendantOfZone(ev.target);
            var newActiveElement;
            if (isImmediateDescendant) newActiveElement = ev.target;
            else {
                var parentElement = ev.target;
                while(parentElement && parentElement !== _this._root.current){
                    if ((0, $94bdc1ebed789608$export$5d5979bf640d1558)(parentElement, undefined, _this._inShadowRoot) && _this._isImmediateDescendantOfZone(parentElement)) {
                        newActiveElement = parentElement;
                        break;
                    }
                    parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(parentElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
                }
            }
            // If an inner focusable element should be focused when FocusZone container receives focus
            if (shouldFocusInnerElementWhenReceivedFocus && ev.target === _this._root.current) {
                var maybeElementToFocus = defaultTabbableElement && typeof defaultTabbableElement === 'function' && _this._root.current && defaultTabbableElement(_this._root.current);
                // try to focus defaultTabbable element
                if (maybeElementToFocus && (0, $94bdc1ebed789608$export$5d5979bf640d1558)(maybeElementToFocus, undefined, _this._inShadowRoot)) {
                    newActiveElement = maybeElementToFocus;
                    maybeElementToFocus.focus();
                } else {
                    // force focus on first focusable element
                    _this.focus(true);
                    if (_this._activeElement) // set to null as new active element was handled in method above
                    newActiveElement = null;
                }
            }
            var initialElementFocused = !_this._activeElement;
            // If the new active element is a child of this zone and received focus,
            // update alignment an immediate descendant
            if (newActiveElement && newActiveElement !== _this._activeElement) {
                if (isImmediateDescendant || initialElementFocused) _this._setFocusAlignment(newActiveElement, true, true);
                _this._activeElement = newActiveElement;
                if (initialElementFocused) _this._updateTabIndexes();
            }
            if (onActiveElementChanged) onActiveElementChanged(_this._activeElement, ev);
            if (stopFocusPropagation || doNotAllowFocusEventToPropagate) ev.stopPropagation();
            if (onFocus) onFocus(ev);
            else if (onFocusNotification) onFocusNotification();
        };
        _this._onBlur = function() {
            _this._setParkedFocus(false);
        };
        _this._onMouseDown = function(ev) {
            if (_this._portalContainsElement(ev.target)) // If the event target is inside a portal do not process the event.
            return;
            var disabled = _this.props.disabled;
            if (disabled) return;
            var target = ev.target;
            var path = [];
            while(target && target !== _this._root.current){
                path.push(target);
                target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
            }
            while(path.length){
                target = path.pop();
                if (target && (0, $94bdc1ebed789608$export$5d5979bf640d1558)(target, undefined, _this._inShadowRoot)) _this._setActiveElement(target, true);
                if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(target)) break;
            }
        };
        /**
         * Handle the keystrokes.
         */ _this._onKeyDown = function(ev, theme) {
            if (_this._portalContainsElement(ev.target)) // If the event target is inside a portal do not process the event.
            return;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = _this.props, direction = _a.direction, disabled = _a.disabled, isInnerZoneKeystroke = _a.isInnerZoneKeystroke, pagingSupportDisabled = _a.pagingSupportDisabled, shouldEnterInnerZone = _a.shouldEnterInnerZone;
            if (disabled) return;
            if (_this.props.onKeyDown) _this.props.onKeyDown(ev);
            // If the default has been prevented, do not process keyboard events.
            if (ev.isDefaultPrevented()) return;
            if (_this._getDocument().activeElement === _this._root.current && _this._isInnerZone) // If this element has focus, it is being controlled by a parent.
            // Ignore the keystroke.
            return;
            if ((shouldEnterInnerZone && shouldEnterInnerZone(ev) || isInnerZoneKeystroke && isInnerZoneKeystroke(ev)) && _this._isImmediateDescendantOfZone(ev.target)) {
                // Try to focus
                var innerZone = _this._getFirstInnerZone();
                if (innerZone) {
                    if (!innerZone.focus(true)) return;
                } else if ((0, $94bdc1ebed789608$export$7e6b7baad6f0187d)(ev.target)) {
                    if (!_this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(ev.target, ev.target.firstChild, true))) return;
                } else return;
            } else if (ev.altKey) return;
            else // eslint-disable-next-line @fluentui/deprecated-keyboard-event-props, @typescript-eslint/no-deprecated
            switch(ev.which){
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).space:
                    if (_this._shouldRaiseClicksOnSpace && _this._tryInvokeClickForFocusable(ev.target, ev)) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).left:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusLeft(theme)) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).right:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusRight(theme)) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).up:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusUp()) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).down:
                    if (direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal) {
                        _this._preventDefaultWhenHandled(ev);
                        if (_this._moveFocusDown()) break;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).pageDown:
                    if (!pagingSupportDisabled && _this._moveFocusPaging(true)) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).pageUp:
                    if (!pagingSupportDisabled && _this._moveFocusPaging(false)) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).tab:
                    if (// eslint-disable-next-line @typescript-eslint/no-deprecated
                    _this.props.allowTabKey || _this.props.handleTabKey === (0, $13ca773bee6ceecf$export$269041a88986a933).all || _this.props.handleTabKey === (0, $13ca773bee6ceecf$export$269041a88986a933).inputOnly && _this._isElementInput(ev.target)) {
                        var focusChanged = false;
                        _this._processingTabKey = true;
                        if (direction === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical || !_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP)) focusChanged = ev.shiftKey ? _this._moveFocusUp() : _this._moveFocusDown();
                        else {
                            var tabWithDirection = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? !ev.shiftKey : ev.shiftKey;
                            focusChanged = tabWithDirection ? _this._moveFocusLeft(theme) : _this._moveFocusRight(theme);
                        }
                        _this._processingTabKey = false;
                        if (focusChanged) break;
                        else if (_this.props.shouldResetActiveElementWhenTabFromZone) _this._activeElement = null;
                    }
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).home:
                    if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, false)) return false;
                    var firstChild = _this._root.current && _this._root.current.firstChild;
                    if (_this._root.current && firstChild && _this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(_this._root.current, firstChild, true))) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).end:
                    if (_this._isContentEditableElement(ev.target) || _this._isElementInput(ev.target) && !_this._shouldInputLoseFocus(ev.target, true)) return false;
                    var lastChild = _this._root.current && _this._root.current.lastChild;
                    if (_this._root.current && _this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(_this._root.current, lastChild, true, true, true))) break;
                    return;
                case (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter:
                    if (_this._shouldRaiseClicksOnEnter && _this._tryInvokeClickForFocusable(ev.target, ev)) break;
                    return;
                default:
                    return;
            }
            ev.preventDefault();
            ev.stopPropagation();
        };
        _this._getHorizontalDistanceFromCenter = function(isForward, // eslint-disable-next-line @typescript-eslint/no-deprecated
        activeRect, // eslint-disable-next-line @typescript-eslint/no-deprecated
        targetRect) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var leftAlignment = _this._focusAlignment.left || _this._focusAlignment.x || 0;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectBottom = Math.floor(activeRect.bottom);
            var targetRectBottom = Math.floor(targetRect.bottom);
            var activeRectTop = Math.floor(activeRect.top);
            var isValidCandidateOnpagingDown = isForward && targetRectTop > activeRectBottom;
            var isValidCandidateOnpagingUp = !isForward && targetRectBottom < activeRectTop;
            if (isValidCandidateOnpagingDown || isValidCandidateOnpagingUp) {
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) return 0;
                return Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            if (!_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP)) return $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            return $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER;
        };
        // Manage componentRef resolution.
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)('FocusZone');
        _this._focusAlignment = {
            left: 0,
            top: 0
        };
        _this._processingTabKey = false;
        var shouldRaiseClicksFallback = (_b = (_a = props.shouldRaiseClicks) !== null && _a !== void 0 ? _a : FocusZone.defaultProps.shouldRaiseClicks) !== null && _b !== void 0 ? _b : true;
        _this._shouldRaiseClicksOnEnter = (_c = props.shouldRaiseClicksOnEnter) !== null && _c !== void 0 ? _c : shouldRaiseClicksFallback;
        _this._shouldRaiseClicksOnSpace = (_d = props.shouldRaiseClicksOnSpace) !== null && _d !== void 0 ? _d : shouldRaiseClicksFallback;
        return _this;
    }
    /** Used for testing purposes only. */ FocusZone.getOuterZones = function() {
        return $8c4e0e7eaa58d986$var$_outerZones.size;
    };
    /**
     * Handle global tab presses so that we can patch tabindexes on the fly.
     * HEADS UP: This must not be an arrow function in order to be referentially equal among instances
     * for ref counting to work correctly!
     */ FocusZone._onKeyDownCapture = function(ev) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated, @fluentui/deprecated-keyboard-event-props
        if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).tab) $8c4e0e7eaa58d986$var$_outerZones.forEach(function(zone) {
            return zone._updateTabIndexes();
        });
    };
    FocusZone.prototype.componentDidMount = function() {
        var _a;
        var root = this._root.current;
        this._inShadowRoot = !!((_a = this.context) === null || _a === void 0 ? void 0 : _a.shadowRoot);
        $8c4e0e7eaa58d986$var$_allInstances[this._id] = this;
        if (root) {
            var parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(root, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
            while(parentElement && parentElement !== this._getDocument().body && parentElement.nodeType === 1){
                if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(parentElement)) {
                    this._isInnerZone = true;
                    break;
                }
                parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(parentElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
            }
            if (!this._isInnerZone) {
                $8c4e0e7eaa58d986$var$_outerZones.add(this);
                this._root.current && this._root.current.addEventListener('keydown', FocusZone._onKeyDownCapture, true);
            }
            this._root.current && this._root.current.addEventListener('blur', this._onBlur, true);
            // Assign initial tab indexes so that we can set initial focus as appropriate.
            this._updateTabIndexes();
            if (this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === 'string') this._activeElement = this._getDocument().querySelector(this.props.defaultTabbableElement);
            else if (this.props.defaultActiveElement) // eslint-disable-next-line @typescript-eslint/no-deprecated
            this._activeElement = this._getDocument().querySelector(this.props.defaultActiveElement);
            if (this.props.shouldFocusOnMount) this.focus();
        }
    };
    FocusZone.prototype.componentDidUpdate = function() {
        var _a;
        var root = this._root.current;
        var doc = this._getDocument();
        this._inShadowRoot = !!((_a = this.context) === null || _a === void 0 ? void 0 : _a.shadowRoot);
        // If either _activeElement or _defaultFocusElement are no longer contained by _root,
        // reset those variables (and update tab indexes) to avoid memory leaks
        if (this._activeElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, this._activeElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS) || this._defaultFocusElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, this._defaultFocusElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS)) {
            this._activeElement = null;
            this._defaultFocusElement = null;
            this._updateTabIndexes();
        }
        if (!this.props.preventFocusRestoration && doc && this._lastIndexPath && (doc.activeElement === doc.body || doc.activeElement === null || doc.activeElement === root)) {
            // The element has been removed after the render, attempt to restore focus.
            var elementToFocus = (0, $94bdc1ebed789608$export$f41c042330addd91)(root, this._lastIndexPath);
            if (elementToFocus) {
                this._setActiveElement(elementToFocus, true);
                elementToFocus.focus();
                this._setParkedFocus(false);
            } else // We had a focus path to restore, but now that path is unresolvable. Park focus
            // on the container until we can try again.
            this._setParkedFocus(true);
        }
    };
    FocusZone.prototype.componentWillUnmount = function() {
        delete $8c4e0e7eaa58d986$var$_allInstances[this._id];
        if (!this._isInnerZone) {
            $8c4e0e7eaa58d986$var$_outerZones.delete(this);
            this._root.current && this._root.current.removeEventListener('keydown', FocusZone._onKeyDownCapture, true);
        }
        if (this._root.current) this._root.current.removeEventListener('blur', this._onBlur, true);
        this._activeElement = null;
        this._defaultFocusElement = null;
    };
    FocusZone.prototype.render = function() {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var _a = this.props, tag = _a.as, elementType = _a.elementType, rootProps = _a.rootProps, ariaDescribedBy = _a.ariaDescribedBy, ariaLabelledBy = _a.ariaLabelledBy, className = _a.className;
        var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40));
        var Tag = tag || elementType || 'div';
        // Note, right before rendering/reconciling proceeds, we need to record if focus
        // was in the zone before the update. This helper will track this and, if focus
        // was actually in the zone, what the index path to the element is at this time.
        // Then, later in componentDidUpdate, we can evaluate if we need to restore it in
        // the case the element was removed.
        this._evaluateFocusBeforeRender();
        // Only support RTL defined in global theme, not contextual theme/RTL.
        var theme = (0, $756f0943cb677ee4$export$89cbf1a0881c8b9c)();
        return $acw62.createElement(Tag, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy
        }, divProps, rootProps, {
            // Once the getClassName correctly memoizes inputs this should
            // be replaced so that className is passed to getRootClass and is included there so
            // the class names will always be in the same order.
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)($8c4e0e7eaa58d986$var$getRootClass(), className),
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ref: this._mergedRef(this.props.elementRef, this._root),
            "data-focuszone-id": this._id,
            // eslint-disable-next-line react/jsx-no-bind
            onKeyDown: function(ev) {
                return _this._onKeyDown(ev, theme);
            },
            onFocus: this._onFocus,
            onMouseDownCapture: this._onMouseDown
        }), this.props.children);
    };
    /**
     * Sets focus to the first tabbable item in the zone.
     * @param forceIntoFirstElement - If true, focus will be forced into the first element, even
     * if focus is already in the focus zone.
     * @param bypassHiddenElements - If true, focus will be not be set on hidden elements.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */ FocusZone.prototype.focus = function(forceIntoFirstElement, bypassHiddenElements) {
        if (forceIntoFirstElement === void 0) forceIntoFirstElement = false;
        if (bypassHiddenElements === void 0) bypassHiddenElements = false;
        if (this._root.current) {
            if (!forceIntoFirstElement && this._root.current.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === 'true' && this._isInnerZone) {
                var ownerZoneElement = this._getOwnerZone(this._root.current);
                if (ownerZoneElement !== this._root.current) {
                    var ownerZone = $8c4e0e7eaa58d986$var$_allInstances[ownerZoneElement.getAttribute($8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE)];
                    return !!ownerZone && ownerZone.focusElement(this._root.current);
                }
                return false;
            } else if (!forceIntoFirstElement && this._activeElement && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(this._root.current, this._activeElement) && (0, $94bdc1ebed789608$export$5d5979bf640d1558)(this._activeElement, undefined, this._inShadowRoot) && (!bypassHiddenElements || (0, $94bdc1ebed789608$export$5d127f54530ed28b)(this._activeElement))) {
                this._activeElement.focus();
                return true;
            } else {
                var firstChild = this._root.current.firstChild;
                return this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, firstChild, true, undefined, undefined, undefined, undefined, undefined, bypassHiddenElements));
            }
        }
        return false;
    };
    /**
     * Sets focus to the last tabbable item in the zone.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */ FocusZone.prototype.focusLast = function() {
        if (this._root.current) {
            var lastChild = this._root.current && this._root.current.lastChild;
            return this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, lastChild, true, true, true));
        }
        return false;
    };
    /**
     * Sets focus to a specific child element within the zone. This can be used in conjunction with
     * shouldReceiveFocus to create delayed focus scenarios (like animate the scroll position to the correct
     * location and then focus.)
     * @param element - The child element within the zone to focus.
     * @param forceAlignment - If true, focus alignment will be set according to the element provided.
     * @returns True if focus could be set to an active element, false if no operation was taken.
     */ FocusZone.prototype.focusElement = function(element, forceAlignment) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var _a = this.props, onBeforeFocus = _a.onBeforeFocus, shouldReceiveFocus = _a.shouldReceiveFocus;
        if (shouldReceiveFocus && !shouldReceiveFocus(element) || onBeforeFocus && !onBeforeFocus(element)) return false;
        if (element) {
            // when we set focus to a specific child, we should recalculate the alignment depending on its position.
            this._setActiveElement(element, forceAlignment);
            if (this._activeElement) this._activeElement.focus();
            return true;
        }
        return false;
    };
    /**
     * Forces horizontal alignment in the context of vertical arrowing to use specific point as the reference,
     * rather than a center based on the last horizontal motion.
     * @param point - the new reference point.
     */ FocusZone.prototype.setFocusAlignment = function(point) {
        this._focusAlignment = point;
    };
    Object.defineProperty(FocusZone.prototype, "defaultFocusElement", {
        get: function() {
            return this._defaultFocusElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FocusZone.prototype, "activeElement", {
        get: function() {
            return this._activeElement;
        },
        enumerable: false,
        configurable: true
    });
    FocusZone.prototype._evaluateFocusBeforeRender = function() {
        var root = this._root.current;
        var doc = this._getDocument();
        if (doc) {
            var focusedElement = doc.activeElement;
            // Only update the index path if we are not parked on the root.
            if (focusedElement !== root) {
                var shouldRestoreFocus = (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root, focusedElement, false);
                this._lastIndexPath = shouldRestoreFocus ? (0, $94bdc1ebed789608$export$fe29704f84b976d2)(root, focusedElement) : undefined;
            }
        }
    };
    /**
     * When focus is in the zone at render time but then all focusable elements are removed,
     * we "park" focus temporarily on the root. Once we update with focusable children, we restore
     * focus to the closest path from previous. If the user tabs away from the parked container,
     * we restore focusability to the pre-parked state.
     */ FocusZone.prototype._setParkedFocus = function(isParked) {
        var root = this._root.current;
        if (root && this._isParked !== isParked) {
            this._isParked = isParked;
            if (isParked) {
                if (!this.props.allowFocusRoot) {
                    this._parkedTabIndex = root.getAttribute('tabindex');
                    root.setAttribute('tabindex', '-1');
                }
                root.focus();
            } else if (!this.props.allowFocusRoot) {
                if (this._parkedTabIndex) {
                    root.setAttribute('tabindex', this._parkedTabIndex);
                    this._parkedTabIndex = undefined;
                } else root.removeAttribute('tabindex');
            }
        }
    };
    FocusZone.prototype._setActiveElement = function(element, forceAlignment) {
        var previousActiveElement = this._activeElement;
        this._activeElement = element;
        if (previousActiveElement) {
            if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(previousActiveElement)) this._updateTabIndexes(previousActiveElement);
            previousActiveElement.tabIndex = -1;
        }
        if (this._activeElement) {
            if (!this._focusAlignment || forceAlignment) this._setFocusAlignment(element, true, true);
            this._activeElement.tabIndex = 0;
        }
    };
    FocusZone.prototype._preventDefaultWhenHandled = function(ev) {
        this.props.preventDefaultWhenHandled && ev.preventDefault();
    };
    /**
     * Walk up the dom try to find a focusable element.
     */ FocusZone.prototype._tryInvokeClickForFocusable = function(targetElement, ev) {
        var target = targetElement;
        if (target === this._root.current) return false;
        do {
            if (target.tagName === 'BUTTON' || target.tagName === 'A' || target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SUMMARY') return false;
            if (this._isImmediateDescendantOfZone(target) && target.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === 'true' && target.getAttribute($8c4e0e7eaa58d986$var$IS_ENTER_DISABLED_ATTRIBUTE) !== 'true') {
                $8c4e0e7eaa58d986$var$raiseClickFromKeyboardEvent(target, ev);
                return true;
            }
            target = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(target, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
        }while (target !== this._root.current);
        return false;
    };
    /**
     * Traverse to find first child zone.
     */ FocusZone.prototype._getFirstInnerZone = function(rootElement) {
        rootElement = rootElement || this._activeElement || this._root.current;
        if (!rootElement) return null;
        if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(rootElement)) return $8c4e0e7eaa58d986$var$_allInstances[rootElement.getAttribute($8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE)];
        var child = rootElement.firstElementChild;
        while(child){
            if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(child)) return $8c4e0e7eaa58d986$var$_allInstances[child.getAttribute($8c4e0e7eaa58d986$var$FOCUSZONE_ID_ATTRIBUTE)];
            var match = this._getFirstInnerZone(child);
            if (match) return match;
            child = child.nextElementSibling;
        }
        return null;
    };
    FocusZone.prototype._moveFocus = function(isForward, // eslint-disable-next-line @typescript-eslint/no-deprecated
    getDistanceFromCenter, ev, useDefaultWrap) {
        if (useDefaultWrap === void 0) useDefaultWrap = true;
        var element = this._activeElement;
        var candidateDistance = -1;
        var candidateElement = undefined;
        var changedFocus = false;
        var isBidirectional = this.props.direction === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).bidirectional;
        if (!element || !this._root.current) return false;
        if (this._isElementInput(element)) {
            if (!this._shouldInputLoseFocus(element, isForward)) return false;
        }
        var activeRect = isBidirectional ? element.getBoundingClientRect() : null;
        do {
            element = isForward ? (0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, element) : (0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, element);
            if (isBidirectional) {
                if (element) {
                    var targetRect = element.getBoundingClientRect();
                    // eslint-disable-next-line @typescript-eslint/no-deprecated
                    var elementDistance = getDistanceFromCenter(activeRect, targetRect);
                    if (elementDistance === -1 && candidateDistance === -1) {
                        candidateElement = element;
                        break;
                    }
                    if (elementDistance > -1 && (candidateDistance === -1 || elementDistance < candidateDistance)) {
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                    if (candidateDistance >= 0 && elementDistance < 0) break;
                }
            } else {
                candidateElement = element;
                break;
            }
        }while (element);
        // Focus the closest candidate
        if (candidateElement && candidateElement !== this._activeElement) {
            changedFocus = true;
            this.focusElement(candidateElement);
        } else if (this.props.isCircularNavigation && useDefaultWrap) {
            if (isForward) return this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, this._root.current.firstElementChild, true));
            else return this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, this._root.current.lastElementChild, true, true, true));
        }
        return changedFocus;
    };
    FocusZone.prototype._moveFocusDown = function() {
        var _this = this;
        var targetTop = -1;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;
        if (// eslint-disable-next-line @typescript-eslint/no-deprecated
        this._moveFocus(true, function(activeRect, targetRect) {
            var distance = -1;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectBottom = Math.floor(activeRect.bottom);
            if (targetRectTop < activeRectBottom) {
                if (!_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP)) return $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                return $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER;
            }
            if (targetTop === -1 && targetRectTop >= activeRectBottom || targetRectTop === targetTop) {
                targetTop = targetRectTop;
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) distance = 0;
                else distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            return distance;
        })) {
            this._setFocusAlignment(this._activeElement, false, true);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusUp = function() {
        var _this = this;
        var targetTop = -1;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var leftAlignment = this._focusAlignment.left || this._focusAlignment.x || 0;
        if (// eslint-disable-next-line @typescript-eslint/no-deprecated
        this._moveFocus(false, function(activeRect, targetRect) {
            var distance = -1;
            // ClientRect values can be floats that differ by very small fractions of a decimal.
            // If the difference between top and bottom are within a pixel then we should treat
            // them as equivalent by using Math.floor. For instance 5.2222 and 5.222221 should be equivalent,
            // but without Math.Floor they will be handled incorrectly.
            var targetRectBottom = Math.floor(targetRect.bottom);
            var targetRectTop = Math.floor(targetRect.top);
            var activeRectTop = Math.floor(activeRect.top);
            if (targetRectBottom > activeRectTop) {
                if (!_this._shouldWrapFocus(_this._activeElement, $8c4e0e7eaa58d986$var$NO_VERTICAL_WRAP)) return $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
                return $8c4e0e7eaa58d986$var$LARGE_DISTANCE_FROM_CENTER;
            }
            if (targetTop === -1 && targetRectBottom <= activeRectTop || targetRectTop === targetTop) {
                targetTop = targetRectTop;
                if (leftAlignment >= targetRect.left && leftAlignment <= targetRect.left + targetRect.width) distance = 0;
                else distance = Math.abs(targetRect.left + targetRect.width / 2 - leftAlignment);
            }
            return distance;
        })) {
            this._setFocusAlignment(this._activeElement, false, true);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusLeft = function(theme) {
        var _this = this;
        var shouldWrap = this._shouldWrapFocus(this._activeElement, $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP);
        if (this._moveFocus((0, $723d0744d8fe4fde$export$b2303637e9533380)(theme), // eslint-disable-next-line @typescript-eslint/no-deprecated
        function(activeRect, targetRect) {
            var distance = -1;
            var topBottomComparison;
            if ((0, $723d0744d8fe4fde$export$b2303637e9533380)(theme)) // When in RTL, this comparison should be the same as the one in _moveFocusRight for LTR.
            // Going left at a leftmost rectangle will go down a line instead of up a line like in LTR.
            // This is important, because we want to be comparing the top of the target rect
            // with the bottom of the active rect.
            topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
            else topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
            if (topBottomComparison && targetRect.right <= activeRect.right && _this.props.direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) distance = activeRect.right - targetRect.right;
            else if (!shouldWrap) distance = $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            return distance;
        }, undefined /*ev*/ , shouldWrap)) {
            this._setFocusAlignment(this._activeElement, true, false);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusRight = function(theme) {
        var _this = this;
        var shouldWrap = this._shouldWrapFocus(this._activeElement, $8c4e0e7eaa58d986$var$NO_HORIZONTAL_WRAP);
        if (this._moveFocus(!(0, $723d0744d8fe4fde$export$b2303637e9533380)(theme), // eslint-disable-next-line @typescript-eslint/no-deprecated
        function(activeRect, targetRect) {
            var distance = -1;
            var topBottomComparison;
            if ((0, $723d0744d8fe4fde$export$b2303637e9533380)(theme)) // When in RTL, this comparison should be the same as the one in _moveFocusLeft for LTR.
            // Going right at a rightmost rectangle will go up a line instead of down a line like in LTR.
            // This is important, because we want to be comparing the bottom of the target rect
            // with the top of the active rect.
            topBottomComparison = parseFloat(targetRect.bottom.toFixed(3)) > parseFloat(activeRect.top.toFixed(3));
            else topBottomComparison = parseFloat(targetRect.top.toFixed(3)) < parseFloat(activeRect.bottom.toFixed(3));
            if (topBottomComparison && targetRect.left >= activeRect.left && _this.props.direction !== (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical) distance = targetRect.left - activeRect.left;
            else if (!shouldWrap) distance = $8c4e0e7eaa58d986$var$LARGE_NEGATIVE_DISTANCE_FROM_CENTER;
            return distance;
        }, undefined /*ev*/ , shouldWrap)) {
            this._setFocusAlignment(this._activeElement, true, false);
            return true;
        }
        return false;
    };
    FocusZone.prototype._moveFocusPaging = function(isForward, useDefaultWrap) {
        if (useDefaultWrap === void 0) useDefaultWrap = true;
        var element = this._activeElement;
        if (!element || !this._root.current) return false;
        if (this._isElementInput(element)) {
            if (!this._shouldInputLoseFocus(element, isForward)) return false;
        }
        var scrollableParent = (0, $11f97b2a9a127629$export$494fa69500a5872a)(element);
        if (!scrollableParent) return false;
        var candidateDistance = -1;
        var candidateElement = undefined;
        var targetTop = -1;
        var targetBottom = -1;
        var pagesize = scrollableParent.clientHeight;
        var activeRect = element.getBoundingClientRect();
        do {
            element = isForward ? (0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, element) : (0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, element);
            if (element) {
                var targetRect = element.getBoundingClientRect();
                var targetRectTop = Math.floor(targetRect.top);
                var activeRectBottom = Math.floor(activeRect.bottom);
                var targetRectBottom = Math.floor(targetRect.bottom);
                var activeRectTop = Math.floor(activeRect.top);
                var elementDistance = this._getHorizontalDistanceFromCenter(isForward, activeRect, targetRect);
                var isElementPassedPageSizeOnPagingDown = isForward && targetRectTop > activeRectBottom + pagesize;
                var isElementPassedPageSizeOnPagingUp = !isForward && targetRectBottom < activeRectTop - pagesize;
                if (isElementPassedPageSizeOnPagingDown || isElementPassedPageSizeOnPagingUp) break;
                if (elementDistance > -1) {
                    // for paging down
                    if (isForward && targetRectTop > targetTop) {
                        targetTop = targetRectTop;
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    } else if (!isForward && targetRectBottom < targetBottom) {
                        // for paging up
                        targetBottom = targetRectBottom;
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    } else if (candidateDistance === -1 || elementDistance <= candidateDistance) {
                        candidateDistance = elementDistance;
                        candidateElement = element;
                    }
                }
            }
        }while (element);
        var changedFocus = false;
        // Focus the closest candidate
        if (candidateElement && candidateElement !== this._activeElement) {
            changedFocus = true;
            this.focusElement(candidateElement);
            this._setFocusAlignment(candidateElement, false, true);
        } else if (this.props.isCircularNavigation && useDefaultWrap) {
            if (isForward) return this.focusElement((0, $94bdc1ebed789608$export$4109ed81edd7716d)(this._root.current, this._root.current.firstElementChild, true));
            return this.focusElement((0, $94bdc1ebed789608$export$42ed4d93850449f7)(this._root.current, this._root.current.lastElementChild, true, true, true));
        }
        return changedFocus;
    };
    FocusZone.prototype._setFocusAlignment = function(element, isHorizontal, isVertical) {
        if (this.props.direction === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).bidirectional && (!this._focusAlignment || isHorizontal || isVertical)) {
            var rect = element.getBoundingClientRect();
            var left = rect.left + rect.width / 2;
            var top_1 = rect.top + rect.height / 2;
            if (!this._focusAlignment) this._focusAlignment = {
                left: left,
                top: top_1
            };
            if (isHorizontal) this._focusAlignment.left = left;
            if (isVertical) this._focusAlignment.top = top_1;
        }
    };
    FocusZone.prototype._isImmediateDescendantOfZone = function(element) {
        return this._getOwnerZone(element) === this._root.current;
    };
    FocusZone.prototype._getOwnerZone = function(element) {
        var parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(element, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
        while(parentElement && parentElement !== this._root.current && parentElement !== this._getDocument().body){
            if ((0, $94bdc1ebed789608$export$1b55aa98f48e3915)(parentElement)) return parentElement;
            parentElement = (0, $7ca0c55777f4d1e1$export$58081aedf094d85b)(parentElement, $8c4e0e7eaa58d986$var$ALLOW_VIRTUAL_ELEMENTS);
        }
        return parentElement;
    };
    FocusZone.prototype._updateTabIndexes = function(element) {
        if (!this._activeElement && this.props.defaultTabbableElement && typeof this.props.defaultTabbableElement === 'function') this._activeElement = this.props.defaultTabbableElement(this._root.current);
        if (!element && this._root.current) {
            this._defaultFocusElement = null;
            element = this._root.current;
            if (this._activeElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(element, this._activeElement)) this._activeElement = null;
        }
        // If active element changes state to disabled, set it to null.
        // Otherwise, we lose keyboard accessibility to other elements in focus zone.
        if (this._activeElement && !(0, $94bdc1ebed789608$export$5d5979bf640d1558)(this._activeElement, undefined, this._inShadowRoot)) this._activeElement = null;
        var childNodes = element && element.children;
        for(var childIndex = 0; childNodes && childIndex < childNodes.length; childIndex++){
            var child = childNodes[childIndex];
            if (!(0, $94bdc1ebed789608$export$1b55aa98f48e3915)(child)) {
                // If the item is explicitly set to not be focusable then TABINDEX needs to be set to -1.
                if (child.getAttribute && child.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === 'false') child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, '-1');
                if ((0, $94bdc1ebed789608$export$5d5979bf640d1558)(child, undefined, this._inShadowRoot)) {
                    if (this.props.disabled) child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, '-1');
                    else if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
                        this._defaultFocusElement = child;
                        if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== '0') child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, '0');
                    } else if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== '-1') child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, '-1');
                } else if (child.tagName === 'svg' && child.getAttribute('focusable') !== 'false') // Disgusting IE hack. Sad face.
                child.setAttribute('focusable', 'false');
            } else if (child.getAttribute($8c4e0e7eaa58d986$var$IS_FOCUSABLE_ATTRIBUTE) === 'true') {
                if (!this._isInnerZone && (!this._activeElement && !this._defaultFocusElement || this._activeElement === child)) {
                    this._defaultFocusElement = child;
                    if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== '0') child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, '0');
                } else if (child.getAttribute($8c4e0e7eaa58d986$var$TABINDEX) !== '-1') child.setAttribute($8c4e0e7eaa58d986$var$TABINDEX, '-1');
            }
            this._updateTabIndexes(child);
        }
    };
    FocusZone.prototype._isContentEditableElement = function(element) {
        return element && element.getAttribute('contenteditable') === 'true';
    };
    FocusZone.prototype._isElementInput = function(element) {
        if (element && element.tagName && (element.tagName.toLowerCase() === 'input' || element.tagName.toLowerCase() === 'textarea')) return true;
        return false;
    };
    FocusZone.prototype._shouldInputLoseFocus = function(element, isForward) {
        // If a tab was used, we want to focus on the next element.
        if (!this._processingTabKey && element && element.type && $8c4e0e7eaa58d986$var$ALLOWED_INPUT_TYPES.indexOf(element.type.toLowerCase()) > -1) {
            var selectionStart = element.selectionStart;
            var selectionEnd = element.selectionEnd;
            var isRangeSelected = selectionStart !== selectionEnd;
            var inputValue = element.value;
            var isReadonly = element.readOnly;
            // We shouldn't lose focus in the following cases:
            // 1. There is range selected.
            // 2. When selection start is larger than 0 and it is backward and not readOnly.
            // 3. when selection start is not the end of length, it is forward and not readOnly.
            // 4. We press any of the arrow keys when our handleTabKey isn't none or undefined (only losing focus if we hit
            // tab) and if shouldInputLoseFocusOnArrowKey is defined, if scenario prefers to not loose the focus which is
            // determined by calling the callback shouldInputLoseFocusOnArrowKey
            if (isRangeSelected || selectionStart > 0 && !isForward && !isReadonly || selectionStart !== inputValue.length && isForward && !isReadonly || !!this.props.handleTabKey && !(this.props.shouldInputLoseFocusOnArrowKey && this.props.shouldInputLoseFocusOnArrowKey(element))) return false;
        }
        return true;
    };
    FocusZone.prototype._shouldWrapFocus = function(element, noWrapDataAttribute) {
        return this.props.checkForNoWrap ? (0, $94bdc1ebed789608$export$841acbea7fb3b182)(element, noWrapDataAttribute) : true;
    };
    /**
     * Returns true if the element is a descendant of the FocusZone through a React portal.
     */ FocusZone.prototype._portalContainsElement = function(element) {
        return element && !!this._root.current && (0, $8eda1135a5ecf96f$export$ca66eda9f83446dd)(element, this._root.current);
    };
    FocusZone.prototype._getDocument = function() {
        return (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(this._root.current);
    };
    FocusZone.defaultProps = {
        isCircularNavigation: false,
        direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).bidirectional,
        shouldRaiseClicks: true,
        // Hardcoding uncontrolled flag for proper interop with FluentUI V9.
        'data-tabster': '{"uncontrolled": {}}'
    };
    FocusZone.contextType = (0, $81033f91b1d0d219$export$bab63bc83b10c08f);
    return FocusZone;
}($acw62.Component);



function $f3ff39ec82d473ae$export$36ffd6a0ea64902d(defaultProps, propsWithoutDefaults) {
    var props = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, propsWithoutDefaults);
    for(var _i = 0, _a = Object.keys(defaultProps); _i < _a.length; _i++){
        var key = _a[_i];
        if (props[key] === undefined) props[key] = defaultProps[key];
    }
    return props;
}

/**
 * Returns true if and only if the user is on a iOS device.
 * Used to determine whether iOS-specific behavior should be applied.
 */ var $865faf0b4151a9c6$export$fedb369cb70207f1 = function() {
    // eslint-disable-next-line no-restricted-globals
    if (!window || !window.navigator || !window.navigator.userAgent) return false;
    // eslint-disable-next-line no-restricted-globals
    return /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
};


var $46def017ce9f8d16$var$isMacResult;
function $46def017ce9f8d16$export$9ac100e40613ea10(reset) {
    var _a;
    if (typeof $46def017ce9f8d16$var$isMacResult === 'undefined' || reset) {
        var win = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
        // In certain SSR frameworks, `window` will be defined even on the server but `navigator` will be undefined
        var userAgent = (_a = win === null || win === void 0 ? void 0 : win.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
        $46def017ce9f8d16$var$isMacResult = !!userAgent && userAgent.indexOf('Macintosh') !== -1;
    }
    return !!$46def017ce9f8d16$var$isMacResult;
}


/**
 * Determines the effective checked state of a menu item.
 *
 * @param item {IContextualMenuItem} to get the check state of.
 * @returns {true} if the item is checked.
 * @returns {false} if the item is unchecked.
 * @returns {null} if the item is not checkable.
 */ function $3250824b6f1d23dc$export$876e33b6ab5c0eaa(item) {
    if (item.canCheck) return !!(item.isChecked || item.checked);
    if (typeof item.isChecked === 'boolean') return item.isChecked;
    if (typeof item.checked === 'boolean') return item.checked;
    // Item is not checkable.
    return null;
}
function $3250824b6f1d23dc$export$bb9ab0e82942591e(item) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return !!(item.subMenuProps || item.items);
}
function $3250824b6f1d23dc$export$98e832630d6cf989(item) {
    return !!(item.isDisabled || item.disabled);
}
function $3250824b6f1d23dc$export$84bfff8e7c9de691(item) {
    var isChecked = $3250824b6f1d23dc$export$876e33b6ab5c0eaa(item);
    var canCheck = isChecked !== null;
    return canCheck ? 'menuitemcheckbox' : 'menuitem';
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $18e32c5a70ef0416$export$af631764ddc44097(element, eventName, callback, options) {
    element.addEventListener(eventName, callback, options);
    return function() {
        return element.removeEventListener(eventName, callback, options);
    };
}




/**
 * Rectangle helper class.
 *
 * @public
 * {@docCategory Rectangle}
 */ var $e6e58afbc62ca69b$export$4617fb02663045ef = /** @class */ function() {
    function Rectangle(left, right, top, bottom) {
        if (left === void 0) left = 0;
        if (right === void 0) right = 0;
        if (top === void 0) top = 0;
        if (bottom === void 0) bottom = 0;
        this.top = top;
        this.bottom = bottom;
        this.left = left;
        this.right = right;
    }
    Object.defineProperty(Rectangle.prototype, "width", {
        /**
         * Calculated automatically by subtracting the right from left
         */ get: function() {
            return this.right - this.left;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "height", {
        /**
         * Calculated automatically by subtracting the bottom from top.
         */ get: function() {
            return this.bottom - this.top;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Tests if another rect is approximately equal to this rect (within 4 decimal places.)
     */ Rectangle.prototype.equals = function(rect) {
        // Fixing to 4 decimal places because it allows enough precision and will handle cases when something
        // should be rounded, like .999999 should round to 1.
        return parseFloat(this.top.toFixed(4)) === parseFloat(rect.top.toFixed(4)) && parseFloat(this.bottom.toFixed(4)) === parseFloat(rect.bottom.toFixed(4)) && parseFloat(this.left.toFixed(4)) === parseFloat(rect.left.toFixed(4)) && parseFloat(this.right.toFixed(4)) === parseFloat(rect.right.toFixed(4));
    };
    return Rectangle;
}();


var $915a71a5da79ffac$export$a121ec89eaa4231a;
(function(RectangleEdge) {
    RectangleEdge[RectangleEdge["top"] = 1] = "top";
    RectangleEdge[RectangleEdge["bottom"] = -1] = "bottom";
    RectangleEdge[RectangleEdge["left"] = 2] = "left";
    RectangleEdge[RectangleEdge["right"] = -2] = "right";
})($915a71a5da79ffac$export$a121ec89eaa4231a || ($915a71a5da79ffac$export$a121ec89eaa4231a = {}));
var $915a71a5da79ffac$export$13807d9ee5a34a42;
(function(Position) {
    Position[Position["top"] = 0] = "top";
    Position[Position["bottom"] = 1] = "bottom";
    Position[Position["start"] = 2] = "start";
    Position[Position["end"] = 3] = "end";
})($915a71a5da79ffac$export$13807d9ee5a34a42 || ($915a71a5da79ffac$export$13807d9ee5a34a42 = {}));


var $ce88cd5257e3ce57$var$_a;
function $ce88cd5257e3ce57$var$_createPositionData(targetEdge, alignmentEdge, isAuto) {
    return {
        targetEdge: targetEdge,
        alignmentEdge: alignmentEdge,
        isAuto: isAuto
    };
}
// Currently the beakPercent is set to 50 for all positions meaning that it should tend to the center of the target
var $ce88cd5257e3ce57$var$DirectionalDictionary = ($ce88cd5257e3ce57$var$_a = {}, $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topLeftEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topRightEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).topAutoEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top, undefined, true), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomLeftEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomRightEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom, undefined, true), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).leftTopEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).leftCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).leftBottomEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).rightTopEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).rightCenter] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right), $ce88cd5257e3ce57$var$_a[(0, $e52f208cfc343b11$export$7bbc434a13063638).rightBottomEdge] = $ce88cd5257e3ce57$var$_createPositionData((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right, (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom), $ce88cd5257e3ce57$var$_a);
function $ce88cd5257e3ce57$var$_isRectangleWithinBounds(rect, boundingRect) {
    if (rect.top < boundingRect.top) return false;
    if (rect.bottom > boundingRect.bottom) return false;
    if (rect.left < boundingRect.left) return false;
    if (rect.right > boundingRect.right) return false;
    return true;
}
/**
 * Gets all of the edges of a rectangle that are outside of the given bounds.
 * If there are no out of bounds edges it returns an empty array.
 */ function $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(rect, boundingRect) {
    var outOfBounds = [];
    if (rect.top < boundingRect.top) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).top);
    if (rect.bottom > boundingRect.bottom) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom);
    if (rect.left < boundingRect.left) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).left);
    if (rect.right > boundingRect.right) outOfBounds.push((0, $915a71a5da79ffac$export$a121ec89eaa4231a).right);
    return outOfBounds;
}
function $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge) {
    return rect[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[edge]];
}
function $ce88cd5257e3ce57$var$_setEdgeValue(rect, edge, value) {
    rect[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[edge]] = value;
    return rect;
}
/**
 * Returns the middle value of an edge. Only returns 1 value rather than xy coordinates as
 * the itself already contains the other coordinate.
 * For instance, a bottom edge's current value is it's y coordinate, so the number returned is the x.
 */ function $ce88cd5257e3ce57$var$_getCenterValue(rect, edge) {
    var edges = $ce88cd5257e3ce57$var$_getFlankingEdges(edge);
    return ($ce88cd5257e3ce57$var$_getEdgeValue(rect, edges.positiveEdge) + $ce88cd5257e3ce57$var$_getEdgeValue(rect, edges.negativeEdge)) / 2;
}
/**
 * Flips the value depending on the edge.
 * If the edge is a "positive" edge, Top or Left, then the value should stay as it is.
 * If the edge is a "negative" edge, Bottom or Right, then the value should be flipped.
 * This is to account for the fact that the coordinates are effectively reserved in certain cases for the
 * "negative" edges.
 *
 * For example, when testing to see if a bottom edge 1 is within the bounds of another bottom edge 2:
 * If edge 1 is greater than edge 2 then it is out of bounds. This is reversed for top edge 1 and top edge 2.
 * If top edge 1 is less than edge 2 then it is out of bounds.
 */ function $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, value) {
    if (edge > 0) return value;
    else return value * -1;
}
function $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(edge, rect) {
    return $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge));
}
function $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(rect, hostRect, edge) {
    var edgeDifference = $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge) - $ce88cd5257e3ce57$var$_getEdgeValue(hostRect, edge);
    return $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, edgeDifference);
}
/**
 * Moves the edge of a rectangle to the value given. It only moves the edge in a linear direction based on that edge.
 * For example, if it's a bottom edge it will only change y coordinates.
 * if maintainSize is set to false, it will only adjust the specified edge value
 */ function $ce88cd5257e3ce57$var$_moveEdge(rect, edge, newValue, maintainSize) {
    if (maintainSize === void 0) maintainSize = true;
    var difference = $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge) - newValue;
    var returnRect = $ce88cd5257e3ce57$var$_setEdgeValue(rect, edge, newValue);
    if (maintainSize) returnRect = $ce88cd5257e3ce57$var$_setEdgeValue(rect, edge * -1, $ce88cd5257e3ce57$var$_getEdgeValue(rect, edge * -1) - difference);
    return returnRect;
}
/**
 * Aligns the edge on the passed in rect to the target. If there is a gap then it will have that space between the two.
 */ function $ce88cd5257e3ce57$var$_alignEdges(rect, target, edge, gap) {
    if (gap === void 0) gap = 0;
    return $ce88cd5257e3ce57$var$_moveEdge(rect, edge, $ce88cd5257e3ce57$var$_getEdgeValue(target, edge) + $ce88cd5257e3ce57$var$_getRelativeEdgeValue(edge, gap));
}
/**
 * Aligns the targetEdge on the passed in target to the rects corresponding opposite edge.
 * For instance if targetEdge is bottom, then the rects top will be moved to match it.
 */ function $ce88cd5257e3ce57$var$_alignOppositeEdges(rect, target, targetEdge, gap) {
    if (gap === void 0) gap = 0;
    var oppositeEdge = targetEdge * -1;
    var adjustedGap = $ce88cd5257e3ce57$var$_getRelativeEdgeValue(oppositeEdge, gap);
    return $ce88cd5257e3ce57$var$_moveEdge(rect, targetEdge * -1, $ce88cd5257e3ce57$var$_getEdgeValue(target, targetEdge) + adjustedGap);
}
/**
 * Tests to see if the given edge is within the bounds of the given rectangle.
 */ function $ce88cd5257e3ce57$var$_isEdgeInBounds(rect, bounds, edge) {
    var adjustedRectValue = $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(edge, rect);
    return adjustedRectValue > $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(edge, bounds);
}
/**
 * Returns a measure of how much a rectangle is out of bounds for a given alignment;
 * this can be used to compare which rectangle is more or less out of bounds.
 * A value of 0 means the rectangle is entirely in bounds
 */ function $ce88cd5257e3ce57$var$_getOutOfBoundsDegree(rect, bounds) {
    var breakingEdges = $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(rect, bounds);
    var total = 0;
    for(var _i = 0, breakingEdges_1 = breakingEdges; _i < breakingEdges_1.length; _i++){
        var edge = breakingEdges_1[_i];
        total += Math.pow($ce88cd5257e3ce57$var$_getRelativeEdgeDifference(rect, bounds, edge), 2);
    }
    return total;
}
/**
 * Returns true if scroll-resizing will move the target edge within the bounding rectangle,
 * and there is room between the target edge and the bounding edge for scrolled content.
 * Returns false otherwise.
 */ function $ce88cd5257e3ce57$var$_canScrollResizeToFitEdge(target, bounding, targetEdge, minimumScrollResizeHeight) {
    if (minimumScrollResizeHeight === void 0) minimumScrollResizeHeight = 200;
    // Only scroll vertically to fit - cannot scroll to fit right or left edges
    if (targetEdge !== (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom && targetEdge !== (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top) return false;
    return $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(target, bounding, targetEdge) >= minimumScrollResizeHeight;
}
/**
 * Attempts to move the rectangle through various sides of the target to find a place to fit.
 * If no fit is found, the least bad option should be returned.
 */ function $ce88cd5257e3ce57$var$_flipToFit(rect, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap) {
    if (shouldScroll === void 0) shouldScroll = false;
    if (gap === void 0) gap = 0;
    var directions = [
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left,
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right,
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom,
        (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top
    ];
    // In RTL page, RectangleEdge.right has a higher priority than RectangleEdge.left, so the order should be updated.
    if ((0, $723d0744d8fe4fde$export$b2303637e9533380)()) {
        directions[0] *= -1;
        directions[1] *= -1;
    }
    var currentEstimate = rect;
    var currentEdge = positionData.targetEdge;
    var currentAlignment = positionData.alignmentEdge;
    // keep track of least bad option, in case no sides fit
    var oobDegree;
    var bestEdge = currentEdge;
    var bestAlignment = currentAlignment;
    // Keep switching sides until one is found with enough space.
    // If all sides don't fit then return the unmodified element.
    for(var i = 0; i < 4; i++){
        if ($ce88cd5257e3ce57$var$_isEdgeInBounds(currentEstimate, bounding, currentEdge)) // Edge is in bounds, return current estimate
        return {
            elementRectangle: currentEstimate,
            targetEdge: currentEdge,
            alignmentEdge: currentAlignment
        };
        else if (shouldScroll && $ce88cd5257e3ce57$var$_canScrollResizeToFitEdge(target, bounding, currentEdge, minimumScrollResizeHeight)) {
            // Scrolling will allow edge to fit, move the estimate currentEdge inside the bounds and return
            switch(currentEdge){
                case (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom:
                    currentEstimate.bottom = bounding.bottom;
                    break;
                case (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top:
                    currentEstimate.top = bounding.top;
                    break;
            }
            return {
                elementRectangle: currentEstimate,
                targetEdge: currentEdge,
                alignmentEdge: currentAlignment,
                forcedInBounds: true
            };
        } else {
            // update least-bad edges
            var currentOOBDegree = $ce88cd5257e3ce57$var$_getOutOfBoundsDegree(currentEstimate, bounding);
            if (!oobDegree || currentOOBDegree < oobDegree) {
                oobDegree = currentOOBDegree;
                bestEdge = currentEdge;
                bestAlignment = currentAlignment;
            }
            directions.splice(directions.indexOf(currentEdge), 1);
            if (directions.length > 0) {
                if (directions.indexOf(currentEdge * -1) > -1) currentEdge = currentEdge * -1;
                else {
                    currentAlignment = currentEdge;
                    currentEdge = directions.slice(-1)[0];
                }
                currentEstimate = $ce88cd5257e3ce57$var$_estimatePosition(rect, target, {
                    targetEdge: currentEdge,
                    alignmentEdge: currentAlignment
                }, gap);
            }
        }
    }
    // nothing fits, use least-bad option
    currentEstimate = $ce88cd5257e3ce57$var$_estimatePosition(rect, target, {
        targetEdge: bestEdge,
        alignmentEdge: bestAlignment
    }, gap);
    return {
        elementRectangle: currentEstimate,
        targetEdge: bestEdge,
        alignmentEdge: bestAlignment
    };
}
/**
 * Flips only the alignment edge of an element rectangle. This is used instead of nudging the alignment edges
 * into position, when `alignTargetEdge` is specified.
 */ function $ce88cd5257e3ce57$var$_flipAlignmentEdge(elementEstimate, target, gap, coverTarget) {
    var alignmentEdge = elementEstimate.alignmentEdge, targetEdge = elementEstimate.targetEdge, elementRectangle = elementEstimate.elementRectangle;
    var oppositeEdge = alignmentEdge * -1;
    var newEstimate = $ce88cd5257e3ce57$var$_estimatePosition(elementRectangle, target, {
        targetEdge: targetEdge,
        alignmentEdge: oppositeEdge
    }, gap, coverTarget);
    return {
        elementRectangle: newEstimate,
        targetEdge: targetEdge,
        alignmentEdge: oppositeEdge
    };
}
/**
 * Adjusts a element rectangle to fit within the bounds given. If directionalHintFixed or covertarget is passed in
 * then the element will not flip sides on the target. They will, however, be nudged to fit within the bounds given.
 */ function $ce88cd5257e3ce57$var$_adjustFitWithinBounds(element, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap, directionalHintFixed, coverTarget) {
    if (shouldScroll === void 0) shouldScroll = false;
    if (gap === void 0) gap = 0;
    var alignmentEdge = positionData.alignmentEdge, alignTargetEdge = positionData.alignTargetEdge;
    var elementEstimate = {
        elementRectangle: element,
        targetEdge: positionData.targetEdge,
        alignmentEdge: alignmentEdge
    };
    if (!directionalHintFixed && !coverTarget) elementEstimate = $ce88cd5257e3ce57$var$_flipToFit(element, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap);
    var outOfBounds = $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(elementEstimate.elementRectangle, bounding);
    // if directionalHintFixed is specified, we need to force the target edge to not change
    // we need *-1 because targetEdge refers to the target's edge; the callout edge is the opposite
    var fixedEdge = directionalHintFixed ? -elementEstimate.targetEdge : undefined;
    if (outOfBounds.length > 0) {
        if (alignTargetEdge) {
            // The edge opposite to the alignment edge might be out of bounds.
            // Flip alignment to see if we can get it within bounds.
            if (elementEstimate.alignmentEdge && outOfBounds.indexOf(elementEstimate.alignmentEdge * -1) > -1) {
                var flippedElementEstimate = $ce88cd5257e3ce57$var$_flipAlignmentEdge(elementEstimate, target, gap, coverTarget);
                if ($ce88cd5257e3ce57$var$_isRectangleWithinBounds(flippedElementEstimate.elementRectangle, bounding)) return flippedElementEstimate;
                else // If the flipped elements edges are still out of bounds, try nudging it.
                elementEstimate = $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges($ce88cd5257e3ce57$var$_getOutOfBoundsEdges(flippedElementEstimate.elementRectangle, bounding), elementEstimate, bounding, fixedEdge);
            } else elementEstimate = $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges(outOfBounds, elementEstimate, bounding, fixedEdge);
        } else elementEstimate = $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges(outOfBounds, elementEstimate, bounding, fixedEdge);
    }
    return elementEstimate;
}
/**
 * Iterates through a list of out of bounds edges and tries to nudge and align them.
 * @param outOfBoundsEdges - Array of edges that are out of bounds
 * @param elementEstimate - The current element positioning estimate
 * @param bounding - The current bounds
 * @param preserveEdge - Specify an edge that should not be modified
 */ function $ce88cd5257e3ce57$var$_alignOutOfBoundsEdges(outOfBoundsEdges, elementEstimate, bounding, preserveEdge) {
    for(var _i = 0, outOfBoundsEdges_1 = outOfBoundsEdges; _i < outOfBoundsEdges_1.length; _i++){
        var direction = outOfBoundsEdges_1[_i];
        var edgeAttempt = void 0;
        // if preserveEdge is specified, do not call _alignEdges, skip directly to _moveEdge
        // this is because _alignEdges will move the opposite edge
        if (preserveEdge && preserveEdge === direction * -1) {
            edgeAttempt = $ce88cd5257e3ce57$var$_moveEdge(elementEstimate.elementRectangle, direction, $ce88cd5257e3ce57$var$_getEdgeValue(bounding, direction), false);
            elementEstimate.forcedInBounds = true;
        } else {
            edgeAttempt = $ce88cd5257e3ce57$var$_alignEdges(elementEstimate.elementRectangle, bounding, direction);
            var inBounds = $ce88cd5257e3ce57$var$_isEdgeInBounds(edgeAttempt, bounding, direction * -1);
            // only update estimate if the attempt didn't break out of the opposite bounding edge
            if (!inBounds) {
                edgeAttempt = $ce88cd5257e3ce57$var$_moveEdge(edgeAttempt, direction * -1, $ce88cd5257e3ce57$var$_getEdgeValue(bounding, direction * -1), false);
                elementEstimate.forcedInBounds = true;
            }
        }
        elementEstimate.elementRectangle = edgeAttempt;
    }
    return elementEstimate;
}
/**
 * Moves the middle point on an edge to the point given.
 * Only moves in one direction. For instance if a bottom edge is passed in, then
 * the bottom edge will be moved in the x axis to match the point.
 */ function $ce88cd5257e3ce57$var$_centerEdgeToPoint(rect, edge, point) {
    var positiveEdge = $ce88cd5257e3ce57$var$_getFlankingEdges(edge).positiveEdge;
    var elementMiddle = $ce88cd5257e3ce57$var$_getCenterValue(rect, edge);
    var distanceToMiddle = elementMiddle - $ce88cd5257e3ce57$var$_getEdgeValue(rect, positiveEdge);
    return $ce88cd5257e3ce57$var$_moveEdge(rect, positiveEdge, point - distanceToMiddle);
}
/**
 * Moves the element rectangle to be appropriately positioned relative to a given target.
 * Does not flip or adjust the element.
 */ function $ce88cd5257e3ce57$var$_estimatePosition(elementToPosition, target, positionData, gap, coverTarget) {
    if (gap === void 0) gap = 0;
    var estimatedElementPosition = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(elementToPosition.left, elementToPosition.right, elementToPosition.top, elementToPosition.bottom);
    var alignmentEdge = positionData.alignmentEdge, targetEdge = positionData.targetEdge;
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    estimatedElementPosition = coverTarget ? $ce88cd5257e3ce57$var$_alignEdges(estimatedElementPosition, target, targetEdge, gap) : $ce88cd5257e3ce57$var$_alignOppositeEdges(estimatedElementPosition, target, targetEdge, gap);
    // if no alignment edge is provided it's supposed to be centered.
    if (!alignmentEdge) {
        var targetMiddlePoint = $ce88cd5257e3ce57$var$_getCenterValue(target, targetEdge);
        estimatedElementPosition = $ce88cd5257e3ce57$var$_centerEdgeToPoint(estimatedElementPosition, elementEdge, targetMiddlePoint);
    } else estimatedElementPosition = $ce88cd5257e3ce57$var$_alignEdges(estimatedElementPosition, target, alignmentEdge);
    return estimatedElementPosition;
}
/**
 * Returns the non-opposite edges of the target edge.
 * For instance if bottom is passed in then left and right will be returned.
 */ function $ce88cd5257e3ce57$var$_getFlankingEdges(edge) {
    if (edge === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top || edge === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom) return {
        positiveEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).left,
        negativeEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).right
    };
    else return {
        positiveEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top,
        negativeEdge: (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom
    };
}
/**
 * Retrieve the final value for the return edge of `elementRectangle`. If the `elementRectangle` is closer to one side
 * of the bounds versus the other, the return edge is flipped to grow inward.
 */ function $ce88cd5257e3ce57$var$_finalizeReturnEdge(elementRectangle, returnEdge, bounds) {
    if (bounds && Math.abs($ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge)) > Math.abs($ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, bounds, returnEdge * -1))) return returnEdge * -1;
    return returnEdge;
}
/**
 * Whether or not the considered edge of the elementRectangle is lying on the edge of the bounds
 * @param elementRectangle The rectangle whose edge we are considering
 * @param bounds The rectangle marking the bounds
 * @param edge The target edge we're considering
 * @returns If the target edge of the elementRectangle is in the same location as that edge of the bounds
 */ function $ce88cd5257e3ce57$var$_isEdgeOnBounds(elementRectangle, edge, bounds) {
    return bounds !== undefined && $ce88cd5257e3ce57$var$_getEdgeValue(elementRectangle, edge) === $ce88cd5257e3ce57$var$_getEdgeValue(bounds, edge);
}
/**
 * Finalizes the element position based on the hostElement. Only returns the
 * rectangle values to position such that they are anchored to the target.
 * This helps prevent resizing from looking very strange.
 * For instance, if the target edge is top and aligned with the left side then
 * the bottom and left values are returned so as the Callout shrinks it shrinks towards that corner.
 */ function $ce88cd5257e3ce57$var$_finalizeElementPosition(elementRectangle, hostElement, targetEdge, bounds, alignmentEdge, coverTarget, doNotFinalizeReturnEdge, forceWithinBounds) {
    var returnValue = {};
    var hostRect = $ce88cd5257e3ce57$var$_getRectangleFromElement(hostElement);
    var elementEdge = coverTarget ? targetEdge : targetEdge * -1;
    var returnEdge = alignmentEdge ? alignmentEdge : $ce88cd5257e3ce57$var$_getFlankingEdges(targetEdge).positiveEdge;
    // If we are finalizing the return edge, choose the edge such that we grow away from the bounds
    // If we are not finalizing the return edge but the opposite edge is flush against the bounds,
    // choose that as the anchor edge so the element rect can grow away from the bounds' edge
    // In this case there will not be a visual difference because there is no more room for the elementRectangle to grow
    // in the usual direction
    if (!doNotFinalizeReturnEdge || $ce88cd5257e3ce57$var$_isEdgeOnBounds(elementRectangle, $ce88cd5257e3ce57$export$91aad4f6c09ebbeb(returnEdge), bounds)) returnEdge = $ce88cd5257e3ce57$var$_finalizeReturnEdge(elementRectangle, returnEdge, bounds);
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[elementEdge]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge);
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[returnEdge]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge);
    // if the positioned element will still overflow, return all four edges with in-bounds values
    if (forceWithinBounds) {
        returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[elementEdge * -1]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, elementEdge * -1);
        returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[returnEdge * -1]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementRectangle, hostRect, returnEdge * -1);
    }
    return returnValue;
}
// Since the beak is rotated 45 degrees the actual height/width is the length of the diagonal.
// We still want to position the beak based on it's midpoint which does not change. It will
// be at (beakwidth / 2, beakwidth / 2)
function $ce88cd5257e3ce57$var$_calculateActualBeakWidthInPixels(beakWidth) {
    return Math.sqrt(beakWidth * beakWidth * 2);
}
/**
 * Returns the appropriate IPositionData based on the props altered for RTL.
 * If directionalHintForRTL is passed in that is used if the page is RTL.
 * If directionalHint is specified, no directionalHintForRTL is available, and the page is RTL, the hint will be
 * flipped (e.g. bottomLeftEdge would become bottomRightEdge).
 *
 * If there is no directionalHint passed in, bottomAutoEdge is chosen automatically.
 */ function $ce88cd5257e3ce57$var$_getPositionData(directionalHint, directionalHintForRTL, previousPositions) {
    if (directionalHint === void 0) directionalHint = (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge;
    if (previousPositions) return {
        alignmentEdge: previousPositions.alignmentEdge,
        isAuto: previousPositions.isAuto,
        targetEdge: previousPositions.targetEdge
    };
    var positionInformation = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $ce88cd5257e3ce57$var$DirectionalDictionary[directionalHint]);
    if ((0, $723d0744d8fe4fde$export$b2303637e9533380)()) {
        // If alignment edge exists and that alignment edge is -2 or 2, right or left, then flip it.
        if (positionInformation.alignmentEdge && positionInformation.alignmentEdge % 2 === 0) positionInformation.alignmentEdge = positionInformation.alignmentEdge * -1;
        return directionalHintForRTL !== undefined ? $ce88cd5257e3ce57$var$DirectionalDictionary[directionalHintForRTL] : positionInformation;
    }
    return positionInformation;
}
/**
 * Gets the alignment data for the given information. This only really matters if the positioning is Auto.
 * If it is auto then the alignmentEdge should be chosen based on the target edge's position relative to
 * the center of the page.
 */ function $ce88cd5257e3ce57$var$_getAlignmentData(positionData, target, boundingRect, coverTarget, alignTargetEdge) {
    if (positionData.isAuto) positionData.alignmentEdge = $ce88cd5257e3ce57$var$getClosestEdge(positionData.targetEdge, target, boundingRect);
    positionData.alignTargetEdge = alignTargetEdge;
    return positionData;
}
function $ce88cd5257e3ce57$var$getClosestEdge(targetEdge, target, boundingRect) {
    var targetCenter = $ce88cd5257e3ce57$var$_getCenterValue(target, targetEdge);
    var boundingCenter = $ce88cd5257e3ce57$var$_getCenterValue(boundingRect, targetEdge);
    var _a = $ce88cd5257e3ce57$var$_getFlankingEdges(targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    if (targetCenter <= boundingCenter) return positiveEdge;
    else return negativeEdge;
}
function $ce88cd5257e3ce57$var$_positionElementWithinBounds(elementToPosition, target, bounding, positionData, gap, shouldScroll, minimumScrollResizeHeight, directionalHintFixed, coverTarget) {
    if (shouldScroll === void 0) shouldScroll = false;
    var estimatedElementPosition = $ce88cd5257e3ce57$var$_estimatePosition(elementToPosition, target, positionData, gap, coverTarget);
    if ($ce88cd5257e3ce57$var$_isRectangleWithinBounds(estimatedElementPosition, bounding)) return {
        elementRectangle: estimatedElementPosition,
        targetEdge: positionData.targetEdge,
        alignmentEdge: positionData.alignmentEdge
    };
    else return $ce88cd5257e3ce57$var$_adjustFitWithinBounds(estimatedElementPosition, target, bounding, positionData, shouldScroll, minimumScrollResizeHeight, gap, directionalHintFixed, coverTarget);
}
function $ce88cd5257e3ce57$var$_finalizeBeakPosition(elementPosition, positionedBeak, bounds) {
    var targetEdge = elementPosition.targetEdge * -1;
    // The "host" element that we will use to help position the beak.
    var actualElement = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, elementPosition.elementRectangle.width, 0, elementPosition.elementRectangle.height);
    var returnValue = {};
    var returnEdge = $ce88cd5257e3ce57$var$_finalizeReturnEdge(elementPosition.elementRectangle, elementPosition.alignmentEdge ? elementPosition.alignmentEdge : $ce88cd5257e3ce57$var$_getFlankingEdges(targetEdge).positiveEdge, bounds);
    // only show the beak if the callout is not fully covering the target
    var beakEdgeDifference = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(elementPosition.elementRectangle, elementPosition.targetRectangle, targetEdge);
    var showBeak = beakEdgeDifference > Math.abs($ce88cd5257e3ce57$var$_getEdgeValue(positionedBeak, targetEdge));
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[targetEdge]] = $ce88cd5257e3ce57$var$_getEdgeValue(positionedBeak, targetEdge);
    returnValue[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[returnEdge]] = $ce88cd5257e3ce57$var$_getRelativeEdgeDifference(positionedBeak, actualElement, returnEdge);
    return {
        elementPosition: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, returnValue),
        closestEdge: $ce88cd5257e3ce57$var$getClosestEdge(elementPosition.targetEdge, positionedBeak, actualElement),
        targetEdge: targetEdge,
        hideBeak: !showBeak
    };
}
function $ce88cd5257e3ce57$var$_positionBeak(beakWidth, elementPosition) {
    var target = elementPosition.targetRectangle;
    /**
     * Note about beak positioning: The actual beak width only matters for getting the gap between the callout and
     * target, it does not impact the beak placement within the callout. For example example, if the beakWidth is 8,
     * then the actual beakWidth is sqrroot(8^2 + 8^2) = 11.31x11.31. So the callout will need to be an extra 3 pixels
     * away from its target. While the beak is being positioned in the callout it still acts as though it were 8x8.
     */ var _a = $ce88cd5257e3ce57$var$_getFlankingEdges(elementPosition.targetEdge), positiveEdge = _a.positiveEdge, negativeEdge = _a.negativeEdge;
    var beakTargetPoint = $ce88cd5257e3ce57$var$_getCenterValue(target, elementPosition.targetEdge);
    var elementBounds = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(beakWidth / 2, elementPosition.elementRectangle.width - beakWidth / 2, beakWidth / 2, elementPosition.elementRectangle.height - beakWidth / 2);
    var beakPosition = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, beakWidth, 0, beakWidth);
    beakPosition = $ce88cd5257e3ce57$var$_moveEdge(beakPosition, elementPosition.targetEdge * -1, -beakWidth / 2);
    beakPosition = $ce88cd5257e3ce57$var$_centerEdgeToPoint(beakPosition, elementPosition.targetEdge * -1, beakTargetPoint - $ce88cd5257e3ce57$var$_getRelativeRectEdgeValue(positiveEdge, elementPosition.elementRectangle));
    if (!$ce88cd5257e3ce57$var$_isEdgeInBounds(beakPosition, elementBounds, positiveEdge)) beakPosition = $ce88cd5257e3ce57$var$_alignEdges(beakPosition, elementBounds, positiveEdge);
    else if (!$ce88cd5257e3ce57$var$_isEdgeInBounds(beakPosition, elementBounds, negativeEdge)) beakPosition = $ce88cd5257e3ce57$var$_alignEdges(beakPosition, elementBounds, negativeEdge);
    return beakPosition;
}
function $ce88cd5257e3ce57$var$_getRectangleFromElement(element) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var clientRect = element.getBoundingClientRect();
    return new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(clientRect.left, clientRect.right, clientRect.top, clientRect.bottom);
}
function $ce88cd5257e3ce57$var$_getRectangleFromIRect(rect) {
    return new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(rect.left, rect.right, rect.top, rect.bottom);
}
function $ce88cd5257e3ce57$var$_getTargetRect(bounds, target) {
    var targetRectangle;
    if (target) {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!target.preventDefault) {
            var ev = target;
            targetRectangle = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(ev.clientX, ev.clientX, ev.clientY, ev.clientY);
        // eslint-disable-next-line no-extra-boolean-cast
        } else if (!!target.getBoundingClientRect) targetRectangle = $ce88cd5257e3ce57$var$_getRectangleFromElement(target);
        else {
            var rectOrPoint = target;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var left = rectOrPoint.left || rectOrPoint.x;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var top_1 = rectOrPoint.top || rectOrPoint.y;
            var right = rectOrPoint.right || left;
            var bottom = rectOrPoint.bottom || top_1;
            targetRectangle = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(left, right, top_1, bottom);
        }
        if (!$ce88cd5257e3ce57$var$_isRectangleWithinBounds(targetRectangle, bounds)) {
            var outOfBounds = $ce88cd5257e3ce57$var$_getOutOfBoundsEdges(targetRectangle, bounds);
            for(var _i = 0, outOfBounds_1 = outOfBounds; _i < outOfBounds_1.length; _i++){
                var direction = outOfBounds_1[_i];
                targetRectangle[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[direction]] = bounds[(0, $915a71a5da79ffac$export$a121ec89eaa4231a)[direction]];
            }
        }
    } else targetRectangle = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, 0, 0, 0);
    return targetRectangle;
}
/**
 * If max height is less than zero it returns the bounds height instead.
 */ function $ce88cd5257e3ce57$var$_getMaxHeightFromTargetRectangle(targetRectangle, targetEdge, gapSpace, bounds, coverTarget) {
    var maxHeight = 0;
    var directionalHint = $ce88cd5257e3ce57$var$DirectionalDictionary[targetEdge];
    // If cover target is set, then the max height should be calculated using the opposite of the target edge since
    // that's the direction that the callout will expand in.
    // For instance, if the directionalhint is bottomLeftEdge then the callout will position so it's bottom edge
    // is aligned with the bottom of the target and expand up towards the top of the screen and the calculated max height
    // is (bottom of target) - (top of screen) - gapSpace.
    var target = coverTarget ? directionalHint.targetEdge * -1 : directionalHint.targetEdge;
    if (target === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top) maxHeight = $ce88cd5257e3ce57$var$_getEdgeValue(targetRectangle, directionalHint.targetEdge) - bounds.top - gapSpace;
    else if (target === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom) maxHeight = bounds.bottom - $ce88cd5257e3ce57$var$_getEdgeValue(targetRectangle, directionalHint.targetEdge) - gapSpace;
    else maxHeight = bounds.bottom - targetRectangle.top - gapSpace;
    return maxHeight > 0 ? maxHeight : bounds.height;
}
function $ce88cd5257e3ce57$var$_positionElementRelative(props, elementToPosition, boundingRect, previousPositions, shouldScroll, minimumScrollResizeHeight) {
    if (shouldScroll === void 0) shouldScroll = false;
    var gap = props.gapSpace ? props.gapSpace : 0;
    var targetRect = $ce88cd5257e3ce57$var$_getTargetRect(boundingRect, props.target);
    var positionData = $ce88cd5257e3ce57$var$_getAlignmentData($ce88cd5257e3ce57$var$_getPositionData(props.directionalHint, props.directionalHintForRTL, previousPositions), targetRect, boundingRect, props.coverTarget, props.alignTargetEdge);
    var positionedElement = $ce88cd5257e3ce57$var$_positionElementWithinBounds($ce88cd5257e3ce57$var$_getRectangleFromElement(elementToPosition), targetRect, boundingRect, positionData, gap, shouldScroll, minimumScrollResizeHeight, props.directionalHintFixed, props.coverTarget);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, positionedElement), {
        targetRectangle: targetRect
    });
}
function $ce88cd5257e3ce57$var$_finalizePositionData(positionedElement, hostElement, bounds, coverTarget, doNotFinalizeReturnEdge) {
    var finalizedElement = $ce88cd5257e3ce57$var$_finalizeElementPosition(positionedElement.elementRectangle, hostElement, positionedElement.targetEdge, bounds, positionedElement.alignmentEdge, coverTarget, doNotFinalizeReturnEdge, positionedElement.forcedInBounds);
    return {
        elementPosition: finalizedElement,
        targetEdge: positionedElement.targetEdge,
        alignmentEdge: positionedElement.alignmentEdge
    };
}
function $ce88cd5257e3ce57$var$_positionElement(props, hostElement, elementToPosition, previousPositions, win) {
    var theWin = win !== null && win !== void 0 ? win : (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    var boundingRect = props.bounds ? $ce88cd5257e3ce57$var$_getRectangleFromIRect(props.bounds) : new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, theWin.innerWidth - (0, $11f97b2a9a127629$export$ace028f8da1a6300)(), 0, theWin.innerHeight);
    var positionedElement = $ce88cd5257e3ce57$var$_positionElementRelative(props, elementToPosition, boundingRect, previousPositions);
    return $ce88cd5257e3ce57$var$_finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget);
}
function $ce88cd5257e3ce57$var$_calculateGapSpace(isBeakVisible, beakWidth, gapSpace) {
    if (beakWidth === void 0) beakWidth = 0;
    if (gapSpace === void 0) gapSpace = 0;
    return $ce88cd5257e3ce57$var$_calculateActualBeakWidthInPixels(isBeakVisible ? beakWidth : 0) / 2 + gapSpace;
}
function $ce88cd5257e3ce57$var$_positionCallout(props, hostElement, callout, previousPositions, shouldScroll, minimumScrollResizeHeight, doNotFinalizeReturnEdge, win) {
    if (shouldScroll === void 0) shouldScroll = false;
    var theWin = win !== null && win !== void 0 ? win : (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    var beakWidth = props.isBeakVisible ? props.beakWidth || 0 : 0;
    var gap = $ce88cd5257e3ce57$var$_calculateGapSpace(props.isBeakVisible, props.beakWidth, props.gapSpace);
    var positionProps = props;
    positionProps.gapSpace = gap;
    var boundingRect = props.bounds ? $ce88cd5257e3ce57$var$_getRectangleFromIRect(props.bounds) : new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, theWin.innerWidth - (0, $11f97b2a9a127629$export$ace028f8da1a6300)(), 0, theWin.innerHeight);
    var positionedElement = $ce88cd5257e3ce57$var$_positionElementRelative(positionProps, callout, boundingRect, previousPositions, shouldScroll, minimumScrollResizeHeight);
    var beakPositioned = $ce88cd5257e3ce57$var$_positionBeak(beakWidth, positionedElement);
    var finalizedBeakPosition = $ce88cd5257e3ce57$var$_finalizeBeakPosition(positionedElement, beakPositioned, boundingRect);
    return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $ce88cd5257e3ce57$var$_finalizePositionData(positionedElement, hostElement, boundingRect, props.coverTarget, doNotFinalizeReturnEdge)), {
        beakPosition: finalizedBeakPosition
    });
}
function $ce88cd5257e3ce57$var$_positionCard(props, hostElement, callout, previousPositions, win) {
    var theWin = win !== null && win !== void 0 ? win : (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    return $ce88cd5257e3ce57$var$_positionCallout(props, hostElement, callout, previousPositions, false, undefined, true, theWin);
}
function $ce88cd5257e3ce57$var$_getRectangleFromTarget(target) {
    var _a, _b, _c, _d;
    var mouseTarget = target;
    var elementTarget = target;
    var rectOrPointTarget = target;
    var targetRect;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var left = (_a = rectOrPointTarget.left) !== null && _a !== void 0 ? _a : rectOrPointTarget.x;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var top = (_b = rectOrPointTarget.top) !== null && _b !== void 0 ? _b : rectOrPointTarget.y;
    var right = (_c = rectOrPointTarget.right) !== null && _c !== void 0 ? _c : left;
    var bottom = (_d = rectOrPointTarget.bottom) !== null && _d !== void 0 ? _d : top;
    // eslint-disable-next-line no-extra-boolean-cast -- may not actually be a MouseEvent
    if (!!mouseTarget.stopPropagation) targetRect = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(mouseTarget.clientX, mouseTarget.clientX, mouseTarget.clientY, mouseTarget.clientY);
    else if (left !== undefined && top !== undefined) targetRect = new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(left, right, top, bottom);
    else targetRect = $ce88cd5257e3ce57$var$_getRectangleFromElement(elementTarget);
    return targetRect;
}
var $ce88cd5257e3ce57$export$6d761371ccc85c4 = {
    _finalizePositionData: $ce88cd5257e3ce57$var$_finalizePositionData,
    _finalizeBeakPosition: $ce88cd5257e3ce57$var$_finalizeBeakPosition,
    _calculateActualBeakWidthInPixels: $ce88cd5257e3ce57$var$_calculateActualBeakWidthInPixels,
    _positionElementWithinBounds: $ce88cd5257e3ce57$var$_positionElementWithinBounds,
    _positionBeak: $ce88cd5257e3ce57$var$_positionBeak,
    _getPositionData: $ce88cd5257e3ce57$var$_getPositionData,
    _getMaxHeightFromTargetRectangle: $ce88cd5257e3ce57$var$_getMaxHeightFromTargetRectangle
};
function $ce88cd5257e3ce57$export$74054bd96b5eeef1(props, hostElement, elementToPosition, previousPositions, win) {
    return $ce88cd5257e3ce57$var$_positionElement(props, hostElement, elementToPosition, previousPositions, win);
}
function $ce88cd5257e3ce57$export$eb5e1ef38aa89e6e(props, hostElement, elementToPosition, previousPositions, shouldScroll, minimumScrollResizeHeight, win) {
    return $ce88cd5257e3ce57$var$_positionCallout(props, hostElement, elementToPosition, previousPositions, shouldScroll, minimumScrollResizeHeight, undefined, win);
}
function $ce88cd5257e3ce57$export$9c27ad88a8f823dd(props, hostElement, elementToPosition, previousPositions, win) {
    return $ce88cd5257e3ce57$var$_positionCard(props, hostElement, elementToPosition, previousPositions, win);
}
function $ce88cd5257e3ce57$export$825c16631b262763(target, targetEdge, gapSpace, bounds, coverTarget, win) {
    if (gapSpace === void 0) gapSpace = 0;
    var theWin = win !== null && win !== void 0 ? win : (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
    var targetRect = $ce88cd5257e3ce57$var$_getRectangleFromTarget(target);
    var boundingRectangle = bounds ? $ce88cd5257e3ce57$var$_getRectangleFromIRect(bounds) : new (0, $e6e58afbc62ca69b$export$4617fb02663045ef)(0, theWin.innerWidth - (0, $11f97b2a9a127629$export$ace028f8da1a6300)(), 0, theWin.innerHeight);
    return $ce88cd5257e3ce57$var$_getMaxHeightFromTargetRectangle(targetRect, targetEdge, gapSpace, boundingRectangle, coverTarget);
}
function $ce88cd5257e3ce57$export$91aad4f6c09ebbeb(edge) {
    return edge * -1;
}
function $ce88cd5257e3ce57$var$_getBoundsFromTargetWindow(target, targetWindow) {
    var segments = undefined;
    if (targetWindow.getWindowSegments) segments = targetWindow.getWindowSegments();
    // Identify if we're dealing with single screen scenarios.
    if (segments === undefined || segments.length <= 1) return {
        top: 0,
        left: 0,
        right: targetWindow.innerWidth,
        bottom: targetWindow.innerHeight,
        width: targetWindow.innerWidth,
        height: targetWindow.innerHeight
    };
    // Logic for determining dual screen scenarios.
    var x = 0;
    var y = 0;
    // If the target is an Element get coordinates for its center.
    if (target !== null && !!target.getBoundingClientRect) {
        var clientRect = target.getBoundingClientRect();
        x = (clientRect.left + clientRect.right) / 2;
        y = (clientRect.top + clientRect.bottom) / 2;
    } else if (target !== null) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        x = target.left || target.x;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        y = target.top || target.y;
    }
    var bounds = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: 0,
        height: 0
    };
    // Define which window segment are the coordinates in and calculate bounds based on that.
    for(var _i = 0, segments_1 = segments; _i < segments_1.length; _i++){
        var segment = segments_1[_i];
        if (x && segment.left <= x && segment.right >= x && y && segment.top <= y && segment.bottom >= y) bounds = {
            top: segment.top,
            left: segment.left,
            right: segment.right,
            bottom: segment.bottom,
            width: segment.width,
            height: segment.height
        };
    }
    return bounds;
}
function $ce88cd5257e3ce57$export$c09bf387c66666b4(target, targetWindow) {
    return $ce88cd5257e3ce57$var$_getBoundsFromTargetWindow(target, targetWindow);
}
function $ce88cd5257e3ce57$export$4dd180f13fe5ed70(isBeakVisible, beakWidth, gapSpace) {
    return $ce88cd5257e3ce57$var$_calculateGapSpace(isBeakVisible, beakWidth, gapSpace);
}
function $ce88cd5257e3ce57$export$9825f9c7d9c8fc16(target) {
    return $ce88cd5257e3ce57$var$_getRectangleFromTarget(target);
}





var $acw62 = parcelRequire("acw62");
/**
 * The helper functions here will make the target element as modal to screen readers, by placing aria-hidden on elements
 * that are siblings to the target element and the target element's ancestors (because aria-hidden gets inherited).
 * That way, all other elements on the page are hidden to the screen reader.
 */ 
/** Tag names to ignore when modalizing */ var $4077fee6e96f12f4$var$tagsToIgnore = [
    'TEMPLATE',
    'STYLE',
    'SCRIPT'
];
function $4077fee6e96f12f4$export$6c6b3b5a8658bfc1(target) {
    var targetDocument = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(target);
    if (!targetDocument) // can't do this in SSR
    return function() {
        return undefined;
    };
    var affectedNodes = [];
    // start at target, then recurse and do the same for parent, until we reach <body>
    while(target !== targetDocument.body && target.parentElement){
        // grab all siblings of current element
        for(var _i = 0, _a = target.parentElement.children; _i < _a.length; _i++){
            var sibling = _a[_i];
            // but ignore elements that are already aria-hidden
            var ariaHidden = sibling.getAttribute('aria-hidden');
            if (sibling !== target && (ariaHidden === null || ariaHidden === void 0 ? void 0 : ariaHidden.toLowerCase()) !== 'true' && $4077fee6e96f12f4$var$tagsToIgnore.indexOf(sibling.tagName) === -1) affectedNodes.push([
                sibling,
                ariaHidden
            ]);
        }
        target = target.parentElement;
    }
    // take all those elements and set aria-hidden=true on them
    affectedNodes.forEach(function(_a) {
        var node = _a[0];
        node.setAttribute('aria-hidden', 'true');
    });
    return function() {
        $4077fee6e96f12f4$var$unmodalize(affectedNodes);
        affectedNodes = []; // dispose
    };
}
/**
 * Undoes the changes that modalize() did.
 */ function $4077fee6e96f12f4$var$unmodalize(affectedNodes) {
    affectedNodes.forEach(function(_a) {
        var node = _a[0], originalValue = _a[1];
        // Restore the original value (false or unset)
        if (originalValue) node.setAttribute('aria-hidden', originalValue);
        else node.removeAttribute('aria-hidden');
    });
}




var $acw62 = parcelRequire("acw62");
function $d1969548e570103f$export$cdf1dc76b55502e3() {
    var asyncRef = $acw62.useRef(undefined);
    if (!asyncRef.current) asyncRef.current = new (0, $64b4350fe064431c$export$4d3c597da532240f)();
    $acw62.useEffect(function() {
        return function() {
            var _a;
            (_a = asyncRef.current) === null || _a === void 0 || _a.dispose();
            asyncRef.current = undefined;
        };
    }, []);
    return asyncRef.current;
}



var $acw62 = parcelRequire("acw62");
function $5fe1a153d9a941d2$export$2bc3860deec8a08f(element, eventName, callback, useCapture) {
    // Use a ref for the callback to prevent repeatedly attaching/unattaching callbacks that are unstable across renders
    var callbackRef = $acw62.useRef(callback);
    callbackRef.current = callback;
    $acw62.useEffect(function() {
        var actualElement = element && 'current' in element ? element.current : element;
        if (!actualElement || !actualElement.addEventListener) return;
        var dispose = (0, $18e32c5a70ef0416$export$af631764ddc44097)(actualElement, eventName, function(ev) {
            return callbackRef.current(ev);
        }, useCapture);
        return dispose;
    }, [
        element,
        eventName,
        useCapture
    ]);
}



var $acw62 = parcelRequire("acw62");
var $b139ba3b4431b53f$export$19f5fbe41bba757 = $acw62.createContext({
    // eslint-disable-next-line no-restricted-globals
    window: typeof window === 'object' ? window : undefined
});
var $b139ba3b4431b53f$export$24b8fbafc4b6a151 = function() {
    return $acw62.useContext($b139ba3b4431b53f$export$19f5fbe41bba757).window;
};
var $b139ba3b4431b53f$export$e71e2fb5c5c476d5 = function() {
    var _a;
    return (_a = $acw62.useContext($b139ba3b4431b53f$export$19f5fbe41bba757).window) === null || _a === void 0 ? void 0 : _a.document;
};
var $b139ba3b4431b53f$export$f7d306aeb1cf5fbc = function(props) {
    return $acw62.createElement($b139ba3b4431b53f$export$19f5fbe41bba757.Provider, {
        value: props
    }, props.children);
};


function $36276731e4f27f52$var$useScrollbarAsync(props, root) {
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var _a = $acw62.useState(false), needsVerticalScrollBarState = _a[0], setNeedsVerticalScrollBar = _a[1];
    $acw62.useEffect(function() {
        async.requestAnimationFrame(function() {
            var _a;
            // If overflowY is overridden, don't waste time calculating whether the scrollbar is necessary.
            if (props.style && props.style.overflowY) return;
            var needsVerticalScrollBar = false;
            if (root && root.current && ((_a = root.current) === null || _a === void 0 ? void 0 : _a.firstElementChild)) {
                // ClientHeight returns the client height of an element rounded to an
                // integer. On some browsers at different zoom levels this rounding
                // can generate different results for the root container and child even
                // though they are the same height. This causes us to show a scroll bar
                // when not needed. Ideally we would use BoundingClientRect().height
                // instead however seems that the API is 90% slower than using ClientHeight.
                // Therefore instead we will calculate the difference between heights and
                // allow for a 1px difference to still be considered ok and not show the
                // scroll bar.
                var rootHeight = root.current.clientHeight;
                var firstChildHeight = root.current.firstElementChild.clientHeight;
                if (rootHeight > 0 && firstChildHeight > rootHeight) needsVerticalScrollBar = firstChildHeight - rootHeight > 1;
            }
            if (needsVerticalScrollBarState !== needsVerticalScrollBar) setNeedsVerticalScrollBar(needsVerticalScrollBar);
        });
        return function() {
            return async.dispose();
        };
    });
    return needsVerticalScrollBarState;
}
function $36276731e4f27f52$var$defaultFocusRestorer(options) {
    var originalElement = options.originalElement, containsFocus = options.containsFocus;
    if (originalElement && containsFocus && originalElement !== (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)()) // Make sure that the focus method actually exists
    // In some cases the object might exist but not be a real element.
    // This is primarily for IE 11 and should be removed once IE 11 is no longer in use.
    // This is wrapped in a setTimeout because of a React 16 bug that is resolved in 17.
    // Once we move to 17, the setTimeout should be removed (ref: https://github.com/facebook/react/issues/17894#issuecomment-656094405)
    setTimeout(function() {
        var _a;
        (_a = originalElement.focus) === null || _a === void 0 || _a.call(originalElement);
    }, 0);
}
function $36276731e4f27f52$var$useRestoreFocus(props, root) {
    var _a = props.onRestoreFocus, onRestoreFocus = _a === void 0 ? $36276731e4f27f52$var$defaultFocusRestorer : _a;
    var originalFocusedElement = $acw62.useRef(undefined);
    var containsFocus = $acw62.useRef(false);
    $acw62.useEffect(function() {
        originalFocusedElement.current = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)().activeElement;
        if ((0, $94bdc1ebed789608$export$597abdf7826dd64a)(root.current)) containsFocus.current = true;
        return function() {
            var _a;
            onRestoreFocus === null || onRestoreFocus === void 0 || onRestoreFocus({
                originalElement: originalFocusedElement.current,
                containsFocus: containsFocus.current,
                documentContainsFocus: ((_a = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)()) === null || _a === void 0 ? void 0 : _a.hasFocus()) || false
            });
            // De-reference DOM Node to avoid retainment via transpiled closure of _onKeyDown
            originalFocusedElement.current = undefined;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on first render
    }, []);
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(root, 'focus', $acw62.useCallback(function() {
        containsFocus.current = true;
    }, []), true);
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(root, 'blur', $acw62.useCallback(function(ev) {
        /** The popup should update this._containsFocus when:
         * relatedTarget exists AND
         * the relatedTarget is not contained within the popup.
         * If the relatedTarget is within the popup, that means the popup still has focus
         * and focused moved from one element to another within the popup.
         * If relatedTarget is undefined or null that usually means that a
         * keyboard event occurred and focus didn't change
         */ if (root.current && ev.relatedTarget && !root.current.contains(ev.relatedTarget)) containsFocus.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run on first render
    }, []), true);
}
function $36276731e4f27f52$var$useHideSiblingNodes(props, root) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var shouldHideSiblings = String(props['aria-modal']).toLowerCase() === 'true' && props.enableAriaHiddenSiblings;
    $acw62.useEffect(function() {
        if (!(shouldHideSiblings && root.current)) return;
        var unmodalize = (0, $4077fee6e96f12f4$export$6c6b3b5a8658bfc1)(root.current);
        return unmodalize;
    }, [
        root,
        shouldHideSiblings
    ]);
}
var $36276731e4f27f52$export$129a32eedafa97c5 = $acw62.forwardRef(function(propsWithoutDefaults, forwardedRef) {
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)({
        shouldRestoreFocus: true,
        enableAriaHiddenSiblings: true
    }, propsWithoutDefaults);
    var root = $acw62.useRef(undefined);
    var mergedRootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(root, forwardedRef);
    $36276731e4f27f52$var$useHideSiblingNodes(props, root);
    $36276731e4f27f52$var$useRestoreFocus(props, root);
    var role = props.role, className = props.className, ariaLabel = props.ariaLabel, ariaLabelledBy = props.ariaLabelledBy, ariaDescribedBy = props.ariaDescribedBy, style = props.style, children = props.children, onDismiss = props.onDismiss;
    var needsVerticalScrollBar = $36276731e4f27f52$var$useScrollbarAsync(props, root);
    var onKeyDown = $acw62.useCallback(function(ev) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        switch(ev.which){
            case (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape:
                if (onDismiss) {
                    onDismiss(ev);
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                break;
        }
    }, [
        onDismiss
    ]);
    var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(win, 'keydown', onKeyDown);
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: mergedRootRef
    }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
        className: className,
        role: role,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        onKeyDown: onKeyDown,
        style: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            overflowY: needsVerticalScrollBar ? 'scroll' : undefined,
            outline: 'none'
        }, style)
    }), children);
});
$36276731e4f27f52$export$129a32eedafa97c5.displayName = 'Popup';





var $acw62 = parcelRequire("acw62");

function $d39eb924c3e4805b$export$7df435cf7131d47a(target, hostElement) {
    var _a, _b, _c;
    var previousTargetProp = $acw62.useRef(undefined);
    var targetRef = $acw62.useRef(null);
    /**
     * Stores an instance of Window, used to check
     * for server side rendering and if focus was lost.
     */ var targetWindow = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    // If the target element changed, find the new one. If we are tracking
    // target with class name, always find element because we do not know if
    // fabric has rendered a new element and disposed the old element.
    if (!target || target !== previousTargetProp.current || typeof target === 'string') {
        var currentElement = hostElement === null || hostElement === void 0 ? void 0 : hostElement.current;
        if (target) {
            if (typeof target === 'string') {
                // If element is part of shadow dom, then querySelector on shadow root, else query on document
                if ((_a = currentElement === null || currentElement === void 0 ? void 0 : currentElement.getRootNode()) === null || _a === void 0 ? void 0 : _a.host) targetRef.current = (_c = (_b = currentElement === null || currentElement === void 0 ? void 0 : currentElement.getRootNode()) === null || _b === void 0 ? void 0 : _b.querySelector(target)) !== null && _c !== void 0 ? _c : null;
                else {
                    var currentDoc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(currentElement);
                    targetRef.current = currentDoc ? currentDoc.querySelector(target) : null;
                }
            } else if ('stopPropagation' in target) targetRef.current = target;
            else if ('getBoundingClientRect' in target) targetRef.current = target;
            else if ('current' in target) targetRef.current = target.current;
            else targetRef.current = target;
        }
        previousTargetProp.current = target;
    }
    return [
        targetRef,
        targetWindow
    ];
}



var $2214ae3f3c5a332e$export$ad10a290a09d5141 = function() {
    var _a;
    // eslint-disable-next-line no-restricted-globals
    return (_a = (0, $b139ba3b4431b53f$export$e71e2fb5c5c476d5)()) !== null && _a !== void 0 ? _a : typeof document !== 'undefined' ? document : undefined;
};
var $2214ae3f3c5a332e$export$9dddd5610c794317 = function() {
    var _a;
    // eslint-disable-next-line no-restricted-globals
    return (_a = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)()) !== null && _a !== void 0 ? _a : typeof window !== 'undefined' ? window : undefined;
};
var $2214ae3f3c5a332e$export$c0256123a07df134 = function(ctx) {
    var _a, _b;
    // eslint-disable-next-line no-restricted-globals
    return (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.window) === null || _a === void 0 ? void 0 : _a.document) !== null && _b !== void 0 ? _b : typeof document !== 'undefined' ? document : undefined;
};
var $2214ae3f3c5a332e$export$3457832d0844a7b1 = function(ctx) {
    var _a;
    // eslint-disable-next-line no-restricted-globals
    return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.window) !== null && _a !== void 0 ? _a : typeof window !== 'undefined' ? window : undefined;
};


var $d44060969b90fc9c$var$_a;
var $d44060969b90fc9c$var$COMPONENT_NAME = 'CalloutContentBase';
var $d44060969b90fc9c$var$ANIMATIONS = ($d44060969b90fc9c$var$_a = {}, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).top] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideUpIn10, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).bottom] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideDownIn10, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).left] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideLeftIn10, $d44060969b90fc9c$var$_a[(0, $915a71a5da79ffac$export$a121ec89eaa4231a).right] = (0, $e2629e8d47c94809$export$a386448ab9904275).slideRightIn10, $d44060969b90fc9c$var$_a);
var $d44060969b90fc9c$var$BEAK_ORIGIN_POSITION = {
    top: 0,
    left: 0
};
// Microsoft Edge will overwrite inline styles if there is an animation pertaining to that style.
// To help ensure that edge will respect the offscreen style opacity
// filter needs to be added as an additional way to set opacity.
// Also set pointer-events: none so that the callout will not occlude the element it is
// going to be positioned against
var $d44060969b90fc9c$var$OFF_SCREEN_STYLE = {
    opacity: 0,
    filter: 'opacity(0)',
    pointerEvents: 'none'
};
// role and role description go hand-in-hand. Both would be included by spreading getNativeProps for a basic element
// This constant array can be used to filter these out of native props spread on callout root and apply them together on
// calloutMain (the Popup component within the callout)
var $d44060969b90fc9c$var$ARIA_ROLE_ATTRIBUTES = [
    'role',
    'aria-roledescription'
];
var $d44060969b90fc9c$var$DEFAULT_PROPS = {
    preventDismissOnLostFocus: false,
    preventDismissOnScroll: false,
    preventDismissOnResize: false,
    isBeakVisible: true,
    beakWidth: 16,
    gapSpace: 0,
    minPagePadding: 8,
    directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge
};
var $d44060969b90fc9c$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)({
    disableCaching: true
});
/**
 * (Hook) to return a function to lazily fetch the bounds of the target element for the callout.
 */ function $d44060969b90fc9c$var$useBounds(_a, targetRef, targetWindow) {
    var bounds = _a.bounds, _b = _a.minPagePadding, minPagePadding = _b === void 0 ? $d44060969b90fc9c$var$DEFAULT_PROPS.minPagePadding : _b, target = _a.target;
    var _c = $acw62.useState(false), targetWindowResized = _c[0], setTargetWindowResized = _c[1];
    var cachedBounds = $acw62.useRef(undefined);
    var getBounds = $acw62.useCallback(function() {
        if (!cachedBounds.current || targetWindowResized) {
            var currentBounds = typeof bounds === 'function' ? targetWindow ? bounds(target, targetWindow) : undefined : bounds;
            if (!currentBounds && targetWindow) {
                currentBounds = (0, $ce88cd5257e3ce57$export$c09bf387c66666b4)(targetRef.current, targetWindow);
                currentBounds = {
                    top: currentBounds.top + minPagePadding,
                    left: currentBounds.left + minPagePadding,
                    right: currentBounds.right - minPagePadding,
                    bottom: currentBounds.bottom - minPagePadding,
                    width: currentBounds.width - minPagePadding * 2,
                    height: currentBounds.height - minPagePadding * 2
                };
            }
            cachedBounds.current = currentBounds;
            targetWindowResized && setTargetWindowResized(false);
        }
        return cachedBounds.current;
    }, [
        bounds,
        minPagePadding,
        target,
        targetRef,
        targetWindow,
        targetWindowResized
    ]);
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(targetWindow, 'resize', async.debounce(function() {
        setTargetWindowResized(true);
    }, 500, {
        leading: true
    }));
    return getBounds;
}
/**
 * (Hook) to return the maximum available height for the Callout to render into.
 */ function $d44060969b90fc9c$var$useMaxHeight(_a, getBounds, targetRef, positions) {
    var _b;
    var calloutMaxHeight = _a.calloutMaxHeight, finalHeight = _a.finalHeight, directionalHint = _a.directionalHint, directionalHintFixed = _a.directionalHintFixed, hidden = _a.hidden, gapSpace = _a.gapSpace, beakWidth = _a.beakWidth, isBeakVisible = _a.isBeakVisible, coverTarget = _a.coverTarget;
    var _c = $acw62.useState(), maxHeight = _c[0], setMaxHeight = _c[1];
    var _d = (_b = positions === null || positions === void 0 ? void 0 : positions.elementPosition) !== null && _b !== void 0 ? _b : {}, top = _d.top, bottom = _d.bottom;
    var targetRect = (targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) ? (0, $ce88cd5257e3ce57$export$9825f9c7d9c8fc16)(targetRef.current) : undefined;
    $acw62.useEffect(function() {
        var _a;
        var bounds = (_a = getBounds()) !== null && _a !== void 0 ? _a : {};
        var topBounds = bounds.top;
        var bottomBounds = bounds.bottom;
        var calculatedHeight;
        // If aligned to top edge of target and not covering target, update bottom bounds to the
        // top of the target (accounting for gap space and beak)
        if ((positions === null || positions === void 0 ? void 0 : positions.targetEdge) === (0, $915a71a5da79ffac$export$a121ec89eaa4231a).top && (targetRect === null || targetRect === void 0 ? void 0 : targetRect.top) && !coverTarget) bottomBounds = targetRect.top - (0, $ce88cd5257e3ce57$export$4dd180f13fe5ed70)(isBeakVisible, beakWidth, gapSpace);
        if (typeof top === 'number' && bottomBounds) calculatedHeight = bottomBounds - top;
        else if (typeof bottom === 'number' && typeof topBounds === 'number' && bottomBounds) calculatedHeight = bottomBounds - topBounds - bottom;
        if (!calloutMaxHeight && !hidden || calloutMaxHeight && calculatedHeight && calloutMaxHeight > calculatedHeight) setMaxHeight(calculatedHeight);
        else if (calloutMaxHeight) setMaxHeight(calloutMaxHeight);
        else setMaxHeight(undefined);
    }, [
        bottom,
        calloutMaxHeight,
        finalHeight,
        directionalHint,
        directionalHintFixed,
        getBounds,
        hidden,
        positions,
        top,
        gapSpace,
        beakWidth,
        isBeakVisible,
        targetRect,
        coverTarget
    ]);
    return maxHeight;
}
/**
 * (Hook) to find the current position of Callout. If Callout is resized then a new position is calculated.
 */ function $d44060969b90fc9c$var$usePositions(props, hostElement, calloutElement, targetRef, getBounds, popupRef) {
    var _a = $acw62.useState(), positions = _a[0], setPositions = _a[1];
    var positionAttempts = $acw62.useRef(0);
    var previousTarget = $acw62.useRef(undefined);
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var hidden = props.hidden, target = props.target, finalHeight = props.finalHeight, calloutMaxHeight = props.calloutMaxHeight, onPositioned = props.onPositioned, directionalHint = props.directionalHint, hideOverflow = props.hideOverflow, preferScrollResizePositioning = props.preferScrollResizePositioning;
    var win = (0, $2214ae3f3c5a332e$export$9dddd5610c794317)();
    var localRef = $acw62.useRef(undefined);
    var popupStyles;
    if (localRef.current !== popupRef.current) {
        localRef.current = popupRef.current;
        popupStyles = popupRef.current ? win === null || win === void 0 ? void 0 : win.getComputedStyle(popupRef.current) : undefined;
    }
    var popupOverflowY = popupStyles === null || popupStyles === void 0 ? void 0 : popupStyles.overflowY;
    $acw62.useEffect(function() {
        if (!hidden) {
            var timerId_1 = async.requestAnimationFrame(function() {
                var _a, _b;
                if (hostElement.current && calloutElement) {
                    var currentProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props), {
                        target: targetRef.current,
                        bounds: getBounds()
                    });
                    // duplicate calloutElement & remove useMaxHeight's maxHeight for position calc
                    var dupeCalloutElement = calloutElement.cloneNode(true);
                    dupeCalloutElement.style.maxHeight = calloutMaxHeight ? "".concat(calloutMaxHeight) : '';
                    dupeCalloutElement.style.visibility = 'hidden';
                    (_a = calloutElement.parentElement) === null || _a === void 0 || _a.appendChild(dupeCalloutElement);
                    var previousPositions = previousTarget.current === target ? positions : undefined;
                    // only account for scroll resizing if styles allow callout to scroll
                    // (popup styles determine if callout will scroll)
                    var isOverflowYHidden = hideOverflow || popupOverflowY === 'clip' || popupOverflowY === 'hidden';
                    var shouldScroll = preferScrollResizePositioning && !isOverflowYHidden;
                    // If there is a finalHeight given then we assume that the user knows and will handle
                    // additional positioning adjustments so we should call positionCard
                    var newPositions = finalHeight ? (0, $ce88cd5257e3ce57$export$9c27ad88a8f823dd)(currentProps, hostElement.current, dupeCalloutElement, previousPositions, win) : (0, $ce88cd5257e3ce57$export$eb5e1ef38aa89e6e)(currentProps, hostElement.current, dupeCalloutElement, previousPositions, shouldScroll, undefined, win);
                    // clean up duplicate calloutElement
                    (_b = calloutElement.parentElement) === null || _b === void 0 || _b.removeChild(dupeCalloutElement);
                    // Set the new position only when the positions do not exist or one of the new callout positions
                    // is different. The position should not change if the position is within 2 decimal places.
                    if (!positions && newPositions || positions && newPositions && !$d44060969b90fc9c$var$arePositionsEqual(positions, newPositions) && positionAttempts.current < 5) {
                        // We should not reposition the callout more than a few times, if it is then the content is likely resizing
                        // and we should stop trying to reposition to prevent a stack overflow.
                        positionAttempts.current++;
                        setPositions(newPositions);
                    } else if (positionAttempts.current > 0) {
                        // Only call the onPositioned callback if the callout has been re-positioned at least once.
                        positionAttempts.current = 0;
                        onPositioned === null || onPositioned === void 0 || onPositioned(positions);
                    }
                }
            }, calloutElement);
            previousTarget.current = target;
            return function() {
                async.cancelAnimationFrame(timerId_1);
                previousTarget.current = undefined;
            };
        } else {
            // When the callout is hidden, clear position state so that it is not accidentally used next render.
            setPositions(undefined);
            positionAttempts.current = 0;
        }
    }, [
        hidden,
        directionalHint,
        async,
        calloutElement,
        calloutMaxHeight,
        hostElement,
        targetRef,
        finalHeight,
        getBounds,
        onPositioned,
        positions,
        props,
        target,
        hideOverflow,
        preferScrollResizePositioning,
        popupOverflowY,
        win
    ]);
    return positions;
}
/**
 * (Hook) to set up behavior to automatically focus the callout when it appears, if indicated by props.
 */ function $d44060969b90fc9c$var$useAutoFocus(_a, positions, calloutElement) {
    var hidden = _a.hidden, setInitialFocus = _a.setInitialFocus;
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var hasPositions = !!positions;
    $acw62.useEffect(function() {
        if (!hidden && setInitialFocus && hasPositions && calloutElement) {
            var timerId_2 = async.requestAnimationFrame(function() {
                return (0, $94bdc1ebed789608$export$8765806c2c274519)(calloutElement);
            }, calloutElement);
            return function() {
                return async.cancelAnimationFrame(timerId_2);
            };
        }
    }, [
        hidden,
        hasPositions,
        async,
        calloutElement,
        setInitialFocus
    ]);
}
/**
 * (Hook) to set up various handlers to dismiss the popup when it loses focus or the window scrolls or similar cases.
 */ function $d44060969b90fc9c$var$useDismissHandlers(_a, positions, hostElement, targetRef, targetWindow) {
    var hidden = _a.hidden, onDismiss = _a.onDismiss, preventDismissOnScroll = _a.preventDismissOnScroll, preventDismissOnResize = _a.preventDismissOnResize, preventDismissOnLostFocus = _a.preventDismissOnLostFocus, dismissOnTargetClick = _a.dismissOnTargetClick, shouldDismissOnWindowFocus = _a.shouldDismissOnWindowFocus, preventDismissOnEvent = _a.preventDismissOnEvent;
    var isMouseDownOnPopup = $acw62.useRef(false);
    var async = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var mouseDownHandlers = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)([
        function() {
            isMouseDownOnPopup.current = true;
        },
        function() {
            isMouseDownOnPopup.current = false;
        }
    ]);
    var positionsExists = !!positions;
    $acw62.useEffect(function() {
        var dismissOnScroll = function(ev) {
            if (positionsExists && !preventDismissOnScroll) dismissOnClickOrScroll(ev);
        };
        var dismissOnResize = function(ev) {
            if (!preventDismissOnResize && !(preventDismissOnEvent && preventDismissOnEvent(ev))) onDismiss === null || onDismiss === void 0 || onDismiss(ev);
        };
        var dismissOnLostFocus = function(ev) {
            if (!preventDismissOnLostFocus) dismissOnClickOrScroll(ev);
        };
        var dismissOnClickOrScroll = function(ev) {
            var eventPaths = ev.composedPath ? ev.composedPath() : [];
            var target = eventPaths.length > 0 ? eventPaths[0] : ev.target;
            var isEventTargetOutsideCallout = hostElement.current && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(hostElement.current, target);
            // If mouse is pressed down on callout but moved outside then released, don't dismiss the callout.
            if (isEventTargetOutsideCallout && isMouseDownOnPopup.current) {
                isMouseDownOnPopup.current = false;
                return;
            }
            if (!targetRef.current && isEventTargetOutsideCallout || ev.target !== targetWindow && isEventTargetOutsideCallout && (!targetRef.current || 'stopPropagation' in targetRef.current || dismissOnTargetClick || target !== targetRef.current && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(targetRef.current, target))) {
                if (preventDismissOnEvent && preventDismissOnEvent(ev)) return;
                onDismiss === null || onDismiss === void 0 || onDismiss(ev);
            }
        };
        var dismissOnTargetWindowBlur = function(ev) {
            // Do nothing
            if (!shouldDismissOnWindowFocus) return;
            if ((preventDismissOnEvent && !preventDismissOnEvent(ev) || !preventDismissOnEvent && !preventDismissOnLostFocus) && !(targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.hasFocus()) && ev.relatedTarget === null) onDismiss === null || onDismiss === void 0 || onDismiss(ev);
        };
        // This is added so the callout will dismiss when the window is scrolled
        // but not when something inside the callout is scrolled. The delay seems
        // to be required to avoid React firing an async focus event in IE from
        // the target changing focus quickly prior to rendering the callout.
        var disposablesPromise = new Promise(function(resolve) {
            async.setTimeout(function() {
                if (!hidden && targetWindow) {
                    var disposables_1 = [
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow, 'scroll', dismissOnScroll, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow, 'resize', dismissOnResize, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow.document.documentElement, 'focus', dismissOnLostFocus, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow.document.documentElement, 'click', dismissOnLostFocus, true),
                        (0, $18e32c5a70ef0416$export$af631764ddc44097)(targetWindow, 'blur', dismissOnTargetWindowBlur, true)
                    ];
                    resolve(function() {
                        disposables_1.forEach(function(dispose) {
                            return dispose();
                        });
                    });
                }
            }, 0);
        });
        return function() {
            disposablesPromise.then(function(dispose) {
                return dispose();
            });
        };
    }, [
        hidden,
        async,
        hostElement,
        targetRef,
        targetWindow,
        onDismiss,
        shouldDismissOnWindowFocus,
        dismissOnTargetClick,
        preventDismissOnLostFocus,
        preventDismissOnResize,
        preventDismissOnScroll,
        positionsExists,
        preventDismissOnEvent
    ]);
    return mouseDownHandlers;
}
var $d44060969b90fc9c$export$9691c2c04b66dd88 = $acw62.memo($acw62.forwardRef(function(propsWithoutDefaults, forwardedRef) {
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($d44060969b90fc9c$var$DEFAULT_PROPS, propsWithoutDefaults);
    var styles = props.styles, style = props.style, ariaLabel = props.ariaLabel, ariaDescribedBy = props.ariaDescribedBy, ariaLabelledBy = props.ariaLabelledBy, className = props.className, isBeakVisible = props.isBeakVisible, children = props.children, beakWidth = props.beakWidth, calloutWidth = props.calloutWidth, calloutMaxWidth = props.calloutMaxWidth, calloutMinWidth = props.calloutMinWidth, doNotLayer = props.doNotLayer, finalHeight = props.finalHeight, _a = props.hideOverflow, hideOverflow = _a === void 0 ? !!finalHeight : _a, backgroundColor = props.backgroundColor, calloutMaxHeight = props.calloutMaxHeight, onScroll = props.onScroll, // eslint-disable-next-line @typescript-eslint/no-deprecated
    _b = props.shouldRestoreFocus, // eslint-disable-next-line @typescript-eslint/no-deprecated
    shouldRestoreFocus = _b === void 0 ? true : _b, target = props.target, hidden = props.hidden, onLayerMounted = props.onLayerMounted, popupProps = props.popupProps;
    var hostElement = $acw62.useRef(null);
    var popupRef = $acw62.useRef(null);
    var mergedPopupRefs = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(popupRef, popupProps === null || popupProps === void 0 ? void 0 : popupProps.ref);
    var _c = $acw62.useState(null), calloutElement = _c[0], setCalloutElement = _c[1];
    var calloutCallback = $acw62.useCallback(function(calloutEl) {
        setCalloutElement(calloutEl);
    }, []);
    var rootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(hostElement, forwardedRef);
    var _d = (0, $d39eb924c3e4805b$export$7df435cf7131d47a)(props.target, {
        current: calloutElement
    }), targetRef = _d[0], targetWindow = _d[1];
    var getBounds = $d44060969b90fc9c$var$useBounds(props, targetRef, targetWindow);
    var positions = $d44060969b90fc9c$var$usePositions(props, hostElement, calloutElement, targetRef, getBounds, mergedPopupRefs);
    var maxHeight = $d44060969b90fc9c$var$useMaxHeight(props, getBounds, targetRef, positions);
    var _e = $d44060969b90fc9c$var$useDismissHandlers(props, positions, hostElement, targetRef, targetWindow), mouseDownOnPopup = _e[0], mouseUpOnPopup = _e[1];
    // do not set both top and bottom css props from positions
    // instead, use maxHeight
    var isForcedInBounds = (positions === null || positions === void 0 ? void 0 : positions.elementPosition.top) && (positions === null || positions === void 0 ? void 0 : positions.elementPosition.bottom);
    var cssPositions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, positions === null || positions === void 0 ? void 0 : positions.elementPosition), {
        maxHeight: maxHeight
    });
    if (isForcedInBounds) cssPositions.bottom = undefined;
    $d44060969b90fc9c$var$useAutoFocus(props, positions, calloutElement);
    $acw62.useEffect(function() {
        if (!hidden) onLayerMounted === null || onLayerMounted === void 0 || onLayerMounted();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run if hidden changes
    }, [
        hidden
    ]);
    // If there is no target window then we are likely in server side rendering and we should not render anything.
    if (!targetWindow) return null;
    var overflowYHidden = hideOverflow;
    var beakVisible = isBeakVisible && !!target;
    var classNames = $d44060969b90fc9c$var$getClassNames(styles, {
        theme: props.theme,
        className: className,
        overflowYHidden: overflowYHidden,
        calloutWidth: calloutWidth,
        positions: positions,
        beakWidth: beakWidth,
        backgroundColor: backgroundColor,
        calloutMaxWidth: calloutMaxWidth,
        calloutMinWidth: calloutMinWidth,
        doNotLayer: doNotLayer
    });
    var overflowStyle = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        maxHeight: calloutMaxHeight ? calloutMaxHeight : '100%'
    }, style), overflowYHidden && {
        overflowY: 'hidden'
    });
    var visibilityStyle = props.hidden ? {
        visibility: 'hidden'
    } : undefined;
    // React.CSSProperties does not understand IRawStyle, so the inline animations will need to be cast as any for now.
    return $acw62.createElement("div", {
        ref: rootRef,
        className: classNames.container,
        style: visibilityStyle
    }, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), $d44060969b90fc9c$var$ARIA_ROLE_ATTRIBUTES), {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, positions && positions.targetEdge && $d44060969b90fc9c$var$ANIMATIONS[positions.targetEdge]),
        style: positions ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, cssPositions) : $d44060969b90fc9c$var$OFF_SCREEN_STYLE,
        // Safari and Firefox on Mac OS requires this to back-stop click events so focus remains in the Callout.
        // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus
        tabIndex: -1,
        ref: calloutCallback
    }), beakVisible && $acw62.createElement("div", {
        className: classNames.beak,
        style: $d44060969b90fc9c$var$getBeakPosition(positions)
    }), beakVisible && $acw62.createElement("div", {
        className: classNames.beakCurtain
    }), $acw62.createElement((0, $36276731e4f27f52$export$129a32eedafa97c5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        // don't use getNativeElementProps for role and roledescription because it will also
        // pass through data-* props (resulting in them being used in two places)
        role: props.role,
        "aria-roledescription": props['aria-roledescription'],
        ariaDescribedBy: ariaDescribedBy,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        className: classNames.calloutMain,
        onDismiss: props.onDismiss,
        onMouseDown: mouseDownOnPopup,
        onMouseUp: mouseUpOnPopup,
        onRestoreFocus: props.onRestoreFocus,
        onScroll: onScroll,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        shouldRestoreFocus: shouldRestoreFocus,
        style: overflowStyle
    }, popupProps, {
        ref: mergedPopupRefs
    }), children)));
}), function(previousProps, nextProps) {
    if (!nextProps.shouldUpdateWhenHidden && previousProps.hidden && nextProps.hidden) // Do not update when hidden.
    return true;
    return (0, $f504d2279336999d$export$90e866afbd6b9f1a)(previousProps, nextProps);
});
/**
 * (Utility) to find and return the current `Callout` Beak position.
 *
 * @param positions
 */ function $d44060969b90fc9c$var$getBeakPosition(positions) {
    var _a, _b;
    var beakPositionStyle = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (_a = positions === null || positions === void 0 ? void 0 : positions.beakPosition) === null || _a === void 0 ? void 0 : _a.elementPosition), {
        display: ((_b = positions === null || positions === void 0 ? void 0 : positions.beakPosition) === null || _b === void 0 ? void 0 : _b.hideBeak) ? 'none' : undefined
    });
    if (!beakPositionStyle.top && !beakPositionStyle.bottom && !beakPositionStyle.left && !beakPositionStyle.right) {
        beakPositionStyle.left = $d44060969b90fc9c$var$BEAK_ORIGIN_POSITION.left;
        beakPositionStyle.top = $d44060969b90fc9c$var$BEAK_ORIGIN_POSITION.top;
    }
    return beakPositionStyle;
}
/**
 * (Utility) used to compare two different elementPositions to determine whether they are equal.
 *
 * @param prevElementPositions
 * @param newElementPosition
 */ function $d44060969b90fc9c$var$arePositionsEqual(prevElementPositions, newElementPosition) {
    return $d44060969b90fc9c$var$comparePositions(prevElementPositions.elementPosition, newElementPosition.elementPosition) && $d44060969b90fc9c$var$comparePositions(prevElementPositions.beakPosition.elementPosition, newElementPosition.beakPosition.elementPosition);
}
/**
 * (Utility) used in **arePositionsEqual** to compare two different elementPositions.
 *
 * @param prevElementPositions
 * @param newElementPositions
 */ function $d44060969b90fc9c$var$comparePositions(prevElementPositions, newElementPositions) {
    for(var key in newElementPositions)if (newElementPositions.hasOwnProperty(key)) {
        var oldPositionEdge = prevElementPositions[key];
        var newPositionEdge = newElementPositions[key];
        if (oldPositionEdge !== undefined && newPositionEdge !== undefined) {
            if (oldPositionEdge.toFixed(2) !== newPositionEdge.toFixed(2)) return false;
        } else return false;
    }
    return true;
}
$d44060969b90fc9c$export$9691c2c04b66dd88.displayName = $d44060969b90fc9c$var$COMPONENT_NAME;



function $beecb0dab32bf6f3$var$getBeakStyle(beakWidth) {
    return {
        height: beakWidth,
        width: beakWidth
    };
}
var $beecb0dab32bf6f3$var$GlobalClassNames = {
    container: 'ms-Callout-container',
    root: 'ms-Callout',
    beak: 'ms-Callout-beak',
    beakCurtain: 'ms-Callout-beakCurtain',
    calloutMain: 'ms-Callout-main'
};
var $beecb0dab32bf6f3$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var theme = props.theme, className = props.className, overflowYHidden = props.overflowYHidden, calloutWidth = props.calloutWidth, beakWidth = props.beakWidth, backgroundColor = props.backgroundColor, calloutMaxWidth = props.calloutMaxWidth, calloutMinWidth = props.calloutMinWidth, doNotLayer = props.doNotLayer;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($beecb0dab32bf6f3$var$GlobalClassNames, theme);
    var semanticColors = theme.semanticColors, effects = theme.effects;
    return {
        container: [
            classNames.container,
            {
                position: 'relative'
            }
        ],
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                position: 'absolute',
                display: 'flex',
                zIndex: doNotLayer ? (0, $e718b14ff8496161$export$ee30d3e11c8625f1).Layer : undefined,
                boxSizing: 'border-box',
                borderRadius: effects.roundedCorner2,
                boxShadow: effects.elevation16,
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: 'WindowText'
                }, _a)
            },
            (0, $3c8eab4e1d179dea$export$47933a1040be8871)(),
            className,
            !!calloutWidth && {
                width: calloutWidth
            },
            !!calloutMaxWidth && {
                maxWidth: calloutMaxWidth
            },
            !!calloutMinWidth && {
                minWidth: calloutMinWidth
            }
        ],
        beak: [
            classNames.beak,
            {
                position: 'absolute',
                backgroundColor: semanticColors.menuBackground,
                boxShadow: 'inherit',
                border: 'inherit',
                boxSizing: 'border-box',
                transform: 'rotate(45deg)'
            },
            $beecb0dab32bf6f3$var$getBeakStyle(beakWidth),
            backgroundColor && {
                backgroundColor: backgroundColor
            }
        ],
        beakCurtain: [
            classNames.beakCurtain,
            {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: semanticColors.menuBackground,
                borderRadius: effects.roundedCorner2
            }
        ],
        calloutMain: [
            classNames.calloutMain,
            {
                backgroundColor: semanticColors.menuBackground,
                overflowX: 'hidden',
                overflowY: 'auto',
                position: 'relative',
                width: '100%',
                borderRadius: effects.roundedCorner2
            },
            overflowYHidden && {
                overflowY: 'hidden'
            },
            backgroundColor && {
                backgroundColor: backgroundColor
            }
        ]
    };
};


var $57cf9e0ffad9e5e0$export$f6122ee2215f6f10 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $d44060969b90fc9c$export$9691c2c04b66dd88), (0, $beecb0dab32bf6f3$export$ffd58b7f6f099a57), undefined, {
    scope: 'CalloutContent'
});





var $acw62 = parcelRequire("acw62");
'use client';
var $a6dcfff088e996dd$var$PortalCompatContext = $acw62.createContext(undefined);
var $a6dcfff088e996dd$var$portalCompatContextDefaultValue = function() {
    return function() {
        return undefined;
    };
};
var $a6dcfff088e996dd$export$1abd643230d66e44 = $a6dcfff088e996dd$var$PortalCompatContext.Provider;
function $a6dcfff088e996dd$export$712a597a27357a15() {
    var _React_useContext;
    return (_React_useContext = $acw62.useContext($a6dcfff088e996dd$var$PortalCompatContext)) !== null && _React_useContext !== void 0 ? _React_useContext : $a6dcfff088e996dd$var$portalCompatContextDefaultValue;
}



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



function $e3f86a9c88cde7ae$export$953b8844777cd492(oldSettings, newSettings) {
    if (oldSettings === void 0) oldSettings = {};
    var mergeSettingsWith = $e3f86a9c88cde7ae$var$_isSettingsFunction(newSettings) ? newSettings : $e3f86a9c88cde7ae$var$_settingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function $e3f86a9c88cde7ae$export$23927a6086b44fac(oldSettings, newSettings) {
    if (oldSettings === void 0) oldSettings = {};
    var mergeSettingsWith = $e3f86a9c88cde7ae$var$_isSettingsFunction(newSettings) ? newSettings : $e3f86a9c88cde7ae$var$_scopedSettingsMergeWith(newSettings);
    return mergeSettingsWith(oldSettings);
}
function $e3f86a9c88cde7ae$var$_isSettingsFunction(settings) {
    return typeof settings === 'function';
}
function $e3f86a9c88cde7ae$var$_settingsMergeWith(newSettings) {
    return function(settings) {
        return newSettings ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, settings), newSettings) : settings;
    };
}
function $e3f86a9c88cde7ae$var$_scopedSettingsMergeWith(scopedSettingsFromProps) {
    if (scopedSettingsFromProps === void 0) scopedSettingsFromProps = {};
    return function(oldScopedSettings) {
        var newScopedSettings = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, oldScopedSettings);
        for(var scopeName in scopedSettingsFromProps)if (scopedSettingsFromProps.hasOwnProperty(scopeName)) newScopedSettings[scopeName] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, oldScopedSettings[scopeName]), scopedSettingsFromProps[scopeName]);
        return newScopedSettings;
    };
}


function $5c83a7f0b5d7529f$export$710b302555b5c18c(props, parentContext) {
    var _a = (parentContext || {}).customizations, customizations = _a === void 0 ? {
        settings: {},
        scopedSettings: {}
    } : _a;
    return {
        customizations: {
            settings: (0, $e3f86a9c88cde7ae$export$953b8844777cd492)(customizations.settings, props.settings),
            scopedSettings: (0, $e3f86a9c88cde7ae$export$23927a6086b44fac)(customizations.scopedSettings, props.scopedSettings),
            inCustomizerContext: true
        }
    };
}


/**
 * The Customizer component allows for default props to be mixed into components which
 * are decorated with the customizable() decorator, or use the styled HOC. This enables
 * injection scenarios like:
 *
 * 1. render svg icons instead of the icon font within all buttons
 * 2. inject a custom theme object into a component
 *
 * Props are provided via the settings prop which should be one of the following:
 * - A json map which contains 1 or more name/value pairs representing injectable props.
 * - A function that receives the current settings and returns the new ones that apply to the scope
 *
 * @public
 *
 * @deprecated This component is deprecated for purpose of applying theme to components
 * as of `@fluentui/react` version 8. Use `ThemeProvider` for applying theme instead.
 */ var $9997c9cf02ee2446$export$84d28c22644f2e3a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Customizer, _super);
    function Customizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onCustomizationChange = function() {
            return _this.forceUpdate();
        };
        return _this;
    }
    Customizer.prototype.componentDidMount = function() {
        (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).observe(this._onCustomizationChange);
    };
    Customizer.prototype.componentWillUnmount = function() {
        (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).unobserve(this._onCustomizationChange);
    };
    Customizer.prototype.render = function() {
        var _this = this;
        var contextTransform = this.props.contextTransform;
        return $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Consumer, null, function(parentContext) {
            var newContext = (0, $5c83a7f0b5d7529f$export$710b302555b5c18c)(_this.props, parentContext);
            if (contextTransform) newContext = contextTransform(newContext);
            return $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Provider, {
                value: newContext
            }, _this.props.children);
        });
    };
    return Customizer;
}($acw62.Component);


var $acw62 = parcelRequire("acw62");

var $0a0122a1daf8e02f$export$7f9071f49e01dae9 = function(props) {
    var providerRef = props.providerRef, layerRoot = props.layerRoot;
    var registeredProviders = $acw62.useState([])[0];
    var parentContext = $acw62.useContext((0, $872a30e3c6519016$export$683969f4bf72ffbd));
    // Inherit the parent context if it exists, unless this is a layer root.
    // This allows the topmost provider element in the DOM tree to handle the focus events.
    // Since layers are in a separate HTML tree from their parent, they shouldn't use the parent's providerRef.
    var inheritParentContext = parentContext !== undefined && !layerRoot;
    var context = $acw62.useMemo(function() {
        return inheritParentContext ? undefined : {
            providerRef: providerRef,
            registeredProviders: registeredProviders,
            registerProvider: function(ref) {
                // Register this child provider with the current context, and any parent contexts
                registeredProviders.push(ref);
                parentContext === null || parentContext === void 0 || parentContext.registerProvider(ref);
            },
            unregisterProvider: function(ref) {
                parentContext === null || parentContext === void 0 || parentContext.unregisterProvider(ref);
                var i = registeredProviders.indexOf(ref);
                if (i >= 0) registeredProviders.splice(i, 1);
            }
        };
    }, [
        providerRef,
        registeredProviders,
        parentContext,
        inheritParentContext
    ]);
    $acw62.useEffect(function() {
        if (context) {
            context.registerProvider(context.providerRef);
            return function() {
                return context.unregisterProvider(context.providerRef);
            };
        }
    }, [
        context
    ]);
    // Create a new context provider if this is not inheriting from the parent.
    if (context) return $acw62.createElement((0, $872a30e3c6519016$export$683969f4bf72ffbd).Provider, {
        value: context
    }, props.children);
    else return $acw62.createElement($acw62.Fragment, null, props.children);
};




var $f889493d4b981ec5$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $f889493d4b981ec5$var$getFabricTheme = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, isRTL) {
    return (0, $49b644eef671596b$export$25d302a5b900a763)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, theme), {
        rtl: isRTL
    }));
});
var $f889493d4b981ec5$var$getDir = function(_a) {
    var theme = _a.theme, dir = _a.dir;
    var contextDir = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? 'rtl' : 'ltr';
    var pageDir = (0, $723d0744d8fe4fde$export$b2303637e9533380)() ? 'rtl' : 'ltr';
    var componentDir = dir ? dir : contextDir;
    return {
        // If Fabric dir !== contextDir
        // Or If contextDir !== pageDir
        // Then we need to set dir of the Fabric root
        rootDir: componentDir !== contextDir || componentDir !== pageDir ? componentDir : dir,
        // If dir !== contextDir || pageDir
        // then set contextual theme around content
        needsTheme: componentDir !== contextDir
    };
};
var $f889493d4b981ec5$export$e4aae1774125dd2f = $acw62.forwardRef(function(props, ref) {
    var className = props.className, theme = props.theme, applyTheme = props.applyTheme, applyThemeToBody = props.applyThemeToBody, styles = props.styles;
    var classNames = $f889493d4b981ec5$var$getClassNames(styles, {
        theme: theme,
        applyTheme: applyTheme,
        className: className
    });
    var rootElement = $acw62.useRef(null);
    $f889493d4b981ec5$var$useApplyThemeToBody(applyThemeToBody, classNames, rootElement);
    return $acw62.createElement($acw62.Fragment, null, $f889493d4b981ec5$var$useRenderedContent(props, classNames, rootElement, ref));
});
$f889493d4b981ec5$export$e4aae1774125dd2f.displayName = 'FabricBase';
function $f889493d4b981ec5$var$useRenderedContent(props, _a, rootElement, ref) {
    var root = _a.root;
    var _b = props.as, Root = _b === void 0 ? 'div' : _b, dir = props.dir, theme = props.theme;
    var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
        'dir'
    ]);
    var _c = $f889493d4b981ec5$var$getDir(props), rootDir = _c.rootDir, needsTheme = _c.needsTheme;
    var renderedContent = $acw62.createElement((0, $0a0122a1daf8e02f$export$7f9071f49e01dae9), {
        providerRef: rootElement
    }, $acw62.createElement(Root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        dir: rootDir
    }, divProps, {
        className: root,
        ref: (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootElement, ref)
    })));
    // Create the contextual theme if component direction does not match parent direction.
    if (needsTheme) // Disabling ThemeProvider here because theme doesn't need to be re-provided by ThemeProvider if dir has changed.
    renderedContent = // eslint-disable-next-line @typescript-eslint/no-deprecated
    $acw62.createElement((0, $9997c9cf02ee2446$export$84d28c22644f2e3a), {
        settings: {
            theme: $f889493d4b981ec5$var$getFabricTheme(theme, dir === 'rtl')
        }
    }, renderedContent);
    return renderedContent;
}
function $f889493d4b981ec5$var$useApplyThemeToBody(applyThemeToBody, _a, rootElement) {
    var bodyThemed = _a.bodyThemed;
    $acw62.useEffect(function() {
        if (applyThemeToBody) {
            var currentDoc_1 = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(rootElement.current);
            if (currentDoc_1) {
                currentDoc_1.body.classList.add(bodyThemed);
                return function() {
                    currentDoc_1.body.classList.remove(bodyThemed);
                };
            }
        }
    }, [
        bodyThemed,
        applyThemeToBody,
        rootElement
    ]);
    return rootElement;
}



var $578e9deb1e5673a4$var$inheritFont = {
    fontFamily: 'inherit'
};
var $578e9deb1e5673a4$var$GlobalClassNames = {
    root: 'ms-Fabric',
    bodyThemed: 'ms-Fabric-bodyThemed'
};
var $578e9deb1e5673a4$export$ffd58b7f6f099a57 = function(props) {
    var applyTheme = props.applyTheme, className = props.className, preventBlanketFontInheritance = props.preventBlanketFontInheritance, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($578e9deb1e5673a4$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                color: theme.palette.neutralPrimary
            },
            !preventBlanketFontInheritance && {
                '& button': $578e9deb1e5673a4$var$inheritFont,
                '& input': $578e9deb1e5673a4$var$inheritFont,
                '& textarea': $578e9deb1e5673a4$var$inheritFont
            },
            // apply theme to only if applyTheme is true
            applyTheme && {
                color: theme.semanticColors.bodyText,
                backgroundColor: theme.semanticColors.bodyBackground
            },
            className
        ],
        bodyThemed: [
            {
                backgroundColor: theme.semanticColors.bodyBackground
            }
        ]
    };
};


var $be4e78d7f9eccc5a$export$9c88c10c19390bf2 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $f889493d4b981ec5$export$e4aae1774125dd2f), (0, $578e9deb1e5673a4$export$ffd58b7f6f099a57), undefined, {
    scope: 'Fabric'
});


/**
 * Sets the virtual parent of an element.
 * Pass `undefined` as the `parent` to clear the virtual parent.
 *
 * @public
 */ function $e2a8102ee715fdfe$export$9bba5276a9c4d47(child, parent) {
    var virtualChild = child;
    var virtualParent = parent;
    if (!virtualChild._virtual) virtualChild._virtual = {
        children: []
    };
    var oldParent = virtualChild._virtual.parent;
    if (oldParent && oldParent !== parent) {
        // Remove the child from its old parent.
        var index = oldParent._virtual.children.indexOf(virtualChild);
        if (index > -1) oldParent._virtual.children.splice(index, 1);
    }
    virtualChild._virtual.parent = virtualParent || undefined;
    if (virtualParent) {
        if (!virtualParent._virtual) virtualParent._virtual = {
            children: []
        };
        virtualParent._virtual.children.push(virtualChild);
    }
}


var $7dfac6b046c9f384$var$_layersByHostId = {};
var $7dfac6b046c9f384$var$_layerHostsById = {};
var $7dfac6b046c9f384$var$defaultHostId = 'fluent-default-layer-host';
var $7dfac6b046c9f384$var$_defaultHostSelector = "#".concat($7dfac6b046c9f384$var$defaultHostId);
function $7dfac6b046c9f384$export$1229b260902b7551(hostId, callback) {
    if (!$7dfac6b046c9f384$var$_layersByHostId[hostId]) $7dfac6b046c9f384$var$_layersByHostId[hostId] = [];
    $7dfac6b046c9f384$var$_layersByHostId[hostId].push(callback);
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    if (layerHosts) for(var _i = 0, layerHosts_1 = layerHosts; _i < layerHosts_1.length; _i++){
        var layerHost = layerHosts_1[_i];
        layerHost.notifyLayersChanged();
    }
}
function $7dfac6b046c9f384$export$99742cfcbbb7d974(hostId, callback) {
    var layers = $7dfac6b046c9f384$var$_layersByHostId[hostId];
    if (layers) {
        var idx = layers.indexOf(callback);
        if (idx >= 0) {
            layers.splice(idx, 1);
            if (layers.length === 0) delete $7dfac6b046c9f384$var$_layersByHostId[hostId];
        }
    }
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    if (layerHosts) for(var _i = 0, layerHosts_2 = layerHosts; _i < layerHosts_2.length; _i++){
        var layerHost = layerHosts_2[_i];
        layerHost.notifyLayersChanged();
    }
}
function $7dfac6b046c9f384$export$53fc4645c2516081(hostId) {
    var layers = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    return layers ? layers.length : 0;
}
function $7dfac6b046c9f384$export$5e1d5bc18f3e89d1(hostId) {
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    return layerHosts && layerHosts[0] || undefined;
}
function $7dfac6b046c9f384$export$f8f2368bc87a5ad4(hostId, layerHost) {
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId] || ($7dfac6b046c9f384$var$_layerHostsById[hostId] = []);
    // Insert this at the start of an array to avoid race conditions between mount and unmount.
    // If a LayerHost is re-mounted, and mount of the new instance may occur before the unmount of the old one.
    // Putting the new instance at the start of this array ensures that calls to `getLayerHost` will immediately
    // get the new one even if the old one is around briefly.
    layerHosts.unshift(layerHost);
}
function $7dfac6b046c9f384$export$fe3922105a2d30ad(hostId, layerHost) {
    var layerHosts = $7dfac6b046c9f384$var$_layerHostsById[hostId];
    if (layerHosts) {
        var idx = layerHosts.indexOf(layerHost);
        if (idx >= 0) layerHosts.splice(idx, 1);
        if (layerHosts.length === 0) delete $7dfac6b046c9f384$var$_layerHostsById[hostId];
    }
}
function $7dfac6b046c9f384$export$69a1b8986fe349a3(doc, shadowRoot) {
    if (shadowRoot === void 0) shadowRoot = null;
    var host = doc.createElement('div');
    host.setAttribute('id', $7dfac6b046c9f384$var$defaultHostId);
    host.style.cssText = 'position:fixed;z-index:1000000';
    if (shadowRoot) shadowRoot.appendChild(host);
    else doc === null || doc === void 0 || doc.body.appendChild(host);
    // doc?.body.appendChild(host);
    return host;
}
function $7dfac6b046c9f384$export$ffd4678a99119173(doc, shadowRoot) {
    if (shadowRoot === void 0) shadowRoot = null;
    var root = shadowRoot !== null && shadowRoot !== void 0 ? shadowRoot : doc;
    var host = root.querySelector("#".concat($7dfac6b046c9f384$var$defaultHostId));
    if (host) root.removeChild(host);
}
function $7dfac6b046c9f384$export$c14456671080cd6f(id) {
    if ($7dfac6b046c9f384$var$_layersByHostId[id]) $7dfac6b046c9f384$var$_layersByHostId[id].forEach(function(callback) {
        return callback();
    });
}
function $7dfac6b046c9f384$export$46538688e1f98dc4(selector) {
    $7dfac6b046c9f384$var$_defaultHostSelector = selector;
}
function $7dfac6b046c9f384$export$a7e6e434b174d91d() {
    return $7dfac6b046c9f384$var$_defaultHostSelector;
}



var $f185cc45f08d011c$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $f185cc45f08d011c$var$getFocusVisibility = function(providerRef) {
    if (providerRef === null || providerRef === void 0 ? void 0 : providerRef.current) return providerRef.current.classList.contains((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf));
    return false;
};
var $f185cc45f08d011c$export$fce5e14267d0afbe = $acw62.forwardRef(function(props, ref) {
    var registerPortalEl = (0, $a6dcfff088e996dd$export$712a597a27357a15)();
    var rootRef = $acw62.useRef(null);
    var mergedRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootRef, ref);
    var layerRef = $acw62.useRef(undefined);
    var fabricElementRef = $acw62.useRef(null);
    var focusContext = $acw62.useContext((0, $872a30e3c6519016$export$683969f4bf72ffbd));
    // Tracks if the layer mount events need to be raised.
    // Required to allow the DOM to render after the layer element is added.
    var _a = $acw62.useState(false), needRaiseLayerMount = _a[0], setNeedRaiseLayerMount = _a[1];
    // Sets the focus visible className when the FocusRectsProvider for the layer is rendered
    // This allows the current focus visibility style to be carried over to the layer content
    var focusRectsRef = $acw62.useCallback(function(el) {
        var isFocusVisible = $f185cc45f08d011c$var$getFocusVisibility(focusContext === null || focusContext === void 0 ? void 0 : focusContext.providerRef);
        if (el && isFocusVisible) el.classList.add((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf));
    }, [
        focusContext
    ]);
    var children = props.children, className = props.className, eventBubblingEnabled = props.eventBubblingEnabled, fabricProps = props.fabricProps, hostId = props.hostId, insertFirst = props.insertFirst, _b = props.onLayerDidMount, onLayerDidMount = _b === void 0 ? function() {
        return undefined;
    } : _b, // eslint-disable-next-line @typescript-eslint/no-deprecated
    _c = props.onLayerMounted, // eslint-disable-next-line @typescript-eslint/no-deprecated
    onLayerMounted = _c === void 0 ? function() {
        return undefined;
    } : _c, onLayerWillUnmount = props.onLayerWillUnmount, styles = props.styles, theme = props.theme;
    var fabricRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(fabricElementRef, fabricProps === null || fabricProps === void 0 ? void 0 : fabricProps.ref, focusRectsRef);
    var classNames = $f185cc45f08d011c$var$getClassNames(styles, {
        theme: theme,
        className: className,
        isNotHost: !hostId
    });
    // Returns the user provided hostId props element, the default target selector,
    // or undefined if document doesn't exist.
    var getHost = function(doc, shadowRoot) {
        var _a, _b;
        if (shadowRoot === void 0) shadowRoot = null;
        var root = shadowRoot !== null && shadowRoot !== void 0 ? shadowRoot : doc;
        if (hostId) {
            var layerHost = (0, $7dfac6b046c9f384$export$5e1d5bc18f3e89d1)(hostId);
            if (layerHost) return (_a = layerHost.rootRef.current) !== null && _a !== void 0 ? _a : null;
            return (_b = root.getElementById(hostId)) !== null && _b !== void 0 ? _b : null;
        } else {
            var defaultHostSelector = (0, $7dfac6b046c9f384$export$a7e6e434b174d91d)();
            // Find the host.
            var host = defaultHostSelector ? root.querySelector(defaultHostSelector) : null;
            // If no host is available, create a container for injecting layers in.
            // Having a container scopes layout computation.
            if (!host) host = (0, $7dfac6b046c9f384$export$69a1b8986fe349a3)(doc, shadowRoot);
            return host;
        }
    };
    // Removes the current layer element's parentNode and runs onLayerWillUnmount prop if provided.
    var removeLayerElement = function() {
        onLayerWillUnmount === null || onLayerWillUnmount === void 0 || onLayerWillUnmount();
        var elem = layerRef.current;
        // Clear ref before removing from the DOM
        layerRef.current = undefined;
        if (elem && elem.parentNode) elem.parentNode.removeChild(elem);
    };
    // If a doc or host exists, it will remove and update layer parentNodes.
    var createLayerElement = function() {
        var _a, _b, _c, _d;
        var doc = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)(rootRef.current);
        var shadowRoot = ((_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.getRootNode()) === null || _b === void 0 ? void 0 : _b.host) ? (_c = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _c === void 0 ? void 0 : _c.getRootNode() : undefined;
        if (!doc || !doc && !shadowRoot) return;
        var host = getHost(doc, shadowRoot);
        if (!host) return;
        // Tabster in V9 sets aria-hidden on the elements outside of the modal dialog. And it doesn't set aria-hidden
        // on the virtual children of the dialog. But the host element itself is not a virtual child of a dialog, it
        // might contain virtual children. noDirectAriaHidden flag makes Tabster to poke inside the element and set
        // aria-hidden on the children (if they are not virtual children of the active V9 dialog) not on the host element.
        // To avoid importing Tabster as a dependency here, we just set a flag on the host element which is checked by
        // Tabster.
        if (!host.__tabsterElementFlags) host.__tabsterElementFlags = {};
        host.__tabsterElementFlags.noDirectAriaHidden = true;
        // Remove and re-create any previous existing layer elements.
        removeLayerElement();
        var el = ((_d = host.ownerDocument) !== null && _d !== void 0 ? _d : doc).createElement('div');
        el.className = classNames.root;
        (0, $d38428ba3ade01f7$export$c36b8a5db804ed10)(el);
        (0, $e2a8102ee715fdfe$export$9bba5276a9c4d47)(el, rootRef.current);
        insertFirst ? host.insertBefore(el, host.firstChild) : host.appendChild(el);
        layerRef.current = el;
        setNeedRaiseLayerMount(true);
    };
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        createLayerElement();
        // Check if the user provided a hostId prop and register the layer with the ID.
        if (hostId) (0, $7dfac6b046c9f384$export$1229b260902b7551)(hostId, createLayerElement);
        var unregisterPortalEl = layerRef.current ? registerPortalEl(layerRef.current) : undefined;
        return function() {
            if (unregisterPortalEl) unregisterPortalEl();
            removeLayerElement();
            if (hostId) (0, $7dfac6b046c9f384$export$99742cfcbbb7d974)(hostId, createLayerElement);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should run if the hostId updates.
    }, [
        hostId
    ]);
    $acw62.useEffect(function() {
        if (layerRef.current && needRaiseLayerMount) {
            onLayerMounted === null || onLayerMounted === void 0 || onLayerMounted();
            onLayerDidMount === null || onLayerDidMount === void 0 || onLayerDidMount();
            setNeedRaiseLayerMount(false);
        }
    }, [
        needRaiseLayerMount,
        onLayerMounted,
        onLayerDidMount
    ]);
    $f185cc45f08d011c$var$useDebugWarnings(props);
    return $acw62.createElement("span", {
        className: "ms-layer",
        ref: mergedRef
    }, layerRef.current && $11492dca620dcaa5$exports.createPortal($acw62.createElement((0, $0a0122a1daf8e02f$export$7f9071f49e01dae9), {
        layerRoot: true,
        providerRef: fabricRef
    }, $acw62.createElement((0, $be4e78d7f9eccc5a$export$9c88c10c19390bf2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, !eventBubblingEnabled && $f185cc45f08d011c$var$getFilteredEvents(), fabricProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.content, fabricProps === null || fabricProps === void 0 ? void 0 : fabricProps.className),
        ref: fabricRef
    }), children)), layerRef.current));
});
$f185cc45f08d011c$export$fce5e14267d0afbe.displayName = 'LayerBase';
var $f185cc45f08d011c$var$filteredEventProps;
var $f185cc45f08d011c$var$onFilterEvent = function(ev) {
    // We should just be able to check ev.bubble here and only stop events that are bubbling up. However, even though
    // mouseenter and mouseleave do NOT bubble up, they are showing up as bubbling. Therefore we stop events based on
    // event name rather than ev.bubble.
    if (ev.eventPhase === Event.BUBBLING_PHASE && ev.type !== 'mouseenter' && ev.type !== 'mouseleave' && ev.type !== 'touchstart' && ev.type !== 'touchend') ev.stopPropagation();
};
function $f185cc45f08d011c$var$getFilteredEvents() {
    if (!$f185cc45f08d011c$var$filteredEventProps) {
        $f185cc45f08d011c$var$filteredEventProps = {};
        [
            'onClick',
            'onContextMenu',
            'onDoubleClick',
            'onDrag',
            'onDragEnd',
            'onDragEnter',
            'onDragExit',
            'onDragLeave',
            'onDragOver',
            'onDragStart',
            'onDrop',
            'onMouseDown',
            'onMouseEnter',
            'onMouseLeave',
            'onMouseMove',
            'onMouseOver',
            'onMouseOut',
            'onMouseUp',
            'onTouchMove',
            'onTouchStart',
            'onTouchCancel',
            'onTouchEnd',
            'onKeyDown',
            'onKeyPress',
            'onKeyUp',
            'onFocus',
            'onBlur',
            'onChange',
            'onInput',
            'onInvalid',
            'onSubmit'
        ].forEach(function(name) {
            return $f185cc45f08d011c$var$filteredEventProps[name] = $f185cc45f08d011c$var$onFilterEvent;
        });
    }
    return $f185cc45f08d011c$var$filteredEventProps;
}
function $f185cc45f08d011c$var$useDebugWarnings(props) {}



var $9782235cb00753f1$var$GlobalClassNames = {
    root: 'ms-Layer',
    rootNoHost: 'ms-Layer--fixed',
    content: 'ms-Layer-content'
};
var $9782235cb00753f1$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, isNotHost = props.isNotHost, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($9782235cb00753f1$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            isNotHost && [
                classNames.rootNoHost,
                {
                    position: 'fixed',
                    zIndex: (0, $e718b14ff8496161$export$ee30d3e11c8625f1).Layer,
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    visibility: 'hidden'
                }
            ],
            className
        ],
        content: [
            classNames.content,
            {
                visibility: 'visible'
            }
        ]
    };
};


var $0644c419e4ac4578$export$936d0764594b6eb3 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $f185cc45f08d011c$export$fce5e14267d0afbe), (0, $9782235cb00753f1$export$ffd58b7f6f099a57), undefined, {
    scope: 'Layer',
    fields: [
        'hostId',
        'theme',
        'styles'
    ]
});


var $bb8160ea11d5c986$export$97a5aca3dea8edc7 = $acw62.forwardRef(function(_a, forwardedRef) {
    var layerProps = _a.layerProps, doNotLayer = _a.doNotLayer, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "layerProps",
        "doNotLayer"
    ]);
    var content = $acw62.createElement((0, $57cf9e0ffad9e5e0$export$f6122ee2215f6f10), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest, {
        doNotLayer: doNotLayer,
        ref: forwardedRef
    }));
    return doNotLayer ? content : $acw62.createElement((0, $0644c419e4ac4578$export$936d0764594b6eb3), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, layerProps), content);
});
$bb8160ea11d5c986$export$97a5aca3dea8edc7.displayName = 'Callout';





var $acw62 = parcelRequire("acw62");



var $840dfb0754982edd$var$defaultIconRenderer = function(props) {
    var item = props.item, classNames = props.classNames;
    var iconProps = item.iconProps;
    return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, iconProps, {
        className: classNames.icon
    }));
};
var $840dfb0754982edd$var$renderItemIcon = function(props) {
    var item = props.item, hasIcons = props.hasIcons;
    if (!hasIcons) return null;
    if (item.onRenderIcon) return item.onRenderIcon(props, $840dfb0754982edd$var$defaultIconRenderer);
    return $840dfb0754982edd$var$defaultIconRenderer(props);
};
var $840dfb0754982edd$var$renderCheckMarkIcon = function(_a) {
    var onCheckmarkClick = _a.onCheckmarkClick, item = _a.item, classNames = _a.classNames;
    var isItemChecked = (0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item);
    if (onCheckmarkClick) {
        // Ensures that the item is passed as the first argument to the checkmark click callback.
        var onClick = function(e) {
            return onCheckmarkClick(item, e);
        };
        return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
            iconName: item.canCheck !== false && isItemChecked ? 'CheckMark' : '',
            className: classNames.checkmarkIcon,
            // eslint-disable-next-line react/jsx-no-bind
            onClick: onClick
        });
    }
    return null;
};
var $840dfb0754982edd$var$renderItemName = function(_a) {
    var item = _a.item, classNames = _a.classNames;
    /* eslint-disable @typescript-eslint/no-deprecated */ if (item.text || item.name) return $acw62.createElement("span", {
        className: classNames.label
    }, item.text || item.name);
    /* eslint-enable @typescript-eslint/no-deprecated */ return null;
};
var $840dfb0754982edd$var$renderSecondaryText = function(_a) {
    var item = _a.item, classNames = _a.classNames;
    if (item.secondaryText) return $acw62.createElement("span", {
        className: classNames.secondaryText
    }, item.secondaryText);
    return null;
};
var $840dfb0754982edd$var$renderSubMenuIcon = function(_a) {
    var item = _a.item, classNames = _a.classNames, theme = _a.theme;
    if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item)) return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        iconName: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? 'ChevronLeft' : 'ChevronRight'
    }, item.submenuIconProps, {
        className: classNames.subMenuIcon
    }));
    return null;
};
var $840dfb0754982edd$export$629e0691500c5c6a = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuItemBase, _super);
    function ContextualMenuItemBase(props) {
        var _this = _super.call(this, props) || this;
        _this.openSubMenu = function() {
            var _a = _this.props, item = _a.item, openSubMenu = _a.openSubMenu, getSubmenuTarget = _a.getSubmenuTarget;
            if (getSubmenuTarget) {
                var submenuTarget = getSubmenuTarget();
                if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item) && openSubMenu && submenuTarget) openSubMenu(item, submenuTarget);
            }
        };
        _this.dismissSubMenu = function() {
            var _a = _this.props, item = _a.item, dismissSubMenu = _a.dismissSubMenu;
            if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item) && dismissSubMenu) dismissSubMenu();
        };
        _this.dismissMenu = function(dismissAll) {
            var dismissMenu = _this.props.dismissMenu;
            if (dismissMenu) dismissMenu(undefined /* ev */ , dismissAll);
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        return _this;
    }
    ContextualMenuItemBase.prototype.render = function() {
        var _a = this.props, item = _a.item, classNames = _a.classNames;
        var renderContent = item.onRenderContent || this._renderLayout;
        return $acw62.createElement("div", {
            className: item.split ? classNames.linkContentMenu : classNames.linkContent
        }, renderContent(this.props, {
            renderCheckMarkIcon: $840dfb0754982edd$var$renderCheckMarkIcon,
            renderItemIcon: $840dfb0754982edd$var$renderItemIcon,
            renderItemName: $840dfb0754982edd$var$renderItemName,
            renderSecondaryText: $840dfb0754982edd$var$renderSecondaryText,
            renderSubMenuIcon: $840dfb0754982edd$var$renderSubMenuIcon
        }));
    };
    ContextualMenuItemBase.prototype._renderLayout = function(props, defaultRenders) {
        return $acw62.createElement($acw62.Fragment, null, defaultRenders.renderCheckMarkIcon(props), defaultRenders.renderItemIcon(props), defaultRenders.renderItemName(props), defaultRenders.renderSecondaryText(props), defaultRenders.renderSubMenuIcon(props));
    };
    return ContextualMenuItemBase;
}($acw62.Component);




var $3efc3c3b4ad2794c$export$ef1a4c000b9663fc = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(// eslint-disable-next-line @typescript-eslint/no-deprecated
function(theme) {
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
        wrapper: {
            display: 'inline-flex',
            height: '100%',
            alignItems: 'center'
        },
        divider: {
            width: 1,
            height: '100%',
            backgroundColor: theme.palette.neutralTertiaryAlt
        }
    });
});





var $194675c1c18101b9$export$f4ed060eaa49a3 = 36;
var $194675c1c18101b9$var$MediumScreenSelector = (0, $905fed6f1ccd845a$export$be136f2e7621e736)(0, (0, $905fed6f1ccd845a$export$af97800cf211974a));
var $194675c1c18101b9$export$adaad53e003c74d0 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme) {
    var _a, _b, _c, _d, _e;
    var semanticColors = theme.semanticColors, fonts = theme.fonts, palette = theme.palette;
    var ContextualMenuItemBackgroundHoverColor = semanticColors.menuItemBackgroundHovered;
    var ContextualMenuItemTextHoverColor = semanticColors.menuItemTextHovered;
    var ContextualMenuItemBackgroundSelectedColor = semanticColors.menuItemBackgroundPressed;
    var ContextualMenuItemDividerColor = semanticColors.bodyDivider;
    var menuItemStyles = {
        item: [
            fonts.medium,
            {
                color: semanticColors.bodyText,
                position: 'relative',
                boxSizing: 'border-box'
            }
        ],
        divider: {
            display: 'block',
            height: '1px',
            backgroundColor: ContextualMenuItemDividerColor,
            position: 'relative'
        },
        root: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            fonts.medium,
            {
                color: semanticColors.bodyText,
                backgroundColor: 'transparent',
                border: 'none',
                width: '100%',
                height: $194675c1c18101b9$export$f4ed060eaa49a3,
                lineHeight: $194675c1c18101b9$export$f4ed060eaa49a3,
                display: 'block',
                cursor: 'pointer',
                padding: '0px 8px 0 4px',
                textAlign: 'left'
            }
        ],
        rootDisabled: {
            color: semanticColors.disabledBodyText,
            cursor: 'default',
            pointerEvents: 'none',
            selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                // ensure disabled text looks different than enabled
                color: 'GrayText',
                opacity: 1
            }, _a)
        },
        rootHovered: {
            backgroundColor: ContextualMenuItemBackgroundHoverColor,
            color: ContextualMenuItemTextHoverColor,
            selectors: {
                '.ms-ContextualMenu-icon': {
                    color: palette.themeDarkAlt
                },
                '.ms-ContextualMenu-submenuIcon': {
                    color: palette.neutralPrimary
                }
            }
        },
        rootFocused: {
            backgroundColor: palette.white
        },
        rootChecked: {
            selectors: {
                '.ms-ContextualMenu-checkmarkIcon': {
                    color: palette.neutralPrimary
                }
            }
        },
        rootPressed: {
            backgroundColor: ContextualMenuItemBackgroundSelectedColor,
            selectors: {
                '.ms-ContextualMenu-icon': {
                    color: palette.themeDark
                },
                '.ms-ContextualMenu-submenuIcon': {
                    color: palette.neutralPrimary
                }
            }
        },
        rootExpanded: {
            backgroundColor: ContextualMenuItemBackgroundSelectedColor,
            color: semanticColors.bodyTextChecked,
            selectors: (_b = {
                '.ms-ContextualMenu-submenuIcon': (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    // icons inside of anchor tags are not properly inheriting color in high contrast
                    color: 'inherit'
                }, _c)
            }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _b)
        },
        linkContent: {
            whiteSpace: 'nowrap',
            height: 'inherit',
            display: 'flex',
            alignItems: 'center',
            maxWidth: '100%'
        },
        anchorLink: {
            padding: '0px 8px 0 4px',
            textRendering: 'auto',
            color: 'inherit',
            letterSpacing: 'normal',
            wordSpacing: 'normal',
            textTransform: 'none',
            textIndent: '0px',
            textShadow: 'none',
            textDecoration: 'none',
            boxSizing: 'border-box'
        },
        label: {
            margin: '0 4px',
            verticalAlign: 'middle',
            display: 'inline-block',
            flexGrow: '1',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        secondaryText: {
            color: theme.palette.neutralSecondary,
            paddingLeft: '20px',
            textAlign: 'right'
        },
        icon: {
            display: 'inline-block',
            minHeight: '1px',
            maxHeight: $194675c1c18101b9$export$f4ed060eaa49a3,
            fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
            width: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium,
            margin: '0 4px',
            verticalAlign: 'middle',
            flexShrink: '0',
            selectors: (_d = {}, _d[$194675c1c18101b9$var$MediumScreenSelector] = {
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).large,
                width: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).large
            }, _d)
        },
        iconColor: {
            color: semanticColors.menuIcon
        },
        iconDisabled: {
            color: semanticColors.disabledBodyText
        },
        checkmarkIcon: {
            color: semanticColors.bodySubtext
        },
        subMenuIcon: {
            height: $194675c1c18101b9$export$f4ed060eaa49a3,
            lineHeight: $194675c1c18101b9$export$f4ed060eaa49a3,
            color: palette.neutralSecondary,
            textAlign: 'center',
            display: 'inline-block',
            verticalAlign: 'middle',
            flexShrink: '0',
            fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).small,
            selectors: (_e = {
                ':hover': {
                    color: palette.neutralPrimary
                },
                ':active': {
                    color: palette.neutralPrimary
                }
            }, _e[$194675c1c18101b9$var$MediumScreenSelector] = {
                fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium
            }, _e)
        },
        splitButtonFlexContainer: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme),
            {
                display: 'flex',
                height: $194675c1c18101b9$export$f4ed060eaa49a3,
                flexWrap: 'nowrap',
                justifyContent: 'center',
                alignItems: 'flex-start'
            }
        ]
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(menuItemStyles);
});




var $b0ea91f2e2fa7180$var$CONTEXTUAL_SPLIT_MENU_MINWIDTH = '28px';
var $b0ea91f2e2fa7180$var$MediumScreenSelector = (0, $905fed6f1ccd845a$export$be136f2e7621e736)(0, (0, $905fed6f1ccd845a$export$af97800cf211974a));
var $b0ea91f2e2fa7180$export$c554b00c240727fe = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(/* eslint-disable @typescript-eslint/no-deprecated */ function(theme) {
    var _a;
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)((0, $3efc3c3b4ad2794c$export$ef1a4c000b9663fc)(theme), {
        /* eslint-enable @typescript-eslint/no-deprecated */ wrapper: {
            position: 'absolute',
            right: 28,
            selectors: (_a = {}, _a[$b0ea91f2e2fa7180$var$MediumScreenSelector] = {
                right: 32
            }, _a)
        },
        divider: {
            height: 16,
            width: 1
        }
    });
});
var $b0ea91f2e2fa7180$var$GlobalClassNames = {
    item: 'ms-ContextualMenu-item',
    divider: 'ms-ContextualMenu-divider',
    root: 'ms-ContextualMenu-link',
    isChecked: 'is-checked',
    isExpanded: 'is-expanded',
    isDisabled: 'is-disabled',
    linkContent: 'ms-ContextualMenu-linkContent',
    linkContentMenu: 'ms-ContextualMenu-linkContent',
    icon: 'ms-ContextualMenu-icon',
    iconColor: 'ms-ContextualMenu-iconColor',
    checkmarkIcon: 'ms-ContextualMenu-checkmarkIcon',
    subMenuIcon: 'ms-ContextualMenu-submenuIcon',
    label: 'ms-ContextualMenu-itemText',
    secondaryText: 'ms-ContextualMenu-secondaryText',
    splitMenu: 'ms-ContextualMenu-splitMenu',
    screenReaderText: 'ms-ContextualMenu-screenReaderText'
};
var $b0ea91f2e2fa7180$export$4e2f85cdf7cc1c08 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className) {
    var _a, _b, _c, _d;
    var styles = (0, $194675c1c18101b9$export$adaad53e003c74d0)(theme);
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($b0ea91f2e2fa7180$var$GlobalClassNames, theme);
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)({
        item: [
            classNames.item,
            styles.item,
            itemClassName
        ],
        divider: [
            classNames.divider,
            styles.divider,
            dividerClassName
        ],
        root: [
            classNames.root,
            styles.root,
            checked && [
                classNames.isChecked,
                styles.rootChecked
            ],
            isAnchorLink && styles.anchorLink,
            expanded && [
                classNames.isExpanded,
                styles.rootExpanded
            ],
            disabled && [
                classNames.isDisabled,
                styles.rootDisabled
            ],
            !disabled && !expanded && [
                {
                    selectors: (_a = {
                        ':hover': styles.rootHovered,
                        ':active': styles.rootPressed
                    }, // eslint-disable-next-line @fluentui/max-len
                    _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus:hover")] = styles.rootFocused, _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:hover")] = {
                        background: 'inherit;'
                    }, _a)
                }
            ],
            className
        ],
        splitPrimary: [
            styles.root,
            {
                width: "calc(100% - ".concat($b0ea91f2e2fa7180$var$CONTEXTUAL_SPLIT_MENU_MINWIDTH, ")")
            },
            checked && [
                'is-checked',
                styles.rootChecked
            ],
            (disabled || primaryDisabled) && [
                'is-disabled',
                styles.rootDisabled
            ],
            !(disabled || primaryDisabled) && !checked && [
                {
                    selectors: (_b = {
                        ':hover': styles.rootHovered
                    }, // when hovering over the splitPrimary also affect the splitMenu
                    _b[":hover ~ .".concat(classNames.splitMenu)] = styles.rootHovered, _b[':active'] = styles.rootPressed, // eslint-disable-next-line @fluentui/max-len
                    _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus:hover")] = styles.rootFocused, _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:hover")] = {
                        background: 'inherit;'
                    }, _b)
                }
            ]
        ],
        splitMenu: [
            classNames.splitMenu,
            styles.root,
            {
                flexBasis: '0',
                padding: '0 8px',
                minWidth: $b0ea91f2e2fa7180$var$CONTEXTUAL_SPLIT_MENU_MINWIDTH
            },
            expanded && [
                'is-expanded',
                styles.rootExpanded
            ],
            disabled && [
                'is-disabled',
                styles.rootDisabled
            ],
            !disabled && !expanded && [
                {
                    selectors: (_c = {
                        ':hover': styles.rootHovered,
                        ':active': styles.rootPressed
                    }, // eslint-disable-next-line @fluentui/max-len
                    _c[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus:hover")] = styles.rootFocused, _c[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:hover")] = {
                        background: 'inherit;'
                    }, _c)
                }
            ]
        ],
        anchorLink: styles.anchorLink,
        linkContent: [
            classNames.linkContent,
            styles.linkContent
        ],
        linkContentMenu: [
            classNames.linkContentMenu,
            styles.linkContent,
            {
                justifyContent: 'center'
            }
        ],
        icon: [
            classNames.icon,
            knownIcon && styles.iconColor,
            styles.icon,
            iconClassName,
            disabled && [
                classNames.isDisabled,
                styles.iconDisabled
            ]
        ],
        iconColor: styles.iconColor,
        checkmarkIcon: [
            classNames.checkmarkIcon,
            knownIcon && styles.checkmarkIcon,
            styles.icon,
            iconClassName
        ],
        subMenuIcon: [
            classNames.subMenuIcon,
            styles.subMenuIcon,
            subMenuClassName,
            expanded && {
                color: theme.palette.neutralPrimary
            },
            disabled && [
                styles.iconDisabled
            ]
        ],
        label: [
            classNames.label,
            styles.label
        ],
        secondaryText: [
            classNames.secondaryText,
            styles.secondaryText
        ],
        splitContainer: [
            styles.splitButtonFlexContainer,
            !disabled && !checked && [
                {
                    selectors: (_d = {}, // eslint-disable-next-line @fluentui/max-len
                    _d[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, .").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:hover, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus:hover")] = styles.rootFocused, _d)
                }
            ]
        ],
        screenReaderText: [
            classNames.screenReaderText,
            styles.screenReaderText,
            (0, $34563ae103a23d08$export$35835471cbe77db4),
            {
                visibility: 'hidden'
            }
        ]
    });
});
var $b0ea91f2e2fa7180$export$68f648f9dd4d8263 = function(props) {
    var theme = props.theme, disabled = props.disabled, expanded = props.expanded, checked = props.checked, isAnchorLink = props.isAnchorLink, knownIcon = props.knownIcon, itemClassName = props.itemClassName, dividerClassName = props.dividerClassName, iconClassName = props.iconClassName, subMenuClassName = props.subMenuClassName, primaryDisabled = props.primaryDisabled, className = props.className;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return $b0ea91f2e2fa7180$export$4e2f85cdf7cc1c08(theme, disabled, expanded, checked, isAnchorLink, knownIcon, itemClassName, dividerClassName, iconClassName, subMenuClassName, primaryDisabled, className);
};


var $dbc0d5833638f24e$export$4267af6d9e6f3487 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $840dfb0754982edd$export$629e0691500c5c6a), (0, $b0ea91f2e2fa7180$export$68f648f9dd4d8263), undefined, {
    scope: 'ContextualMenuItem'
});




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $91ba163d72302a3e$export$d3035c4985d1b359 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuItemWrapper, _super);
    function ContextualMenuItemWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this._onItemMouseEnter = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) onItemMouseEnter(item, ev, ev.currentTarget);
        };
        _this._onItemClick = function(ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) onItemClickBase(item, ev, ev.currentTarget);
        };
        _this._onItemMouseLeave = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseLeave = _a.onItemMouseLeave;
            if (onItemMouseLeave) onItemMouseLeave(item, ev);
        };
        _this._onItemKeyDown = function(ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            if (onItemKeyDown) onItemKeyDown(item, ev);
        };
        _this._onItemMouseMove = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) onItemMouseMove(item, ev, ev.currentTarget);
        };
        _this._getSubmenuTarget = function() {
            return undefined;
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        return _this;
    }
    ContextualMenuItemWrapper.prototype.shouldComponentUpdate = function(newProps) {
        return !(0, $f504d2279336999d$export$90e866afbd6b9f1a)(newProps, this.props);
    };
    return ContextualMenuItemWrapper;
}($acw62.Component);



var $b93318a7b1d1c2ef$export$728cf8667bd7c06f = 'ktp';
var $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0 = '-';
var $b93318a7b1d1c2ef$export$4083e12f0f38721 = $b93318a7b1d1c2ef$export$728cf8667bd7c06f + $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0;
var $b93318a7b1d1c2ef$export$b075aa67ec3ce39b = 'data-ktp-target';
var $b93318a7b1d1c2ef$export$4830628b0416058 = 'data-ktp-execute-target';
var $b93318a7b1d1c2ef$export$8c7b9a821b7c114c = 'data-ktp-aria-target';
var $b93318a7b1d1c2ef$export$787c3bee7e52cabf = 'ktp-layer-id';
var $b93318a7b1d1c2ef$export$cf4a82ab5af0bf5a = ', ';
var $b93318a7b1d1c2ef$export$f121db0802a54d32;
(function(KeytipEvents) {
    KeytipEvents.KEYTIP_ADDED = 'keytipAdded';
    KeytipEvents.KEYTIP_REMOVED = 'keytipRemoved';
    KeytipEvents.KEYTIP_UPDATED = 'keytipUpdated';
    KeytipEvents.PERSISTED_KEYTIP_ADDED = 'persistedKeytipAdded';
    KeytipEvents.PERSISTED_KEYTIP_REMOVED = 'persistedKeytipRemoved';
    KeytipEvents.PERSISTED_KEYTIP_EXECUTE = 'persistedKeytipExecute';
    KeytipEvents.ENTER_KEYTIP_MODE = 'enterKeytipMode';
    KeytipEvents.EXIT_KEYTIP_MODE = 'exitKeytipMode';
})($b93318a7b1d1c2ef$export$f121db0802a54d32 || ($b93318a7b1d1c2ef$export$f121db0802a54d32 = {}));




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $3ae817ff5fe2ac83$export$5cae361ad82dce8b(value) {
    var ref = $acw62.useRef(undefined);
    $acw62.useEffect(function() {
        ref.current = value;
    });
    return ref.current;
}






function $5da71d0b240ae24c$export$18be6da7299faebb(keySequences) {
    return keySequences.reduce(function(prevValue, keySequence) {
        return prevValue + (0, $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0) + keySequence.split('').join((0, $b93318a7b1d1c2ef$export$e8d3cc8a6afc0ab0));
    }, (0, $b93318a7b1d1c2ef$export$728cf8667bd7c06f));
}
function $5da71d0b240ae24c$export$b1a802da09324058(keySequences, overflowKeySequences) {
    var overflowSequenceLen = overflowKeySequences.length;
    var overflowSequence = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], overflowKeySequences, true).pop();
    var newKeySequences = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], keySequences, true);
    return (0, $b9105dc723fd02ea$export$df2fbf469f510c97)(newKeySequences, overflowSequenceLen - 1, overflowSequence);
}
function $5da71d0b240ae24c$export$875c435dc78e881f(keySequences) {
    return '[' + (0, $b93318a7b1d1c2ef$export$b075aa67ec3ce39b) + '="' + $5da71d0b240ae24c$export$18be6da7299faebb(keySequences) + '"]';
}
function $5da71d0b240ae24c$export$f973355f195910f8(keytipId) {
    return '[' + (0, $b93318a7b1d1c2ef$export$4830628b0416058) + '="' + keytipId + '"]';
}
function $5da71d0b240ae24c$export$65ef0a02533e7bf7(keySequences) {
    var describedby = ' ' + (0, $b93318a7b1d1c2ef$export$787c3bee7e52cabf);
    if (!keySequences.length) // Return just the layer ID
    return describedby;
    return describedby + ' ' + $5da71d0b240ae24c$export$18be6da7299faebb(keySequences);
}




/**
 * This class is responsible for handling registering, updating, and unregistering of keytips
 */ var $3ce833705adf3bff$export$98a3eaa272c56420 = /** @class */ function() {
    function KeytipManager() {
        this.keytips = {};
        this.persistedKeytips = {};
        this.sequenceMapping = {};
        // This is (and should be) updated and kept in sync
        // with the inKeytipMode in KeytipLayer.
        this.inKeytipMode = false;
        // Boolean that gets checked before entering keytip mode by the KeytipLayer
        // Used for an override in special cases (e.g. Disable entering keytip mode when a modal is shown)
        this.shouldEnterKeytipMode = true;
        // Boolean to indicate whether to delay firing an event to update subscribers of
        // keytip data changed.
        this.delayUpdatingKeytipChange = false;
    }
    /**
     * Static function to get singleton KeytipManager instance
     *
     * @returns Singleton KeytipManager instance
     */ KeytipManager.getInstance = function() {
        return this._instance;
    };
    /**
     * Initialization code to set set parameters to define
     * how the KeytipManager handles keytip data.
     *
     * @param delayUpdatingKeytipChange - T/F if we should delay notifiying keytip subscribers
     * of keytip changes
     */ KeytipManager.prototype.init = function(delayUpdatingKeytipChange) {
        this.delayUpdatingKeytipChange = delayUpdatingKeytipChange;
    };
    /**
     * Registers a keytip
     *
     * @param keytipProps - Keytip to register
     * @param persisted - T/F if this keytip should be persisted, default is false
     * @returns Unique ID for this keytip
     */ KeytipManager.prototype.register = function(keytipProps, persisted) {
        if (persisted === void 0) persisted = false;
        var props = keytipProps;
        if (!persisted) {
            // Add the overflowSetSequence if necessary
            props = this.addParentOverflow(keytipProps);
            this.sequenceMapping[props.keySequences.toString()] = props;
        }
        // Create a unique keytip
        var uniqueKeytip = this._getUniqueKtp(props);
        // Add to dictionary
        persisted ? this.persistedKeytips[uniqueKeytip.uniqueID] = uniqueKeytip : this.keytips[uniqueKeytip.uniqueID] = uniqueKeytip;
        // We only want to add something new if we are currently showing keytip mode
        if (this.inKeytipMode || !this.delayUpdatingKeytipChange) {
            var event_1 = persisted ? (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).PERSISTED_KEYTIP_ADDED : (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).KEYTIP_ADDED;
            (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, event_1, {
                keytip: props,
                uniqueID: uniqueKeytip.uniqueID
            });
        }
        return uniqueKeytip.uniqueID;
    };
    /**
     * Update a keytip
     *
     * @param keytipProps - Keytip to update
     * @param uniqueID - Unique ID of this keytip
     */ KeytipManager.prototype.update = function(keytipProps, uniqueID) {
        var newKeytipProps = this.addParentOverflow(keytipProps);
        var uniqueKeytip = this._getUniqueKtp(newKeytipProps, uniqueID);
        var oldKeyTip = this.keytips[uniqueID];
        if (oldKeyTip) {
            // Update everything except 'visible'
            uniqueKeytip.keytip.visible = oldKeyTip.keytip.visible;
            // Update keytip in this.keytips
            this.keytips[uniqueID] = uniqueKeytip;
            // Update the sequence to be up to date
            delete this.sequenceMapping[oldKeyTip.keytip.keySequences.toString()];
            this.sequenceMapping[uniqueKeytip.keytip.keySequences.toString()] = uniqueKeytip.keytip;
            // Raise event only if we are currently in keytip mode
            if (this.inKeytipMode || !this.delayUpdatingKeytipChange) (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).KEYTIP_UPDATED, {
                keytip: uniqueKeytip.keytip,
                uniqueID: uniqueKeytip.uniqueID
            });
        }
    };
    /**
     * Unregisters a keytip
     *
     * @param keytipToRemove - IKeytipProps of the keytip to remove
     * @param uniqueID - Unique ID of this keytip
     * @param persisted - T/F if this keytip should be persisted, default is false
     */ KeytipManager.prototype.unregister = function(keytipToRemove, uniqueID, persisted) {
        if (persisted === void 0) persisted = false;
        persisted ? delete this.persistedKeytips[uniqueID] : delete this.keytips[uniqueID];
        !persisted && delete this.sequenceMapping[keytipToRemove.keySequences.toString()];
        var event = persisted ? (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).PERSISTED_KEYTIP_REMOVED : (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).KEYTIP_REMOVED;
        // Update keytips only if we're in keytip mode
        if (this.inKeytipMode || !this.delayUpdatingKeytipChange) (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, event, {
            keytip: keytipToRemove,
            uniqueID: uniqueID
        });
    };
    /**
     * Manual call to enter keytip mode
     */ KeytipManager.prototype.enterKeytipMode = function() {
        (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).ENTER_KEYTIP_MODE);
    };
    /**
     * Manual call to exit keytip mode
     */ KeytipManager.prototype.exitKeytipMode = function() {
        (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).EXIT_KEYTIP_MODE);
    };
    /**
     * Gets all IKeytipProps from this.keytips
     *
     * @returns All keytips stored in the manager
     */ KeytipManager.prototype.getKeytips = function() {
        var _this = this;
        return Object.keys(this.keytips).map(function(key) {
            return _this.keytips[key].keytip;
        });
    };
    /**
     * Adds the overflowSetSequence to the keytipProps if its parent keytip also has it
     *
     * @param keytipProps - Keytip props to add overflowSetSequence to if necessary
     * @returns - Modified keytip props, if needed to be modified
     */ KeytipManager.prototype.addParentOverflow = function(keytipProps) {
        var fullSequence = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], keytipProps.keySequences, true);
        fullSequence.pop();
        if (fullSequence.length !== 0) {
            var parentKeytip = this.sequenceMapping[fullSequence.toString()];
            if (parentKeytip && parentKeytip.overflowSetSequence) return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                overflowSetSequence: parentKeytip.overflowSetSequence
            });
        }
        return keytipProps;
    };
    /**
     * Public function to bind for overflow items that have a submenu
     */ KeytipManager.prototype.menuExecute = function(overflowButtonSequences, keytipSequences) {
        (0, $7e392406ee2126b8$export$7af5106782f53286).raise(this, (0, $b93318a7b1d1c2ef$export$f121db0802a54d32).PERSISTED_KEYTIP_EXECUTE, {
            overflowButtonSequences: overflowButtonSequences,
            keytipSequences: keytipSequences
        });
    };
    /**
     * Creates an IUniqueKeytip object
     *
     * @param keytipProps - IKeytipProps
     * @param uniqueID - Unique ID, will default to the next unique ID if not passed
     * @returns IUniqueKeytip object
     */ KeytipManager.prototype._getUniqueKtp = function(keytipProps, uniqueID) {
        if (uniqueID === void 0) uniqueID = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        return {
            keytip: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps),
            uniqueID: uniqueID
        };
    };
    KeytipManager._instance = new KeytipManager();
    return KeytipManager;
}();


function $fdf98e2d5c990390$export$566fb23b8c51c119(options) {
    var uniqueId = $acw62.useRef(undefined);
    var keytipProps = options.keytipProps ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        disabled: options.disabled
    }, options.keytipProps) : undefined;
    var keytipManager = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)((0, $3ce833705adf3bff$export$98a3eaa272c56420).getInstance());
    var prevOptions = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(options);
    // useLayoutEffect used to strictly emulate didUpdate/didMount behavior
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        if (uniqueId.current && keytipProps && ((prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.keytipProps) !== options.keytipProps || (prevOptions === null || prevOptions === void 0 ? void 0 : prevOptions.disabled) !== options.disabled)) keytipManager.update(keytipProps, uniqueId.current);
    });
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        // Register Keytip in KeytipManager
        if (keytipProps) uniqueId.current = keytipManager.register(keytipProps);
        return function() {
            // Unregister Keytip in KeytipManager
            keytipProps && keytipManager.unregister(keytipProps, uniqueId.current);
        };
    // this is meant to run only at mount, and updates are handled separately
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var nativeKeytipProps = {
        ariaDescribedBy: options.ariaDescribedBy,
        keytipId: undefined
    };
    if (keytipProps) nativeKeytipProps = $fdf98e2d5c990390$var$getKeytipData(keytipManager, keytipProps, options.ariaDescribedBy);
    return nativeKeytipProps;
}
/**
 * Gets the aria- and data- attributes to attach to the component
 * @param keytipProps - options for Keytip
 * @param describedByPrepend - ariaDescribedBy value to prepend
 */ function $fdf98e2d5c990390$var$getKeytipData(keytipManager, keytipProps, describedByPrepend) {
    // Add the parent overflow sequence if necessary
    var newKeytipProps = keytipManager.addParentOverflow(keytipProps);
    // Construct aria-describedby and data-ktp-id attributes
    var ariaDescribedBy = (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(describedByPrepend, (0, $5da71d0b240ae24c$export$65ef0a02533e7bf7)(newKeytipProps.keySequences));
    var keySequences = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], newKeytipProps.keySequences, true);
    if (newKeytipProps.overflowSetSequence) keySequences = (0, $5da71d0b240ae24c$export$b1a802da09324058)(keySequences, newKeytipProps.overflowSetSequence);
    var keytipId = (0, $5da71d0b240ae24c$export$18be6da7299faebb)(keySequences);
    return {
        ariaDescribedBy: ariaDescribedBy,
        keytipId: keytipId
    };
}


var $eb1de6218d550a90$export$fb9facd15f0137af = function(props) {
    var _a;
    var children = props.children, keytipDataProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "children"
    ]);
    var _b = (0, $fdf98e2d5c990390$export$566fb23b8c51c119)(keytipDataProps), keytipId = _b.keytipId, ariaDescribedBy = _b.ariaDescribedBy;
    return children((_a = {}, _a[0, $b93318a7b1d1c2ef$export$b075aa67ec3ce39b] = keytipId, _a[0, $b93318a7b1d1c2ef$export$4830628b0416058] = keytipId, _a['aria-describedby'] = ariaDescribedBy, _a));
};




var $4d34c28d37611dbf$export$53be548a9698e315 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuAnchor, _super);
    function ContextualMenuAnchor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._anchor = $acw62.createRef();
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._getSubmenuTarget = function() {
            return _this._anchor.current ? _this._anchor.current : undefined;
        };
        _this._onItemClick = function(ev) {
            var _a = _this.props, item = _a.item, onItemClick = _a.onItemClick;
            if (onItemClick) onItemClick(item, ev);
        };
        _this._renderAriaDescription = function(ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? $acw62.createElement("span", {
                id: _this._ariaDescriptionId,
                className: className
            }, ariaDescription) : null;
        };
        return _this;
    }
    ContextualMenuAnchor.prototype.render = function() {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, expandedMenuItemKey = _a.expandedMenuItemKey, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var ChildrenRenderer = (0, $dbc0d5833638f24e$export$4267af6d9e6f3487);
        if (this.props.item.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(this.props.item.contextualMenuItemAs, ChildrenRenderer);
        if (this.props.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(this.props.contextualMenuItemAs, ChildrenRenderer);
        var anchorRel = item.rel;
        if (item.target && item.target.toLowerCase() === '_blank') anchorRel = anchorRel ? anchorRel : 'nofollow noopener noreferrer'; // Safe default to prevent tabjacking
        var itemHasSubmenu = (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item);
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(item, (0, $076f236b4b7f2dc0$export$bd4643a0b4568ed8));
        var disabled = (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item);
        var itemProps = item.itemProps, ariaDescription = item.ariaDescription;
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        if (ariaDescription) this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        var ariaDescribedByIds = (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(item.ariaDescribedBy, ariaDescription ? this._ariaDescriptionId : undefined, nativeProps['aria-describedby']);
        var additionalItemProperties = {
            'aria-describedby': ariaDescribedByIds
        };
        return $acw62.createElement("div", null, $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: item.keytipProps,
            ariaDescribedBy: ariaDescribedByIds,
            disabled: disabled
        }, function(keytipAttributes) {
            return $acw62.createElement("a", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, additionalItemProperties, nativeProps, keytipAttributes, {
                ref: _this._anchor,
                href: item.href,
                target: item.target,
                rel: anchorRel,
                className: classNames.root,
                role: "menuitem",
                "aria-haspopup": itemHasSubmenu || undefined,
                "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
                "aria-posinset": focusableElementIndex + 1,
                "aria-setsize": totalItemCount,
                "aria-disabled": (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                style: item.style,
                onClick: _this._onItemClick,
                onMouseEnter: _this._onItemMouseEnter,
                onMouseLeave: _this._onItemMouseLeave,
                onMouseMove: _this._onItemMouseMove,
                onKeyDown: itemHasSubmenu ? _this._onItemKeyDown : undefined
            }), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                componentRef: item.componentRef,
                item: item,
                classNames: classNames,
                index: index,
                onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined,
                hasIcons: hasIcons,
                openSubMenu: openSubMenu,
                dismissSubMenu: dismissSubMenu,
                dismissMenu: dismissMenu,
                getSubmenuTarget: _this._getSubmenuTarget
            }, itemProps)), _this._renderAriaDescription(ariaDescription, classNames.screenReaderText));
        }));
    };
    return ContextualMenuAnchor;
}((0, $91ba163d72302a3e$export$d3035c4985d1b359));



var $acw62 = parcelRequire("acw62");





var $5b4ee16a3fe91ee4$export$77db5d9420e58cc5 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuButton, _super);
    function ContextualMenuButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._btn = $acw62.createRef();
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._renderAriaDescription = function(ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? $acw62.createElement("span", {
                id: _this._ariaDescriptionId,
                className: className
            }, ariaDescription) : null;
        };
        _this._getSubmenuTarget = function() {
            return _this._btn.current ? _this._btn.current : undefined;
        };
        return _this;
    }
    ContextualMenuButton.prototype.render = function() {
        var _this = this;
        var _a = this.props, item = _a.item, classNames = _a.classNames, index = _a.index, focusableElementIndex = _a.focusableElementIndex, totalItemCount = _a.totalItemCount, hasCheckmarks = _a.hasCheckmarks, hasIcons = _a.hasIcons, contextualMenuItemAs = _a.contextualMenuItemAs, expandedMenuItemKey = _a.expandedMenuItemKey, onItemMouseDown = _a.onItemMouseDown, onItemClick = _a.onItemClick, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var ChildrenRenderer = (0, $dbc0d5833638f24e$export$4267af6d9e6f3487);
        if (item.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(item.contextualMenuItemAs, ChildrenRenderer);
        if (contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(contextualMenuItemAs, ChildrenRenderer);
        var isChecked = (0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item);
        var canCheck = isChecked !== null;
        var defaultRole = (0, $3250824b6f1d23dc$export$84bfff8e7c9de691)(item);
        var itemHasSubmenu = (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item);
        var itemProps = item.itemProps, ariaLabel = item.ariaLabel, ariaDescription = item.ariaDescription;
        var buttonNativeProperties = (0, $076f236b4b7f2dc0$export$26fba481281db559)(item, (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4));
        // Do not add the disabled attribute to the button so that it is focusable
        delete buttonNativeProperties.disabled;
        var itemRole = item.role || defaultRole;
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        if (ariaDescription) this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        var ariaDescribedByIds = (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(item.ariaDescribedBy, ariaDescription ? this._ariaDescriptionId : undefined, buttonNativeProperties['aria-describedby']);
        var itemButtonProperties = {
            className: classNames.root,
            onClick: this._onItemClick,
            onKeyDown: itemHasSubmenu ? this._onItemKeyDown : undefined,
            onMouseEnter: this._onItemMouseEnter,
            onMouseLeave: this._onItemMouseLeave,
            onMouseDown: function(ev) {
                return onItemMouseDown ? onItemMouseDown(item, ev) : undefined;
            },
            onMouseMove: this._onItemMouseMove,
            href: item.href,
            title: item.title,
            'aria-label': ariaLabel,
            'aria-describedby': ariaDescribedByIds,
            'aria-haspopup': itemHasSubmenu || undefined,
            'aria-expanded': itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
            'aria-posinset': focusableElementIndex + 1,
            'aria-setsize': totalItemCount,
            'aria-disabled': (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
            'aria-checked': (itemRole === 'menuitemcheckbox' || itemRole === 'menuitemradio') && canCheck ? !!isChecked : undefined,
            'aria-selected': itemRole === 'menuitem' && canCheck ? !!isChecked : undefined,
            role: itemRole,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            style: item.style
        };
        var keytipProps = item.keytipProps;
        if (keytipProps && itemHasSubmenu) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        return $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: keytipProps,
            ariaDescribedBy: ariaDescribedByIds,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item)
        }, function(keytipAttributes) {
            return $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: _this._btn
            }, buttonNativeProperties, itemButtonProperties, keytipAttributes), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                componentRef: item.componentRef,
                item: item,
                classNames: classNames,
                index: index,
                onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined,
                hasIcons: hasIcons,
                openSubMenu: openSubMenu,
                dismissSubMenu: dismissSubMenu,
                dismissMenu: dismissMenu,
                getSubmenuTarget: _this._getSubmenuTarget
            }, itemProps)), _this._renderAriaDescription(ariaDescription, classNames.screenReaderText));
        });
    };
    return ContextualMenuButton;
}((0, $91ba163d72302a3e$export$d3035c4985d1b359));



var $acw62 = parcelRequire("acw62");





var $27fd99f118e7d831$export$ffd58b7f6f099a57 = function(props) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var theme = props.theme, getClassNames = props.getClassNames, className = props.className;
    if (!theme) throw new Error('Theme is undefined or null.');
    if (getClassNames) {
        var names = getClassNames(theme);
        return {
            wrapper: [
                names.wrapper
            ],
            divider: [
                names.divider
            ]
        };
    }
    return {
        wrapper: [
            {
                display: 'inline-flex',
                height: '100%',
                alignItems: 'center'
            },
            className
        ],
        divider: [
            {
                width: 1,
                height: '100%',
                backgroundColor: theme.palette.neutralTertiaryAlt
            }
        ]
    };
};



var $acw62 = parcelRequire("acw62");

var $3429e7068f747a3b$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $3429e7068f747a3b$export$9f9dad71c8f84f23 = $acw62.forwardRef(function(props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var styles = props.styles, theme = props.theme, deprecatedGetClassNames = props.getClassNames, className = props.className;
    var classNames = $3429e7068f747a3b$var$getClassNames(styles, {
        theme: theme,
        getClassNames: deprecatedGetClassNames,
        className: className
    });
    return $acw62.createElement("span", {
        className: classNames.wrapper,
        ref: ref
    }, $acw62.createElement("span", {
        className: classNames.divider
    }));
});
$3429e7068f747a3b$export$9f9dad71c8f84f23.displayName = 'VerticalDividerBase';



var $9a7e9b73556051a2$export$8da326e5389a0196 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $3429e7068f747a3b$export$9f9dad71c8f84f23), (0, $27fd99f118e7d831$export$ffd58b7f6f099a57), undefined, {
    scope: 'VerticalDivider'
});



var $d0192128ae91cb03$var$TouchIdleDelay = 500; /* ms */ 
var $d0192128ae91cb03$export$6b814188c716a895 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContextualMenuSplitButton, _super);
    function ContextualMenuSplitButton(props) {
        var _this = _super.call(this, props) || this;
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._onItemKeyDown = function(ev) {
            var _a = _this.props, item = _a.item, onItemKeyDown = _a.onItemKeyDown;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter) {
                _this._executeItemClick(ev);
                ev.preventDefault();
                ev.stopPropagation();
            } else if (onItemKeyDown) onItemKeyDown(item, ev);
        };
        _this._getSubmenuTarget = function() {
            return _this._splitButton;
        };
        _this._renderAriaDescription = function(ariaDescription, className) {
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan
            return ariaDescription ? $acw62.createElement("span", {
                id: _this._ariaDescriptionId,
                className: className
            }, ariaDescription) : null;
        };
        _this._onItemMouseEnterPrimary = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) onItemMouseEnter((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, item), {
                subMenuProps: undefined,
                items: undefined
            }), ev, _this._splitButton);
        };
        _this._onItemMouseEnterIcon = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseEnter = _a.onItemMouseEnter;
            if (onItemMouseEnter) onItemMouseEnter(item, ev, _this._splitButton);
        };
        _this._onItemMouseMovePrimary = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) onItemMouseMove((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, item), {
                subMenuProps: undefined,
                items: undefined
            }), ev, _this._splitButton);
        };
        _this._onItemMouseMoveIcon = function(ev) {
            var _a = _this.props, item = _a.item, onItemMouseMove = _a.onItemMouseMove;
            if (onItemMouseMove) onItemMouseMove(item, ev, _this._splitButton);
        };
        _this._onIconItemClick = function(ev) {
            var _a = _this.props, item = _a.item, onItemClickBase = _a.onItemClickBase;
            if (onItemClickBase) onItemClickBase(item, ev, _this._splitButton ? _this._splitButton : ev.currentTarget);
        };
        _this._executeItemClick = function(ev) {
            var _a = _this.props, item = _a.item, executeItemClick = _a.executeItemClick, onItemClick = _a.onItemClick;
            if (item.disabled || item.isDisabled) return;
            if (_this._processingTouch && !item.canCheck && onItemClick) return onItemClick(item, ev);
            if (executeItemClick) executeItemClick(item, ev);
        };
        _this._onTouchStart = function(ev) {
            if (_this._splitButton && !('onpointerdown' in _this._splitButton)) _this._handleTouchAndPointerEvent(ev);
        };
        _this._onPointerDown = function(ev) {
            if (ev.pointerType === 'touch') {
                _this._handleTouchAndPointerEvent(ev);
                ev.preventDefault();
                ev.stopImmediatePropagation();
            }
        };
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        _this._dismissLabelId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        return _this;
    }
    ContextualMenuSplitButton.prototype.componentDidMount = function() {
        if (this._splitButton && 'onpointerdown' in this._splitButton) this._events.on(this._splitButton, 'pointerdown', this._onPointerDown, true);
    };
    ContextualMenuSplitButton.prototype.componentWillUnmount = function() {
        this._async.dispose();
        this._events.dispose();
    };
    ContextualMenuSplitButton.prototype.render = function() {
        var _this = this;
        var _a;
        var _b = this.props, item = _b.item, classNames = _b.classNames, index = _b.index, focusableElementIndex = _b.focusableElementIndex, totalItemCount = _b.totalItemCount, hasCheckmarks = _b.hasCheckmarks, hasIcons = _b.hasIcons, onItemMouseLeave = _b.onItemMouseLeave, expandedMenuItemKey = _b.expandedMenuItemKey;
        var itemHasSubmenu = (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item);
        var keytipProps = item.keytipProps;
        if (keytipProps) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        // Check for ariaDescription to set the _ariaDescriptionId and render a hidden span with
        // the description in it to be added to ariaDescribedBy
        var ariaDescription = item.ariaDescription;
        if (ariaDescription) this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        var ariaChecked = (_a = (0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item)) !== null && _a !== void 0 ? _a : undefined;
        return $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: keytipProps,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item)
        }, function(keytipAttributes) {
            return $acw62.createElement("div", {
                "data-ktp-target": keytipAttributes['data-ktp-target'],
                ref: function(splitButton) {
                    _this._splitButton = splitButton;
                },
                role: (0, $3250824b6f1d23dc$export$84bfff8e7c9de691)(item),
                "aria-label": item.ariaLabel,
                className: classNames.splitContainer,
                "aria-disabled": (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
                "aria-expanded": itemHasSubmenu ? item.key === expandedMenuItemKey : undefined,
                "aria-haspopup": true,
                "aria-describedby": (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(item.ariaDescribedBy, ariaDescription ? _this._ariaDescriptionId : undefined, keytipAttributes['aria-describedby']),
                "aria-checked": ariaChecked,
                "aria-posinset": focusableElementIndex + 1,
                "aria-setsize": totalItemCount,
                onMouseEnter: _this._onItemMouseEnterPrimary,
                onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(_this, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, item), {
                    subMenuProps: null,
                    items: null
                })) : undefined,
                onMouseMove: _this._onItemMouseMovePrimary,
                onKeyDown: _this._onItemKeyDown,
                onClick: _this._executeItemClick,
                onTouchStart: _this._onTouchStart,
                tabIndex: 0,
                "data-is-focusable": true,
                "aria-roledescription": item['aria-roledescription']
            }, _this._renderSplitPrimaryButton(item, classNames, index, hasCheckmarks, hasIcons), _this._renderSplitDivider(item), _this._renderSplitIconButton(item, classNames, index, keytipAttributes), _this._renderAriaDescription(ariaDescription, classNames.screenReaderText));
        });
    };
    ContextualMenuSplitButton.prototype._renderSplitPrimaryButton = function(item, // eslint-disable-next-line @typescript-eslint/no-deprecated
    classNames, index, hasCheckmarks, hasIcons) {
        var _a = this.props, _b = _a.contextualMenuItemAs, ChildrenRenderer = _b === void 0 ? (0, $dbc0d5833638f24e$export$4267af6d9e6f3487) : _b, onItemClick = _a.onItemClick;
        var itemProps = {
            key: item.key,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item) || item.primaryDisabled,
            /* eslint-disable @typescript-eslint/no-deprecated */ name: item.name,
            text: item.text || item.name,
            secondaryText: item.secondaryText,
            /* eslint-enable @typescript-eslint/no-deprecated */ className: classNames.splitPrimary,
            canCheck: item.canCheck,
            isChecked: item.isChecked,
            checked: item.checked,
            iconProps: item.iconProps,
            id: this._dismissLabelId,
            onRenderIcon: item.onRenderIcon,
            data: item.data,
            'data-is-focusable': false
        };
        var itemComponentProps = item.itemProps;
        return $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(itemProps, (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4))), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            "data-is-focusable": false,
            item: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, itemProps), {
                onClick: item.onClick
            }),
            classNames: classNames,
            index: index,
            onCheckmarkClick: hasCheckmarks && onItemClick ? onItemClick : undefined,
            hasIcons: hasIcons
        }, itemComponentProps)));
    };
    ContextualMenuSplitButton.prototype._renderSplitDivider = function(item) {
        var getDividerClassNames = item.getSplitButtonVerticalDividerClassNames || (0, $b0ea91f2e2fa7180$export$c554b00c240727fe);
        return $acw62.createElement((0, $9a7e9b73556051a2$export$8da326e5389a0196), {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            getClassNames: getDividerClassNames
        });
    };
    ContextualMenuSplitButton.prototype._renderSplitIconButton = function(item, classNames, index, keytipAttributes) {
        var _a = this.props, onItemMouseLeave = _a.onItemMouseLeave, onItemMouseDown = _a.onItemMouseDown, openSubMenu = _a.openSubMenu, dismissSubMenu = _a.dismissSubMenu, dismissMenu = _a.dismissMenu;
        var ChildrenRenderer = (0, $dbc0d5833638f24e$export$4267af6d9e6f3487);
        if (this.props.item.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(this.props.item.contextualMenuItemAs, ChildrenRenderer);
        if (this.props.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(this.props.contextualMenuItemAs, ChildrenRenderer);
        var itemProps = {
            onClick: this._onIconItemClick,
            disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
            className: classNames.splitMenu,
            subMenuProps: item.subMenuProps,
            submenuIconProps: item.submenuIconProps,
            split: true,
            key: item.key,
            'aria-labelledby': this._dismissLabelId
        };
        var buttonProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(itemProps, (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4))), {
            onMouseEnter: this._onItemMouseEnterIcon,
            onMouseLeave: onItemMouseLeave ? onItemMouseLeave.bind(this, item) : undefined,
            onMouseDown: function(ev) {
                return onItemMouseDown ? onItemMouseDown(item, ev) : undefined;
            },
            onMouseMove: this._onItemMouseMoveIcon,
            'data-is-focusable': false,
            'data-ktp-execute-target': keytipAttributes['data-ktp-execute-target'],
            'aria-haspopup': true
        });
        var itemComponentProps = item.itemProps;
        return $acw62.createElement("button", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, buttonProps), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            componentRef: item.componentRef,
            item: itemProps,
            classNames: classNames,
            index: index,
            hasIcons: false,
            openSubMenu: openSubMenu,
            dismissSubMenu: dismissSubMenu,
            dismissMenu: dismissMenu,
            getSubmenuTarget: this._getSubmenuTarget
        }, itemComponentProps)));
    };
    ContextualMenuSplitButton.prototype._handleTouchAndPointerEvent = function(ev) {
        var _this = this;
        var onTap = this.props.onTap;
        if (onTap) onTap(ev);
        // If we already have an existing timeout from a previous touch/pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function() {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
        }, $d0192128ae91cb03$var$TouchIdleDelay);
    };
    return ContextualMenuSplitButton;
}((0, $91ba163d72302a3e$export$d3035c4985d1b359));





parcelRequire("acw62");



var $e896b2d9c1302e32$var$warningId = 0;
function $e896b2d9c1302e32$export$8aeb3a0795e619c9(options) {
    var name_1, props, _a, other, conditionallyRequired, deprecations, mutuallyExclusive, controlledUsage, hasWarnedRef, componentId, oldProps, _i, other_1, warning, _b, conditionallyRequired_1, req;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $0d6bc61d290491ae$var$REACT_LIFECYCLE_EXCLUSIONS = [
    'setState',
    'render',
    'componentWillMount',
    'UNSAFE_componentWillMount',
    'componentDidMount',
    'componentWillReceiveProps',
    'UNSAFE_componentWillReceiveProps',
    'shouldComponentUpdate',
    'componentWillUpdate',
    'getSnapshotBeforeUpdate',
    'UNSAFE_componentWillUpdate',
    'componentDidUpdate',
    'componentWillUnmount'
];
function $0d6bc61d290491ae$export$1cf09497260991e2(// eslint-disable-next-line @typescript-eslint/no-explicit-any
destination, // eslint-disable-next-line @typescript-eslint/no-explicit-any
source, exclusions) {
    if (exclusions === void 0) exclusions = $0d6bc61d290491ae$var$REACT_LIFECYCLE_EXCLUSIONS;
    var hoisted = [];
    var _loop_1 = function(methodName) {
        if (typeof source[methodName] === 'function' && destination[methodName] === undefined && (!exclusions || exclusions.indexOf(methodName) === -1)) {
            hoisted.push(methodName);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            destination[methodName] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                source[methodName].apply(source, args);
            };
        }
    };
    for(var methodName in source)_loop_1(methodName);
    return hoisted;
}
function $0d6bc61d290491ae$export$25de49fa50223d1(source, methodNames) {
    methodNames.forEach(function(methodName) {
        return delete source[methodName];
    });
}


var $e763806f79fb847c$export$949383f3ea84aa97 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseDecorator, _super);
    function BaseDecorator(props) {
        var _this = _super.call(this, props) || this;
        _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
        return _this;
    }
    /**
     * Updates the ref to the component composed by the decorator, which will also take care of hoisting
     * (and unhoisting as appropriate) methods from said component.
     *
     * Pass this method as the argument to the 'ref' property of the composed component.
     */ BaseDecorator.prototype._updateComposedComponentRef = function(composedComponentInstance) {
        this._composedComponentInstance = composedComponentInstance;
        if (composedComponentInstance) this._hoisted = (0, $0d6bc61d290491ae$export$1cf09497260991e2)(this, composedComponentInstance);
        else if (this._hoisted) (0, $0d6bc61d290491ae$export$25de49fa50223d1)(this, this._hoisted);
    };
    return BaseDecorator;
}($acw62.Component);


/**
 * Allows you to hoist static functions in components.
 * Created for the purpose of fixing broken static functions in classes
 * that utilize decorators.
 *
 * @public
 * @param source - The object where the methods are hoisted from.
 * @param dest - The object to hoist the methods onto.
 * @returns The dest object with methods added
 */ function $05b03fe0c0fe3377$export$e2ba2733092cef57(source, dest) {
    for(var name_1 in source)if (source.hasOwnProperty(name_1)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[name_1] = source[name_1];
    return dest;
}



var $d2efee541c4fc734$export$73c2705cb2da08ab;
(function(ResponsiveMode) {
    /** Width \<= 479px */ ResponsiveMode[ResponsiveMode["small"] = 0] = "small";
    /** Width \> 479px and \<= 639px */ ResponsiveMode[ResponsiveMode["medium"] = 1] = "medium";
    /** Width \> 639px and \<= 1023px */ ResponsiveMode[ResponsiveMode["large"] = 2] = "large";
    /** Width \> 1023px and \<= 1365px */ ResponsiveMode[ResponsiveMode["xLarge"] = 3] = "xLarge";
    /** Width \> 1365px and \<= 1919px */ ResponsiveMode[ResponsiveMode["xxLarge"] = 4] = "xxLarge";
    /** Width \> 1919px */ ResponsiveMode[ResponsiveMode["xxxLarge"] = 5] = "xxxLarge";
    ResponsiveMode[ResponsiveMode["unknown"] = 999] = "unknown";
})($d2efee541c4fc734$export$73c2705cb2da08ab || ($d2efee541c4fc734$export$73c2705cb2da08ab = {}));
var $d2efee541c4fc734$var$RESPONSIVE_MAX_CONSTRAINT = [
    479,
    639,
    1023,
    1365,
    1919,
    99999999
];
/**
 * User specified mode to default to, useful for server side rendering scenarios.
 */ var $d2efee541c4fc734$var$_defaultMode;
/**
 * Tracking the last mode we successfully rendered, which allows us to
 * paint initial renders with the correct size.
 */ var $d2efee541c4fc734$var$_lastMode;
function $d2efee541c4fc734$export$1a7882a876dfdc7d(responsiveMode) {
    $d2efee541c4fc734$var$_defaultMode = responsiveMode;
}
function $d2efee541c4fc734$export$8eb25712ef612ed1(element) {
    var currentWindow = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(element);
    if (currentWindow) $d2efee541c4fc734$export$26286068bf03da16(currentWindow);
}
function $d2efee541c4fc734$export$71e9890600a902c8() {
    var _a;
    return (_a = $d2efee541c4fc734$var$_defaultMode !== null && $d2efee541c4fc734$var$_defaultMode !== void 0 ? $d2efee541c4fc734$var$_defaultMode : $d2efee541c4fc734$var$_lastMode) !== null && _a !== void 0 ? _a : $d2efee541c4fc734$export$73c2705cb2da08ab.large;
}
function $d2efee541c4fc734$export$a0079cc4280057ef(ComposedComponent) {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var resultClass = (_a = /** @class */ function(_super) {
        (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(WithResponsiveMode, _super);
        function WithResponsiveMode(props) {
            var _this = _super.call(this, props) || this;
            _this._onResize = function() {
                var responsiveMode = $d2efee541c4fc734$export$26286068bf03da16(_this.context.window);
                if (responsiveMode !== _this.state.responsiveMode) _this.setState({
                    responsiveMode: responsiveMode
                });
            };
            _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
            _this._updateComposedComponentRef = _this._updateComposedComponentRef.bind(_this);
            _this.state = {
                responsiveMode: $d2efee541c4fc734$export$71e9890600a902c8()
            };
            return _this;
        }
        WithResponsiveMode.prototype.componentDidMount = function() {
            this._events.on(this.context.window, 'resize', this._onResize);
            this._onResize();
        };
        WithResponsiveMode.prototype.componentWillUnmount = function() {
            this._events.dispose();
        };
        WithResponsiveMode.prototype.render = function() {
            var responsiveMode = this.state.responsiveMode;
            return responsiveMode === $d2efee541c4fc734$export$73c2705cb2da08ab.unknown ? null : $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                ref: this._updateComposedComponentRef,
                responsiveMode: responsiveMode
            }, this.props));
        };
        return WithResponsiveMode;
    }((0, $e763806f79fb847c$export$949383f3ea84aa97)), _a.contextType = (0, $b139ba3b4431b53f$export$19f5fbe41bba757), _a);
    return (0, $05b03fe0c0fe3377$export$e2ba2733092cef57)(ComposedComponent, resultClass);
}
function $d2efee541c4fc734$var$getWidthOfCurrentWindow(currentWindow) {
    try {
        return currentWindow.document.documentElement.clientWidth;
    } catch (e) {
        return currentWindow.innerWidth;
    }
}
function $d2efee541c4fc734$export$26286068bf03da16(currentWindow) {
    var responsiveMode = $d2efee541c4fc734$export$73c2705cb2da08ab.small;
    if (currentWindow) {
        try {
            while($d2efee541c4fc734$var$getWidthOfCurrentWindow(currentWindow) > $d2efee541c4fc734$var$RESPONSIVE_MAX_CONSTRAINT[responsiveMode])responsiveMode++;
        } catch (e) {
            // Return a best effort result in cases where we're in the browser but it throws on getting innerWidth.
            responsiveMode = $d2efee541c4fc734$export$71e9890600a902c8();
        }
        // Tracking last mode just gives us a better default in future renders,
        // which avoids starting with the wrong value if we've measured once.
        $d2efee541c4fc734$var$_lastMode = responsiveMode;
    } else {
        if ($d2efee541c4fc734$var$_defaultMode !== undefined) responsiveMode = $d2efee541c4fc734$var$_defaultMode;
        else throw new Error("Content was rendered in a server environment without providing a default responsive mode. Call setResponsiveMode to define what the responsive mode is.");
    }
    return responsiveMode;
}


var $acw62 = parcelRequire("acw62");




var $6124a3d3c764767c$export$551dad37f2b289e2 = function(elementRef, overrideResponsiveMode) {
    var _a = $acw62.useState((0, $d2efee541c4fc734$export$71e9890600a902c8)()), lastResponsiveMode = _a[0], setLastResponsiveMode = _a[1];
    var onResize = $acw62.useCallback(function() {
        var newResponsiveMode = (0, $d2efee541c4fc734$export$26286068bf03da16)((0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(elementRef.current));
        // Setting the same value should not cause a re-render.
        if (lastResponsiveMode !== newResponsiveMode) setLastResponsiveMode(newResponsiveMode);
    }, [
        elementRef,
        lastResponsiveMode
    ]);
    var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    (0, $5fe1a153d9a941d2$export$2bc3860deec8a08f)(win, 'resize', onResize);
    // Call resize function initially on mount, or if the override changes from defined to undefined
    // (the effect will run on all override changes, but onResize will only be called if it changed to undefined)
    $acw62.useEffect(function() {
        if (overrideResponsiveMode === undefined) onResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only meant to run on mount or when override changes
    }, [
        overrideResponsiveMode
    ]);
    return overrideResponsiveMode !== null && overrideResponsiveMode !== void 0 ? overrideResponsiveMode : lastResponsiveMode;
};



var $acw62 = parcelRequire("acw62");
var $247bbbbcfb0b71e2$export$c7e742effb1c51e2 = $acw62.createContext({});
var $247bbbbcfb0b71e2$export$21c7ab35b39f78ec = function() {
    return $acw62.useContext($247bbbbcfb0b71e2$export$c7e742effb1c51e2);
};


var $1f9efb1806e6b3c0$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $1f9efb1806e6b3c0$var$getContextualMenuItemClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
// The default ContextualMenu properties have no items and beak, the default submenu direction is right and top.
var $1f9efb1806e6b3c0$var$DEFAULT_PROPS = {
    items: [],
    shouldFocusOnMount: true,
    gapSpace: 0,
    directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomAutoEdge,
    beakWidth: 16
};
/* return number of menu items, excluding headers and dividers */ function $1f9efb1806e6b3c0$var$getItemCount(items) {
    var totalItemCount = 0;
    for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
        var item = items_1[_i];
        if (item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider && item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header) {
            var itemCount = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
            totalItemCount += itemCount;
        }
    }
    return totalItemCount;
}
function $1f9efb1806e6b3c0$export$291de058395e0a1c(item, options) {
    var target = options === null || options === void 0 ? void 0 : options.target;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    var items = item.subMenuProps ? item.subMenuProps.items : item.items;
    if (items) {
        var overrideItems = [];
        for(var _i = 0, items_2 = items; _i < items_2.length; _i++){
            var subItem = items_2[_i];
            if (subItem.preferMenuTargetAsEventTarget) {
                // For sub-items which need an overridden target, intercept `onClick`
                var onClick = subItem.onClick, contextItem = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(subItem, [
                    "onClick"
                ]);
                overrideItems.push((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, contextItem), {
                    onClick: $1f9efb1806e6b3c0$var$getOnClickWithOverrideTarget(onClick, target)
                }));
            } else overrideItems.push(subItem);
        }
        return overrideItems;
    }
}
function $1f9efb1806e6b3c0$export$2a1d7a07e590a159(items) {
    return items.some(function(item) {
        if (item.canCheck) return true;
        // If the item is a section, check if any of the items in the section can check.
        if (item.sectionProps && item.sectionProps.items.some(function(submenuItem) {
            return submenuItem.canCheck === true;
        })) return true;
        return false;
    });
}
var $1f9efb1806e6b3c0$var$NavigationIdleDelay = 250; /* ms */ 
var $1f9efb1806e6b3c0$var$COMPONENT_NAME = 'ContextualMenu';
var $1f9efb1806e6b3c0$var$_getMenuItemStylesFunction = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function() {
    var styles = [];
    for(var _i = 0; _i < arguments.length; _i++)styles[_i] = arguments[_i];
    return function(styleProps) {
        return (0, $386ae5a2cd0e8632$export$5136bfd779f95982).apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            styleProps,
            (0, $b0ea91f2e2fa7180$export$68f648f9dd4d8263)
        ], styles, false));
    };
});
//#region Custom hooks
function $1f9efb1806e6b3c0$var$useVisibility(props, targetWindow) {
    var _a = props.hidden, hidden = _a === void 0 ? false : _a, onMenuDismissed = props.onMenuDismissed, onMenuOpened = props.onMenuOpened;
    var previousHidden = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(hidden);
    var onMenuOpenedRef = $acw62.useRef(onMenuOpened);
    var onMenuClosedRef = $acw62.useRef(onMenuDismissed);
    var propsRef = $acw62.useRef(props);
    onMenuOpenedRef.current = onMenuOpened;
    onMenuClosedRef.current = onMenuDismissed;
    propsRef.current = props;
    $acw62.useEffect(function() {
        var _a, _b;
        // Don't issue dismissed callbacks on initial mount
        if (hidden && previousHidden === false) (_a = onMenuClosedRef.current) === null || _a === void 0 || _a.call(onMenuClosedRef, propsRef.current);
        else if (!hidden && previousHidden !== false) (_b = onMenuOpenedRef.current) === null || _b === void 0 || _b.call(onMenuOpenedRef, propsRef.current);
    }, [
        hidden,
        previousHidden
    ]);
    // Issue onDismissedCallback on unmount
    $acw62.useEffect(function() {
        return function() {
            var _a;
            return (_a = onMenuClosedRef.current) === null || _a === void 0 ? void 0 : _a.call(onMenuClosedRef, propsRef.current);
        };
    }, []);
}
function $1f9efb1806e6b3c0$var$useSubMenuState(_a, dismiss) {
    var hidden = _a.hidden, items = _a.items, theme = _a.theme, className = _a.className, id = _a.id, menuTarget = _a.target;
    var _b = $acw62.useState(), expandedMenuItemKey = _b[0], setExpandedMenuItemKey = _b[1];
    var _c = $acw62.useState(), submenuTarget = _c[0], setSubmenuTarget = _c[1];
    /** True if the menu was expanded by mouse click OR hover (as opposed to by keyboard) */ var _d = $acw62.useState(), shouldFocusOnContainer = _d[0], setShouldFocusOnContainer = _d[1];
    var subMenuId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)($1f9efb1806e6b3c0$var$COMPONENT_NAME, id);
    var closeSubMenu = $acw62.useCallback(function() {
        setShouldFocusOnContainer(undefined);
        setExpandedMenuItemKey(undefined);
        setSubmenuTarget(undefined);
    }, []);
    var openSubMenu = $acw62.useCallback(function(_a, target, focusContainer) {
        var submenuItemKey = _a.key;
        if (expandedMenuItemKey === submenuItemKey) return;
        target.focus();
        setShouldFocusOnContainer(focusContainer);
        setExpandedMenuItemKey(submenuItemKey);
        setSubmenuTarget(target);
    }, [
        expandedMenuItemKey
    ]);
    $acw62.useEffect(function() {
        if (hidden) closeSubMenu();
    }, [
        hidden,
        closeSubMenu
    ]);
    var onSubMenuDismiss = $1f9efb1806e6b3c0$var$useOnSubmenuDismiss(dismiss, closeSubMenu);
    var getSubmenuProps = function() {
        var item = $1f9efb1806e6b3c0$var$findItemByKeyFromItems(expandedMenuItemKey, items);
        var submenuProps = null;
        if (item) {
            submenuProps = {
                items: $1f9efb1806e6b3c0$export$291de058395e0a1c(item, {
                    target: menuTarget
                }),
                target: submenuTarget,
                onDismiss: onSubMenuDismiss,
                isSubMenu: true,
                id: subMenuId,
                shouldFocusOnMount: true,
                shouldFocusOnContainer: shouldFocusOnContainer,
                directionalHint: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? (0, $e52f208cfc343b11$export$7bbc434a13063638).leftTopEdge : (0, $e52f208cfc343b11$export$7bbc434a13063638).rightTopEdge,
                className: className,
                gapSpace: 0,
                isBeakVisible: false
            };
            if (item.subMenuProps) (0, $f504d2279336999d$export$e6e34fd1f2686227)(submenuProps, item.subMenuProps);
            if (item.preferMenuTargetAsEventTarget) {
                var onItemClick = item.onItemClick;
                submenuProps.onItemClick = $1f9efb1806e6b3c0$var$getOnClickWithOverrideTarget(onItemClick, menuTarget);
            }
        }
        return submenuProps;
    };
    return [
        expandedMenuItemKey,
        openSubMenu,
        getSubmenuProps,
        onSubMenuDismiss
    ];
}
function $1f9efb1806e6b3c0$var$useShouldUpdateFocusOnMouseMove(_a) {
    var delayUpdateFocusOnHover = _a.delayUpdateFocusOnHover, hidden = _a.hidden;
    var shouldUpdateFocusOnMouseEvent = $acw62.useRef(!delayUpdateFocusOnHover);
    var gotMouseMove = $acw62.useRef(false);
    $acw62.useEffect(function() {
        shouldUpdateFocusOnMouseEvent.current = !delayUpdateFocusOnHover;
        gotMouseMove.current = hidden ? false : !delayUpdateFocusOnHover && gotMouseMove.current;
    }, [
        delayUpdateFocusOnHover,
        hidden
    ]);
    var onMenuFocusCapture = $acw62.useCallback(function() {
        if (delayUpdateFocusOnHover) shouldUpdateFocusOnMouseEvent.current = false;
    }, [
        delayUpdateFocusOnHover
    ]);
    return [
        shouldUpdateFocusOnMouseEvent,
        gotMouseMove,
        onMenuFocusCapture
    ];
}
function $1f9efb1806e6b3c0$var$usePreviousActiveElement(_a, targetWindow, hostElement) {
    var hidden = _a.hidden, onRestoreFocus = _a.onRestoreFocus;
    var previousActiveElement = $acw62.useRef(undefined);
    var tryFocusPreviousActiveElement = $acw62.useCallback(function(options) {
        var _a, _b;
        if (onRestoreFocus) onRestoreFocus(options);
        else if (options === null || options === void 0 ? void 0 : options.documentContainsFocus) // Make sure that the focus method actually exists
        // In some cases the object might exist but not be a real element.
        // This is primarily for IE 11 and should be removed once IE 11 is no longer in use.
        (_b = (_a = previousActiveElement.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
    }, [
        onRestoreFocus
    ]);
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        var _a, _b;
        if (!hidden) {
            var newElement = targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.activeElement;
            if (!((_a = hostElement.current) === null || _a === void 0 ? void 0 : _a.contains(newElement)) && newElement.tagName !== 'BODY') previousActiveElement.current = newElement;
        } else if (previousActiveElement.current) {
            tryFocusPreviousActiveElement({
                originalElement: previousActiveElement.current,
                containsFocus: true,
                documentContainsFocus: ((_b = (0, $6787cc90d6254b3e$export$f65ca476c09acec0)()) === null || _b === void 0 ? void 0 : _b.hasFocus()) || false
            });
            previousActiveElement.current = undefined;
        }
    }, [
        hidden,
        targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.activeElement,
        tryFocusPreviousActiveElement,
        hostElement
    ]);
    return [
        tryFocusPreviousActiveElement
    ];
}
function $1f9efb1806e6b3c0$var$useKeyHandlers(_a, dismiss, hostElement, openSubMenu) {
    var theme = _a.theme, isSubMenu = _a.isSubMenu, _b = _a.focusZoneProps, _c = _b === void 0 ? {} : _b, checkForNoWrap = _c.checkForNoWrap, _d = _c.direction, focusZoneDirection = _d === void 0 ? (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical : _d;
    /** True if the most recent keydown event was for alt (option) or meta (command). */ var lastKeyDownWasAltOrMeta = $acw62.useRef(undefined);
    /**
     * Calls `shouldHandleKey` to determine whether the keyboard event should be handled;
     * if so, stops event propagation and dismisses menu(s).
     * @param ev - The keyboard event.
     * @param shouldHandleKey - Returns whether we should handle this keyboard event.
     * @param dismissAllMenus - If true, dismiss all menus. Otherwise, dismiss only the current menu.
     * Only does anything if `shouldHandleKey` returns true.
     * @returns Whether the event was handled.
     */ var keyHandler = function(ev, shouldHandleKey, dismissAllMenus) {
        var handled = false;
        if (shouldHandleKey(ev)) {
            dismiss(ev, dismissAllMenus);
            ev.preventDefault();
            ev.stopPropagation();
            handled = true;
        }
        return handled;
    };
    /**
     * Checks if the submenu should be closed
     */ var shouldCloseSubMenu = function(ev) {
        var submenuCloseKey = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? (0, $c011a102064f82ea$export$ec835b702d42f3f0).right : (0, $c011a102064f82ea$export$ec835b702d42f3f0).left;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (ev.which !== submenuCloseKey || !isSubMenu) return false;
        return !!(focusZoneDirection === (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical || checkForNoWrap && !(0, $94bdc1ebed789608$export$841acbea7fb3b182)(ev.target, 'data-no-horizontal-wrap'));
    };
    var shouldHandleKeyDown = function(ev) {
        return(// eslint-disable-next-line @typescript-eslint/no-deprecated
        ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape || shouldCloseSubMenu(ev) || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up && (ev.altKey || ev.metaKey));
    };
    var onKeyDown = function(ev) {
        // Take note if we are processing an alt (option) or meta (command) keydown.
        // See comment in shouldHandleKeyUp for reasoning.
        lastKeyDownWasAltOrMeta.current = $1f9efb1806e6b3c0$var$isAltOrMeta(ev);
        // On Mac, pressing escape dismisses all levels of native context menus
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var dismissAllMenus = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape && ((0, $46def017ce9f8d16$export$9ac100e40613ea10)() || (0, $865faf0b4151a9c6$export$fedb369cb70207f1)());
        return keyHandler(ev, shouldHandleKeyDown, dismissAllMenus);
    };
    /**
     * We close the menu on key up only if ALL of the following are true:
     * - Most recent key down was alt or meta (command)
     * - The alt/meta key down was NOT followed by some other key (such as down/up arrow to
     *   expand/collapse the menu)
     * - We're not on a Mac (or iOS)
     *
     * This is because on Windows, pressing alt moves focus to the application menu bar or similar,
     * closing any open context menus. There is not a similar behavior on Macs.
     */ var shouldHandleKeyUp = function(ev) {
        var keyPressIsAltOrMetaAlone = lastKeyDownWasAltOrMeta.current && $1f9efb1806e6b3c0$var$isAltOrMeta(ev);
        lastKeyDownWasAltOrMeta.current = false;
        return !!keyPressIsAltOrMetaAlone && !((0, $865faf0b4151a9c6$export$fedb369cb70207f1)() || (0, $46def017ce9f8d16$export$9ac100e40613ea10)());
    };
    var onKeyUp = function(ev) {
        return keyHandler(ev, shouldHandleKeyUp, true);
    };
    var onMenuKeyDown = function(ev) {
        // Mark as handled if onKeyDown returns true (for handling collapse cases)
        // or if we are attempting to expand a submenu
        var handled = onKeyDown(ev);
        if (handled || !hostElement.current) return;
        // If we have a modifier key being pressed, we do not want to move focus.
        // Otherwise, handle up and down keys.
        var hasModifier = !!(ev.altKey || ev.metaKey);
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var isUp = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var isDown = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down;
        if (!hasModifier && (isUp || isDown)) {
            var elementToFocus = isUp ? (0, $94bdc1ebed789608$export$73e81fa65335a75b)(hostElement.current, hostElement.current.lastChild, true) : (0, $94bdc1ebed789608$export$748138f04a69bf21)(hostElement.current, hostElement.current.firstChild, true);
            if (elementToFocus) {
                elementToFocus.focus();
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    };
    var onItemKeyDown = function(item, ev) {
        var openKey = (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme) ? (0, $c011a102064f82ea$export$ec835b702d42f3f0).left : (0, $c011a102064f82ea$export$ec835b702d42f3f0).right;
        if (!item.disabled && // eslint-disable-next-line @typescript-eslint/no-deprecated
        (ev.which === openKey || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down && (ev.altKey || ev.metaKey))) {
            openSubMenu(item, ev.currentTarget);
            ev.preventDefault();
        }
    };
    return [
        onKeyDown,
        onKeyUp,
        onMenuKeyDown,
        onItemKeyDown
    ];
}
function $1f9efb1806e6b3c0$var$useScrollHandler(asyncTracker) {
    var isScrollIdle = $acw62.useRef(true);
    var scrollIdleTimeoutId = $acw62.useRef(undefined);
    /**
     * Scroll handler for the callout to make sure the mouse events
     * for updating focus are not interacting during scroll
     */ var onScroll = function() {
        if (!isScrollIdle.current && scrollIdleTimeoutId.current !== undefined) {
            asyncTracker.clearTimeout(scrollIdleTimeoutId.current);
            scrollIdleTimeoutId.current = undefined;
        } else isScrollIdle.current = false;
        scrollIdleTimeoutId.current = asyncTracker.setTimeout(function() {
            isScrollIdle.current = true;
        }, $1f9efb1806e6b3c0$var$NavigationIdleDelay);
    };
    return [
        onScroll,
        isScrollIdle
    ];
}
function $1f9efb1806e6b3c0$var$useOnSubmenuDismiss(dismiss, closeSubMenu) {
    var isMountedRef = $acw62.useRef(false);
    $acw62.useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    /**
     * This function is called ASYNCHRONOUSLY, and so there is a chance it is called
     * after the component is unmounted. The isMountedRef is added to prevent
     * from calling setState() after unmount. Do NOT copy this pattern in synchronous
     * code.
     */ var onSubMenuDismiss = function(ev, dismissAll) {
        if (dismissAll) dismiss(ev, dismissAll);
        else if (isMountedRef.current) closeSubMenu();
    };
    return onSubMenuDismiss;
}
function $1f9efb1806e6b3c0$var$useSubmenuEnterTimer(_a, asyncTracker) {
    var _b = _a.subMenuHoverDelay, subMenuHoverDelay = _b === void 0 ? $1f9efb1806e6b3c0$var$NavigationIdleDelay : _b;
    var enterTimerRef = $acw62.useRef(undefined);
    var cancelSubMenuTimer = function() {
        if (enterTimerRef.current !== undefined) {
            asyncTracker.clearTimeout(enterTimerRef.current);
            enterTimerRef.current = undefined;
        }
    };
    var startSubmenuTimer = function(onTimerExpired) {
        enterTimerRef.current = asyncTracker.setTimeout(function() {
            onTimerExpired();
            cancelSubMenuTimer();
        }, subMenuHoverDelay);
    };
    return [
        cancelSubMenuTimer,
        startSubmenuTimer,
        enterTimerRef
    ];
}
function $1f9efb1806e6b3c0$var$useMouseHandlers(props, // eslint-disable-next-line @typescript-eslint/no-deprecated
isScrollIdle, subMenuEntryTimer, targetWindow, // eslint-disable-next-line @typescript-eslint/no-deprecated
shouldUpdateFocusOnMouseEvent, // eslint-disable-next-line @typescript-eslint/no-deprecated
gotMouseMove, expandedMenuItemKey, hostElement, startSubmenuTimer, cancelSubMenuTimer, openSubMenu, onSubMenuDismiss, dismiss) {
    var menuTarget = props.target;
    var onItemMouseEnterBase = function(item, ev, target) {
        if (shouldUpdateFocusOnMouseEvent.current) gotMouseMove.current = true;
        if (shouldIgnoreMouseEvent()) return;
        updateFocusOnMouseEvent(item, ev, target);
    };
    var onItemMouseMoveBase = function(item, ev, target) {
        var targetElement = ev.currentTarget;
        // Always do this check to make sure we record a mouseMove if needed (even if we are timed out)
        if (shouldUpdateFocusOnMouseEvent.current) gotMouseMove.current = true;
        else return;
        if (!isScrollIdle.current || subMenuEntryTimer.current !== undefined || targetElement === (targetWindow === null || targetWindow === void 0 ? void 0 : targetWindow.document.activeElement)) return;
        updateFocusOnMouseEvent(item, ev, target);
    };
    var shouldIgnoreMouseEvent = function() {
        return !isScrollIdle.current || !gotMouseMove.current;
    };
    var onMouseItemLeave = function(item, ev) {
        var _a;
        if (shouldIgnoreMouseEvent()) return;
        cancelSubMenuTimer();
        if (expandedMenuItemKey !== undefined) return;
        /**
         * IE11 focus() method forces parents to scroll to top of element.
         * Edge and IE expose a setActive() function for focusable divs that
         * sets the page focus but does not scroll the parent element.
         */ if (hostElement.current.setActive) try {
            hostElement.current.setActive();
        } catch (e) {
        /* no-op */ }
        else (_a = hostElement.current) === null || _a === void 0 || _a.focus();
    };
    /**
     * Handles updating focus when mouseEnter or mouseMove fire.
     * As part of updating focus, This function will also update
     * the expand/collapse state accordingly.
     */ var updateFocusOnMouseEvent = function(item, ev, target) {
        var targetElement = target ? target : ev.currentTarget;
        if (item.key === expandedMenuItemKey) return;
        cancelSubMenuTimer();
        // If the menu is not expanded we can update focus without any delay
        if (expandedMenuItemKey === undefined) targetElement.focus();
        // Delay updating expanding/dismissing the submenu
        // and only set focus if we have not already done so
        if ((0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item)) {
            ev.stopPropagation();
            startSubmenuTimer(function() {
                targetElement.focus();
                openSubMenu(item, targetElement, true);
            });
        } else startSubmenuTimer(function() {
            onSubMenuDismiss(ev);
            targetElement.focus();
        });
    };
    var onItemClick = function(item, ev) {
        onItemClickBase(item, ev, ev.currentTarget);
    };
    var onItemClickBase = function(item, ev, target) {
        var items = $1f9efb1806e6b3c0$export$291de058395e0a1c(item, {
            target: menuTarget
        });
        // Cancel an async menu item hover timeout action from being taken and instead
        // just trigger the click event instead.
        cancelSubMenuTimer();
        if (!(0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item) && (!items || !items.length)) // This is an item without a menu. Click it.
        executeItemClick(item, ev);
        else if (item.key !== expandedMenuItemKey) {
            // This has a collapsed sub menu. Expand it.
            // focus on the container by default when the menu is opened with a click event
            // this differentiates from a keyboard interaction triggering the click event
            var shouldFocusOnContainer = typeof props.shouldFocusOnContainer === 'boolean' ? props.shouldFocusOnContainer : ev.nativeEvent.pointerType === 'mouse';
            openSubMenu(item, target, shouldFocusOnContainer);
        }
        ev.stopPropagation();
        ev.preventDefault();
    };
    var onAnchorClick = function(item, ev) {
        executeItemClick(item, ev);
        ev.stopPropagation();
    };
    var executeItemClick = function(item, ev) {
        if (item.disabled || item.isDisabled) return;
        if (item.preferMenuTargetAsEventTarget) $1f9efb1806e6b3c0$var$overrideTarget(ev, menuTarget);
        var shouldDismiss = false;
        if (item.onClick) shouldDismiss = !!item.onClick(ev, item);
        else if (props.onItemClick) shouldDismiss = !!props.onItemClick(ev, item);
        if (shouldDismiss || !ev.defaultPrevented) dismiss(ev, true);
    };
    return [
        onItemMouseEnterBase,
        onItemMouseMoveBase,
        onMouseItemLeave,
        onItemClick,
        onAnchorClick,
        executeItemClick,
        onItemClickBase
    ];
}
var $1f9efb1806e6b3c0$export$6a869745b5bc3200 = $acw62.memo($acw62.forwardRef(function(propsWithoutDefaults, forwardedRef) {
    var _a;
    var _b = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($1f9efb1806e6b3c0$var$DEFAULT_PROPS, propsWithoutDefaults), ref = _b.ref, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_b, [
        "ref"
    ]);
    var hostElement = $acw62.useRef(null);
    var asyncTracker = (0, $d1969548e570103f$export$cdf1dc76b55502e3)();
    var menuId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)($1f9efb1806e6b3c0$var$COMPONENT_NAME, props.id);
    (0, $e896b2d9c1302e32$export$8aeb3a0795e619c9)({
        name: $1f9efb1806e6b3c0$var$COMPONENT_NAME,
        props: props,
        deprecations: {
            getMenuClassNames: 'styles'
        }
    });
    var dismiss = function(ev, dismissAll) {
        var _a;
        return (_a = props.onDismiss) === null || _a === void 0 ? void 0 : _a.call(props, ev, dismissAll);
    };
    var _c = (0, $d39eb924c3e4805b$export$7df435cf7131d47a)(props.target, hostElement), targetRef = _c[0], targetWindow = _c[1];
    var tryFocusPreviousActiveElement = $1f9efb1806e6b3c0$var$usePreviousActiveElement(props, targetWindow, hostElement)[0];
    var _d = $1f9efb1806e6b3c0$var$useSubMenuState(props, dismiss), expandedMenuItemKey = _d[0], openSubMenu = _d[1], getSubmenuProps = _d[2], onSubMenuDismiss = _d[3];
    var _e = $1f9efb1806e6b3c0$var$useShouldUpdateFocusOnMouseMove(props), shouldUpdateFocusOnMouseEvent = _e[0], gotMouseMove = _e[1], onMenuFocusCapture = _e[2];
    var _f = $1f9efb1806e6b3c0$var$useScrollHandler(asyncTracker), onScroll = _f[0], isScrollIdle = _f[1];
    var _g = $1f9efb1806e6b3c0$var$useSubmenuEnterTimer(props, asyncTracker), cancelSubMenuTimer = _g[0], startSubmenuTimer = _g[1], subMenuEntryTimer = _g[2];
    var responsiveMode = (0, $6124a3d3c764767c$export$551dad37f2b289e2)(hostElement, props.responsiveMode);
    $1f9efb1806e6b3c0$var$useVisibility(props, targetWindow);
    var _h = $1f9efb1806e6b3c0$var$useKeyHandlers(props, dismiss, hostElement, openSubMenu), onKeyDown = _h[0], onKeyUp = _h[1], onMenuKeyDown = _h[2], onItemKeyDown = _h[3];
    var _j = $1f9efb1806e6b3c0$var$useMouseHandlers(props, isScrollIdle, subMenuEntryTimer, targetWindow, shouldUpdateFocusOnMouseEvent, gotMouseMove, expandedMenuItemKey, hostElement, startSubmenuTimer, cancelSubMenuTimer, openSubMenu, onSubMenuDismiss, dismiss), onItemMouseEnterBase = _j[0], onItemMouseMoveBase = _j[1], onMouseItemLeave = _j[2], onItemClick = _j[3], onAnchorClick = _j[4], executeItemClick = _j[5], onItemClickBase = _j[6];
    //#region Render helpers
    var onDefaultRenderMenuList = function(menuListProps, // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames, defaultRender) {
        var indexCorrection = 0;
        var items = menuListProps.items, totalItemCount = menuListProps.totalItemCount, hasCheckmarks = menuListProps.hasCheckmarks, hasIcons = menuListProps.hasIcons;
        return $acw62.createElement("ul", {
            className: menuClassNames.list,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            role: 'presentation'
        }, items.map(function(item, index) {
            var menuItem = renderMenuItem(item, index, indexCorrection, totalItemCount, hasCheckmarks, hasIcons, menuClassNames);
            if (item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider && item.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header) {
                var indexIncrease = item.customOnRenderListLength ? item.customOnRenderListLength : 1;
                indexCorrection += indexIncrease;
            }
            return menuItem;
        }));
    };
    var renderFocusZone = function(children, adjustedFocusZoneProps) {
        var _a = props.focusZoneAs, ChildrenRenderer = _a === void 0 ? (0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2) : _a;
        return $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, adjustedFocusZoneProps), children);
    };
    /**
     * !!!IMPORTANT!!! Avoid mutating `item: IContextualMenuItem` argument. It will
     * cause the menu items to always re-render because the component update is based on shallow comparison.
     */ var renderMenuItem = function(item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons, // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames) {
        var _a;
        var renderedItems = [];
        var iconProps = item.iconProps || {
            iconName: 'None'
        };
        var getItemClassNames = item.getItemClassNames, itemProps = item.itemProps;
        var styles = itemProps ? itemProps.styles : undefined;
        // We only send a dividerClassName when the item to be rendered is a divider.
        // For all other cases, the default divider style is used.
        var dividerClassName = item.itemType === (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider ? item.className : undefined;
        var subMenuIconClassName = item.submenuIconProps ? item.submenuIconProps.className : '';
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var itemClassNames;
        // IContextualMenuItem#getItemClassNames for backwards compatibility
        // otherwise uses mergeStyles for class names.
        if (getItemClassNames) itemClassNames = getItemClassNames(props.theme, (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item), expandedMenuItemKey === item.key, !!(0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item), !!item.href, iconProps.iconName !== 'None', item.className, dividerClassName, iconProps.className, subMenuIconClassName, item.primaryDisabled);
        else {
            var itemStyleProps = {
                theme: props.theme,
                disabled: (0, $3250824b6f1d23dc$export$98e832630d6cf989)(item),
                expanded: expandedMenuItemKey === item.key,
                checked: !!(0, $3250824b6f1d23dc$export$876e33b6ab5c0eaa)(item),
                isAnchorLink: !!item.href,
                knownIcon: iconProps.iconName !== 'None',
                itemClassName: item.className,
                dividerClassName: dividerClassName,
                iconClassName: iconProps.className,
                subMenuClassName: subMenuIconClassName,
                primaryDisabled: item.primaryDisabled
            };
            // We need to generate default styles then override if styles are provided
            // since the ContextualMenu currently handles item classNames.
            itemClassNames = $1f9efb1806e6b3c0$var$getContextualMenuItemClassNames($1f9efb1806e6b3c0$var$_getMenuItemStylesFunction((_a = menuClassNames.subComponentStyles) === null || _a === void 0 ? void 0 : _a.menuItem, styles), itemStyleProps);
        }
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (item.text === '-' || item.name === '-') item.itemType = (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider;
        switch(item.itemType){
            case (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider:
                renderedItems.push(renderSeparator(index, itemClassNames));
                break;
            case (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header:
                renderedItems.push(renderSeparator(index, itemClassNames));
                var headerItem = renderHeaderMenuItem(item, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons);
                renderedItems.push(renderListItem(headerItem, item.key || index, itemClassNames, item.title));
                break;
            case (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Section:
                renderedItems.push(renderSectionItem(item, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons));
                break;
            default:
                var defaultRenderNormalItem = function() {
                    return renderNormalItem(item, itemClassNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons);
                };
                var menuItem = props.onRenderContextualMenuItem ? props.onRenderContextualMenuItem(item, defaultRenderNormalItem) : defaultRenderNormalItem();
                renderedItems.push(renderListItem(menuItem, item.key || index, itemClassNames, item.title));
                break;
        }
        // Since multiple nodes *could* be rendered, wrap them all in a fragment with this item's key.
        // This ensures the reconciler handles multi-item output per-node correctly and does not re-mount content.
        return $acw62.createElement($acw62.Fragment, {
            key: item.key
        }, renderedItems);
    };
    var defaultMenuItemRenderer = function(item, // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames) {
        var index = item.index, focusableElementIndex = item.focusableElementIndex, totalItemCount = item.totalItemCount, hasCheckmarks = item.hasCheckmarks, hasIcons = item.hasIcons;
        return renderMenuItem(item, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons, menuClassNames);
    };
    var renderSectionItem = function(sectionItem, // eslint-disable-next-line @typescript-eslint/no-deprecated
    itemClassNames, // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames, index, hasCheckmarks, hasIcons) {
        var sectionProps = sectionItem.sectionProps;
        if (!sectionProps) return;
        var headerItem;
        var groupProps;
        if (sectionProps.title) {
            var headerContextualMenuItem = undefined;
            var ariaLabelledby = '';
            if (typeof sectionProps.title === 'string') {
                // Since title is a user-facing string, it needs to be stripped
                // of whitespace in order to build a valid element ID
                var id_1 = menuId + sectionProps.title.replace(/\s/g, '');
                headerContextualMenuItem = {
                    key: "section-".concat(sectionProps.title, "-title"),
                    itemType: (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header,
                    text: sectionProps.title,
                    id: id_1
                };
                ariaLabelledby = id_1;
            } else {
                var id_2 = sectionProps.title.id || menuId + sectionProps.title.key.replace(/\s/g, '');
                headerContextualMenuItem = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, sectionProps.title), {
                    id: id_2
                });
                ariaLabelledby = id_2;
            }
            if (headerContextualMenuItem) {
                groupProps = {
                    role: 'group',
                    'aria-labelledby': ariaLabelledby
                };
                headerItem = renderHeaderMenuItem(headerContextualMenuItem, itemClassNames, menuClassNames, index, hasCheckmarks, hasIcons);
            }
        }
        if (sectionProps.items && sectionProps.items.length > 0) {
            var correctedIndex_1 = 0;
            return $acw62.createElement("li", {
                role: "presentation",
                key: sectionProps.key || sectionItem.key || "section-".concat(index)
            }, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, groupProps), $acw62.createElement("ul", {
                className: menuClassNames.list,
                role: "presentation"
            }, sectionProps.topDivider && renderSeparator(index, itemClassNames, true, true), headerItem && renderListItem(headerItem, sectionItem.key || index, itemClassNames, sectionItem.title), sectionProps.items.map(function(contextualMenuItem, itemsIndex) {
                var menuItem = renderMenuItem(contextualMenuItem, itemsIndex, correctedIndex_1, $1f9efb1806e6b3c0$var$getItemCount(sectionProps.items), hasCheckmarks, hasIcons, menuClassNames);
                if (contextualMenuItem.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Divider && contextualMenuItem.itemType !== (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Header) {
                    var indexIncrease = contextualMenuItem.customOnRenderListLength ? contextualMenuItem.customOnRenderListLength : 1;
                    correctedIndex_1 += indexIncrease;
                }
                return menuItem;
            }), sectionProps.bottomDivider && renderSeparator(index, itemClassNames, false, true))));
        }
    };
    var renderListItem = function(content, key, classNames, title) {
        return $acw62.createElement("li", {
            role: "presentation",
            title: title,
            key: key,
            className: classNames.item
        }, content);
    };
    var renderSeparator = function(index, classNames, top, fromSection) {
        if (fromSection || index > 0) return $acw62.createElement("li", {
            role: "separator",
            key: 'separator-' + index + (top === undefined ? '' : top ? '-top' : '-bottom'),
            className: classNames.divider,
            "aria-hidden": "true"
        });
        return null;
    };
    var renderNormalItem = function(item, classNames, index, focusableElementIndex, totalItemCount, hasCheckmarks, hasIcons) {
        if (item.onRender) return item.onRender((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            'aria-posinset': focusableElementIndex + 1,
            'aria-setsize': totalItemCount
        }, item), dismiss);
        var contextualMenuItemAs = props.contextualMenuItemAs;
        var commonProps = {
            item: item,
            classNames: classNames,
            index: index,
            focusableElementIndex: focusableElementIndex,
            totalItemCount: totalItemCount,
            hasCheckmarks: hasCheckmarks,
            hasIcons: hasIcons,
            contextualMenuItemAs: contextualMenuItemAs,
            onItemMouseEnter: onItemMouseEnterBase,
            onItemMouseLeave: onMouseItemLeave,
            onItemMouseMove: onItemMouseMoveBase,
            onItemMouseDown: $1f9efb1806e6b3c0$var$onItemMouseDown,
            executeItemClick: executeItemClick,
            onItemKeyDown: onItemKeyDown,
            expandedMenuItemKey: expandedMenuItemKey,
            openSubMenu: openSubMenu,
            dismissSubMenu: onSubMenuDismiss,
            dismissMenu: dismiss
        };
        if (item.href) {
            var ContextualMenuAnchorAs = (0, $4d34c28d37611dbf$export$53be548a9698e315);
            if (item.contextualMenuItemWrapperAs) ContextualMenuAnchorAs = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(item.contextualMenuItemWrapperAs, ContextualMenuAnchorAs);
            return $acw62.createElement(ContextualMenuAnchorAs, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, commonProps, {
                onItemClick: onAnchorClick
            }));
        }
        if (item.split && (0, $3250824b6f1d23dc$export$bb9ab0e82942591e)(item)) {
            var ContextualMenuSplitButtonAs = (0, $d0192128ae91cb03$export$6b814188c716a895);
            if (item.contextualMenuItemWrapperAs) ContextualMenuSplitButtonAs = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(item.contextualMenuItemWrapperAs, ContextualMenuSplitButtonAs);
            return $acw62.createElement(ContextualMenuSplitButtonAs, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, commonProps, {
                onItemClick: onItemClick,
                onItemClickBase: onItemClickBase,
                onTap: cancelSubMenuTimer
            }));
        }
        var ContextualMenuButtonAs = (0, $5b4ee16a3fe91ee4$export$77db5d9420e58cc5);
        if (item.contextualMenuItemWrapperAs) ContextualMenuButtonAs = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(item.contextualMenuItemWrapperAs, ContextualMenuButtonAs);
        return $acw62.createElement(ContextualMenuButtonAs, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, commonProps, {
            onItemClick: onItemClick,
            onItemClickBase: onItemClickBase
        }));
    };
    var renderHeaderMenuItem = function(item, // eslint-disable-next-line @typescript-eslint/no-deprecated
    itemClassNames, // eslint-disable-next-line @typescript-eslint/no-deprecated
    menuClassNames, index, hasCheckmarks, hasIcons) {
        var ChildrenRenderer = (0, $dbc0d5833638f24e$export$4267af6d9e6f3487);
        if (item.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(item.contextualMenuItemAs, ChildrenRenderer);
        if (props.contextualMenuItemAs) ChildrenRenderer = (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(props.contextualMenuItemAs, ChildrenRenderer);
        var itemProps = item.itemProps, id = item.id;
        var divHtmlProperties = itemProps && (0, $076f236b4b7f2dc0$export$26fba481281db559)(itemProps, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        return(// eslint-disable-next-line @typescript-eslint/no-deprecated
        $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: id,
            className: menuClassNames.header
        }, divHtmlProperties, {
            style: item.style
        }), $acw62.createElement(ChildrenRenderer, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            item: item,
            classNames: itemClassNames,
            index: index,
            onCheckmarkClick: hasCheckmarks ? onItemClick : undefined,
            hasIcons: hasIcons
        }, itemProps))));
    };
    //#endregion
    //#region Main render
    var isBeakVisible = props.isBeakVisible;
    var items = props.items, labelElementId = props.labelElementId, id = props.id, className = props.className, beakWidth = props.beakWidth, directionalHint = props.directionalHint, directionalHintForRTL = props.directionalHintForRTL, alignTargetEdge = props.alignTargetEdge, gapSpace = props.gapSpace, coverTarget = props.coverTarget, ariaLabel = props.ariaLabel, doNotLayer = props.doNotLayer, target = props.target, bounds = props.bounds, useTargetWidth = props.useTargetWidth, useTargetAsMinWidth = props.useTargetAsMinWidth, directionalHintFixed = props.directionalHintFixed, shouldFocusOnMount = props.shouldFocusOnMount, shouldFocusOnContainer = props.shouldFocusOnContainer, title = props.title, styles = props.styles, theme = props.theme, calloutProps = props.calloutProps, _k = props.onRenderSubMenu, onRenderSubMenu = _k === void 0 ? $1f9efb1806e6b3c0$var$onDefaultRenderSubMenu : _k, _l = props.onRenderMenuList, onRenderMenuList = _l === void 0 ? function(menuListProps, defaultRender) {
        return onDefaultRenderMenuList(menuListProps, classNames, defaultRender);
    } : _l, focusZoneProps = props.focusZoneProps, // eslint-disable-next-line @typescript-eslint/no-deprecated
    getMenuClassNames = props.getMenuClassNames;
    var classNames = getMenuClassNames ? getMenuClassNames(theme, className) : $1f9efb1806e6b3c0$var$getClassNames(styles, {
        theme: theme,
        className: className
    });
    var hasIcons = itemsHaveIcons(items);
    function itemsHaveIcons(contextualMenuItems) {
        for(var _i = 0, contextualMenuItems_1 = contextualMenuItems; _i < contextualMenuItems_1.length; _i++){
            var item = contextualMenuItems_1[_i];
            if (item.iconProps) return true;
            if (item.itemType === (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Section && item.sectionProps && itemsHaveIcons(item.sectionProps.items)) return true;
        }
        return false;
    }
    var adjustedFocusZoneProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).vertical,
        handleTabKey: (0, $13ca773bee6ceecf$export$269041a88986a933).all,
        isCircularNavigation: true,
        'data-tabster': '{"uncontrolled": {}, "focusable": { "excludeFromMover": true }}'
    }, focusZoneProps), {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, (_a = props.focusZoneProps) === null || _a === void 0 ? void 0 : _a.className)
    });
    var hasCheckmarks = $1f9efb1806e6b3c0$export$2a1d7a07e590a159(items);
    var submenuProps = expandedMenuItemKey && props.hidden !== true ? getSubmenuProps() : null;
    isBeakVisible = isBeakVisible === undefined ? responsiveMode <= (0, $d2efee541c4fc734$export$73c2705cb2da08ab).medium : isBeakVisible;
    /**
     * When useTargetWidth is true, get the width of the target element and apply it for the context menu container
     */ var contextMenuStyle;
    var targetAsHtmlElement = targetRef.current;
    if ((useTargetWidth || useTargetAsMinWidth) && targetAsHtmlElement && targetAsHtmlElement.offsetWidth) {
        var targetBoundingRect = targetAsHtmlElement.getBoundingClientRect();
        var targetWidth = targetBoundingRect.width - 2; /* Accounts for 1px border */ 
        if (useTargetWidth) contextMenuStyle = {
            width: targetWidth
        };
        else if (useTargetAsMinWidth) contextMenuStyle = {
            minWidth: targetWidth
        };
    }
    // The menu should only return if items were provided, if no items were provided then it should not appear.
    if (items && items.length > 0) {
        var totalItemCount_1 = $1f9efb1806e6b3c0$var$getItemCount(items);
        var calloutStyles_1 = classNames.subComponentStyles ? classNames.subComponentStyles.callout : undefined;
        return $acw62.createElement((0, $247bbbbcfb0b71e2$export$c7e742effb1c51e2).Consumer, null, function(menuContext) {
            return $acw62.createElement((0, $bb8160ea11d5c986$export$97a5aca3dea8edc7), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                styles: calloutStyles_1,
                onRestoreFocus: tryFocusPreviousActiveElement
            }, calloutProps, {
                target: target || menuContext.target,
                isBeakVisible: isBeakVisible,
                beakWidth: beakWidth,
                directionalHint: directionalHint,
                directionalHintForRTL: directionalHintForRTL,
                gapSpace: gapSpace,
                coverTarget: coverTarget,
                doNotLayer: doNotLayer,
                className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)('ms-ContextualMenu-Callout', calloutProps && calloutProps.className),
                setInitialFocus: shouldFocusOnMount,
                onDismiss: props.onDismiss || menuContext.onDismiss,
                onScroll: onScroll,
                bounds: bounds,
                directionalHintFixed: directionalHintFixed,
                alignTargetEdge: alignTargetEdge,
                hidden: props.hidden || menuContext.hidden,
                ref: forwardedRef
            }), $acw62.createElement("div", {
                style: contextMenuStyle,
                ref: hostElement,
                id: id,
                className: classNames.container,
                tabIndex: shouldFocusOnContainer ? 0 : -1,
                onKeyDown: onMenuKeyDown,
                onKeyUp: onKeyUp,
                onFocusCapture: onMenuFocusCapture,
                "aria-label": ariaLabel,
                "aria-labelledby": labelElementId,
                role: 'menu'
            }, title && $acw62.createElement("div", {
                className: classNames.title
            }, " ", title, " "), items && items.length ? renderFocusZone(onRenderMenuList({
                ariaLabel: ariaLabel,
                items: items,
                totalItemCount: totalItemCount_1,
                hasCheckmarks: hasCheckmarks,
                hasIcons: hasIcons,
                defaultMenuItemRenderer: function(item) {
                    return defaultMenuItemRenderer(item, classNames);
                },
                labelElementId: labelElementId
            }, function(menuListProps, defaultRender) {
                return onDefaultRenderMenuList(menuListProps, classNames, defaultRender);
            }), adjustedFocusZoneProps) : null, submenuProps && onRenderSubMenu(submenuProps, $1f9efb1806e6b3c0$var$onDefaultRenderSubMenu)), $acw62.createElement((0, $872a30e3c6519016$export$5dedbdbae91633c9), null));
        });
    } else return null;
//#endregion
}), function(prevProps, newProps) {
    if (!newProps.shouldUpdateWhenHidden && prevProps.hidden && newProps.hidden) // Do not update when hidden.
    return true;
    return (0, $f504d2279336999d$export$90e866afbd6b9f1a)(prevProps, newProps);
});
$1f9efb1806e6b3c0$export$6a869745b5bc3200.displayName = 'ContextualMenuBase';
/**
 * Returns true if the key for the event is alt (Mac option) or meta (Mac command).
 */ function $1f9efb1806e6b3c0$var$isAltOrMeta(ev) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).alt || ev.key === 'Meta';
}
function $1f9efb1806e6b3c0$var$onItemMouseDown(item, ev) {
    var _a;
    (_a = item.onMouseDown) === null || _a === void 0 || _a.call(item, item, ev);
}
function $1f9efb1806e6b3c0$var$onDefaultRenderSubMenu(subMenuProps, defaultRender) {
    throw Error("ContextualMenuBase: onRenderSubMenu callback is null or undefined. Please ensure to set `onRenderSubMenu` property either manually or with `styled` helper.");
}
/**
 * Returns the item that matches a given key if any.
 * @param key - The key of the item to match
 * @param items - The items to look for the key
 */ function $1f9efb1806e6b3c0$var$findItemByKeyFromItems(key, items) {
    for(var _i = 0, items_3 = items; _i < items_3.length; _i++){
        var item = items_3[_i];
        if (item.itemType === (0, $406552f968f746a1$export$7dc3c01339ee6e7f).Section && item.sectionProps) {
            var match = $1f9efb1806e6b3c0$var$findItemByKeyFromItems(key, item.sectionProps.items);
            if (match) return match;
        } else if (item.key && item.key === key) return item;
    }
}
function $1f9efb1806e6b3c0$var$getOnClickWithOverrideTarget(onClick, target) {
    return onClick ? function(ev, item) {
        $1f9efb1806e6b3c0$var$overrideTarget(ev, target);
        return onClick(ev, item);
    } : onClick;
}
function $1f9efb1806e6b3c0$var$overrideTarget(ev, target) {
    if (ev && target) {
        ev.persist();
        if (target instanceof Event) ev.target = target.target;
        else if (target instanceof Element) ev.target = target;
    }
}




var $3bfe12eac3fc7683$var$GlobalClassNames = {
    root: 'ms-ContextualMenu',
    container: 'ms-ContextualMenu-container',
    list: 'ms-ContextualMenu-list',
    header: 'ms-ContextualMenu-header',
    title: 'ms-ContextualMenu-title',
    isopen: 'is-open'
};
var $3bfe12eac3fc7683$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($3bfe12eac3fc7683$var$GlobalClassNames, theme);
    var fonts = theme.fonts, semanticColors = theme.semanticColors, effects = theme.effects;
    return {
        root: [
            theme.fonts.medium,
            classNames.root,
            classNames.isopen,
            {
                backgroundColor: semanticColors.menuBackground,
                minWidth: '180px'
            },
            className
        ],
        container: [
            classNames.container,
            {
                selectors: {
                    ':focus': {
                        outline: 0
                    }
                }
            }
        ],
        list: [
            classNames.list,
            classNames.isopen,
            {
                listStyleType: 'none',
                margin: '0',
                padding: '0'
            }
        ],
        header: [
            classNames.header,
            fonts.small,
            {
                fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                color: semanticColors.menuHeader,
                background: 'none',
                backgroundColor: 'transparent',
                border: 'none',
                height: (0, $194675c1c18101b9$export$f4ed060eaa49a3),
                lineHeight: (0, $194675c1c18101b9$export$f4ed060eaa49a3),
                cursor: 'default',
                padding: '0px 6px',
                userSelect: 'none',
                textAlign: 'left'
            }
        ],
        title: [
            classNames.title,
            {
                fontSize: fonts.mediumPlus.fontSize,
                paddingRight: '14px',
                paddingLeft: '14px',
                paddingBottom: '5px',
                paddingTop: '5px',
                backgroundColor: semanticColors.menuItemBackgroundPressed
            }
        ],
        subComponentStyles: {
            callout: {
                root: {
                    boxShadow: effects.elevation8
                }
            },
            menuItem: {}
        }
    };
};


function $ce0e54155b3ccf1a$var$onRenderSubMenu(subMenuProps) {
    return $acw62.createElement($ce0e54155b3ccf1a$var$LocalContextualMenu, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, subMenuProps));
}
// This is to prevent cyclic import with ContextualMenu.base.tsx.
var $ce0e54155b3ccf1a$var$LocalContextualMenu = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $1f9efb1806e6b3c0$export$6a869745b5bc3200), (0, $3bfe12eac3fc7683$export$ffd58b7f6f099a57), function(props) {
    return {
        onRenderSubMenu: props.onRenderSubMenu ? (0, $dcded159bee91fac$export$6427897eb70b5e23)(props.onRenderSubMenu, $ce0e54155b3ccf1a$var$onRenderSubMenu) : $ce0e54155b3ccf1a$var$onRenderSubMenu
    };
}, {
    scope: 'ContextualMenu'
});
var $ce0e54155b3ccf1a$export$f55c8e309b1cad66 = $ce0e54155b3ccf1a$var$LocalContextualMenu;
$ce0e54155b3ccf1a$export$f55c8e309b1cad66.displayName = 'ContextualMenu';




var $4fe39bc207aa6e6b$export$78e5756b1cbe9c85 = {
    msButton: 'ms-Button',
    msButtonHasMenu: 'ms-Button--hasMenu',
    msButtonIcon: 'ms-Button-icon',
    msButtonMenuIcon: 'ms-Button-menuIcon',
    msButtonLabel: 'ms-Button-label',
    msButtonDescription: 'ms-Button-description',
    msButtonScreenReaderText: 'ms-Button-screenReaderText',
    msButtonFlexContainer: 'ms-Button-flexContainer',
    msButtonTextContainer: 'ms-Button-textContainer'
};
var $4fe39bc207aa6e6b$export$c856ccb8b0de330d = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, styles, className, variantClassName, iconClassName, menuIconClassName, disabled, hasMenu, checked, expanded, isSplit) {
    var _a, _b;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($4fe39bc207aa6e6b$export$78e5756b1cbe9c85, theme || {});
    var isExpanded = expanded && !isSplit;
    return (0, $00784e00f3e28b27$export$fbaf15ac64fa8f3e)(styles.__shadowConfig__, {
        root: [
            classNames.msButton,
            styles.root,
            variantClassName,
            checked && [
                'is-checked',
                styles.rootChecked
            ],
            isExpanded && [
                'is-expanded',
                styles.rootExpanded,
                (_a = {}, _a[":hover .".concat(classNames.msButtonIcon)] = styles.iconExpandedHovered, // menuIcon falls back to rootExpandedHovered to support original behavior
                _a[":hover .".concat(classNames.msButtonMenuIcon)] = styles.menuIconExpandedHovered || styles.rootExpandedHovered, _a[':hover'] = styles.rootExpandedHovered, _a)
            ],
            hasMenu && [
                $4fe39bc207aa6e6b$export$78e5756b1cbe9c85.msButtonHasMenu,
                styles.rootHasMenu
            ],
            disabled && [
                'is-disabled',
                styles.rootDisabled
            ],
            !disabled && !isExpanded && !checked && (_b = {
                ':hover': styles.rootHovered
            }, _b[":hover .".concat(classNames.msButtonLabel)] = styles.labelHovered, _b[":hover .".concat(classNames.msButtonIcon)] = styles.iconHovered, _b[":hover .".concat(classNames.msButtonDescription)] = styles.descriptionHovered, _b[":hover .".concat(classNames.msButtonMenuIcon)] = styles.menuIconHovered, _b[':focus'] = styles.rootFocused, _b[':active'] = styles.rootPressed, _b[":active .".concat(classNames.msButtonIcon)] = styles.iconPressed, _b[":active .".concat(classNames.msButtonDescription)] = styles.descriptionPressed, _b[":active .".concat(classNames.msButtonMenuIcon)] = styles.menuIconPressed, _b),
            disabled && checked && [
                styles.rootCheckedDisabled
            ],
            !disabled && checked && {
                ':hover': styles.rootCheckedHovered,
                ':active': styles.rootCheckedPressed
            },
            className
        ],
        flexContainer: [
            classNames.msButtonFlexContainer,
            styles.flexContainer
        ],
        textContainer: [
            classNames.msButtonTextContainer,
            styles.textContainer
        ],
        icon: [
            classNames.msButtonIcon,
            iconClassName,
            styles.icon,
            isExpanded && styles.iconExpanded,
            checked && styles.iconChecked,
            disabled && styles.iconDisabled
        ],
        label: [
            classNames.msButtonLabel,
            styles.label,
            checked && styles.labelChecked,
            disabled && styles.labelDisabled
        ],
        menuIcon: [
            classNames.msButtonMenuIcon,
            menuIconClassName,
            styles.menuIcon,
            checked && styles.menuIconChecked,
            disabled && !isSplit && styles.menuIconDisabled,
            !disabled && !isExpanded && !checked && {
                ':hover': styles.menuIconHovered,
                ':active': styles.menuIconPressed
            },
            isExpanded && [
                'is-expanded',
                styles.menuIconExpanded
            ]
        ],
        description: [
            classNames.msButtonDescription,
            styles.description,
            checked && styles.descriptionChecked,
            disabled && styles.descriptionDisabled
        ],
        screenReaderText: [
            classNames.msButtonScreenReaderText,
            styles.screenReaderText
        ]
    });
});




var $69f0f54fd3cb91aa$export$c0dfbb5ce364dcd9 = {
    msSplitButtonDivider: 'ms-SplitButton-divider'
};
var $69f0f54fd3cb91aa$export$f5956e741d4621bd = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(styles, disabled, expanded, checked, primaryDisabled) {
    return {
        root: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonMenuButton, expanded && [
            styles.splitButtonMenuButtonExpanded
        ], disabled && [
            styles.splitButtonMenuButtonDisabled
        ], checked && !disabled && [
            styles.splitButtonMenuButtonChecked
        ], primaryDisabled && !disabled && [
            {
                ':focus': styles.splitButtonMenuFocused
            }
        ]),
        splitButtonContainer: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonContainer, !disabled && checked && [
            styles.splitButtonContainerChecked,
            {
                ':hover': styles.splitButtonContainerCheckedHovered
            }
        ], !disabled && !checked && [
            {
                ':hover': styles.splitButtonContainerHovered,
                ':focus': styles.splitButtonContainerFocused
            }
        ], disabled && styles.splitButtonContainerDisabled),
        icon: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonMenuIcon, disabled && styles.splitButtonMenuIconDisabled, !disabled && primaryDisabled && styles.splitButtonMenuIcon),
        flexContainer: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(styles.splitButtonFlexContainer),
        divider: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)($69f0f54fd3cb91aa$export$c0dfbb5ce364dcd9.msSplitButtonDivider, styles.splitButtonDivider, (primaryDisabled || disabled) && styles.splitButtonDividerDisabled)
    };
});



var $108f802e6afba9ea$var$TouchIdleDelay = 500; /* ms */ 
var $108f802e6afba9ea$var$COMPONENT_NAME = 'BaseButton';
/**
 * {@docCategory Button}
 */ var $108f802e6afba9ea$export$e30f1d91ae9a4bf9 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseButton, _super);
    function BaseButton(props) {
        var _this = _super.call(this, props) || this;
        _this._buttonElement = $acw62.createRef();
        _this._splitButtonContainer = $acw62.createRef();
        _this._mergedRef = (0, $ad53d15595d1f5d5$export$9f37a988498f0f9c)();
        _this._renderedVisibleMenu = false;
        _this._getMemoizedMenuButtonKeytipProps = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(keytipProps) {
            return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, keytipProps), {
                hasMenu: true
            });
        });
        _this._onRenderIcon = function(buttonProps, defaultRender) {
            var iconProps = _this.props.iconProps;
            if (iconProps && (iconProps.iconName !== undefined || iconProps.imageProps)) {
                var className = iconProps.className, imageProps = iconProps.imageProps, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(iconProps, [
                    "className",
                    "imageProps"
                ]);
                // If the styles prop is specified as part of iconProps, fall back to regular Icon as FontIcon and ImageIcon
                // do not have this prop.
                if (iconProps.styles) return $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.icon, className),
                    imageProps: imageProps
                }, rest));
                if (iconProps.iconName) return $acw62.createElement((0, $eec83b0087c5fe87$export$f56ea46797033f60), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.icon, className)
                }, rest));
                if (imageProps) return $acw62.createElement((0, $98737100b97aa693$export$4a122bafaa48b23d), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(_this._classNames.icon, className),
                    imageProps: imageProps
                }, rest));
            }
            return null;
        };
        _this._onRenderTextContents = function() {
            var _a = _this.props, text = _a.text, children = _a.children, // eslint-disable-next-line @typescript-eslint/no-deprecated
            _b = _a.secondaryText, // eslint-disable-next-line @typescript-eslint/no-deprecated
            secondaryText = _b === void 0 ? _this.props.description : _b, _c = _a.onRenderText, onRenderText = _c === void 0 ? _this._onRenderText : _c, _d = _a.onRenderDescription, onRenderDescription = _d === void 0 ? _this._onRenderDescription : _d;
            if (text || typeof children === 'string' || secondaryText) return $acw62.createElement("span", {
                className: _this._classNames.textContainer
            }, onRenderText(_this.props, _this._onRenderText), onRenderDescription(_this.props, _this._onRenderDescription));
            return [
                onRenderText(_this.props, _this._onRenderText),
                onRenderDescription(_this.props, _this._onRenderDescription)
            ];
        };
        _this._onRenderText = function() {
            var text = _this.props.text;
            var children = _this.props.children;
            // For backwards compat, we should continue to take in the text content from children.
            if (text === undefined && typeof children === 'string') text = children;
            if (_this._hasText()) return $acw62.createElement("span", {
                key: _this._labelId,
                className: _this._classNames.label,
                id: _this._labelId
            }, text);
            return null;
        };
        _this._onRenderChildren = function() {
            var children = _this.props.children;
            // If children is just a string, either it or the text will be rendered via onRenderLabel
            // If children is another component, it will be rendered after text
            if (typeof children === 'string') return null;
            return children;
        };
        _this._onRenderDescription = function(props) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = props.secondaryText, secondaryText = _a === void 0 ? _this.props.description : _a;
            // ms-Button-description is only shown when the button type is compound.
            // In other cases it will not be displayed.
            return secondaryText ? $acw62.createElement("span", {
                key: _this._descriptionId,
                className: _this._classNames.description,
                id: _this._descriptionId
            }, secondaryText) : null;
        };
        _this._onRenderAriaDescription = function() {
            var ariaDescription = _this.props.ariaDescription;
            // If ariaDescription is given, descriptionId will be assigned to ariaDescriptionSpan,
            // otherwise it will be assigned to descriptionSpan.
            return ariaDescription ? $acw62.createElement("span", {
                className: _this._classNames.screenReaderText,
                id: _this._ariaDescriptionId
            }, ariaDescription) : null;
        };
        _this._onRenderMenuIcon = function(props) {
            var menuIconProps = _this.props.menuIconProps;
            return $acw62.createElement((0, $eec83b0087c5fe87$export$f56ea46797033f60), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                iconName: "ChevronDown"
            }, menuIconProps, {
                className: _this._classNames.menuIcon
            }));
        };
        _this._onRenderMenu = function(menuProps) {
            var MenuType = _this.props.menuAs ? (0, $7d0a77756f8e01ee$export$a196dddec0747ba0)(_this.props.menuAs, (0, $ce0e54155b3ccf1a$export$f55c8e309b1cad66)) : (0, $ce0e54155b3ccf1a$export$f55c8e309b1cad66);
            return $acw62.createElement(MenuType, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, menuProps));
        };
        _this._onDismissMenu = function(ev) {
            var menuProps = _this.props.menuProps;
            if (menuProps && menuProps.onDismiss) menuProps.onDismiss(ev);
            if (!ev || !ev.defaultPrevented) _this._dismissMenu();
        };
        _this._dismissMenu = function() {
            _this._menuShouldFocusOnMount = undefined;
            _this._menuShouldFocusOnContainer = undefined;
            _this.setState({
                menuHidden: true
            });
        };
        _this._openMenu = function(shouldFocusOnContainer, shouldFocusOnMount) {
            if (shouldFocusOnMount === void 0) shouldFocusOnMount = true;
            if (_this.props.menuProps) {
                _this._menuShouldFocusOnContainer = shouldFocusOnContainer;
                _this._menuShouldFocusOnMount = shouldFocusOnMount;
                _this._renderedVisibleMenu = true;
                _this.setState({
                    menuHidden: false
                });
            }
        };
        _this._onToggleMenu = function(shouldFocusOnContainer) {
            var shouldFocusOnMount = true;
            if (_this.props.menuProps && _this.props.menuProps.shouldFocusOnMount === false) shouldFocusOnMount = false;
            _this.state.menuHidden ? _this._openMenu(shouldFocusOnContainer, shouldFocusOnMount) : _this._dismissMenu();
        };
        _this._onSplitContainerFocusCapture = function(ev) {
            var container = _this._splitButtonContainer.current;
            // If the target is coming from the portal we do not need to set focus on the container.
            if (!container || ev.target && (0, $8eda1135a5ecf96f$export$ca66eda9f83446dd)(ev.target, container)) return;
            // We should never be able to focus the individual buttons in a split button. Focus
            // should always remain on the container.
            container.focus();
        };
        _this._onSplitButtonPrimaryClick = function(ev) {
            if (!_this.state.menuHidden) _this._dismissMenu();
            // toggle split buttons need two separate targets, even for touch
            var singleTouchTarget = _this._processingTouch && !_this.props.toggle;
            if (!singleTouchTarget && _this.props.onClick) _this.props.onClick(ev);
            else if (singleTouchTarget) _this._onMenuClick(ev);
        };
        _this._onKeyDown = function(ev) {
            // explicity cancelling event so click won't fire after this
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (_this.props.disabled && (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space)) {
                ev.preventDefault();
                ev.stopPropagation();
            } else if (!_this.props.disabled) {
                if (_this.props.menuProps) _this._onMenuKeyDown(ev);
                else if (_this.props.onKeyDown !== undefined) _this.props.onKeyDown(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onKeyUp = function(ev) {
            if (!_this.props.disabled && _this.props.onKeyUp !== undefined) _this.props.onKeyUp(ev); // not cancelling event because it's not disabled
        };
        _this._onKeyPress = function(ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (!_this.props.disabled && _this.props.onKeyPress !== undefined) // eslint-disable-next-line @typescript-eslint/no-deprecated
            _this.props.onKeyPress(ev); // not cancelling event because it's not disabled
        };
        _this._onMouseUp = function(ev) {
            if (!_this.props.disabled && _this.props.onMouseUp !== undefined) _this.props.onMouseUp(ev); // not cancelling event because it's not disabled
        };
        _this._onMouseDown = function(ev) {
            if (!_this.props.disabled && _this.props.onMouseDown !== undefined) _this.props.onMouseDown(ev); // not cancelling event because it's not disabled
        };
        _this._onClick = function(ev) {
            if (!_this.props.disabled) {
                if (_this.props.menuProps) _this._onMenuClick(ev);
                else if (_this.props.onClick !== undefined) _this.props.onClick(ev); // not cancelling event because it's not disabled
            }
        };
        _this._onSplitButtonContainerKeyDown = function(ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) {
                if (_this._buttonElement.current) {
                    _this._buttonElement.current.click();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            } else _this._onMenuKeyDown(ev);
        };
        _this._onMenuKeyDown = function(ev) {
            var _a;
            if (_this.props.disabled) return;
            if (_this.props.onKeyDown) _this.props.onKeyDown(ev);
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var isUp = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).up;
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var isDown = ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down;
            if (!ev.defaultPrevented && _this._isValidMenuOpenKey(ev)) {
                var onMenuClick = _this.props.onMenuClick;
                if (onMenuClick) onMenuClick(ev, _this.props);
                _this._onToggleMenu(false);
                ev.preventDefault();
                ev.stopPropagation();
            }
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter || ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) // We manually set the focus visibility to true if opening via Enter or Space to account for the scenario where
            // a user clicks on the button, closes the menu and then opens it via keyboard. In this scenario our default logic
            // for setting focus visibility is not triggered since there is no keyboard navigation present beforehand.
            (0, $68e6902efa21380a$export$760b5674477e9343)(true, ev.target, (_a = _this.context) === null || _a === void 0 ? void 0 : _a.registeredProviders);
            if (!(ev.altKey || ev.metaKey) && (isUp || isDown)) // Suppose a menu, with shouldFocusOnMount: false, is open, and user wants to keyboard to the menu items
            // We need to re-render the menu with shouldFocusOnMount as true.
            {
                if (!_this.state.menuHidden && _this.props.menuProps) {
                    var currentShouldFocusOnMount = _this._menuShouldFocusOnMount !== undefined ? _this._menuShouldFocusOnMount : _this.props.menuProps.shouldFocusOnMount;
                    if (!currentShouldFocusOnMount) {
                        ev.preventDefault();
                        ev.stopPropagation();
                        _this._menuShouldFocusOnMount = true;
                        _this.forceUpdate();
                    }
                }
            }
        };
        _this._onTouchStart = function() {
            if (_this._isSplitButton && _this._splitButtonContainer.current && !('onpointerdown' in _this._splitButtonContainer.current)) _this._handleTouchAndPointerEvent();
        };
        _this._onMenuClick = function(ev) {
            var _a = _this.props, onMenuClick = _a.onMenuClick, menuProps = _a.menuProps;
            if (onMenuClick) onMenuClick(ev, _this.props);
            // focus on the container by default when the menu is opened with a click event
            // this differentiates from a keyboard interaction triggering the click event
            var shouldFocusOnContainer = typeof (menuProps === null || menuProps === void 0 ? void 0 : menuProps.shouldFocusOnContainer) === 'boolean' ? menuProps.shouldFocusOnContainer : ev.nativeEvent.pointerType === 'mouse';
            if (!ev.defaultPrevented) {
                _this._onToggleMenu(shouldFocusOnContainer);
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(_this);
        _this._events = new (0, $7e392406ee2126b8$export$7af5106782f53286)(_this);
        (0, $35efe983fe3c9b91$export$864d02b07a04fe0f)($108f802e6afba9ea$var$COMPONENT_NAME, props, [
            'menuProps',
            'onClick'
        ], 'split', _this.props.split);
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)($108f802e6afba9ea$var$COMPONENT_NAME, props, {
            rootProps: undefined,
            description: 'secondaryText',
            toggled: 'checked'
        });
        _this._labelId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        _this._descriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        _this._ariaDescriptionId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
        _this.state = {
            menuHidden: true
        };
        return _this;
    }
    Object.defineProperty(BaseButton.prototype, "_isSplitButton", {
        get: function() {
            return !!this.props.menuProps && !!this.props.onClick && this.props.split === true;
        },
        enumerable: false,
        configurable: true
    });
    BaseButton.prototype.render = function() {
        var _a;
        var _b = this.props, ariaDescription = _b.ariaDescription, ariaLabel = _b.ariaLabel, ariaHidden = _b.ariaHidden, className = _b.className, disabled = _b.disabled, allowDisabledFocus = _b.allowDisabledFocus, primaryDisabled = _b.primaryDisabled, // eslint-disable-next-line @typescript-eslint/no-deprecated
        _c = _b.secondaryText, // eslint-disable-next-line @typescript-eslint/no-deprecated
        secondaryText = _c === void 0 ? this.props.description : _c, href = _b.href, iconProps = _b.iconProps, menuIconProps = _b.menuIconProps, styles = _b.styles, checked = _b.checked, variantClassName = _b.variantClassName, theme = _b.theme, toggle = _b.toggle, getClassNames = _b.getClassNames, role = _b.role;
        var menuHidden = this.state.menuHidden;
        // Button is disabled if the whole button (in case of splitButton is disabled) or if the primary action is disabled
        var isPrimaryButtonDisabled = disabled || primaryDisabled;
        this._classNames = getClassNames ? getClassNames(theme, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, checked, !menuHidden, !!this.props.menuProps, this.props.split, !!allowDisabledFocus) : (0, $4fe39bc207aa6e6b$export$c856ccb8b0de330d)(theme, styles, className, variantClassName, iconProps && iconProps.className, menuIconProps && menuIconProps.className, isPrimaryButtonDisabled, !!this.props.menuProps, checked, !menuHidden, this.props.split);
        var _d = this, _ariaDescriptionId = _d._ariaDescriptionId, _labelId = _d._labelId, _descriptionId = _d._descriptionId;
        // Anchor tag cannot be disabled hence in disabled state rendering
        // anchor button as normal button
        var renderAsAnchor = !isPrimaryButtonDisabled && !!href;
        var tag = renderAsAnchor ? 'a' : 'button';
        var nativeProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(// eslint-disable-next-line @typescript-eslint/no-deprecated
        (0, $f504d2279336999d$export$e6e34fd1f2686227)(renderAsAnchor ? {} : {
            type: 'button'
        }, this.props.rootProps, this.props), renderAsAnchor ? (0, $076f236b4b7f2dc0$export$bd4643a0b4568ed8) : (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4), [
            'disabled'
        ]);
        // Check for ariaLabel passed in via Button props, and fall back to aria-label passed in via native props
        var resolvedAriaLabel = ariaLabel || nativeProps['aria-label'];
        // Check for ariaDescription, secondaryText or aria-describedby in the native props to determine source of
        // aria-describedby. Otherwise default to undefined so property does not appear in output.
        var ariaDescribedBy = undefined;
        if (ariaDescription) ariaDescribedBy = _ariaDescriptionId;
        else if (secondaryText && this.props.onRenderDescription !== (0, $12233c50b7efccdc$export$c14f77b8570f3676)) // for buttons like CompoundButton with a valid onRenderDescription, we need to set an ariaDescribedBy
        // for buttons that do not render anything (via nullRender), we should not set an ariaDescribedBy
        ariaDescribedBy = _descriptionId;
        else if (nativeProps['aria-describedby']) ariaDescribedBy = nativeProps['aria-describedby'];
        // If an explicit aria-labelledby is given, use that and we're done.
        // If any kind of description is given (which will end up as an aria-describedby attribute)
        // and no ariaLabel is specified, set the labelledby element.
        // Otherwise, the button is labeled implicitly by the descendent text on the button (if it exists).
        var ariaLabelledBy = undefined;
        if (nativeProps['aria-labelledby']) ariaLabelledBy = nativeProps['aria-labelledby'];
        else if (ariaDescribedBy && !resolvedAriaLabel) ariaLabelledBy = this._hasText() ? _labelId : undefined;
        var dataIsFocusable = this.props['data-is-focusable'] === false || disabled && !allowDisabledFocus || this._isSplitButton ? false : true;
        var isCheckboxTypeRole = role === 'menuitemcheckbox' || role === 'checkbox';
        // if isCheckboxTypeRole, always return a checked value.
        // Otherwise only return checked value if toggle is set to true.
        // This is because role="checkbox" always needs to have an aria-checked value
        // but our checked prop only sets aria-pressed if we mark the button as a toggle="true"
        var checkedOrPressedValue = isCheckboxTypeRole ? !!checked : toggle === true ? !!checked : undefined;
        var buttonProps = (0, $f504d2279336999d$export$e6e34fd1f2686227)(nativeProps, (_a = {
            className: this._classNames.root,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            ref: this._mergedRef(this.props.elementRef, this._buttonElement),
            disabled: isPrimaryButtonDisabled && !allowDisabledFocus,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseDown: this._onMouseDown,
            onMouseUp: this._onMouseUp,
            onClick: this._onClick,
            'aria-label': resolvedAriaLabel,
            'aria-labelledby': ariaLabelledBy,
            'aria-describedby': ariaDescribedBy,
            'aria-disabled': isPrimaryButtonDisabled,
            'data-is-focusable': dataIsFocusable
        }, // aria-pressed attribute should only be present for toggle buttons
        // aria-checked attribute should only be present for toggle buttons with checkbox type role
        _a[isCheckboxTypeRole ? 'aria-checked' : 'aria-pressed'] = checkedOrPressedValue, _a));
        if (ariaHidden) buttonProps['aria-hidden'] = true;
        if (this._isSplitButton) return this._onRenderSplitButtonContent(tag, buttonProps);
        else if (this.props.menuProps) {
            var _e = this.props.menuProps.id, id = _e === void 0 ? "".concat(this._labelId, "-menu") : _e;
            (0, $f504d2279336999d$export$e6e34fd1f2686227)(buttonProps, {
                'aria-expanded': !menuHidden,
                'aria-controls': !menuHidden ? id : null,
                'aria-haspopup': true
            });
        }
        return this._onRenderContent(tag, buttonProps);
    };
    BaseButton.prototype.componentDidMount = function() {
        // For split buttons, touching anywhere in the button should drop the dropdown, which should contain the
        // primary action. This gives more hit target space for touch environments. We're setting the onpointerdown here,
        // because React does not support Pointer events yet.
        if (this._isSplitButton && this._splitButtonContainer.current) {
            if ('onpointerdown' in this._splitButtonContainer.current) this._events.on(this._splitButtonContainer.current, 'pointerdown', this._onPointerDown, true);
            if ('onpointerup' in this._splitButtonContainer.current && this.props.onPointerUp) this._events.on(this._splitButtonContainer.current, 'pointerup', this.props.onPointerUp, true);
        }
    };
    BaseButton.prototype.componentDidUpdate = function(prevProps, prevState) {
        // If Button's menu was closed, run onAfterMenuDismiss.
        if (this.props.onAfterMenuDismiss && !prevState.menuHidden && this.state.menuHidden) this.props.onAfterMenuDismiss();
    };
    BaseButton.prototype.componentWillUnmount = function() {
        this._async.dispose();
        this._events.dispose();
    };
    BaseButton.prototype.focus = function() {
        var _a, _b;
        if (this._isSplitButton && this._splitButtonContainer.current) {
            (0, $68e6902efa21380a$export$760b5674477e9343)(true, undefined, (_a = this.context) === null || _a === void 0 ? void 0 : _a.registeredProviders);
            this._splitButtonContainer.current.focus();
        } else if (this._buttonElement.current) {
            (0, $68e6902efa21380a$export$760b5674477e9343)(true, undefined, (_b = this.context) === null || _b === void 0 ? void 0 : _b.registeredProviders);
            this._buttonElement.current.focus();
        }
    };
    BaseButton.prototype.dismissMenu = function() {
        this._dismissMenu();
    };
    BaseButton.prototype.openMenu = function(shouldFocusOnContainer, shouldFocusOnMount) {
        this._openMenu(shouldFocusOnContainer, shouldFocusOnMount);
    };
    BaseButton.prototype._onRenderContent = function(tag, buttonProps) {
        var _this = this;
        var props = this.props;
        var Tag = tag;
        var menuIconProps = props.menuIconProps, menuProps = props.menuProps, _a = props.onRenderIcon, onRenderIcon = _a === void 0 ? this._onRenderIcon : _a, _b = props.onRenderAriaDescription, onRenderAriaDescription = _b === void 0 ? this._onRenderAriaDescription : _b, _c = props.onRenderChildren, onRenderChildren = _c === void 0 ? this._onRenderChildren : _c, // eslint-disable-next-line @typescript-eslint/no-deprecated
        _d = props.onRenderMenu, // eslint-disable-next-line @typescript-eslint/no-deprecated
        onRenderMenu = _d === void 0 ? this._onRenderMenu : _d, _e = props.onRenderMenuIcon, onRenderMenuIcon = _e === void 0 ? this._onRenderMenuIcon : _e, disabled = props.disabled;
        var keytipProps = props.keytipProps;
        if (keytipProps && menuProps) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        var Button = function(keytipAttributes) {
            return $acw62.createElement(Tag, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, buttonProps, keytipAttributes), $acw62.createElement("span", {
                className: _this._classNames.flexContainer,
                "data-automationid": "splitbuttonprimary"
            }, onRenderIcon(props, _this._onRenderIcon), _this._onRenderTextContents(), onRenderAriaDescription(props, _this._onRenderAriaDescription), onRenderChildren(props, _this._onRenderChildren), !_this._isSplitButton && (menuProps || menuIconProps || _this.props.onRenderMenuIcon) && onRenderMenuIcon(_this.props, _this._onRenderMenuIcon), menuProps && !menuProps.doNotLayer && _this._shouldRenderMenu() && onRenderMenu(_this._getMenuProps(menuProps), _this._onRenderMenu)));
        };
        var Content = keytipProps ? // If we're making a split button, we won't put the keytip here
        $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: !this._isSplitButton ? keytipProps : undefined,
            ariaDescribedBy: buttonProps['aria-describedby'],
            disabled: disabled
        }, function(keytipAttributes) {
            return Button(keytipAttributes);
        }) : Button();
        if (menuProps && menuProps.doNotLayer) return $acw62.createElement($acw62.Fragment, null, Content, this._shouldRenderMenu() && onRenderMenu(this._getMenuProps(menuProps), this._onRenderMenu));
        return $acw62.createElement($acw62.Fragment, null, Content, $acw62.createElement((0, $872a30e3c6519016$export$5dedbdbae91633c9), null));
    };
    /**
     * Method to help determine if the menu's component tree should
     * be rendered. It takes into account whether the menu is expanded,
     * whether it is a persisted menu and whether it has been shown to the user.
     */ BaseButton.prototype._shouldRenderMenu = function() {
        var menuHidden = this.state.menuHidden;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        var _a = this.props, persistMenu = _a.persistMenu, renderPersistedMenuHiddenOnMount = _a.renderPersistedMenuHiddenOnMount;
        if (!menuHidden) // Always should render a menu when it is expanded
        return true;
        else if (persistMenu && (this._renderedVisibleMenu || renderPersistedMenuHiddenOnMount)) // _renderedVisibleMenu ensures that the first rendering of
        // the menu happens on-screen, as edge's scrollbar calculations are off if done while hidden.
        return true;
        return false;
    };
    BaseButton.prototype._hasText = function() {
        // _onRenderTextContents and _onRenderText do not perform the same checks. Below is parity with what _onRenderText
        // used to have before the refactor that introduced this function. _onRenderTextContents does not require props.
        // text to be undefined in order for props.children to be used as a fallback.
        // Purely a code maintainability/reuse issue, but logged as Issue #4979.
        return this.props.text !== null && (this.props.text !== undefined || typeof this.props.children === 'string');
    };
    BaseButton.prototype._getMenuProps = function(menuProps) {
        var persistMenu = this.props.persistMenu;
        var menuHidden = this.state.menuHidden;
        // the accessible menu label (accessible name) has a relationship to the button.
        // If the menu props do not specify an explicit value for aria-label or aria-labelledBy,
        // AND the button has text, we'll set the menu aria-labelledBy to the text element id.
        if (!menuProps.ariaLabel && !menuProps.labelElementId && this._hasText()) menuProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, menuProps), {
            labelElementId: this._labelId
        });
        return (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: this._labelId + '-menu',
            directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomLeftEdge
        }, menuProps), {
            shouldFocusOnContainer: this._menuShouldFocusOnContainer,
            shouldFocusOnMount: this._menuShouldFocusOnMount,
            hidden: persistMenu ? menuHidden : undefined,
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)('ms-BaseButton-menuhost', menuProps.className),
            target: this._isSplitButton ? this._splitButtonContainer.current : this._buttonElement.current,
            onDismiss: this._onDismissMenu
        });
    };
    BaseButton.prototype._onRenderSplitButtonContent = function(tag, buttonProps) {
        var _this = this;
        var _a = this.props, _b = _a.styles, styles = _b === void 0 ? {} : _b, disabled = _a.disabled, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, getSplitButtonClassNames = _a.getSplitButtonClassNames, primaryDisabled = _a.primaryDisabled, menuProps = _a.menuProps, toggle = _a.toggle, role = _a.role, primaryActionButtonProps = _a.primaryActionButtonProps;
        var keytipProps = this.props.keytipProps;
        var menuHidden = this.state.menuHidden;
        var classNames = getSplitButtonClassNames ? getSplitButtonClassNames(!!disabled, !menuHidden, !!checked, !!allowDisabledFocus) : styles && (0, $69f0f54fd3cb91aa$export$f5956e741d4621bd)(styles, !!disabled, !menuHidden, !!checked, !!primaryDisabled);
        (0, $f504d2279336999d$export$e6e34fd1f2686227)(buttonProps, {
            onClick: undefined,
            onPointerDown: undefined,
            onPointerUp: undefined,
            tabIndex: -1,
            'data-is-focusable': false
        });
        if (keytipProps && menuProps) keytipProps = this._getMemoizedMenuButtonKeytipProps(keytipProps);
        var containerProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(buttonProps, [], [
            'disabled'
        ]);
        // Add additional props to apply on primary action button
        if (primaryActionButtonProps) (0, $f504d2279336999d$export$e6e34fd1f2686227)(buttonProps, primaryActionButtonProps);
        var SplitButton = function(keytipAttributes) {
            return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
                "data-ktp-target": keytipAttributes ? keytipAttributes['data-ktp-target'] : undefined,
                role: role ? role : 'button',
                "aria-disabled": disabled,
                "aria-haspopup": true,
                "aria-expanded": !menuHidden,
                "aria-pressed": toggle ? !!checked : undefined,
                "aria-describedby": (0, $47ed660f7395a6aa$export$35013cdad9bb6ffa)(buttonProps['aria-describedby'], keytipAttributes ? keytipAttributes['aria-describedby'] : undefined),
                className: classNames && classNames.splitButtonContainer,
                onKeyDown: _this._onSplitButtonContainerKeyDown,
                onTouchStart: _this._onTouchStart,
                ref: _this._splitButtonContainer,
                "data-is-focusable": true,
                onClick: !disabled && !primaryDisabled ? _this._onSplitButtonPrimaryClick : undefined,
                tabIndex: !disabled && !primaryDisabled || allowDisabledFocus ? 0 : undefined,
                "aria-roledescription": buttonProps['aria-roledescription'],
                onFocusCapture: _this._onSplitContainerFocusCapture
            }), $acw62.createElement("span", {
                style: {
                    display: 'flex',
                    width: '100%'
                }
            }, _this._onRenderContent(tag, buttonProps), _this._onRenderSplitButtonMenuButton(classNames, keytipAttributes), _this._onRenderSplitButtonDivider(classNames)));
        };
        return keytipProps ? $acw62.createElement((0, $eb1de6218d550a90$export$fb9facd15f0137af), {
            keytipProps: keytipProps,
            disabled: disabled
        }, function(keytipAttributes) {
            return SplitButton(keytipAttributes);
        }) : SplitButton();
    };
    BaseButton.prototype._onRenderSplitButtonDivider = function(classNames) {
        if (classNames && classNames.divider) {
            var onClick = function(ev) {
                ev.stopPropagation();
            };
            return $acw62.createElement("span", {
                className: classNames.divider,
                "aria-hidden": true,
                onClick: onClick
            });
        }
        return null;
    };
    BaseButton.prototype._onRenderSplitButtonMenuButton = function(classNames, keytipAttributes) {
        var _a = this.props, allowDisabledFocus = _a.allowDisabledFocus, checked = _a.checked, disabled = _a.disabled, splitButtonMenuProps = _a.splitButtonMenuProps, splitButtonAriaLabel = _a.splitButtonAriaLabel, primaryDisabled = _a.primaryDisabled;
        var menuHidden = this.state.menuHidden;
        var menuIconProps = this.props.menuIconProps;
        if (menuIconProps === undefined) menuIconProps = {
            iconName: 'ChevronDown'
        };
        var splitButtonProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonMenuProps), {
            styles: classNames,
            checked: checked,
            disabled: disabled,
            allowDisabledFocus: allowDisabledFocus,
            onClick: this._onMenuClick,
            menuProps: undefined,
            iconProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, menuIconProps), {
                className: this._classNames.menuIcon
            }),
            ariaLabel: splitButtonAriaLabel,
            'aria-haspopup': true,
            'aria-expanded': !menuHidden,
            'data-is-focusable': false
        });
        // Add data-ktp-execute-target to the split button if the keytip is defined
        return $acw62.createElement(BaseButton, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonProps, {
            "data-ktp-execute-target": keytipAttributes ? keytipAttributes['data-ktp-execute-target'] : keytipAttributes,
            onMouseDown: this._onMouseDown,
            tabIndex: primaryDisabled && !allowDisabledFocus ? 0 : -1
        }));
    };
    BaseButton.prototype._onPointerDown = function(ev) {
        var onPointerDown = this.props.onPointerDown;
        if (onPointerDown) onPointerDown(ev);
        if (ev.pointerType === 'touch') {
            this._handleTouchAndPointerEvent();
            ev.preventDefault();
            ev.stopImmediatePropagation();
        }
    };
    BaseButton.prototype._handleTouchAndPointerEvent = function() {
        var _this = this;
        // If we already have an existing timeout from a previous touch and pointer event
        // cancel that timeout so we can set a new one.
        if (this._lastTouchTimeoutId !== undefined) {
            this._async.clearTimeout(this._lastTouchTimeoutId);
            this._lastTouchTimeoutId = undefined;
        }
        this._processingTouch = true;
        this._lastTouchTimeoutId = this._async.setTimeout(function() {
            _this._processingTouch = false;
            _this._lastTouchTimeoutId = undefined;
            // Touch and pointer events don't focus the button naturally,
            // so adding an imperative focus call to guarantee this behavior.
            // Only focus the button if a splitbutton menu is not open
            if (_this.state.menuHidden) _this.focus();
        }, $108f802e6afba9ea$var$TouchIdleDelay);
    };
    /**
     * Returns if the user hits a valid keyboard key to open the menu
     * @param ev - the keyboard event
     * @returns True if user clicks on custom trigger key if enabled or alt + down arrow if not. False otherwise.
     */ BaseButton.prototype._isValidMenuOpenKey = function(ev) {
        if (this.props.menuTriggerKeyCode) // eslint-disable-next-line @typescript-eslint/no-deprecated
        return ev.which === this.props.menuTriggerKeyCode;
        else if (this.props.menuProps) // eslint-disable-next-line @typescript-eslint/no-deprecated
        return ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).down && (ev.altKey || ev.metaKey);
        // Note: When enter is pressed, we will let the event continue to propagate
        // to trigger the onClick event on the button
        return false;
    };
    BaseButton.defaultProps = {
        baseClassName: 'ms-Button',
        styles: {},
        split: false
    };
    // needed to access registeredProviders when manually setting focus visibility
    BaseButton.contextType = (0, $872a30e3c6519016$export$683969f4bf72ffbd);
    return BaseButton;
}($acw62.Component);




var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

var $a2e8f416ec0988e8$export$b2ac1e0ebc67376c = function() {
    return !!$a2e8f416ec0988e8$export$cfc74b86dc8b6e03();
};
var $a2e8f416ec0988e8$export$cfc74b86dc8b6e03 = function() {
    return $acw62.useContext((0, $81033f91b1d0d219$export$bab63bc83b10c08f));
};


var $9719a3dc3f7126ce$export$a98fd2d286c7040 = function(_a) {
    var stylesheetKey = _a.stylesheetKey, children = _a.children;
    var _b = (0, $a76127aad685aec8$export$c700cc7ea3d01c27)(), useAdoptedStylesheetEx = _b.useAdoptedStylesheetEx, useMergeStylesRootStylesheets = _b.useMergeStylesRootStylesheets, useWindow = _b.useWindow;
    var shadowCtx = (0, $a2e8f416ec0988e8$export$cfc74b86dc8b6e03)();
    var rootMergeStyles = useMergeStylesRootStylesheets();
    var win = useWindow();
    useAdoptedStylesheetEx((0, $c9c2f6e9ef06bed5$export$5afbf446153651d), shadowCtx, rootMergeStyles, win);
    useAdoptedStylesheetEx(stylesheetKey, shadowCtx, rootMergeStyles, win);
    return children(!!shadowCtx);
};





var $037d9c48a7aea5ed$var$memoizedMakeShadowConfig = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)((0, $c9c2f6e9ef06bed5$export$e2bab33b2c30d9));
var $037d9c48a7aea5ed$var$mergeComponentStyles = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
function(defaultStyles, componentStyles, shadowConfig) {
    var _a;
    var styles = (_a = componentStyles !== null && componentStyles !== void 0 ? componentStyles : defaultStyles) !== null && _a !== void 0 ? _a : {};
    styles.__shadowConfig__ = shadowConfig;
    return styles;
});
function $037d9c48a7aea5ed$export$3693d3f92db27e78(scope, fields, concatStyles) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function customizableFactory(ComposedComponent) {
        var _a;
        var resultClass = (_a = /** @class */ function(_super) {
            (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ComponentWithInjectedProps, _super);
            function ComponentWithInjectedProps(props) {
                var _this = _super.call(this, props) || this;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                _this._styleCache = {};
                _this._onSettingChanged = _this._onSettingChanged.bind(_this);
                return _this;
            }
            ComponentWithInjectedProps.prototype.componentDidMount = function() {
                (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).observe(this._onSettingChanged);
            };
            ComponentWithInjectedProps.prototype.componentWillUnmount = function() {
                (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).unobserve(this._onSettingChanged);
            };
            ComponentWithInjectedProps.prototype.render = function() {
                var _this = this;
                return $acw62.createElement((0, $9719a3dc3f7126ce$export$a98fd2d286c7040), {
                    stylesheetKey: scope
                }, function(inShadow) {
                    return $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Consumer, null, function(context) {
                        var _b;
                        var defaultProps = (0, $dae4fc66435db4e1$export$cbb5b5586292cdb).getSettings(fields, scope, context.customizations);
                        var win = (_b = _this.context.window) !== null && _b !== void 0 ? _b : (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)();
                        var shadowConfig = $037d9c48a7aea5ed$var$memoizedMakeShadowConfig(scope, inShadow, win);
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        var componentProps = _this.props;
                        // If defaultProps.styles is a function, evaluate it before calling concatStyleSets
                        if (defaultProps.styles && typeof defaultProps.styles === 'function') defaultProps.styles = defaultProps.styles((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultProps), componentProps));
                        // If concatStyles is true and custom styles have been defined compute those styles
                        if (concatStyles && defaultProps.styles) {
                            if (_this._styleCache.default !== defaultProps.styles || _this._styleCache.component !== componentProps.styles) {
                                var mergedStyles = (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(defaultProps.styles, componentProps.styles);
                                mergedStyles.__shadowConfig__ = shadowConfig;
                                _this._styleCache.default = defaultProps.styles;
                                _this._styleCache.component = componentProps.styles;
                                _this._styleCache.merged = mergedStyles;
                            }
                            return $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultProps, componentProps, {
                                styles: _this._styleCache.merged
                            }));
                        }
                        var styles = $037d9c48a7aea5ed$var$mergeComponentStyles(defaultProps.styles, componentProps.styles, shadowConfig);
                        return $acw62.createElement(ComposedComponent, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, defaultProps, componentProps, {
                            styles: styles
                        }));
                    });
                });
            };
            ComponentWithInjectedProps.prototype._onSettingChanged = function() {
                this.forceUpdate();
            };
            return ComponentWithInjectedProps;
        }($acw62.Component), _a.displayName = 'Customized' + scope, _a.contextType = (0, $b139ba3b4431b53f$export$19f5fbe41bba757), _a);
        return (0, $05b03fe0c0fe3377$export$e2ba2733092cef57)(ComposedComponent, resultClass);
    };
}






var $daa9adaf0cdc8fd1$var$noOutline = {
    outline: 0
};
var $daa9adaf0cdc8fd1$var$iconStyle = function(fontSize) {
    return {
        fontSize: fontSize,
        margin: '0 4px',
        height: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        flexShrink: 0
    };
};
var $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme) {
    var _a, _b;
    var semanticColors = theme.semanticColors, effects = theme.effects, fonts = theme.fonts;
    var border = semanticColors.buttonBorder;
    var disabledBackground = semanticColors.disabledBackground;
    var disabledText = semanticColors.disabledText;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        outlineColor: 'ButtonText'
    };
    return {
        root: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: 1,
                highContrastStyle: buttonHighContrastFocus,
                borderColor: 'transparent'
            }),
            theme.fonts.medium,
            {
                border: '1px solid ' + border,
                borderRadius: effects.roundedCorner2,
                boxSizing: 'border-box',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 16px',
                textDecoration: 'none',
                textAlign: 'center',
                userSelect: 'none',
                // IE11 workaround for preventing shift of child elements of a button when active.
                ':active > span': {
                    position: 'relative',
                    left: 0,
                    top: 0
                }
            }
        ],
        rootDisabled: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                inset: 1,
                highContrastStyle: buttonHighContrastFocus,
                borderColor: 'transparent'
            }),
            {
                backgroundColor: disabledBackground,
                borderColor: disabledBackground,
                color: disabledText,
                cursor: 'default',
                ':hover': $daa9adaf0cdc8fd1$var$noOutline,
                ':focus': $daa9adaf0cdc8fd1$var$noOutline
            }
        ],
        iconDisabled: (_a = {
            color: disabledText
        }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText'
        }, _a),
        menuIconDisabled: (_b = {
            color: disabledText
        }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText'
        }, _b),
        flexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center'
        },
        description: {
            display: 'block'
        },
        textContainer: {
            flexGrow: 1,
            display: 'block'
        },
        icon: $daa9adaf0cdc8fd1$var$iconStyle(fonts.mediumPlus.fontSize),
        menuIcon: $daa9adaf0cdc8fd1$var$iconStyle(fonts.small.fontSize),
        label: {
            margin: '0 4px',
            lineHeight: '100%',
            display: 'block'
        },
        screenReaderText: (0, $34563ae103a23d08$export$35835471cbe77db4)
    };
});


var $fe35ab35dbcf7cf3$var$DEFAULT_BUTTON_HEIGHT = '40px';
var $fe35ab35dbcf7cf3$var$DEFAULT_PADDING = '0 4px';
var $fe35ab35dbcf7cf3$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles) {
    var _a, _b, _c;
    var baseButtonStyles = (0, $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57)(theme);
    var actionButtonStyles = {
        root: (_a = {
            padding: $fe35ab35dbcf7cf3$var$DEFAULT_PADDING,
            height: $fe35ab35dbcf7cf3$var$DEFAULT_BUTTON_HEIGHT,
            color: theme.palette.neutralPrimary,
            backgroundColor: 'transparent',
            border: '1px solid transparent'
        }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            borderColor: 'Window'
        }, _a),
        rootHovered: (_b = {
            color: theme.palette.themePrimary
        }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'Highlight'
        }, _b),
        iconHovered: {
            color: theme.palette.themePrimary
        },
        rootPressed: {
            color: theme.palette.black
        },
        rootExpanded: {
            color: theme.palette.themePrimary
        },
        iconPressed: {
            color: theme.palette.themeDarker
        },
        rootDisabled: (_c = {
            color: theme.palette.neutralTertiary,
            backgroundColor: 'transparent',
            borderColor: 'transparent'
        }, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText'
        }, _c),
        rootChecked: {
            color: theme.palette.black
        },
        iconChecked: {
            color: theme.palette.themeDarker
        },
        flexContainer: {
            justifyContent: 'flex-start'
        },
        icon: {
            color: theme.palette.themeDarkAlt
        },
        iconDisabled: {
            color: 'inherit'
        },
        menuIcon: {
            color: theme.palette.neutralSecondary
        },
        textContainer: {
            flexGrow: 0
        }
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(baseButtonStyles, actionButtonStyles, customStyles);
});


/**
 * {@docCategory Button}
 */ var $ad8062884923dcf3$export$cfc7921d29ef7b80 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ActionButton, _super);
    function ActionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionButton.prototype.render = function() {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return $acw62.createElement((0, $108f802e6afba9ea$export$e30f1d91ae9a4bf9), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            variantClassName: "ms-Button--action ms-Button--command",
            styles: (0, $fe35ab35dbcf7cf3$export$ffd58b7f6f099a57)(theme, styles),
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    ActionButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)('ActionButton', [
            'theme',
            'styles'
        ], true)
    ], ActionButton);
    return ActionButton;
}($acw62.Component);


var $926fc0b25de033fd$export$f2c92b1cb085d69 = (0, $ad8062884923dcf3$export$cfc7921d29ef7b80);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $97630f38c800601f$export$1e425f1022b31913(callback, initial) {
    if (initial === void 0) initial = null;
    var createRefCallback = function() {
        var refCallback = function(value) {
            if (data.ref.current !== value) {
                if (data.cleanup) {
                    data.cleanup();
                    data.cleanup = undefined;
                }
                data.ref.current = value;
                if (value !== null) data.cleanup = data.callback(value);
            }
        };
        refCallback.current = initial;
        return refCallback;
    };
    var data = $acw62.useRef({
        ref: createRefCallback(),
        callback: callback
    }).current;
    data.callback = callback;
    return data.ref;
}




var $3cfccbc9c2e9c541$export$3e59a5e1472e94f1 = function(target, onResize) {
    if (typeof ResizeObserver !== 'undefined') {
        var observer_1 = new ResizeObserver(onResize);
        if (Array.isArray(target)) target.forEach(function(t) {
            return observer_1.observe(t);
        });
        else observer_1.observe(target);
        return function() {
            return observer_1.disconnect();
        };
    } else {
        // Fallback for browsers that don't support ResizeObserver
        var onResizeWrapper_1 = function() {
            return onResize(undefined);
        };
        var win_1 = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(Array.isArray(target) ? target[0] : target);
        if (!win_1) // Can't listen for resize if we can't get the window object
        return function() {
        // Nothing to clean up
        };
        // Listen for the first animation frame, which will happen after layout is complete
        var animationFrameId_1 = win_1.requestAnimationFrame(onResizeWrapper_1);
        win_1.addEventListener('resize', onResizeWrapper_1, false);
        return function() {
            win_1.cancelAnimationFrame(animationFrameId_1);
            win_1.removeEventListener('resize', onResizeWrapper_1, false);
        };
    }
};


var $4600c460f1652246$export$4edaa8dceb7a95ff = function(_a) {
    var onOverflowItemsChanged = _a.onOverflowItemsChanged, rtl = _a.rtl, pinnedIndex = _a.pinnedIndex;
    var updateOverflowRef = $acw62.useRef(undefined);
    var containerWidthRef = $acw62.useRef(undefined);
    // Attach a resize observer to the container
    var containerRef = (0, $97630f38c800601f$export$1e425f1022b31913)(function(container) {
        var cleanupObserver = (0, $3cfccbc9c2e9c541$export$3e59a5e1472e94f1)(container, function(entries) {
            containerWidthRef.current = entries ? entries[0].contentRect.width : container.clientWidth;
            if (updateOverflowRef.current) updateOverflowRef.current();
        });
        return function() {
            cleanupObserver();
            containerWidthRef.current = undefined;
        };
    });
    var menuButtonRef = (0, $97630f38c800601f$export$1e425f1022b31913)(function(menuButton) {
        containerRef(menuButton.parentElement);
        return function() {
            return containerRef(null);
        };
    });
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        var container = containerRef.current;
        var menuButton = menuButtonRef.current;
        if (!container || !menuButton) return;
        // items contains the container's children, excluding the overflow menu button itself
        var items = [];
        for(var i = 0; i < container.children.length; i++){
            var item = container.children[i];
            if (item instanceof HTMLElement && item !== menuButton) items.push(item);
        }
        // Keep track of the minimum width of the container to fit each child index.
        // This cache is an integral part of the algorithm and not just a performance optimization: it allows us to
        // recalculate the overflowIndex on subsequent resizes even if some items are already inside the overflow.
        var minContainerWidth = [];
        var extraWidth = 0; // The accumulated width of items that don't move into the overflow
        updateOverflowRef.current = function() {
            var containerWidth = containerWidthRef.current;
            if (containerWidth === undefined) return;
            // Iterate the items in reverse order until we find one that fits within the bounds of the container
            for(var i = items.length - 1; i >= 0; i--){
                // Calculate the min container width for this item if we haven't done so yet
                if (minContainerWidth[i] === undefined) {
                    var itemOffsetEnd = rtl ? containerWidth - items[i].offsetLeft : items[i].offsetLeft + items[i].offsetWidth;
                    // If the item after this one is pinned, reserve space for it
                    if (i + 1 < items.length && i + 1 === pinnedIndex) // Use distance between the end of the previous item and this one (rather than the
                    // pinned item's offsetWidth), to account for any margin between the items.
                    extraWidth = minContainerWidth[i + 1] - itemOffsetEnd;
                    // Reserve space for the menu button after the first item was added to the overflow
                    if (i === items.length - 2) extraWidth += menuButton.offsetWidth;
                    minContainerWidth[i] = itemOffsetEnd + extraWidth;
                }
                if (containerWidth > minContainerWidth[i]) {
                    setOverflowIndex(i + 1);
                    return;
                }
            }
            // If we got here, nothing fits outside the overflow
            setOverflowIndex(0);
        };
        var prevOverflowIndex = items.length;
        var setOverflowIndex = function(overflowIndex) {
            if (prevOverflowIndex !== overflowIndex) {
                prevOverflowIndex = overflowIndex;
                onOverflowItemsChanged(overflowIndex, items.map(function(ele, index) {
                    return {
                        ele: ele,
                        isOverflowing: index >= overflowIndex && index !== pinnedIndex
                    };
                }));
            }
        };
        var cancelAnimationFrame = undefined;
        // If the container width is already known from a previous render, update the overflow with its width.
        // Do this in an animation frame to avoid forcing layout to happen early.
        if (containerWidthRef.current !== undefined) {
            var win_1 = (0, $1e1f791b4ec4e821$export$38b2d434cce3ea22)(container);
            if (win_1) {
                var animationFrameId_1 = win_1.requestAnimationFrame(updateOverflowRef.current);
                cancelAnimationFrame = function() {
                    return win_1.cancelAnimationFrame(animationFrameId_1);
                };
            }
        }
        return function() {
            if (cancelAnimationFrame) cancelAnimationFrame();
            // On cleanup, need to remove all items from the overflow
            // so they don't have stale properties on the next render
            setOverflowIndex(items.length);
            updateOverflowRef.current = undefined;
        };
    });
    return {
        menuButtonRef: menuButtonRef
    };
};







var $acw62 = parcelRequire("acw62");

var $0e63da54d743ce64$var$COMPONENT_NAME = 'PivotItem';
var $0e63da54d743ce64$export$7f006972a1dd69ae = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PivotItem, _super);
    function PivotItem(props) {
        var _this = _super.call(this, props) || this;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)($0e63da54d743ce64$var$COMPONENT_NAME, props, {
            linkText: 'headerText'
        });
        return _this;
    }
    PivotItem.prototype.render = function() {
        return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0))), this.props.children);
    };
    return PivotItem;
}($acw62.Component);


var $d5b0ff48f5381baf$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $d5b0ff48f5381baf$var$COMPONENT_NAME = 'Pivot';
var $d5b0ff48f5381baf$var$getTabId = function(props, pivotId, itemKey, index) {
    if (props.getTabId) return props.getTabId(itemKey, index);
    return pivotId + "-Tab".concat(index);
};
// Gets the set of PivotLinks as array of IPivotItemProps
// The set of Links is determined by child components of type PivotItem
var $d5b0ff48f5381baf$var$getLinkItems = function(props, pivotId) {
    var result = {
        links: [],
        keyToIndexMapping: {},
        keyToTabIdMapping: {}
    };
    $acw62.Children.forEach($acw62.Children.toArray(props.children), function(child, index) {
        if ($d5b0ff48f5381baf$var$isPivotItem(child)) {
            var _a = child.props, // eslint-disable-next-line @typescript-eslint/no-deprecated
            linkText = _a.linkText, pivotItemProps = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
                "linkText"
            ]);
            var itemKey = child.props.itemKey || index.toString();
            result.links.push((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                headerText: linkText
            }, pivotItemProps), {
                itemKey: itemKey
            }));
            result.keyToIndexMapping[itemKey] = index;
            result.keyToTabIdMapping[itemKey] = $d5b0ff48f5381baf$var$getTabId(props, pivotId, itemKey, index);
        } else if (child) (0, $6f044242a3d99d90$export$c106dd0671a0fc2d)('The children of a Pivot component must be of type PivotItem to be rendered.');
    });
    return result;
};
var $d5b0ff48f5381baf$var$isPivotItem = function(item) {
    var _a;
    return $acw62.isValidElement(item) && ((_a = item.type) === null || _a === void 0 ? void 0 : _a.name) === (0, $0e63da54d743ce64$export$7f006972a1dd69ae).name;
};
var $d5b0ff48f5381baf$export$808d6f9cbe75659b = $acw62.forwardRef(function(props, ref) {
    var focusZoneRef = $acw62.useRef(null);
    var overflowMenuButtonComponentRef = $acw62.useRef(null);
    var pivotId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)('Pivot');
    var _a = (0, $55cf7aa9f769b3e9$export$2400c890ca0180b4)(props.selectedKey, props.defaultSelectedKey), selectedKey = _a[0], setSelectedKey = _a[1];
    var componentRef = props.componentRef, theme = props.theme, linkSize = props.linkSize, linkFormat = props.linkFormat, overflowBehavior = props.overflowBehavior, overflowAriaLabel = props.overflowAriaLabel, focusZoneProps = props.focusZoneProps, overflowButtonAs = props.overflowButtonAs;
    // eslint-disable-next-line prefer-const
    var classNames;
    var nameProps = {
        'aria-label': props['aria-label'],
        'aria-labelledby': props['aria-labelledby']
    };
    var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
        'aria-label',
        'aria-labelledby'
    ]);
    var linkCollection = $d5b0ff48f5381baf$var$getLinkItems(props, pivotId);
    $acw62.useImperativeHandle(componentRef, function() {
        return {
            focus: function() {
                var _a;
                (_a = focusZoneRef.current) === null || _a === void 0 || _a.focus();
            }
        };
    });
    var renderLinkContent = function(link) {
        if (!link) return null;
        var itemCount = link.itemCount, itemIcon = link.itemIcon, headerText = link.headerText;
        return $acw62.createElement("span", {
            className: classNames.linkContent
        }, itemIcon !== undefined && $acw62.createElement("span", {
            className: classNames.icon
        }, $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
            iconName: itemIcon
        })), headerText !== undefined && $acw62.createElement("span", {
            className: classNames.text
        }, " ", link.headerText), itemCount !== undefined && $acw62.createElement("span", {
            className: classNames.count
        }, " (", itemCount, ")"));
    };
    var renderPivotLink = function(renderLinkCollection, link, renderPivotLinkSelectedKey, className) {
        var itemKey = link.itemKey, headerButtonProps = link.headerButtonProps, onRenderItemLink = link.onRenderItemLink;
        var tabId = renderLinkCollection.keyToTabIdMapping[itemKey];
        var linkContent;
        var isSelected = renderPivotLinkSelectedKey === itemKey;
        if (onRenderItemLink) linkContent = onRenderItemLink(link, renderLinkContent);
        else linkContent = renderLinkContent(link);
        var contentString = link.headerText || '';
        contentString += link.itemCount ? ' (' + link.itemCount + ')' : '';
        // Adding space supplementary for icon
        contentString += link.itemIcon ? ' xx' : '';
        var itemSemantics = link.role && link.role !== 'tab' ? {
            role: link.role
        } : {
            role: 'tab',
            'aria-selected': isSelected
        };
        return $acw62.createElement((0, $926fc0b25de033fd$export$f2c92b1cb085d69), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, headerButtonProps, itemSemantics, {
            id: tabId,
            key: itemKey,
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(className, isSelected && classNames.linkIsSelected),
            // eslint-disable-next-line react/jsx-no-bind
            onClick: function(ev) {
                return onLinkClick(itemKey, ev);
            },
            // eslint-disable-next-line react/jsx-no-bind
            onKeyDown: function(ev) {
                return onKeyDown(itemKey, ev);
            },
            "aria-label": link.ariaLabel,
            name: link.headerText,
            keytipProps: link.keytipProps,
            "data-content": contentString
        }), linkContent);
    };
    var onLinkClick = function(itemKey, ev) {
        ev.preventDefault();
        updateSelectedItem(itemKey, ev);
    };
    var onKeyDown = function(itemKey, ev) {
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        if (ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter) {
            ev.preventDefault();
            updateSelectedItem(itemKey, ev);
        }
    };
    var updateSelectedItem = function(itemKey, ev) {
        var _a;
        setSelectedKey(itemKey);
        linkCollection = $d5b0ff48f5381baf$var$getLinkItems(props, pivotId);
        if (props.onLinkClick && linkCollection.keyToIndexMapping[itemKey] >= 0) {
            var selectedIndex = linkCollection.keyToIndexMapping[itemKey];
            var item = $acw62.Children.toArray(props.children)[selectedIndex];
            if ($d5b0ff48f5381baf$var$isPivotItem(item)) props.onLinkClick(item, ev);
        }
        (_a = overflowMenuButtonComponentRef.current) === null || _a === void 0 || _a.dismissMenu();
    };
    var renderPivotItem = function(itemKey, isActive) {
        if (props.headersOnly || !itemKey) return null;
        var index = linkCollection.keyToIndexMapping[itemKey];
        var selectedTabId = linkCollection.keyToTabIdMapping[itemKey];
        return $acw62.createElement("div", {
            role: "tabpanel",
            hidden: !isActive,
            key: itemKey,
            "aria-hidden": !isActive,
            "aria-labelledby": selectedTabId,
            className: classNames.itemContainer
        }, $acw62.Children.toArray(props.children)[index]);
    };
    var isKeyValid = function(itemKey) {
        return itemKey === null || itemKey !== undefined && linkCollection.keyToIndexMapping[itemKey] !== undefined;
    };
    var getSelectedKey = function() {
        if (isKeyValid(selectedKey)) return selectedKey;
        if (linkCollection.links.length) return linkCollection.links[0].itemKey;
        return undefined;
    };
    classNames = $d5b0ff48f5381baf$var$getClassNames(props.styles, {
        theme: theme,
        linkSize: linkSize,
        linkFormat: linkFormat
    });
    var renderedSelectedKey = getSelectedKey();
    var renderedSelectedIndex = renderedSelectedKey ? linkCollection.keyToIndexMapping[renderedSelectedKey] : 0;
    var items = linkCollection.links.map(function(l) {
        return renderPivotLink(linkCollection, l, renderedSelectedKey, classNames.link);
    });
    // The overflow menu starts empty and items[] is updated as the overflow items change
    var overflowMenuProps = $acw62.useMemo(function() {
        return {
            items: [],
            alignTargetEdge: true,
            directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).bottomRightEdge
        };
    }, []);
    var overflowMenuButtonRef = (0, $4600c460f1652246$export$4edaa8dceb7a95ff)({
        onOverflowItemsChanged: function(overflowIndex, elements) {
            // Set data-is-overflowing on each item
            elements.forEach(function(_a) {
                var ele = _a.ele, isOverflowing = _a.isOverflowing;
                return ele.dataset.isOverflowing = "".concat(isOverflowing);
            });
            // Update the menu items
            overflowMenuProps.items = linkCollection.links.slice(overflowIndex).filter(function(link) {
                return link.itemKey !== renderedSelectedKey;
            }).map(function(link, index) {
                link.role = 'menuitem';
                return {
                    key: link.itemKey || "".concat(overflowIndex + index),
                    onRender: function() {
                        return renderPivotLink(linkCollection, link, renderedSelectedKey, classNames.linkInMenu);
                    }
                };
            });
        },
        rtl: (0, $723d0744d8fe4fde$export$b2303637e9533380)(theme),
        pinnedIndex: renderedSelectedIndex
    }).menuButtonRef;
    var OverflowButton = overflowButtonAs ? overflowButtonAs : (0, $926fc0b25de033fd$export$f2c92b1cb085d69);
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: ref
    }, divProps), $acw62.createElement((0, $8c4e0e7eaa58d986$export$4949eceb002ae2e2), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        componentRef: focusZoneRef,
        role: "tablist"
    }, nameProps, {
        direction: (0, $13ca773bee6ceecf$export$5764f9ffe1c23cd3).horizontal
    }, focusZoneProps, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.root, focusZoneProps === null || focusZoneProps === void 0 ? void 0 : focusZoneProps.className)
    }), items, overflowBehavior === 'menu' && $acw62.createElement(OverflowButton, {
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.link, classNames.overflowMenuButton),
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        elementRef: overflowMenuButtonRef,
        componentRef: overflowMenuButtonComponentRef,
        menuProps: overflowMenuProps,
        menuIconProps: {
            iconName: 'More',
            style: {
                color: 'inherit'
            }
        },
        ariaLabel: overflowAriaLabel,
        role: "tab"
    })), renderedSelectedKey && linkCollection.links.map(function(link) {
        return (link.alwaysRender === true || renderedSelectedKey === link.itemKey) && renderPivotItem(link.itemKey, renderedSelectedKey === link.itemKey);
    }));
});
$d5b0ff48f5381baf$export$808d6f9cbe75659b.displayName = $d5b0ff48f5381baf$var$COMPONENT_NAME;





var $564dcd9e5742b192$var$globalClassNames = {
    count: 'ms-Pivot-count',
    icon: 'ms-Pivot-icon',
    linkIsSelected: 'is-selected',
    link: 'ms-Pivot-link',
    linkContent: 'ms-Pivot-linkContent',
    root: 'ms-Pivot',
    rootIsLarge: 'ms-Pivot--large',
    rootIsTabs: 'ms-Pivot--tabs',
    text: 'ms-Pivot-text',
    linkInMenu: 'ms-Pivot-linkInMenu',
    overflowMenuButton: 'ms-Pivot-overflowMenuButton'
};
var $564dcd9e5742b192$var$getLinkStyles = function(props, classNames, isLinkInOverflowMenu) {
    var _a, _b, _c;
    if (isLinkInOverflowMenu === void 0) isLinkInOverflowMenu = false;
    var linkSize = props.linkSize, linkFormat = props.linkFormat;
    var _d = props.theme, semanticColors = _d.semanticColors, fonts = _d.fonts;
    var rootIsLarge = linkSize === 'large';
    var rootIsTabs = linkFormat === 'tabs';
    return [
        fonts.medium,
        {
            color: semanticColors.actionLink,
            padding: '0 8px',
            position: 'relative',
            backgroundColor: 'transparent',
            border: 0,
            borderRadius: 0,
            selectors: {
                ':hover': {
                    backgroundColor: semanticColors.buttonBackgroundHovered,
                    color: semanticColors.buttonTextHovered,
                    cursor: 'pointer'
                },
                ':active': {
                    backgroundColor: semanticColors.buttonBackgroundPressed,
                    color: semanticColors.buttonTextHovered
                },
                ':focus': {
                    outline: 'none'
                }
            }
        },
        !isLinkInOverflowMenu && [
            {
                display: 'inline-block',
                lineHeight: 44,
                height: 44,
                marginRight: 8,
                textAlign: 'center',
                selectors: (_a = {}, _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus")] = {
                    outline: "1px solid ".concat(semanticColors.focusBorder)
                }, _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus:after, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus:after")] = {
                    content: 'attr(data-content)',
                    position: 'relative',
                    border: 0
                }, _a[':before'] = {
                    backgroundColor: 'transparent',
                    bottom: 0,
                    content: '""',
                    height: 2,
                    left: 8,
                    position: 'absolute',
                    right: 8,
                    transition: "left ".concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue2, " ").concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).easeFunction2, ",\n                        right ").concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue2, " ").concat((0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).easeFunction2)
                }, _a[':after'] = {
                    color: 'transparent',
                    content: 'attr(data-content)',
                    display: 'block',
                    fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).bold,
                    height: 1,
                    overflow: 'hidden',
                    visibility: 'hidden'
                }, _a)
            },
            rootIsLarge && {
                fontSize: fonts.large.fontSize
            },
            rootIsTabs && [
                {
                    marginRight: 0,
                    height: 44,
                    lineHeight: 44,
                    backgroundColor: semanticColors.buttonBackground,
                    padding: '0 10px',
                    verticalAlign: 'top',
                    selectors: (_b = {
                        ':focus': {
                            outlineOffset: '-2px'
                        }
                    }, _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus::before, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus::before")] = {
                        height: 'auto',
                        background: 'transparent',
                        transition: 'none'
                    }, _b['&:hover, &:focus'] = {
                        color: semanticColors.buttonTextCheckedHovered
                    }, _b['&:active, &:hover'] = {
                        color: semanticColors.primaryButtonText,
                        backgroundColor: semanticColors.primaryButtonBackground
                    }, _b["&.".concat(classNames.linkIsSelected)] = {
                        backgroundColor: semanticColors.primaryButtonBackground,
                        color: semanticColors.primaryButtonText,
                        fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular,
                        selectors: (_c = {
                            ':before': {
                                backgroundColor: 'transparent',
                                transition: 'none',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                content: '""',
                                height: 0
                            },
                            ':hover': {
                                backgroundColor: semanticColors.primaryButtonBackgroundHovered,
                                color: semanticColors.primaryButtonText
                            },
                            ':active': {
                                backgroundColor: semanticColors.primaryButtonBackgroundPressed,
                                color: semanticColors.primaryButtonText
                            }
                        }, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                            fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                            color: 'HighlightText',
                            background: 'Highlight'
                        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _c)
                    }, // eslint-disable-next-line @fluentui/max-len
                    _b[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &.").concat(classNames.linkIsSelected, ":focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &.").concat(classNames.linkIsSelected, ":focus")] = {
                        outlineColor: semanticColors.primaryButtonText
                    }, _b)
                }
            ]
        ]
    ];
};
var $564dcd9e5742b192$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c, _d;
    var className = props.className, linkSize = props.linkSize, linkFormat = props.linkFormat, theme = props.theme;
    var semanticColors = theme.semanticColors, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($564dcd9e5742b192$var$globalClassNames, theme);
    var rootIsLarge = linkSize === 'large';
    var rootIsTabs = linkFormat === 'tabs';
    return {
        root: [
            classNames.root,
            fonts.medium,
            (0, $3472c0f90c64fe40$export$a3295358bff77e),
            {
                position: 'relative',
                color: semanticColors.link,
                whiteSpace: 'nowrap'
            },
            rootIsLarge && classNames.rootIsLarge,
            rootIsTabs && classNames.rootIsTabs,
            className
        ],
        itemContainer: {
            selectors: {
                '&[hidden]': {
                    display: 'none'
                }
            }
        },
        link: (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            classNames.link
        ], $564dcd9e5742b192$var$getLinkStyles(props, classNames), true), [
            (_a = {}, _a["&[data-is-overflowing='true']"] = {
                display: 'none'
            }, _a)
        ], false),
        overflowMenuButton: [
            classNames.overflowMenuButton,
            (_b = {
                visibility: 'hidden',
                position: 'absolute',
                right: 0
            }, _b[".".concat(classNames.link, "[data-is-overflowing='true'] ~ &")] = {
                visibility: 'visible',
                position: 'relative'
            }, _b)
        ],
        linkInMenu: (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            classNames.linkInMenu
        ], $564dcd9e5742b192$var$getLinkStyles(props, classNames, true), true), [
            {
                justifyContent: 'start',
                height: 36,
                lineHeight: 36,
                width: '100%'
            }
        ], false),
        linkIsSelected: [
            classNames.link,
            classNames.linkIsSelected,
            {
                fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold,
                selectors: (_c = {
                    ':before': {
                        backgroundColor: semanticColors.inputBackgroundChecked,
                        selectors: (_d = {}, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                            backgroundColor: 'Highlight'
                        }, _d)
                    },
                    ':hover::before': {
                        left: 0,
                        right: 0
                    }
                }, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: 'Highlight'
                }, _c)
            }
        ],
        linkContent: [
            classNames.linkContent,
            {
                flex: '0 1 100%',
                selectors: {
                    '& > * ': {
                        marginLeft: 4
                    },
                    '& > *:first-child': {
                        marginLeft: 0
                    }
                }
            }
        ],
        text: [
            classNames.text,
            {
                display: 'inline-block',
                verticalAlign: 'top'
            }
        ],
        count: [
            classNames.count,
            {
                display: 'inline-block',
                verticalAlign: 'top'
            }
        ],
        icon: classNames.icon
    };
};


var $6c715443a2463de7$export$5147da8fe36663f6 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $d5b0ff48f5381baf$export$808d6f9cbe75659b), (0, $564dcd9e5742b192$export$ffd58b7f6f099a57), undefined, {
    scope: 'Pivot'
});




class $6ed8bbebf8aa6544$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6c715443a2463de7$export$5147da8fe36663f6), {
            className: "gameInfo shadowUtil",
            overflowBehavior: "menu",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e63da54d743ce64$export$7f006972a1dd69ae), {
                    headerText: "Background (story)",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Upon receiving a notice from your company\u2019s",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("abbr", {
                                        title: "Internet Service Provider",
                                        children: "ISP"
                                    }),
                                    ' ',
                                    "about outgoing connections to a",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://en.wikipedia.org/wiki/Botnet",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: "malware command-and-control centre"
                                    }),
                                    ", every network-connected device was shut down by your company\u2019s overzealous system analysts."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "Unfortunately, the suspected",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://en.wikipedia.org/wiki/Ransomware",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: "ransomware"
                                    }),
                                    ' ',
                                    "operates by encrypting all mounted drives upon startup."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    "You are a cybersecurity analyst in the",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://en.wikipedia.org/wiki/Information_security_operations_center",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: "Security Operations Centre"
                                    }),
                                    ' ',
                                    "tasked with remediating this security incident. Can you quarantine all the threats without having your company\u2019s data held hostage?"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e63da54d743ce64$export$7f006972a1dd69ae), {
                    headerText: "Gameplay",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Power on all uninfected nodes on the network without powering on any infected nodes. Powered on nodes will indicate the number of adjacent infected nodes."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Flags can be used to mark a node as quarantined so that it cannot be accidentally powered on."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e63da54d743ce64$export$7f006972a1dd69ae), {
                    headerText: "Controls",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8aaa562457c1b2a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e63da54d743ce64$export$7f006972a1dd69ae), {
                    headerText: "High scores",
                    className: "highScorePanel",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                            horizontal: true,
                            horizontalAlign: "stretch",
                            wrap: true,
                            tokens: {
                                childrenGap: 's1',
                                padding: 'm'
                            },
                            children: [
                                'EASY',
                                'MEDIUM',
                                'HARD'
                            ].map((level)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c).Item, {
                                    style: {
                                        flex: '1'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                                            variant: "large",
                                            children: level
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $47176950e2a98b0b$export$2e2bcd8739ae039), {
                                            highscores: this.props.highscores[level]
                                        })
                                    ]
                                }, level))
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e63da54d743ce64$export$7f006972a1dd69ae), {
                    headerText: "Achievements",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e241e8c3cc886a95$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7514c45a7d5f305$export$2e2bcd8739ae039), {
                            engine: this.props.achievementsEngine
                        })
                    })
                })
            ]
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $d8a8084a4f41660f$var$BroomIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1984 0q26 0 45 19t19 45q0 26-19 45l-730 730q54 69 81 150t28 168q0 103-39 197t-112 168l-68 68-227 454L4 1086l454-227 68-68q73-73 167-112t198-39q87 0 168 27t150 82l730-730q19-19 45-19zm-915 1543L505 979l-285 142 707 707 142-285zm83-98q61-60 94-130t34-158q0-81-30-151t-84-124-123-83-152-31q-87 0-157 33t-131 95l549 549z"
        })),
    displayName: 'BroomIcon'
});
var $d8a8084a4f41660f$export$2e2bcd8739ae039 = $d8a8084a4f41660f$var$BroomIcon;


var $acw62 = parcelRequire("acw62");

const $fc7f12bf94e890f9$var$FlagIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1920 256v1024h-896v-256H384v1024H256V0h896v256h768zm-896 640V128H384v768h640zm768-512h-640v768h640V384z"
        })),
    displayName: 'FlagIcon'
});
var $fc7f12bf94e890f9$export$2e2bcd8739ae039 = $fc7f12bf94e890f9$var$FlagIcon;


var $acw62 = parcelRequire("acw62");

const $64983f61546bdd50$var$TimerIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1639 500q135 136 208 297t73 355q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-111 26-216t75-198 118-172 154-141 185-103 210-57V128H640V0h640v128h-256v128q139 0 270 41t245 122l208-208 90 90-198 199zm-615 1420q159 0 298-60t244-165 165-244 61-299q0-159-60-298t-165-244-244-165-299-61q-159 0-298 60T482 609 317 853t-61 299q0 159 60 298t165 244 244 165 299 61zm640-896v128q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-136-137-203-50-250q0-88 23-170t64-153 100-129 130-101 152-65 171-23h128v512h512zm-640 640q106 0 199-40t163-109 110-163 40-200h-512V640q-107 0-200 40T662 790 552 954t-40 200q0 106 40 199t110 162 163 109 199 40z"
        })),
    displayName: 'TimerIcon'
});
var $64983f61546bdd50$export$2e2bcd8739ae039 = $64983f61546bdd50$var$TimerIcon;


class $748c50e66593826e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
            horizontal: true,
            wrap: true,
            horizontalAlign: "space-around",
            className: "gameStatus shadowUtil",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                    as: "p",
                    role: "status",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64983f61546bdd50$export$2e2bcd8739ae039), {
                            "aria-label": "Time",
                            style: {
                                marginRight: '0.5em',
                                fontSize: '1.25em'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: this.props.time
                        }),
                        " seconds"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                    as: "p",
                    role: "status",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8a8084a4f41660f$export$2e2bcd8739ae039), {
                            "aria-label": "Sweeping progress",
                            style: {
                                marginRight: '0.5em',
                                fontSize: '1.25em'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: new Intl.NumberFormat(undefined, {
                                style: 'percent',
                                maximumFractionDigits: 1
                            }).format(this.props.revealed / (this.props.size - this.props.mines))
                        }),
                        ' ',
                        "devices powered on"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                    as: "p",
                    style: {
                        padding: '0 0.5em',
                        backgroundColor: this.props.flags > this.props.mines ? 'pink' : 'transparent'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc7f12bf94e890f9$export$2e2bcd8739ae039), {
                            "aria-label": "Nodes flagged",
                            style: {
                                marginRight: '0.5em',
                                fontSize: '1.25em'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: this.props.flags
                        }),
                        " of ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                            children: this.props.mines
                        })
                    ]
                })
            ]
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

/**
 * {@docCategory Dialog}
 */ var $02539af196256a3f$export$290cb7291ee58b61;
(function(DialogType) {
    /** Standard dialog */ DialogType[DialogType["normal"] = 0] = "normal";
    /** Dialog with large header banner */ DialogType[DialogType["largeHeader"] = 1] = "largeHeader";
    /** Dialog with an 'x' close button in the upper-right corner */ DialogType[DialogType["close"] = 2] = "close";
})($02539af196256a3f$export$290cb7291ee58b61 || ($02539af196256a3f$export$290cb7291ee58b61 = {}));





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $91622eba4a11f95e$export$cd4e5573fbe2b576 = function(doc) {
    var ae = doc.activeElement;
    while(ae === null || ae === void 0 ? void 0 : ae.shadowRoot)ae = ae.shadowRoot.activeElement;
    return ae;
};

var $1c637104744a43c4$export$e58f029f0fbfdb29 = function(event) {
    var target = event.target;
    if (target && target.shadowRoot) target = event.composedPath()[0];
    return target;
};



var $acw62 = parcelRequire("acw62");


function $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e(fn) {
    var callbackRef = $acw62.useRef(function() {
        throw new Error('Cannot call an event handler while rendering');
    });
    (0, $8c9c580731387b01$export$700979bc83e7db82)(function() {
        callbackRef.current = fn;
    }, [
        fn
    ]);
    // useConst rather than useCallback to ensure the reference is always stable
    // (useCallback's deps list is an optimization, not a guarantee)
    return (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var callback = callbackRef.current;
            return callback.apply(void 0, args);
        };
    });
}


var $acw62 = parcelRequire("acw62");
var $6de8a0d93973ac84$export$89e33b3d84d8c331 = function(callback) {
    var unmountRef = $acw62.useRef(callback);
    unmountRef.current = callback;
    $acw62.useEffect(function() {
        return function() {
            var _a;
            (_a = unmountRef.current) === null || _a === void 0 || _a.call(unmountRef);
        };
    }, []);
};




var $a59e3b1923635c76$var$COMPONENT_NAME = 'FocusTrapZone';
var $a59e3b1923635c76$var$DEFAULT_PROPS = {
    disabled: false,
    disableFirstFocus: false,
    forceFocusInsideTrap: true,
    isClickableOutsideFocusTrap: false,
    // Hardcoding completely uncontrolled flag for proper interop with FluentUI V9.
    'data-tabster': '{"uncontrolled": {"completely": true}}'
};
var $a59e3b1923635c76$var$useComponentRef = function(componentRef, previouslyFocusedElement, focusFTZ) {
    $acw62.useImperativeHandle(componentRef, function() {
        return {
            get previouslyFocusedElement () {
                return previouslyFocusedElement;
            },
            focus: focusFTZ
        };
    }, [
        focusFTZ,
        previouslyFocusedElement
    ]);
};
var $a59e3b1923635c76$export$d51d2fd1b83a7384 = $acw62.forwardRef(function(propsWithoutDefaults, ref) {
    var _a;
    var root = $acw62.useRef(null);
    var firstBumper = $acw62.useRef(null);
    var lastBumper = $acw62.useRef(null);
    var mergedRootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(root, ref);
    var doc = (0, $b139ba3b4431b53f$export$e71e2fb5c5c476d5)();
    var win = (0, $2214ae3f3c5a332e$export$9dddd5610c794317)();
    var inShadow = (0, $a2e8f416ec0988e8$export$b2ac1e0ebc67376c)();
    var isFirstRender = (_a = (0, $3ae817ff5fe2ac83$export$5cae361ad82dce8b)(false)) !== null && _a !== void 0 ? _a : true;
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($a59e3b1923635c76$var$DEFAULT_PROPS, propsWithoutDefaults);
    var internalState = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)({
        hasFocus: false,
        focusStackId: (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)('ftz-', props.id)
    });
    var children = props.children, componentRef = props.componentRef, disabled = props.disabled, disableFirstFocus = props.disableFirstFocus, forceFocusInsideTrap = props.forceFocusInsideTrap, focusPreviouslyFocusedInnerElement = props.focusPreviouslyFocusedInnerElement, // eslint-disable-next-line @typescript-eslint/no-deprecated
    firstFocusableSelector = props.firstFocusableSelector, firstFocusableTarget = props.firstFocusableTarget, // eslint-disable-next-line @typescript-eslint/no-deprecated
    _b = props.disableRestoreFocus, // eslint-disable-next-line @typescript-eslint/no-deprecated
    disableRestoreFocus = _b === void 0 ? props.ignoreExternalFocusing : _b, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, enableAriaHiddenSiblings = props.enableAriaHiddenSiblings;
    var bumperProps = {
        'aria-hidden': true,
        style: {
            pointerEvents: 'none',
            position: 'fixed'
        },
        tabIndex: disabled ? -1 : 0,
        'data-is-visible': true,
        'data-is-focus-trap-zone-bumper': true
    };
    var focusElementAsync = $acw62.useCallback(function(element) {
        if (element !== firstBumper.current && element !== lastBumper.current) (0, $94bdc1ebed789608$export$b5a401136c35d08a)(element);
    }, []);
    /**
     * Callback to force focus into FTZ (named to avoid overlap with global focus() callback).
     * useEventCallback always returns the same callback reference but updates the implementation
     * every render to avoid stale captured values.
     */ var focusFTZ = (0, $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e)(function() {
        if (!root.current) return; // not done mounting
        var previouslyFocusedElementInTrapZone = internalState.previouslyFocusedElementInTrapZone;
        if (focusPreviouslyFocusedInnerElement && previouslyFocusedElementInTrapZone && (0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, previouslyFocusedElementInTrapZone)) {
            // focus on the last item that had focus in the zone before we left the zone
            focusElementAsync(previouslyFocusedElementInTrapZone);
            return;
        }
        var firstFocusableChild = null;
        if (typeof firstFocusableTarget === 'string') firstFocusableChild = root.current.querySelector(firstFocusableTarget);
        else if (firstFocusableTarget) firstFocusableChild = firstFocusableTarget(root.current);
        else if (firstFocusableSelector) {
            var focusSelector = typeof firstFocusableSelector === 'string' ? firstFocusableSelector : firstFocusableSelector();
            firstFocusableChild = root.current.querySelector('.' + focusSelector);
        }
        // Fall back to first element if query selector did not match any elements.
        if (!firstFocusableChild) firstFocusableChild = (0, $94bdc1ebed789608$export$4109ed81edd7716d)(root.current, root.current.firstChild, false, false, false, true, undefined, undefined, undefined, inShadow);
        if (firstFocusableChild) focusElementAsync(firstFocusableChild);
    });
    /** Used in root div focus/blur handlers */ var focusBumper = function(isFirstBumper) {
        if (disabled || !root.current) return;
        var nextFocusable = isFirstBumper === internalState.hasFocus ? (0, $94bdc1ebed789608$export$73cc6e682b257cff)(root.current, lastBumper.current, true, false, inShadow) : (0, $94bdc1ebed789608$export$9beaf9bf6ff178ae)(root.current, firstBumper.current, true, false, inShadow);
        if (nextFocusable) {
            if (nextFocusable === firstBumper.current || nextFocusable === lastBumper.current) // This can happen when FTZ contains no tabbable elements.
            // focusFTZ() will take care of finding a focusable element in FTZ.
            focusFTZ();
            else nextFocusable.focus();
        }
    };
    /** Root div blur handler (doesn't need useCallback since it's for a native element) */ var onRootBlurCapture = function(ev) {
        var _a;
        (_a = props.onBlurCapture) === null || _a === void 0 || _a.call(props, ev);
        var relatedTarget = ev.relatedTarget;
        if (ev.relatedTarget === null) // In IE11, due to lack of support, event.relatedTarget is always
        // null making every onBlur call to be "outside" of the root
        // even when it's not. Using document.activeElement is another way
        // for us to be able to get what the relatedTarget without relying
        // on the event
        relatedTarget = (0, $91622eba4a11f95e$export$cd4e5573fbe2b576)(doc);
        if (!(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, relatedTarget)) internalState.hasFocus = false;
    };
    /** Root div focus handler (doesn't need useCallback since it's for a native element) */ var onRootFocusCapture = function(ev) {
        var _a;
        (_a = props.onFocusCapture) === null || _a === void 0 || _a.call(props, ev);
        if (ev.target === firstBumper.current) focusBumper(true);
        else if (ev.target === lastBumper.current) focusBumper(false);
        internalState.hasFocus = true;
        if (ev.target !== ev.currentTarget && !(ev.target === firstBumper.current || ev.target === lastBumper.current)) // every time focus changes within the trap zone, remember the focused element so that
        // it can be restored if focus leaves the pane and returns via keystroke (i.e. via a call to this.focus(true))
        internalState.previouslyFocusedElementInTrapZone = (0, $1c637104744a43c4$export$e58f029f0fbfdb29)(ev.nativeEvent);
    };
    /** Called to restore focus on unmount or props change. (useEventCallback ensures latest prop values are used.) */ var returnFocusToInitiator = (0, $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e)(function(elementToFocusOnDismiss) {
        $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack = $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack.filter(function(value) {
            return internalState.focusStackId !== value;
        });
        if (!doc) return;
        // Do not use getActiveElement() here.
        // When the FTZ is in shadow DOM focus returns to the
        // shadow host rather than body so we need to be
        // able to inspect that
        var activeElement = doc.activeElement;
        if (!disableRestoreFocus && typeof (elementToFocusOnDismiss === null || elementToFocusOnDismiss === void 0 ? void 0 : elementToFocusOnDismiss.focus) === 'function' && // only restore focus if the current focused element is within the FTZ, or if nothing is focused
        ((0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, activeElement) || activeElement === doc.body || activeElement.shadowRoot)) focusElementAsync(elementToFocusOnDismiss);
    });
    /** Called in window event handlers. (useEventCallback ensures latest prop values are used.) */ var forceFocusOrClickInTrap = (0, $d8fd92ef5ce6bc2c$export$ee5b5d04074a389e)(function(ev) {
        // be sure to use the latest values here
        if (disabled) return;
        if (internalState.focusStackId === $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack.slice(-1)[0]) {
            var targetElement = (0, $1c637104744a43c4$export$e58f029f0fbfdb29)(ev);
            if (targetElement && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, targetElement)) {
                if (doc && (0, $91622eba4a11f95e$export$cd4e5573fbe2b576)(doc) === doc.body) setTimeout(function() {
                    if (doc && (0, $91622eba4a11f95e$export$cd4e5573fbe2b576)(doc) === doc.body) {
                        focusFTZ();
                        internalState.hasFocus = true; // set focus here since we stop event propagation
                    }
                }, 0);
                else {
                    focusFTZ();
                    internalState.hasFocus = true; // set focus here since we stop event propagation
                }
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    });
    // Update window event handlers when relevant props change
    $acw62.useEffect(function() {
        var disposables = [];
        if (forceFocusInsideTrap) disposables.push((0, $18e32c5a70ef0416$export$af631764ddc44097)(win, 'focus', forceFocusOrClickInTrap, true));
        if (!isClickableOutsideFocusTrap) disposables.push((0, $18e32c5a70ef0416$export$af631764ddc44097)(win, 'click', forceFocusOrClickInTrap, true));
        return function() {
            disposables.forEach(function(dispose) {
                return dispose();
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when these two props change
    }, [
        forceFocusInsideTrap,
        isClickableOutsideFocusTrap,
        win
    ]);
    // On prop change or first render, focus the FTZ and update focusStack if appropriate
    $acw62.useEffect(function() {
        // Do nothing if disabled, or if it's a re-render and forceFocusInsideTrap is false
        // (to match existing behavior, the FTZ handles first focus even if forceFocusInsideTrap
        // is false, though it's debatable whether it should do this)
        if (disabled || !isFirstRender && !forceFocusInsideTrap || !root.current) return;
        // Transition from forceFocusInsideTrap / FTZ disabled to enabled (or initial mount)
        $a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack.push(internalState.focusStackId);
        var elementToFocusOnDismiss = props.elementToFocusOnDismiss || (0, $91622eba4a11f95e$export$cd4e5573fbe2b576)(doc);
        if (!disableFirstFocus && !(0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(root.current, elementToFocusOnDismiss)) focusFTZ();
        // To match existing behavior, always return focus on cleanup (even if we didn't handle
        // initial focus), but it's debatable whether that's correct
        return function() {
            return returnFocusToInitiator(elementToFocusOnDismiss);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run when these two props change
    }, [
        forceFocusInsideTrap,
        disabled
    ]);
    // Handle modalization separately from first focus
    $acw62.useEffect(function() {
        if (!disabled && enableAriaHiddenSiblings) {
            var unmodalize = (0, $4077fee6e96f12f4$export$6c6b3b5a8658bfc1)(root.current);
            return unmodalize;
        }
    }, [
        disabled,
        enableAriaHiddenSiblings,
        root
    ]);
    // Cleanup lifecyle method for internalState.
    (0, $6de8a0d93973ac84$export$89e33b3d84d8c331)(function() {
        // Dispose of element references so the DOM Nodes can be garbage-collected
        delete internalState.previouslyFocusedElementInTrapZone;
    });
    $a59e3b1923635c76$var$useComponentRef(componentRef, internalState.previouslyFocusedElementInTrapZone, focusFTZ);
    return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        "aria-labelledby": props.ariaLabelledBy
    }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0)), {
        ref: mergedRootRef,
        onFocusCapture: onRootFocusCapture,
        onBlurCapture: onRootBlurCapture
    }), $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, bumperProps, {
        ref: firstBumper
    })), children, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, bumperProps, {
        ref: lastBumper
    })));
});
$a59e3b1923635c76$export$d51d2fd1b83a7384.displayName = $a59e3b1923635c76$var$COMPONENT_NAME;
$a59e3b1923635c76$export$d51d2fd1b83a7384.focusStack = [];



var $73afaff3798c8b2d$export$82f5c257a11c5515 = (0, $ca17ef8e897e1cc4$export$8b2661a06dc8473f).durationValue2;
var $73afaff3798c8b2d$var$globalClassNames = {
    root: 'ms-Modal',
    main: 'ms-Dialog-main',
    scrollableContent: 'ms-Modal-scrollableContent',
    isOpen: 'is-open',
    layer: 'ms-Modal-Layer'
};
var $73afaff3798c8b2d$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var className = props.className, containerClassName = props.containerClassName, scrollableContentClassName = props.scrollableContentClassName, isOpen = props.isOpen, isVisible = props.isVisible, hasBeenOpened = props.hasBeenOpened, modalRectangleTop = props.modalRectangleTop, theme = props.theme, topOffsetFixed = props.topOffsetFixed, isModeless = props.isModeless, layerClassName = props.layerClassName, isDefaultDragHandle = props.isDefaultDragHandle, windowInnerHeight = props.windowInnerHeight;
    var palette = theme.palette, effects = theme.effects, fonts = theme.fonts;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($73afaff3798c8b2d$var$globalClassNames, theme);
    return {
        root: [
            classNames.root,
            fonts.medium,
            {
                backgroundColor: 'transparent',
                position: 'fixed',
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 0,
                pointerEvents: 'none',
                transition: "opacity ".concat($73afaff3798c8b2d$export$82f5c257a11c5515)
            },
            topOffsetFixed && typeof modalRectangleTop === 'number' && hasBeenOpened && {
                alignItems: 'flex-start'
            },
            isOpen && classNames.isOpen,
            isVisible && {
                opacity: 1
            },
            isVisible && !isModeless && {
                pointerEvents: 'auto'
            },
            className
        ],
        main: [
            classNames.main,
            {
                boxShadow: effects.elevation64,
                borderRadius: effects.roundedCorner2,
                backgroundColor: palette.white,
                boxSizing: 'border-box',
                position: 'relative',
                textAlign: 'left',
                outline: '3px solid transparent',
                maxHeight: 'calc(100% - 32px)',
                maxWidth: 'calc(100% - 32px)',
                minHeight: '176px',
                minWidth: '288px',
                overflowY: 'auto',
                zIndex: isModeless ? (0, $e718b14ff8496161$export$ee30d3e11c8625f1).Layer : undefined
            },
            isModeless && {
                pointerEvents: 'auto'
            },
            topOffsetFixed && typeof modalRectangleTop === 'number' && hasBeenOpened && {
                top: modalRectangleTop
            },
            isDefaultDragHandle && {
                cursor: 'move'
            },
            containerClassName
        ],
        scrollableContent: [
            classNames.scrollableContent,
            {
                overflowY: 'auto',
                flexGrow: 1,
                maxHeight: '100vh',
                selectors: (_a = {}, _a['@supports (-webkit-overflow-scrolling: touch)'] = {
                    maxHeight: windowInnerHeight
                }, _a)
            },
            scrollableContentClassName
        ],
        layer: isModeless && [
            layerClassName,
            classNames.layer,
            {
                pointerEvents: 'none'
            }
        ],
        keyboardMoveIconContainer: {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            padding: '3px 0px'
        },
        keyboardMoveIcon: {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            fontSize: fonts.xLargePlus.fontSize,
            width: '24px'
        }
    };
};





var $acw62 = parcelRequire("acw62");

var $179fcbdee77aba61$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $179fcbdee77aba61$export$e1997a00f7a6d44c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OverlayBase, _super);
    function OverlayBase(props) {
        var _this = _super.call(this, props) || this;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        var _a = _this.props.allowTouchBodyScroll, allowTouchBodyScroll = _a === void 0 ? false : _a;
        _this._allowTouchBodyScroll = allowTouchBodyScroll;
        return _this;
    }
    OverlayBase.prototype.componentDidMount = function() {
        !this._allowTouchBodyScroll && (0, $11f97b2a9a127629$export$24fdf68abf432c44)();
    };
    OverlayBase.prototype.componentWillUnmount = function() {
        !this._allowTouchBodyScroll && (0, $11f97b2a9a127629$export$e5d0524c3725571e)();
    };
    OverlayBase.prototype.render = function() {
        var _a = this.props, isDark = _a.isDarkThemed, className = _a.className, theme = _a.theme, styles = _a.styles;
        var divProps = (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0));
        var classNames = $179fcbdee77aba61$var$getClassNames(styles, {
            theme: theme,
            className: className,
            isDark: isDark
        });
        return $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, divProps, {
            className: classNames.root
        }));
    };
    return OverlayBase;
}($acw62.Component);



var $928f406b652d356e$var$GlobalClassNames = {
    root: 'ms-Overlay',
    rootDark: 'ms-Overlay--dark'
};
var $928f406b652d356e$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var className = props.className, theme = props.theme, isNone = props.isNone, isDark = props.isDark;
    var palette = theme.palette;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($928f406b652d356e$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            {
                backgroundColor: palette.whiteTranslucent40,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                position: 'absolute',
                selectors: (_a = {}, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    border: '1px solid WindowText',
                    opacity: 0
                }, _a)
            },
            isNone && {
                visibility: 'hidden'
            },
            isDark && [
                classNames.rootDark,
                {
                    backgroundColor: palette.blackTranslucent40
                }
            ],
            className
        ]
    };
};


var $91037d22bd4739f3$export$c6fdb837b070b4ff = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $179fcbdee77aba61$export$e1997a00f7a6d44c), (0, $928f406b652d356e$export$ffd58b7f6f099a57), undefined, {
    scope: 'Overlay'
});









var $acw62 = parcelRequire("acw62");


var $0adf6e3641bba959$export$18505e447a7bb2d5 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(className, isDragging) {
    return {
        root: (0, $aa1d034ba9a4cf1b$export$e618dc39ac9ad607)(className, isDragging && {
            touchAction: 'none',
            selectors: {
                '& *': {
                    userSelect: 'none'
                }
            }
        })
    };
});





var $2ba92f40acc406bb$var$eventMapping = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
var $2ba92f40acc406bb$export$4fd887aed1bd2a83 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DraggableZone, _super);
    function DraggableZone(props) {
        var _this = _super.call(this, props) || this;
        _this._currentEventType = $2ba92f40acc406bb$var$eventMapping.mouse;
        _this._events = [];
        _this._onMouseDown = function(event) {
            var onMouseDown = $acw62.Children.only(_this.props.children).props.onMouseDown;
            if (onMouseDown) onMouseDown(event);
            _this._currentEventType = $2ba92f40acc406bb$var$eventMapping.mouse;
            return _this._onDragStart(event);
        };
        _this._onMouseUp = function(event) {
            var onMouseUp = $acw62.Children.only(_this.props.children).props.onMouseUp;
            if (onMouseUp) onMouseUp(event);
            _this._currentEventType = $2ba92f40acc406bb$var$eventMapping.mouse;
            return _this._onDragStop(event);
        };
        _this._onTouchStart = function(event) {
            var onTouchStart = $acw62.Children.only(_this.props.children).props.onTouchStart;
            if (onTouchStart) onTouchStart(event);
            _this._currentEventType = $2ba92f40acc406bb$var$eventMapping.touch;
            return _this._onDragStart(event);
        };
        _this._onTouchEnd = function(event) {
            var onTouchEnd = $acw62.Children.only(_this.props.children).props.onTouchEnd;
            if (onTouchEnd) onTouchEnd(event);
            _this._currentEventType = $2ba92f40acc406bb$var$eventMapping.touch;
            _this._onDragStop(event);
        };
        _this._onDragStart = function(event) {
            // Only handle left click for dragging
            if (typeof event.button === 'number' && event.button !== 0) return false;
            // If the target doesn't match the handleSelector OR
            // if the target does match the preventDragSelector, bail out
            if (_this.props.handleSelector && !_this._matchesSelector(event.target, _this.props.handleSelector) || _this.props.preventDragSelector && _this._matchesSelector(event.target, _this.props.preventDragSelector)) return;
            // Remember the touch identifier if this is a touch event so we can
            // distinguish between individual touches in multitouch scenarios
            // by remembering which touch point we were given
            _this._touchId = _this._getTouchId(event);
            var position = _this._getControlPosition(event);
            if (position === undefined) return;
            var dragData = _this._createDragDataFromPosition(position);
            _this.props.onStart && _this.props.onStart(event, dragData);
            _this.setState({
                isDragging: true,
                lastPosition: position
            });
            // hook up the appropriate mouse/touch events to the body to ensure
            // smooth dragging
            var doc = (0, $2214ae3f3c5a332e$export$c0256123a07df134)(_this.context);
            _this._events = [
                (0, $18e32c5a70ef0416$export$af631764ddc44097)(doc.body, _this._currentEventType.move, _this._onDrag, true),
                (0, $18e32c5a70ef0416$export$af631764ddc44097)(doc.body, _this._currentEventType.stop, _this._onDragStop, true)
            ];
        };
        _this._onDrag = function(event) {
            // Prevent scrolling on mobile devices
            if (event.type === 'touchmove') event.preventDefault();
            var position = _this._getControlPosition(event);
            if (!position) return;
            // create the updated drag data from the position data
            var updatedData = _this._createUpdatedDragData(_this._createDragDataFromPosition(position));
            var updatedPosition = updatedData.position;
            _this.props.onDragChange && _this.props.onDragChange(event, updatedData);
            _this.setState({
                position: updatedPosition,
                lastPosition: position
            });
        };
        _this._onDragStop = function(event) {
            if (!_this.state.isDragging) return;
            var position = _this._getControlPosition(event);
            if (!position) return;
            var baseDragData = _this._createDragDataFromPosition(position);
            // Set dragging to false and reset the lastPosition
            _this.setState({
                isDragging: false,
                lastPosition: undefined
            });
            _this.props.onStop && _this.props.onStop(event, baseDragData);
            if (_this.props.position) _this.setState({
                position: _this.props.position
            });
            // Remove event handlers
            _this._events.forEach(function(dispose) {
                return dispose();
            });
        };
        _this.state = {
            isDragging: false,
            position: _this.props.position || {
                x: 0,
                y: 0
            },
            lastPosition: undefined
        };
        return _this;
    }
    DraggableZone.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.position && (!prevProps.position || this.props.position !== prevProps.position)) this.setState({
            position: this.props.position
        });
    };
    DraggableZone.prototype.componentWillUnmount = function() {
        this._events.forEach(function(dispose) {
            return dispose();
        });
    };
    DraggableZone.prototype.render = function() {
        var child = $acw62.Children.only(this.props.children);
        var props = child.props;
        var position = this.props.position;
        var _a = this.state, statePosition = _a.position, isDragging = _a.isDragging;
        var x = statePosition.x;
        var y = statePosition.y;
        if (position && !isDragging) {
            x = position.x;
            y = position.y;
        }
        return $acw62.cloneElement(child, {
            style: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props.style), {
                transform: "translate(".concat(x, "px, ").concat(y, "px)")
            }),
            className: (0, $0adf6e3641bba959$export$18505e447a7bb2d5)(props.className, this.state.isDragging).root,
            onMouseDown: this._onMouseDown,
            onMouseUp: this._onMouseUp,
            onTouchStart: this._onTouchStart,
            onTouchEnd: this._onTouchEnd
        });
    };
    /**
     * Get the control position based off the event that fired
     * @param event - The event to get offsets from
     */ DraggableZone.prototype._getControlPosition = function(event) {
        var touchObj = this._getActiveTouch(event);
        // did we get the right touch?
        if (this._touchId !== undefined && !touchObj) return undefined;
        var eventToGetOffset = touchObj || event;
        return {
            x: eventToGetOffset.clientX,
            y: eventToGetOffset.clientY
        };
    };
    /**
     * Get the active touch point that we have saved from the event's TouchList
     * @param event - The event used to get the TouchList for the active touch point
     */ DraggableZone.prototype._getActiveTouch = function(event) {
        return event.targetTouches && this._findTouchInTouchList(event.targetTouches) || event.changedTouches && this._findTouchInTouchList(event.changedTouches);
    };
    /**
     * Get the initial touch identifier associated with the given event
     * @param event - The event that contains the TouchList
     */ DraggableZone.prototype._getTouchId = function(event) {
        var touch = event.targetTouches && event.targetTouches[0] || event.changedTouches && event.changedTouches[0];
        if (touch) return touch.identifier;
    };
    /**
     * Returns if an element (or any of the element's parents) match the given selector
     */ DraggableZone.prototype._matchesSelector = function(element, selector) {
        var _a;
        if (!element || element === ((_a = (0, $2214ae3f3c5a332e$export$c0256123a07df134)(this.context)) === null || _a === void 0 ? void 0 : _a.body)) return false;
        var matchesSelectorFn = // eslint-disable-next-line @typescript-eslint/no-deprecated
        element.matches || element.webkitMatchesSelector || element.msMatchesSelector; /* for IE */ 
        if (!matchesSelectorFn) return false;
        return matchesSelectorFn.call(element, selector) || this._matchesSelector(element.parentElement, selector);
    };
    /**
     * Attempts to find the Touch that matches the identifier  we stored in dragStart
     * @param touchList The TouchList to look for the stored identifier from dragStart
     */ DraggableZone.prototype._findTouchInTouchList = function(touchList) {
        if (this._touchId === undefined) return;
        for(var i = 0; i < touchList.length; i++){
            if (touchList[i].identifier === this._touchId) return touchList[i];
        }
        return undefined;
    };
    /**
     * Create DragData based off of the last known position and the new position passed in
     * @param position The new position as part of the drag
     */ DraggableZone.prototype._createDragDataFromPosition = function(position) {
        var lastPosition = this.state.lastPosition;
        // If we have no lastPosition, use the given position
        // for last position
        if (lastPosition === undefined) return {
            delta: {
                x: 0,
                y: 0
            },
            lastPosition: position,
            position: position
        };
        return {
            delta: {
                x: position.x - lastPosition.x,
                y: position.y - lastPosition.y
            },
            lastPosition: lastPosition,
            position: position
        };
    };
    /**
     * Creates an updated DragData based off the current position and given baseDragData
     * @param baseDragData The base DragData (from _createDragDataFromPosition) used to calculate the updated positions
     */ DraggableZone.prototype._createUpdatedDragData = function(baseDragData) {
        var position = this.state.position;
        return {
            position: {
                x: position.x + baseDragData.delta.x,
                y: position.y + baseDragData.delta.y
            },
            delta: baseDragData.delta,
            lastPosition: position
        };
    };
    DraggableZone.contextType = (0, $b139ba3b4431b53f$export$19f5fbe41bba757);
    return DraggableZone;
}($acw62.Component);




var $acw62 = parcelRequire("acw62");

function $4e47a037286114d5$export$c32275ecbd12948f(initialState) {
    var _a = $acw62.useState(initialState), value = _a[0], setValue = _a[1];
    var setTrue = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            setValue(true);
        };
    });
    var setFalse = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            setValue(false);
        };
    });
    var toggle = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return function() {
            setValue(function(currentValue) {
                return !currentValue;
            });
        };
    });
    return [
        value,
        {
            setTrue: setTrue,
            setFalse: setFalse,
            toggle: toggle
        }
    ];
}


var $acw62 = parcelRequire("acw62");

var $1640fda4ff4ce33f$export$4f34107a2b00f39c = function() {
    var timeoutIds = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)({});
    // Cleanup function.
    $acw62.useEffect(function() {
        return function() {
            for(var _i = 0, _a = Object.keys(timeoutIds); _i < _a.length; _i++){
                var id = _a[_i];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                clearTimeout(id);
            }
        };
    }, // useConst ensures this will never change, but react-hooks/exhaustive-deps doesn't know that
    [
        timeoutIds
    ]);
    // Return wrapper which will auto cleanup.
    return (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)({
        setTimeout: function(func, duration) {
            var id = setTimeout(func, duration);
            timeoutIds[id] = 1;
            return id;
        },
        clearTimeout: function(id) {
            delete timeoutIds[id];
            clearTimeout(id);
        }
    });
};


var $1ef96167263bc9b4$var$ZERO = {
    x: 0,
    y: 0
};
var $1ef96167263bc9b4$var$DEFAULT_PROPS = {
    isOpen: false,
    isDarkOverlay: true,
    className: '',
    containerClassName: '',
    enableAriaHiddenSiblings: true
};
var $1ef96167263bc9b4$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $1ef96167263bc9b4$var$getMoveDelta = function(ev) {
    var delta = 10;
    if (ev.shiftKey) {
        if (!ev.ctrlKey) delta = 50;
    } else if (ev.ctrlKey) delta = 1;
    return delta;
};
var $1ef96167263bc9b4$var$useComponentRef = function(props, focusTrapZone) {
    $acw62.useImperativeHandle(props.componentRef, function() {
        return {
            focus: function() {
                if (focusTrapZone.current) focusTrapZone.current.focus();
            }
        };
    }, [
        focusTrapZone
    ]);
};
var $1ef96167263bc9b4$export$acabb5bd2b72d092 = $acw62.forwardRef(function(propsWithoutDefaults, ref) {
    var _a, _b, _c, _d, _e;
    var props = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)($1ef96167263bc9b4$var$DEFAULT_PROPS, propsWithoutDefaults);
    var allowTouchBodyScroll = props.allowTouchBodyScroll, className = props.className, children = props.children, containerClassName = props.containerClassName, scrollableContentClassName = props.scrollableContentClassName, elementToFocusOnDismiss = props.elementToFocusOnDismiss, firstFocusableSelector = props.firstFocusableSelector, focusTrapZoneProps = props.focusTrapZoneProps, forceFocusInsideTrap = props.forceFocusInsideTrap, // eslint-disable-next-line @typescript-eslint/no-deprecated
    _f = props.disableRestoreFocus, // eslint-disable-next-line @typescript-eslint/no-deprecated
    disableRestoreFocus = _f === void 0 ? props.ignoreExternalFocusing : _f, isBlocking = props.isBlocking, isAlert = props.isAlert, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, isDarkOverlay = props.isDarkOverlay, onDismiss = props.onDismiss, layerProps = props.layerProps, overlay = props.overlay, isOpen = props.isOpen, titleAriaId = props.titleAriaId, styles = props.styles, subtitleAriaId = props.subtitleAriaId, theme = props.theme, topOffsetFixed = props.topOffsetFixed, responsiveMode = props.responsiveMode, // eslint-disable-next-line @typescript-eslint/no-deprecated
    onLayerDidMount = props.onLayerDidMount, isModeless = props.isModeless, dragOptions = props.dragOptions, onDismissed = props.onDismissed, // eslint-disable-next-line @typescript-eslint/no-deprecated
    enableAriaHiddenSiblings = props.enableAriaHiddenSiblings, popupProps = props.popupProps;
    var rootRef = $acw62.useRef(null);
    var focusTrapZone = $acw62.useRef(null);
    var focusTrapZoneRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(focusTrapZone, focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.componentRef);
    var focusTrapZoneElm = $acw62.useRef(null);
    var mergedRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(rootRef, ref);
    var modalResponsiveMode = (0, $6124a3d3c764767c$export$551dad37f2b289e2)(mergedRef);
    var focusTrapZoneId = (0, $cd7f9b753e2e3aa8$export$f680877a34711e37)('ModalFocusTrapZone', focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.id);
    var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
    var _g = (0, $1640fda4ff4ce33f$export$4f34107a2b00f39c)(), setTimeout = _g.setTimeout, clearTimeout = _g.clearTimeout;
    var _h = $acw62.useState(isOpen), isModalOpen = _h[0], setIsModalOpen = _h[1];
    var _j = $acw62.useState(isOpen), isVisible = _j[0], setIsVisible = _j[1];
    var _k = $acw62.useState($1ef96167263bc9b4$var$ZERO), coordinates = _k[0], setCoordinates = _k[1];
    var _l = $acw62.useState(), modalRectangleTop = _l[0], setModalRectangleTop = _l[1];
    var _m = (0, $4e47a037286114d5$export$c32275ecbd12948f)(false), isModalMenuOpen = _m[0], _o = _m[1], toggleModalMenuOpen = _o.toggle, setModalMenuClose = _o.setFalse;
    var internalState = (0, $7cd4cc59ef8f1433$export$8219f5c55c7cc288)(function() {
        return {
            onModalCloseTimer: 0,
            allowTouchBodyScroll: allowTouchBodyScroll,
            scrollableContent: null,
            lastSetCoordinates: $1ef96167263bc9b4$var$ZERO,
            events: new (0, $7e392406ee2126b8$export$7af5106782f53286)({})
        };
    });
    var keepInBounds = (dragOptions || {}).keepInBounds;
    var isAlertRole = isAlert !== null && isAlert !== void 0 ? isAlert : isBlocking && !isModeless;
    var layerClassName = layerProps === undefined ? '' : layerProps.className;
    var classNames = $1ef96167263bc9b4$var$getClassNames(styles, {
        theme: theme,
        className: className,
        containerClassName: containerClassName,
        scrollableContentClassName: scrollableContentClassName,
        isOpen: isOpen,
        isVisible: isVisible,
        hasBeenOpened: internalState.hasBeenOpened,
        modalRectangleTop: modalRectangleTop,
        topOffsetFixed: topOffsetFixed,
        isModeless: isModeless,
        layerClassName: layerClassName,
        windowInnerHeight: win === null || win === void 0 ? void 0 : win.innerHeight,
        isDefaultDragHandle: dragOptions && !dragOptions.dragHandleSelector
    });
    var mergedLayerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        eventBubblingEnabled: false
    }, layerProps), {
        onLayerDidMount: layerProps && layerProps.onLayerDidMount ? layerProps.onLayerDidMount : onLayerDidMount,
        insertFirst: (layerProps === null || layerProps === void 0 ? void 0 : layerProps.insertFirst) || isModeless,
        className: classNames.layer
    });
    // Allow the user to scroll within the modal but not on the body
    var allowScrollOnModal = $acw62.useCallback(function(elt) {
        if (elt) {
            if (internalState.allowTouchBodyScroll) (0, $11f97b2a9a127629$export$d4daebbd8ba7010c)(elt, internalState.events);
            else (0, $11f97b2a9a127629$export$f02f9101103a4939)(elt, internalState.events);
        } else internalState.events.off(internalState.scrollableContent);
        internalState.scrollableContent = elt;
    }, [
        internalState
    ]);
    var registerInitialModalPosition = function() {
        var dialogMain = focusTrapZoneElm.current;
        var modalRectangle = dialogMain === null || dialogMain === void 0 ? void 0 : dialogMain.getBoundingClientRect();
        if (modalRectangle) {
            if (topOffsetFixed) setModalRectangleTop(modalRectangle.top);
            if (keepInBounds) {
                // x/y are unavailable in IE, so use the equivalent left/top
                internalState.minPosition = {
                    x: -modalRectangle.left,
                    y: -modalRectangle.top
                };
                internalState.maxPosition = {
                    x: modalRectangle.left,
                    y: modalRectangle.top
                };
            }
        }
    };
    /**
     * Clamps an axis to a specified min and max position.
     *
     * @param axis A string that represents the axis (x/y).
     * @param position The position on the axis.
     */ var getClampedAxis = $acw62.useCallback(function(axis, position) {
        var minPosition = internalState.minPosition, maxPosition = internalState.maxPosition;
        if (keepInBounds && minPosition && maxPosition) {
            position = Math.max(minPosition[axis], position);
            position = Math.min(maxPosition[axis], position);
        }
        return position;
    }, [
        keepInBounds,
        internalState
    ]);
    var handleModalClose = function() {
        var _a;
        internalState.lastSetCoordinates = $1ef96167263bc9b4$var$ZERO;
        setModalMenuClose();
        internalState.isInKeyboardMoveMode = false;
        setIsModalOpen(false);
        setCoordinates($1ef96167263bc9b4$var$ZERO);
        (_a = internalState.disposeOnKeyUp) === null || _a === void 0 || _a.call(internalState);
        onDismissed === null || onDismissed === void 0 || onDismissed();
    };
    var handleDragStart = $acw62.useCallback(function() {
        setModalMenuClose();
        internalState.isInKeyboardMoveMode = false;
    }, [
        internalState,
        setModalMenuClose
    ]);
    var handleDrag = $acw62.useCallback(function(ev, dragData) {
        setCoordinates(function(prevValue) {
            return {
                x: getClampedAxis('x', prevValue.x + dragData.delta.x),
                y: getClampedAxis('y', prevValue.y + dragData.delta.y)
            };
        });
    }, [
        getClampedAxis
    ]);
    var handleDragStop = $acw62.useCallback(function() {
        if (focusTrapZone.current) focusTrapZone.current.focus();
    }, []);
    var handleEnterKeyboardMoveMode = function() {
        // We need a global handleKeyDown event when we are in the move mode so that we can
        // handle the key presses and the components inside the modal do not get the events
        var handleKeyDown = function(ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.altKey && ev.ctrlKey && ev.keyCode === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) {
                // CTRL + ALT + SPACE is handled during keyUp
                ev.preventDefault();
                ev.stopPropagation();
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var newLocal = ev.altKey || ev.keyCode === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape;
            if (isModalMenuOpen && newLocal) setModalMenuClose();
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (internalState.isInKeyboardMoveMode && (ev.keyCode === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape || ev.keyCode === (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter)) {
                internalState.isInKeyboardMoveMode = false;
                ev.preventDefault();
                ev.stopPropagation();
            }
            if (internalState.isInKeyboardMoveMode) {
                var handledEvent = true;
                var delta_1 = $1ef96167263bc9b4$var$getMoveDelta(ev);
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                switch(ev.keyCode){
                    /* eslint-disable no-fallthrough */ case (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape:
                        setCoordinates(internalState.lastSetCoordinates);
                    case (0, $c011a102064f82ea$export$ec835b702d42f3f0).enter:
                        // TODO: determine if fallthrough was intentional
                        /* eslint-enable no-fallthrough */ internalState.lastSetCoordinates = $1ef96167263bc9b4$var$ZERO;
                        break;
                    case (0, $c011a102064f82ea$export$ec835b702d42f3f0).up:
                        setCoordinates(function(prevValue) {
                            return {
                                x: prevValue.x,
                                y: getClampedAxis('y', prevValue.y - delta_1)
                            };
                        });
                        break;
                    case (0, $c011a102064f82ea$export$ec835b702d42f3f0).down:
                        setCoordinates(function(prevValue) {
                            return {
                                x: prevValue.x,
                                y: getClampedAxis('y', prevValue.y + delta_1)
                            };
                        });
                        break;
                    case (0, $c011a102064f82ea$export$ec835b702d42f3f0).left:
                        setCoordinates(function(prevValue) {
                            return {
                                x: getClampedAxis('x', prevValue.x - delta_1),
                                y: prevValue.y
                            };
                        });
                        break;
                    case (0, $c011a102064f82ea$export$ec835b702d42f3f0).right:
                        setCoordinates(function(prevValue) {
                            return {
                                x: getClampedAxis('x', prevValue.x + delta_1),
                                y: prevValue.y
                            };
                        });
                        break;
                    default:
                        handledEvent = false;
                }
                if (handledEvent) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        internalState.lastSetCoordinates = coordinates;
        setModalMenuClose();
        internalState.isInKeyboardMoveMode = true;
        internalState.events.on(win, 'keydown', handleKeyDown, true);
        internalState.disposeOnKeyDown = function() {
            internalState.events.off(win, 'keydown', handleKeyDown, true);
            internalState.disposeOnKeyDown = undefined;
        };
    };
    var handleExitKeyboardMoveMode = function(ev) {
        var _a, _b;
        (_a = focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.onBlur) === null || _a === void 0 || _a.call(focusTrapZoneProps, ev);
        internalState.lastSetCoordinates = $1ef96167263bc9b4$var$ZERO;
        internalState.isInKeyboardMoveMode = false;
        (_b = internalState.disposeOnKeyDown) === null || _b === void 0 || _b.call(internalState);
    };
    var registerForKeyUp = function() {
        var handleKeyUp = function(ev) {
            // Needs to handle the CTRL + ALT + SPACE key during keyup due to FireFox bug:
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1220143
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if (ev.altKey && ev.ctrlKey && ev.keyCode === (0, $c011a102064f82ea$export$ec835b702d42f3f0).space) {
                if ((0, $bd2f10be17e6ca27$export$12de49ec5e3dd0cd)(internalState.scrollableContent, ev.target)) {
                    toggleModalMenuOpen();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        };
        if (!internalState.disposeOnKeyUp) {
            internalState.events.on(win, 'keyup', handleKeyUp, true);
            internalState.disposeOnKeyUp = function() {
                internalState.events.off(win, 'keyup', handleKeyUp, true);
                internalState.disposeOnKeyUp = undefined;
            };
        }
    };
    $acw62.useEffect(function() {
        clearTimeout(internalState.onModalCloseTimer);
        // Opening the dialog
        if (isOpen) {
            // This must be done after the modal content has rendered
            requestAnimationFrame(function() {
                return setTimeout(registerInitialModalPosition, 0);
            });
            setIsModalOpen(true);
            // Add a keyUp handler for all key up events once the dialog is open.
            if (dragOptions) registerForKeyUp();
            internalState.hasBeenOpened = true;
            setIsVisible(true);
        }
        // Closing the dialog
        if (!isOpen && isModalOpen) {
            internalState.onModalCloseTimer = setTimeout(handleModalClose, parseFloat((0, $73afaff3798c8b2d$export$82f5c257a11c5515)) * 1000);
            setIsVisible(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- should only run if isModalOpen or isOpen mutates.
    }, [
        isModalOpen,
        isOpen
    ]);
    (0, $6de8a0d93973ac84$export$89e33b3d84d8c331)(function() {
        internalState.events.dispose();
        if (internalState.onModalCloseTimer) {
            clearTimeout(internalState.onModalCloseTimer);
            internalState.onModalCloseTimer = 0;
        }
    });
    $1ef96167263bc9b4$var$useComponentRef(props, focusTrapZone);
    $1ef96167263bc9b4$var$useDebugWarnings(props);
    var modalContent = $acw62.createElement((0, $a59e3b1923635c76$export$d51d2fd1b83a7384), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, focusTrapZoneProps, {
        id: focusTrapZoneId,
        ref: focusTrapZoneElm,
        componentRef: focusTrapZoneRef,
        className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.main, focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.className),
        elementToFocusOnDismiss: (_a = focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.elementToFocusOnDismiss) !== null && _a !== void 0 ? _a : elementToFocusOnDismiss,
        isClickableOutsideFocusTrap: (_b = focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.isClickableOutsideFocusTrap) !== null && _b !== void 0 ? _b : isModeless || isClickableOutsideFocusTrap || !isBlocking,
        disableRestoreFocus: (_c = focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.disableRestoreFocus) !== null && _c !== void 0 ? _c : disableRestoreFocus,
        forceFocusInsideTrap: ((_d = focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.forceFocusInsideTrap) !== null && _d !== void 0 ? _d : forceFocusInsideTrap) && !isModeless,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        firstFocusableSelector: (focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.firstFocusableSelector) || firstFocusableSelector,
        focusPreviouslyFocusedInnerElement: (_e = focusTrapZoneProps === null || focusTrapZoneProps === void 0 ? void 0 : focusTrapZoneProps.focusPreviouslyFocusedInnerElement) !== null && _e !== void 0 ? _e : true,
        onBlur: internalState.isInKeyboardMoveMode ? handleExitKeyboardMoveMode : undefined
    }), dragOptions && internalState.isInKeyboardMoveMode && $acw62.createElement("div", {
        className: classNames.keyboardMoveIconContainer
    }, dragOptions.keyboardMoveIconProps ? $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, dragOptions.keyboardMoveIconProps)) : $acw62.createElement((0, $4b3e235077c5b552$export$f04a61298a47a40f), {
        iconName: "move",
        className: classNames.keyboardMoveIcon
    })), $acw62.createElement("div", {
        ref: allowScrollOnModal,
        className: classNames.scrollableContent,
        "data-is-scrollable": true
    }, dragOptions && isModalMenuOpen && $acw62.createElement(dragOptions.menu, {
        items: [
            {
                key: 'move',
                text: dragOptions.moveMenuItemText,
                onClick: handleEnterKeyboardMoveMode
            },
            {
                key: 'close',
                text: dragOptions.closeMenuItemText,
                onClick: handleModalClose
            }
        ],
        onDismiss: setModalMenuClose,
        alignTargetEdge: true,
        coverTarget: true,
        directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).topLeftEdge,
        directionalHintFixed: true,
        shouldFocusOnMount: true,
        target: internalState.scrollableContent
    }), children));
    return isModalOpen && modalResponsiveMode >= (responsiveMode || (0, $d2efee541c4fc734$export$73c2705cb2da08ab).small) && $acw62.createElement((0, $0644c419e4ac4578$export$936d0764594b6eb3), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        ref: mergedRef
    }, mergedLayerProps), $acw62.createElement((0, $36276731e4f27f52$export$129a32eedafa97c5), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        role: isAlertRole ? 'alertdialog' : 'dialog',
        ariaLabelledBy: titleAriaId,
        ariaDescribedBy: subtitleAriaId,
        onDismiss: onDismiss,
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        shouldRestoreFocus: !disableRestoreFocus,
        // Modeless modals shouldn't hide siblings.
        // Popup will automatically handle this based on the aria-modal setting.
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        enableAriaHiddenSiblings: enableAriaHiddenSiblings,
        "aria-modal": !isModeless
    }, popupProps), $acw62.createElement("div", {
        className: classNames.root,
        role: !isModeless ? 'document' : undefined
    }, !isModeless && $acw62.createElement((0, $91037d22bd4739f3$export$c6fdb837b070b4ff), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        "aria-hidden": true,
        isDarkThemed: isDarkOverlay,
        onClick: isBlocking ? undefined : onDismiss,
        allowTouchBodyScroll: allowTouchBodyScroll
    }, overlay)), dragOptions ? $acw62.createElement((0, $2ba92f40acc406bb$export$4fd887aed1bd2a83), {
        handleSelector: dragOptions.dragHandleSelector || "#".concat(focusTrapZoneId),
        preventDragSelector: "button",
        onStart: handleDragStart,
        onDragChange: handleDrag,
        onStop: handleDragStop,
        position: coordinates
    }, modalContent) : modalContent))) || null;
});
$1ef96167263bc9b4$export$acabb5bd2b72d092.displayName = 'Modal';
function $1ef96167263bc9b4$var$useDebugWarnings(props) {}



var $531cf1b7e875e852$export$2b77a92f1a5ad772 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $1ef96167263bc9b4$export$acabb5bd2b72d092), (0, $73afaff3798c8b2d$export$ffd58b7f6f099a57), undefined, {
    scope: 'Modal',
    fields: [
        'theme',
        'styles',
        'enableAriaHiddenSiblings'
    ]
});
$531cf1b7e875e852$export$2b77a92f1a5ad772.displayName = 'Modal';






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








var $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var effects = theme.effects, palette = theme.palette, semanticColors = theme.semanticColors;
    var buttonHighContrastFocus = {
        left: -2,
        top: -2,
        bottom: -2,
        right: -2,
        border: 'none'
    };
    var splitButtonDividerBaseStyles = {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8
    };
    var splitButtonStyles = {
        splitButtonContainer: [
            (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
                highContrastStyle: buttonHighContrastFocus,
                inset: 2,
                pointerEvents: 'none'
            }),
            {
                display: 'inline-flex',
                '.ms-Button--default': {
                    borderTopRightRadius: '0',
                    borderBottomRightRadius: '0',
                    borderRight: 'none',
                    flexGrow: '1'
                },
                '.ms-Button--primary': (_a = {
                    borderTopRightRadius: '0',
                    borderBottomRightRadius: '0',
                    border: 'none',
                    flexGrow: '1',
                    ':hover': {
                        border: 'none'
                    },
                    ':active': {
                        border: 'none'
                    }
                }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    color: 'WindowText',
                    backgroundColor: 'Window',
                    border: '1px solid WindowText',
                    borderRightWidth: '0'
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
                    ':hover': {
                        backgroundColor: 'Highlight',
                        border: '1px solid Highlight',
                        borderRightWidth: '0',
                        color: 'HighlightText'
                    },
                    ':active': {
                        border: '1px solid Highlight'
                    }
                }), _a),
                '.ms-Button--default + .ms-Button': (_b = {}, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    border: '1px solid WindowText',
                    borderLeftWidth: '0',
                    ':hover': {
                        backgroundColor: 'HighlightText',
                        borderColor: 'Highlight',
                        color: 'Highlight',
                        '.ms-Button-menuIcon': (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                            backgroundColor: 'HighlightText',
                            color: 'Highlight'
                        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)())
                    }
                }, _b),
                '.ms-Button--default + .ms-Button[aria-expanded="true"]': (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    backgroundColor: 'HighlightText',
                    borderColor: 'Highlight',
                    color: 'Highlight',
                    '.ms-Button-menuIcon': (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                        backgroundColor: 'HighlightText',
                        color: 'Highlight'
                    }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)())
                }, _c),
                '.ms-Button--primary + .ms-Button': (_d = {
                    border: 'none'
                }, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    border: '1px solid WindowText',
                    borderLeftWidth: '0',
                    ':hover': {
                        borderLeftWidth: '0',
                        backgroundColor: 'Highlight',
                        borderColor: 'Highlight',
                        color: 'HighlightText',
                        '.ms-Button-menuIcon': (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
                            color: 'HighlightText'
                        })
                    }
                }, _d),
                '.ms-Button--primary + .ms-Button[aria-expanded="true"]': (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                    backgroundColor: 'Highlight',
                    borderColor: 'Highlight',
                    color: 'HighlightText'
                }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), {
                    '.ms-Button-menuIcon': {
                        color: 'HighlightText'
                    }
                }), _e),
                '.ms-Button.is-disabled': (_f = {}, _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                    color: 'GrayText',
                    borderColor: 'GrayText',
                    backgroundColor: 'Window'
                }, _f)
            }
        ],
        splitButtonContainerHovered: {
            '.ms-Button--default.is-disabled': (_g = {
                backgroundColor: semanticColors.buttonBackgroundDisabled,
                color: semanticColors.buttonTextDisabled
            }, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: 'GrayText',
                borderColor: 'GrayText',
                backgroundColor: 'Window'
            }, _g),
            '.ms-Button--primary.is-disabled': (_h = {
                backgroundColor: semanticColors.primaryButtonBackgroundDisabled,
                color: semanticColors.primaryButtonTextDisabled
            }, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: 'GrayText',
                borderColor: 'GrayText',
                backgroundColor: 'Window'
            }, _h)
        },
        splitButtonContainerChecked: {
            '.ms-Button--primary': (_j = {}, _j[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: 'Window',
                backgroundColor: 'WindowText'
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _j)
        },
        splitButtonContainerCheckedHovered: {
            '.ms-Button--primary': (_k = {}, _k[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                color: 'Window',
                backgroundColor: 'WindowText'
            }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _k)
        },
        splitButtonContainerFocused: {
            outline: 'none!important'
        },
        splitButtonMenuButton: (_l = {
            padding: 6,
            height: 'auto',
            boxSizing: 'border-box',
            borderRadius: 0,
            borderTopRightRadius: effects.roundedCorner2,
            borderBottomRightRadius: effects.roundedCorner2,
            border: "1px solid ".concat(palette.neutralSecondaryAlt),
            borderLeft: 'none',
            outline: 'transparent',
            userSelect: 'none',
            display: 'inline-block',
            textDecoration: 'none',
            textAlign: 'center',
            cursor: 'pointer',
            verticalAlign: 'top',
            width: 32,
            marginLeft: -1,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0
        }, _l[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            '.ms-Button-menuIcon': {
                color: 'WindowText'
            }
        }, _l),
        splitButtonDivider: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonDividerBaseStyles), (_m = {}, _m[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            backgroundColor: 'WindowText'
        }, _m)),
        splitButtonDividerDisabled: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, splitButtonDividerBaseStyles), (_o = {}, _o[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            backgroundColor: 'GrayText'
        }, _o)),
        splitButtonMenuButtonDisabled: (_p = {
            pointerEvents: 'none',
            border: 'none',
            ':hover': {
                cursor: 'default'
            },
            '.ms-Button--primary': (_q = {}, _q[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: 'GrayText',
                borderColor: 'GrayText',
                backgroundColor: 'Window'
            }, _q),
            '.ms-Button-menuIcon': (_r = {}, _r[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: 'GrayText'
            }, _r)
        }, _p[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText',
            border: '1px solid GrayText',
            backgroundColor: 'Window'
        }, _p),
        splitButtonFlexContainer: {
            display: 'flex',
            height: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center'
        },
        splitButtonContainerDisabled: (_s = {
            outline: 'none',
            border: 'none'
        }, _s[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            color: 'GrayText',
            borderColor: 'GrayText',
            backgroundColor: 'Window'
        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _s),
        splitButtonMenuFocused: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, (0, $3c8eab4e1d179dea$export$58062d1b35a0b5bd)(theme, {
            highContrastStyle: buttonHighContrastFocus,
            inset: 2
        }))
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(splitButtonStyles, customStyles);
});


var $d5c452a0e6fe6545$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles) {
    var _a;
    var baseButtonStyles = (0, $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57)(theme);
    var splitButtonStyles = (0, $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57)(theme);
    var palette = theme.palette, semanticColors = theme.semanticColors;
    var iconButtonStyles = {
        root: {
            padding: '0 4px',
            width: '32px',
            height: '32px',
            backgroundColor: 'transparent',
            border: 'none',
            color: semanticColors.link
        },
        rootHovered: (_a = {
            color: palette.themeDarkAlt,
            backgroundColor: palette.neutralLighter
        }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            borderColor: 'Highlight',
            color: 'Highlight'
        }, _a),
        rootHasMenu: {
            width: 'auto'
        },
        rootPressed: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight
        },
        rootExpanded: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight
        },
        rootChecked: {
            color: palette.themeDark,
            backgroundColor: palette.neutralLight
        },
        rootCheckedHovered: {
            color: palette.themeDark,
            backgroundColor: palette.neutralQuaternaryAlt
        },
        rootDisabled: {
            color: palette.neutralTertiaryAlt
        }
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(baseButtonStyles, iconButtonStyles, splitButtonStyles, customStyles);
});


/**
 * {@docCategory Button}
 */ var $e1e2a5c29caeedea$export$c25acd513dcc8062 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IconButton, _super);
    function IconButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconButton.prototype.render = function() {
        var _a = this.props, styles = _a.styles, theme = _a.theme;
        return $acw62.createElement((0, $108f802e6afba9ea$export$e30f1d91ae9a4bf9), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            variantClassName: "ms-Button--icon",
            styles: (0, $d5c452a0e6fe6545$export$ffd58b7f6f099a57)(theme, styles),
            onRenderText: (0, $12233c50b7efccdc$export$c14f77b8570f3676),
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    IconButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)('IconButton', [
            'theme',
            'styles'
        ], true)
    ], IconButton);
    return IconButton;
}($acw62.Component);





var $acw62 = parcelRequire("acw62");

var $b61c34f7f09bbab5$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $b61c34f7f09bbab5$export$5be05ded51043162 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DialogFooterBase, _super);
    function DialogFooterBase(props) {
        var _this = _super.call(this, props) || this;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        return _this;
    }
    DialogFooterBase.prototype.render = function() {
        var _a = this.props, className = _a.className, styles = _a.styles, theme = _a.theme;
        this._classNames = $b61c34f7f09bbab5$var$getClassNames(styles, {
            theme: theme,
            className: className
        });
        return $acw62.createElement("div", {
            className: this._classNames.actions
        }, $acw62.createElement("div", {
            className: this._classNames.actionsRight
        }, this._renderChildrenAsActions()));
    };
    DialogFooterBase.prototype._renderChildrenAsActions = function() {
        var _this = this;
        return $acw62.Children.map(this.props.children, function(child) {
            return child ? $acw62.createElement("span", {
                className: _this._classNames.action
            }, child) : null;
        });
    };
    return DialogFooterBase;
}($acw62.Component);



var $b79746dfdf6be14b$var$GlobalClassNames = {
    actions: 'ms-Dialog-actions',
    action: 'ms-Dialog-action',
    actionsRight: 'ms-Dialog-actionsRight'
};
var $b79746dfdf6be14b$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($b79746dfdf6be14b$var$GlobalClassNames, theme);
    return {
        actions: [
            classNames.actions,
            {
                position: 'relative',
                width: '100%',
                minHeight: '24px',
                lineHeight: '24px',
                margin: '16px 0 0',
                fontSize: '0',
                selectors: {
                    '.ms-Button': {
                        lineHeight: 'normal',
                        verticalAlign: 'middle'
                    }
                }
            },
            className
        ],
        action: [
            classNames.action,
            {
                margin: '0 4px'
            }
        ],
        actionsRight: [
            classNames.actionsRight,
            {
                alignItems: 'center',
                display: 'flex',
                fontSize: '0',
                justifyContent: 'flex-end',
                marginRight: '-4px'
            }
        ]
    };
};


var $b12e79a827290871$export$7bbfb2d443473050 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $b61c34f7f09bbab5$export$5be05ded51043162), (0, $b79746dfdf6be14b$export$ffd58b7f6f099a57), undefined, {
    scope: 'DialogFooter'
});
$b12e79a827290871$export$7bbfb2d443473050.displayName = 'DialogFooter';



var $24e6d24790afc573$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $24e6d24790afc573$var$DialogFooterType = $acw62.createElement((0, $b12e79a827290871$export$7bbfb2d443473050), null).type;
var $24e6d24790afc573$var$COMPONENT_NAME = 'DialogContent';
// eslint-disable-next-line @typescript-eslint/no-deprecated
var $24e6d24790afc573$export$414f10ca60bd3e5 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DialogContentBase, _super);
    function DialogContentBase(props) {
        var _this = _super.call(this, props) || this;
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        (0, $9d47dbd69e7cba76$export$8f36788a39deb482)($24e6d24790afc573$var$COMPONENT_NAME, props, {
            titleId: 'titleProps.id'
        });
        return _this;
    }
    DialogContentBase.prototype.render = function() {
        var _a = this.props, showCloseButton = _a.showCloseButton, className = _a.className, closeButtonAriaLabel = _a.closeButtonAriaLabel, onDismiss = _a.onDismiss, subTextId = _a.subTextId, subText = _a.subText, _b = _a.titleProps, titleProps = _b === void 0 ? {} : _b, // eslint-disable-next-line @typescript-eslint/no-deprecated
        titleId = _a.titleId, title = _a.title, type = _a.type, styles = _a.styles, theme = _a.theme, draggableHeaderClassName = _a.draggableHeaderClassName;
        var classNames = $24e6d24790afc573$var$getClassNames(styles, {
            theme: theme,
            className: className,
            isLargeHeader: type === (0, $02539af196256a3f$export$290cb7291ee58b61).largeHeader,
            isClose: type === (0, $02539af196256a3f$export$290cb7291ee58b61).close,
            draggableHeaderClassName: draggableHeaderClassName
        });
        var groupings = this._groupChildren();
        var subTextContent;
        if (subText) subTextContent = $acw62.createElement("p", {
            className: classNames.subText,
            id: subTextId
        }, subText);
        return $acw62.createElement("div", {
            className: classNames.content
        }, $acw62.createElement("div", {
            className: classNames.header
        }, $acw62.createElement("div", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: titleId,
            role: "heading",
            "aria-level": 1
        }, titleProps, {
            className: (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(classNames.title, titleProps.className)
        }), title), $acw62.createElement("div", {
            className: classNames.topButton
        }, this.props.topButtonsProps.map(function(props, index) {
            return $acw62.createElement((0, $e1e2a5c29caeedea$export$c25acd513dcc8062), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                key: props.uniqueId || index
            }, props));
        }), (type === (0, $02539af196256a3f$export$290cb7291ee58b61).close || showCloseButton && type !== (0, $02539af196256a3f$export$290cb7291ee58b61).largeHeader) && $acw62.createElement((0, $e1e2a5c29caeedea$export$c25acd513dcc8062), {
            className: classNames.button,
            iconProps: {
                iconName: 'Cancel'
            },
            ariaLabel: closeButtonAriaLabel,
            onClick: onDismiss
        }))), $acw62.createElement("div", {
            className: classNames.inner
        }, $acw62.createElement("div", {
            className: classNames.innerContent
        }, subTextContent, groupings.contents), groupings.footers));
    };
    // @TODO - typing the footers as an array of DialogFooter is difficult because
    // casing "child as DialogFooter" causes a problem because
    // "Neither type 'ReactElement<any>' nor type 'DialogFooter' is assignable to the other."
    DialogContentBase.prototype._groupChildren = function() {
        var groupings = {
            footers: [],
            contents: []
        };
        $acw62.Children.map(this.props.children, function(child) {
            if (typeof child === 'object' && child !== null && child.type === $24e6d24790afc573$var$DialogFooterType) groupings.footers.push(child);
            else groupings.contents.push(child);
        });
        return groupings;
    };
    DialogContentBase.defaultProps = {
        showCloseButton: false,
        className: '',
        topButtonsProps: [],
        closeButtonAriaLabel: 'Close'
    };
    DialogContentBase = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $d2efee541c4fc734$export$a0079cc4280057ef)
    ], DialogContentBase);
    return DialogContentBase;
}($acw62.Component);



var $03ca1998f2ea9acf$var$GlobalClassNames = {
    contentLgHeader: 'ms-Dialog-lgHeader',
    close: 'ms-Dialog--close',
    subText: 'ms-Dialog-subText',
    header: 'ms-Dialog-header',
    headerLg: 'ms-Dialog--lgHeader',
    button: 'ms-Dialog-button ms-Dialog-button--close',
    inner: 'ms-Dialog-inner',
    content: 'ms-Dialog-content',
    title: 'ms-Dialog-title'
};
var $03ca1998f2ea9acf$export$ffd58b7f6f099a57 = function(props) {
    var _a, _b, _c;
    var className = props.className, theme = props.theme, isLargeHeader = props.isLargeHeader, isClose = props.isClose, hidden = props.hidden, isMultiline = props.isMultiline, draggableHeaderClassName = props.draggableHeaderClassName;
    var palette = theme.palette, fonts = theme.fonts, effects = theme.effects, semanticColors = theme.semanticColors;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($03ca1998f2ea9acf$var$GlobalClassNames, theme);
    return {
        content: [
            isLargeHeader && [
                classNames.contentLgHeader,
                {
                    borderTop: "4px solid ".concat(palette.themePrimary)
                }
            ],
            isClose && classNames.close,
            {
                flexGrow: 1,
                overflowY: 'hidden'
            },
            className
        ],
        subText: [
            classNames.subText,
            fonts.medium,
            {
                margin: '0 0 24px 0',
                color: semanticColors.bodySubtext,
                lineHeight: '1.5',
                wordWrap: 'break-word',
                fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).regular
            }
        ],
        header: [
            classNames.header,
            {
                position: 'relative',
                width: '100%',
                boxSizing: 'border-box'
            },
            isClose && classNames.close,
            draggableHeaderClassName && [
                draggableHeaderClassName,
                {
                    cursor: 'move'
                }
            ]
        ],
        button: [
            classNames.button,
            hidden && {
                selectors: {
                    '.ms-Icon.ms-Icon--Cancel': {
                        color: semanticColors.buttonText,
                        fontSize: (0, $1ba480b26914dcf0$export$7f8918a48f5782fd).medium
                    }
                }
            }
        ],
        inner: [
            classNames.inner,
            {
                padding: '0 24px 24px',
                selectors: (_a = {}, _a["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$a91d390a6282498), "px) and (max-width: ").concat((0, $905fed6f1ccd845a$export$b7949b403ba42a41), "px)")] = {
                    padding: '0 16px 16px'
                }, _a)
            }
        ],
        innerContent: [
            classNames.content,
            {
                position: 'relative',
                width: '100%'
            }
        ],
        title: [
            classNames.title,
            fonts.xLarge,
            {
                color: semanticColors.bodyText,
                margin: '0',
                minHeight: fonts.xLarge.fontSize,
                padding: '16px 46px 20px 24px',
                lineHeight: 'normal',
                selectors: (_b = {}, _b["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$a91d390a6282498), "px) and (max-width: ").concat((0, $905fed6f1ccd845a$export$b7949b403ba42a41), "px)")] = {
                    padding: '16px 46px 16px 16px'
                }, _b)
            },
            isLargeHeader && {
                color: semanticColors.menuHeader
            },
            isMultiline && {
                fontSize: fonts.xxLarge.fontSize
            }
        ],
        topButton: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                position: 'absolute',
                top: '0',
                right: '0',
                padding: '15px 15px 0 0',
                selectors: (_c = {
                    '> *': {
                        flex: '0 0 auto'
                    },
                    '.ms-Dialog-button': {
                        color: semanticColors.buttonText
                    },
                    '.ms-Dialog-button:hover': {
                        color: semanticColors.buttonTextHovered,
                        borderRadius: effects.roundedCorner2
                    }
                }, _c["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$a91d390a6282498), "px) and (max-width: ").concat((0, $905fed6f1ccd845a$export$b7949b403ba42a41), "px)")] = {
                    padding: '15px 8px 0 0'
                }, _c)
            }
        ]
    };
};


var $1c5ac6447e0ee342$export$b6d9565de1e068cf = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $24e6d24790afc573$export$414f10ca60bd3e5), (0, $03ca1998f2ea9acf$export$ffd58b7f6f099a57), undefined, {
    scope: 'DialogContent'
});
$1c5ac6447e0ee342$export$b6d9565de1e068cf.displayName = 'DialogContent';


var $c36b84e64078e7e5$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $c36b84e64078e7e5$var$DefaultModalProps = {
    isDarkOverlay: false,
    isBlocking: false,
    className: '',
    containerClassName: '',
    topOffsetFixed: false,
    enableAriaHiddenSiblings: true
};
var $c36b84e64078e7e5$var$DefaultDialogContentProps = {
    type: (0, $02539af196256a3f$export$290cb7291ee58b61).normal,
    className: '',
    topButtonsProps: []
};
// eslint-disable-next-line @typescript-eslint/no-deprecated
var $c36b84e64078e7e5$export$569e42c9a98af7b7 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DialogBase, _super);
    function DialogBase(props) {
        var _this = _super.call(this, props) || this;
        _this._getSubTextId = function() {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = _this.props, ariaDescribedById = _a.ariaDescribedById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, subText = _a.subText;
            var id = modalProps && modalProps.subtitleAriaId || ariaDescribedById;
            if (!id) id = (dialogContentProps && dialogContentProps.subText || subText) && _this._defaultSubTextId;
            return id;
        };
        _this._getTitleTextId = function() {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            var _a = _this.props, ariaLabelledById = _a.ariaLabelledById, modalProps = _a.modalProps, dialogContentProps = _a.dialogContentProps, title = _a.title;
            var id = modalProps && modalProps.titleAriaId || ariaLabelledById;
            if (!id) id = (dialogContentProps && dialogContentProps.title || title) && _this._defaultTitleTextId;
            return id;
        };
        _this._id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)('Dialog');
        _this._defaultTitleTextId = _this._id + '-title';
        _this._defaultSubTextId = _this._id + '-subText';
        return _this;
    }
    DialogBase.prototype.render = function() {
        var _a, _b, _c;
        var props = this.props;
        var /* eslint-disable @typescript-eslint/no-deprecated */ className = props.className, containerClassName = props.containerClassName, contentClassName = props.contentClassName, elementToFocusOnDismiss = props.elementToFocusOnDismiss, firstFocusableSelector = props.firstFocusableSelector, forceFocusInsideTrap = props.forceFocusInsideTrap, styles = props.styles, hidden = props.hidden, _d = props.disableRestoreFocus, disableRestoreFocus = _d === void 0 ? props.ignoreExternalFocusing : _d, isBlocking = props.isBlocking, isClickableOutsideFocusTrap = props.isClickableOutsideFocusTrap, isDarkOverlay = props.isDarkOverlay, _e = props.isOpen, isOpen = _e === void 0 ? !hidden : _e, onDismiss = props.onDismiss, onDismissed = props.onDismissed, onLayerDidMount = props.onLayerDidMount, responsiveMode = props.responsiveMode, subText = props.subText, theme = props.theme, title = props.title, topButtonsProps = props.topButtonsProps, type = props.type, /* eslint-enable @typescript-eslint/no-deprecated */ minWidth = props.minWidth, maxWidth = props.maxWidth, modalProps = props.modalProps;
        var mergedLayerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            onLayerDidMount: onLayerDidMount
        }, modalProps === null || modalProps === void 0 ? void 0 : modalProps.layerProps);
        var dialogDraggableClassName;
        var dragOptions;
        // If dragOptions are provided, but no drag handle is specified, we supply a drag handle,
        // and inform dialog contents to add class to draggable class to the header
        if ((modalProps === null || modalProps === void 0 ? void 0 : modalProps.dragOptions) && !((_a = modalProps.dragOptions) === null || _a === void 0 ? void 0 : _a.dragHandleSelector)) {
            // spread options to avoid mutating props
            dragOptions = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, modalProps.dragOptions);
            dialogDraggableClassName = 'ms-Dialog-draggable-header';
            dragOptions.dragHandleSelector = ".".concat(dialogDraggableClassName);
        }
        var mergedModalProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $c36b84e64078e7e5$var$DefaultModalProps), {
            elementToFocusOnDismiss: elementToFocusOnDismiss,
            firstFocusableSelector: firstFocusableSelector,
            forceFocusInsideTrap: forceFocusInsideTrap,
            disableRestoreFocus: disableRestoreFocus,
            isClickableOutsideFocusTrap: isClickableOutsideFocusTrap,
            responsiveMode: responsiveMode,
            className: className,
            containerClassName: containerClassName,
            isBlocking: isBlocking,
            isDarkOverlay: isDarkOverlay,
            onDismissed: onDismissed
        }), modalProps), {
            dragOptions: dragOptions,
            layerProps: mergedLayerProps,
            isOpen: isOpen
        });
        var dialogContentProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            className: contentClassName,
            subText: subText,
            title: title,
            topButtonsProps: topButtonsProps,
            type: type
        }, $c36b84e64078e7e5$var$DefaultDialogContentProps), props.dialogContentProps), {
            draggableHeaderClassName: dialogDraggableClassName,
            titleProps: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
                // eslint-disable-next-line @typescript-eslint/no-deprecated
                id: ((_b = props.dialogContentProps) === null || _b === void 0 ? void 0 : _b.titleId) || this._defaultTitleTextId
            }, (_c = props.dialogContentProps) === null || _c === void 0 ? void 0 : _c.titleProps)
        });
        var classNames = $c36b84e64078e7e5$var$getClassNames(styles, {
            theme: theme,
            className: mergedModalProps.className,
            containerClassName: mergedModalProps.containerClassName,
            hidden: hidden,
            dialogDefaultMinWidth: minWidth,
            dialogDefaultMaxWidth: maxWidth
        });
        return $acw62.createElement((0, $531cf1b7e875e852$export$2b77a92f1a5ad772), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, mergedModalProps, {
            className: classNames.root,
            containerClassName: classNames.main,
            onDismiss: onDismiss || mergedModalProps.onDismiss,
            subtitleAriaId: this._getSubTextId(),
            titleAriaId: this._getTitleTextId()
        }), $acw62.createElement((0, $1c5ac6447e0ee342$export$b6d9565de1e068cf), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            subTextId: this._defaultSubTextId,
            showCloseButton: mergedModalProps.isBlocking,
            onDismiss: onDismiss
        }, dialogContentProps), props.children));
    };
    DialogBase.defaultProps = {
        hidden: true
    };
    DialogBase = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $d2efee541c4fc734$export$a0079cc4280057ef)
    ], DialogBase);
    return DialogBase;
}($acw62.Component);



var $13b7c13a96b4a046$var$GlobalClassNames = {
    root: 'ms-Dialog'
};
var $13b7c13a96b4a046$export$ffd58b7f6f099a57 = function(props) {
    var _a;
    var className = props.className, containerClassName = props.containerClassName, _b = props.dialogDefaultMinWidth, dialogDefaultMinWidth = _b === void 0 ? '288px' : _b, _c = props.dialogDefaultMaxWidth, dialogDefaultMaxWidth = _c === void 0 ? '340px' : _c, hidden = props.hidden, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($13b7c13a96b4a046$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            theme.fonts.medium,
            className
        ],
        main: [
            {
                width: dialogDefaultMinWidth,
                outline: '3px solid transparent',
                selectors: (_a = {}, _a["@media (min-width: ".concat((0, $905fed6f1ccd845a$export$2a2cf3a4e575f28), "px)")] = {
                    width: 'auto',
                    maxWidth: dialogDefaultMaxWidth,
                    minWidth: dialogDefaultMinWidth
                }, _a)
            },
            !hidden && {
                display: 'flex'
            },
            containerClassName
        ]
    };
};


var $02711f7facaa0bc1$export$3ddf2d174ce01153 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $c36b84e64078e7e5$export$569e42c9a98af7b7), (0, $13b7c13a96b4a046$export$ffd58b7f6f099a57), undefined, {
    scope: 'Dialog'
});
$02711f7facaa0bc1$export$3ddf2d174ce01153.displayName = 'Dialog';




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");









var $f2de76bf8443ae94$var$splitButtonDividerBaseStyles = function() {
    return {
        position: 'absolute',
        width: 1,
        right: 31,
        top: 8,
        bottom: 8
    };
};
function $f2de76bf8443ae94$export$d3b979120f04e53e(theme) {
    var _a, _b, _c, _d, _e;
    var s = theme.semanticColors, p = theme.palette;
    var buttonBackground = s.buttonBackground;
    var buttonBackgroundPressed = s.buttonBackgroundPressed;
    var buttonBackgroundHovered = s.buttonBackgroundHovered;
    var buttonBackgroundDisabled = s.buttonBackgroundDisabled;
    var buttonText = s.buttonText;
    var buttonTextHovered = s.buttonTextHovered;
    var buttonTextDisabled = s.buttonTextDisabled;
    var buttonTextChecked = s.buttonTextChecked;
    var buttonTextCheckedHovered = s.buttonTextCheckedHovered;
    return {
        root: {
            backgroundColor: buttonBackground,
            color: buttonText
        },
        rootHovered: (_a = {
            backgroundColor: buttonBackgroundHovered,
            color: buttonTextHovered
        }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            borderColor: 'Highlight',
            color: 'Highlight'
        }, _a),
        rootPressed: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked
        },
        rootExpanded: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked
        },
        rootChecked: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextChecked
        },
        rootCheckedHovered: {
            backgroundColor: buttonBackgroundPressed,
            color: buttonTextCheckedHovered
        },
        rootDisabled: (_b = {
            color: buttonTextDisabled,
            backgroundColor: buttonBackgroundDisabled
        }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText',
            borderColor: 'GrayText',
            backgroundColor: 'Window'
        }, _b),
        // Split button styles
        splitButtonContainer: (_c = {}, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            border: 'none'
        }, _c),
        splitButtonMenuButton: {
            color: p.white,
            backgroundColor: 'transparent',
            ':hover': (_d = {
                backgroundColor: p.neutralLight
            }, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
                color: 'Highlight'
            }, _d)
        },
        splitButtonMenuButtonDisabled: {
            backgroundColor: s.buttonBackgroundDisabled,
            ':hover': {
                backgroundColor: s.buttonBackgroundDisabled
            }
        },
        splitButtonDivider: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f2de76bf8443ae94$var$splitButtonDividerBaseStyles()), (_e = {
            backgroundColor: p.neutralTertiaryAlt
        }, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            backgroundColor: 'WindowText'
        }, _e)),
        splitButtonDividerDisabled: {
            backgroundColor: theme.palette.neutralTertiaryAlt
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: p.neutralQuaternaryAlt,
            ':hover': {
                backgroundColor: p.neutralQuaternaryAlt
            }
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: p.neutralQuaternaryAlt,
            ':hover': {
                backgroundColor: p.neutralQuaternaryAlt
            }
        },
        splitButtonMenuIcon: {
            color: s.buttonText
        },
        splitButtonMenuIconDisabled: {
            color: s.buttonTextDisabled
        }
    };
}
function $f2de76bf8443ae94$export$7e75853538f28122(theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var p = theme.palette, s = theme.semanticColors;
    return {
        root: (_a = {
            backgroundColor: s.primaryButtonBackground,
            border: "1px solid ".concat(s.primaryButtonBackground),
            color: s.primaryButtonText
        }, _a[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            color: 'Window',
            backgroundColor: 'WindowText',
            borderColor: 'WindowText'
        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _a[".".concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), " &:focus, :host(.").concat((0, $68e6902efa21380a$export$d4b0d4f3148ab6bf), ") &:focus")] = {
            ':after': {
                border: "none",
                outlineColor: p.white
            }
        }, _a),
        rootHovered: (_b = {
            backgroundColor: s.primaryButtonBackgroundHovered,
            border: "1px solid ".concat(s.primaryButtonBackgroundHovered),
            color: s.primaryButtonTextHovered
        }, _b[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'Window',
            backgroundColor: 'Highlight',
            borderColor: 'Highlight'
        }, _b),
        rootPressed: (_c = {
            backgroundColor: s.primaryButtonBackgroundPressed,
            border: "1px solid ".concat(s.primaryButtonBackgroundPressed),
            color: s.primaryButtonTextPressed
        }, _c[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            color: 'Window',
            backgroundColor: 'WindowText',
            borderColor: 'WindowText'
        }, (0, $905fed6f1ccd845a$export$ea44bc327145cc4d)()), _c),
        rootExpanded: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed
        },
        rootChecked: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed
        },
        rootCheckedHovered: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            color: s.primaryButtonTextPressed
        },
        rootDisabled: (_d = {
            color: s.primaryButtonTextDisabled,
            backgroundColor: s.primaryButtonBackgroundDisabled
        }, _d[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText',
            borderColor: 'GrayText',
            backgroundColor: 'Window'
        }, _d),
        // Split button styles
        splitButtonContainer: (_e = {}, _e[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            border: 'none'
        }, _e),
        splitButtonDivider: (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f2de76bf8443ae94$var$splitButtonDividerBaseStyles()), (_f = {
            backgroundColor: p.white
        }, _f[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            backgroundColor: 'Window'
        }, _f)),
        splitButtonMenuButton: (_g = {
            backgroundColor: s.primaryButtonBackground,
            color: s.primaryButtonText
        }, _g[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            backgroundColor: 'Canvas'
        }, _g[':hover'] = (_h = {
            backgroundColor: s.primaryButtonBackgroundHovered
        }, _h[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'Highlight'
        }, _h), _g),
        splitButtonMenuButtonDisabled: {
            backgroundColor: s.primaryButtonBackgroundDisabled,
            ':hover': {
                backgroundColor: s.primaryButtonBackgroundDisabled
            }
        },
        splitButtonMenuButtonChecked: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            ':hover': {
                backgroundColor: s.primaryButtonBackgroundPressed
            }
        },
        splitButtonMenuButtonExpanded: {
            backgroundColor: s.primaryButtonBackgroundPressed,
            ':hover': {
                backgroundColor: s.primaryButtonBackgroundPressed
            }
        },
        splitButtonMenuIcon: {
            color: s.primaryButtonText
        },
        splitButtonMenuIconDisabled: (_j = {
            color: p.neutralTertiary
        }, _j[0, $905fed6f1ccd845a$export$77a09a3b0466bd17] = {
            color: 'GrayText'
        }, _j)
    };
}


var $3bc66d69c75dee3c$var$DEFAULT_BUTTON_MIN_HEIGHT = '32px';
var $3bc66d69c75dee3c$var$DEFAULT_BUTTON_MIN_WIDTH = '80px';
var $3bc66d69c75dee3c$export$ffd58b7f6f099a57 = (0, $ccf88a0d18e38068$export$c008d290adbd8ce5)(function(theme, customStyles, primary) {
    var baseButtonStyles = (0, $daa9adaf0cdc8fd1$export$ffd58b7f6f099a57)(theme);
    var splitButtonStyles = (0, $ba73ee86e0bdb3e5$export$ffd58b7f6f099a57)(theme);
    var defaultButtonStyles = {
        root: {
            minWidth: $3bc66d69c75dee3c$var$DEFAULT_BUTTON_MIN_WIDTH,
            minHeight: $3bc66d69c75dee3c$var$DEFAULT_BUTTON_MIN_HEIGHT
        },
        label: {
            fontWeight: (0, $1ba480b26914dcf0$export$32743b01f42d159e).semibold
        }
    };
    return (0, $9f80d64ff1d557a5$export$b9e8701096551fdc)(baseButtonStyles, defaultButtonStyles, primary ? (0, $f2de76bf8443ae94$export$7e75853538f28122)(theme) : (0, $f2de76bf8443ae94$export$d3b979120f04e53e)(theme), splitButtonStyles, customStyles);
});


/**
 * {@docCategory Button}
 */ var $82fb36076cfcc62a$export$b7c3a2f69225ecf = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DefaultButton, _super);
    function DefaultButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultButton.prototype.render = function() {
        var _a = this.props, _b = _a.primary, primary = _b === void 0 ? false : _b, styles = _a.styles, theme = _a.theme;
        return $acw62.createElement((0, $108f802e6afba9ea$export$e30f1d91ae9a4bf9), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            variantClassName: primary ? 'ms-Button--primary' : 'ms-Button--default',
            styles: (0, $3bc66d69c75dee3c$export$ffd58b7f6f099a57)(theme, styles, primary),
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    DefaultButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)('DefaultButton', [
            'theme',
            'styles'
        ], true)
    ], DefaultButton);
    return DefaultButton;
}($acw62.Component);


/**
 * {@docCategory Button}
 */ var $bf3792db3fad6664$export$ac16a6a04d9b7c84 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PrimaryButton, _super);
    function PrimaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrimaryButton.prototype.render = function() {
        return $acw62.createElement((0, $82fb36076cfcc62a$export$b7c3a2f69225ecf), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.props, {
            primary: true,
            onRenderDescription: (0, $12233c50b7efccdc$export$c14f77b8570f3676)
        }));
    };
    PrimaryButton = (0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
        (0, $037d9c48a7aea5ed$export$3693d3f92db27e78)('PrimaryButton', [
            'theme',
            'styles'
        ], true)
    ], PrimaryButton);
    return PrimaryButton;
}($acw62.Component);



var $acw62 = parcelRequire("acw62");

const $868500f3719dd006$var$ReportHackedIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1024 1536H896v-128h128v128zm0-1152H896v896h128V384zm-64 1661q-119-70-236-149t-224-171-198-196-159-223-105-253T0 768V256q83 0 161-6t152-22 146-45 144-75q85-55 170-81T960 0q51 0 97 6t89 20 86 34 85 48q72 46 144 75t146 45 152 22 161 6v512q0 151-38 285t-105 253-158 223-198 195-224 171-237 150zM128 382v386q0 127 33 244t92 222 138 200 172 178 193 155 204 130q102-59 203-130t194-154 172-178 138-200 91-223 34-244V382q-149-8-285-48t-263-121q-68-44-135-64t-149-21q-81 0-148 20t-136 65q-126 81-262 121t-286 48z"
        })),
    displayName: 'ReportHackedIcon'
});
var $868500f3719dd006$export$2e2bcd8739ae039 = $868500f3719dd006$var$ReportHackedIcon;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $5ecd0e508deaca50$export$2c657da244d00bd6 = $acw62.createContext(undefined);


/**
 * Get theme from CustomizerContext or Customizations singleton.
 */ function $c0559e03c5bb1edc$var$useCompatTheme() {
    return (0, $2a04d28498bd59af$export$e00cde8527a0be3f)([
        'theme'
    ]).theme;
}
var $c0559e03c5bb1edc$export$93d4e7f90805808f = function() {
    var theme = $acw62.useContext((0, $5ecd0e508deaca50$export$2c657da244d00bd6));
    var legacyTheme = $c0559e03c5bb1edc$var$useCompatTheme();
    return theme || legacyTheme || (0, $49b644eef671596b$export$25d302a5b900a763)({});
};





var $e4aafc8312ff068d$var$_seed = 0;
var $e4aafc8312ff068d$export$7963e85cec90d1cd = {
    reset: function() {
        // If the stylesheet reset call is made, invalidate the cache keys.
        (0, $09297afe86dd7d0e$export$cd02bf5de16fbd7c).getInstance().onReset(function() {
            return $e4aafc8312ff068d$var$_seed++;
        });
    },
    getId: function() {
        return $e4aafc8312ff068d$var$_seed;
    },
    renderStyles: function(styleSet, options) {
        return (0, $00784e00f3e28b27$export$3ea21144e9973d29)(Array.isArray(styleSet) ? styleSet : [
            styleSet
        ], options);
    },
    renderFontFace: function(fontFace, options) {
        return (0, $14126b943c3ed2af$export$566c6c2ff0443c7)(fontFace);
    },
    renderKeyframes: function(keyframes) {
        return (0, $20f518cc12336d5a$export$d25ddfdf17c3ad3e)(keyframes);
    }
};


var $3cf0e258175884c2$var$graphGet = function(graphNode, _a) {
    var _b, _c, _d;
    var windowId = _a[0], id = _a[1], theme = _a[2];
    return (_d = (_c = (_b = graphNode.get(windowId)) === null || _b === void 0 ? void 0 : _b.get(id)) === null || _c === void 0 ? void 0 : _c.get(theme)) === null || _d === void 0 ? void 0 : _d.classMap;
};
var $3cf0e258175884c2$var$graphSet = function(graphNode, _a, classMap) {
    var _b, _c;
    var windowId = _a[0], id = _a[1], theme = _a[2];
    var windowNode = (_b = graphNode.get(windowId)) !== null && _b !== void 0 ? _b : new Map();
    graphNode.set(windowId, windowNode);
    var idNode = (_c = windowNode.get(id)) !== null && _c !== void 0 ? _c : new Map();
    windowNode.set(id, idNode);
    idNode.set(theme, {
        classMap: classMap,
        refCount: 0
    });
};
function $3cf0e258175884c2$var$graphRef(graphNode, _a) {
    var _b, _c;
    var windowId = _a[0], id = _a[1], theme = _a[2];
    var node = (_c = (_b = graphNode.get(windowId)) === null || _b === void 0 ? void 0 : _b.get(id)) === null || _c === void 0 ? void 0 : _c.get(theme);
    if (node) node.refCount++;
}
function $3cf0e258175884c2$var$graphDeref(graphNode, _a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var windowId = _a[0], id = _a[1], theme = _a[2];
    var node = (_c = (_b = graphNode.get(windowId)) === null || _b === void 0 ? void 0 : _b.get(id)) === null || _c === void 0 ? void 0 : _c.get(theme);
    if (node) {
        node.refCount--;
        if (node.refCount === 0) {
            (_e = (_d = graphNode.get(windowId)) === null || _d === void 0 ? void 0 : _d.get(id)) === null || _e === void 0 || _e.delete(theme);
            if (((_g = (_f = graphNode.get(windowId)) === null || _f === void 0 ? void 0 : _f.get(id)) === null || _g === void 0 ? void 0 : _g.size) === 0) {
                (_h = graphNode.get(windowId)) === null || _h === void 0 || _h.delete(id);
                if (((_j = graphNode.get(windowId)) === null || _j === void 0 ? void 0 : _j.size) === 0) graphNode.delete(windowId);
            }
        }
    }
}
function $3cf0e258175884c2$export$b35517af9e0a5689(styleOrFunction) {
    // Create graph of inputs to map to output.
    var graph = new Map();
    // Retain a dictionary of window ids we're tracking
    var allWindows = new Set();
    // cleanupMapEntries will
    // 1. remove all the graph branches for the window,
    // 2. remove the event listener,
    // 3. delete the allWindows entry.
    var cleanupMapEntries = function(ev) {
        var win = ev.currentTarget;
        var winId = win.__id__;
        graph.delete(winId);
        win.removeEventListener('unload', cleanupMapEntries);
        allWindows.delete(winId);
    };
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    return function(options) {
        if (options === void 0) options = {};
        var theme = options.theme;
        var winId;
        var win = (0, $b139ba3b4431b53f$export$24b8fbafc4b6a151)();
        if (win) {
            win.__id__ = win.__id__ || (0, $532a46d3b196c0f3$export$218c8c3169c024d2)();
            winId = win.__id__;
            if (!allWindows.has(winId)) {
                allWindows.add(winId);
                win.addEventListener('unload', cleanupMapEntries);
            }
        }
        var contextualTheme = (0, $c0559e03c5bb1edc$export$93d4e7f90805808f)();
        theme = theme || contextualTheme;
        var renderer = (0, $e4aafc8312ff068d$export$7963e85cec90d1cd);
        var id = renderer.getId();
        var path = [
            winId,
            id,
            theme
        ];
        var value = $3cf0e258175884c2$var$graphGet(graph, path);
        // Don't keep around unused styles
        $acw62.useEffect(function() {
            $3cf0e258175884c2$var$graphRef(graph, [
                winId,
                id,
                theme
            ]);
            return function() {
                return $3cf0e258175884c2$var$graphDeref(graph, [
                    winId,
                    id,
                    theme
                ]);
            };
        }, [
            winId,
            id,
            theme
        ]);
        if (!value) {
            var styles = $3cf0e258175884c2$var$isStyleFunction(styleOrFunction) ? styleOrFunction(theme) : styleOrFunction;
            value = (0, $e4aafc8312ff068d$export$7963e85cec90d1cd).renderStyles(styles, {
                targetWindow: win,
                rtl: !!theme.rtl
            });
            $3cf0e258175884c2$var$graphSet(graph, path, value);
        }
        return value;
    };
}
function $3cf0e258175884c2$var$isStyleFunction(styleOrFunction) {
    return typeof styleOrFunction === 'function';
}


// eslint-disable-next-line @typescript-eslint/no-deprecated
var $7443daf1a4b20ee1$var$useThemeProviderStyles = (0, $3cf0e258175884c2$export$b35517af9e0a5689)(function(theme) {
    var semanticColors = theme.semanticColors, fonts = theme.fonts;
    return {
        body: [
            {
                color: semanticColors.bodyText,
                background: semanticColors.bodyBackground,
                fontFamily: fonts.medium.fontFamily,
                fontWeight: fonts.medium.fontWeight,
                fontSize: fonts.medium.fontSize,
                MozOsxFontSmoothing: fonts.medium.MozOsxFontSmoothing,
                WebkitFontSmoothing: fonts.medium.WebkitFontSmoothing
            }
        ]
    };
});
/**
 * Hook to add class to body element.
 */ function $7443daf1a4b20ee1$var$useApplyClassToBody(state, classesToApply) {
    var _a;
    var applyTo = state.applyTo;
    var applyToBody = applyTo === 'body';
    var body = (_a = (0, $b139ba3b4431b53f$export$e71e2fb5c5c476d5)()) === null || _a === void 0 ? void 0 : _a.body;
    $acw62.useEffect(function() {
        if (!applyToBody || !body) return;
        for(var _i = 0, classesToApply_1 = classesToApply; _i < classesToApply_1.length; _i++){
            var classToApply = classesToApply_1[_i];
            if (classToApply) body.classList.add(classToApply);
        }
        return function() {
            if (!applyToBody || !body) return;
            for(var _i = 0, classesToApply_2 = classesToApply; _i < classesToApply_2.length; _i++){
                var classToApply = classesToApply_2[_i];
                if (classToApply) body.classList.remove(classToApply);
            }
        };
    }, [
        applyToBody,
        body,
        classesToApply
    ]);
}
function $7443daf1a4b20ee1$export$b0ef5d11eb9d4e2e(state) {
    var classes = $7443daf1a4b20ee1$var$useThemeProviderStyles(state);
    var className = state.className, applyTo = state.applyTo;
    $7443daf1a4b20ee1$var$useApplyClassToBody(state, [
        classes.root,
        classes.body
    ]);
    state.className = (0, $12c8f27fb57f0fcf$export$dbf350e5966cf602)(className, classes.root, applyTo === 'element' && classes.body);
}




var $acw62 = parcelRequire("acw62");

var $cc901e5460d835ce$var$nativeElementMap = {
    label: (0, $076f236b4b7f2dc0$export$ec8d81a3d8f61d0f),
    audio: (0, $076f236b4b7f2dc0$export$55af9cf105a52547),
    video: (0, $076f236b4b7f2dc0$export$cd2126b486be823e),
    ol: (0, $076f236b4b7f2dc0$export$9e755727cea4fd1f),
    li: (0, $076f236b4b7f2dc0$export$8703767c2ecb797b),
    a: (0, $076f236b4b7f2dc0$export$bd4643a0b4568ed8),
    button: (0, $076f236b4b7f2dc0$export$4fd534fb1e82b8b4),
    input: (0, $076f236b4b7f2dc0$export$33c6815a27d08ce5),
    textarea: (0, $076f236b4b7f2dc0$export$699534499318873d),
    select: (0, $076f236b4b7f2dc0$export$9475341421ea2846),
    option: (0, $076f236b4b7f2dc0$export$9004c3828878727f),
    table: (0, $076f236b4b7f2dc0$export$2f53f8cf7eb86ae5),
    tr: (0, $076f236b4b7f2dc0$export$3ab2f4f445c2eb24),
    th: (0, $076f236b4b7f2dc0$export$2b115a026f474c83),
    td: (0, $076f236b4b7f2dc0$export$b5d753b2279d22cc),
    colGroup: (0, $076f236b4b7f2dc0$export$d526cc4b9c261b42),
    col: (0, $076f236b4b7f2dc0$export$e487baa138d06e98),
    form: (0, $076f236b4b7f2dc0$export$477a3a6d251d97a7),
    iframe: (0, $076f236b4b7f2dc0$export$727a7f82229b450f),
    img: (0, $076f236b4b7f2dc0$export$91f8cc2b546c057d)
};
function $cc901e5460d835ce$export$eca624771caa6078(tagName, props, excludedPropNames) {
    var allowedPropNames = tagName && $cc901e5460d835ce$var$nativeElementMap[tagName] || (0, $076f236b4b7f2dc0$export$e4936fed10ab2c40);
    return (0, $076f236b4b7f2dc0$export$26fba481281db559)(props, allowedPropNames, excludedPropNames);
}



var $28d1b1006dc4efc6$export$584e64b2e4bb6cc0 = function(state) {
    var customizerContext = state.customizerContext, ref = state.ref, theme = state.theme;
    var Root = state.as || 'div';
    var rootProps = typeof state.as === 'string' ? (0, $cc901e5460d835ce$export$eca624771caa6078)(state.as, state) : state.as === $acw62.Fragment ? {
        children: state.children
    } : (0, $f504d2279336999d$export$30a06c8d3562193f)(state, [
        'as'
    ]);
    return $acw62.createElement((0, $5ecd0e508deaca50$export$2c657da244d00bd6).Provider, {
        value: theme
    }, $acw62.createElement((0, $841b877f8387ff91$export$3eb7f4ab94bcebc3).Provider, {
        value: customizerContext
    }, $acw62.createElement((0, $0a0122a1daf8e02f$export$7f9071f49e01dae9), {
        providerRef: ref
    }, $acw62.createElement(Root, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rootProps)))));
};




var $acw62 = parcelRequire("acw62");


var $61dea753c15bf981$var$themeToIdMap = new Map();
var $61dea753c15bf981$var$getThemeId = function() {
    var themes = [];
    for(var _i = 0; _i < arguments.length; _i++)themes[_i] = arguments[_i];
    var ids = [];
    for(var _a = 0, themes_1 = themes; _a < themes_1.length; _a++){
        var theme = themes_1[_a];
        if (theme) {
            var id = theme.id || $61dea753c15bf981$var$themeToIdMap.get(theme);
            if (!id) {
                id = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)('');
                $61dea753c15bf981$var$themeToIdMap.set(theme, id);
            }
            ids.push(id);
        }
    }
    return ids.join('-');
};
var $61dea753c15bf981$export$94117efb68eadb09 = function(draftState) {
    var userTheme = draftState.theme;
    // Pull contextual theme.
    var parentTheme = (0, $c0559e03c5bb1edc$export$93d4e7f90805808f)();
    // Update the incoming theme with a memoized version of the merged theme.
    var theme = draftState.theme = $acw62.useMemo(function() {
        var mergedTheme = (0, $535786ba16bdff82$export$919aa3481b25eaec)(parentTheme, userTheme);
        mergedTheme.id = $61dea753c15bf981$var$getThemeId(parentTheme, userTheme);
        return mergedTheme;
    }, [
        parentTheme,
        userTheme
    ]);
    draftState.customizerContext = $acw62.useMemo(function() {
        return {
            customizations: {
                inCustomizerContext: true,
                settings: {
                    theme: theme
                },
                scopedSettings: theme.components || {}
            }
        };
    }, [
        theme
    ]);
    if (draftState.theme.rtl !== parentTheme.rtl) draftState.dir = draftState.theme.rtl ? 'rtl' : 'ltr';
};



var $8956c08db78fe52f$export$da441ad02c702fa4 = function(props, defaultProps) {
    var state = (0, $f3ff39ec82d473ae$export$36ffd6a0ea64902d)(defaultProps, props);
    // Apply changes to state.
    (0, $61dea753c15bf981$export$94117efb68eadb09)(state);
    return {
        state: state,
        render: (0, $28d1b1006dc4efc6$export$584e64b2e4bb6cc0)
    };
};



var $2d27915946f9c8de$export$d8964aec282183a3 = $acw62.forwardRef(function(props, ref) {
    var rootRef = (0, $0dfbd1d4e59c5781$export$9cf7d991616612b3)(ref, $acw62.useRef(null));
    var _a = (0, $8956c08db78fe52f$export$da441ad02c702fa4)(props, {
        ref: rootRef,
        as: 'div',
        applyTo: 'element'
    }), render = _a.render, state = _a.state;
    // Render styles.
    (0, $7443daf1a4b20ee1$export$b0ef5d11eb9d4e2e)(state);
    // Return the rendered content.
    return render(state);
});
$2d27915946f9c8de$export$d8964aec282183a3.displayName = 'ThemeProvider';


const $3d23c89fbc620dc3$var$theme = {
    palette: {
        themePrimary: '#a4262c',
        themeDarkAlt: '#932227'
    }
};
class $3d23c89fbc620dc3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const dialogContentProps = {
            type: (0, $02539af196256a3f$export$290cb7291ee58b61).largeHeader,
            title: this.props.instantLoss ? 'Pwned by a 0-day!' : "You've been pwned!",
            subText: this.props.instantLoss ? `How unlucky! Unfortunately, sometimes that's just the way it is.` : `Oh no! An infected device was booted and your network has been compromised by a wormable ransomware.`
        };
        const content = this.props.instantLoss ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                "In real-life, a",
                ' ',
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://en.wikipedia.org/wiki/Zero-day_(computing)",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "0-day exploit"
                }),
                ' ',
                "is often very difficult to defend against. Your best option is to keep your systems up-to-date and practice safe computing habits."
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: "Cyber security is a shared responsibility."
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d27915946f9c8de$export$d8964aec282183a3), {
            theme: $3d23c89fbc620dc3$var$theme,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $02711f7facaa0bc1$export$3ddf2d174ce01153), {
                hidden: this.props.hidden,
                onDismiss: this.props.toggleHideDialog,
                dialogContentProps: dialogContentProps,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                        horizontal: true,
                        verticalAlign: "center",
                        tokens: {
                            childrenGap: 'm'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $868500f3719dd006$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '1.5rem',
                                    color: 'red'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    content,
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://getcybersafe.gc.ca/en",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: "Learn how to stay safe online."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b12e79a827290871$export$7bbfb2d443473050), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf3792db3fad6664$export$ac16a6a04d9b7c84), {
                            onClick: this.props.toggleHideDialog,
                            text: "Try again"
                        })
                    })
                ]
            })
        });
    }
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $c018ac0c33380dbc$var$EncryptionIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M1920 256v512q0 151-38 285t-105 253-158 223-198 195-224 171-237 150q-119-70-236-149t-224-171-198-196-159-223-105-253T0 768V256q83 0 161-6t152-22 146-45 144-75q85-55 170-81T960 0q51 0 97 6t89 20 86 34 85 48q72 46 144 75t146 45 152 22 161 6zm-128 512V382q-149-8-285-48t-263-121q-68-44-135-64t-149-21q-81 0-148 20t-136 65q-126 81-262 121t-286 48v386q0 127 33 244t92 222 138 200 172 178 193 155 204 130q102-59 203-130t194-154 172-178 138-200 91-223 34-244zM960 320q66 0 124 25t101 69 69 102 26 124v128h128v640H512V768h128V640q0-66 25-124t68-101 102-69 125-26zm320 960V896H640v384h640zM768 768h384V640q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75v128z"
        })),
    displayName: 'EncryptionIcon'
});
var $c018ac0c33380dbc$export$2e2bcd8739ae039 = $c018ac0c33380dbc$var$EncryptionIcon;



class $ac3f1792f86f4fa5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const dialogContentProps = {
            type: (0, $02539af196256a3f$export$290cb7291ee58b61).largeHeader,
            title: 'Well done',
            subText: "Congratulations! All the known threats on your network have been identified and quarantined. You're back in business!"
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $02711f7facaa0bc1$export$3ddf2d174ce01153), {
                hidden: this.props.hidden,
                onDismiss: this.props.toggleHideDialog,
                dialogContentProps: dialogContentProps,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                        horizontal: true,
                        verticalAlign: "center",
                        tokens: {
                            childrenGap: 'm'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c018ac0c33380dbc$export$2e2bcd8739ae039), {
                                style: {
                                    fontSize: '1.5rem',
                                    color: 'green'
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Remember, there is no such thing as 100% secure.",
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: "https://getcybersafe.gc.ca/en",
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: "Learn how to stay safe online."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b12e79a827290871$export$7bbfb2d443473050), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf3792db3fad6664$export$ac16a6a04d9b7c84), {
                            onClick: this.props.toggleHideDialog,
                            text: "Play again?"
                        })
                    })
                ]
            })
        });
    }
}






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

/**
 * Detects whether an element's content has horizontal overflow
 *
 * @public
 * @param element - Element to check for overflow
 * @returns True if element's content overflows
 */ function $83b45cbc07988a90$export$6593e8d7c1045101(element) {
    return element.clientWidth < element.scrollWidth;
}
function $83b45cbc07988a90$export$960f7fa58164ce36(element) {
    return element.clientHeight < element.scrollHeight;
}
function $83b45cbc07988a90$export$874b45e6fa959b42(element) {
    return $83b45cbc07988a90$export$6593e8d7c1045101(element) || $83b45cbc07988a90$export$960f7fa58164ce36(element);
}


/**
 * {@docCategory Tooltip}
 */ var $3d3718168950b1e5$export$f3ea1a1b02389dd0;
(function(TooltipOverflowMode) {
    /** Only show tooltip if parent DOM element is overflowing */ TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
    /**
     * Only show tooltip if tooltip host's content is overflowing.
     * Note that this does not check the children for overflow, only the TooltipHost root.
     */ TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
})($3d3718168950b1e5$export$f3ea1a1b02389dd0 || ($3d3718168950b1e5$export$f3ea1a1b02389dd0 = {}));





var $acw62 = parcelRequire("acw62");



var $9ce6ed99c0b7b0f9$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $9ce6ed99c0b7b0f9$export$663e8f4fc1276cb8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooltipBase, _super);
    function TooltipBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRenderContent = function(props) {
            if (typeof props.content === 'string') return $acw62.createElement("p", {
                className: _this._classNames.subText
            }, props.content);
            else return $acw62.createElement("div", {
                className: _this._classNames.subText
            }, props.content);
        };
        return _this;
    }
    TooltipBase.prototype.render = function() {
        var _a = this.props, className = _a.className, calloutProps = _a.calloutProps, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, styles = _a.styles, id = _a.id, maxWidth = _a.maxWidth, _b = _a.onRenderContent, onRenderContent = _b === void 0 ? this._onRenderContent : _b, targetElement = _a.targetElement, theme = _a.theme;
        this._classNames = $9ce6ed99c0b7b0f9$var$getClassNames(styles, {
            theme: theme,
            className: className || calloutProps && calloutProps.className,
            beakWidth: calloutProps && calloutProps.isBeakVisible ? calloutProps.beakWidth : 0,
            gapSpace: calloutProps && calloutProps.gapSpace,
            maxWidth: maxWidth
        });
        return $acw62.createElement((0, $bb8160ea11d5c986$export$97a5aca3dea8edc7), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            target: targetElement,
            directionalHint: directionalHint,
            directionalHintForRTL: directionalHintForRTL
        }, calloutProps, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
            'id'
        ]), {
            className: this._classNames.root
        }), $acw62.createElement("div", {
            className: this._classNames.content,
            id: id,
            onFocus: this.props.onFocus,
            onMouseEnter: this.props.onMouseEnter,
            onMouseLeave: this.props.onMouseLeave
        }, onRenderContent(this.props, this._onRenderContent)));
    };
    // Specify default props values
    TooltipBase.defaultProps = {
        directionalHint: (0, $e52f208cfc343b11$export$7bbc434a13063638).topCenter,
        maxWidth: '364px',
        calloutProps: {
            isBeakVisible: true,
            beakWidth: 16,
            gapSpace: 0,
            setInitialFocus: true,
            doNotLayer: false
        }
    };
    return TooltipBase;
}($acw62.Component);



var $bdd05a51f6142723$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, _a = props.beakWidth, beakWidth = _a === void 0 ? 16 : _a, _b = props.gapSpace, gapSpace = _b === void 0 ? 0 : _b, maxWidth = props.maxWidth, theme = props.theme;
    var semanticColors = theme.semanticColors, fonts = theme.fonts, effects = theme.effects;
    // The math here is done to account for the 45 degree rotation of the beak
    // and sub-pixel rounding that differs across browsers, which is more noticeable when
    // the device pixel ratio is larger
    var tooltipGapSpace = -(Math.sqrt(beakWidth * beakWidth / 2) + gapSpace) + 1 / // There isn't really a great way to pass in a `window` reference here so disabling the line rule
    // eslint-disable-next-line no-restricted-globals
    window.devicePixelRatio;
    return {
        root: [
            'ms-Tooltip',
            theme.fonts.medium,
            (0, $e2629e8d47c94809$export$a386448ab9904275).fadeIn200,
            {
                background: semanticColors.menuBackground,
                boxShadow: effects.elevation8,
                padding: '8px',
                maxWidth: maxWidth,
                selectors: {
                    ':after': {
                        content: "''",
                        position: 'absolute',
                        bottom: tooltipGapSpace,
                        left: tooltipGapSpace,
                        right: tooltipGapSpace,
                        top: tooltipGapSpace,
                        zIndex: 0
                    }
                }
            },
            className
        ],
        content: [
            'ms-Tooltip-content',
            fonts.small,
            {
                position: 'relative',
                zIndex: 1,
                color: semanticColors.menuItemText,
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                overflow: 'hidden'
            }
        ],
        subText: [
            'ms-Tooltip-subtext',
            {
                // Using inherit here to avoid unintentional global overrides of the <p> tag.
                fontSize: 'inherit',
                fontWeight: 'inherit',
                color: 'inherit',
                margin: 0
            }
        ]
    };
};


var $c8281ca0c7c3178d$export$28c660c63b792dea = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $9ce6ed99c0b7b0f9$export$663e8f4fc1276cb8), (0, $bdd05a51f6142723$export$ffd58b7f6f099a57), undefined, {
    scope: 'Tooltip'
});


/**
 * {@docCategory Tooltip}
 */ var $d05bac3956229c41$export$2c246ae0aa41b345;
(function(TooltipDelay) {
    TooltipDelay[TooltipDelay["zero"] = 0] = "zero";
    /** 300 ms delay before showing the tooltip */ TooltipDelay[TooltipDelay["medium"] = 1] = "medium";
    /** 500 ms delay before showing the tooltip */ TooltipDelay[TooltipDelay["long"] = 2] = "long";
})($d05bac3956229c41$export$2c246ae0aa41b345 || ($d05bac3956229c41$export$2c246ae0aa41b345 = {}));




var $bb56338254948c40$var$getClassNames = (0, $f64c8e86ac270e43$export$8584b618c75d395d)();
var $bb56338254948c40$export$e7418f645cab4023 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooltipHostBase, _super);
    // Constructor
    function TooltipHostBase(props) {
        var _this = _super.call(this, props) || this;
        // The wrapping div that gets the hover events
        _this._tooltipHost = $acw62.createRef();
        _this._defaultTooltipId = (0, $532a46d3b196c0f3$export$218c8c3169c024d2)('tooltip');
        _this.show = function() {
            _this._toggleTooltip(true);
        };
        _this.dismiss = function() {
            _this._hideTooltip();
        };
        _this._getTargetElement = function() {
            if (!_this._tooltipHost.current) return undefined;
            var overflowMode = _this.props.overflowMode;
            // Select target element based on overflow mode. For parent mode, you want to position the tooltip relative
            // to the parent element, otherwise it might look off.
            if (overflowMode !== undefined) switch(overflowMode){
                case (0, $3d3718168950b1e5$export$f3ea1a1b02389dd0).Parent:
                    return _this._tooltipHost.current.parentElement;
                case (0, $3d3718168950b1e5$export$f3ea1a1b02389dd0).Self:
                    return _this._tooltipHost.current;
            }
            return _this._tooltipHost.current;
        };
        _this._onTooltipFocus = function(ev) {
            if (_this._ignoreNextFocusEvent) {
                _this._ignoreNextFocusEvent = false;
                return;
            }
            _this._onTooltipMouseEnter(ev);
        };
        _this._onTooltipContentFocus = function(ev) {
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) TooltipHostBase._currentVisibleTooltip.dismiss();
            TooltipHostBase._currentVisibleTooltip = _this;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
        };
        _this._onTooltipBlur = function(ev) {
            var _a;
            // The focused element gets a blur event when the document loses focus
            // (e.g. switching tabs in the browser), but we don't want to show the
            // tooltip again when the document gets focus back. Handle this case by
            // checking if the blurred element is still the document's activeElement,
            // and ignoring when it next gets focus back.
            // See https://github.com/microsoft/fluentui/issues/13541
            _this._ignoreNextFocusEvent = ((_a = (0, $2214ae3f3c5a332e$export$c0256123a07df134)(_this.context)) === null || _a === void 0 ? void 0 : _a.activeElement) === ev.target;
            _this._dismissTimerId = _this._async.setTimeout(function() {
                _this._hideTooltip();
            }, 0);
        };
        // Show Tooltip
        _this._onTooltipMouseEnter = function(ev) {
            var _a = _this.props, overflowMode = _a.overflowMode, delay = _a.delay;
            var doc = (0, $2214ae3f3c5a332e$export$c0256123a07df134)(_this.context);
            if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip !== _this) TooltipHostBase._currentVisibleTooltip.dismiss();
            TooltipHostBase._currentVisibleTooltip = _this;
            if (overflowMode !== undefined) {
                var overflowElement = _this._getTargetElement();
                if (overflowElement && !(0, $83b45cbc07988a90$export$874b45e6fa959b42)(overflowElement)) return;
            }
            if (ev.target && (0, $8eda1135a5ecf96f$export$ca66eda9f83446dd)(ev.target, _this._getTargetElement(), doc)) // Do not show tooltip when target is inside a portal relative to TooltipHost.
            return;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
            if (delay !== (0, $d05bac3956229c41$export$2c246ae0aa41b345).zero) {
                var delayTime = _this._getDelayTime(delay); // non-null assertion because we set it in `defaultProps`
                _this._openTimerId = _this._async.setTimeout(function() {
                    _this._toggleTooltip(true);
                }, delayTime);
            } else _this._toggleTooltip(true);
        };
        // Hide Tooltip
        _this._onTooltipMouseLeave = function(ev) {
            var closeDelay = _this.props.closeDelay;
            _this._clearDismissTimer();
            _this._clearOpenTimer();
            if (closeDelay) _this._dismissTimerId = _this._async.setTimeout(function() {
                _this._toggleTooltip(false);
            }, closeDelay);
            else _this._toggleTooltip(false);
            if (TooltipHostBase._currentVisibleTooltip === _this) TooltipHostBase._currentVisibleTooltip = undefined;
        };
        _this._onTooltipKeyDown = function(ev) {
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            if ((ev.which === (0, $c011a102064f82ea$export$ec835b702d42f3f0).escape || ev.ctrlKey) && _this.state.isTooltipVisible) {
                _this._hideTooltip();
                ev.stopPropagation();
            }
        };
        _this._clearDismissTimer = function() {
            _this._async.clearTimeout(_this._dismissTimerId);
        };
        _this._clearOpenTimer = function() {
            _this._async.clearTimeout(_this._openTimerId);
        };
        // Hide Tooltip
        _this._hideTooltip = function() {
            _this._clearOpenTimer();
            _this._clearDismissTimer();
            _this._toggleTooltip(false);
        };
        _this._toggleTooltip = function(isTooltipVisible) {
            if (_this.state.isTooltipVisible !== isTooltipVisible) _this.setState({
                isTooltipVisible: isTooltipVisible
            }, function() {
                return _this.props.onTooltipToggle && _this.props.onTooltipToggle(isTooltipVisible);
            });
        };
        _this._getDelayTime = function(delay) {
            switch(delay){
                case (0, $d05bac3956229c41$export$2c246ae0aa41b345).medium:
                    return 300;
                case (0, $d05bac3956229c41$export$2c246ae0aa41b345).long:
                    return 500;
                default:
                    return 0;
            }
        };
        (0, $e67df77dd079fd43$export$4e1ebb7d216e1f17)(_this);
        _this.state = {
            isAriaPlaceholderRendered: false,
            isTooltipVisible: false
        };
        return _this;
    }
    // Render
    TooltipHostBase.prototype.render = function() {
        var _a = this.props, calloutProps = _a.calloutProps, children = _a.children, content = _a.content, directionalHint = _a.directionalHint, directionalHintForRTL = _a.directionalHintForRTL, className = _a.hostClassName, id = _a.id, // eslint-disable-next-line @typescript-eslint/no-deprecated
        _b = _a.setAriaDescribedBy, // eslint-disable-next-line @typescript-eslint/no-deprecated
        setAriaDescribedBy = _b === void 0 ? true : _b, tooltipProps = _a.tooltipProps, styles = _a.styles, theme = _a.theme;
        this._classNames = $bb56338254948c40$var$getClassNames(styles, {
            theme: theme,
            className: className
        });
        var isTooltipVisible = this.state.isTooltipVisible;
        var tooltipId = id || this._defaultTooltipId;
        var tooltipRenderProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
            id: "".concat(tooltipId, "--tooltip"),
            content: content,
            targetElement: this._getTargetElement(),
            directionalHint: directionalHint,
            directionalHintForRTL: directionalHintForRTL,
            calloutProps: (0, $f504d2279336999d$export$e6e34fd1f2686227)({}, calloutProps, {
                onDismiss: this._hideTooltip,
                onFocus: this._onTooltipContentFocus,
                onMouseEnter: this._onTooltipMouseEnter,
                onMouseLeave: this._onTooltipMouseLeave
            }),
            onMouseEnter: this._onTooltipMouseEnter,
            onMouseLeave: this._onTooltipMouseLeave
        }, (0, $076f236b4b7f2dc0$export$26fba481281db559)(this.props, (0, $076f236b4b7f2dc0$export$eb42a981869108f0), [
            'id'
        ])), tooltipProps);
        // Get the content of the tooltip for use in the hidden div used for screen readers
        var tooltipContent = (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.onRenderContent) ? tooltipProps.onRenderContent(tooltipRenderProps, function(props) {
            return (props === null || props === void 0 ? void 0 : props.content) ? $acw62.createElement($acw62.Fragment, null, props.content) : null;
        }) : content;
        var showTooltip = isTooltipVisible && !!tooltipContent;
        var ariaDescribedBy = setAriaDescribedBy && isTooltipVisible && !!tooltipContent ? tooltipId : undefined;
        return $acw62.createElement("div", {
            className: this._classNames.root,
            ref: this._tooltipHost,
            onFocusCapture: this._onTooltipFocus,
            onBlurCapture: this._onTooltipBlur,
            onMouseEnter: this._onTooltipMouseEnter,
            onMouseLeave: this._onTooltipMouseLeave,
            onKeyDown: this._onTooltipKeyDown,
            role: "none",
            "aria-describedby": ariaDescribedBy
        }, children, showTooltip && $acw62.createElement((0, $c8281ca0c7c3178d$export$28c660c63b792dea), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, tooltipRenderProps)), $acw62.createElement("div", {
            hidden: true,
            id: tooltipId,
            style: (0, $34563ae103a23d08$export$35835471cbe77db4)
        }, tooltipContent));
    };
    TooltipHostBase.prototype.componentDidMount = function() {
        this._async = new (0, $64b4350fe064431c$export$4d3c597da532240f)(this);
    };
    TooltipHostBase.prototype.componentWillUnmount = function() {
        if (TooltipHostBase._currentVisibleTooltip && TooltipHostBase._currentVisibleTooltip === this) TooltipHostBase._currentVisibleTooltip = undefined;
        this._async.dispose();
    };
    TooltipHostBase.defaultProps = {
        delay: (0, $d05bac3956229c41$export$2c246ae0aa41b345).medium
    };
    TooltipHostBase.contextType = (0, $b139ba3b4431b53f$export$19f5fbe41bba757);
    return TooltipHostBase;
}($acw62.Component);



var $267d2068da95c27f$var$GlobalClassNames = {
    root: 'ms-TooltipHost',
    ariaPlaceholder: 'ms-TooltipHost-aria-placeholder'
};
var $267d2068da95c27f$export$ffd58b7f6f099a57 = function(props) {
    var className = props.className, theme = props.theme;
    var classNames = (0, $82e4fc67b7d16117$export$e14385d8f1853921)($267d2068da95c27f$var$GlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                display: 'inline'
            },
            className
        ]
    };
};


var $81fe081095f59877$export$ebbf8986cf9b8de1 = (0, $8af9a8c8d5cac055$export$3817b7a54a07cec7)((0, $bb56338254948c40$export$e7418f645cab4023), (0, $267d2068da95c27f$export$ffd58b7f6f099a57), undefined, {
    scope: 'TooltipHost'
});


class $3ab97bdca28e2565$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    /**
     * Get tooltip properties (text) for each level
     */ #getLevelDescriptionTooltipProps(level) {
        const descriptions = {
            EASY: 'In real-life, a class C network contains a block of 256 IP addresses.',
            MEDIUM: 'In real-life, a class B network contains a block of 65,536 IP addresses.',
            HARD: 'In real-life, a class A network contains a block of 16,777,216 IP addresses.'
        };
        return {
            onRenderContent: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        (0, $4388d496bdb048be$export$2e2bcd8739ae039)[level].width,
                        " \xd7 ",
                        (0, $4388d496bdb048be$export$2e2bcd8739ae039)[level].height,
                        " board size.",
                        ' ',
                        descriptions[level],
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            href: "https://en.wikipedia.org/wiki/Classful_network",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: "Learn more about classful networks."
                        })
                    ]
                })
        };
    }
    render() {
        const buttonLabels = {
            EASY: 'Class C (Easy)',
            MEDIUM: 'Class B (Medium)',
            HARD: 'Class A (Expert)'
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("legend", {
                    children: "New game"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                    horizontal: true,
                    wrap: true,
                    tokens: {
                        childrenGap: 's1'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                            children: "Network size:"
                        }),
                        Object.entries(buttonLabels).map(([level, text])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81fe081095f59877$export$ebbf8986cf9b8de1), {
                                tooltipProps: this.#getLevelDescriptionTooltipProps(level),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82fb36076cfcc62a$export$b7c3a2f69225ecf), {
                                    type: "button",
                                    value: level,
                                    onClick: ()=>this.props.newGameCallback(level),
                                    children: text
                                })
                            }, level))
                    ]
                })
            ]
        });
    }
}




class $f3a5c8b511434d8b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    #timerID;
    #gameEngine;
    #achievementsEngine;
    constructor(props = {}){
        super(props), this.#timerID = null, /**
     * Handles the click event of a square
     */ this.handleSquareClick = (x, y)=>{
            this.#startTimer();
            if (!this.state.gameInProgress) this.setState({
                gameInProgress: true
            });
            if (this.#gameEngine.uncover(x, y)) this.setState({
                game: this.#gameEngine.gameState
            }, ()=>{
                if (this.state.game.won) this.handleGameOver(true);
                else if (this.state.game.lost) this.handleGameOver(false);
                this.#refreshAchievements();
            });
        }, /**
     * Handles the right-click event of a square
     */ this.handleSquareRightClick = (x, y)=>{
            this.#startTimer();
            if (!this.state.gameInProgress) this.setState({
                gameInProgress: true
            });
            if (this.#gameEngine.toggleFlag(x, y)) this.setState({
                game: this.#gameEngine.gameState
            }, ()=>{
                this.#refreshAchievements();
            });
        }, /**
     * Handles the double-click event of a square
     */ this.handleSquareDoubleClick = (x, y)=>{
            this.#startTimer();
            if (this.#gameEngine.autoUncoverAdjacent(x, y)) this.setState({
                game: this.#gameEngine.gameState
            }, ()=>{
                if (this.state.game.won) this.handleGameOver(true);
                else if (this.state.game.lost) this.handleGameOver(false);
                this.#refreshAchievements();
            });
        }, /**
     * Handles changes in page visibility
     */ this.handleVisibilityChange = (isVisible)=>{
            if (!this.state.gameInProgress) return;
            console.debug(isVisible);
            this.#gameEngine.paused = !isVisible;
            if (isVisible) this.#startTimer();
            else this.#stopTimer();
            this.#refreshAchievements();
        };
        this.#achievementsEngine = new (0, $cfdb0b85ae696cd2$export$2e2bcd8739ae039)();
        this.#gameEngine = new (0, $353f29edb58ffff4$export$2e2bcd8739ae039)();
        this.state = {
            level: 'EASY',
            game: this.#gameEngine.gameState,
            timer: 0,
            gameInProgress: false,
            scores: JSON.parse(localStorage.getItem('highscores') ?? '{"EASY":[],"MEDIUM":[],"HARD":[]}'),
            gameCounters: {
                won: Number(localStorage.getItem('gamesWon')) || 0,
                lost: Number(localStorage.getItem('gamesLost')) || 0,
                instantlyLost: Number(localStorage.getItem('gamesInstantlyLost')) || 0
            },
            wonDialogOpen: false,
            lostDialogOpen: false
        };
    }
    /**
     * Initializes a game
     */ initializeGame() {
        this.#gameEngine.initialize((0, $4388d496bdb048be$export$2e2bcd8739ae039)[this.state.level]);
        this.setState({
            game: this.#gameEngine.gameState,
            timer: 0
        });
    }
    /**
     * Starts a new game
     */ startNewGame(level = 'EASY') {
        if (this.state.gameInProgress && !window.confirm('Are you sure you want to start a new game?')) return;
        this.#stopTimer();
        this.setState({
            level: level
        }, ()=>{
            this.initializeGame();
        });
    }
    componentWillUnmount() {
        this.#stopTimer();
    }
    /**
     * Starts a timer
     */ #startTimer() {
        if (this.#timerID === null) this.#timerID = window.setInterval(()=>this.tick(), 1000);
    }
    /**
     * Stops a timer
     */ #stopTimer() {
        if (this.#timerID !== null) window.clearInterval(this.#timerID);
        this.#timerID = null;
    }
    tick() {
        this.setState((prevState)=>({
                timer: prevState.timer + 1
            }));
    }
    /**
     * Get the aggregate count of squares in various states on the game board
     */ #computeBoardStatus() {
        const boardStatus = {
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Covered]: 0,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged]: 0,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Maybe]: 0,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered]: 0,
            [(0, $77f60634a37f26aa$export$595bc52137d2dc55).Detonated]: 0
        };
        this.state.game.board.forEach((column)=>column.forEach((cell)=>++boardStatus[cell.displayState]));
        return boardStatus;
    }
    /**
     * Get the new high score list
     * @returns number[]
     */ #computeNewScores() {
        return [
            ...this.state.scores[this.state.level],
            this.state.timer
        ].filter((score)=>score > 0).sort((a, b)=>a - b).slice(0, 10);
    }
    /**
     * Force achievements re-evaluation
     */ #refreshAchievements() {
        this.#achievementsEngine.evaluate(this.#gameEngine.gameState, this.state.timer);
        this.#achievementsEngine.persist();
    }
    /**
     * Handles when the game is over
     * @param win Whether the game was won
     */ handleGameOver(win) {
        this.#stopTimer();
        const boardStatus = this.#computeBoardStatus();
        const instantLoss = !win && boardStatus[(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered] === 0;
        let scores = this.state.scores;
        let counters = this.state.gameCounters;
        if (win) {
            counters.won++;
            scores[this.state.level] = this.#computeNewScores();
            localStorage.setItem('highscores', JSON.stringify(scores));
            localStorage.setItem('gamesWon', String(counters.won));
        } else {
            counters.lost++;
            counters.instantlyLost += instantLoss ? 1 : 0;
            localStorage.setItem('gamesLost', String(counters.lost));
            localStorage.setItem('gamesInstantlyLost', String(counters.instantlyLost));
        }
        this.setState({
            wonDialogOpen: win,
            lostDialogOpen: !win,
            gameInProgress: false,
            scores: scores,
            gameCounters: counters
        });
    }
    /**
     * Handles closing the game won/lost dialogs
     */ handleCloseGameOverDialog() {
        this.setState({
            wonDialogOpen: false,
            lostDialogOpen: false
        });
    }
    render() {
        const isGameActive = !this.state.game.won && !this.state.game.lost;
        const boardStatus = this.#computeBoardStatus();
        const numberOfFlags = boardStatus[(0, $77f60634a37f26aa$export$595bc52137d2dc55).Flagged];
        const numberRevealed = boardStatus[(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered];
        const boardSize = (0, $4388d496bdb048be$export$2e2bcd8739ae039)[this.state.level].height * (0, $4388d496bdb048be$export$2e2bcd8739ae039)[this.state.level].width;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01a5de12b9480c6b$export$2e2bcd8739ae039), {
            onChange: this.handleVisibilityChange,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $96647f41d860b545$export$694e0d28c7ffc90c), {
                        horizontalAlign: "stretch",
                        tokens: {
                            childrenGap: 'm',
                            padding: 's1'
                        },
                        as: "main",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ab97bdca28e2565$export$2e2bcd8739ae039), {
                                newGameCallback: this.startNewGame.bind(this)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c9f4886983da49d0$export$2e2bcd8739ae039), {
                                squares: this.state.game.board,
                                handleSquareClick: this.handleSquareClick,
                                handleSquareRightClick: this.handleSquareRightClick,
                                handleSquareDoubleClick: this.handleSquareDoubleClick,
                                isGameActive: isGameActive
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $748c50e66593826e$export$2e2bcd8739ae039), {
                                time: this.state.timer,
                                size: boardSize,
                                revealed: numberRevealed,
                                flags: numberOfFlags,
                                mines: (0, $4388d496bdb048be$export$2e2bcd8739ae039)[this.state.level].mines
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ed8bbebf8aa6544$export$2e2bcd8739ae039), {
                                highscores: this.state.scores,
                                achievementsEngine: this.#achievementsEngine
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac3f1792f86f4fa5$export$2e2bcd8739ae039), {
                        hidden: !this.state.wonDialogOpen,
                        toggleHideDialog: this.handleCloseGameOverDialog.bind(this)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d23c89fbc620dc3$export$2e2bcd8739ae039), {
                        hidden: !this.state.lostDialogOpen,
                        instantLoss: boardStatus[(0, $77f60634a37f26aa$export$595bc52137d2dc55).Uncovered] === 0,
                        toggleHideDialog: this.handleCloseGameOverDialog.bind(this)
                    })
                ]
            })
        });
    }
}





var $acw62 = parcelRequire("acw62");

const $903c8a7097d0ab7f$var$MoreIcon = (0, $f790329e2d5b970e$export$2e2bcd8739ae039)({
    svg: ({ classes: classes })=>$acw62.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 2048 2048",
            className: classes.svg,
            focusable: "false"
        }, $acw62.createElement("path", {
            d: "M256 896q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm768 0q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm768 0q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10z"
        })),
    displayName: 'MoreIcon'
});
var $903c8a7097d0ab7f$export$2e2bcd8739ae039 = $903c8a7097d0ab7f$var$MoreIcon;


class $cd93687958c8007e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        (0, $157fc0f40a8f1c26$export$99b432e1290ef823)({
            icons: {
                more: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $903c8a7097d0ab7f$export$2e2bcd8739ae039), {})
            }
        });
    }
    render() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $33ce6250cbba555f$export$5f1af8db9871e1d6), {
                    as: "h1",
                    variant: "xxLarge",
                    children: "Threatsweeper"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    className: "github-fork-ribbon",
                    href: "https://github.com/RinkAttendant6/threatsweeper",
                    "data-ribbon": "Fork me on GitHub",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: "Fork me on GitHub"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3a5c8b511434d8b$export$2e2bcd8739ae039), {})
            ]
        });
    }
}


(0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).render((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cd93687958c8007e$export$2e2bcd8739ae039)), document.getElementById('app'));


//# sourceMappingURL=threatsweeper.6bd6821e.js.map
